/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_core_pb = require('../xcommon/core_pb.js');
goog.object.extend(proto, xcommon_core_pb);
var xcommon_enum_pb = require('../xcommon/enum_pb.js');
goog.object.extend(proto, xcommon_enum_pb);
goog.exportSymbol('proto.xcommon.AiStatusEnum', null, global);
goog.exportSymbol('proto.xcommon.AppStats', null, global);
goog.exportSymbol('proto.xcommon.AssignTicketTrialCalcReq', null, global);
goog.exportSymbol('proto.xcommon.AssignTicketTrialCalcResp', null, global);
goog.exportSymbol('proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail', null, global);
goog.exportSymbol('proto.xcommon.AssignWAPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.AssignWAPhoneResp', null, global);
goog.exportSymbol('proto.xcommon.AssociatedItem', null, global);
goog.exportSymbol('proto.xcommon.AttrItem', null, global);
goog.exportSymbol('proto.xcommon.AudioQualityRuleData', null, global);
goog.exportSymbol('proto.xcommon.AudioQualityScope', null, global);
goog.exportSymbol('proto.xcommon.AudioQualityScriptData', null, global);
goog.exportSymbol('proto.xcommon.AudioQualityTplData', null, global);
goog.exportSymbol('proto.xcommon.AutoCallCoreReq', null, global);
goog.exportSymbol('proto.xcommon.AutoCallCoreResp', null, global);
goog.exportSymbol('proto.xcommon.AutoCallParams', null, global);
goog.exportSymbol('proto.xcommon.BatchAssignTicketReq', null, global);
goog.exportSymbol('proto.xcommon.BatchAssignTicketResp', null, global);
goog.exportSymbol('proto.xcommon.BatchEntrustTicketReq', null, global);
goog.exportSymbol('proto.xcommon.BatchEntrustTicketResp', null, global);
goog.exportSymbol('proto.xcommon.BatchRecallTicketReq', null, global);
goog.exportSymbol('proto.xcommon.BatchRecallTicketResp', null, global);
goog.exportSymbol('proto.xcommon.BatchRecycleTicketReq', null, global);
goog.exportSymbol('proto.xcommon.BatchRecycleTicketResp', null, global);
goog.exportSymbol('proto.xcommon.CallType', null, global);
goog.exportSymbol('proto.xcommon.CallTypeEnum', null, global);
goog.exportSymbol('proto.xcommon.CallingPlanReq', null, global);
goog.exportSymbol('proto.xcommon.CallingPlanResp', null, global);
goog.exportSymbol('proto.xcommon.ChartItem', null, global);
goog.exportSymbol('proto.xcommon.CloseTicketReq', null, global);
goog.exportSymbol('proto.xcommon.CloseTicketResp', null, global);
goog.exportSymbol('proto.xcommon.CollectionType', null, global);
goog.exportSymbol('proto.xcommon.CommonItem', null, global);
goog.exportSymbol('proto.xcommon.CommonOutResp', null, global);
goog.exportSymbol('proto.xcommon.CommonStatus', null, global);
goog.exportSymbol('proto.xcommon.CompareType', null, global);
goog.exportSymbol('proto.xcommon.CreateOcrMarkTicketReq', null, global);
goog.exportSymbol('proto.xcommon.CreateQualityInspectionVoipReq', null, global);
goog.exportSymbol('proto.xcommon.CreateRobotCorpusMarkReq', null, global);
goog.exportSymbol('proto.xcommon.DashboardReq', null, global);
goog.exportSymbol('proto.xcommon.DashboardResp', null, global);
goog.exportSymbol('proto.xcommon.DashboardStats', null, global);
goog.exportSymbol('proto.xcommon.DealMethod', null, global);
goog.exportSymbol('proto.xcommon.DelMultilingualDetailReq', null, global);
goog.exportSymbol('proto.xcommon.DelMultilingualDetailResp', null, global);
goog.exportSymbol('proto.xcommon.DelReportReq', null, global);
goog.exportSymbol('proto.xcommon.DelTicketItemReq', null, global);
goog.exportSymbol('proto.xcommon.DeleteTicketAssignRuleReq', null, global);
goog.exportSymbol('proto.xcommon.DeleteTicketAssignRuleResp', null, global);
goog.exportSymbol('proto.xcommon.DeleteTicketEntrustRuleReq', null, global);
goog.exportSymbol('proto.xcommon.DeleteTicketEntrustRuleResp', null, global);
goog.exportSymbol('proto.xcommon.DeleteTicketRecallRuleReq', null, global);
goog.exportSymbol('proto.xcommon.DeleteTicketRecallRuleResp', null, global);
goog.exportSymbol('proto.xcommon.DeleteTicketRecycleRuleReq', null, global);
goog.exportSymbol('proto.xcommon.DeleteTicketRecycleRuleResp', null, global);
goog.exportSymbol('proto.xcommon.Dialer', null, global);
goog.exportSymbol('proto.xcommon.DialerAutoNextReq', null, global);
goog.exportSymbol('proto.xcommon.DialerAutoNextResp', null, global);
goog.exportSymbol('proto.xcommon.DialerAutoStartReq', null, global);
goog.exportSymbol('proto.xcommon.DialerAutoStartResp', null, global);
goog.exportSymbol('proto.xcommon.DialerAutoStopReq', null, global);
goog.exportSymbol('proto.xcommon.DialerAutoStopResp', null, global);
goog.exportSymbol('proto.xcommon.DialerBackend', null, global);
goog.exportSymbol('proto.xcommon.DialerCurrentInfoReq', null, global);
goog.exportSymbol('proto.xcommon.DialerCurrentInfoResp', null, global);
goog.exportSymbol('proto.xcommon.DialerListOrder', null, global);
goog.exportSymbol('proto.xcommon.DialerListOrderBackend', null, global);
goog.exportSymbol('proto.xcommon.DialerStatus', null, global);
goog.exportSymbol('proto.xcommon.DoReduceOtherReq', null, global);
goog.exportSymbol('proto.xcommon.DoReduceOtherResp', null, global);
goog.exportSymbol('proto.xcommon.DoReducePrincipalReq', null, global);
goog.exportSymbol('proto.xcommon.DoReducePrincipalResp', null, global);
goog.exportSymbol('proto.xcommon.DownWarningLetterReq', null, global);
goog.exportSymbol('proto.xcommon.DownWarningLetterResp', null, global);
goog.exportSymbol('proto.xcommon.ExportTicketEmailCSVReq', null, global);
goog.exportSymbol('proto.xcommon.ExportTicketEmailCSVResp', null, global);
goog.exportSymbol('proto.xcommon.FileResponse', null, global);
goog.exportSymbol('proto.xcommon.Follow', null, global);
goog.exportSymbol('proto.xcommon.FuncItem', null, global);
goog.exportSymbol('proto.xcommon.FuncOption', null, global);
goog.exportSymbol('proto.xcommon.FuncParamItem', null, global);
goog.exportSymbol('proto.xcommon.GetAppPerformanceReq', null, global);
goog.exportSymbol('proto.xcommon.GetAppPerformanceResp', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityOptionReq', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityOptionResp', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityRuleListReq', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityRuleListResp', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityRuleReq', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityRuleResp', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityScriptListReq', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityScriptListResp', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityScriptReq', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityScriptResp', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityTplListReq', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityTplListResp', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityTplReq', null, global);
goog.exportSymbol('proto.xcommon.GetAudioQualityTplResp', null, global);
goog.exportSymbol('proto.xcommon.GetBasicLoadAttrsReq', null, global);
goog.exportSymbol('proto.xcommon.GetBasicLoadAttrsResp', null, global);
goog.exportSymbol('proto.xcommon.GetBasicTicketAttrsReq', null, global);
goog.exportSymbol('proto.xcommon.GetBasicTicketAttrsResp', null, global);
goog.exportSymbol('proto.xcommon.GetBasicUserAttrsReq', null, global);
goog.exportSymbol('proto.xcommon.GetBasicUserAttrsResp', null, global);
goog.exportSymbol('proto.xcommon.GetCallingPlanConfigReq', null, global);
goog.exportSymbol('proto.xcommon.GetCallingPlanConfigResp', null, global);
goog.exportSymbol('proto.xcommon.GetCollectionConfigItem', null, global);
goog.exportSymbol('proto.xcommon.GetCollectionConfigReq', null, global);
goog.exportSymbol('proto.xcommon.GetCollectionConfigResp', null, global);
goog.exportSymbol('proto.xcommon.GetDialerListOrderReq', null, global);
goog.exportSymbol('proto.xcommon.GetDialerListOrderResp', null, global);
goog.exportSymbol('proto.xcommon.GetDialerListParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetDialerListParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetDialerListReq', null, global);
goog.exportSymbol('proto.xcommon.GetDialerListResp', null, global);
goog.exportSymbol('proto.xcommon.GetHourlyCollectionStatsReq', null, global);
goog.exportSymbol('proto.xcommon.GetHourlyCollectionStatsResp', null, global);
goog.exportSymbol('proto.xcommon.GetLoadAttrsOptionReq', null, global);
goog.exportSymbol('proto.xcommon.GetLoadAttrsOptionResp', null, global);
goog.exportSymbol('proto.xcommon.GetLoadAttrsReq', null, global);
goog.exportSymbol('proto.xcommon.GetLoadAttrsResp', null, global);
goog.exportSymbol('proto.xcommon.GetOcrMarkCaseReq', null, global);
goog.exportSymbol('proto.xcommon.GetOcrMarkCaseResp', null, global);
goog.exportSymbol('proto.xcommon.GetOcrMarkTicketListReq', null, global);
goog.exportSymbol('proto.xcommon.GetOcrMarkTicketListResp', null, global);
goog.exportSymbol('proto.xcommon.GetOrderRepayDetailReq', null, global);
goog.exportSymbol('proto.xcommon.GetOrderRepayDetailResp', null, global);
goog.exportSymbol('proto.xcommon.GetPVOptionStatsReq', null, global);
goog.exportSymbol('proto.xcommon.GetPVOptionStatsResp', null, global);
goog.exportSymbol('proto.xcommon.GetPVOptionStatsResp.OneRow', null, global);
goog.exportSymbol('proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay', null, global);
goog.exportSymbol('proto.xcommon.GetPVRecordReq', null, global);
goog.exportSymbol('proto.xcommon.GetPVRecordResp', null, global);
goog.exportSymbol('proto.xcommon.GetPVRecordResp.Answer', null, global);
goog.exportSymbol('proto.xcommon.GetReduceAuditListReq', null, global);
goog.exportSymbol('proto.xcommon.GetReduceAuditListResp', null, global);
goog.exportSymbol('proto.xcommon.GetReduceAuditListResp.ReduceAuditItem', null, global);
goog.exportSymbol('proto.xcommon.GetReduceDetailReq', null, global);
goog.exportSymbol('proto.xcommon.GetReduceDetailResp', null, global);
goog.exportSymbol('proto.xcommon.GetReduceListReq', null, global);
goog.exportSymbol('proto.xcommon.GetReduceListResp', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodeHistoryListReq', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodeHistoryListResp', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodePageCond', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodePageCond.RepayCodeItem', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodePageCondReq', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodePageCondResp', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodePageItem', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodePageReq', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodePageResp', null, global);
goog.exportSymbol('proto.xcommon.GetRepayCodePageResult', null, global);
goog.exportSymbol('proto.xcommon.GetRepaymentDetailReq', null, global);
goog.exportSymbol('proto.xcommon.GetRepaymentDetailResp', null, global);
goog.exportSymbol('proto.xcommon.GetReportListResp', null, global);
goog.exportSymbol('proto.xcommon.GetRobotCorpusMarkListReq', null, global);
goog.exportSymbol('proto.xcommon.GetRobotCorpusMarkListResp', null, global);
goog.exportSymbol('proto.xcommon.GetRolePerformanceReq', null, global);
goog.exportSymbol('proto.xcommon.GetRolePerformanceResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAssignParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAssignParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAssignRulesItem', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAssignRulesReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAssignRulesResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAttrFuncReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAttrFuncResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAttrsOptionReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAttrsOptionResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAttrsReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketAttrsResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketCaseNameListReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketCaseNameListResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketEntrustParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketEntrustParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketEntrustRulesItem', null, global);
goog.exportSymbol('proto.xcommon.GetTicketEntrustRulesReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketEntrustRulesResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketEstimateReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketEstimateResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketGroupByCountReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketGroupByCountResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketItemListReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketItemListResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketListParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketListParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketListReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketListResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketLogReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketLogResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketQuantityReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketQuantityResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecallParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecallParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecallRulesItem', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecallRulesReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecallRulesResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecycleParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecycleParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecycleRulesItem', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecycleRulesReq', null, global);
goog.exportSymbol('proto.xcommon.GetTicketRecycleRulesResp', null, global);
goog.exportSymbol('proto.xcommon.GetUrgeEfficiencyReq', null, global);
goog.exportSymbol('proto.xcommon.GetUrgeEfficiencyResp', null, global);
goog.exportSymbol('proto.xcommon.GetUrgeFollowReq', null, global);
goog.exportSymbol('proto.xcommon.GetUrgeFollowResp', null, global);
goog.exportSymbol('proto.xcommon.GetUserAttrFuncReq', null, global);
goog.exportSymbol('proto.xcommon.GetUserAttrFuncResp', null, global);
goog.exportSymbol('proto.xcommon.GetUserAttrsOptionReq', null, global);
goog.exportSymbol('proto.xcommon.GetUserAttrsOptionResp', null, global);
goog.exportSymbol('proto.xcommon.GetUserAttrsReq', null, global);
goog.exportSymbol('proto.xcommon.GetUserAttrsResp', null, global);
goog.exportSymbol('proto.xcommon.GetUserItemReq', null, global);
goog.exportSymbol('proto.xcommon.GetUserItemResp', null, global);
goog.exportSymbol('proto.xcommon.GetUserTicketLoadReq', null, global);
goog.exportSymbol('proto.xcommon.GetUserTicketLoadResp', null, global);
goog.exportSymbol('proto.xcommon.GetVerifyTicketHandleTimeReq', null, global);
goog.exportSymbol('proto.xcommon.GetVerifyTicketHandleTimeResp', null, global);
goog.exportSymbol('proto.xcommon.GetVerifyTicketListParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetVerifyTicketListParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetVerifyTicketListReq', null, global);
goog.exportSymbol('proto.xcommon.GetVerifyTicketListResp', null, global);
goog.exportSymbol('proto.xcommon.GetVoipQITicketListReq', null, global);
goog.exportSymbol('proto.xcommon.GetVoipQITicketListResp', null, global);
goog.exportSymbol('proto.xcommon.GetWaKeywordListParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetWaKeywordListParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetWaKeywordListReq', null, global);
goog.exportSymbol('proto.xcommon.GetWaKeywordListResp', null, global);
goog.exportSymbol('proto.xcommon.GetWaKeywordReq', null, global);
goog.exportSymbol('proto.xcommon.GetWaKeywordResp', null, global);
goog.exportSymbol('proto.xcommon.GetWorkerLoanUnpaidDetailReq', null, global);
goog.exportSymbol('proto.xcommon.GetWorkerLoanUnpaidDetailResp', null, global);
goog.exportSymbol('proto.xcommon.GetWorkerPerformanceReq', null, global);
goog.exportSymbol('proto.xcommon.GetWorkerPerformanceResp', null, global);
goog.exportSymbol('proto.xcommon.GetWorkerRepayDetailReq', null, global);
goog.exportSymbol('proto.xcommon.GetWorkerRepayDetailResp', null, global);
goog.exportSymbol('proto.xcommon.HitRule', null, global);
goog.exportSymbol('proto.xcommon.HourlyCollectionStat', null, global);
goog.exportSymbol('proto.xcommon.HourlyUrgeStatsReq', null, global);
goog.exportSymbol('proto.xcommon.HourlyUrgeStatsResp', null, global);
goog.exportSymbol('proto.xcommon.IDVerifyEnum', null, global);
goog.exportSymbol('proto.xcommon.ImageTypeEnum', null, global);
goog.exportSymbol('proto.xcommon.ImportWAPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.ImportWAPhoneResp', null, global);
goog.exportSymbol('proto.xcommon.IntentMap', null, global);
goog.exportSymbol('proto.xcommon.IntentNode', null, global);
goog.exportSymbol('proto.xcommon.ItemNode', null, global);
goog.exportSymbol('proto.xcommon.LawyerLetter', null, global);
goog.exportSymbol('proto.xcommon.LawyerLetterListReq', null, global);
goog.exportSymbol('proto.xcommon.LawyerLetterListResp', null, global);
goog.exportSymbol('proto.xcommon.LawyerLetterReq', null, global);
goog.exportSymbol('proto.xcommon.LawyerLetterSendType', null, global);
goog.exportSymbol('proto.xcommon.LawyerLetterStatus', null, global);
goog.exportSymbol('proto.xcommon.LeaderPSMetrics', null, global);
goog.exportSymbol('proto.xcommon.LeaderPSMetrics.AnswerNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPSMetrics.AssignNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPSMetrics.ClosureNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPSMetrics.HandleNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPSMetrics.TicketNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPVMetrics', null, global);
goog.exportSymbol('proto.xcommon.LeaderPVMetrics.AssignNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPVMetrics.CompleteNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPVMetrics.InspectionPassNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPVMetrics.InvalidNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPVMetrics.PassNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPVMetrics.RejectNumStat', null, global);
goog.exportSymbol('proto.xcommon.LeaderPVMetrics.TicketNumStat', null, global);
goog.exportSymbol('proto.xcommon.ListCallingPlanReq', null, global);
goog.exportSymbol('proto.xcommon.ListCallingPlanResp', null, global);
goog.exportSymbol('proto.xcommon.ListCallingPlanResp.CallingPlan', null, global);
goog.exportSymbol('proto.xcommon.ListMultilingualDetailReq', null, global);
goog.exportSymbol('proto.xcommon.ListMultilingualDetailResp', null, global);
goog.exportSymbol('proto.xcommon.ListMultilingualReq', null, global);
goog.exportSymbol('proto.xcommon.ListMultilingualResp', null, global);
goog.exportSymbol('proto.xcommon.ListPVCallReq', null, global);
goog.exportSymbol('proto.xcommon.ListPVCallResp', null, global);
goog.exportSymbol('proto.xcommon.ListPVCallResp.CallDetail', null, global);
goog.exportSymbol('proto.xcommon.ListPhoneSaleProductReq', null, global);
goog.exportSymbol('proto.xcommon.ListPhoneSaleProductResp', null, global);
goog.exportSymbol('proto.xcommon.ListPhoneSaleStatsReq', null, global);
goog.exportSymbol('proto.xcommon.ListPhoneSaleStatsResp', null, global);
goog.exportSymbol('proto.xcommon.ListPhoneVerifyReasonStatReq', null, global);
goog.exportSymbol('proto.xcommon.ListPhoneVerifyReasonStatResp', null, global);
goog.exportSymbol('proto.xcommon.ListPhoneVerifyStatsReq', null, global);
goog.exportSymbol('proto.xcommon.ListPhoneVerifyStatsResp', null, global);
goog.exportSymbol('proto.xcommon.ListPushDetailReq', null, global);
goog.exportSymbol('proto.xcommon.ListPushDetailResp', null, global);
goog.exportSymbol('proto.xcommon.ListPushDetailResp.OnePushDetailRow', null, global);
goog.exportSymbol('proto.xcommon.ListPushTaskReq', null, global);
goog.exportSymbol('proto.xcommon.ListPushTaskResp', null, global);
goog.exportSymbol('proto.xcommon.ListPushTemplateReq', null, global);
goog.exportSymbol('proto.xcommon.ListPushTemplateResp', null, global);
goog.exportSymbol('proto.xcommon.ListQuestionAssociatedItemReq', null, global);
goog.exportSymbol('proto.xcommon.ListQuestionAssociatedItemResp', null, global);
goog.exportSymbol('proto.xcommon.ListQuestionDisplayReq', null, global);
goog.exportSymbol('proto.xcommon.ListQuestionDisplayResp', null, global);
goog.exportSymbol('proto.xcommon.ListQuestionParameterReq', null, global);
goog.exportSymbol('proto.xcommon.ListQuestionParameterResp', null, global);
goog.exportSymbol('proto.xcommon.ListQuestionReq', null, global);
goog.exportSymbol('proto.xcommon.ListQuestionResp', null, global);
goog.exportSymbol('proto.xcommon.ListUrgeDetailStatsParamReq', null, global);
goog.exportSymbol('proto.xcommon.ListUrgeDetailStatsParamResp', null, global);
goog.exportSymbol('proto.xcommon.ListUrgeDetailStatsReq', null, global);
goog.exportSymbol('proto.xcommon.ListUrgeDetailStatsResp', null, global);
goog.exportSymbol('proto.xcommon.ListVerifyQuestionReq', null, global);
goog.exportSymbol('proto.xcommon.ListVerifyQuestionResp', null, global);
goog.exportSymbol('proto.xcommon.ListVerifyQuestionResp.Question', null, global);
goog.exportSymbol('proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem', null, global);
goog.exportSymbol('proto.xcommon.LoadAttrItem', null, global);
goog.exportSymbol('proto.xcommon.Logical', null, global);
goog.exportSymbol('proto.xcommon.ManualUpgradeTicketReq', null, global);
goog.exportSymbol('proto.xcommon.ManualUpgradeTicketResp', null, global);
goog.exportSymbol('proto.xcommon.ManualUpgradeTicketResultReq', null, global);
goog.exportSymbol('proto.xcommon.ManualUpgradeTicketResultResp', null, global);
goog.exportSymbol('proto.xcommon.MarkWAPhoneReq', null, global);
goog.exportSymbol('proto.xcommon.MarkWAPhoneResp', null, global);
goog.exportSymbol('proto.xcommon.MarkWAType', null, global);
goog.exportSymbol('proto.xcommon.MatchTimes', null, global);
goog.exportSymbol('proto.xcommon.ModifyAudioQualityRuleStatusReq', null, global);
goog.exportSymbol('proto.xcommon.ModifyAudioQualityScriptStatusReq', null, global);
goog.exportSymbol('proto.xcommon.ModifyAudioQualityTemplateStatusReq', null, global);
goog.exportSymbol('proto.xcommon.Multilingual', null, global);
goog.exportSymbol('proto.xcommon.MultilingualDetail', null, global);
goog.exportSymbol('proto.xcommon.OcrMarkStatus', null, global);
goog.exportSymbol('proto.xcommon.OcrMarkTicket', null, global);
goog.exportSymbol('proto.xcommon.OcrTypeEnum', null, global);
goog.exportSymbol('proto.xcommon.OpenTicketReq', null, global);
goog.exportSymbol('proto.xcommon.OpenTicketResp', null, global);
goog.exportSymbol('proto.xcommon.OrderUnpaidDetail', null, global);
goog.exportSymbol('proto.xcommon.OutSourceRepayStats', null, global);
goog.exportSymbol('proto.xcommon.OutSourceRepayStatsReq', null, global);
goog.exportSymbol('proto.xcommon.OutSourceRepayStatsResp', null, global);
goog.exportSymbol('proto.xcommon.OutSourceStats', null, global);
goog.exportSymbol('proto.xcommon.OutSourceStatsReq', null, global);
goog.exportSymbol('proto.xcommon.OutSourceStatsResp', null, global);
goog.exportSymbol('proto.xcommon.PSDashboardReq', null, global);
goog.exportSymbol('proto.xcommon.PSDashboardResp', null, global);
goog.exportSymbol('proto.xcommon.PSGroupStatsReq', null, global);
goog.exportSymbol('proto.xcommon.PSGroupStatsResp', null, global);
goog.exportSymbol('proto.xcommon.PSMetrics', null, global);
goog.exportSymbol('proto.xcommon.PSMetrics.AnswerNumStat', null, global);
goog.exportSymbol('proto.xcommon.PSMetrics.ClosureNumStat', null, global);
goog.exportSymbol('proto.xcommon.PVDashboardReq', null, global);
goog.exportSymbol('proto.xcommon.PVDashboardResp', null, global);
goog.exportSymbol('proto.xcommon.PVGroupStatsReq', null, global);
goog.exportSymbol('proto.xcommon.PVGroupStatsResp', null, global);
goog.exportSymbol('proto.xcommon.PVMetrics', null, global);
goog.exportSymbol('proto.xcommon.PVNextPage', null, global);
goog.exportSymbol('proto.xcommon.PVStatus', null, global);
goog.exportSymbol('proto.xcommon.PerformanceStat', null, global);
goog.exportSymbol('proto.xcommon.PhoneSaleItem', null, global);
goog.exportSymbol('proto.xcommon.PhoneSaleStats', null, global);
goog.exportSymbol('proto.xcommon.PhoneVerifyReasonStat', null, global);
goog.exportSymbol('proto.xcommon.PhoneVerifyStats', null, global);
goog.exportSymbol('proto.xcommon.Pies', null, global);
goog.exportSymbol('proto.xcommon.PushTask', null, global);
goog.exportSymbol('proto.xcommon.QOptionItem', null, global);
goog.exportSymbol('proto.xcommon.QStatusEnum', null, global);
goog.exportSymbol('proto.xcommon.QaResultSelect', null, global);
goog.exportSymbol('proto.xcommon.QpType', null, global);
goog.exportSymbol('proto.xcommon.QualityKindEnum', null, global);
goog.exportSymbol('proto.xcommon.QualityObject', null, global);
goog.exportSymbol('proto.xcommon.QualityPoint', null, global);
goog.exportSymbol('proto.xcommon.QualityReport', null, global);
goog.exportSymbol('proto.xcommon.QualityType', null, global);
goog.exportSymbol('proto.xcommon.Question', null, global);
goog.exportSymbol('proto.xcommon.QuestionDisplay', null, global);
goog.exportSymbol('proto.xcommon.QuestionDisplayEnum', null, global);
goog.exportSymbol('proto.xcommon.QuestionDisplayReq', null, global);
goog.exportSymbol('proto.xcommon.QuestionParameter', null, global);
goog.exportSymbol('proto.xcommon.QuestionParameterI18n', null, global);
goog.exportSymbol('proto.xcommon.QuestionParameterReq', null, global);
goog.exportSymbol('proto.xcommon.QuestionReq', null, global);
goog.exportSymbol('proto.xcommon.ReAudioQualityReq', null, global);
goog.exportSymbol('proto.xcommon.ReasonItemTotal', null, global);
goog.exportSymbol('proto.xcommon.ReduceApprovedType', null, global);
goog.exportSymbol('proto.xcommon.ReduceRecordBackend', null, global);
goog.exportSymbol('proto.xcommon.ReduceRecordBackend.ReduceOtherItem', null, global);
goog.exportSymbol('proto.xcommon.ReduceRecordLog', null, global);
goog.exportSymbol('proto.xcommon.ReduceStatus', null, global);
goog.exportSymbol('proto.xcommon.ReduceTicketReq', null, global);
goog.exportSymbol('proto.xcommon.ReduceTicketResp', null, global);
goog.exportSymbol('proto.xcommon.ReduceType', null, global);
goog.exportSymbol('proto.xcommon.RepeatScript', null, global);
goog.exportSymbol('proto.xcommon.Report', null, global);
goog.exportSymbol('proto.xcommon.ReportReq', null, global);
goog.exportSymbol('proto.xcommon.RestTimes', null, global);
goog.exportSymbol('proto.xcommon.ResultStrategies', null, global);
goog.exportSymbol('proto.xcommon.RobotCallOutRecordItem', null, global);
goog.exportSymbol('proto.xcommon.RobotCallOutRecordListParamsReq', null, global);
goog.exportSymbol('proto.xcommon.RobotCallOutRecordListParamsResp', null, global);
goog.exportSymbol('proto.xcommon.RobotCorpusMarkData', null, global);
goog.exportSymbol('proto.xcommon.RoleStats', null, global);
goog.exportSymbol('proto.xcommon.RollApplyTicketReq', null, global);
goog.exportSymbol('proto.xcommon.RollApplyTicketResp', null, global);
goog.exportSymbol('proto.xcommon.RollOrderApplyReq', null, global);
goog.exportSymbol('proto.xcommon.RollOrderApplyResp', null, global);
goog.exportSymbol('proto.xcommon.RollOrderCancelReq', null, global);
goog.exportSymbol('proto.xcommon.RollOrderCancelResp', null, global);
goog.exportSymbol('proto.xcommon.RollOrderTrialCalcReq', null, global);
goog.exportSymbol('proto.xcommon.RollOrderTrialCalcResp', null, global);
goog.exportSymbol('proto.xcommon.RuleAction', null, global);
goog.exportSymbol('proto.xcommon.SaveAudioQualityRuleReq', null, global);
goog.exportSymbol('proto.xcommon.SaveAudioQualityScriptReq', null, global);
goog.exportSymbol('proto.xcommon.SaveAudioQualityTplReq', null, global);
goog.exportSymbol('proto.xcommon.SaveDialerListOrderReq', null, global);
goog.exportSymbol('proto.xcommon.SaveDialerListOrderResp', null, global);
goog.exportSymbol('proto.xcommon.SaveDialerReq', null, global);
goog.exportSymbol('proto.xcommon.SaveDialerResp', null, global);
goog.exportSymbol('proto.xcommon.SaveLoadAttrReq', null, global);
goog.exportSymbol('proto.xcommon.SaveLoadAttrResp', null, global);
goog.exportSymbol('proto.xcommon.SaveMultilingualDetailReq', null, global);
goog.exportSymbol('proto.xcommon.SaveMultilingualDetailResp', null, global);
goog.exportSymbol('proto.xcommon.SaveMultilingualReq', null, global);
goog.exportSymbol('proto.xcommon.SaveMultilingualResp', null, global);
goog.exportSymbol('proto.xcommon.SaveOcrMarkCaseReq', null, global);
goog.exportSymbol('proto.xcommon.SaveOcrMarkCaseResp', null, global);
goog.exportSymbol('proto.xcommon.SavePVCallReq', null, global);
goog.exportSymbol('proto.xcommon.SavePVCallReq.SavePVCallBaseInfo', null, global);
goog.exportSymbol('proto.xcommon.SavePVCallResp', null, global);
goog.exportSymbol('proto.xcommon.SavePVRecordReq', null, global);
goog.exportSymbol('proto.xcommon.SavePVRecordReq.Answer', null, global);
goog.exportSymbol('proto.xcommon.SavePVRecordResp', null, global);
goog.exportSymbol('proto.xcommon.SavePushTaskReq', null, global);
goog.exportSymbol('proto.xcommon.SavePushTaskResp', null, global);
goog.exportSymbol('proto.xcommon.SaveQIRecordReq', null, global);
goog.exportSymbol('proto.xcommon.SaveQIRecordResp', null, global);
goog.exportSymbol('proto.xcommon.SaveReduceReq', null, global);
goog.exportSymbol('proto.xcommon.SaveReduceResp', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketAssignRuleReq', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketAssignRuleResp', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketAttrReq', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketAttrResp', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketEntrustRuleReq', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketEntrustRuleResp', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketItemsReq', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketRecallRuleReq', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketRecallRuleResp', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketRecycleRuleReq', null, global);
goog.exportSymbol('proto.xcommon.SaveTicketRecycleRuleResp', null, global);
goog.exportSymbol('proto.xcommon.SaveUserAttrReq', null, global);
goog.exportSymbol('proto.xcommon.SaveUserAttrResp', null, global);
goog.exportSymbol('proto.xcommon.SaveWaKeywordReq', null, global);
goog.exportSymbol('proto.xcommon.ScorePolicy', null, global);
goog.exportSymbol('proto.xcommon.ScriptPoint', null, global);
goog.exportSymbol('proto.xcommon.SeatTreeNode', null, global);
goog.exportSymbol('proto.xcommon.SimInfo', null, global);
goog.exportSymbol('proto.xcommon.SimplePSStats', null, global);
goog.exportSymbol('proto.xcommon.SimplePVStats', null, global);
goog.exportSymbol('proto.xcommon.SmsHistoryItem', null, global);
goog.exportSymbol('proto.xcommon.SmsHistoryReq', null, global);
goog.exportSymbol('proto.xcommon.SmsHistoryResp', null, global);
goog.exportSymbol('proto.xcommon.SmsStatsBackend', null, global);
goog.exportSymbol('proto.xcommon.SmsStatsReq', null, global);
goog.exportSymbol('proto.xcommon.SmsStatsResp', null, global);
goog.exportSymbol('proto.xcommon.StatDimension', null, global);
goog.exportSymbol('proto.xcommon.StatsSort', null, global);
goog.exportSymbol('proto.xcommon.StatsType', null, global);
goog.exportSymbol('proto.xcommon.StopTaskReq', null, global);
goog.exportSymbol('proto.xcommon.SuspendTicketReq', null, global);
goog.exportSymbol('proto.xcommon.SuspendTicketResp', null, global);
goog.exportSymbol('proto.xcommon.TalkResult', null, global);
goog.exportSymbol('proto.xcommon.ThirdStatus', null, global);
goog.exportSymbol('proto.xcommon.Ticket', null, global);
goog.exportSymbol('proto.xcommon.TicketAssignParam', null, global);
goog.exportSymbol('proto.xcommon.TicketAssignRuleAttr', null, global);
goog.exportSymbol('proto.xcommon.TicketAttrItem', null, global);
goog.exportSymbol('proto.xcommon.TicketBackend', null, global);
goog.exportSymbol('proto.xcommon.TicketDimension', null, global);
goog.exportSymbol('proto.xcommon.TicketEntrustRuleAttr', null, global);
goog.exportSymbol('proto.xcommon.TicketEstimate', null, global);
goog.exportSymbol('proto.xcommon.TicketEstimateBackend', null, global);
goog.exportSymbol('proto.xcommon.TicketGroupByCount', null, global);
goog.exportSymbol('proto.xcommon.TicketItem', null, global);
goog.exportSymbol('proto.xcommon.TicketItemEnum', null, global);
goog.exportSymbol('proto.xcommon.TicketLogBackend', null, global);
goog.exportSymbol('proto.xcommon.TicketQuantityStats', null, global);
goog.exportSymbol('proto.xcommon.TicketRecallRuleAttr', null, global);
goog.exportSymbol('proto.xcommon.TicketRecycleParam', null, global);
goog.exportSymbol('proto.xcommon.TicketRecycleRuleAttr', null, global);
goog.exportSymbol('proto.xcommon.UDDimension', null, global);
goog.exportSymbol('proto.xcommon.UrgeDetailStats', null, global);
goog.exportSymbol('proto.xcommon.UrgeEfficiency', null, global);
goog.exportSymbol('proto.xcommon.UrgeStatsItem', null, global);
goog.exportSymbol('proto.xcommon.UserAttrItem', null, global);
goog.exportSymbol('proto.xcommon.UserLoad', null, global);
goog.exportSymbol('proto.xcommon.VerifyInfoEnum', null, global);
goog.exportSymbol('proto.xcommon.VerifyInfoGroupEnum', null, global);
goog.exportSymbol('proto.xcommon.VerifyInfoItem', null, global);
goog.exportSymbol('proto.xcommon.VerifyStepItem', null, global);
goog.exportSymbol('proto.xcommon.VerifyTicketBackend', null, global);
goog.exportSymbol('proto.xcommon.VoipQITicketBackend', null, global);
goog.exportSymbol('proto.xcommon.WAGetChatByMobileReq', null, global);
goog.exportSymbol('proto.xcommon.WAGetChatByMobileResp', null, global);
goog.exportSymbol('proto.xcommon.WAGetChatByMobileResp.ChatInfo', null, global);
goog.exportSymbol('proto.xcommon.WAGetMobileByUIDReq', null, global);
goog.exportSymbol('proto.xcommon.WAGetMobileByUIDResp', null, global);
goog.exportSymbol('proto.xcommon.WAGetMobileByUIDResp.ChatInfo', null, global);
goog.exportSymbol('proto.xcommon.WAGetMobileByUIDResp.GroupInfo', null, global);
goog.exportSymbol('proto.xcommon.WAGetMsgByMobileReq', null, global);
goog.exportSymbol('proto.xcommon.WAGetMsgByMobileResp', null, global);
goog.exportSymbol('proto.xcommon.WAGetParamByUIDReq', null, global);
goog.exportSymbol('proto.xcommon.WAGetParamByUIDResp', null, global);
goog.exportSymbol('proto.xcommon.WAGetParamByUIDResp.PushTemplate', null, global);
goog.exportSymbol('proto.xcommon.WAGetQRCodeReq', null, global);
goog.exportSymbol('proto.xcommon.WAGetQRCodeResp', null, global);
goog.exportSymbol('proto.xcommon.WAInfo', null, global);
goog.exportSymbol('proto.xcommon.WAListReq', null, global);
goog.exportSymbol('proto.xcommon.WAListResp', null, global);
goog.exportSymbol('proto.xcommon.WALoginStatusReq', null, global);
goog.exportSymbol('proto.xcommon.WALoginStatusResp', null, global);
goog.exportSymbol('proto.xcommon.WAMsgInfo', null, global);
goog.exportSymbol('proto.xcommon.WAMsgReadReq', null, global);
goog.exportSymbol('proto.xcommon.WAMsgReadResp', null, global);
goog.exportSymbol('proto.xcommon.WASendTextMsgReq', null, global);
goog.exportSymbol('proto.xcommon.WASendTextMsgResp', null, global);
goog.exportSymbol('proto.xcommon.WASensitiveCheck', null, global);
goog.exportSymbol('proto.xcommon.WaKeywordData', null, global);
goog.exportSymbol('proto.xcommon.WarningLetter', null, global);
goog.exportSymbol('proto.xcommon.WarningLetterListReq', null, global);
goog.exportSymbol('proto.xcommon.WarningLetterListResp', null, global);
goog.exportSymbol('proto.xcommon.WarningLetterReq', null, global);
goog.exportSymbol('proto.xcommon.WarningLetterStatus', null, global);
goog.exportSymbol('proto.xcommon.WorkOrderStatistic', null, global);
goog.exportSymbol('proto.xcommon.WorkOrderStatisticReq', null, global);
goog.exportSymbol('proto.xcommon.WorkOrderStatisticResp', null, global);
goog.exportSymbol('proto.xcommon.WorkOverdueReasonStat', null, global);
goog.exportSymbol('proto.xcommon.WorkOverdueReasonStatReq', null, global);
goog.exportSymbol('proto.xcommon.WorkOverdueReasonStatResp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCollectionConfigReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCollectionConfigReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCollectionConfigReq.displayName = 'proto.xcommon.GetCollectionConfigReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCollectionConfigItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCollectionConfigItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCollectionConfigItem.displayName = 'proto.xcommon.GetCollectionConfigItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCollectionConfigResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCollectionConfigResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCollectionConfigResp.displayName = 'proto.xcommon.GetCollectionConfigResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CommonOutResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CommonOutResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CommonOutResp.displayName = 'proto.xcommon.CommonOutResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetBasicTicketAttrsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetBasicTicketAttrsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetBasicTicketAttrsReq.displayName = 'proto.xcommon.GetBasicTicketAttrsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetBasicTicketAttrsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetBasicTicketAttrsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetBasicTicketAttrsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetBasicTicketAttrsResp.displayName = 'proto.xcommon.GetBasicTicketAttrsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAttrFuncReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketAttrFuncReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAttrFuncReq.displayName = 'proto.xcommon.GetTicketAttrFuncReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAttrFuncResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketAttrFuncResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketAttrFuncResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAttrFuncResp.displayName = 'proto.xcommon.GetTicketAttrFuncResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAttrsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketAttrsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAttrsReq.displayName = 'proto.xcommon.GetTicketAttrsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAttrsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketAttrsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketAttrsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAttrsResp.displayName = 'proto.xcommon.GetTicketAttrsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAttrsOptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketAttrsOptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAttrsOptionReq.displayName = 'proto.xcommon.GetTicketAttrsOptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAttrsOptionResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketAttrsOptionResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketAttrsOptionResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAttrsOptionResp.displayName = 'proto.xcommon.GetTicketAttrsOptionResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketAttrReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketAttrReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketAttrReq.displayName = 'proto.xcommon.SaveTicketAttrReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketAttrResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketAttrResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketAttrResp.displayName = 'proto.xcommon.SaveTicketAttrResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetBasicUserAttrsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetBasicUserAttrsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetBasicUserAttrsReq.displayName = 'proto.xcommon.GetBasicUserAttrsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetBasicUserAttrsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetBasicUserAttrsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetBasicUserAttrsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetBasicUserAttrsResp.displayName = 'proto.xcommon.GetBasicUserAttrsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserAttrFuncReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUserAttrFuncReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserAttrFuncReq.displayName = 'proto.xcommon.GetUserAttrFuncReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserAttrFuncResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetUserAttrFuncResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetUserAttrFuncResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserAttrFuncResp.displayName = 'proto.xcommon.GetUserAttrFuncResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserAttrsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUserAttrsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserAttrsReq.displayName = 'proto.xcommon.GetUserAttrsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserAttrsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetUserAttrsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetUserAttrsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserAttrsResp.displayName = 'proto.xcommon.GetUserAttrsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserAttrsOptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUserAttrsOptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserAttrsOptionReq.displayName = 'proto.xcommon.GetUserAttrsOptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserAttrsOptionResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetUserAttrsOptionResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetUserAttrsOptionResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserAttrsOptionResp.displayName = 'proto.xcommon.GetUserAttrsOptionResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveUserAttrReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveUserAttrReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveUserAttrReq.displayName = 'proto.xcommon.SaveUserAttrReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveUserAttrResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveUserAttrResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveUserAttrResp.displayName = 'proto.xcommon.SaveUserAttrResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetBasicLoadAttrsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetBasicLoadAttrsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetBasicLoadAttrsReq.displayName = 'proto.xcommon.GetBasicLoadAttrsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetBasicLoadAttrsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetBasicLoadAttrsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetBasicLoadAttrsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetBasicLoadAttrsResp.displayName = 'proto.xcommon.GetBasicLoadAttrsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetLoadAttrsOptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetLoadAttrsOptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetLoadAttrsOptionReq.displayName = 'proto.xcommon.GetLoadAttrsOptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetLoadAttrsOptionResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetLoadAttrsOptionResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetLoadAttrsOptionResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetLoadAttrsOptionResp.displayName = 'proto.xcommon.GetLoadAttrsOptionResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetLoadAttrsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetLoadAttrsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetLoadAttrsReq.displayName = 'proto.xcommon.GetLoadAttrsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetLoadAttrsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetLoadAttrsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetLoadAttrsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetLoadAttrsResp.displayName = 'proto.xcommon.GetLoadAttrsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveLoadAttrReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveLoadAttrReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveLoadAttrReq.displayName = 'proto.xcommon.SaveLoadAttrReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveLoadAttrResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveLoadAttrResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveLoadAttrResp.displayName = 'proto.xcommon.SaveLoadAttrResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAssignParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketAssignParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAssignParamReq.displayName = 'proto.xcommon.GetTicketAssignParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAssignParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketAssignParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAssignParamResp.displayName = 'proto.xcommon.GetTicketAssignParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAssignRulesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketAssignRulesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAssignRulesReq.displayName = 'proto.xcommon.GetTicketAssignRulesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAssignRulesResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketAssignRulesResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketAssignRulesResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAssignRulesResp.displayName = 'proto.xcommon.GetTicketAssignRulesResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketAssignRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketAssignRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketAssignRuleReq.displayName = 'proto.xcommon.SaveTicketAssignRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketAssignRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketAssignRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketAssignRuleResp.displayName = 'proto.xcommon.SaveTicketAssignRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteTicketAssignRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteTicketAssignRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteTicketAssignRuleReq.displayName = 'proto.xcommon.DeleteTicketAssignRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteTicketAssignRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteTicketAssignRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteTicketAssignRuleResp.displayName = 'proto.xcommon.DeleteTicketAssignRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecycleParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketRecycleParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecycleParamReq.displayName = 'proto.xcommon.GetTicketRecycleParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecycleParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketRecycleParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecycleParamResp.displayName = 'proto.xcommon.GetTicketRecycleParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecycleRulesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketRecycleRulesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecycleRulesReq.displayName = 'proto.xcommon.GetTicketRecycleRulesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecycleRulesResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketRecycleRulesResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketRecycleRulesResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecycleRulesResp.displayName = 'proto.xcommon.GetTicketRecycleRulesResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketRecycleRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketRecycleRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketRecycleRuleReq.displayName = 'proto.xcommon.SaveTicketRecycleRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketRecycleRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketRecycleRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketRecycleRuleResp.displayName = 'proto.xcommon.SaveTicketRecycleRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteTicketRecycleRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteTicketRecycleRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteTicketRecycleRuleReq.displayName = 'proto.xcommon.DeleteTicketRecycleRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteTicketRecycleRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteTicketRecycleRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteTicketRecycleRuleResp.displayName = 'proto.xcommon.DeleteTicketRecycleRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketEntrustParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketEntrustParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketEntrustParamReq.displayName = 'proto.xcommon.GetTicketEntrustParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketEntrustParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketEntrustParamResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketEntrustParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketEntrustParamResp.displayName = 'proto.xcommon.GetTicketEntrustParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketEntrustRulesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketEntrustRulesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketEntrustRulesReq.displayName = 'proto.xcommon.GetTicketEntrustRulesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketEntrustRulesResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketEntrustRulesResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketEntrustRulesResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketEntrustRulesResp.displayName = 'proto.xcommon.GetTicketEntrustRulesResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketEntrustRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketEntrustRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketEntrustRuleReq.displayName = 'proto.xcommon.SaveTicketEntrustRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketEntrustRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketEntrustRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketEntrustRuleResp.displayName = 'proto.xcommon.SaveTicketEntrustRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteTicketEntrustRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteTicketEntrustRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteTicketEntrustRuleReq.displayName = 'proto.xcommon.DeleteTicketEntrustRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteTicketEntrustRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteTicketEntrustRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteTicketEntrustRuleResp.displayName = 'proto.xcommon.DeleteTicketEntrustRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecallParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketRecallParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecallParamReq.displayName = 'proto.xcommon.GetTicketRecallParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecallParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketRecallParamResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketRecallParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecallParamResp.displayName = 'proto.xcommon.GetTicketRecallParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecallRulesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketRecallRulesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecallRulesReq.displayName = 'proto.xcommon.GetTicketRecallRulesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecallRulesResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketRecallRulesResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketRecallRulesResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecallRulesResp.displayName = 'proto.xcommon.GetTicketRecallRulesResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketRecallRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketRecallRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketRecallRuleReq.displayName = 'proto.xcommon.SaveTicketRecallRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketRecallRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveTicketRecallRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketRecallRuleResp.displayName = 'proto.xcommon.SaveTicketRecallRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteTicketRecallRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteTicketRecallRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteTicketRecallRuleReq.displayName = 'proto.xcommon.DeleteTicketRecallRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DeleteTicketRecallRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DeleteTicketRecallRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DeleteTicketRecallRuleResp.displayName = 'proto.xcommon.DeleteTicketRecallRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityOptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityOptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityOptionReq.displayName = 'proto.xcommon.GetAudioQualityOptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityOptionResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityOptionResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityOptionResp.displayName = 'proto.xcommon.GetAudioQualityOptionResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityScriptListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityScriptListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityScriptListReq.displayName = 'proto.xcommon.GetAudioQualityScriptListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityScriptListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetAudioQualityScriptListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetAudioQualityScriptListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityScriptListResp.displayName = 'proto.xcommon.GetAudioQualityScriptListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityScriptReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityScriptReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityScriptReq.displayName = 'proto.xcommon.GetAudioQualityScriptReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityScriptResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityScriptResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityScriptResp.displayName = 'proto.xcommon.GetAudioQualityScriptResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveAudioQualityScriptReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveAudioQualityScriptReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveAudioQualityScriptReq.displayName = 'proto.xcommon.SaveAudioQualityScriptReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ModifyAudioQualityScriptStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ModifyAudioQualityScriptStatusReq.displayName = 'proto.xcommon.ModifyAudioQualityScriptStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AudioQualityScriptData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AudioQualityScriptData.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AudioQualityScriptData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AudioQualityScriptData.displayName = 'proto.xcommon.AudioQualityScriptData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityRuleListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityRuleListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityRuleListReq.displayName = 'proto.xcommon.GetAudioQualityRuleListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityRuleListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetAudioQualityRuleListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetAudioQualityRuleListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityRuleListResp.displayName = 'proto.xcommon.GetAudioQualityRuleListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityRuleReq.displayName = 'proto.xcommon.GetAudioQualityRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityRuleResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityRuleResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityRuleResp.displayName = 'proto.xcommon.GetAudioQualityRuleResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveAudioQualityRuleReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveAudioQualityRuleReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveAudioQualityRuleReq.displayName = 'proto.xcommon.SaveAudioQualityRuleReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ModifyAudioQualityRuleStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ModifyAudioQualityRuleStatusReq.displayName = 'proto.xcommon.ModifyAudioQualityRuleStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AudioQualityRuleData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AudioQualityRuleData.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AudioQualityRuleData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AudioQualityRuleData.displayName = 'proto.xcommon.AudioQualityRuleData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QualityPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.QualityPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QualityPoint.displayName = 'proto.xcommon.QualityPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RepeatScript = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RepeatScript, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RepeatScript.displayName = 'proto.xcommon.RepeatScript';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ScriptPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ScriptPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ScriptPoint.displayName = 'proto.xcommon.ScriptPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityTplListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityTplListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityTplListReq.displayName = 'proto.xcommon.GetAudioQualityTplListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityTplListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetAudioQualityTplListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetAudioQualityTplListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityTplListResp.displayName = 'proto.xcommon.GetAudioQualityTplListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityTplReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityTplReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityTplReq.displayName = 'proto.xcommon.GetAudioQualityTplReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAudioQualityTplResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAudioQualityTplResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAudioQualityTplResp.displayName = 'proto.xcommon.GetAudioQualityTplResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveAudioQualityTplReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveAudioQualityTplReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveAudioQualityTplReq.displayName = 'proto.xcommon.SaveAudioQualityTplReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ModifyAudioQualityTemplateStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ModifyAudioQualityTemplateStatusReq.displayName = 'proto.xcommon.ModifyAudioQualityTemplateStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReAudioQualityReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReAudioQualityReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReAudioQualityReq.displayName = 'proto.xcommon.ReAudioQualityReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AudioQualityTplData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AudioQualityTplData.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AudioQualityTplData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AudioQualityTplData.displayName = 'proto.xcommon.AudioQualityTplData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AudioQualityScope = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AudioQualityScope.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AudioQualityScope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AudioQualityScope.displayName = 'proto.xcommon.AudioQualityScope';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ItemNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ItemNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ItemNode.displayName = 'proto.xcommon.ItemNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVerifyTicketListParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetVerifyTicketListParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVerifyTicketListParamReq.displayName = 'proto.xcommon.GetVerifyTicketListParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVerifyTicketListParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVerifyTicketListParamResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVerifyTicketListParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVerifyTicketListParamResp.displayName = 'proto.xcommon.GetVerifyTicketListParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVerifyTicketListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetVerifyTicketListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVerifyTicketListReq.displayName = 'proto.xcommon.GetVerifyTicketListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVerifyTicketListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVerifyTicketListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVerifyTicketListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVerifyTicketListResp.displayName = 'proto.xcommon.GetVerifyTicketListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVerifyTicketHandleTimeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetVerifyTicketHandleTimeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVerifyTicketHandleTimeReq.displayName = 'proto.xcommon.GetVerifyTicketHandleTimeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVerifyTicketHandleTimeResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVerifyTicketHandleTimeResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVerifyTicketHandleTimeResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVerifyTicketHandleTimeResp.displayName = 'proto.xcommon.GetVerifyTicketHandleTimeResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketListParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketListParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketListParamReq.displayName = 'proto.xcommon.GetTicketListParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketListParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketListParamResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketListParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketListParamResp.displayName = 'proto.xcommon.GetTicketListParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketListReq.displayName = 'proto.xcommon.GetTicketListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketListResp.displayName = 'proto.xcommon.GetTicketListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketGroupByCountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketGroupByCountReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketGroupByCountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketGroupByCountReq.displayName = 'proto.xcommon.GetTicketGroupByCountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketGroupByCount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.TicketGroupByCount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketGroupByCount.displayName = 'proto.xcommon.TicketGroupByCount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketGroupByCountResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketGroupByCountResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketGroupByCountResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketGroupByCountResp.displayName = 'proto.xcommon.GetTicketGroupByCountResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketLogReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketLogReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketLogReq.displayName = 'proto.xcommon.GetTicketLogReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketLogResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketLogResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketLogResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketLogResp.displayName = 'proto.xcommon.GetTicketLogResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketLogBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.TicketLogBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketLogBackend.displayName = 'proto.xcommon.TicketLogBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchAssignTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchAssignTicketReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchAssignTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchAssignTicketReq.displayName = 'proto.xcommon.BatchAssignTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchAssignTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchAssignTicketResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchAssignTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchAssignTicketResp.displayName = 'proto.xcommon.BatchAssignTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchRecycleTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchRecycleTicketReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchRecycleTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchRecycleTicketReq.displayName = 'proto.xcommon.BatchRecycleTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchRecycleTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchRecycleTicketResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchRecycleTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchRecycleTicketResp.displayName = 'proto.xcommon.BatchRecycleTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchEntrustTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchEntrustTicketReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchEntrustTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchEntrustTicketReq.displayName = 'proto.xcommon.BatchEntrustTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchEntrustTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchEntrustTicketResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchEntrustTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchEntrustTicketResp.displayName = 'proto.xcommon.BatchEntrustTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchRecallTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchRecallTicketReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchRecallTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchRecallTicketReq.displayName = 'proto.xcommon.BatchRecallTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.BatchRecallTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.BatchRecallTicketResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.BatchRecallTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.BatchRecallTicketResp.displayName = 'proto.xcommon.BatchRecallTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReduceTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceTicketReq.displayName = 'proto.xcommon.ReduceTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ReduceTicketResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ReduceTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceTicketResp.displayName = 'proto.xcommon.ReduceTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DoReducePrincipalReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DoReducePrincipalReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DoReducePrincipalReq.displayName = 'proto.xcommon.DoReducePrincipalReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DoReducePrincipalResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DoReducePrincipalResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DoReducePrincipalResp.displayName = 'proto.xcommon.DoReducePrincipalResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DoReduceOtherReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.DoReduceOtherReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.DoReduceOtherReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DoReduceOtherReq.displayName = 'proto.xcommon.DoReduceOtherReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DoReduceOtherResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DoReduceOtherResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DoReduceOtherResp.displayName = 'proto.xcommon.DoReduceOtherResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollApplyTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollApplyTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollApplyTicketReq.displayName = 'proto.xcommon.RollApplyTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollApplyTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollApplyTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollApplyTicketResp.displayName = 'proto.xcommon.RollApplyTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssignTicketTrialCalcReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AssignTicketTrialCalcReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssignTicketTrialCalcReq.displayName = 'proto.xcommon.AssignTicketTrialCalcReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssignTicketTrialCalcResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AssignTicketTrialCalcResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AssignTicketTrialCalcResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssignTicketTrialCalcResp.displayName = 'proto.xcommon.AssignTicketTrialCalcResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.displayName = 'proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollOrderTrialCalcReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollOrderTrialCalcReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollOrderTrialCalcReq.displayName = 'proto.xcommon.RollOrderTrialCalcReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollOrderTrialCalcResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollOrderTrialCalcResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollOrderTrialCalcResp.displayName = 'proto.xcommon.RollOrderTrialCalcResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollOrderApplyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollOrderApplyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollOrderApplyReq.displayName = 'proto.xcommon.RollOrderApplyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollOrderApplyResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollOrderApplyResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollOrderApplyResp.displayName = 'proto.xcommon.RollOrderApplyResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollOrderCancelReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollOrderCancelReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollOrderCancelReq.displayName = 'proto.xcommon.RollOrderCancelReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollOrderCancelResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollOrderCancelResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollOrderCancelResp.displayName = 'proto.xcommon.RollOrderCancelResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OpenTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OpenTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OpenTicketReq.displayName = 'proto.xcommon.OpenTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OpenTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OpenTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OpenTicketResp.displayName = 'proto.xcommon.OpenTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CloseTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CloseTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CloseTicketReq.displayName = 'proto.xcommon.CloseTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CloseTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CloseTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CloseTicketResp.displayName = 'proto.xcommon.CloseTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SuspendTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SuspendTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SuspendTicketReq.displayName = 'proto.xcommon.SuspendTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SuspendTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SuspendTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SuspendTicketResp.displayName = 'proto.xcommon.SuspendTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketEstimateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketEstimateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketEstimateReq.displayName = 'proto.xcommon.GetTicketEstimateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketEstimate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.TicketEstimate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketEstimate.displayName = 'proto.xcommon.TicketEstimate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketEstimateBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.TicketEstimateBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketEstimateBackend.displayName = 'proto.xcommon.TicketEstimateBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketEstimateResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketEstimateResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketEstimateResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketEstimateResp.displayName = 'proto.xcommon.GetTicketEstimateResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CommonItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CommonItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CommonItem.displayName = 'proto.xcommon.CommonItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AttrItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AttrItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AttrItem.displayName = 'proto.xcommon.AttrItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.FuncItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.FuncItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.FuncItem.displayName = 'proto.xcommon.FuncItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.FuncParamItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.FuncParamItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.FuncParamItem.displayName = 'proto.xcommon.FuncParamItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PhoneSaleItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PhoneSaleItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PhoneSaleItem.displayName = 'proto.xcommon.PhoneSaleItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.FuncOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.FuncOption.repeatedFields_, null);
};
goog.inherits(proto.xcommon.FuncOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.FuncOption.displayName = 'proto.xcommon.FuncOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketAttrItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.TicketAttrItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketAttrItem.displayName = 'proto.xcommon.TicketAttrItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserAttrItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserAttrItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserAttrItem.displayName = 'proto.xcommon.UserAttrItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LoadAttrItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LoadAttrItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LoadAttrItem.displayName = 'proto.xcommon.LoadAttrItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketAssignParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TicketAssignParam.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TicketAssignParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketAssignParam.displayName = 'proto.xcommon.TicketAssignParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketAssignRuleAttr = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TicketAssignRuleAttr.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TicketAssignRuleAttr, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketAssignRuleAttr.displayName = 'proto.xcommon.TicketAssignRuleAttr';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketRecycleParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TicketRecycleParam.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TicketRecycleParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketRecycleParam.displayName = 'proto.xcommon.TicketRecycleParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketRecycleRuleAttr = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TicketRecycleRuleAttr.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TicketRecycleRuleAttr, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketRecycleRuleAttr.displayName = 'proto.xcommon.TicketRecycleRuleAttr';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketEntrustRuleAttr = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TicketEntrustRuleAttr.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TicketEntrustRuleAttr, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketEntrustRuleAttr.displayName = 'proto.xcommon.TicketEntrustRuleAttr';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketAssignRulesItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketAssignRulesItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketAssignRulesItem.displayName = 'proto.xcommon.GetTicketAssignRulesItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecycleRulesItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketRecycleRulesItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecycleRulesItem.displayName = 'proto.xcommon.GetTicketRecycleRulesItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketEntrustRulesItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketEntrustRulesItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketEntrustRulesItem.displayName = 'proto.xcommon.GetTicketEntrustRulesItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketRecallRuleAttr = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TicketRecallRuleAttr.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TicketRecallRuleAttr, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketRecallRuleAttr.displayName = 'proto.xcommon.TicketRecallRuleAttr';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketRecallRulesItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketRecallRulesItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketRecallRulesItem.displayName = 'proto.xcommon.GetTicketRecallRulesItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Ticket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Ticket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Ticket.displayName = 'proto.xcommon.Ticket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.VerifyTicketBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.VerifyTicketBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.VerifyTicketBackend.displayName = 'proto.xcommon.VerifyTicketBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TicketBackend.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TicketBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketBackend.displayName = 'proto.xcommon.TicketBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketItemListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketItemListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketItemListReq.displayName = 'proto.xcommon.GetTicketItemListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketItemListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketItemListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketItemListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketItemListResp.displayName = 'proto.xcommon.GetTicketItemListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketCaseNameListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketCaseNameListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketCaseNameListReq.displayName = 'proto.xcommon.GetTicketCaseNameListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketCaseNameListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketCaseNameListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketCaseNameListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketCaseNameListResp.displayName = 'proto.xcommon.GetTicketCaseNameListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveTicketItemsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SaveTicketItemsReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SaveTicketItemsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveTicketItemsReq.displayName = 'proto.xcommon.SaveTicketItemsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DelTicketItemReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DelTicketItemReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DelTicketItemReq.displayName = 'proto.xcommon.DelTicketItemReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.TicketItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketItem.displayName = 'proto.xcommon.TicketItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWorkerPerformanceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWorkerPerformanceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWorkerPerformanceReq.displayName = 'proto.xcommon.GetWorkerPerformanceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWorkerPerformanceResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetWorkerPerformanceResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetWorkerPerformanceResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWorkerPerformanceResp.displayName = 'proto.xcommon.GetWorkerPerformanceResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PerformanceStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PerformanceStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PerformanceStat.displayName = 'proto.xcommon.PerformanceStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRolePerformanceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRolePerformanceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRolePerformanceReq.displayName = 'proto.xcommon.GetRolePerformanceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRolePerformanceResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRolePerformanceResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRolePerformanceResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRolePerformanceResp.displayName = 'proto.xcommon.GetRolePerformanceResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RoleStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RoleStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RoleStats.displayName = 'proto.xcommon.RoleStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAppPerformanceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAppPerformanceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAppPerformanceReq.displayName = 'proto.xcommon.GetAppPerformanceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAppPerformanceResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetAppPerformanceResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetAppPerformanceResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAppPerformanceResp.displayName = 'proto.xcommon.GetAppPerformanceResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AppStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AppStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AppStats.displayName = 'proto.xcommon.AppStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.FileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.FileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.FileResponse.displayName = 'proto.xcommon.FileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DashboardReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DashboardReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DashboardReq.displayName = 'proto.xcommon.DashboardReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DashboardResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.DashboardResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.DashboardResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DashboardResp.displayName = 'proto.xcommon.DashboardResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Pies = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Pies, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Pies.displayName = 'proto.xcommon.Pies';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ChartItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ChartItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ChartItem.displayName = 'proto.xcommon.ChartItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DashboardStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DashboardStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DashboardStats.displayName = 'proto.xcommon.DashboardStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUrgeEfficiencyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUrgeEfficiencyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUrgeEfficiencyReq.displayName = 'proto.xcommon.GetUrgeEfficiencyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUrgeEfficiencyResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetUrgeEfficiencyResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetUrgeEfficiencyResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUrgeEfficiencyResp.displayName = 'proto.xcommon.GetUrgeEfficiencyResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUrgeFollowReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUrgeFollowReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUrgeFollowReq.displayName = 'proto.xcommon.GetUrgeFollowReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUrgeFollowResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetUrgeFollowResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetUrgeFollowResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUrgeFollowResp.displayName = 'proto.xcommon.GetUrgeFollowResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UrgeEfficiency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UrgeEfficiency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UrgeEfficiency.displayName = 'proto.xcommon.UrgeEfficiency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Follow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Follow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Follow.displayName = 'proto.xcommon.Follow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReportReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReportReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReportReq.displayName = 'proto.xcommon.ReportReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Report = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Report, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Report.displayName = 'proto.xcommon.Report';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DelReportReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DelReportReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DelReportReq.displayName = 'proto.xcommon.DelReportReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReportListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetReportListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetReportListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReportListResp.displayName = 'proto.xcommon.GetReportListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodePageCondReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepayCodePageCondReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodePageCondReq.displayName = 'proto.xcommon.GetRepayCodePageCondReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodePageCondResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepayCodePageCondResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodePageCondResp.displayName = 'proto.xcommon.GetRepayCodePageCondResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodePageReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepayCodePageReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodePageReq.displayName = 'proto.xcommon.GetRepayCodePageReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodePageResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRepayCodePageResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRepayCodePageResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodePageResp.displayName = 'proto.xcommon.GetRepayCodePageResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodePageItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepayCodePageItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodePageItem.displayName = 'proto.xcommon.GetRepayCodePageItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodePageCond = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRepayCodePageCond.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRepayCodePageCond, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodePageCond.displayName = 'proto.xcommon.GetRepayCodePageCond';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepayCodePageCond.RepayCodeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodePageCond.RepayCodeItem.displayName = 'proto.xcommon.GetRepayCodePageCond.RepayCodeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodePageResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRepayCodePageResult.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRepayCodePageResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodePageResult.displayName = 'proto.xcommon.GetRepayCodePageResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodeHistoryListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepayCodeHistoryListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodeHistoryListReq.displayName = 'proto.xcommon.GetRepayCodeHistoryListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayCodeHistoryListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRepayCodeHistoryListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRepayCodeHistoryListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayCodeHistoryListResp.displayName = 'proto.xcommon.GetRepayCodeHistoryListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReduceListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetReduceListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetReduceListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReduceListReq.displayName = 'proto.xcommon.GetReduceListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReduceListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetReduceListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetReduceListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReduceListResp.displayName = 'proto.xcommon.GetReduceListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceRecordLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReduceRecordLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceRecordLog.displayName = 'proto.xcommon.ReduceRecordLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceRecordBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ReduceRecordBackend.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ReduceRecordBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceRecordBackend.displayName = 'proto.xcommon.ReduceRecordBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReduceRecordBackend.ReduceOtherItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceRecordBackend.ReduceOtherItem.displayName = 'proto.xcommon.ReduceRecordBackend.ReduceOtherItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReduceDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetReduceDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReduceDetailReq.displayName = 'proto.xcommon.GetReduceDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReduceDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetReduceDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetReduceDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReduceDetailResp.displayName = 'proto.xcommon.GetReduceDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReduceAuditListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetReduceAuditListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReduceAuditListReq.displayName = 'proto.xcommon.GetReduceAuditListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReduceAuditListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetReduceAuditListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetReduceAuditListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReduceAuditListResp.displayName = 'proto.xcommon.GetReduceAuditListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetReduceAuditListResp.ReduceAuditItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.displayName = 'proto.xcommon.GetReduceAuditListResp.ReduceAuditItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveReduceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveReduceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveReduceReq.displayName = 'proto.xcommon.SaveReduceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveReduceResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveReduceResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveReduceResp.displayName = 'proto.xcommon.SaveReduceResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QuestionParameterI18n = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.QuestionParameterI18n, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QuestionParameterI18n.displayName = 'proto.xcommon.QuestionParameterI18n';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QuestionParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.QuestionParameter.repeatedFields_, null);
};
goog.inherits(proto.xcommon.QuestionParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QuestionParameter.displayName = 'proto.xcommon.QuestionParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QuestionParameterReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.QuestionParameterReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QuestionParameterReq.displayName = 'proto.xcommon.QuestionParameterReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListQuestionParameterReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListQuestionParameterReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListQuestionParameterReq.displayName = 'proto.xcommon.ListQuestionParameterReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListQuestionParameterResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListQuestionParameterResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListQuestionParameterResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListQuestionParameterResp.displayName = 'proto.xcommon.ListQuestionParameterResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Question = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.Question.repeatedFields_, null);
};
goog.inherits(proto.xcommon.Question, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Question.displayName = 'proto.xcommon.Question';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QuestionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.QuestionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QuestionReq.displayName = 'proto.xcommon.QuestionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListQuestionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListQuestionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListQuestionReq.displayName = 'proto.xcommon.ListQuestionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListQuestionResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListQuestionResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListQuestionResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListQuestionResp.displayName = 'proto.xcommon.ListQuestionResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QuestionDisplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.QuestionDisplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QuestionDisplay.displayName = 'proto.xcommon.QuestionDisplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QuestionDisplayReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.QuestionDisplayReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QuestionDisplayReq.displayName = 'proto.xcommon.QuestionDisplayReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListQuestionDisplayReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListQuestionDisplayReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListQuestionDisplayReq.displayName = 'proto.xcommon.ListQuestionDisplayReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListQuestionDisplayResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListQuestionDisplayResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListQuestionDisplayResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListQuestionDisplayResp.displayName = 'proto.xcommon.ListQuestionDisplayResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListQuestionAssociatedItemReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListQuestionAssociatedItemReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListQuestionAssociatedItemReq.displayName = 'proto.xcommon.ListQuestionAssociatedItemReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListQuestionAssociatedItemResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListQuestionAssociatedItemResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListQuestionAssociatedItemResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListQuestionAssociatedItemResp.displayName = 'proto.xcommon.ListQuestionAssociatedItemResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssociatedItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AssociatedItem.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AssociatedItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssociatedItem.displayName = 'proto.xcommon.AssociatedItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.VerifyInfoItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.VerifyInfoItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.VerifyInfoItem.displayName = 'proto.xcommon.VerifyInfoItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AutoCallParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AutoCallParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AutoCallParams.displayName = 'proto.xcommon.AutoCallParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AutoCallCoreReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AutoCallCoreReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AutoCallCoreReq.displayName = 'proto.xcommon.AutoCallCoreReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AutoCallCoreResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AutoCallCoreResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AutoCallCoreResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AutoCallCoreResp.displayName = 'proto.xcommon.AutoCallCoreResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ManualUpgradeTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ManualUpgradeTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ManualUpgradeTicketReq.displayName = 'proto.xcommon.ManualUpgradeTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ManualUpgradeTicketResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ManualUpgradeTicketResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ManualUpgradeTicketResp.displayName = 'proto.xcommon.ManualUpgradeTicketResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ManualUpgradeTicketResultReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ManualUpgradeTicketResultReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ManualUpgradeTicketResultReq.displayName = 'proto.xcommon.ManualUpgradeTicketResultReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ManualUpgradeTicketResultResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ManualUpgradeTicketResultResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ManualUpgradeTicketResultResp.displayName = 'proto.xcommon.ManualUpgradeTicketResultResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepaymentDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepaymentDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepaymentDetailReq.displayName = 'proto.xcommon.GetRepaymentDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepaymentDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRepaymentDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRepaymentDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepaymentDetailResp.displayName = 'proto.xcommon.GetRepaymentDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWorkerRepayDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWorkerRepayDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWorkerRepayDetailReq.displayName = 'proto.xcommon.GetWorkerRepayDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWorkerRepayDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetWorkerRepayDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetWorkerRepayDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWorkerRepayDetailResp.displayName = 'proto.xcommon.GetWorkerRepayDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWorkerLoanUnpaidDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWorkerLoanUnpaidDetailReq.displayName = 'proto.xcommon.GetWorkerLoanUnpaidDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetWorkerLoanUnpaidDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetWorkerLoanUnpaidDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWorkerLoanUnpaidDetailResp.displayName = 'proto.xcommon.GetWorkerLoanUnpaidDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderUnpaidDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderUnpaidDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderUnpaidDetail.displayName = 'proto.xcommon.OrderUnpaidDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOrderRepayDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOrderRepayDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOrderRepayDetailReq.displayName = 'proto.xcommon.GetOrderRepayDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOrderRepayDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetOrderRepayDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetOrderRepayDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOrderRepayDetailResp.displayName = 'proto.xcommon.GetOrderRepayDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CallingPlanReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CallingPlanReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CallingPlanReq.displayName = 'proto.xcommon.CallingPlanReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RestTimes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RestTimes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RestTimes.displayName = 'proto.xcommon.RestTimes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ResultStrategies = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ResultStrategies.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ResultStrategies, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ResultStrategies.displayName = 'proto.xcommon.ResultStrategies';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QaResultSelect = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.QaResultSelect, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QaResultSelect.displayName = 'proto.xcommon.QaResultSelect';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CallingPlanResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CallingPlanResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CallingPlanResp.displayName = 'proto.xcommon.CallingPlanResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCallingPlanConfigReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCallingPlanConfigReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCallingPlanConfigReq.displayName = 'proto.xcommon.GetCallingPlanConfigReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCallingPlanConfigResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetCallingPlanConfigResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetCallingPlanConfigResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCallingPlanConfigResp.displayName = 'proto.xcommon.GetCallingPlanConfigResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DealMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DealMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DealMethod.displayName = 'proto.xcommon.DealMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SeatTreeNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SeatTreeNode.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SeatTreeNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SeatTreeNode.displayName = 'proto.xcommon.SeatTreeNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TalkResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TalkResult.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TalkResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TalkResult.displayName = 'proto.xcommon.TalkResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListCallingPlanReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListCallingPlanReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListCallingPlanReq.displayName = 'proto.xcommon.ListCallingPlanReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListCallingPlanResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListCallingPlanResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListCallingPlanResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListCallingPlanResp.displayName = 'proto.xcommon.ListCallingPlanResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListCallingPlanResp.CallingPlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListCallingPlanResp.CallingPlan.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListCallingPlanResp.CallingPlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListCallingPlanResp.CallingPlan.displayName = 'proto.xcommon.ListCallingPlanResp.CallingPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.StopTaskReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.StopTaskReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.StopTaskReq.displayName = 'proto.xcommon.StopTaskReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Dialer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Dialer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Dialer.displayName = 'proto.xcommon.Dialer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerBackend.displayName = 'proto.xcommon.DialerBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerListOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerListOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerListOrder.displayName = 'proto.xcommon.DialerListOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerListOrderBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerListOrderBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerListOrderBackend.displayName = 'proto.xcommon.DialerListOrderBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialerListParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetDialerListParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialerListParamReq.displayName = 'proto.xcommon.GetDialerListParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialerListParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetDialerListParamResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetDialerListParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialerListParamResp.displayName = 'proto.xcommon.GetDialerListParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialerListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetDialerListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialerListReq.displayName = 'proto.xcommon.GetDialerListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialerListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetDialerListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetDialerListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialerListResp.displayName = 'proto.xcommon.GetDialerListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveDialerReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveDialerReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveDialerReq.displayName = 'proto.xcommon.SaveDialerReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveDialerResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveDialerResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveDialerResp.displayName = 'proto.xcommon.SaveDialerResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialerListOrderReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetDialerListOrderReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialerListOrderReq.displayName = 'proto.xcommon.GetDialerListOrderReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetDialerListOrderResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetDialerListOrderResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetDialerListOrderResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetDialerListOrderResp.displayName = 'proto.xcommon.GetDialerListOrderResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveDialerListOrderReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveDialerListOrderReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveDialerListOrderReq.displayName = 'proto.xcommon.SaveDialerListOrderReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveDialerListOrderResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveDialerListOrderResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveDialerListOrderResp.displayName = 'proto.xcommon.SaveDialerListOrderResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerCurrentInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerCurrentInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerCurrentInfoReq.displayName = 'proto.xcommon.DialerCurrentInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerCurrentInfoResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerCurrentInfoResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerCurrentInfoResp.displayName = 'proto.xcommon.DialerCurrentInfoResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerAutoStartReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerAutoStartReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerAutoStartReq.displayName = 'proto.xcommon.DialerAutoStartReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerAutoStartResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerAutoStartResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerAutoStartResp.displayName = 'proto.xcommon.DialerAutoStartResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerAutoStopReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerAutoStopReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerAutoStopReq.displayName = 'proto.xcommon.DialerAutoStopReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerAutoStopResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerAutoStopResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerAutoStopResp.displayName = 'proto.xcommon.DialerAutoStopResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerAutoNextReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerAutoNextReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerAutoNextReq.displayName = 'proto.xcommon.DialerAutoNextReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DialerAutoNextResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DialerAutoNextResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DialerAutoNextResp.displayName = 'proto.xcommon.DialerAutoNextResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LawyerLetterListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LawyerLetterListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LawyerLetterListReq.displayName = 'proto.xcommon.LawyerLetterListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LawyerLetterListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.LawyerLetterListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.LawyerLetterListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LawyerLetterListResp.displayName = 'proto.xcommon.LawyerLetterListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LawyerLetter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LawyerLetter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LawyerLetter.displayName = 'proto.xcommon.LawyerLetter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LawyerLetterReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LawyerLetterReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LawyerLetterReq.displayName = 'proto.xcommon.LawyerLetterReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListVerifyQuestionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListVerifyQuestionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListVerifyQuestionReq.displayName = 'proto.xcommon.ListVerifyQuestionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListVerifyQuestionResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListVerifyQuestionResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListVerifyQuestionResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListVerifyQuestionResp.displayName = 'proto.xcommon.ListVerifyQuestionResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListVerifyQuestionResp.Question = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListVerifyQuestionResp.Question.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListVerifyQuestionResp.Question, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListVerifyQuestionResp.Question.displayName = 'proto.xcommon.ListVerifyQuestionResp.Question';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.displayName = 'proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QOptionItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.QOptionItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QOptionItem.displayName = 'proto.xcommon.QOptionItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePVRecordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SavePVRecordReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SavePVRecordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePVRecordReq.displayName = 'proto.xcommon.SavePVRecordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePVRecordReq.Answer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePVRecordReq.Answer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePVRecordReq.Answer.displayName = 'proto.xcommon.SavePVRecordReq.Answer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePVRecordResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePVRecordResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePVRecordResp.displayName = 'proto.xcommon.SavePVRecordResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PVNextPage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PVNextPage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PVNextPage.displayName = 'proto.xcommon.PVNextPage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPVRecordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetPVRecordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPVRecordReq.displayName = 'proto.xcommon.GetPVRecordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPVRecordResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetPVRecordResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetPVRecordResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPVRecordResp.displayName = 'proto.xcommon.GetPVRecordResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPVRecordResp.Answer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetPVRecordResp.Answer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPVRecordResp.Answer.displayName = 'proto.xcommon.GetPVRecordResp.Answer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePVCallReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePVCallReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePVCallReq.displayName = 'proto.xcommon.SavePVCallReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePVCallReq.SavePVCallBaseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.displayName = 'proto.xcommon.SavePVCallReq.SavePVCallBaseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePVCallResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePVCallResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePVCallResp.displayName = 'proto.xcommon.SavePVCallResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPVCallReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPVCallReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPVCallReq.displayName = 'proto.xcommon.ListPVCallReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPVCallResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListPVCallResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListPVCallResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPVCallResp.displayName = 'proto.xcommon.ListPVCallResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPVCallResp.CallDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPVCallResp.CallDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPVCallResp.CallDetail.displayName = 'proto.xcommon.ListPVCallResp.CallDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveQIRecordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveQIRecordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveQIRecordReq.displayName = 'proto.xcommon.SaveQIRecordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveQIRecordResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveQIRecordResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveQIRecordResp.displayName = 'proto.xcommon.SaveQIRecordResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WarningLetterListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WarningLetterListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WarningLetterListReq.displayName = 'proto.xcommon.WarningLetterListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WarningLetterListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WarningLetterListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WarningLetterListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WarningLetterListResp.displayName = 'proto.xcommon.WarningLetterListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WarningLetter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WarningLetter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WarningLetter.displayName = 'proto.xcommon.WarningLetter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DownWarningLetterReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DownWarningLetterReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DownWarningLetterReq.displayName = 'proto.xcommon.DownWarningLetterReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DownWarningLetterResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DownWarningLetterResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DownWarningLetterResp.displayName = 'proto.xcommon.DownWarningLetterResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WarningLetterReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WarningLetterReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WarningLetterReq.displayName = 'proto.xcommon.WarningLetterReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserTicketLoadReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetUserTicketLoadReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetUserTicketLoadReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserTicketLoadReq.displayName = 'proto.xcommon.GetUserTicketLoadReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserTicketLoadResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetUserTicketLoadResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetUserTicketLoadResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserTicketLoadResp.displayName = 'proto.xcommon.GetUserTicketLoadResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UserLoad = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UserLoad, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UserLoad.displayName = 'proto.xcommon.UserLoad';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListUrgeDetailStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListUrgeDetailStatsReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListUrgeDetailStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListUrgeDetailStatsReq.displayName = 'proto.xcommon.ListUrgeDetailStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListUrgeDetailStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListUrgeDetailStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListUrgeDetailStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListUrgeDetailStatsResp.displayName = 'proto.xcommon.ListUrgeDetailStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UrgeDetailStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UrgeDetailStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UrgeDetailStats.displayName = 'proto.xcommon.UrgeDetailStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListUrgeDetailStatsParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListUrgeDetailStatsParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListUrgeDetailStatsParamReq.displayName = 'proto.xcommon.ListUrgeDetailStatsParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListUrgeDetailStatsParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListUrgeDetailStatsParamResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListUrgeDetailStatsParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListUrgeDetailStatsParamResp.displayName = 'proto.xcommon.ListUrgeDetailStatsParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.HourlyUrgeStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.HourlyUrgeStatsReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.HourlyUrgeStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.HourlyUrgeStatsReq.displayName = 'proto.xcommon.HourlyUrgeStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.HourlyUrgeStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.HourlyUrgeStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.HourlyUrgeStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.HourlyUrgeStatsResp.displayName = 'proto.xcommon.HourlyUrgeStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UrgeStatsItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UrgeStatsItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UrgeStatsItem.displayName = 'proto.xcommon.UrgeStatsItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallOutRecordListParamsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RobotCallOutRecordListParamsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallOutRecordListParamsReq.displayName = 'proto.xcommon.RobotCallOutRecordListParamsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallOutRecordItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RobotCallOutRecordItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallOutRecordItem.displayName = 'proto.xcommon.RobotCallOutRecordItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCallOutRecordListParamsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.RobotCallOutRecordListParamsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.RobotCallOutRecordListParamsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCallOutRecordListParamsResp.displayName = 'proto.xcommon.RobotCallOutRecordListParamsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PhoneVerifyReasonStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PhoneVerifyReasonStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PhoneVerifyReasonStat.displayName = 'proto.xcommon.PhoneVerifyReasonStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPhoneVerifyReasonStatReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPhoneVerifyReasonStatReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPhoneVerifyReasonStatReq.displayName = 'proto.xcommon.ListPhoneVerifyReasonStatReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPhoneVerifyReasonStatResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListPhoneVerifyReasonStatResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListPhoneVerifyReasonStatResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPhoneVerifyReasonStatResp.displayName = 'proto.xcommon.ListPhoneVerifyReasonStatResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPhoneVerifyStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPhoneVerifyStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPhoneVerifyStatsReq.displayName = 'proto.xcommon.ListPhoneVerifyStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPhoneVerifyStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListPhoneVerifyStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListPhoneVerifyStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPhoneVerifyStatsResp.displayName = 'proto.xcommon.ListPhoneVerifyStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CreateQualityInspectionVoipReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CreateQualityInspectionVoipReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CreateQualityInspectionVoipReq.displayName = 'proto.xcommon.CreateQualityInspectionVoipReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVoipQITicketListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVoipQITicketListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVoipQITicketListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVoipQITicketListReq.displayName = 'proto.xcommon.GetVoipQITicketListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVoipQITicketListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVoipQITicketListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVoipQITicketListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVoipQITicketListResp.displayName = 'proto.xcommon.GetVoipQITicketListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.VoipQITicketBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.VoipQITicketBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.VoipQITicketBackend.displayName = 'proto.xcommon.VoipQITicketBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.QualityReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.QualityReport.repeatedFields_, null);
};
goog.inherits(proto.xcommon.QualityReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.QualityReport.displayName = 'proto.xcommon.QualityReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SimInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SimInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SimInfo.displayName = 'proto.xcommon.SimInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PhoneVerifyStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PhoneVerifyStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PhoneVerifyStats.displayName = 'proto.xcommon.PhoneVerifyStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PVDashboardReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PVDashboardReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PVDashboardReq.displayName = 'proto.xcommon.PVDashboardReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PVDashboardResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PVDashboardResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PVDashboardResp.displayName = 'proto.xcommon.PVDashboardResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PVGroupStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PVGroupStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PVGroupStatsReq.displayName = 'proto.xcommon.PVGroupStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PVGroupStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.PVGroupStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.PVGroupStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PVGroupStatsResp.displayName = 'proto.xcommon.PVGroupStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PVMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PVMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PVMetrics.displayName = 'proto.xcommon.PVMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPVMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPVMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPVMetrics.displayName = 'proto.xcommon.LeaderPVMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPVMetrics.TicketNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPVMetrics.TicketNumStat.displayName = 'proto.xcommon.LeaderPVMetrics.TicketNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPVMetrics.AssignNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPVMetrics.AssignNumStat.displayName = 'proto.xcommon.LeaderPVMetrics.AssignNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPVMetrics.CompleteNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPVMetrics.CompleteNumStat.displayName = 'proto.xcommon.LeaderPVMetrics.CompleteNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPVMetrics.PassNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPVMetrics.PassNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPVMetrics.PassNumStat.displayName = 'proto.xcommon.LeaderPVMetrics.PassNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPVMetrics.InvalidNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPVMetrics.InvalidNumStat.displayName = 'proto.xcommon.LeaderPVMetrics.InvalidNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPVMetrics.RejectNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPVMetrics.RejectNumStat.displayName = 'proto.xcommon.LeaderPVMetrics.RejectNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPVMetrics.InspectionPassNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.displayName = 'proto.xcommon.LeaderPVMetrics.InspectionPassNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SimplePVStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SimplePVStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SimplePVStats.displayName = 'proto.xcommon.SimplePVStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketQuantityReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetTicketQuantityReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketQuantityReq.displayName = 'proto.xcommon.GetTicketQuantityReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetTicketQuantityResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetTicketQuantityResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetTicketQuantityResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetTicketQuantityResp.displayName = 'proto.xcommon.GetTicketQuantityResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TicketQuantityStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.TicketQuantityStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TicketQuantityStats.displayName = 'proto.xcommon.TicketQuantityStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SmsStatsReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SmsStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsStatsReq.displayName = 'proto.xcommon.SmsStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SmsStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SmsStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsStatsResp.displayName = 'proto.xcommon.SmsStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsStatsBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SmsStatsBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsStatsBackend.displayName = 'proto.xcommon.SmsStatsBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OutSourceRepayStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OutSourceRepayStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OutSourceRepayStatsReq.displayName = 'proto.xcommon.OutSourceRepayStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OutSourceRepayStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.OutSourceRepayStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.OutSourceRepayStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OutSourceRepayStatsResp.displayName = 'proto.xcommon.OutSourceRepayStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OutSourceRepayStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OutSourceRepayStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OutSourceRepayStats.displayName = 'proto.xcommon.OutSourceRepayStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OutSourceStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OutSourceStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OutSourceStatsReq.displayName = 'proto.xcommon.OutSourceStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OutSourceStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.OutSourceStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.OutSourceStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OutSourceStatsResp.displayName = 'proto.xcommon.OutSourceStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OutSourceStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OutSourceStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OutSourceStats.displayName = 'proto.xcommon.OutSourceStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PSDashboardReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PSDashboardReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PSDashboardReq.displayName = 'proto.xcommon.PSDashboardReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PSDashboardResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PSDashboardResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PSDashboardResp.displayName = 'proto.xcommon.PSDashboardResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PSGroupStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PSGroupStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PSGroupStatsReq.displayName = 'proto.xcommon.PSGroupStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PSGroupStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.PSGroupStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.PSGroupStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PSGroupStatsResp.displayName = 'proto.xcommon.PSGroupStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SimplePSStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SimplePSStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SimplePSStats.displayName = 'proto.xcommon.SimplePSStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPSMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPSMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPSMetrics.displayName = 'proto.xcommon.LeaderPSMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPSMetrics.TicketNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPSMetrics.TicketNumStat.displayName = 'proto.xcommon.LeaderPSMetrics.TicketNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPSMetrics.AssignNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPSMetrics.AssignNumStat.displayName = 'proto.xcommon.LeaderPSMetrics.AssignNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPSMetrics.HandleNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPSMetrics.HandleNumStat.displayName = 'proto.xcommon.LeaderPSMetrics.HandleNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPSMetrics.AnswerNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPSMetrics.AnswerNumStat.displayName = 'proto.xcommon.LeaderPSMetrics.AnswerNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LeaderPSMetrics.ClosureNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LeaderPSMetrics.ClosureNumStat.displayName = 'proto.xcommon.LeaderPSMetrics.ClosureNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PSMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PSMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PSMetrics.displayName = 'proto.xcommon.PSMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PSMetrics.AnswerNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PSMetrics.AnswerNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PSMetrics.AnswerNumStat.displayName = 'proto.xcommon.PSMetrics.AnswerNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PSMetrics.ClosureNumStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PSMetrics.ClosureNumStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PSMetrics.ClosureNumStat.displayName = 'proto.xcommon.PSMetrics.ClosureNumStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPhoneSaleStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPhoneSaleStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPhoneSaleStatsReq.displayName = 'proto.xcommon.ListPhoneSaleStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPhoneSaleStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListPhoneSaleStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListPhoneSaleStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPhoneSaleStatsResp.displayName = 'proto.xcommon.ListPhoneSaleStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PhoneSaleStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PhoneSaleStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PhoneSaleStats.displayName = 'proto.xcommon.PhoneSaleStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WorkOrderStatisticReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WorkOrderStatisticReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WorkOrderStatisticReq.displayName = 'proto.xcommon.WorkOrderStatisticReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WorkOrderStatisticResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WorkOrderStatisticResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WorkOrderStatisticResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WorkOrderStatisticResp.displayName = 'proto.xcommon.WorkOrderStatisticResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WorkOrderStatistic = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WorkOrderStatistic, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WorkOrderStatistic.displayName = 'proto.xcommon.WorkOrderStatistic';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReasonItemTotal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReasonItemTotal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReasonItemTotal.displayName = 'proto.xcommon.ReasonItemTotal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsHistoryReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SmsHistoryReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsHistoryReq.displayName = 'proto.xcommon.SmsHistoryReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsHistoryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SmsHistoryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsHistoryItem.displayName = 'proto.xcommon.SmsHistoryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsHistoryResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SmsHistoryResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SmsHistoryResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsHistoryResp.displayName = 'proto.xcommon.SmsHistoryResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WorkOverdueReasonStatReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WorkOverdueReasonStatReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WorkOverdueReasonStatReq.displayName = 'proto.xcommon.WorkOverdueReasonStatReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WorkOverdueReasonStatResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WorkOverdueReasonStatResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WorkOverdueReasonStatResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WorkOverdueReasonStatResp.displayName = 'proto.xcommon.WorkOverdueReasonStatResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WorkOverdueReasonStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WorkOverdueReasonStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WorkOverdueReasonStat.displayName = 'proto.xcommon.WorkOverdueReasonStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CreateOcrMarkTicketReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CreateOcrMarkTicketReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CreateOcrMarkTicketReq.displayName = 'proto.xcommon.CreateOcrMarkTicketReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOcrMarkTicketListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOcrMarkTicketListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOcrMarkTicketListReq.displayName = 'proto.xcommon.GetOcrMarkTicketListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOcrMarkTicketListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetOcrMarkTicketListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetOcrMarkTicketListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOcrMarkTicketListResp.displayName = 'proto.xcommon.GetOcrMarkTicketListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OcrMarkTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OcrMarkTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OcrMarkTicket.displayName = 'proto.xcommon.OcrMarkTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOcrMarkCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOcrMarkCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOcrMarkCaseReq.displayName = 'proto.xcommon.GetOcrMarkCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOcrMarkCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOcrMarkCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOcrMarkCaseResp.displayName = 'proto.xcommon.GetOcrMarkCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveOcrMarkCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveOcrMarkCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveOcrMarkCaseReq.displayName = 'proto.xcommon.SaveOcrMarkCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveOcrMarkCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveOcrMarkCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveOcrMarkCaseResp.displayName = 'proto.xcommon.SaveOcrMarkCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPVOptionStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetPVOptionStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPVOptionStatsReq.displayName = 'proto.xcommon.GetPVOptionStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPVOptionStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetPVOptionStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetPVOptionStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPVOptionStatsResp.displayName = 'proto.xcommon.GetPVOptionStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPVOptionStatsResp.OneRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetPVOptionStatsResp.OneRow.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetPVOptionStatsResp.OneRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPVOptionStatsResp.OneRow.displayName = 'proto.xcommon.GetPVOptionStatsResp.OneRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.displayName = 'proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WALoginStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WALoginStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WALoginStatusReq.displayName = 'proto.xcommon.WALoginStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WALoginStatusResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WALoginStatusResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WALoginStatusResp.displayName = 'proto.xcommon.WALoginStatusResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetQRCodeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetQRCodeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetQRCodeReq.displayName = 'proto.xcommon.WAGetQRCodeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetQRCodeResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetQRCodeResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetQRCodeResp.displayName = 'proto.xcommon.WAGetQRCodeResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WASendTextMsgReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WASendTextMsgReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WASendTextMsgReq.displayName = 'proto.xcommon.WASendTextMsgReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WASendTextMsgResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WASendTextMsgResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WASendTextMsgResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WASendTextMsgResp.displayName = 'proto.xcommon.WASendTextMsgResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WASensitiveCheck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WASensitiveCheck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WASensitiveCheck.displayName = 'proto.xcommon.WASensitiveCheck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPhoneSaleProductReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPhoneSaleProductReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPhoneSaleProductReq.displayName = 'proto.xcommon.ListPhoneSaleProductReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPhoneSaleProductResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPhoneSaleProductResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPhoneSaleProductResp.displayName = 'proto.xcommon.ListPhoneSaleProductResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAMsgReadReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAMsgReadReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAMsgReadReq.displayName = 'proto.xcommon.WAMsgReadReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAMsgReadResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAMsgReadResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAMsgReadResp.displayName = 'proto.xcommon.WAMsgReadResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetMobileByUIDReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetMobileByUIDReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetMobileByUIDReq.displayName = 'proto.xcommon.WAGetMobileByUIDReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetMobileByUIDResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WAGetMobileByUIDResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WAGetMobileByUIDResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetMobileByUIDResp.displayName = 'proto.xcommon.WAGetMobileByUIDResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetMobileByUIDResp.ChatInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetMobileByUIDResp.ChatInfo.displayName = 'proto.xcommon.WAGetMobileByUIDResp.ChatInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WAGetMobileByUIDResp.GroupInfo.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WAGetMobileByUIDResp.GroupInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetMobileByUIDResp.GroupInfo.displayName = 'proto.xcommon.WAGetMobileByUIDResp.GroupInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetParamByUIDReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetParamByUIDReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetParamByUIDReq.displayName = 'proto.xcommon.WAGetParamByUIDReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetParamByUIDResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WAGetParamByUIDResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WAGetParamByUIDResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetParamByUIDResp.displayName = 'proto.xcommon.WAGetParamByUIDResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetParamByUIDResp.PushTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetParamByUIDResp.PushTemplate.displayName = 'proto.xcommon.WAGetParamByUIDResp.PushTemplate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetChatByMobileReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetChatByMobileReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetChatByMobileReq.displayName = 'proto.xcommon.WAGetChatByMobileReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetChatByMobileResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WAGetChatByMobileResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WAGetChatByMobileResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetChatByMobileResp.displayName = 'proto.xcommon.WAGetChatByMobileResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetChatByMobileResp.ChatInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetChatByMobileResp.ChatInfo.displayName = 'proto.xcommon.WAGetChatByMobileResp.ChatInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetMsgByMobileReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAGetMsgByMobileReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetMsgByMobileReq.displayName = 'proto.xcommon.WAGetMsgByMobileReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAMsgInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAMsgInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAMsgInfo.displayName = 'proto.xcommon.WAMsgInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAGetMsgByMobileResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WAGetMsgByMobileResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WAGetMsgByMobileResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAGetMsgByMobileResp.displayName = 'proto.xcommon.WAGetMsgByMobileResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ImportWAPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ImportWAPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ImportWAPhoneReq.displayName = 'proto.xcommon.ImportWAPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ImportWAPhoneResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ImportWAPhoneResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ImportWAPhoneResp.displayName = 'proto.xcommon.ImportWAPhoneResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAListReq.displayName = 'proto.xcommon.WAListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WAListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WAListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAListResp.displayName = 'proto.xcommon.WAListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WAInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WAInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WAInfo.displayName = 'proto.xcommon.WAInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssignWAPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AssignWAPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssignWAPhoneReq.displayName = 'proto.xcommon.AssignWAPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AssignWAPhoneResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AssignWAPhoneResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AssignWAPhoneResp.displayName = 'proto.xcommon.AssignWAPhoneResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MarkWAPhoneReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MarkWAPhoneReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MarkWAPhoneReq.displayName = 'proto.xcommon.MarkWAPhoneReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MarkWAPhoneResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MarkWAPhoneResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MarkWAPhoneResp.displayName = 'proto.xcommon.MarkWAPhoneResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWaKeywordListParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWaKeywordListParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWaKeywordListParamReq.displayName = 'proto.xcommon.GetWaKeywordListParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWaKeywordListParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWaKeywordListParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWaKeywordListParamResp.displayName = 'proto.xcommon.GetWaKeywordListParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWaKeywordListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWaKeywordListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWaKeywordListReq.displayName = 'proto.xcommon.GetWaKeywordListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWaKeywordListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetWaKeywordListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetWaKeywordListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWaKeywordListResp.displayName = 'proto.xcommon.GetWaKeywordListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWaKeywordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWaKeywordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWaKeywordReq.displayName = 'proto.xcommon.GetWaKeywordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWaKeywordResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWaKeywordResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWaKeywordResp.displayName = 'proto.xcommon.GetWaKeywordResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveWaKeywordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveWaKeywordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveWaKeywordReq.displayName = 'proto.xcommon.SaveWaKeywordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WaKeywordData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WaKeywordData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WaKeywordData.displayName = 'proto.xcommon.WaKeywordData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CreateRobotCorpusMarkReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CreateRobotCorpusMarkReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CreateRobotCorpusMarkReq.displayName = 'proto.xcommon.CreateRobotCorpusMarkReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRobotCorpusMarkListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRobotCorpusMarkListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRobotCorpusMarkListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRobotCorpusMarkListReq.displayName = 'proto.xcommon.GetRobotCorpusMarkListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRobotCorpusMarkListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRobotCorpusMarkListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRobotCorpusMarkListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRobotCorpusMarkListResp.displayName = 'proto.xcommon.GetRobotCorpusMarkListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RobotCorpusMarkData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.RobotCorpusMarkData.repeatedFields_, null);
};
goog.inherits(proto.xcommon.RobotCorpusMarkData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RobotCorpusMarkData.displayName = 'proto.xcommon.RobotCorpusMarkData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.IntentNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.IntentNode.repeatedFields_, null);
};
goog.inherits(proto.xcommon.IntentNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.IntentNode.displayName = 'proto.xcommon.IntentNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.IntentMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.IntentMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.IntentMap.displayName = 'proto.xcommon.IntentMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Multilingual = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Multilingual, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Multilingual.displayName = 'proto.xcommon.Multilingual';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MultilingualDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MultilingualDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MultilingualDetail.displayName = 'proto.xcommon.MultilingualDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveMultilingualReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SaveMultilingualReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SaveMultilingualReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveMultilingualReq.displayName = 'proto.xcommon.SaveMultilingualReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveMultilingualResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveMultilingualResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveMultilingualResp.displayName = 'proto.xcommon.SaveMultilingualResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListMultilingualReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListMultilingualReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListMultilingualReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListMultilingualReq.displayName = 'proto.xcommon.ListMultilingualReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListMultilingualResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListMultilingualResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListMultilingualResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListMultilingualResp.displayName = 'proto.xcommon.ListMultilingualResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveMultilingualDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveMultilingualDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveMultilingualDetailReq.displayName = 'proto.xcommon.SaveMultilingualDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveMultilingualDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveMultilingualDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveMultilingualDetailResp.displayName = 'proto.xcommon.SaveMultilingualDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DelMultilingualDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DelMultilingualDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DelMultilingualDetailReq.displayName = 'proto.xcommon.DelMultilingualDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DelMultilingualDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DelMultilingualDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DelMultilingualDetailResp.displayName = 'proto.xcommon.DelMultilingualDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListMultilingualDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListMultilingualDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListMultilingualDetailReq.displayName = 'proto.xcommon.ListMultilingualDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListMultilingualDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListMultilingualDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListMultilingualDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListMultilingualDetailResp.displayName = 'proto.xcommon.ListMultilingualDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPushTemplateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPushTemplateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPushTemplateReq.displayName = 'proto.xcommon.ListPushTemplateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPushTemplateResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListPushTemplateResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListPushTemplateResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPushTemplateResp.displayName = 'proto.xcommon.ListPushTemplateResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PushTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PushTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PushTask.displayName = 'proto.xcommon.PushTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePushTaskReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePushTaskReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePushTaskReq.displayName = 'proto.xcommon.SavePushTaskReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SavePushTaskResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SavePushTaskResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SavePushTaskResp.displayName = 'proto.xcommon.SavePushTaskResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPushTaskReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPushTaskReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPushTaskReq.displayName = 'proto.xcommon.ListPushTaskReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPushTaskResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListPushTaskResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListPushTaskResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPushTaskResp.displayName = 'proto.xcommon.ListPushTaskResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPushDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPushDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPushDetailReq.displayName = 'proto.xcommon.ListPushDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPushDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListPushDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListPushDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPushDetailResp.displayName = 'proto.xcommon.ListPushDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListPushDetailResp.OnePushDetailRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListPushDetailResp.OnePushDetailRow.displayName = 'proto.xcommon.ListPushDetailResp.OnePushDetailRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserItemReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUserItemReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserItemReq.displayName = 'proto.xcommon.GetUserItemReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUserItemResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUserItemResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUserItemResp.displayName = 'proto.xcommon.GetUserItemResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ExportTicketEmailCSVReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ExportTicketEmailCSVReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ExportTicketEmailCSVReq.displayName = 'proto.xcommon.ExportTicketEmailCSVReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ExportTicketEmailCSVResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ExportTicketEmailCSVResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ExportTicketEmailCSVResp.displayName = 'proto.xcommon.ExportTicketEmailCSVResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetHourlyCollectionStatsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetHourlyCollectionStatsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetHourlyCollectionStatsReq.displayName = 'proto.xcommon.GetHourlyCollectionStatsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetHourlyCollectionStatsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetHourlyCollectionStatsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetHourlyCollectionStatsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetHourlyCollectionStatsResp.displayName = 'proto.xcommon.GetHourlyCollectionStatsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.HourlyCollectionStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.HourlyCollectionStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.HourlyCollectionStat.displayName = 'proto.xcommon.HourlyCollectionStat';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCollectionConfigReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCollectionConfigReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCollectionConfigReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCollectionConfigReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCollectionConfigReq}
 */
proto.xcommon.GetCollectionConfigReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCollectionConfigReq;
  return proto.xcommon.GetCollectionConfigReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCollectionConfigReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCollectionConfigReq}
 */
proto.xcommon.GetCollectionConfigReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCollectionConfigReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCollectionConfigReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCollectionConfigReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCollectionConfigReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetCollectionConfigReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetCollectionConfigReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetCollectionConfigReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCollectionConfigReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCollectionConfigItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCollectionConfigItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCollectionConfigItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCollectionConfigItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    configMap: (f = msg.getConfigMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCollectionConfigItem}
 */
proto.xcommon.GetCollectionConfigItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCollectionConfigItem;
  return proto.xcommon.GetCollectionConfigItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCollectionConfigItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCollectionConfigItem}
 */
proto.xcommon.GetCollectionConfigItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getConfigMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readEnum, null, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCollectionConfigItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCollectionConfigItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCollectionConfigItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCollectionConfigItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeEnum);
  }
};


/**
 * map<string, Mark> Config = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.xcommon.Mark>}
 */
proto.xcommon.GetCollectionConfigItem.prototype.getConfigMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.xcommon.Mark>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetCollectionConfigItem.prototype.clearConfigMap = function() {
  this.getConfigMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCollectionConfigResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCollectionConfigResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCollectionConfigResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCollectionConfigResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    configMap: (f = msg.getConfigMap()) ? f.toObject(includeInstance, proto.xcommon.GetCollectionConfigItem.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCollectionConfigResp}
 */
proto.xcommon.GetCollectionConfigResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCollectionConfigResp;
  return proto.xcommon.GetCollectionConfigResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCollectionConfigResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCollectionConfigResp}
 */
proto.xcommon.GetCollectionConfigResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getConfigMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.xcommon.GetCollectionConfigItem.deserializeBinaryFromReader, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCollectionConfigResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCollectionConfigResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCollectionConfigResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCollectionConfigResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getConfigMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.GetCollectionConfigItem.serializeBinaryToWriter);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetCollectionConfigResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetCollectionConfigResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetCollectionConfigResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCollectionConfigResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, GetCollectionConfigItem> Config = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.xcommon.GetCollectionConfigItem>}
 */
proto.xcommon.GetCollectionConfigResp.prototype.getConfigMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.xcommon.GetCollectionConfigItem>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.xcommon.GetCollectionConfigItem));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetCollectionConfigResp.prototype.clearConfigMap = function() {
  this.getConfigMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CommonOutResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CommonOutResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CommonOutResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CommonOutResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CommonOutResp}
 */
proto.xcommon.CommonOutResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CommonOutResp;
  return proto.xcommon.CommonOutResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CommonOutResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CommonOutResp}
 */
proto.xcommon.CommonOutResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CommonOutResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CommonOutResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CommonOutResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CommonOutResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CommonOutResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.CommonOutResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CommonOutResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CommonOutResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetBasicTicketAttrsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetBasicTicketAttrsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicTicketAttrsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    filtername: jspb.Message.getFieldWithDefault(msg, 3, ""),
    attrtype: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetBasicTicketAttrsReq}
 */
proto.xcommon.GetBasicTicketAttrsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetBasicTicketAttrsReq;
  return proto.xcommon.GetBasicTicketAttrsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetBasicTicketAttrsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetBasicTicketAttrsReq}
 */
proto.xcommon.GetBasicTicketAttrsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFiltername(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttrtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetBasicTicketAttrsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetBasicTicketAttrsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicTicketAttrsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getFiltername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAttrtype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetBasicTicketAttrsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetBasicTicketAttrsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string FilterName = 3;
 * @return {string}
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.getFiltername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetBasicTicketAttrsReq.prototype.setFiltername = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 AttrType = 4;
 * @return {number}
 */
proto.xcommon.GetBasicTicketAttrsReq.prototype.getAttrtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetBasicTicketAttrsReq.prototype.setAttrtype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetBasicTicketAttrsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetBasicTicketAttrsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetBasicTicketAttrsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicTicketAttrsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.TicketAttrItem.toObject, includeInstance),
    funcoptionMap: (f = msg.getFuncoptionMap()) ? f.toObject(includeInstance, proto.xcommon.FuncOption.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetBasicTicketAttrsResp}
 */
proto.xcommon.GetBasicTicketAttrsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetBasicTicketAttrsResp;
  return proto.xcommon.GetBasicTicketAttrsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetBasicTicketAttrsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetBasicTicketAttrsResp}
 */
proto.xcommon.GetBasicTicketAttrsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketAttrItem;
      reader.readMessage(value,proto.xcommon.TicketAttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = msg.getFuncoptionMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.FuncOption.deserializeBinaryFromReader, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetBasicTicketAttrsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetBasicTicketAttrsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicTicketAttrsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.TicketAttrItem.serializeBinaryToWriter
    );
  }
  f = message.getFuncoptionMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.FuncOption.serializeBinaryToWriter);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetBasicTicketAttrsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetBasicTicketAttrsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated TicketAttrItem List = 3;
 * @return {!Array<!proto.xcommon.TicketAttrItem>}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.TicketAttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketAttrItem, 3));
};


/** @param {!Array<!proto.xcommon.TicketAttrItem>} value */
proto.xcommon.GetBasicTicketAttrsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.TicketAttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketAttrItem}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.TicketAttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * map<int32, FuncOption> FuncOption = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.FuncOption>}
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.getFuncoptionMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.FuncOption>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.xcommon.FuncOption));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetBasicTicketAttrsResp.prototype.clearFuncoptionMap = function() {
  this.getFuncoptionMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAttrFuncReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAttrFuncReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAttrFuncReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrFuncReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    functype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAttrFuncReq}
 */
proto.xcommon.GetTicketAttrFuncReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAttrFuncReq;
  return proto.xcommon.GetTicketAttrFuncReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAttrFuncReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAttrFuncReq}
 */
proto.xcommon.GetTicketAttrFuncReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFunctype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAttrFuncReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAttrFuncReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAttrFuncReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrFuncReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getFunctype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketAttrFuncReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketAttrFuncReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrFuncReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrFuncReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 FuncType = 2;
 * @return {number}
 */
proto.xcommon.GetTicketAttrFuncReq.prototype.getFunctype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketAttrFuncReq.prototype.setFunctype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketAttrFuncResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAttrFuncResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAttrFuncResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAttrFuncResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrFuncResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.FuncItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAttrFuncResp}
 */
proto.xcommon.GetTicketAttrFuncResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAttrFuncResp;
  return proto.xcommon.GetTicketAttrFuncResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAttrFuncResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAttrFuncResp}
 */
proto.xcommon.GetTicketAttrFuncResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.FuncItem;
      reader.readMessage(value,proto.xcommon.FuncItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAttrFuncResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAttrFuncResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAttrFuncResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrFuncResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.FuncItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketAttrFuncResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketAttrFuncResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrFuncResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrFuncResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated FuncItem List = 2;
 * @return {!Array<!proto.xcommon.FuncItem>}
 */
proto.xcommon.GetTicketAttrFuncResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.FuncItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.FuncItem, 2));
};


/** @param {!Array<!proto.xcommon.FuncItem>} value */
proto.xcommon.GetTicketAttrFuncResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.FuncItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.FuncItem}
 */
proto.xcommon.GetTicketAttrFuncResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.FuncItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketAttrFuncResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAttrsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAttrsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAttrsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    systemtype: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAttrsReq}
 */
proto.xcommon.GetTicketAttrsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAttrsReq;
  return proto.xcommon.GetTicketAttrsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAttrsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAttrsReq}
 */
proto.xcommon.GetTicketAttrsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAttrsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAttrsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAttrsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketAttrsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketAttrsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetTicketAttrsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetTicketAttrsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.GetTicketAttrsReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketAttrsReq.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional MPSystemType SystemType = 4;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.GetTicketAttrsReq.prototype.getSystemtype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.MPSystemType} value */
proto.xcommon.GetTicketAttrsReq.prototype.setSystemtype = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketAttrsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAttrsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAttrsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAttrsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.TicketAttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAttrsResp}
 */
proto.xcommon.GetTicketAttrsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAttrsResp;
  return proto.xcommon.GetTicketAttrsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAttrsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAttrsResp}
 */
proto.xcommon.GetTicketAttrsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketAttrItem;
      reader.readMessage(value,proto.xcommon.TicketAttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAttrsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAttrsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAttrsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.TicketAttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketAttrsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketAttrsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketAttrsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketAttrsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated TicketAttrItem List = 3;
 * @return {!Array<!proto.xcommon.TicketAttrItem>}
 */
proto.xcommon.GetTicketAttrsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.TicketAttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketAttrItem, 3));
};


/** @param {!Array<!proto.xcommon.TicketAttrItem>} value */
proto.xcommon.GetTicketAttrsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.TicketAttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketAttrItem}
 */
proto.xcommon.GetTicketAttrsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.TicketAttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketAttrsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAttrsOptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAttrsOptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAttrsOptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrsOptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    systemtype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAttrsOptionReq}
 */
proto.xcommon.GetTicketAttrsOptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAttrsOptionReq;
  return proto.xcommon.GetTicketAttrsOptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAttrsOptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAttrsOptionReq}
 */
proto.xcommon.GetTicketAttrsOptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAttrsOptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAttrsOptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAttrsOptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrsOptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketAttrsOptionReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketAttrsOptionReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrsOptionReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrsOptionReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MPSystemType SystemType = 2;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.GetTicketAttrsOptionReq.prototype.getSystemtype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.MPSystemType} value */
proto.xcommon.GetTicketAttrsOptionReq.prototype.setSystemtype = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketAttrsOptionResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAttrsOptionResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAttrsOptionResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrsOptionResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAttrsOptionResp}
 */
proto.xcommon.GetTicketAttrsOptionResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAttrsOptionResp;
  return proto.xcommon.GetTicketAttrsOptionResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAttrsOptionResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAttrsOptionResp}
 */
proto.xcommon.GetTicketAttrsOptionResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAttrsOptionResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAttrsOptionResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAttrsOptionResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketAttrsOptionResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketAttrsOptionResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AttrItem List = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetTicketAttrsOptionResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketAttrsOptionResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketAttrReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketAttrReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketAttrReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketAttrReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    attrtype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    value: jspb.Message.getFieldWithDefault(msg, 6, ""),
    func: jspb.Message.getFieldWithDefault(msg, 7, ""),
    funcparam: jspb.Message.getFieldWithDefault(msg, 8, ""),
    systemtype: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketAttrReq}
 */
proto.xcommon.SaveTicketAttrReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketAttrReq;
  return proto.xcommon.SaveTicketAttrReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketAttrReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketAttrReq}
 */
proto.xcommon.SaveTicketAttrReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttrtype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFunc(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFuncparam(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketAttrReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketAttrReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketAttrReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketAttrReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAttrtype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFunc();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFuncparam();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveTicketAttrReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketAttrReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketAttrReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.SaveTicketAttrReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketAttrReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketAttrReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 Id = 3;
 * @return {number}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketAttrReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 AttrType = 4;
 * @return {number}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getAttrtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketAttrReq.prototype.setAttrtype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string Name = 5;
 * @return {string}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.SaveTicketAttrReq.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Value = 6;
 * @return {string}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.SaveTicketAttrReq.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Func = 7;
 * @return {string}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getFunc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.SaveTicketAttrReq.prototype.setFunc = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string FuncParam = 8;
 * @return {string}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getFuncparam = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.SaveTicketAttrReq.prototype.setFuncparam = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional MPSystemType SystemType = 9;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.SaveTicketAttrReq.prototype.getSystemtype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.MPSystemType} value */
proto.xcommon.SaveTicketAttrReq.prototype.setSystemtype = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketAttrResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketAttrResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketAttrResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketAttrResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketAttrResp}
 */
proto.xcommon.SaveTicketAttrResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketAttrResp;
  return proto.xcommon.SaveTicketAttrResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketAttrResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketAttrResp}
 */
proto.xcommon.SaveTicketAttrResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketAttrResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketAttrResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketAttrResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketAttrResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveTicketAttrResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveTicketAttrResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketAttrResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketAttrResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketAttrResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketAttrResp.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetBasicUserAttrsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetBasicUserAttrsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicUserAttrsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    filtername: jspb.Message.getFieldWithDefault(msg, 3, ""),
    attrtype: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetBasicUserAttrsReq}
 */
proto.xcommon.GetBasicUserAttrsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetBasicUserAttrsReq;
  return proto.xcommon.GetBasicUserAttrsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetBasicUserAttrsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetBasicUserAttrsReq}
 */
proto.xcommon.GetBasicUserAttrsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFiltername(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttrtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetBasicUserAttrsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetBasicUserAttrsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicUserAttrsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getFiltername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAttrtype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetBasicUserAttrsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetBasicUserAttrsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string FilterName = 3;
 * @return {string}
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.getFiltername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetBasicUserAttrsReq.prototype.setFiltername = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 AttrType = 4;
 * @return {number}
 */
proto.xcommon.GetBasicUserAttrsReq.prototype.getAttrtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetBasicUserAttrsReq.prototype.setAttrtype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetBasicUserAttrsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetBasicUserAttrsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetBasicUserAttrsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicUserAttrsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.UserAttrItem.toObject, includeInstance),
    funcoptionMap: (f = msg.getFuncoptionMap()) ? f.toObject(includeInstance, proto.xcommon.FuncOption.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetBasicUserAttrsResp}
 */
proto.xcommon.GetBasicUserAttrsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetBasicUserAttrsResp;
  return proto.xcommon.GetBasicUserAttrsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetBasicUserAttrsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetBasicUserAttrsResp}
 */
proto.xcommon.GetBasicUserAttrsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.UserAttrItem;
      reader.readMessage(value,proto.xcommon.UserAttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = msg.getFuncoptionMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.FuncOption.deserializeBinaryFromReader, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetBasicUserAttrsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetBasicUserAttrsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicUserAttrsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.UserAttrItem.serializeBinaryToWriter
    );
  }
  f = message.getFuncoptionMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.FuncOption.serializeBinaryToWriter);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetBasicUserAttrsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetBasicUserAttrsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated UserAttrItem List = 3;
 * @return {!Array<!proto.xcommon.UserAttrItem>}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.UserAttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UserAttrItem, 3));
};


/** @param {!Array<!proto.xcommon.UserAttrItem>} value */
proto.xcommon.GetBasicUserAttrsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.UserAttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UserAttrItem}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.UserAttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * map<int32, FuncOption> FuncOption = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.FuncOption>}
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.getFuncoptionMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.FuncOption>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.xcommon.FuncOption));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetBasicUserAttrsResp.prototype.clearFuncoptionMap = function() {
  this.getFuncoptionMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserAttrFuncReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserAttrFuncReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserAttrFuncReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrFuncReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    functype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserAttrFuncReq}
 */
proto.xcommon.GetUserAttrFuncReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserAttrFuncReq;
  return proto.xcommon.GetUserAttrFuncReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserAttrFuncReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserAttrFuncReq}
 */
proto.xcommon.GetUserAttrFuncReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFunctype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserAttrFuncReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserAttrFuncReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserAttrFuncReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrFuncReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getFunctype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetUserAttrFuncReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetUserAttrFuncReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrFuncReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrFuncReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 FuncType = 2;
 * @return {number}
 */
proto.xcommon.GetUserAttrFuncReq.prototype.getFunctype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.GetUserAttrFuncReq.prototype.setFunctype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetUserAttrFuncResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserAttrFuncResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserAttrFuncResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserAttrFuncResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrFuncResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.FuncItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserAttrFuncResp}
 */
proto.xcommon.GetUserAttrFuncResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserAttrFuncResp;
  return proto.xcommon.GetUserAttrFuncResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserAttrFuncResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserAttrFuncResp}
 */
proto.xcommon.GetUserAttrFuncResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.FuncItem;
      reader.readMessage(value,proto.xcommon.FuncItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserAttrFuncResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserAttrFuncResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserAttrFuncResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrFuncResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.FuncItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetUserAttrFuncResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetUserAttrFuncResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrFuncResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrFuncResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated FuncItem List = 2;
 * @return {!Array<!proto.xcommon.FuncItem>}
 */
proto.xcommon.GetUserAttrFuncResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.FuncItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.FuncItem, 2));
};


/** @param {!Array<!proto.xcommon.FuncItem>} value */
proto.xcommon.GetUserAttrFuncResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.FuncItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.FuncItem}
 */
proto.xcommon.GetUserAttrFuncResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.FuncItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetUserAttrFuncResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserAttrsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserAttrsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserAttrsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserAttrsReq}
 */
proto.xcommon.GetUserAttrsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserAttrsReq;
  return proto.xcommon.GetUserAttrsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserAttrsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserAttrsReq}
 */
proto.xcommon.GetUserAttrsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserAttrsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserAttrsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserAttrsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetUserAttrsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetUserAttrsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetUserAttrsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetUserAttrsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.GetUserAttrsReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetUserAttrsReq.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetUserAttrsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserAttrsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserAttrsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserAttrsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.UserAttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserAttrsResp}
 */
proto.xcommon.GetUserAttrsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserAttrsResp;
  return proto.xcommon.GetUserAttrsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserAttrsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserAttrsResp}
 */
proto.xcommon.GetUserAttrsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.UserAttrItem;
      reader.readMessage(value,proto.xcommon.UserAttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserAttrsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserAttrsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserAttrsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.UserAttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetUserAttrsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetUserAttrsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetUserAttrsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetUserAttrsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated UserAttrItem List = 3;
 * @return {!Array<!proto.xcommon.UserAttrItem>}
 */
proto.xcommon.GetUserAttrsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.UserAttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UserAttrItem, 3));
};


/** @param {!Array<!proto.xcommon.UserAttrItem>} value */
proto.xcommon.GetUserAttrsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.UserAttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UserAttrItem}
 */
proto.xcommon.GetUserAttrsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.UserAttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetUserAttrsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserAttrsOptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserAttrsOptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserAttrsOptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrsOptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserAttrsOptionReq}
 */
proto.xcommon.GetUserAttrsOptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserAttrsOptionReq;
  return proto.xcommon.GetUserAttrsOptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserAttrsOptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserAttrsOptionReq}
 */
proto.xcommon.GetUserAttrsOptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserAttrsOptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserAttrsOptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserAttrsOptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrsOptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetUserAttrsOptionReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetUserAttrsOptionReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrsOptionReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrsOptionReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetUserAttrsOptionResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserAttrsOptionResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserAttrsOptionResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrsOptionResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserAttrsOptionResp}
 */
proto.xcommon.GetUserAttrsOptionResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserAttrsOptionResp;
  return proto.xcommon.GetUserAttrsOptionResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserAttrsOptionResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserAttrsOptionResp}
 */
proto.xcommon.GetUserAttrsOptionResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserAttrsOptionResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserAttrsOptionResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserAttrsOptionResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetUserAttrsOptionResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetUserAttrsOptionResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AttrItem List = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetUserAttrsOptionResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetUserAttrsOptionResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveUserAttrReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveUserAttrReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveUserAttrReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveUserAttrReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    attrtype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    value: jspb.Message.getFieldWithDefault(msg, 6, ""),
    func: jspb.Message.getFieldWithDefault(msg, 7, ""),
    funcparam: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveUserAttrReq}
 */
proto.xcommon.SaveUserAttrReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveUserAttrReq;
  return proto.xcommon.SaveUserAttrReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveUserAttrReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveUserAttrReq}
 */
proto.xcommon.SaveUserAttrReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttrtype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFunc(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFuncparam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveUserAttrReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveUserAttrReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveUserAttrReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveUserAttrReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAttrtype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFunc();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFuncparam();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveUserAttrReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveUserAttrReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveUserAttrReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveUserAttrReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.SaveUserAttrReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.SaveUserAttrReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveUserAttrReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveUserAttrReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 Id = 3;
 * @return {number}
 */
proto.xcommon.SaveUserAttrReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.SaveUserAttrReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 AttrType = 4;
 * @return {number}
 */
proto.xcommon.SaveUserAttrReq.prototype.getAttrtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.SaveUserAttrReq.prototype.setAttrtype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string Name = 5;
 * @return {string}
 */
proto.xcommon.SaveUserAttrReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.SaveUserAttrReq.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Value = 6;
 * @return {string}
 */
proto.xcommon.SaveUserAttrReq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.SaveUserAttrReq.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Func = 7;
 * @return {string}
 */
proto.xcommon.SaveUserAttrReq.prototype.getFunc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.SaveUserAttrReq.prototype.setFunc = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string FuncParam = 8;
 * @return {string}
 */
proto.xcommon.SaveUserAttrReq.prototype.getFuncparam = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.SaveUserAttrReq.prototype.setFuncparam = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveUserAttrResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveUserAttrResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveUserAttrResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveUserAttrResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveUserAttrResp}
 */
proto.xcommon.SaveUserAttrResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveUserAttrResp;
  return proto.xcommon.SaveUserAttrResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveUserAttrResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveUserAttrResp}
 */
proto.xcommon.SaveUserAttrResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveUserAttrResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveUserAttrResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveUserAttrResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveUserAttrResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveUserAttrResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveUserAttrResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveUserAttrResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveUserAttrResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveUserAttrResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveUserAttrResp.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetBasicLoadAttrsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetBasicLoadAttrsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetBasicLoadAttrsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicLoadAttrsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetBasicLoadAttrsReq}
 */
proto.xcommon.GetBasicLoadAttrsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetBasicLoadAttrsReq;
  return proto.xcommon.GetBasicLoadAttrsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetBasicLoadAttrsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetBasicLoadAttrsReq}
 */
proto.xcommon.GetBasicLoadAttrsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetBasicLoadAttrsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetBasicLoadAttrsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetBasicLoadAttrsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicLoadAttrsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetBasicLoadAttrsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetBasicLoadAttrsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicLoadAttrsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicLoadAttrsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetBasicLoadAttrsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetBasicLoadAttrsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicLoadAttrsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicLoadAttrsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetBasicLoadAttrsResp.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetBasicLoadAttrsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetBasicLoadAttrsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicLoadAttrsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    attrtypeList: jspb.Message.toObjectList(msg.getAttrtypeList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetBasicLoadAttrsResp}
 */
proto.xcommon.GetBasicLoadAttrsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetBasicLoadAttrsResp;
  return proto.xcommon.GetBasicLoadAttrsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetBasicLoadAttrsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetBasicLoadAttrsResp}
 */
proto.xcommon.GetBasicLoadAttrsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addAttrtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetBasicLoadAttrsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetBasicLoadAttrsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetBasicLoadAttrsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getAttrtypeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetBasicLoadAttrsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetBasicLoadAttrsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AttrItem List = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetBasicLoadAttrsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * repeated AttrItem AttrType = 4;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.getAttrtypeList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 4));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetBasicLoadAttrsResp.prototype.setAttrtypeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.addAttrtype = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetBasicLoadAttrsResp.prototype.clearAttrtypeList = function() {
  this.setAttrtypeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetLoadAttrsOptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetLoadAttrsOptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetLoadAttrsOptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetLoadAttrsOptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetLoadAttrsOptionReq}
 */
proto.xcommon.GetLoadAttrsOptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetLoadAttrsOptionReq;
  return proto.xcommon.GetLoadAttrsOptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetLoadAttrsOptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetLoadAttrsOptionReq}
 */
proto.xcommon.GetLoadAttrsOptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetLoadAttrsOptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetLoadAttrsOptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetLoadAttrsOptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetLoadAttrsOptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetLoadAttrsOptionReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetLoadAttrsOptionReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetLoadAttrsOptionReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetLoadAttrsOptionReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetLoadAttrsOptionResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetLoadAttrsOptionResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetLoadAttrsOptionResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetLoadAttrsOptionResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetLoadAttrsOptionResp}
 */
proto.xcommon.GetLoadAttrsOptionResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetLoadAttrsOptionResp;
  return proto.xcommon.GetLoadAttrsOptionResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetLoadAttrsOptionResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetLoadAttrsOptionResp}
 */
proto.xcommon.GetLoadAttrsOptionResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetLoadAttrsOptionResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetLoadAttrsOptionResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetLoadAttrsOptionResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetLoadAttrsOptionResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetLoadAttrsOptionResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AttrItem List = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetLoadAttrsOptionResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetLoadAttrsOptionResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetLoadAttrsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetLoadAttrsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetLoadAttrsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetLoadAttrsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetLoadAttrsReq}
 */
proto.xcommon.GetLoadAttrsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetLoadAttrsReq;
  return proto.xcommon.GetLoadAttrsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetLoadAttrsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetLoadAttrsReq}
 */
proto.xcommon.GetLoadAttrsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetLoadAttrsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetLoadAttrsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetLoadAttrsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetLoadAttrsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetLoadAttrsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetLoadAttrsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetLoadAttrsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetLoadAttrsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetLoadAttrsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetLoadAttrsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetLoadAttrsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetLoadAttrsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.GetLoadAttrsReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetLoadAttrsReq.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetLoadAttrsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetLoadAttrsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetLoadAttrsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetLoadAttrsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetLoadAttrsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.LoadAttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetLoadAttrsResp}
 */
proto.xcommon.GetLoadAttrsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetLoadAttrsResp;
  return proto.xcommon.GetLoadAttrsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetLoadAttrsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetLoadAttrsResp}
 */
proto.xcommon.GetLoadAttrsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.LoadAttrItem;
      reader.readMessage(value,proto.xcommon.LoadAttrItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetLoadAttrsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetLoadAttrsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetLoadAttrsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetLoadAttrsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.LoadAttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetLoadAttrsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetLoadAttrsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetLoadAttrsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetLoadAttrsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetLoadAttrsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetLoadAttrsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetLoadAttrsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetLoadAttrsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated LoadAttrItem List = 3;
 * @return {!Array<!proto.xcommon.LoadAttrItem>}
 */
proto.xcommon.GetLoadAttrsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.LoadAttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.LoadAttrItem, 3));
};


/** @param {!Array<!proto.xcommon.LoadAttrItem>} value */
proto.xcommon.GetLoadAttrsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.LoadAttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.LoadAttrItem}
 */
proto.xcommon.GetLoadAttrsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.LoadAttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetLoadAttrsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveLoadAttrReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveLoadAttrReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveLoadAttrReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveLoadAttrReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.LoadAttrItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveLoadAttrReq}
 */
proto.xcommon.SaveLoadAttrReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveLoadAttrReq;
  return proto.xcommon.SaveLoadAttrReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveLoadAttrReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveLoadAttrReq}
 */
proto.xcommon.SaveLoadAttrReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.LoadAttrItem;
      reader.readMessage(value,proto.xcommon.LoadAttrItem.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveLoadAttrReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveLoadAttrReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveLoadAttrReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveLoadAttrReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.LoadAttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveLoadAttrReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveLoadAttrReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveLoadAttrReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveLoadAttrReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LoadAttrItem Data = 2;
 * @return {?proto.xcommon.LoadAttrItem}
 */
proto.xcommon.SaveLoadAttrReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.LoadAttrItem} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LoadAttrItem, 2));
};


/** @param {?proto.xcommon.LoadAttrItem|undefined} value */
proto.xcommon.SaveLoadAttrReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveLoadAttrReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveLoadAttrReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveLoadAttrResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveLoadAttrResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveLoadAttrResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveLoadAttrResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveLoadAttrResp}
 */
proto.xcommon.SaveLoadAttrResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveLoadAttrResp;
  return proto.xcommon.SaveLoadAttrResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveLoadAttrResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveLoadAttrResp}
 */
proto.xcommon.SaveLoadAttrResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveLoadAttrResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveLoadAttrResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveLoadAttrResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveLoadAttrResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveLoadAttrResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveLoadAttrResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveLoadAttrResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveLoadAttrResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveLoadAttrResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveLoadAttrResp.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAssignParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAssignParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAssignParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    systemtype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAssignParamReq}
 */
proto.xcommon.GetTicketAssignParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAssignParamReq;
  return proto.xcommon.GetTicketAssignParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAssignParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAssignParamReq}
 */
proto.xcommon.GetTicketAssignParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAssignParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAssignParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAssignParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketAssignParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketAssignParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAssignParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAssignParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MPSystemType SystemType = 2;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.GetTicketAssignParamReq.prototype.getSystemtype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.MPSystemType} value */
proto.xcommon.GetTicketAssignParamReq.prototype.setSystemtype = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAssignParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAssignParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAssignParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    param: (f = msg.getParam()) && proto.xcommon.TicketAssignParam.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAssignParamResp}
 */
proto.xcommon.GetTicketAssignParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAssignParamResp;
  return proto.xcommon.GetTicketAssignParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAssignParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAssignParamResp}
 */
proto.xcommon.GetTicketAssignParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.TicketAssignParam;
      reader.readMessage(value,proto.xcommon.TicketAssignParam.deserializeBinaryFromReader);
      msg.setParam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAssignParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAssignParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAssignParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getParam();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.TicketAssignParam.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketAssignParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketAssignParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAssignParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAssignParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TicketAssignParam Param = 2;
 * @return {?proto.xcommon.TicketAssignParam}
 */
proto.xcommon.GetTicketAssignParamResp.prototype.getParam = function() {
  return /** @type{?proto.xcommon.TicketAssignParam} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketAssignParam, 2));
};


/** @param {?proto.xcommon.TicketAssignParam|undefined} value */
proto.xcommon.GetTicketAssignParamResp.prototype.setParam = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAssignParamResp.prototype.clearParam = function() {
  this.setParam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAssignParamResp.prototype.hasParam = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAssignRulesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAssignRulesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignRulesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    systemtype: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAssignRulesReq}
 */
proto.xcommon.GetTicketAssignRulesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAssignRulesReq;
  return proto.xcommon.GetTicketAssignRulesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAssignRulesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAssignRulesReq}
 */
proto.xcommon.GetTicketAssignRulesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAssignRulesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAssignRulesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignRulesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketAssignRulesReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetTicketAssignRulesReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketAssignRulesReq.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional MPSystemType SystemType = 4;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.GetTicketAssignRulesReq.prototype.getSystemtype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.MPSystemType} value */
proto.xcommon.GetTicketAssignRulesReq.prototype.setSystemtype = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketAssignRulesResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAssignRulesResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAssignRulesResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignRulesResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.GetTicketAssignRulesItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAssignRulesResp}
 */
proto.xcommon.GetTicketAssignRulesResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAssignRulesResp;
  return proto.xcommon.GetTicketAssignRulesResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAssignRulesResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAssignRulesResp}
 */
proto.xcommon.GetTicketAssignRulesResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.GetTicketAssignRulesItem;
      reader.readMessage(value,proto.xcommon.GetTicketAssignRulesItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAssignRulesResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAssignRulesResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignRulesResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetTicketAssignRulesItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketAssignRulesResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketAssignRulesResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated GetTicketAssignRulesItem List = 3;
 * @return {!Array<!proto.xcommon.GetTicketAssignRulesItem>}
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.GetTicketAssignRulesItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetTicketAssignRulesItem, 3));
};


/** @param {!Array<!proto.xcommon.GetTicketAssignRulesItem>} value */
proto.xcommon.GetTicketAssignRulesResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetTicketAssignRulesItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetTicketAssignRulesItem}
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetTicketAssignRulesItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketAssignRulesResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketAssignRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketAssignRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketAssignRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.TicketAssignRuleAttr.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketAssignRuleReq}
 */
proto.xcommon.SaveTicketAssignRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketAssignRuleReq;
  return proto.xcommon.SaveTicketAssignRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketAssignRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketAssignRuleReq}
 */
proto.xcommon.SaveTicketAssignRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketAssignRuleAttr;
      reader.readMessage(value,proto.xcommon.TicketAssignRuleAttr.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketAssignRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketAssignRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketAssignRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.TicketAssignRuleAttr.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveTicketAssignRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketAssignRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional TicketAssignRuleAttr Data = 3;
 * @return {?proto.xcommon.TicketAssignRuleAttr}
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.TicketAssignRuleAttr} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketAssignRuleAttr, 3));
};


/** @param {?proto.xcommon.TicketAssignRuleAttr|undefined} value */
proto.xcommon.SaveTicketAssignRuleReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketAssignRuleReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketAssignRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketAssignRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketAssignRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketAssignRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketAssignRuleResp}
 */
proto.xcommon.SaveTicketAssignRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketAssignRuleResp;
  return proto.xcommon.SaveTicketAssignRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketAssignRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketAssignRuleResp}
 */
proto.xcommon.SaveTicketAssignRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketAssignRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketAssignRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketAssignRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketAssignRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveTicketAssignRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveTicketAssignRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketAssignRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketAssignRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketAssignRuleResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketAssignRuleResp.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteTicketAssignRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteTicketAssignRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketAssignRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    action: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteTicketAssignRuleReq}
 */
proto.xcommon.DeleteTicketAssignRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteTicketAssignRuleReq;
  return proto.xcommon.DeleteTicketAssignRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteTicketAssignRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteTicketAssignRuleReq}
 */
proto.xcommon.DeleteTicketAssignRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.RuleAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteTicketAssignRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteTicketAssignRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketAssignRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional RuleAction action = 3;
 * @return {!proto.xcommon.RuleAction}
 */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.getAction = function() {
  return /** @type {!proto.xcommon.RuleAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.RuleAction} value */
proto.xcommon.DeleteTicketAssignRuleReq.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteTicketAssignRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteTicketAssignRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteTicketAssignRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketAssignRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteTicketAssignRuleResp}
 */
proto.xcommon.DeleteTicketAssignRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteTicketAssignRuleResp;
  return proto.xcommon.DeleteTicketAssignRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteTicketAssignRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteTicketAssignRuleResp}
 */
proto.xcommon.DeleteTicketAssignRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteTicketAssignRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteTicketAssignRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteTicketAssignRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketAssignRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DeleteTicketAssignRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DeleteTicketAssignRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DeleteTicketAssignRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteTicketAssignRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecycleParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecycleParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecycleParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecycleParamReq}
 */
proto.xcommon.GetTicketRecycleParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecycleParamReq;
  return proto.xcommon.GetTicketRecycleParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecycleParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecycleParamReq}
 */
proto.xcommon.GetTicketRecycleParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecycleParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecycleParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecycleParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketRecycleParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketRecycleParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecycleParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecycleParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecycleParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecycleParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecycleParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    param: (f = msg.getParam()) && proto.xcommon.TicketRecycleParam.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecycleParamResp}
 */
proto.xcommon.GetTicketRecycleParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecycleParamResp;
  return proto.xcommon.GetTicketRecycleParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecycleParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecycleParamResp}
 */
proto.xcommon.GetTicketRecycleParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.TicketRecycleParam;
      reader.readMessage(value,proto.xcommon.TicketRecycleParam.deserializeBinaryFromReader);
      msg.setParam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecycleParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecycleParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecycleParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getParam();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.TicketRecycleParam.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketRecycleParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketRecycleParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecycleParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecycleParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TicketRecycleParam Param = 2;
 * @return {?proto.xcommon.TicketRecycleParam}
 */
proto.xcommon.GetTicketRecycleParamResp.prototype.getParam = function() {
  return /** @type{?proto.xcommon.TicketRecycleParam} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketRecycleParam, 2));
};


/** @param {?proto.xcommon.TicketRecycleParam|undefined} value */
proto.xcommon.GetTicketRecycleParamResp.prototype.setParam = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecycleParamResp.prototype.clearParam = function() {
  this.setParam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecycleParamResp.prototype.hasParam = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecycleRulesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecycleRulesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecycleRulesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleRulesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecycleRulesReq}
 */
proto.xcommon.GetTicketRecycleRulesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecycleRulesReq;
  return proto.xcommon.GetTicketRecycleRulesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecycleRulesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecycleRulesReq}
 */
proto.xcommon.GetTicketRecycleRulesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecycleRulesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecycleRulesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecycleRulesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleRulesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketRecycleRulesReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketRecycleRulesReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecycleRulesReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecycleRulesReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetTicketRecycleRulesReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetTicketRecycleRulesReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecycleRulesReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecycleRulesReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketRecycleRulesResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecycleRulesResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecycleRulesResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleRulesResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.GetTicketRecycleRulesItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecycleRulesResp}
 */
proto.xcommon.GetTicketRecycleRulesResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecycleRulesResp;
  return proto.xcommon.GetTicketRecycleRulesResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecycleRulesResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecycleRulesResp}
 */
proto.xcommon.GetTicketRecycleRulesResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.GetTicketRecycleRulesItem;
      reader.readMessage(value,proto.xcommon.GetTicketRecycleRulesItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecycleRulesResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecycleRulesResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleRulesResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetTicketRecycleRulesItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketRecycleRulesResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketRecycleRulesResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated GetTicketRecycleRulesItem List = 3;
 * @return {!Array<!proto.xcommon.GetTicketRecycleRulesItem>}
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.GetTicketRecycleRulesItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetTicketRecycleRulesItem, 3));
};


/** @param {!Array<!proto.xcommon.GetTicketRecycleRulesItem>} value */
proto.xcommon.GetTicketRecycleRulesResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetTicketRecycleRulesItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetTicketRecycleRulesItem}
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetTicketRecycleRulesItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketRecycleRulesResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketRecycleRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketRecycleRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketRecycleRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.TicketRecycleRuleAttr.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketRecycleRuleReq}
 */
proto.xcommon.SaveTicketRecycleRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketRecycleRuleReq;
  return proto.xcommon.SaveTicketRecycleRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketRecycleRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketRecycleRuleReq}
 */
proto.xcommon.SaveTicketRecycleRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketRecycleRuleAttr;
      reader.readMessage(value,proto.xcommon.TicketRecycleRuleAttr.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketRecycleRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketRecycleRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketRecycleRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.TicketRecycleRuleAttr.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional TicketRecycleRuleAttr Data = 3;
 * @return {?proto.xcommon.TicketRecycleRuleAttr}
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.TicketRecycleRuleAttr} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketRecycleRuleAttr, 3));
};


/** @param {?proto.xcommon.TicketRecycleRuleAttr|undefined} value */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketRecycleRuleReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketRecycleRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketRecycleRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketRecycleRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketRecycleRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketRecycleRuleResp}
 */
proto.xcommon.SaveTicketRecycleRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketRecycleRuleResp;
  return proto.xcommon.SaveTicketRecycleRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketRecycleRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketRecycleRuleResp}
 */
proto.xcommon.SaveTicketRecycleRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketRecycleRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketRecycleRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketRecycleRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketRecycleRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveTicketRecycleRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveTicketRecycleRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketRecycleRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketRecycleRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketRecycleRuleResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketRecycleRuleResp.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteTicketRecycleRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteTicketRecycleRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketRecycleRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    action: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteTicketRecycleRuleReq}
 */
proto.xcommon.DeleteTicketRecycleRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteTicketRecycleRuleReq;
  return proto.xcommon.DeleteTicketRecycleRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteTicketRecycleRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteTicketRecycleRuleReq}
 */
proto.xcommon.DeleteTicketRecycleRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.RuleAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteTicketRecycleRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteTicketRecycleRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketRecycleRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional RuleAction action = 3;
 * @return {!proto.xcommon.RuleAction}
 */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.getAction = function() {
  return /** @type {!proto.xcommon.RuleAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.RuleAction} value */
proto.xcommon.DeleteTicketRecycleRuleReq.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteTicketRecycleRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteTicketRecycleRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteTicketRecycleRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketRecycleRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteTicketRecycleRuleResp}
 */
proto.xcommon.DeleteTicketRecycleRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteTicketRecycleRuleResp;
  return proto.xcommon.DeleteTicketRecycleRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteTicketRecycleRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteTicketRecycleRuleResp}
 */
proto.xcommon.DeleteTicketRecycleRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteTicketRecycleRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteTicketRecycleRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteTicketRecycleRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketRecycleRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DeleteTicketRecycleRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DeleteTicketRecycleRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DeleteTicketRecycleRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteTicketRecycleRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketEntrustParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketEntrustParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketEntrustParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketEntrustParamReq}
 */
proto.xcommon.GetTicketEntrustParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketEntrustParamReq;
  return proto.xcommon.GetTicketEntrustParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketEntrustParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketEntrustParamReq}
 */
proto.xcommon.GetTicketEntrustParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketEntrustParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketEntrustParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketEntrustParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketEntrustParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketEntrustParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEntrustParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEntrustParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketEntrustParamResp.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketEntrustParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketEntrustParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    thirdcompanyList: jspb.Message.toObjectList(msg.getThirdcompanyList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    workmodeList: jspb.Message.toObjectList(msg.getWorkmodeList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketEntrustParamResp}
 */
proto.xcommon.GetTicketEntrustParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketEntrustParamResp;
  return proto.xcommon.GetTicketEntrustParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketEntrustParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketEntrustParamResp}
 */
proto.xcommon.GetTicketEntrustParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addThirdcompany(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addWorkmode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketEntrustParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketEntrustParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getThirdcompanyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getWorkmodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketEntrustParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AttrItem ThirdCompany = 2;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.getThirdcompanyList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 2));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetTicketEntrustParamResp.prototype.setThirdcompanyList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.addThirdcompany = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.clearThirdcompanyList = function() {
  this.setThirdcompanyList([]);
};


/**
 * repeated AttrItem WorkMode = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.getWorkmodeList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetTicketEntrustParamResp.prototype.setWorkmodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.addWorkmode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketEntrustParamResp.prototype.clearWorkmodeList = function() {
  this.setWorkmodeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketEntrustRulesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketEntrustRulesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketEntrustRulesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustRulesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketEntrustRulesReq}
 */
proto.xcommon.GetTicketEntrustRulesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketEntrustRulesReq;
  return proto.xcommon.GetTicketEntrustRulesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketEntrustRulesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketEntrustRulesReq}
 */
proto.xcommon.GetTicketEntrustRulesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketEntrustRulesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketEntrustRulesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketEntrustRulesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustRulesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketEntrustRulesReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketEntrustRulesReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEntrustRulesReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEntrustRulesReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetTicketEntrustRulesReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetTicketEntrustRulesReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEntrustRulesReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEntrustRulesReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketEntrustRulesResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketEntrustRulesResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketEntrustRulesResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustRulesResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.GetTicketEntrustRulesItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketEntrustRulesResp}
 */
proto.xcommon.GetTicketEntrustRulesResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketEntrustRulesResp;
  return proto.xcommon.GetTicketEntrustRulesResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketEntrustRulesResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketEntrustRulesResp}
 */
proto.xcommon.GetTicketEntrustRulesResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.GetTicketEntrustRulesItem;
      reader.readMessage(value,proto.xcommon.GetTicketEntrustRulesItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketEntrustRulesResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketEntrustRulesResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustRulesResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetTicketEntrustRulesItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketEntrustRulesResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketEntrustRulesResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated GetTicketEntrustRulesItem List = 3;
 * @return {!Array<!proto.xcommon.GetTicketEntrustRulesItem>}
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.GetTicketEntrustRulesItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetTicketEntrustRulesItem, 3));
};


/** @param {!Array<!proto.xcommon.GetTicketEntrustRulesItem>} value */
proto.xcommon.GetTicketEntrustRulesResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetTicketEntrustRulesItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetTicketEntrustRulesItem}
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetTicketEntrustRulesItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketEntrustRulesResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketEntrustRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketEntrustRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketEntrustRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.TicketEntrustRuleAttr.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketEntrustRuleReq}
 */
proto.xcommon.SaveTicketEntrustRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketEntrustRuleReq;
  return proto.xcommon.SaveTicketEntrustRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketEntrustRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketEntrustRuleReq}
 */
proto.xcommon.SaveTicketEntrustRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketEntrustRuleAttr;
      reader.readMessage(value,proto.xcommon.TicketEntrustRuleAttr.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketEntrustRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketEntrustRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketEntrustRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.TicketEntrustRuleAttr.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional TicketEntrustRuleAttr Data = 3;
 * @return {?proto.xcommon.TicketEntrustRuleAttr}
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.TicketEntrustRuleAttr} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketEntrustRuleAttr, 3));
};


/** @param {?proto.xcommon.TicketEntrustRuleAttr|undefined} value */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketEntrustRuleReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketEntrustRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketEntrustRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketEntrustRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketEntrustRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketEntrustRuleResp}
 */
proto.xcommon.SaveTicketEntrustRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketEntrustRuleResp;
  return proto.xcommon.SaveTicketEntrustRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketEntrustRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketEntrustRuleResp}
 */
proto.xcommon.SaveTicketEntrustRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketEntrustRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketEntrustRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketEntrustRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketEntrustRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveTicketEntrustRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveTicketEntrustRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketEntrustRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketEntrustRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketEntrustRuleResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketEntrustRuleResp.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteTicketEntrustRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteTicketEntrustRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketEntrustRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    action: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteTicketEntrustRuleReq}
 */
proto.xcommon.DeleteTicketEntrustRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteTicketEntrustRuleReq;
  return proto.xcommon.DeleteTicketEntrustRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteTicketEntrustRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteTicketEntrustRuleReq}
 */
proto.xcommon.DeleteTicketEntrustRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.RuleAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteTicketEntrustRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteTicketEntrustRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketEntrustRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional RuleAction action = 3;
 * @return {!proto.xcommon.RuleAction}
 */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.getAction = function() {
  return /** @type {!proto.xcommon.RuleAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.RuleAction} value */
proto.xcommon.DeleteTicketEntrustRuleReq.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteTicketEntrustRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteTicketEntrustRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteTicketEntrustRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketEntrustRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteTicketEntrustRuleResp}
 */
proto.xcommon.DeleteTicketEntrustRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteTicketEntrustRuleResp;
  return proto.xcommon.DeleteTicketEntrustRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteTicketEntrustRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteTicketEntrustRuleResp}
 */
proto.xcommon.DeleteTicketEntrustRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteTicketEntrustRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteTicketEntrustRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteTicketEntrustRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketEntrustRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DeleteTicketEntrustRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DeleteTicketEntrustRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DeleteTicketEntrustRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteTicketEntrustRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecallParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecallParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecallParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecallParamReq}
 */
proto.xcommon.GetTicketRecallParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecallParamReq;
  return proto.xcommon.GetTicketRecallParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecallParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecallParamReq}
 */
proto.xcommon.GetTicketRecallParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecallParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecallParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecallParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketRecallParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketRecallParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecallParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecallParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketRecallParamResp.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecallParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecallParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecallParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    thirdcompanyList: jspb.Message.toObjectList(msg.getThirdcompanyList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    workmodeList: jspb.Message.toObjectList(msg.getWorkmodeList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecallParamResp}
 */
proto.xcommon.GetTicketRecallParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecallParamResp;
  return proto.xcommon.GetTicketRecallParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecallParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecallParamResp}
 */
proto.xcommon.GetTicketRecallParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addThirdcompany(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addWorkmode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecallParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecallParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecallParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getThirdcompanyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getWorkmodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketRecallParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketRecallParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecallParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecallParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AttrItem ThirdCompany = 2;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetTicketRecallParamResp.prototype.getThirdcompanyList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 2));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetTicketRecallParamResp.prototype.setThirdcompanyList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetTicketRecallParamResp.prototype.addThirdcompany = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketRecallParamResp.prototype.clearThirdcompanyList = function() {
  this.setThirdcompanyList([]);
};


/**
 * repeated AttrItem WorkMode = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetTicketRecallParamResp.prototype.getWorkmodeList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetTicketRecallParamResp.prototype.setWorkmodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetTicketRecallParamResp.prototype.addWorkmode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketRecallParamResp.prototype.clearWorkmodeList = function() {
  this.setWorkmodeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecallRulesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecallRulesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecallRulesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallRulesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecallRulesReq}
 */
proto.xcommon.GetTicketRecallRulesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecallRulesReq;
  return proto.xcommon.GetTicketRecallRulesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecallRulesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecallRulesReq}
 */
proto.xcommon.GetTicketRecallRulesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecallRulesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecallRulesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecallRulesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallRulesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketRecallRulesReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketRecallRulesReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecallRulesReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecallRulesReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetTicketRecallRulesReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetTicketRecallRulesReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecallRulesReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecallRulesReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketRecallRulesResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecallRulesResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecallRulesResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallRulesResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.GetTicketRecallRulesItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecallRulesResp}
 */
proto.xcommon.GetTicketRecallRulesResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecallRulesResp;
  return proto.xcommon.GetTicketRecallRulesResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecallRulesResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecallRulesResp}
 */
proto.xcommon.GetTicketRecallRulesResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.GetTicketRecallRulesItem;
      reader.readMessage(value,proto.xcommon.GetTicketRecallRulesItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecallRulesResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecallRulesResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallRulesResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetTicketRecallRulesItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketRecallRulesResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketRecallRulesResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated GetTicketRecallRulesItem List = 3;
 * @return {!Array<!proto.xcommon.GetTicketRecallRulesItem>}
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.GetTicketRecallRulesItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetTicketRecallRulesItem, 3));
};


/** @param {!Array<!proto.xcommon.GetTicketRecallRulesItem>} value */
proto.xcommon.GetTicketRecallRulesResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetTicketRecallRulesItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetTicketRecallRulesItem}
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetTicketRecallRulesItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketRecallRulesResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketRecallRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketRecallRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketRecallRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.TicketRecallRuleAttr.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketRecallRuleReq}
 */
proto.xcommon.SaveTicketRecallRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketRecallRuleReq;
  return proto.xcommon.SaveTicketRecallRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketRecallRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketRecallRuleReq}
 */
proto.xcommon.SaveTicketRecallRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketRecallRuleAttr;
      reader.readMessage(value,proto.xcommon.TicketRecallRuleAttr.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketRecallRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketRecallRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketRecallRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.TicketRecallRuleAttr.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveTicketRecallRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketRecallRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional TicketRecallRuleAttr Data = 3;
 * @return {?proto.xcommon.TicketRecallRuleAttr}
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.TicketRecallRuleAttr} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketRecallRuleAttr, 3));
};


/** @param {?proto.xcommon.TicketRecallRuleAttr|undefined} value */
proto.xcommon.SaveTicketRecallRuleReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketRecallRuleReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketRecallRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketRecallRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketRecallRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketRecallRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketRecallRuleResp}
 */
proto.xcommon.SaveTicketRecallRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketRecallRuleResp;
  return proto.xcommon.SaveTicketRecallRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketRecallRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketRecallRuleResp}
 */
proto.xcommon.SaveTicketRecallRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketRecallRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketRecallRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketRecallRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketRecallRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveTicketRecallRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveTicketRecallRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketRecallRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketRecallRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketRecallRuleResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketRecallRuleResp.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteTicketRecallRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteTicketRecallRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketRecallRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    action: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteTicketRecallRuleReq}
 */
proto.xcommon.DeleteTicketRecallRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteTicketRecallRuleReq;
  return proto.xcommon.DeleteTicketRecallRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteTicketRecallRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteTicketRecallRuleReq}
 */
proto.xcommon.DeleteTicketRecallRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.RuleAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteTicketRecallRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteTicketRecallRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketRecallRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional RuleAction action = 3;
 * @return {!proto.xcommon.RuleAction}
 */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.getAction = function() {
  return /** @type {!proto.xcommon.RuleAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.RuleAction} value */
proto.xcommon.DeleteTicketRecallRuleReq.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DeleteTicketRecallRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DeleteTicketRecallRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DeleteTicketRecallRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketRecallRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DeleteTicketRecallRuleResp}
 */
proto.xcommon.DeleteTicketRecallRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DeleteTicketRecallRuleResp;
  return proto.xcommon.DeleteTicketRecallRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DeleteTicketRecallRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DeleteTicketRecallRuleResp}
 */
proto.xcommon.DeleteTicketRecallRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DeleteTicketRecallRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DeleteTicketRecallRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DeleteTicketRecallRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DeleteTicketRecallRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DeleteTicketRecallRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DeleteTicketRecallRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DeleteTicketRecallRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DeleteTicketRecallRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityOptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityOptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityOptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityOptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityOptionReq}
 */
proto.xcommon.GetAudioQualityOptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityOptionReq;
  return proto.xcommon.GetAudioQualityOptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityOptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityOptionReq}
 */
proto.xcommon.GetAudioQualityOptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityOptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityOptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityOptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityOptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAudioQualityOptionReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetAudioQualityOptionReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityOptionReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityOptionReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityOptionResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityOptionResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityOptionResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    statusmapMap: (f = msg.getStatusmapMap()) ? f.toObject(includeInstance, undefined) : [],
    scorepolicymapMap: (f = msg.getScorepolicymapMap()) ? f.toObject(includeInstance, undefined) : [],
    matchtimesmapMap: (f = msg.getMatchtimesmapMap()) ? f.toObject(includeInstance, undefined) : [],
    qualitytypemapMap: (f = msg.getQualitytypemapMap()) ? f.toObject(includeInstance, undefined) : [],
    qualityobjectmapMap: (f = msg.getQualityobjectmapMap()) ? f.toObject(includeInstance, undefined) : [],
    hitrulemapMap: (f = msg.getHitrulemapMap()) ? f.toObject(includeInstance, undefined) : [],
    logicalmapMap: (f = msg.getLogicalmapMap()) ? f.toObject(includeInstance, undefined) : [],
    qualitykindmapMap: (f = msg.getQualitykindmapMap()) ? f.toObject(includeInstance, undefined) : [],
    aistatusmapMap: (f = msg.getAistatusmapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityOptionResp}
 */
proto.xcommon.GetAudioQualityOptionResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityOptionResp;
  return proto.xcommon.GetAudioQualityOptionResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityOptionResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityOptionResp}
 */
proto.xcommon.GetAudioQualityOptionResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getStatusmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 3:
      var value = msg.getScorepolicymapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 4:
      var value = msg.getMatchtimesmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 5:
      var value = msg.getQualitytypemapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 6:
      var value = msg.getQualityobjectmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 7:
      var value = msg.getHitrulemapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 8:
      var value = msg.getLogicalmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 9:
      var value = msg.getQualitykindmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 10:
      var value = msg.getAistatusmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityOptionResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityOptionResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityOptionResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getStatusmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getScorepolicymapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getMatchtimesmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getQualitytypemapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getQualityobjectmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getHitrulemapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLogicalmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getQualitykindmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getAistatusmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetAudioQualityOptionResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int32, string> StatusMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getStatusmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearStatusmapMap = function() {
  this.getStatusmapMap().clear();
};


/**
 * map<int32, string> ScorePolicyMap = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getScorepolicymapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearScorepolicymapMap = function() {
  this.getScorepolicymapMap().clear();
};


/**
 * map<int32, string> MatchTimesMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getMatchtimesmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearMatchtimesmapMap = function() {
  this.getMatchtimesmapMap().clear();
};


/**
 * map<int32, string> QualityTypeMap = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getQualitytypemapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearQualitytypemapMap = function() {
  this.getQualitytypemapMap().clear();
};


/**
 * map<int32, string> QualityObjectMap = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getQualityobjectmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearQualityobjectmapMap = function() {
  this.getQualityobjectmapMap().clear();
};


/**
 * map<int32, string> HitRuleMap = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getHitrulemapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearHitrulemapMap = function() {
  this.getHitrulemapMap().clear();
};


/**
 * map<int32, string> LogicalMap = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getLogicalmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearLogicalmapMap = function() {
  this.getLogicalmapMap().clear();
};


/**
 * map<int32, string> QualityKindMap = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getQualitykindmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearQualitykindmapMap = function() {
  this.getQualitykindmapMap().clear();
};


/**
 * map<int32, string> AiStatusMap = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.getAistatusmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetAudioQualityOptionResp.prototype.clearAistatusmapMap = function() {
  this.getAistatusmapMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityScriptListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityScriptListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityScriptListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityScriptData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityScriptListReq}
 */
proto.xcommon.GetAudioQualityScriptListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityScriptListReq;
  return proto.xcommon.GetAudioQualityScriptListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityScriptListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityScriptListReq}
 */
proto.xcommon.GetAudioQualityScriptListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityScriptData;
      reader.readMessage(value,proto.xcommon.AudioQualityScriptData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityScriptListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityScriptListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityScriptListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityScriptData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetAudioQualityScriptListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetAudioQualityScriptListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AudioQualityScriptData Data = 3;
 * @return {?proto.xcommon.AudioQualityScriptData}
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityScriptData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityScriptData, 3));
};


/** @param {?proto.xcommon.AudioQualityScriptData|undefined} value */
proto.xcommon.GetAudioQualityScriptListReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptListReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetAudioQualityScriptListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityScriptListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityScriptListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityScriptListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AudioQualityScriptData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityScriptListResp}
 */
proto.xcommon.GetAudioQualityScriptListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityScriptListResp;
  return proto.xcommon.GetAudioQualityScriptListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityScriptListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityScriptListResp}
 */
proto.xcommon.GetAudioQualityScriptListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityScriptData;
      reader.readMessage(value,proto.xcommon.AudioQualityScriptData.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityScriptListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityScriptListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityScriptListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AudioQualityScriptData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetAudioQualityScriptListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetAudioQualityScriptListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AudioQualityScriptData List = 3;
 * @return {!Array<!proto.xcommon.AudioQualityScriptData>}
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AudioQualityScriptData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AudioQualityScriptData, 3));
};


/** @param {!Array<!proto.xcommon.AudioQualityScriptData>} value */
proto.xcommon.GetAudioQualityScriptListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AudioQualityScriptData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioQualityScriptData}
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AudioQualityScriptData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetAudioQualityScriptListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityScriptReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityScriptReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityScriptReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityScriptReq}
 */
proto.xcommon.GetAudioQualityScriptReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityScriptReq;
  return proto.xcommon.GetAudioQualityScriptReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityScriptReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityScriptReq}
 */
proto.xcommon.GetAudioQualityScriptReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityScriptReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityScriptReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityScriptReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetAudioQualityScriptReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetAudioQualityScriptReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 Id = 3;
 * @return {number}
 */
proto.xcommon.GetAudioQualityScriptReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetAudioQualityScriptReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityScriptResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityScriptResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityScriptResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityScriptData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityScriptResp}
 */
proto.xcommon.GetAudioQualityScriptResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityScriptResp;
  return proto.xcommon.GetAudioQualityScriptResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityScriptResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityScriptResp}
 */
proto.xcommon.GetAudioQualityScriptResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityScriptData;
      reader.readMessage(value,proto.xcommon.AudioQualityScriptData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityScriptResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityScriptResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityScriptResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityScriptData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetAudioQualityScriptResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetAudioQualityScriptResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AudioQualityScriptData Data = 3;
 * @return {?proto.xcommon.AudioQualityScriptData}
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityScriptData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityScriptData, 3));
};


/** @param {?proto.xcommon.AudioQualityScriptData|undefined} value */
proto.xcommon.GetAudioQualityScriptResp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityScriptResp.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveAudioQualityScriptReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveAudioQualityScriptReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveAudioQualityScriptReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityScriptData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveAudioQualityScriptReq}
 */
proto.xcommon.SaveAudioQualityScriptReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveAudioQualityScriptReq;
  return proto.xcommon.SaveAudioQualityScriptReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveAudioQualityScriptReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveAudioQualityScriptReq}
 */
proto.xcommon.SaveAudioQualityScriptReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityScriptData;
      reader.readMessage(value,proto.xcommon.AudioQualityScriptData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveAudioQualityScriptReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveAudioQualityScriptReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveAudioQualityScriptReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityScriptData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveAudioQualityScriptReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveAudioQualityScriptReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional AudioQualityScriptData Data = 3;
 * @return {?proto.xcommon.AudioQualityScriptData}
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityScriptData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityScriptData, 3));
};


/** @param {?proto.xcommon.AudioQualityScriptData|undefined} value */
proto.xcommon.SaveAudioQualityScriptReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveAudioQualityScriptReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ModifyAudioQualityScriptStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ModifyAudioQualityScriptStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ModifyAudioQualityScriptStatusReq}
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ModifyAudioQualityScriptStatusReq;
  return proto.xcommon.ModifyAudioQualityScriptStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ModifyAudioQualityScriptStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ModifyAudioQualityScriptStatusReq}
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ModifyAudioQualityScriptStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ModifyAudioQualityScriptStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional CommonStatus Status = 3;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.ModifyAudioQualityScriptStatusReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AudioQualityScriptData.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AudioQualityScriptData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AudioQualityScriptData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AudioQualityScriptData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioQualityScriptData.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    scriptname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    scripttextList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    scriptnum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    uid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    username: jspb.Message.getFieldWithDefault(msg, 6, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AudioQualityScriptData}
 */
proto.xcommon.AudioQualityScriptData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AudioQualityScriptData;
  return proto.xcommon.AudioQualityScriptData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AudioQualityScriptData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AudioQualityScriptData}
 */
proto.xcommon.AudioQualityScriptData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addScripttext(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScriptnum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AudioQualityScriptData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AudioQualityScriptData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AudioQualityScriptData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioQualityScriptData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getScriptname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScripttextList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getScriptnum();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getUid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.AudioQualityScriptData.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityScriptData.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ScriptName = 2;
 * @return {string}
 */
proto.xcommon.AudioQualityScriptData.prototype.getScriptname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityScriptData.prototype.setScriptname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string ScriptText = 3;
 * @return {!Array<string>}
 */
proto.xcommon.AudioQualityScriptData.prototype.getScripttextList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.AudioQualityScriptData.prototype.setScripttextList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.AudioQualityScriptData.prototype.addScripttext = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AudioQualityScriptData.prototype.clearScripttextList = function() {
  this.setScripttextList([]);
};


/**
 * optional int32 ScriptNum = 4;
 * @return {number}
 */
proto.xcommon.AudioQualityScriptData.prototype.getScriptnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityScriptData.prototype.setScriptnum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 Uid = 5;
 * @return {number}
 */
proto.xcommon.AudioQualityScriptData.prototype.getUid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityScriptData.prototype.setUid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string UserName = 6;
 * @return {string}
 */
proto.xcommon.AudioQualityScriptData.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityScriptData.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 Ctime = 7;
 * @return {number}
 */
proto.xcommon.AudioQualityScriptData.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityScriptData.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional CommonStatus Status = 8;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.AudioQualityScriptData.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.AudioQualityScriptData.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityRuleListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityRuleListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityRuleListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityRuleData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityRuleListReq}
 */
proto.xcommon.GetAudioQualityRuleListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityRuleListReq;
  return proto.xcommon.GetAudioQualityRuleListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityRuleListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityRuleListReq}
 */
proto.xcommon.GetAudioQualityRuleListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityRuleData;
      reader.readMessage(value,proto.xcommon.AudioQualityRuleData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityRuleListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityRuleListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityRuleListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityRuleData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetAudioQualityRuleListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetAudioQualityRuleListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AudioQualityRuleData Data = 3;
 * @return {?proto.xcommon.AudioQualityRuleData}
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityRuleData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityRuleData, 3));
};


/** @param {?proto.xcommon.AudioQualityRuleData|undefined} value */
proto.xcommon.GetAudioQualityRuleListReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleListReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetAudioQualityRuleListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityRuleListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityRuleListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityRuleListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AudioQualityRuleData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityRuleListResp}
 */
proto.xcommon.GetAudioQualityRuleListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityRuleListResp;
  return proto.xcommon.GetAudioQualityRuleListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityRuleListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityRuleListResp}
 */
proto.xcommon.GetAudioQualityRuleListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityRuleData;
      reader.readMessage(value,proto.xcommon.AudioQualityRuleData.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityRuleListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityRuleListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityRuleListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AudioQualityRuleData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetAudioQualityRuleListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetAudioQualityRuleListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AudioQualityRuleData List = 3;
 * @return {!Array<!proto.xcommon.AudioQualityRuleData>}
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AudioQualityRuleData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AudioQualityRuleData, 3));
};


/** @param {!Array<!proto.xcommon.AudioQualityRuleData>} value */
proto.xcommon.GetAudioQualityRuleListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AudioQualityRuleData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioQualityRuleData}
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AudioQualityRuleData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetAudioQualityRuleListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityRuleReq}
 */
proto.xcommon.GetAudioQualityRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityRuleReq;
  return proto.xcommon.GetAudioQualityRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityRuleReq}
 */
proto.xcommon.GetAudioQualityRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetAudioQualityRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetAudioQualityRuleReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 Id = 3;
 * @return {number}
 */
proto.xcommon.GetAudioQualityRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetAudioQualityRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityRuleResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityRuleResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityRuleResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityRuleData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityRuleResp}
 */
proto.xcommon.GetAudioQualityRuleResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityRuleResp;
  return proto.xcommon.GetAudioQualityRuleResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityRuleResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityRuleResp}
 */
proto.xcommon.GetAudioQualityRuleResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityRuleData;
      reader.readMessage(value,proto.xcommon.AudioQualityRuleData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityRuleResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityRuleResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityRuleResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityRuleData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetAudioQualityRuleResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetAudioQualityRuleResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AudioQualityRuleData Data = 3;
 * @return {?proto.xcommon.AudioQualityRuleData}
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityRuleData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityRuleData, 3));
};


/** @param {?proto.xcommon.AudioQualityRuleData|undefined} value */
proto.xcommon.GetAudioQualityRuleResp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityRuleResp.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveAudioQualityRuleReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveAudioQualityRuleReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveAudioQualityRuleReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityRuleData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveAudioQualityRuleReq}
 */
proto.xcommon.SaveAudioQualityRuleReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveAudioQualityRuleReq;
  return proto.xcommon.SaveAudioQualityRuleReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveAudioQualityRuleReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveAudioQualityRuleReq}
 */
proto.xcommon.SaveAudioQualityRuleReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityRuleData;
      reader.readMessage(value,proto.xcommon.AudioQualityRuleData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveAudioQualityRuleReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveAudioQualityRuleReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveAudioQualityRuleReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityRuleData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveAudioQualityRuleReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveAudioQualityRuleReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional AudioQualityRuleData Data = 3;
 * @return {?proto.xcommon.AudioQualityRuleData}
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityRuleData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityRuleData, 3));
};


/** @param {?proto.xcommon.AudioQualityRuleData|undefined} value */
proto.xcommon.SaveAudioQualityRuleReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveAudioQualityRuleReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ModifyAudioQualityRuleStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ModifyAudioQualityRuleStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ModifyAudioQualityRuleStatusReq}
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ModifyAudioQualityRuleStatusReq;
  return proto.xcommon.ModifyAudioQualityRuleStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ModifyAudioQualityRuleStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ModifyAudioQualityRuleStatusReq}
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ModifyAudioQualityRuleStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ModifyAudioQualityRuleStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional CommonStatus Status = 3;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.ModifyAudioQualityRuleStatusReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AudioQualityRuleData.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AudioQualityRuleData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AudioQualityRuleData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AudioQualityRuleData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioQualityRuleData.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rulename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ruletext: jspb.Message.getFieldWithDefault(msg, 3, ""),
    scorepolicy: jspb.Message.getFieldWithDefault(msg, 4, 0),
    score: jspb.Message.getFieldWithDefault(msg, 5, 0),
    pointnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    qualitypointlistList: jspb.Message.toObjectList(msg.getQualitypointlistList(),
    proto.xcommon.QualityPoint.toObject, includeInstance),
    matchtimes: jspb.Message.getFieldWithDefault(msg, 8, 0),
    logical: jspb.Message.getFieldWithDefault(msg, 9, 0),
    uid: jspb.Message.getFieldWithDefault(msg, 10, 0),
    username: jspb.Message.getFieldWithDefault(msg, 11, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    status: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AudioQualityRuleData}
 */
proto.xcommon.AudioQualityRuleData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AudioQualityRuleData;
  return proto.xcommon.AudioQualityRuleData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AudioQualityRuleData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AudioQualityRuleData}
 */
proto.xcommon.AudioQualityRuleData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRulename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRuletext(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.ScorePolicy} */ (reader.readEnum());
      msg.setScorepolicy(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPointnum(value);
      break;
    case 7:
      var value = new proto.xcommon.QualityPoint;
      reader.readMessage(value,proto.xcommon.QualityPoint.deserializeBinaryFromReader);
      msg.addQualitypointlist(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.MatchTimes} */ (reader.readEnum());
      msg.setMatchtimes(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.Logical} */ (reader.readEnum());
      msg.setLogical(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AudioQualityRuleData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AudioQualityRuleData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AudioQualityRuleData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioQualityRuleData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRulename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRuletext();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getScorepolicy();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPointnum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getQualitypointlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.xcommon.QualityPoint.serializeBinaryToWriter
    );
  }
  f = message.getMatchtimes();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getLogical();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getUid();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.AudioQualityRuleData.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityRuleData.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string RuleName = 2;
 * @return {string}
 */
proto.xcommon.AudioQualityRuleData.prototype.getRulename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityRuleData.prototype.setRulename = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string RuleText = 3;
 * @return {string}
 */
proto.xcommon.AudioQualityRuleData.prototype.getRuletext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityRuleData.prototype.setRuletext = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ScorePolicy ScorePolicy = 4;
 * @return {!proto.xcommon.ScorePolicy}
 */
proto.xcommon.AudioQualityRuleData.prototype.getScorepolicy = function() {
  return /** @type {!proto.xcommon.ScorePolicy} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.ScorePolicy} value */
proto.xcommon.AudioQualityRuleData.prototype.setScorepolicy = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 Score = 5;
 * @return {number}
 */
proto.xcommon.AudioQualityRuleData.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityRuleData.prototype.setScore = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 PointNum = 6;
 * @return {number}
 */
proto.xcommon.AudioQualityRuleData.prototype.getPointnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityRuleData.prototype.setPointnum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated QualityPoint QualityPointList = 7;
 * @return {!Array<!proto.xcommon.QualityPoint>}
 */
proto.xcommon.AudioQualityRuleData.prototype.getQualitypointlistList = function() {
  return /** @type{!Array<!proto.xcommon.QualityPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.QualityPoint, 7));
};


/** @param {!Array<!proto.xcommon.QualityPoint>} value */
proto.xcommon.AudioQualityRuleData.prototype.setQualitypointlistList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.xcommon.QualityPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.QualityPoint}
 */
proto.xcommon.AudioQualityRuleData.prototype.addQualitypointlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.xcommon.QualityPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AudioQualityRuleData.prototype.clearQualitypointlistList = function() {
  this.setQualitypointlistList([]);
};


/**
 * optional MatchTimes MatchTimes = 8;
 * @return {!proto.xcommon.MatchTimes}
 */
proto.xcommon.AudioQualityRuleData.prototype.getMatchtimes = function() {
  return /** @type {!proto.xcommon.MatchTimes} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.MatchTimes} value */
proto.xcommon.AudioQualityRuleData.prototype.setMatchtimes = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional Logical Logical = 9;
 * @return {!proto.xcommon.Logical}
 */
proto.xcommon.AudioQualityRuleData.prototype.getLogical = function() {
  return /** @type {!proto.xcommon.Logical} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.Logical} value */
proto.xcommon.AudioQualityRuleData.prototype.setLogical = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional int64 Uid = 10;
 * @return {number}
 */
proto.xcommon.AudioQualityRuleData.prototype.getUid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityRuleData.prototype.setUid = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string UserName = 11;
 * @return {string}
 */
proto.xcommon.AudioQualityRuleData.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityRuleData.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 Ctime = 12;
 * @return {number}
 */
proto.xcommon.AudioQualityRuleData.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityRuleData.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional CommonStatus Status = 13;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.AudioQualityRuleData.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.AudioQualityRuleData.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QualityPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QualityPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QualityPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QualityPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    object: jspb.Message.getFieldWithDefault(msg, 3, 0),
    qualitytype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    repeatscript: (f = msg.getRepeatscript()) && proto.xcommon.RepeatScript.toObject(includeInstance, f),
    scriptpoint: (f = msg.getScriptpoint()) && proto.xcommon.ScriptPoint.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QualityPoint}
 */
proto.xcommon.QualityPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QualityPoint;
  return proto.xcommon.QualityPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QualityPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QualityPoint}
 */
proto.xcommon.QualityPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.QualityObject} */ (reader.readEnum());
      msg.setObject(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.QualityType} */ (reader.readEnum());
      msg.setQualitytype(value);
      break;
    case 5:
      var value = new proto.xcommon.RepeatScript;
      reader.readMessage(value,proto.xcommon.RepeatScript.deserializeBinaryFromReader);
      msg.setRepeatscript(value);
      break;
    case 6:
      var value = new proto.xcommon.ScriptPoint;
      reader.readMessage(value,proto.xcommon.ScriptPoint.deserializeBinaryFromReader);
      msg.setScriptpoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QualityPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QualityPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QualityPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QualityPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getObject();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getQualitytype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getRepeatscript();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.RepeatScript.serializeBinaryToWriter
    );
  }
  f = message.getScriptpoint();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.xcommon.ScriptPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.QualityPoint.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.QualityPoint.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.QualityPoint.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.QualityPoint.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional QualityObject Object = 3;
 * @return {!proto.xcommon.QualityObject}
 */
proto.xcommon.QualityPoint.prototype.getObject = function() {
  return /** @type {!proto.xcommon.QualityObject} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.QualityObject} value */
proto.xcommon.QualityPoint.prototype.setObject = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional QualityType QualityType = 4;
 * @return {!proto.xcommon.QualityType}
 */
proto.xcommon.QualityPoint.prototype.getQualitytype = function() {
  return /** @type {!proto.xcommon.QualityType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.QualityType} value */
proto.xcommon.QualityPoint.prototype.setQualitytype = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional RepeatScript RepeatScript = 5;
 * @return {?proto.xcommon.RepeatScript}
 */
proto.xcommon.QualityPoint.prototype.getRepeatscript = function() {
  return /** @type{?proto.xcommon.RepeatScript} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.RepeatScript, 5));
};


/** @param {?proto.xcommon.RepeatScript|undefined} value */
proto.xcommon.QualityPoint.prototype.setRepeatscript = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.QualityPoint.prototype.clearRepeatscript = function() {
  this.setRepeatscript(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.QualityPoint.prototype.hasRepeatscript = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ScriptPoint ScriptPoint = 6;
 * @return {?proto.xcommon.ScriptPoint}
 */
proto.xcommon.QualityPoint.prototype.getScriptpoint = function() {
  return /** @type{?proto.xcommon.ScriptPoint} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ScriptPoint, 6));
};


/** @param {?proto.xcommon.ScriptPoint|undefined} value */
proto.xcommon.QualityPoint.prototype.setScriptpoint = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.QualityPoint.prototype.clearScriptpoint = function() {
  this.setScriptpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.QualityPoint.prototype.hasScriptpoint = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RepeatScript.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RepeatScript.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RepeatScript} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepeatScript.toObject = function(includeInstance, msg) {
  var f, obj = {
    continuity: jspb.Message.getFieldWithDefault(msg, 1, 0),
    repeat: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RepeatScript}
 */
proto.xcommon.RepeatScript.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RepeatScript;
  return proto.xcommon.RepeatScript.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RepeatScript} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RepeatScript}
 */
proto.xcommon.RepeatScript.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContinuity(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRepeat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RepeatScript.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RepeatScript.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RepeatScript} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepeatScript.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContinuity();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRepeat();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 Continuity = 1;
 * @return {number}
 */
proto.xcommon.RepeatScript.prototype.getContinuity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.RepeatScript.prototype.setContinuity = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 Repeat = 2;
 * @return {number}
 */
proto.xcommon.RepeatScript.prototype.getRepeat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.RepeatScript.prototype.setRepeat = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ScriptPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ScriptPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ScriptPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ScriptPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    hitrule: jspb.Message.getFieldWithDefault(msg, 1, 0),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityScriptData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ScriptPoint}
 */
proto.xcommon.ScriptPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ScriptPoint;
  return proto.xcommon.ScriptPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ScriptPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ScriptPoint}
 */
proto.xcommon.ScriptPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.HitRule} */ (reader.readEnum());
      msg.setHitrule(value);
      break;
    case 2:
      var value = new proto.xcommon.AudioQualityScriptData;
      reader.readMessage(value,proto.xcommon.AudioQualityScriptData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ScriptPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ScriptPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ScriptPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ScriptPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHitrule();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.AudioQualityScriptData.serializeBinaryToWriter
    );
  }
};


/**
 * optional HitRule HitRule = 1;
 * @return {!proto.xcommon.HitRule}
 */
proto.xcommon.ScriptPoint.prototype.getHitrule = function() {
  return /** @type {!proto.xcommon.HitRule} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.HitRule} value */
proto.xcommon.ScriptPoint.prototype.setHitrule = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional AudioQualityScriptData Data = 2;
 * @return {?proto.xcommon.AudioQualityScriptData}
 */
proto.xcommon.ScriptPoint.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityScriptData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityScriptData, 2));
};


/** @param {?proto.xcommon.AudioQualityScriptData|undefined} value */
proto.xcommon.ScriptPoint.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ScriptPoint.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ScriptPoint.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityTplListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityTplListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityTplListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityTplData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityTplListReq}
 */
proto.xcommon.GetAudioQualityTplListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityTplListReq;
  return proto.xcommon.GetAudioQualityTplListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityTplListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityTplListReq}
 */
proto.xcommon.GetAudioQualityTplListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityTplData;
      reader.readMessage(value,proto.xcommon.AudioQualityTplData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityTplListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityTplListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityTplListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityTplData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetAudioQualityTplListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetAudioQualityTplListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AudioQualityTplData Data = 3;
 * @return {?proto.xcommon.AudioQualityTplData}
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityTplData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityTplData, 3));
};


/** @param {?proto.xcommon.AudioQualityTplData|undefined} value */
proto.xcommon.GetAudioQualityTplListReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplListReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetAudioQualityTplListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityTplListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityTplListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityTplListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AudioQualityTplData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityTplListResp}
 */
proto.xcommon.GetAudioQualityTplListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityTplListResp;
  return proto.xcommon.GetAudioQualityTplListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityTplListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityTplListResp}
 */
proto.xcommon.GetAudioQualityTplListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityTplData;
      reader.readMessage(value,proto.xcommon.AudioQualityTplData.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityTplListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityTplListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityTplListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AudioQualityTplData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetAudioQualityTplListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetAudioQualityTplListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AudioQualityTplData List = 3;
 * @return {!Array<!proto.xcommon.AudioQualityTplData>}
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AudioQualityTplData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AudioQualityTplData, 3));
};


/** @param {!Array<!proto.xcommon.AudioQualityTplData>} value */
proto.xcommon.GetAudioQualityTplListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AudioQualityTplData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioQualityTplData}
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AudioQualityTplData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetAudioQualityTplListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityTplReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityTplReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityTplReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityTplReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityTplReq}
 */
proto.xcommon.GetAudioQualityTplReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityTplReq;
  return proto.xcommon.GetAudioQualityTplReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityTplReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityTplReq}
 */
proto.xcommon.GetAudioQualityTplReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityTplReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityTplReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityTplReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityTplReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAudioQualityTplReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetAudioQualityTplReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetAudioQualityTplReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetAudioQualityTplReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 Id = 3;
 * @return {number}
 */
proto.xcommon.GetAudioQualityTplReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetAudioQualityTplReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAudioQualityTplResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAudioQualityTplResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAudioQualityTplResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityTplResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityTplData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAudioQualityTplResp}
 */
proto.xcommon.GetAudioQualityTplResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAudioQualityTplResp;
  return proto.xcommon.GetAudioQualityTplResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAudioQualityTplResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAudioQualityTplResp}
 */
proto.xcommon.GetAudioQualityTplResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityTplData;
      reader.readMessage(value,proto.xcommon.AudioQualityTplData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAudioQualityTplResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAudioQualityTplResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAudioQualityTplResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAudioQualityTplResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityTplData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAudioQualityTplResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetAudioQualityTplResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetAudioQualityTplResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetAudioQualityTplResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AudioQualityTplData Data = 3;
 * @return {?proto.xcommon.AudioQualityTplData}
 */
proto.xcommon.GetAudioQualityTplResp.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityTplData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityTplData, 3));
};


/** @param {?proto.xcommon.AudioQualityTplData|undefined} value */
proto.xcommon.GetAudioQualityTplResp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAudioQualityTplResp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAudioQualityTplResp.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveAudioQualityTplReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveAudioQualityTplReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveAudioQualityTplReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.AudioQualityTplData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveAudioQualityTplReq}
 */
proto.xcommon.SaveAudioQualityTplReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveAudioQualityTplReq;
  return proto.xcommon.SaveAudioQualityTplReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveAudioQualityTplReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveAudioQualityTplReq}
 */
proto.xcommon.SaveAudioQualityTplReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.xcommon.AudioQualityTplData;
      reader.readMessage(value,proto.xcommon.AudioQualityTplData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveAudioQualityTplReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveAudioQualityTplReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveAudioQualityTplReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AudioQualityTplData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveAudioQualityTplReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveAudioQualityTplReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional AudioQualityTplData Data = 3;
 * @return {?proto.xcommon.AudioQualityTplData}
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.AudioQualityTplData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityTplData, 3));
};


/** @param {?proto.xcommon.AudioQualityTplData|undefined} value */
proto.xcommon.SaveAudioQualityTplReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveAudioQualityTplReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ModifyAudioQualityTemplateStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ModifyAudioQualityTemplateStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ModifyAudioQualityTemplateStatusReq}
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ModifyAudioQualityTemplateStatusReq;
  return proto.xcommon.ModifyAudioQualityTemplateStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ModifyAudioQualityTemplateStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ModifyAudioQualityTemplateStatusReq}
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ModifyAudioQualityTemplateStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ModifyAudioQualityTemplateStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional CommonStatus Status = 3;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.ModifyAudioQualityTemplateStatusReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReAudioQualityReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReAudioQualityReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReAudioQualityReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReAudioQualityReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReAudioQualityReq}
 */
proto.xcommon.ReAudioQualityReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReAudioQualityReq;
  return proto.xcommon.ReAudioQualityReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReAudioQualityReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReAudioQualityReq}
 */
proto.xcommon.ReAudioQualityReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReAudioQualityReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReAudioQualityReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReAudioQualityReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReAudioQualityReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ReAudioQualityReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ReAudioQualityReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ReAudioQualityReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReAudioQualityReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AudioQualityTplData.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AudioQualityTplData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AudioQualityTplData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AudioQualityTplData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioQualityTplData.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tplname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tpltext: jspb.Message.getFieldWithDefault(msg, 3, ""),
    scope: (f = msg.getScope()) && proto.xcommon.AudioQualityScope.toObject(includeInstance, f),
    rulelistList: jspb.Message.toObjectList(msg.getRulelistList(),
    proto.xcommon.AudioQualityRuleData.toObject, includeInstance),
    rulenum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    uid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    username: jspb.Message.getFieldWithDefault(msg, 8, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    status: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AudioQualityTplData}
 */
proto.xcommon.AudioQualityTplData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AudioQualityTplData;
  return proto.xcommon.AudioQualityTplData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AudioQualityTplData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AudioQualityTplData}
 */
proto.xcommon.AudioQualityTplData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTplname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTpltext(value);
      break;
    case 4:
      var value = new proto.xcommon.AudioQualityScope;
      reader.readMessage(value,proto.xcommon.AudioQualityScope.deserializeBinaryFromReader);
      msg.setScope(value);
      break;
    case 5:
      var value = new proto.xcommon.AudioQualityRuleData;
      reader.readMessage(value,proto.xcommon.AudioQualityRuleData.deserializeBinaryFromReader);
      msg.addRulelist(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRulenum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AudioQualityTplData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AudioQualityTplData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AudioQualityTplData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioQualityTplData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTplname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTpltext();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getScope();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.AudioQualityScope.serializeBinaryToWriter
    );
  }
  f = message.getRulelistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.AudioQualityRuleData.serializeBinaryToWriter
    );
  }
  f = message.getRulenum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getUid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.AudioQualityTplData.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityTplData.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string TplName = 2;
 * @return {string}
 */
proto.xcommon.AudioQualityTplData.prototype.getTplname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityTplData.prototype.setTplname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string TplText = 3;
 * @return {string}
 */
proto.xcommon.AudioQualityTplData.prototype.getTpltext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityTplData.prototype.setTpltext = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional AudioQualityScope Scope = 4;
 * @return {?proto.xcommon.AudioQualityScope}
 */
proto.xcommon.AudioQualityTplData.prototype.getScope = function() {
  return /** @type{?proto.xcommon.AudioQualityScope} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AudioQualityScope, 4));
};


/** @param {?proto.xcommon.AudioQualityScope|undefined} value */
proto.xcommon.AudioQualityTplData.prototype.setScope = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AudioQualityTplData.prototype.clearScope = function() {
  this.setScope(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AudioQualityTplData.prototype.hasScope = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated AudioQualityRuleData RuleList = 5;
 * @return {!Array<!proto.xcommon.AudioQualityRuleData>}
 */
proto.xcommon.AudioQualityTplData.prototype.getRulelistList = function() {
  return /** @type{!Array<!proto.xcommon.AudioQualityRuleData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AudioQualityRuleData, 5));
};


/** @param {!Array<!proto.xcommon.AudioQualityRuleData>} value */
proto.xcommon.AudioQualityTplData.prototype.setRulelistList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.AudioQualityRuleData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioQualityRuleData}
 */
proto.xcommon.AudioQualityTplData.prototype.addRulelist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.AudioQualityRuleData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AudioQualityTplData.prototype.clearRulelistList = function() {
  this.setRulelistList([]);
};


/**
 * optional int32 RuleNum = 6;
 * @return {number}
 */
proto.xcommon.AudioQualityTplData.prototype.getRulenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityTplData.prototype.setRulenum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Uid = 7;
 * @return {number}
 */
proto.xcommon.AudioQualityTplData.prototype.getUid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityTplData.prototype.setUid = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string UserName = 8;
 * @return {string}
 */
proto.xcommon.AudioQualityTplData.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityTplData.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 Ctime = 9;
 * @return {number}
 */
proto.xcommon.AudioQualityTplData.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityTplData.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional CommonStatus Status = 10;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.AudioQualityTplData.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.AudioQualityTplData.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AudioQualityScope.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AudioQualityScope.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AudioQualityScope.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AudioQualityScope} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioQualityScope.toObject = function(includeInstance, msg) {
  var f, obj = {
    duration: jspb.Message.getFieldWithDefault(msg, 1, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rolename: jspb.Message.getFieldWithDefault(msg, 3, ""),
    itemname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    itemnodeList: jspb.Message.toObjectList(msg.getItemnodeList(),
    proto.xcommon.ItemNode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AudioQualityScope}
 */
proto.xcommon.AudioQualityScope.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AudioQualityScope;
  return proto.xcommon.AudioQualityScope.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AudioQualityScope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AudioQualityScope}
 */
proto.xcommon.AudioQualityScope.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDuration(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRolename(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemname(value);
      break;
    case 5:
      var value = new proto.xcommon.ItemNode;
      reader.readMessage(value,proto.xcommon.ItemNode.deserializeBinaryFromReader);
      msg.addItemnode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AudioQualityScope.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AudioQualityScope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AudioQualityScope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AudioQualityScope.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRolename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getItemname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getItemnodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.ItemNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 Duration = 1;
 * @return {number}
 */
proto.xcommon.AudioQualityScope.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityScope.prototype.setDuration = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 ItemId = 2;
 * @return {number}
 */
proto.xcommon.AudioQualityScope.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.AudioQualityScope.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string RoleName = 3;
 * @return {string}
 */
proto.xcommon.AudioQualityScope.prototype.getRolename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityScope.prototype.setRolename = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ItemName = 4;
 * @return {string}
 */
proto.xcommon.AudioQualityScope.prototype.getItemname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.AudioQualityScope.prototype.setItemname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated ItemNode ItemNode = 5;
 * @return {!Array<!proto.xcommon.ItemNode>}
 */
proto.xcommon.AudioQualityScope.prototype.getItemnodeList = function() {
  return /** @type{!Array<!proto.xcommon.ItemNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ItemNode, 5));
};


/** @param {!Array<!proto.xcommon.ItemNode>} value */
proto.xcommon.AudioQualityScope.prototype.setItemnodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.ItemNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ItemNode}
 */
proto.xcommon.AudioQualityScope.prototype.addItemnode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.ItemNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AudioQualityScope.prototype.clearItemnodeList = function() {
  this.setItemnodeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ItemNode.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ItemNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ItemNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ItemNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    itemname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ItemNode}
 */
proto.xcommon.ItemNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ItemNode;
  return proto.xcommon.ItemNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ItemNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ItemNode}
 */
proto.xcommon.ItemNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ItemNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ItemNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ItemNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ItemNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getItemname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 ItemId = 1;
 * @return {number}
 */
proto.xcommon.ItemNode.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.ItemNode.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ItemName = 2;
 * @return {string}
 */
proto.xcommon.ItemNode.prototype.getItemname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ItemNode.prototype.setItemname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVerifyTicketListParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVerifyTicketListParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVerifyTicketListParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketListParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVerifyTicketListParamReq}
 */
proto.xcommon.GetVerifyTicketListParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVerifyTicketListParamReq;
  return proto.xcommon.GetVerifyTicketListParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVerifyTicketListParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVerifyTicketListParamReq}
 */
proto.xcommon.GetVerifyTicketListParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVerifyTicketListParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVerifyTicketListParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVerifyTicketListParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketListParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetVerifyTicketListParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetVerifyTicketListParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVerifyTicketListParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyTicketListParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVerifyTicketListParamResp.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVerifyTicketListParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVerifyTicketListParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketListParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    ticketstatusList: jspb.Message.toObjectList(msg.getTicketstatusList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    ticketitemList: jspb.Message.toObjectList(msg.getTicketitemList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    verifyresultmapMap: (f = msg.getVerifyresultmapMap()) ? f.toObject(includeInstance, undefined) : [],
    inspectionresultmapMap: (f = msg.getInspectionresultmapMap()) ? f.toObject(includeInstance, undefined) : [],
    applist: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVerifyTicketListParamResp}
 */
proto.xcommon.GetVerifyTicketListParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVerifyTicketListParamResp;
  return proto.xcommon.GetVerifyTicketListParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVerifyTicketListParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVerifyTicketListParamResp}
 */
proto.xcommon.GetVerifyTicketListParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketstatus(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketitem(value);
      break;
    case 4:
      var value = msg.getVerifyresultmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 5:
      var value = msg.getInspectionresultmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVerifyTicketListParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVerifyTicketListParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketListParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTicketstatusList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getTicketitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getVerifyresultmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getInspectionresultmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getApplist();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetVerifyTicketListParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AttrItem TicketStatus = 2;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.getTicketstatusList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 2));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetVerifyTicketListParamResp.prototype.setTicketstatusList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.addTicketstatus = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.clearTicketstatusList = function() {
  this.setTicketstatusList([]);
};


/**
 * repeated AttrItem TicketItem = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.getTicketitemList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetVerifyTicketListParamResp.prototype.setTicketitemList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.addTicketitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.clearTicketitemList = function() {
  this.setTicketitemList([]);
};


/**
 * map<int32, string> VerifyResultMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.getVerifyresultmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.clearVerifyresultmapMap = function() {
  this.getVerifyresultmapMap().clear();
};


/**
 * map<int32, string> InspectionResultMap = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.getInspectionresultmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.clearInspectionresultmapMap = function() {
  this.getInspectionresultmapMap().clear();
};


/**
 * optional string AppList = 6;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListParamResp.prototype.getApplist = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListParamResp.prototype.setApplist = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVerifyTicketListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVerifyTicketListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    createtimerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 9, ""),
    closetimerange: jspb.Message.getFieldWithDefault(msg, 10, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 11, ""),
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 13, ""),
    assignuid: jspb.Message.getFieldWithDefault(msg, 14, 0),
    isreloan: jspb.Message.getFieldWithDefault(msg, 15, 0),
    verifyresult: jspb.Message.getFieldWithDefault(msg, 16, 0),
    inspectionresult: jspb.Message.getFieldWithDefault(msg, 17, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 18, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVerifyTicketListReq}
 */
proto.xcommon.GetVerifyTicketListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVerifyTicketListReq;
  return proto.xcommon.GetVerifyTicketListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVerifyTicketListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVerifyTicketListReq}
 */
proto.xcommon.GetVerifyTicketListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosetimerange(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignuid(value);
      break;
    case 15:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsreloan(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVerifyresult(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInspectionresult(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVerifyTicketListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVerifyTicketListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getClosetimerange();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getVerifyresult();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getInspectionresult();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVerifyTicketListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVerifyTicketListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string CreateTimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setCreatetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string CompleteTimeRange = 9;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setCompletetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CloseTimeRange = 10;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getClosetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setClosetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string AssignTimeRange = 11;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setAssigntimerange = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string Status = 12;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string AssignName = 13;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 AssignUID = 14;
 * @return {number}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional Bool IsReloan = 15;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getIsreloan = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional int32 VerifyResult = 16;
 * @return {number}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getVerifyresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setVerifyresult = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 InspectionResult = 17;
 * @return {number}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getInspectionresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setInspectionresult = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string AppName = 18;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string Mobile = 19;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketListReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketListReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVerifyTicketListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVerifyTicketListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVerifyTicketListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVerifyTicketListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.VerifyTicketBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVerifyTicketListResp}
 */
proto.xcommon.GetVerifyTicketListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVerifyTicketListResp;
  return proto.xcommon.GetVerifyTicketListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVerifyTicketListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVerifyTicketListResp}
 */
proto.xcommon.GetVerifyTicketListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.VerifyTicketBackend;
      reader.readMessage(value,proto.xcommon.VerifyTicketBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVerifyTicketListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVerifyTicketListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVerifyTicketListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.VerifyTicketBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetVerifyTicketListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetVerifyTicketListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVerifyTicketListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyTicketListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetVerifyTicketListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetVerifyTicketListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVerifyTicketListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyTicketListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated VerifyTicketBackend List = 3;
 * @return {!Array<!proto.xcommon.VerifyTicketBackend>}
 */
proto.xcommon.GetVerifyTicketListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.VerifyTicketBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.VerifyTicketBackend, 3));
};


/** @param {!Array<!proto.xcommon.VerifyTicketBackend>} value */
proto.xcommon.GetVerifyTicketListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.VerifyTicketBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.VerifyTicketBackend}
 */
proto.xcommon.GetVerifyTicketListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.VerifyTicketBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetVerifyTicketListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVerifyTicketHandleTimeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVerifyTicketHandleTimeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVerifyTicketHandleTimeReq}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVerifyTicketHandleTimeReq;
  return proto.xcommon.GetVerifyTicketHandleTimeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVerifyTicketHandleTimeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVerifyTicketHandleTimeReq}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVerifyTicketHandleTimeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVerifyTicketHandleTimeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.xcommon.GetVerifyTicketHandleTimeReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVerifyTicketHandleTimeResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVerifyTicketHandleTimeResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    handletimesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVerifyTicketHandleTimeResp}
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVerifyTicketHandleTimeResp;
  return proto.xcommon.GetVerifyTicketHandleTimeResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVerifyTicketHandleTimeResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVerifyTicketHandleTimeResp}
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setHandletimesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVerifyTicketHandleTimeResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVerifyTicketHandleTimeResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getHandletimesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 HandleTimes = 3;
 * @return {!Array<number>}
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.getHandletimesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<number>} value */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.setHandletimesList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.addHandletimes = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetVerifyTicketHandleTimeResp.prototype.clearHandletimesList = function() {
  this.setHandletimesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketListParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketListParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketListParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketListParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketListParamReq}
 */
proto.xcommon.GetTicketListParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketListParamReq;
  return proto.xcommon.GetTicketListParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketListParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketListParamReq}
 */
proto.xcommon.GetTicketListParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketListParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketListParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketListParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketListParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketListParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketListParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketListParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketListParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketListParamResp.repeatedFields_ = [2,3,5,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketListParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketListParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketListParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketListParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    ticketstatusList: jspb.Message.toObjectList(msg.getTicketstatusList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    ticketitemList: jspb.Message.toObjectList(msg.getTicketitemList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    urgeresultmapMap: (f = msg.getUrgeresultmapMap()) ? f.toObject(includeInstance, undefined) : [],
    entrustcompanymapList: jspb.Message.toObjectList(msg.getEntrustcompanymapList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    notrepayreasonmapMap: (f = msg.getNotrepayreasonmapMap()) ? f.toObject(includeInstance, undefined) : [],
    tickettagmapMap: (f = msg.getTickettagmapMap()) ? f.toObject(includeInstance, undefined) : [],
    voipqiresultmapMap: (f = msg.getVoipqiresultmapMap()) ? f.toObject(includeInstance, undefined) : [],
    phonesaleitemList: jspb.Message.toObjectList(msg.getPhonesaleitemList(),
    proto.xcommon.PhoneSaleItem.toObject, includeInstance),
    prestatusmapMap: (f = msg.getPrestatusmapMap()) ? f.toObject(includeInstance, undefined) : [],
    robotcallintenttagmapMap: (f = msg.getRobotcallintenttagmapMap()) ? f.toObject(includeInstance, undefined) : [],
    applist: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketListParamResp}
 */
proto.xcommon.GetTicketListParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketListParamResp;
  return proto.xcommon.GetTicketListParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketListParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketListParamResp}
 */
proto.xcommon.GetTicketListParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketstatus(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketitem(value);
      break;
    case 4:
      var value = msg.getUrgeresultmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 5:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addEntrustcompanymap(value);
      break;
    case 6:
      var value = msg.getNotrepayreasonmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 7:
      var value = msg.getTickettagmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 8:
      var value = msg.getVoipqiresultmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 9:
      var value = new proto.xcommon.PhoneSaleItem;
      reader.readMessage(value,proto.xcommon.PhoneSaleItem.deserializeBinaryFromReader);
      msg.addPhonesaleitem(value);
      break;
    case 10:
      var value = msg.getPrestatusmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 11:
      var value = msg.getRobotcallintenttagmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketListParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketListParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketListParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketListParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTicketstatusList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getTicketitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getUrgeresultmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getEntrustcompanymapList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getNotrepayreasonmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getTickettagmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getVoipqiresultmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPhonesaleitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.xcommon.PhoneSaleItem.serializeBinaryToWriter
    );
  }
  f = message.getPrestatusmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRobotcallintenttagmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getApplist();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketListParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketListParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketListParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AttrItem TicketStatus = 2;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getTicketstatusList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 2));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetTicketListParamResp.prototype.setTicketstatusList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetTicketListParamResp.prototype.addTicketstatus = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearTicketstatusList = function() {
  this.setTicketstatusList([]);
};


/**
 * repeated AttrItem TicketItem = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getTicketitemList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetTicketListParamResp.prototype.setTicketitemList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetTicketListParamResp.prototype.addTicketitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearTicketitemList = function() {
  this.setTicketitemList([]);
};


/**
 * map<int32, string> UrgeResultMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getUrgeresultmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearUrgeresultmapMap = function() {
  this.getUrgeresultmapMap().clear();
};


/**
 * repeated AttrItem EntrustCompanyMap = 5;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getEntrustcompanymapList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 5));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetTicketListParamResp.prototype.setEntrustcompanymapList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetTicketListParamResp.prototype.addEntrustcompanymap = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearEntrustcompanymapList = function() {
  this.setEntrustcompanymapList([]);
};


/**
 * map<int32, string> NotRepayReasonMap = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getNotrepayreasonmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearNotrepayreasonmapMap = function() {
  this.getNotrepayreasonmapMap().clear();
};


/**
 * map<int32, string> TicketTagMap = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getTickettagmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearTickettagmapMap = function() {
  this.getTickettagmapMap().clear();
};


/**
 * map<int32, string> VoipQIResultMap = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getVoipqiresultmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearVoipqiresultmapMap = function() {
  this.getVoipqiresultmapMap().clear();
};


/**
 * repeated PhoneSaleItem PhoneSaleItem = 9;
 * @return {!Array<!proto.xcommon.PhoneSaleItem>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getPhonesaleitemList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneSaleItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PhoneSaleItem, 9));
};


/** @param {!Array<!proto.xcommon.PhoneSaleItem>} value */
proto.xcommon.GetTicketListParamResp.prototype.setPhonesaleitemList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.xcommon.PhoneSaleItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneSaleItem}
 */
proto.xcommon.GetTicketListParamResp.prototype.addPhonesaleitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.xcommon.PhoneSaleItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearPhonesaleitemList = function() {
  this.setPhonesaleitemList([]);
};


/**
 * map<int32, string> PreStatusMap = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getPrestatusmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearPrestatusmapMap = function() {
  this.getPrestatusmapMap().clear();
};


/**
 * map<int32, string> RobotCallIntentTagMap = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetTicketListParamResp.prototype.getRobotcallintenttagmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetTicketListParamResp.prototype.clearRobotcallintenttagmapMap = function() {
  this.getRobotcallintenttagmapMap().clear();
};


/**
 * optional string AppList = 12;
 * @return {string}
 */
proto.xcommon.GetTicketListParamResp.prototype.getApplist = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListParamResp.prototype.setApplist = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketListReq.repeatedFields_ = [19,23,26,28];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    caseid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    createtimerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 9, ""),
    closetimerange: jspb.Message.getFieldWithDefault(msg, 10, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 11, ""),
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 13, ""),
    assignuid: jspb.Message.getFieldWithDefault(msg, 14, 0),
    isreloan: jspb.Message.getFieldWithDefault(msg, 15, 0),
    urgeresult: jspb.Message.getFieldWithDefault(msg, 16, 0),
    isentrust: jspb.Message.getFieldWithDefault(msg, 17, 0),
    entrustcompany: jspb.Message.getFieldWithDefault(msg, 18, 0),
    roleidsList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    rolename: jspb.Message.getFieldWithDefault(msg, 20, ""),
    isroll: jspb.Message.getFieldWithDefault(msg, 21, 0),
    isstage: jspb.Message.getFieldWithDefault(msg, 22, 0),
    overduereasonList: (f = jspb.Message.getRepeatedField(msg, 23)) == null ? undefined : f,
    tickettag: jspb.Message.getFieldWithDefault(msg, 24, 0),
    overdueday: jspb.Message.getFieldWithDefault(msg, 25, ""),
    phonesaleitemList: jspb.Message.toObjectList(msg.getPhonesaleitemList(),
    proto.xcommon.PhoneSaleItem.toObject, includeInstance),
    isrobot: jspb.Message.getFieldWithDefault(msg, 27, 0),
    prestatusList: (f = jspb.Message.getRepeatedField(msg, 28)) == null ? undefined : f,
    tickettags: jspb.Message.getFieldWithDefault(msg, 29, ""),
    pretimerange: jspb.Message.getFieldWithDefault(msg, 30, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 31, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 32, ""),
    isnewticket: jspb.Message.getFieldWithDefault(msg, 33, 0),
    systype: jspb.Message.getFieldWithDefault(msg, 34, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketListReq}
 */
proto.xcommon.GetTicketListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketListReq;
  return proto.xcommon.GetTicketListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketListReq}
 */
proto.xcommon.GetTicketListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosetimerange(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignuid(value);
      break;
    case 15:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsreloan(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUrgeresult(value);
      break;
    case 17:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsentrust(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEntrustcompany(value);
      break;
    case 19:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setRoleidsList(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setRolename(value);
      break;
    case 21:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsroll(value);
      break;
    case 22:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsstage(value);
      break;
    case 23:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setOverduereasonList(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTickettag(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverdueday(value);
      break;
    case 26:
      var value = new proto.xcommon.PhoneSaleItem;
      reader.readMessage(value,proto.xcommon.PhoneSaleItem.deserializeBinaryFromReader);
      msg.addPhonesaleitem(value);
      break;
    case 27:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsrobot(value);
      break;
    case 28:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setPrestatusList(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setTickettags(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setPretimerange(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsnewticket(value);
      break;
    case 34:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getClosetimerange();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getUrgeresult();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getIsentrust();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getEntrustcompany();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getRoleidsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      19,
      f
    );
  }
  f = message.getRolename();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getIsroll();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getIsstage();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getOverduereasonList();
  if (f.length > 0) {
    writer.writePackedInt32(
      23,
      f
    );
  }
  f = message.getTickettag();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getOverdueday();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getPhonesaleitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      26,
      f,
      proto.xcommon.PhoneSaleItem.serializeBinaryToWriter
    );
  }
  f = message.getIsrobot();
  if (f !== 0.0) {
    writer.writeEnum(
      27,
      f
    );
  }
  f = message.getPrestatusList();
  if (f.length > 0) {
    writer.writePackedInt32(
      28,
      f
    );
  }
  f = message.getTickettags();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getPretimerange();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getIsnewticket();
  if (f !== 0) {
    writer.writeInt64(
      33,
      f
    );
  }
  f = message.getSystype();
  if (f !== 0.0) {
    writer.writeEnum(
      34,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetTicketListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetTicketListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetTicketListReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketListReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.GetTicketListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketListReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional int64 CustomerId = 6;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional int64 CaseId = 7;
 * @return {number}
 */
proto.xcommon.GetTicketListReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketListReq.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string CreateTimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setCreatetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string CompleteTimeRange = 9;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setCompletetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CloseTimeRange = 10;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getClosetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setClosetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string AssignTimeRange = 11;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setAssigntimerange = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string Status = 12;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string AssignName = 13;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 AssignUID = 14;
 * @return {number}
 */
proto.xcommon.GetTicketListReq.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketListReq.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional Bool IsReloan = 15;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetTicketListReq.prototype.getIsreloan = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.GetTicketListReq.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional int32 UrgeResult = 16;
 * @return {number}
 */
proto.xcommon.GetTicketListReq.prototype.getUrgeresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketListReq.prototype.setUrgeresult = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional Bool IsEntrust = 17;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetTicketListReq.prototype.getIsentrust = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.GetTicketListReq.prototype.setIsentrust = function(value) {
  jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional int32 EntrustCompany = 18;
 * @return {number}
 */
proto.xcommon.GetTicketListReq.prototype.getEntrustcompany = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketListReq.prototype.setEntrustcompany = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * repeated int64 RoleIDs = 19;
 * @return {!Array<number>}
 */
proto.xcommon.GetTicketListReq.prototype.getRoleidsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 19));
};


/** @param {!Array<number>} value */
proto.xcommon.GetTicketListReq.prototype.setRoleidsList = function(value) {
  jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetTicketListReq.prototype.addRoleids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListReq.prototype.clearRoleidsList = function() {
  this.setRoleidsList([]);
};


/**
 * optional string RoleName = 20;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getRolename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setRolename = function(value) {
  jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional Bool IsRoll = 21;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetTicketListReq.prototype.getIsroll = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.GetTicketListReq.prototype.setIsroll = function(value) {
  jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional Bool IsStage = 22;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetTicketListReq.prototype.getIsstage = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.GetTicketListReq.prototype.setIsstage = function(value) {
  jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * repeated int32 OverdueReason = 23;
 * @return {!Array<number>}
 */
proto.xcommon.GetTicketListReq.prototype.getOverduereasonList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 23));
};


/** @param {!Array<number>} value */
proto.xcommon.GetTicketListReq.prototype.setOverduereasonList = function(value) {
  jspb.Message.setField(this, 23, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetTicketListReq.prototype.addOverduereason = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 23, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListReq.prototype.clearOverduereasonList = function() {
  this.setOverduereasonList([]);
};


/**
 * optional int32 TicketTag = 24;
 * @return {number}
 */
proto.xcommon.GetTicketListReq.prototype.getTickettag = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketListReq.prototype.setTickettag = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional string OverdueDay = 25;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getOverdueday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setOverdueday = function(value) {
  jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * repeated PhoneSaleItem PhoneSaleItem = 26;
 * @return {!Array<!proto.xcommon.PhoneSaleItem>}
 */
proto.xcommon.GetTicketListReq.prototype.getPhonesaleitemList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneSaleItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PhoneSaleItem, 26));
};


/** @param {!Array<!proto.xcommon.PhoneSaleItem>} value */
proto.xcommon.GetTicketListReq.prototype.setPhonesaleitemList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 26, value);
};


/**
 * @param {!proto.xcommon.PhoneSaleItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneSaleItem}
 */
proto.xcommon.GetTicketListReq.prototype.addPhonesaleitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.xcommon.PhoneSaleItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListReq.prototype.clearPhonesaleitemList = function() {
  this.setPhonesaleitemList([]);
};


/**
 * optional Bool IsRobot = 27;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetTicketListReq.prototype.getIsrobot = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.GetTicketListReq.prototype.setIsrobot = function(value) {
  jspb.Message.setProto3EnumField(this, 27, value);
};


/**
 * repeated int32 PreStatus = 28;
 * @return {!Array<number>}
 */
proto.xcommon.GetTicketListReq.prototype.getPrestatusList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 28));
};


/** @param {!Array<number>} value */
proto.xcommon.GetTicketListReq.prototype.setPrestatusList = function(value) {
  jspb.Message.setField(this, 28, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetTicketListReq.prototype.addPrestatus = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 28, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListReq.prototype.clearPrestatusList = function() {
  this.setPrestatusList([]);
};


/**
 * optional string TicketTags = 29;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getTickettags = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setTickettags = function(value) {
  jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string PreTimeRange = 30;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getPretimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setPretimerange = function(value) {
  jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string AppName = 31;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string Mobile = 32;
 * @return {string}
 */
proto.xcommon.GetTicketListReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketListReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional int64 IsNewTicket = 33;
 * @return {number}
 */
proto.xcommon.GetTicketListReq.prototype.getIsnewticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketListReq.prototype.setIsnewticket = function(value) {
  jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional MPSystemType SysType = 34;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.GetTicketListReq.prototype.getSystype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/** @param {!proto.xcommon.MPSystemType} value */
proto.xcommon.GetTicketListReq.prototype.setSystype = function(value) {
  jspb.Message.setProto3EnumField(this, 34, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.TicketBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketListResp}
 */
proto.xcommon.GetTicketListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketListResp;
  return proto.xcommon.GetTicketListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketListResp}
 */
proto.xcommon.GetTicketListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketBackend;
      reader.readMessage(value,proto.xcommon.TicketBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.TicketBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated TicketBackend List = 3;
 * @return {!Array<!proto.xcommon.TicketBackend>}
 */
proto.xcommon.GetTicketListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.TicketBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketBackend, 3));
};


/** @param {!Array<!proto.xcommon.TicketBackend>} value */
proto.xcommon.GetTicketListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.TicketBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketBackend}
 */
proto.xcommon.GetTicketListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.TicketBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketListResp.prototype.clearListList = function() {
  this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketGroupByCountReq.repeatedFields_ = [1,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketGroupByCountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketGroupByCountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketGroupByCountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemidList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assignnameList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    assignuidList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    usergroupList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    ishour: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketGroupByCountReq}
 */
proto.xcommon.GetTicketGroupByCountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketGroupByCountReq;
  return proto.xcommon.GetTicketGroupByCountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketGroupByCountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketGroupByCountReq}
 */
proto.xcommon.GetTicketGroupByCountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setItemidList(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssignname(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setAssignuidList(value);
      break;
    case 5:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setUsergroupList(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIshour(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketGroupByCountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketGroupByCountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketGroupByCountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemidList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssignnameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getAssignuidList();
  if (f.length > 0) {
    writer.writePackedInt64(
      4,
      f
    );
  }
  f = message.getUsergroupList();
  if (f.length > 0) {
    writer.writePackedInt64(
      5,
      f
    );
  }
  f = message.getIshour();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * repeated int64 ItemId = 1;
 * @return {!Array<number>}
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.getItemidList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.xcommon.GetTicketGroupByCountReq.prototype.setItemidList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.addItemid = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.clearItemidList = function() {
  this.setItemidList([]);
};


/**
 * optional string AssignTimeRange = 2;
 * @return {string}
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketGroupByCountReq.prototype.setAssigntimerange = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string AssignName = 3;
 * @return {!Array<string>}
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.getAssignnameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.GetTicketGroupByCountReq.prototype.setAssignnameList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.addAssignname = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.clearAssignnameList = function() {
  this.setAssignnameList([]);
};


/**
 * repeated int64 AssignUID = 4;
 * @return {!Array<number>}
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.getAssignuidList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<number>} value */
proto.xcommon.GetTicketGroupByCountReq.prototype.setAssignuidList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.addAssignuid = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.clearAssignuidList = function() {
  this.setAssignuidList([]);
};


/**
 * repeated int64 UserGroup = 5;
 * @return {!Array<number>}
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.getUsergroupList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/** @param {!Array<number>} value */
proto.xcommon.GetTicketGroupByCountReq.prototype.setUsergroupList = function(value) {
  jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.addUsergroup = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.clearUsergroupList = function() {
  this.setUsergroupList([]);
};


/**
 * optional bool IsHour = 6;
 * @return {boolean}
 */
proto.xcommon.GetTicketGroupByCountReq.prototype.getIshour = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.xcommon.GetTicketGroupByCountReq.prototype.setIshour = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketGroupByCount.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketGroupByCount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketGroupByCount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketGroupByCount.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    assignuid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usergroup: jspb.Message.getFieldWithDefault(msg, 4, 0),
    count: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketGroupByCount}
 */
proto.xcommon.TicketGroupByCount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketGroupByCount;
  return proto.xcommon.TicketGroupByCount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketGroupByCount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketGroupByCount}
 */
proto.xcommon.TicketGroupByCount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroup(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketGroupByCount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketGroupByCount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketGroupByCount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketGroupByCount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUsergroup();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string Date = 1;
 * @return {string}
 */
proto.xcommon.TicketGroupByCount.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.TicketGroupByCount.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 AssignUID = 2;
 * @return {number}
 */
proto.xcommon.TicketGroupByCount.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.TicketGroupByCount.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 ItemId = 3;
 * @return {number}
 */
proto.xcommon.TicketGroupByCount.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.TicketGroupByCount.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 UserGroup = 4;
 * @return {number}
 */
proto.xcommon.TicketGroupByCount.prototype.getUsergroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.TicketGroupByCount.prototype.setUsergroup = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 Count = 5;
 * @return {number}
 */
proto.xcommon.TicketGroupByCount.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.TicketGroupByCount.prototype.setCount = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketGroupByCountResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketGroupByCountResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketGroupByCountResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketGroupByCountResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketGroupByCountResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.TicketGroupByCount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketGroupByCountResp}
 */
proto.xcommon.GetTicketGroupByCountResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketGroupByCountResp;
  return proto.xcommon.GetTicketGroupByCountResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketGroupByCountResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketGroupByCountResp}
 */
proto.xcommon.GetTicketGroupByCountResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.xcommon.TicketGroupByCount;
      reader.readMessage(value,proto.xcommon.TicketGroupByCount.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketGroupByCountResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketGroupByCountResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketGroupByCountResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketGroupByCountResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.TicketGroupByCount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TicketGroupByCount List = 3;
 * @return {!Array<!proto.xcommon.TicketGroupByCount>}
 */
proto.xcommon.GetTicketGroupByCountResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.TicketGroupByCount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketGroupByCount, 3));
};


/** @param {!Array<!proto.xcommon.TicketGroupByCount>} value */
proto.xcommon.GetTicketGroupByCountResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.TicketGroupByCount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketGroupByCount}
 */
proto.xcommon.GetTicketGroupByCountResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.TicketGroupByCount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketGroupByCountResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketLogReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketLogReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketLogReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketLogReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketLogReq}
 */
proto.xcommon.GetTicketLogReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketLogReq;
  return proto.xcommon.GetTicketLogReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketLogReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketLogReq}
 */
proto.xcommon.GetTicketLogReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketLogReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketLogReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketLogReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketLogReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketLogReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketLogReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketLogReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketLogReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetTicketLogReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetTicketLogReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketLogReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketLogReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetTicketLogReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketLogReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.GetTicketLogReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketLogReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketLogResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketLogResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketLogResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketLogResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketLogResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.TicketLogBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketLogResp}
 */
proto.xcommon.GetTicketLogResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketLogResp;
  return proto.xcommon.GetTicketLogResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketLogResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketLogResp}
 */
proto.xcommon.GetTicketLogResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketLogBackend;
      reader.readMessage(value,proto.xcommon.TicketLogBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketLogResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketLogResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketLogResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketLogResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.TicketLogBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketLogResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketLogResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketLogResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketLogResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketLogResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketLogResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketLogResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketLogResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated TicketLogBackend List = 3;
 * @return {!Array<!proto.xcommon.TicketLogBackend>}
 */
proto.xcommon.GetTicketLogResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.TicketLogBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketLogBackend, 3));
};


/** @param {!Array<!proto.xcommon.TicketLogBackend>} value */
proto.xcommon.GetTicketLogResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.TicketLogBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketLogBackend}
 */
proto.xcommon.GetTicketLogResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.TicketLogBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketLogResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketLogBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketLogBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketLogBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketLogBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    operate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    opuser: jspb.Message.getFieldWithDefault(msg, 3, ""),
    optime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    relateduser: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketLogBackend}
 */
proto.xcommon.TicketLogBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketLogBackend;
  return proto.xcommon.TicketLogBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketLogBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketLogBackend}
 */
proto.xcommon.TicketLogBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpuser(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelateduser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketLogBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketLogBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketLogBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketLogBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOpuser();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOptime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getRelateduser();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string Operate = 2;
 * @return {string}
 */
proto.xcommon.TicketLogBackend.prototype.getOperate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.TicketLogBackend.prototype.setOperate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string OpUser = 3;
 * @return {string}
 */
proto.xcommon.TicketLogBackend.prototype.getOpuser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.TicketLogBackend.prototype.setOpuser = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 OpTime = 4;
 * @return {number}
 */
proto.xcommon.TicketLogBackend.prototype.getOptime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.TicketLogBackend.prototype.setOptime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string RelatedUser = 5;
 * @return {string}
 */
proto.xcommon.TicketLogBackend.prototype.getRelateduser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.TicketLogBackend.prototype.setRelateduser = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchAssignTicketReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchAssignTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchAssignTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchAssignTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchAssignTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    assignuid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchAssignTicketReq}
 */
proto.xcommon.BatchAssignTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchAssignTicketReq;
  return proto.xcommon.BatchAssignTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchAssignTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchAssignTicketReq}
 */
proto.xcommon.BatchAssignTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setTicketidsList(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchAssignTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchAssignTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchAssignTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchAssignTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketidsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.BatchAssignTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.BatchAssignTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.BatchAssignTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchAssignTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 TicketIds = 2;
 * @return {!Array<string>}
 */
proto.xcommon.BatchAssignTicketReq.prototype.getTicketidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.BatchAssignTicketReq.prototype.setTicketidsList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.BatchAssignTicketReq.prototype.addTicketids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.BatchAssignTicketReq.prototype.clearTicketidsList = function() {
  this.setTicketidsList([]);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.BatchAssignTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.BatchAssignTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 AssignUid = 4;
 * @return {number}
 */
proto.xcommon.BatchAssignTicketReq.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.BatchAssignTicketReq.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchAssignTicketResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchAssignTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchAssignTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchAssignTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchAssignTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    successnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    erroridsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchAssignTicketResp}
 */
proto.xcommon.BatchAssignTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchAssignTicketResp;
  return proto.xcommon.BatchAssignTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchAssignTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchAssignTicketResp}
 */
proto.xcommon.BatchAssignTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuccessnum(value);
      break;
    case 3:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setErroridsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchAssignTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchAssignTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchAssignTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchAssignTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSuccessnum();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getErroridsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.BatchAssignTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.BatchAssignTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.BatchAssignTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchAssignTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 SuccessNum = 2;
 * @return {number}
 */
proto.xcommon.BatchAssignTicketResp.prototype.getSuccessnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.BatchAssignTicketResp.prototype.setSuccessnum = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int64 ErrorIds = 3;
 * @return {!Array<string>}
 */
proto.xcommon.BatchAssignTicketResp.prototype.getErroridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.BatchAssignTicketResp.prototype.setErroridsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.BatchAssignTicketResp.prototype.addErrorids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.BatchAssignTicketResp.prototype.clearErroridsList = function() {
  this.setErroridsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchRecycleTicketReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchRecycleTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchRecycleTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchRecycleTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchRecycleTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchRecycleTicketReq}
 */
proto.xcommon.BatchRecycleTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchRecycleTicketReq;
  return proto.xcommon.BatchRecycleTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchRecycleTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchRecycleTicketReq}
 */
proto.xcommon.BatchRecycleTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setTicketidsList(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchRecycleTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchRecycleTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchRecycleTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchRecycleTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketidsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.BatchRecycleTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.BatchRecycleTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.BatchRecycleTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchRecycleTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 TicketIds = 2;
 * @return {!Array<string>}
 */
proto.xcommon.BatchRecycleTicketReq.prototype.getTicketidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.BatchRecycleTicketReq.prototype.setTicketidsList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.BatchRecycleTicketReq.prototype.addTicketids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.BatchRecycleTicketReq.prototype.clearTicketidsList = function() {
  this.setTicketidsList([]);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.BatchRecycleTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.BatchRecycleTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchRecycleTicketResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchRecycleTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchRecycleTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchRecycleTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchRecycleTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    successnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    erroridsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchRecycleTicketResp}
 */
proto.xcommon.BatchRecycleTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchRecycleTicketResp;
  return proto.xcommon.BatchRecycleTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchRecycleTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchRecycleTicketResp}
 */
proto.xcommon.BatchRecycleTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuccessnum(value);
      break;
    case 3:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setErroridsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchRecycleTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchRecycleTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchRecycleTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchRecycleTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSuccessnum();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getErroridsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.BatchRecycleTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.BatchRecycleTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.BatchRecycleTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchRecycleTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 SuccessNum = 2;
 * @return {number}
 */
proto.xcommon.BatchRecycleTicketResp.prototype.getSuccessnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.BatchRecycleTicketResp.prototype.setSuccessnum = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int64 ErrorIds = 3;
 * @return {!Array<string>}
 */
proto.xcommon.BatchRecycleTicketResp.prototype.getErroridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.BatchRecycleTicketResp.prototype.setErroridsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.BatchRecycleTicketResp.prototype.addErrorids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.BatchRecycleTicketResp.prototype.clearErroridsList = function() {
  this.setErroridsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchEntrustTicketReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchEntrustTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchEntrustTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchEntrustTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchEntrustTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    entrustcompany: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchEntrustTicketReq}
 */
proto.xcommon.BatchEntrustTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchEntrustTicketReq;
  return proto.xcommon.BatchEntrustTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchEntrustTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchEntrustTicketReq}
 */
proto.xcommon.BatchEntrustTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setTicketidsList(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEntrustcompany(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchEntrustTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchEntrustTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchEntrustTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchEntrustTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketidsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getEntrustcompany();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.BatchEntrustTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.BatchEntrustTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.BatchEntrustTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchEntrustTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 TicketIds = 2;
 * @return {!Array<string>}
 */
proto.xcommon.BatchEntrustTicketReq.prototype.getTicketidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.BatchEntrustTicketReq.prototype.setTicketidsList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.BatchEntrustTicketReq.prototype.addTicketids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.BatchEntrustTicketReq.prototype.clearTicketidsList = function() {
  this.setTicketidsList([]);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.BatchEntrustTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.BatchEntrustTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 EntrustCompany = 4;
 * @return {number}
 */
proto.xcommon.BatchEntrustTicketReq.prototype.getEntrustcompany = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.BatchEntrustTicketReq.prototype.setEntrustcompany = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchEntrustTicketResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchEntrustTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchEntrustTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchEntrustTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchEntrustTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    successnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    erroridsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchEntrustTicketResp}
 */
proto.xcommon.BatchEntrustTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchEntrustTicketResp;
  return proto.xcommon.BatchEntrustTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchEntrustTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchEntrustTicketResp}
 */
proto.xcommon.BatchEntrustTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuccessnum(value);
      break;
    case 3:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setErroridsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchEntrustTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchEntrustTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchEntrustTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchEntrustTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSuccessnum();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getErroridsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.BatchEntrustTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.BatchEntrustTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.BatchEntrustTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchEntrustTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 SuccessNum = 2;
 * @return {number}
 */
proto.xcommon.BatchEntrustTicketResp.prototype.getSuccessnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.BatchEntrustTicketResp.prototype.setSuccessnum = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int64 ErrorIds = 3;
 * @return {!Array<string>}
 */
proto.xcommon.BatchEntrustTicketResp.prototype.getErroridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.BatchEntrustTicketResp.prototype.setErroridsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.BatchEntrustTicketResp.prototype.addErrorids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.BatchEntrustTicketResp.prototype.clearErroridsList = function() {
  this.setErroridsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchRecallTicketReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchRecallTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchRecallTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchRecallTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchRecallTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchRecallTicketReq}
 */
proto.xcommon.BatchRecallTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchRecallTicketReq;
  return proto.xcommon.BatchRecallTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchRecallTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchRecallTicketReq}
 */
proto.xcommon.BatchRecallTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setTicketidsList(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchRecallTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchRecallTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchRecallTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchRecallTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketidsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.BatchRecallTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.BatchRecallTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.BatchRecallTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchRecallTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 TicketIds = 2;
 * @return {!Array<string>}
 */
proto.xcommon.BatchRecallTicketReq.prototype.getTicketidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.BatchRecallTicketReq.prototype.setTicketidsList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.BatchRecallTicketReq.prototype.addTicketids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.BatchRecallTicketReq.prototype.clearTicketidsList = function() {
  this.setTicketidsList([]);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.BatchRecallTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.BatchRecallTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.BatchRecallTicketResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.BatchRecallTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.BatchRecallTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.BatchRecallTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchRecallTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    successnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    erroridsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.BatchRecallTicketResp}
 */
proto.xcommon.BatchRecallTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.BatchRecallTicketResp;
  return proto.xcommon.BatchRecallTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.BatchRecallTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.BatchRecallTicketResp}
 */
proto.xcommon.BatchRecallTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuccessnum(value);
      break;
    case 3:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setErroridsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.BatchRecallTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.BatchRecallTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.BatchRecallTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.BatchRecallTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSuccessnum();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getErroridsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.BatchRecallTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.BatchRecallTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.BatchRecallTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.BatchRecallTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 SuccessNum = 2;
 * @return {number}
 */
proto.xcommon.BatchRecallTicketResp.prototype.getSuccessnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.BatchRecallTicketResp.prototype.setSuccessnum = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int64 ErrorIds = 3;
 * @return {!Array<string>}
 */
proto.xcommon.BatchRecallTicketResp.prototype.getErroridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.BatchRecallTicketResp.prototype.setErroridsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.BatchRecallTicketResp.prototype.addErrorids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.BatchRecallTicketResp.prototype.clearErroridsList = function() {
  this.setErroridsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceTicketReq}
 */
proto.xcommon.ReduceTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceTicketReq;
  return proto.xcommon.ReduceTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceTicketReq}
 */
proto.xcommon.ReduceTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ReduceTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ReduceTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ReduceTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReduceTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.ReduceTicketReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.ReduceTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.ReduceTicketReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.ReduceTicketReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.ReduceTicketReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ReduceTicketReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ReduceTicketResp.repeatedFields_ = [14,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    amountpayed: jspb.Message.getFieldWithDefault(msg, 3, 0),
    amountreduced: jspb.Message.getFieldWithDefault(msg, 4, 0),
    shouldrepaydate: jspb.Message.getFieldWithDefault(msg, 11, 0),
    actuallyrepaydate: jspb.Message.getFieldWithDefault(msg, 12, 0),
    latestreducedate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    detailList: jspb.Message.toObjectList(msg.getDetailList(),
    xcommon_core_pb.ReducePenaltyBillDetail.toObject, includeInstance),
    fieldsList: jspb.Message.toObjectList(msg.getFieldsList(),
    xcommon_core_pb.ReducePenaltyFieldDetail.toObject, includeInstance),
    showlefttotaltips: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    lefttotalstaff: jspb.Message.getFieldWithDefault(msg, 17, 0),
    lefttotalgroup: jspb.Message.getFieldWithDefault(msg, 18, 0),
    leftamounttotalstaff: jspb.Message.getFieldWithDefault(msg, 19, 0),
    leftamounttotalgroup: jspb.Message.getFieldWithDefault(msg, 20, 0),
    amountremained: jspb.Message.getFieldWithDefault(msg, 21, 0),
    principal: (f = msg.getPrincipal()) && xcommon_core_pb.ReducePenaltyBillDetail.toObject(includeInstance, f),
    showleftpercenttips: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    showleftapplyamounttips: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    leftapplyamount: jspb.Message.getFieldWithDefault(msg, 25, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceTicketResp}
 */
proto.xcommon.ReduceTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceTicketResp;
  return proto.xcommon.ReduceTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceTicketResp}
 */
proto.xcommon.ReduceTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountpayed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountreduced(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setShouldrepaydate(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActuallyrepaydate(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLatestreducedate(value);
      break;
    case 14:
      var value = new xcommon_core_pb.ReducePenaltyBillDetail;
      reader.readMessage(value,xcommon_core_pb.ReducePenaltyBillDetail.deserializeBinaryFromReader);
      msg.addDetail(value);
      break;
    case 15:
      var value = new xcommon_core_pb.ReducePenaltyFieldDetail;
      reader.readMessage(value,xcommon_core_pb.ReducePenaltyFieldDetail.deserializeBinaryFromReader);
      msg.addFields(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowlefttotaltips(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLefttotalstaff(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLefttotalgroup(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeftamounttotalstaff(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeftamounttotalgroup(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountremained(value);
      break;
    case 22:
      var value = new xcommon_core_pb.ReducePenaltyBillDetail;
      reader.readMessage(value,xcommon_core_pb.ReducePenaltyBillDetail.deserializeBinaryFromReader);
      msg.setPrincipal(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowleftpercenttips(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowleftapplyamounttips(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftapplyamount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAmountpayed();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAmountreduced();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getShouldrepaydate();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getActuallyrepaydate();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getLatestreducedate();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getDetailList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      xcommon_core_pb.ReducePenaltyBillDetail.serializeBinaryToWriter
    );
  }
  f = message.getFieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      xcommon_core_pb.ReducePenaltyFieldDetail.serializeBinaryToWriter
    );
  }
  f = message.getShowlefttotaltips();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getLefttotalstaff();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getLefttotalgroup();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getLeftamounttotalstaff();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getLeftamounttotalgroup();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getAmountremained();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getPrincipal();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      xcommon_core_pb.ReducePenaltyBillDetail.serializeBinaryToWriter
    );
  }
  f = message.getShowleftpercenttips();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getShowleftapplyamounttips();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getLeftapplyamount();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ReduceTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ReduceTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ReduceTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReduceTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Amount = 2;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AmountPayed = 3;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getAmountpayed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setAmountpayed = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 AmountReduced = 4;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getAmountreduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setAmountreduced = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 ShouldRepayDate = 11;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getShouldrepaydate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setShouldrepaydate = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 ActuallyRepayDate = 12;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getActuallyrepaydate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setActuallyrepaydate = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 LatestReduceDate = 13;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getLatestreducedate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setLatestreducedate = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * repeated ReducePenaltyBillDetail Detail = 14;
 * @return {!Array<!proto.xcommon.ReducePenaltyBillDetail>}
 */
proto.xcommon.ReduceTicketResp.prototype.getDetailList = function() {
  return /** @type{!Array<!proto.xcommon.ReducePenaltyBillDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.ReducePenaltyBillDetail, 14));
};


/** @param {!Array<!proto.xcommon.ReducePenaltyBillDetail>} value */
proto.xcommon.ReduceTicketResp.prototype.setDetailList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.xcommon.ReducePenaltyBillDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ReducePenaltyBillDetail}
 */
proto.xcommon.ReduceTicketResp.prototype.addDetail = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.xcommon.ReducePenaltyBillDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ReduceTicketResp.prototype.clearDetailList = function() {
  this.setDetailList([]);
};


/**
 * repeated ReducePenaltyFieldDetail Fields = 15;
 * @return {!Array<!proto.xcommon.ReducePenaltyFieldDetail>}
 */
proto.xcommon.ReduceTicketResp.prototype.getFieldsList = function() {
  return /** @type{!Array<!proto.xcommon.ReducePenaltyFieldDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.ReducePenaltyFieldDetail, 15));
};


/** @param {!Array<!proto.xcommon.ReducePenaltyFieldDetail>} value */
proto.xcommon.ReduceTicketResp.prototype.setFieldsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.xcommon.ReducePenaltyFieldDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ReducePenaltyFieldDetail}
 */
proto.xcommon.ReduceTicketResp.prototype.addFields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.xcommon.ReducePenaltyFieldDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ReduceTicketResp.prototype.clearFieldsList = function() {
  this.setFieldsList([]);
};


/**
 * optional bool ShowLeftTotalTips = 16;
 * @return {boolean}
 */
proto.xcommon.ReduceTicketResp.prototype.getShowlefttotaltips = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/** @param {boolean} value */
proto.xcommon.ReduceTicketResp.prototype.setShowlefttotaltips = function(value) {
  jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional int32 LeftTotalStaff = 17;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getLefttotalstaff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setLefttotalstaff = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 LeftTotalGroup = 18;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getLefttotalgroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setLefttotalgroup = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 LeftAmountTotalStaff = 19;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getLeftamounttotalstaff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setLeftamounttotalstaff = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 LeftAmountTotalGroup = 20;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getLeftamounttotalgroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setLeftamounttotalgroup = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 AmountRemained = 21;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getAmountremained = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setAmountremained = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional ReducePenaltyBillDetail Principal = 22;
 * @return {?proto.xcommon.ReducePenaltyBillDetail}
 */
proto.xcommon.ReduceTicketResp.prototype.getPrincipal = function() {
  return /** @type{?proto.xcommon.ReducePenaltyBillDetail} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.ReducePenaltyBillDetail, 22));
};


/** @param {?proto.xcommon.ReducePenaltyBillDetail|undefined} value */
proto.xcommon.ReduceTicketResp.prototype.setPrincipal = function(value) {
  jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ReduceTicketResp.prototype.clearPrincipal = function() {
  this.setPrincipal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReduceTicketResp.prototype.hasPrincipal = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool ShowLeftPercentTips = 23;
 * @return {boolean}
 */
proto.xcommon.ReduceTicketResp.prototype.getShowleftpercenttips = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/** @param {boolean} value */
proto.xcommon.ReduceTicketResp.prototype.setShowleftpercenttips = function(value) {
  jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool ShowLeftApplyAmountTips = 24;
 * @return {boolean}
 */
proto.xcommon.ReduceTicketResp.prototype.getShowleftapplyamounttips = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/** @param {boolean} value */
proto.xcommon.ReduceTicketResp.prototype.setShowleftapplyamounttips = function(value) {
  jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional int64 LeftApplyAmount = 25;
 * @return {number}
 */
proto.xcommon.ReduceTicketResp.prototype.getLeftapplyamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.xcommon.ReduceTicketResp.prototype.setLeftapplyamount = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DoReducePrincipalReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DoReducePrincipalReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DoReducePrincipalReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DoReducePrincipalReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    reductionamount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 7, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 8, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DoReducePrincipalReq}
 */
proto.xcommon.DoReducePrincipalReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DoReducePrincipalReq;
  return proto.xcommon.DoReducePrincipalReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DoReducePrincipalReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DoReducePrincipalReq}
 */
proto.xcommon.DoReducePrincipalReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReductionamount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DoReducePrincipalReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DoReducePrincipalReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DoReducePrincipalReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DoReducePrincipalReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getReductionamount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      8,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DoReducePrincipalReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DoReducePrincipalReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DoReducePrincipalReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DoReducePrincipalReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.DoReducePrincipalReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DoReducePrincipalReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.DoReducePrincipalReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.DoReducePrincipalReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 ReductionAmount = 4;
 * @return {number}
 */
proto.xcommon.DoReducePrincipalReq.prototype.getReductionamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.DoReducePrincipalReq.prototype.setReductionamount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string Reason = 7;
 * @return {string}
 */
proto.xcommon.DoReducePrincipalReq.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.DoReducePrincipalReq.prototype.setReason = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 OrderId = 8;
 * @return {string}
 */
proto.xcommon.DoReducePrincipalReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/** @param {string} value */
proto.xcommon.DoReducePrincipalReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DoReducePrincipalResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DoReducePrincipalResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DoReducePrincipalResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DoReducePrincipalResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DoReducePrincipalResp}
 */
proto.xcommon.DoReducePrincipalResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DoReducePrincipalResp;
  return proto.xcommon.DoReducePrincipalResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DoReducePrincipalResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DoReducePrincipalResp}
 */
proto.xcommon.DoReducePrincipalResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DoReducePrincipalResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DoReducePrincipalResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DoReducePrincipalResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DoReducePrincipalResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DoReducePrincipalResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DoReducePrincipalResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DoReducePrincipalResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DoReducePrincipalResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.DoReduceOtherReq.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DoReduceOtherReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DoReduceOtherReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DoReduceOtherReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DoReduceOtherReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 7, ""),
    reductionfieldsList: jspb.Message.toObjectList(msg.getReductionfieldsList(),
    xcommon_core_pb.ApplyReducePenaltyFieldDetail.toObject, includeInstance),
    orderid: jspb.Message.getFieldWithDefault(msg, 9, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DoReduceOtherReq}
 */
proto.xcommon.DoReduceOtherReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DoReduceOtherReq;
  return proto.xcommon.DoReduceOtherReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DoReduceOtherReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DoReduceOtherReq}
 */
proto.xcommon.DoReduceOtherReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 8:
      var value = new xcommon_core_pb.ApplyReducePenaltyFieldDetail;
      reader.readMessage(value,xcommon_core_pb.ApplyReducePenaltyFieldDetail.deserializeBinaryFromReader);
      msg.addReductionfields(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DoReduceOtherReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DoReduceOtherReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DoReduceOtherReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DoReduceOtherReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getReductionfieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      xcommon_core_pb.ApplyReducePenaltyFieldDetail.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      9,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DoReduceOtherReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DoReduceOtherReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DoReduceOtherReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DoReduceOtherReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.DoReduceOtherReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DoReduceOtherReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.DoReduceOtherReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.DoReduceOtherReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Reason = 7;
 * @return {string}
 */
proto.xcommon.DoReduceOtherReq.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.DoReduceOtherReq.prototype.setReason = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated ApplyReducePenaltyFieldDetail ReductionFields = 8;
 * @return {!Array<!proto.xcommon.ApplyReducePenaltyFieldDetail>}
 */
proto.xcommon.DoReduceOtherReq.prototype.getReductionfieldsList = function() {
  return /** @type{!Array<!proto.xcommon.ApplyReducePenaltyFieldDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.ApplyReducePenaltyFieldDetail, 8));
};


/** @param {!Array<!proto.xcommon.ApplyReducePenaltyFieldDetail>} value */
proto.xcommon.DoReduceOtherReq.prototype.setReductionfieldsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.xcommon.ApplyReducePenaltyFieldDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ApplyReducePenaltyFieldDetail}
 */
proto.xcommon.DoReduceOtherReq.prototype.addReductionfields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.xcommon.ApplyReducePenaltyFieldDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.DoReduceOtherReq.prototype.clearReductionfieldsList = function() {
  this.setReductionfieldsList([]);
};


/**
 * optional int64 OrderId = 9;
 * @return {string}
 */
proto.xcommon.DoReduceOtherReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/** @param {string} value */
proto.xcommon.DoReduceOtherReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DoReduceOtherResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DoReduceOtherResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DoReduceOtherResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DoReduceOtherResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DoReduceOtherResp}
 */
proto.xcommon.DoReduceOtherResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DoReduceOtherResp;
  return proto.xcommon.DoReduceOtherResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DoReduceOtherResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DoReduceOtherResp}
 */
proto.xcommon.DoReduceOtherResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DoReduceOtherResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DoReduceOtherResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DoReduceOtherResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DoReduceOtherResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DoReduceOtherResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DoReduceOtherResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DoReduceOtherResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DoReduceOtherResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollApplyTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollApplyTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollApplyTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollApplyTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollApplyTicketReq}
 */
proto.xcommon.RollApplyTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollApplyTicketReq;
  return proto.xcommon.RollApplyTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollApplyTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollApplyTicketReq}
 */
proto.xcommon.RollApplyTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollApplyTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollApplyTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollApplyTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollApplyTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.RollApplyTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.RollApplyTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollApplyTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollApplyTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.RollApplyTicketReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.RollApplyTicketReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.RollApplyTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.RollApplyTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.RollApplyTicketReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.RollApplyTicketReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollApplyTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollApplyTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollApplyTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollApplyTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollApplyTicketResp}
 */
proto.xcommon.RollApplyTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollApplyTicketResp;
  return proto.xcommon.RollApplyTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollApplyTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollApplyTicketResp}
 */
proto.xcommon.RollApplyTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollApplyTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollApplyTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollApplyTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollApplyTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.RollApplyTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.RollApplyTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollApplyTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollApplyTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssignTicketTrialCalcReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssignTicketTrialCalcReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssignTicketTrialCalcReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignTicketTrialCalcReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ruleid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timerange: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssignTicketTrialCalcReq}
 */
proto.xcommon.AssignTicketTrialCalcReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssignTicketTrialCalcReq;
  return proto.xcommon.AssignTicketTrialCalcReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssignTicketTrialCalcReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssignTicketTrialCalcReq}
 */
proto.xcommon.AssignTicketTrialCalcReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRuleid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssignTicketTrialCalcReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssignTicketTrialCalcReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssignTicketTrialCalcReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignTicketTrialCalcReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getRuleid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.AssignTicketTrialCalcReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.AssignTicketTrialCalcReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AssignTicketTrialCalcReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignTicketTrialCalcReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 RuleID = 2;
 * @return {number}
 */
proto.xcommon.AssignTicketTrialCalcReq.prototype.getRuleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.AssignTicketTrialCalcReq.prototype.setRuleid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string TimeRange = 3;
 * @return {string}
 */
proto.xcommon.AssignTicketTrialCalcReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AssignTicketTrialCalcReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AssignTicketTrialCalcResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssignTicketTrialCalcResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssignTicketTrialCalcResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignTicketTrialCalcResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    detailList: jspb.Message.toObjectList(msg.getDetailList(),
    proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 3, 0),
    remain: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssignTicketTrialCalcResp}
 */
proto.xcommon.AssignTicketTrialCalcResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssignTicketTrialCalcResp;
  return proto.xcommon.AssignTicketTrialCalcResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssignTicketTrialCalcResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssignTicketTrialCalcResp}
 */
proto.xcommon.AssignTicketTrialCalcResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail;
      reader.readMessage(value,proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.deserializeBinaryFromReader);
      msg.addDetail(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRemain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssignTicketTrialCalcResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssignTicketTrialCalcResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignTicketTrialCalcResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDetailList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRemain();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    usergroup: jspb.Message.getFieldWithDefault(msg, 3, ""),
    load: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail}
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail;
  return proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail}
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroup(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoad(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsergroup();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLoad();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Email = 2;
 * @return {string}
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string UserGroup = 3;
 * @return {string}
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.getUsergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.setUsergroup = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 Load = 4;
 * @return {number}
 */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.getLoad = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail.prototype.setLoad = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.AssignTicketTrialCalcResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AssignTCDetail Detail = 2;
 * @return {!Array<!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail>}
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.getDetailList = function() {
  return /** @type{!Array<!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail, 2));
};


/** @param {!Array<!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail>} value */
proto.xcommon.AssignTicketTrialCalcResp.prototype.setDetailList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail}
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.addDetail = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AssignTicketTrialCalcResp.AssignTCDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.clearDetailList = function() {
  this.setDetailList([]);
};


/**
 * optional int64 Total = 3;
 * @return {number}
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.AssignTicketTrialCalcResp.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Remain = 4;
 * @return {number}
 */
proto.xcommon.AssignTicketTrialCalcResp.prototype.getRemain = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.AssignTicketTrialCalcResp.prototype.setRemain = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollOrderTrialCalcReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollOrderTrialCalcReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderTrialCalcReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    option: (f = msg.getOption()) && xcommon_core_pb.RollTCOption.toObject(includeInstance, f),
    minrepayamount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollOrderTrialCalcReq}
 */
proto.xcommon.RollOrderTrialCalcReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollOrderTrialCalcReq;
  return proto.xcommon.RollOrderTrialCalcReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollOrderTrialCalcReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollOrderTrialCalcReq}
 */
proto.xcommon.RollOrderTrialCalcReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = new xcommon_core_pb.RollTCOption;
      reader.readMessage(value,xcommon_core_pb.RollTCOption.deserializeBinaryFromReader);
      msg.setOption(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinrepayamount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollOrderTrialCalcReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollOrderTrialCalcReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderTrialCalcReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getOption();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_core_pb.RollTCOption.serializeBinaryToWriter
    );
  }
  f = message.getMinrepayamount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.RollOrderTrialCalcReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.RollOrderTrialCalcReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional RollTCOption Option = 3;
 * @return {?proto.xcommon.RollTCOption}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.getOption = function() {
  return /** @type{?proto.xcommon.RollTCOption} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.RollTCOption, 3));
};


/** @param {?proto.xcommon.RollTCOption|undefined} value */
proto.xcommon.RollOrderTrialCalcReq.prototype.setOption = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.clearOption = function() {
  this.setOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.hasOption = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 MinRepayAmount = 4;
 * @return {number}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.getMinrepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.RollOrderTrialCalcReq.prototype.setMinrepayamount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.RollOrderTrialCalcReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.RollOrderTrialCalcReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollOrderTrialCalcResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollOrderTrialCalcResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderTrialCalcResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    detail: (f = msg.getDetail()) && xcommon_core_pb.RollTCDetail.toObject(includeInstance, f),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollOrderTrialCalcResp}
 */
proto.xcommon.RollOrderTrialCalcResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollOrderTrialCalcResp;
  return proto.xcommon.RollOrderTrialCalcResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollOrderTrialCalcResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollOrderTrialCalcResp}
 */
proto.xcommon.RollOrderTrialCalcResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_core_pb.RollTCDetail;
      reader.readMessage(value,xcommon_core_pb.RollTCDetail.deserializeBinaryFromReader);
      msg.setDetail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollOrderTrialCalcResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollOrderTrialCalcResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderTrialCalcResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDetail();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_core_pb.RollTCDetail.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.RollOrderTrialCalcResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RollTCDetail Detail = 2;
 * @return {?proto.xcommon.RollTCDetail}
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.getDetail = function() {
  return /** @type{?proto.xcommon.RollTCDetail} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.RollTCDetail, 2));
};


/** @param {?proto.xcommon.RollTCDetail|undefined} value */
proto.xcommon.RollOrderTrialCalcResp.prototype.setDetail = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.clearDetail = function() {
  this.setDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.hasDetail = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.RollOrderTrialCalcResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.RollOrderTrialCalcResp.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollOrderApplyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollOrderApplyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollOrderApplyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderApplyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    option: (f = msg.getOption()) && xcommon_core_pb.RollTCOption.toObject(includeInstance, f),
    minrepayamount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollOrderApplyReq}
 */
proto.xcommon.RollOrderApplyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollOrderApplyReq;
  return proto.xcommon.RollOrderApplyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollOrderApplyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollOrderApplyReq}
 */
proto.xcommon.RollOrderApplyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = new xcommon_core_pb.RollTCOption;
      reader.readMessage(value,xcommon_core_pb.RollTCOption.deserializeBinaryFromReader);
      msg.setOption(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinrepayamount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollOrderApplyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollOrderApplyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollOrderApplyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderApplyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getOption();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_core_pb.RollTCOption.serializeBinaryToWriter
    );
  }
  f = message.getMinrepayamount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.RollOrderApplyReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.RollOrderApplyReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderApplyReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderApplyReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.RollOrderApplyReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.RollOrderApplyReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional RollTCOption Option = 3;
 * @return {?proto.xcommon.RollTCOption}
 */
proto.xcommon.RollOrderApplyReq.prototype.getOption = function() {
  return /** @type{?proto.xcommon.RollTCOption} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.RollTCOption, 3));
};


/** @param {?proto.xcommon.RollTCOption|undefined} value */
proto.xcommon.RollOrderApplyReq.prototype.setOption = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderApplyReq.prototype.clearOption = function() {
  this.setOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderApplyReq.prototype.hasOption = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 MinRepayAmount = 4;
 * @return {number}
 */
proto.xcommon.RollOrderApplyReq.prototype.getMinrepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.RollOrderApplyReq.prototype.setMinrepayamount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.RollOrderApplyReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.RollOrderApplyReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollOrderApplyResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollOrderApplyResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollOrderApplyResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderApplyResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    appname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollOrderApplyResp}
 */
proto.xcommon.RollOrderApplyResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollOrderApplyResp;
  return proto.xcommon.RollOrderApplyResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollOrderApplyResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollOrderApplyResp}
 */
proto.xcommon.RollOrderApplyResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollOrderApplyResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollOrderApplyResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollOrderApplyResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderApplyResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.RollOrderApplyResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.RollOrderApplyResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderApplyResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderApplyResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string AppName = 2;
 * @return {string}
 */
proto.xcommon.RollOrderApplyResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.RollOrderApplyResp.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollOrderCancelReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollOrderCancelReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollOrderCancelReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderCancelReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollOrderCancelReq}
 */
proto.xcommon.RollOrderCancelReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollOrderCancelReq;
  return proto.xcommon.RollOrderCancelReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollOrderCancelReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollOrderCancelReq}
 */
proto.xcommon.RollOrderCancelReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollOrderCancelReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollOrderCancelReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollOrderCancelReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderCancelReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.RollOrderCancelReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.RollOrderCancelReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderCancelReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderCancelReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.RollOrderCancelReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.RollOrderCancelReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.RollOrderCancelReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.RollOrderCancelReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollOrderCancelResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollOrderCancelResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollOrderCancelResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderCancelResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    appname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollOrderCancelResp}
 */
proto.xcommon.RollOrderCancelResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollOrderCancelResp;
  return proto.xcommon.RollOrderCancelResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollOrderCancelResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollOrderCancelResp}
 */
proto.xcommon.RollOrderCancelResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollOrderCancelResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollOrderCancelResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollOrderCancelResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollOrderCancelResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.RollOrderCancelResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.RollOrderCancelResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollOrderCancelResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollOrderCancelResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string AppName = 2;
 * @return {string}
 */
proto.xcommon.RollOrderCancelResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.RollOrderCancelResp.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OpenTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OpenTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OpenTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OpenTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OpenTicketReq}
 */
proto.xcommon.OpenTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OpenTicketReq;
  return proto.xcommon.OpenTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OpenTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OpenTicketReq}
 */
proto.xcommon.OpenTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OpenTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OpenTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OpenTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OpenTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.OpenTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.OpenTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OpenTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OpenTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.OpenTicketReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.OpenTicketReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.OpenTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.OpenTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OpenTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OpenTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OpenTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OpenTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OpenTicketResp}
 */
proto.xcommon.OpenTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OpenTicketResp;
  return proto.xcommon.OpenTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OpenTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OpenTicketResp}
 */
proto.xcommon.OpenTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OpenTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OpenTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OpenTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OpenTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.OpenTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.OpenTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OpenTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OpenTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CloseTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CloseTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CloseTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CloseTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CloseTicketReq}
 */
proto.xcommon.CloseTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CloseTicketReq;
  return proto.xcommon.CloseTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CloseTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CloseTicketReq}
 */
proto.xcommon.CloseTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CloseTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CloseTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CloseTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CloseTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CloseTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.CloseTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CloseTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CloseTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.CloseTicketReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.CloseTicketReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.CloseTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.CloseTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CloseTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CloseTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CloseTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CloseTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    opmsg: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CloseTicketResp}
 */
proto.xcommon.CloseTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CloseTicketResp;
  return proto.xcommon.CloseTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CloseTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CloseTicketResp}
 */
proto.xcommon.CloseTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CloseTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CloseTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CloseTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CloseTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOpmsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CloseTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.CloseTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CloseTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CloseTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string OpMsg = 2;
 * @return {string}
 */
proto.xcommon.CloseTicketResp.prototype.getOpmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.CloseTicketResp.prototype.setOpmsg = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SuspendTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SuspendTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SuspendTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SuspendTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    suspendtime: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SuspendTicketReq}
 */
proto.xcommon.SuspendTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SuspendTicketReq;
  return proto.xcommon.SuspendTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SuspendTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SuspendTicketReq}
 */
proto.xcommon.SuspendTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuspendtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SuspendTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SuspendTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SuspendTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SuspendTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSuspendtime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SuspendTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SuspendTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SuspendTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SuspendTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.SuspendTicketReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SuspendTicketReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.SuspendTicketReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.SuspendTicketReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string SuspendTime = 4;
 * @return {string}
 */
proto.xcommon.SuspendTicketReq.prototype.getSuspendtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SuspendTicketReq.prototype.setSuspendtime = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SuspendTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SuspendTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SuspendTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SuspendTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SuspendTicketResp}
 */
proto.xcommon.SuspendTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SuspendTicketResp;
  return proto.xcommon.SuspendTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SuspendTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SuspendTicketResp}
 */
proto.xcommon.SuspendTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SuspendTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SuspendTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SuspendTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SuspendTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SuspendTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SuspendTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SuspendTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SuspendTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketEstimateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketEstimateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketEstimateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEstimateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    daterange: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketEstimateReq}
 */
proto.xcommon.GetTicketEstimateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketEstimateReq;
  return proto.xcommon.GetTicketEstimateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketEstimateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketEstimateReq}
 */
proto.xcommon.GetTicketEstimateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDaterange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketEstimateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketEstimateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketEstimateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEstimateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getDaterange();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketEstimateReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketEstimateReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEstimateReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEstimateReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string DateRange = 2;
 * @return {string}
 */
proto.xcommon.GetTicketEstimateReq.prototype.getDaterange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketEstimateReq.prototype.setDaterange = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketEstimate.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketEstimate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketEstimate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketEstimate.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    singlefirstnum: jspb.Message.getFieldWithDefault(msg, 3, 0),
    singlereloannum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    stagefirstnum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    stagereloannum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    estimatedate: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketEstimate}
 */
proto.xcommon.TicketEstimate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketEstimate;
  return proto.xcommon.TicketEstimate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketEstimate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketEstimate}
 */
proto.xcommon.TicketEstimate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSinglefirstnum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSinglereloannum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStagefirstnum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStagereloannum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEstimatedate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketEstimate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketEstimate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketEstimate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketEstimate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSinglefirstnum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSinglereloannum();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getStagefirstnum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStagereloannum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getEstimatedate();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 TicketItemId = 2;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 SingleFirstNum = 3;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getSinglefirstnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setSinglefirstnum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 SingleReloanNum = 4;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getSinglereloannum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setSinglereloannum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 StageFirstNum = 5;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getStagefirstnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setStagefirstnum = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 StageReloanNum = 6;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getStagereloannum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setStagereloannum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 EstimateDate = 7;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getEstimatedate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setEstimatedate = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 Ctime = 8;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Utime = 9;
 * @return {number}
 */
proto.xcommon.TicketEstimate.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.TicketEstimate.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketEstimateBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketEstimateBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketEstimateBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketEstimateBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketestimate: (f = msg.getTicketestimate()) && proto.xcommon.TicketEstimate.toObject(includeInstance, f),
    ticketitemname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketEstimateBackend}
 */
proto.xcommon.TicketEstimateBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketEstimateBackend;
  return proto.xcommon.TicketEstimateBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketEstimateBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketEstimateBackend}
 */
proto.xcommon.TicketEstimateBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.TicketEstimate;
      reader.readMessage(value,proto.xcommon.TicketEstimate.deserializeBinaryFromReader);
      msg.setTicketestimate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketitemname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketEstimateBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketEstimateBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketEstimateBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketEstimateBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketestimate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.TicketEstimate.serializeBinaryToWriter
    );
  }
  f = message.getTicketitemname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TicketEstimate TicketEstimate = 1;
 * @return {?proto.xcommon.TicketEstimate}
 */
proto.xcommon.TicketEstimateBackend.prototype.getTicketestimate = function() {
  return /** @type{?proto.xcommon.TicketEstimate} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketEstimate, 1));
};


/** @param {?proto.xcommon.TicketEstimate|undefined} value */
proto.xcommon.TicketEstimateBackend.prototype.setTicketestimate = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.TicketEstimateBackend.prototype.clearTicketestimate = function() {
  this.setTicketestimate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.TicketEstimateBackend.prototype.hasTicketestimate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string TicketItemName = 2;
 * @return {string}
 */
proto.xcommon.TicketEstimateBackend.prototype.getTicketitemname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.TicketEstimateBackend.prototype.setTicketitemname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketEstimateResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketEstimateResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketEstimateResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketEstimateResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEstimateResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.xcommon.TicketEstimateBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketEstimateResp}
 */
proto.xcommon.GetTicketEstimateResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketEstimateResp;
  return proto.xcommon.GetTicketEstimateResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketEstimateResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketEstimateResp}
 */
proto.xcommon.GetTicketEstimateResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.TicketEstimateBackend;
      reader.readMessage(value,proto.xcommon.TicketEstimateBackend.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketEstimateResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketEstimateResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketEstimateResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEstimateResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.TicketEstimateBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketEstimateResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketEstimateResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEstimateResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEstimateResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TicketEstimateBackend Data = 2;
 * @return {!Array<!proto.xcommon.TicketEstimateBackend>}
 */
proto.xcommon.GetTicketEstimateResp.prototype.getDataList = function() {
  return /** @type{!Array<!proto.xcommon.TicketEstimateBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketEstimateBackend, 2));
};


/** @param {!Array<!proto.xcommon.TicketEstimateBackend>} value */
proto.xcommon.GetTicketEstimateResp.prototype.setDataList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.TicketEstimateBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketEstimateBackend}
 */
proto.xcommon.GetTicketEstimateResp.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.TicketEstimateBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketEstimateResp.prototype.clearDataList = function() {
  this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CommonItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CommonItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CommonItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CommonItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CommonItem}
 */
proto.xcommon.CommonItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CommonItem;
  return proto.xcommon.CommonItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CommonItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CommonItem}
 */
proto.xcommon.CommonItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CommonItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CommonItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CommonItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CommonItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Id = 1;
 * @return {string}
 */
proto.xcommon.CommonItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CommonItem.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.CommonItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.CommonItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Value = 3;
 * @return {string}
 */
proto.xcommon.CommonItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CommonItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AttrItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AttrItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AttrItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AttrItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    attrid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.AttrItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AttrItem;
  return proto.xcommon.AttrItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AttrItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.AttrItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttrid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AttrItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AttrItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AttrItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AttrItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttrid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string AttrId = 1;
 * @return {string}
 */
proto.xcommon.AttrItem.prototype.getAttrid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.AttrItem.prototype.setAttrid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.AttrItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AttrItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Value = 3;
 * @return {string}
 */
proto.xcommon.AttrItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AttrItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.FuncItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.FuncItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.FuncItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.FuncItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    func: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.FuncItem}
 */
proto.xcommon.FuncItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.FuncItem;
  return proto.xcommon.FuncItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.FuncItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.FuncItem}
 */
proto.xcommon.FuncItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFunc(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.FuncItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.FuncItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.FuncItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.FuncItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFunc();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Func = 1;
 * @return {string}
 */
proto.xcommon.FuncItem.prototype.getFunc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.FuncItem.prototype.setFunc = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.FuncItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.FuncItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.FuncParamItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.FuncParamItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.FuncParamItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.FuncParamItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.FuncParamItem}
 */
proto.xcommon.FuncParamItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.FuncParamItem;
  return proto.xcommon.FuncParamItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.FuncParamItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.FuncParamItem}
 */
proto.xcommon.FuncParamItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.FuncParamItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.FuncParamItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.FuncParamItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.FuncParamItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.xcommon.FuncParamItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.FuncParamItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Value = 2;
 * @return {string}
 */
proto.xcommon.FuncParamItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.FuncParamItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PhoneSaleItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PhoneSaleItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PhoneSaleItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneSaleItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    pid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    index: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PhoneSaleItem}
 */
proto.xcommon.PhoneSaleItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PhoneSaleItem;
  return proto.xcommon.PhoneSaleItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PhoneSaleItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PhoneSaleItem}
 */
proto.xcommon.PhoneSaleItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndex(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PhoneSaleItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PhoneSaleItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PhoneSaleItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneSaleItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIndex();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Pid = 1;
 * @return {string}
 */
proto.xcommon.PhoneSaleItem.prototype.getPid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.PhoneSaleItem.prototype.setPid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Index = 2;
 * @return {string}
 */
proto.xcommon.PhoneSaleItem.prototype.getIndex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.PhoneSaleItem.prototype.setIndex = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Value = 3;
 * @return {string}
 */
proto.xcommon.PhoneSaleItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.PhoneSaleItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.FuncOption.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.FuncOption.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.FuncOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.FuncOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.FuncOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    func: (f = msg.getFunc()) && proto.xcommon.FuncItem.toObject(includeInstance, f),
    funcparamList: jspb.Message.toObjectList(msg.getFuncparamList(),
    proto.xcommon.FuncParamItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.FuncOption}
 */
proto.xcommon.FuncOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.FuncOption;
  return proto.xcommon.FuncOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.FuncOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.FuncOption}
 */
proto.xcommon.FuncOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.FuncItem;
      reader.readMessage(value,proto.xcommon.FuncItem.deserializeBinaryFromReader);
      msg.setFunc(value);
      break;
    case 2:
      var value = new proto.xcommon.FuncParamItem;
      reader.readMessage(value,proto.xcommon.FuncParamItem.deserializeBinaryFromReader);
      msg.addFuncparam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.FuncOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.FuncOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.FuncOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.FuncOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFunc();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.FuncItem.serializeBinaryToWriter
    );
  }
  f = message.getFuncparamList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.FuncParamItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional FuncItem Func = 1;
 * @return {?proto.xcommon.FuncItem}
 */
proto.xcommon.FuncOption.prototype.getFunc = function() {
  return /** @type{?proto.xcommon.FuncItem} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.FuncItem, 1));
};


/** @param {?proto.xcommon.FuncItem|undefined} value */
proto.xcommon.FuncOption.prototype.setFunc = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.FuncOption.prototype.clearFunc = function() {
  this.setFunc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.FuncOption.prototype.hasFunc = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated FuncParamItem FuncParam = 2;
 * @return {!Array<!proto.xcommon.FuncParamItem>}
 */
proto.xcommon.FuncOption.prototype.getFuncparamList = function() {
  return /** @type{!Array<!proto.xcommon.FuncParamItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.FuncParamItem, 2));
};


/** @param {!Array<!proto.xcommon.FuncParamItem>} value */
proto.xcommon.FuncOption.prototype.setFuncparamList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.FuncParamItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.FuncParamItem}
 */
proto.xcommon.FuncOption.prototype.addFuncparam = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.FuncParamItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.FuncOption.prototype.clearFuncparamList = function() {
  this.setFuncparamList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketAttrItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketAttrItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketAttrItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketAttrItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attrid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    attrtype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    value: jspb.Message.getFieldWithDefault(msg, 5, ""),
    func: jspb.Message.getFieldWithDefault(msg, 6, ""),
    funcparam: jspb.Message.getFieldWithDefault(msg, 7, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 11, ""),
    systemtype: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketAttrItem}
 */
proto.xcommon.TicketAttrItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketAttrItem;
  return proto.xcommon.TicketAttrItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketAttrItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketAttrItem}
 */
proto.xcommon.TicketAttrItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttrid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttrtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFunc(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFuncparam(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    case 12:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketAttrItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketAttrItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketAttrItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketAttrItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAttrid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAttrtype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFunc();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFuncparam();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.TicketAttrItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.TicketAttrItem.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string AttrId = 2;
 * @return {string}
 */
proto.xcommon.TicketAttrItem.prototype.getAttrid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.TicketAttrItem.prototype.setAttrid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 AttrType = 3;
 * @return {number}
 */
proto.xcommon.TicketAttrItem.prototype.getAttrtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.TicketAttrItem.prototype.setAttrtype = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Name = 4;
 * @return {string}
 */
proto.xcommon.TicketAttrItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.TicketAttrItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Value = 5;
 * @return {string}
 */
proto.xcommon.TicketAttrItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.TicketAttrItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Func = 6;
 * @return {string}
 */
proto.xcommon.TicketAttrItem.prototype.getFunc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.TicketAttrItem.prototype.setFunc = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string FuncParam = 7;
 * @return {string}
 */
proto.xcommon.TicketAttrItem.prototype.getFuncparam = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.TicketAttrItem.prototype.setFuncparam = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 AdminUid = 8;
 * @return {number}
 */
proto.xcommon.TicketAttrItem.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.TicketAttrItem.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Ctime = 9;
 * @return {number}
 */
proto.xcommon.TicketAttrItem.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.TicketAttrItem.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Utime = 10;
 * @return {number}
 */
proto.xcommon.TicketAttrItem.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.TicketAttrItem.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string Desc = 11;
 * @return {string}
 */
proto.xcommon.TicketAttrItem.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.TicketAttrItem.prototype.setDesc = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional MPSystemType SystemType = 12;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.TicketAttrItem.prototype.getSystemtype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {!proto.xcommon.MPSystemType} value */
proto.xcommon.TicketAttrItem.prototype.setSystemtype = function(value) {
  jspb.Message.setProto3EnumField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserAttrItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserAttrItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserAttrItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserAttrItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attrid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    attrtype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    value: jspb.Message.getFieldWithDefault(msg, 5, ""),
    func: jspb.Message.getFieldWithDefault(msg, 6, ""),
    funcparam: jspb.Message.getFieldWithDefault(msg, 7, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserAttrItem}
 */
proto.xcommon.UserAttrItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserAttrItem;
  return proto.xcommon.UserAttrItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserAttrItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserAttrItem}
 */
proto.xcommon.UserAttrItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttrid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttrtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFunc(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFuncparam(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserAttrItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserAttrItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserAttrItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserAttrItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAttrid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAttrtype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFunc();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFuncparam();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.UserAttrItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.UserAttrItem.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string AttrId = 2;
 * @return {string}
 */
proto.xcommon.UserAttrItem.prototype.getAttrid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.UserAttrItem.prototype.setAttrid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 AttrType = 3;
 * @return {number}
 */
proto.xcommon.UserAttrItem.prototype.getAttrtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.UserAttrItem.prototype.setAttrtype = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Name = 4;
 * @return {string}
 */
proto.xcommon.UserAttrItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.UserAttrItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Value = 5;
 * @return {string}
 */
proto.xcommon.UserAttrItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.UserAttrItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Func = 6;
 * @return {string}
 */
proto.xcommon.UserAttrItem.prototype.getFunc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.UserAttrItem.prototype.setFunc = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string FuncParam = 7;
 * @return {string}
 */
proto.xcommon.UserAttrItem.prototype.getFuncparam = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.UserAttrItem.prototype.setFuncparam = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 AdminUid = 8;
 * @return {number}
 */
proto.xcommon.UserAttrItem.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.UserAttrItem.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Ctime = 9;
 * @return {number}
 */
proto.xcommon.UserAttrItem.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.UserAttrItem.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Utime = 10;
 * @return {number}
 */
proto.xcommon.UserAttrItem.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.UserAttrItem.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string Desc = 11;
 * @return {string}
 */
proto.xcommon.UserAttrItem.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.UserAttrItem.prototype.setDesc = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LoadAttrItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LoadAttrItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LoadAttrItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LoadAttrItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attrid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    attrtype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    value: jspb.Message.getFieldWithDefault(msg, 5, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    describe: jspb.Message.getFieldWithDefault(msg, 7, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    userattr: jspb.Message.getFieldWithDefault(msg, 10, ""),
    rate: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LoadAttrItem}
 */
proto.xcommon.LoadAttrItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LoadAttrItem;
  return proto.xcommon.LoadAttrItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LoadAttrItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LoadAttrItem}
 */
proto.xcommon.LoadAttrItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttrid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttrtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescribe(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserattr(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LoadAttrItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LoadAttrItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LoadAttrItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LoadAttrItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAttrid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAttrtype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getDescribe();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUserattr();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getRate();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.LoadAttrItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LoadAttrItem.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string AttrId = 2;
 * @return {string}
 */
proto.xcommon.LoadAttrItem.prototype.getAttrid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.LoadAttrItem.prototype.setAttrid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 AttrType = 3;
 * @return {number}
 */
proto.xcommon.LoadAttrItem.prototype.getAttrtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LoadAttrItem.prototype.setAttrtype = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Name = 4;
 * @return {string}
 */
proto.xcommon.LoadAttrItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.LoadAttrItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Value = 5;
 * @return {string}
 */
proto.xcommon.LoadAttrItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.LoadAttrItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 AdminUid = 6;
 * @return {number}
 */
proto.xcommon.LoadAttrItem.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.LoadAttrItem.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string Describe = 7;
 * @return {string}
 */
proto.xcommon.LoadAttrItem.prototype.getDescribe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.LoadAttrItem.prototype.setDescribe = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 Ctime = 8;
 * @return {number}
 */
proto.xcommon.LoadAttrItem.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.LoadAttrItem.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Utime = 9;
 * @return {number}
 */
proto.xcommon.LoadAttrItem.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.LoadAttrItem.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string UserAttr = 10;
 * @return {string}
 */
proto.xcommon.LoadAttrItem.prototype.getUserattr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.LoadAttrItem.prototype.setUserattr = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 Rate = 11;
 * @return {number}
 */
proto.xcommon.LoadAttrItem.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.LoadAttrItem.prototype.setRate = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TicketAssignParam.repeatedFields_ = [1,2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketAssignParam.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketAssignParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketAssignParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketAssignParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeactionList: jspb.Message.toObjectList(msg.getTimeactionList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    sortticketList: jspb.Message.toObjectList(msg.getSortticketList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    assignmodeList: jspb.Message.toObjectList(msg.getAssignmodeList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    sortadminList: jspb.Message.toObjectList(msg.getSortadminList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    workmodeList: jspb.Message.toObjectList(msg.getWorkmodeList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketAssignParam}
 */
proto.xcommon.TicketAssignParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketAssignParam;
  return proto.xcommon.TicketAssignParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketAssignParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketAssignParam}
 */
proto.xcommon.TicketAssignParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTimeaction(value);
      break;
    case 2:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addSortticket(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addAssignmode(value);
      break;
    case 4:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addSortadmin(value);
      break;
    case 5:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addWorkmode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketAssignParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketAssignParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketAssignParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketAssignParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeactionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getSortticketList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getAssignmodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getSortadminList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getWorkmodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AttrItem TimeAction = 1;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.TicketAssignParam.prototype.getTimeactionList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 1));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.TicketAssignParam.prototype.setTimeactionList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.TicketAssignParam.prototype.addTimeaction = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignParam.prototype.clearTimeactionList = function() {
  this.setTimeactionList([]);
};


/**
 * repeated AttrItem SortTicket = 2;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.TicketAssignParam.prototype.getSortticketList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 2));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.TicketAssignParam.prototype.setSortticketList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.TicketAssignParam.prototype.addSortticket = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignParam.prototype.clearSortticketList = function() {
  this.setSortticketList([]);
};


/**
 * repeated AttrItem AssignMode = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.TicketAssignParam.prototype.getAssignmodeList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.TicketAssignParam.prototype.setAssignmodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.TicketAssignParam.prototype.addAssignmode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignParam.prototype.clearAssignmodeList = function() {
  this.setAssignmodeList([]);
};


/**
 * repeated AttrItem SortAdmin = 4;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.TicketAssignParam.prototype.getSortadminList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 4));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.TicketAssignParam.prototype.setSortadminList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.TicketAssignParam.prototype.addSortadmin = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignParam.prototype.clearSortadminList = function() {
  this.setSortadminList([]);
};


/**
 * repeated AttrItem WorkMode = 5;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.TicketAssignParam.prototype.getWorkmodeList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 5));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.TicketAssignParam.prototype.setWorkmodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.TicketAssignParam.prototype.addWorkmode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignParam.prototype.clearWorkmodeList = function() {
  this.setWorkmodeList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TicketAssignRuleAttr.repeatedFields_ = [5,6,7,8,9,10,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketAssignRuleAttr.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketAssignRuleAttr} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketAssignRuleAttr.toObject = function(includeInstance, msg) {
  var f, obj = {
    assigntime: jspb.Message.getFieldWithDefault(msg, 1, ""),
    begintime: jspb.Message.getFieldWithDefault(msg, 2, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timeaction: jspb.Message.getFieldWithDefault(msg, 4, 0),
    ticketattrList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    sortticketList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    sortadminList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    assignmodeList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    adminattrList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    loadattrList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    ticketattrdesc: jspb.Message.getFieldWithDefault(msg, 11, ""),
    name: jspb.Message.getFieldWithDefault(msg, 12, ""),
    userattrList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    isfinal: jspb.Message.getFieldWithDefault(msg, 14, 0),
    workday: jspb.Message.getFieldWithDefault(msg, 15, ""),
    workstatus: jspb.Message.getFieldWithDefault(msg, 16, 0),
    systemtype: jspb.Message.getFieldWithDefault(msg, 17, 0),
    pvdailymaxworkload: jspb.Message.getFieldWithDefault(msg, 18, 0),
    pvworkermaxworkload: jspb.Message.getFieldWithDefault(msg, 19, 0),
    pvpartcompleteticketfactor: jspb.Message.getFieldWithDefault(msg, 20, 0),
    id: jspb.Message.getFieldWithDefault(msg, 21, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketAssignRuleAttr}
 */
proto.xcommon.TicketAssignRuleAttr.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketAssignRuleAttr;
  return proto.xcommon.TicketAssignRuleAttr.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketAssignRuleAttr} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketAssignRuleAttr}
 */
proto.xcommon.TicketAssignRuleAttr.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegintime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeaction(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addTicketattr(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addSortticket(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addSortadmin(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssignmode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addAdminattr(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addLoadattr(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketattrdesc(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserattr(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsfinal(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkday(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkstatus(value);
      break;
    case 17:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPvdailymaxworkload(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPvworkermaxworkload(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPvpartcompleteticketfactor(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketAssignRuleAttr.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketAssignRuleAttr} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketAssignRuleAttr.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssigntime();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBegintime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimeaction();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTicketattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getSortticketList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getSortadminList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getAssignmodeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getAdminattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getLoadattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getTicketattrdesc();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUserattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getIsfinal();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getWorkday();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getWorkstatus();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getPvdailymaxworkload();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getPvworkermaxworkload();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getPvpartcompleteticketfactor();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
};


/**
 * optional string AssignTime = 1;
 * @return {string}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getAssigntime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setAssigntime = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string BeginTime = 2;
 * @return {string}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getBegintime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setBegintime = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string EndTime = 3;
 * @return {string}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setEndtime = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 TimeAction = 4;
 * @return {number}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getTimeaction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setTimeaction = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated string TicketAttr = 5;
 * @return {!Array<string>}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getTicketattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setTicketattrList = function(value) {
  jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketAssignRuleAttr.prototype.addTicketattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignRuleAttr.prototype.clearTicketattrList = function() {
  this.setTicketattrList([]);
};


/**
 * repeated string SortTicket = 6;
 * @return {!Array<string>}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getSortticketList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setSortticketList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketAssignRuleAttr.prototype.addSortticket = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignRuleAttr.prototype.clearSortticketList = function() {
  this.setSortticketList([]);
};


/**
 * repeated string SortAdmin = 7;
 * @return {!Array<string>}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getSortadminList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setSortadminList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketAssignRuleAttr.prototype.addSortadmin = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignRuleAttr.prototype.clearSortadminList = function() {
  this.setSortadminList([]);
};


/**
 * repeated string AssignMode = 8;
 * @return {!Array<string>}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getAssignmodeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setAssignmodeList = function(value) {
  jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketAssignRuleAttr.prototype.addAssignmode = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignRuleAttr.prototype.clearAssignmodeList = function() {
  this.setAssignmodeList([]);
};


/**
 * repeated string AdminAttr = 9;
 * @return {!Array<string>}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getAdminattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setAdminattrList = function(value) {
  jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketAssignRuleAttr.prototype.addAdminattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignRuleAttr.prototype.clearAdminattrList = function() {
  this.setAdminattrList([]);
};


/**
 * repeated string LoadAttr = 10;
 * @return {!Array<string>}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getLoadattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setLoadattrList = function(value) {
  jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketAssignRuleAttr.prototype.addLoadattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignRuleAttr.prototype.clearLoadattrList = function() {
  this.setLoadattrList([]);
};


/**
 * optional string TicketAttrDesc = 11;
 * @return {string}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getTicketattrdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setTicketattrdesc = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string Name = 12;
 * @return {string}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated string UserAttr = 13;
 * @return {!Array<string>}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getUserattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setUserattrList = function(value) {
  jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketAssignRuleAttr.prototype.addUserattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketAssignRuleAttr.prototype.clearUserattrList = function() {
  this.setUserattrList([]);
};


/**
 * optional int32 IsFinal = 14;
 * @return {number}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getIsfinal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setIsfinal = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string WorkDay = 15;
 * @return {string}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getWorkday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setWorkday = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 WorkStatus = 16;
 * @return {number}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getWorkstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setWorkstatus = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional MPSystemType SystemType = 17;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getSystemtype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {!proto.xcommon.MPSystemType} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setSystemtype = function(value) {
  jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional int64 PVDailyMaxWorkLoad = 18;
 * @return {number}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getPvdailymaxworkload = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setPvdailymaxworkload = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 PVWorkerMaxWorkLoad = 19;
 * @return {number}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getPvworkermaxworkload = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setPvworkermaxworkload = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 PVPartCompleteTicketFactor = 20;
 * @return {number}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getPvpartcompleteticketfactor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setPvpartcompleteticketfactor = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 ID = 21;
 * @return {number}
 */
proto.xcommon.TicketAssignRuleAttr.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.TicketAssignRuleAttr.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TicketRecycleParam.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketRecycleParam.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketRecycleParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketRecycleParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketRecycleParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeactionList: jspb.Message.toObjectList(msg.getTimeactionList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    workmodeList: jspb.Message.toObjectList(msg.getWorkmodeList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketRecycleParam}
 */
proto.xcommon.TicketRecycleParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketRecycleParam;
  return proto.xcommon.TicketRecycleParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketRecycleParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketRecycleParam}
 */
proto.xcommon.TicketRecycleParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTimeaction(value);
      break;
    case 2:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addWorkmode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketRecycleParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketRecycleParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketRecycleParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketRecycleParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeactionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getWorkmodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AttrItem TimeAction = 1;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.TicketRecycleParam.prototype.getTimeactionList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 1));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.TicketRecycleParam.prototype.setTimeactionList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.TicketRecycleParam.prototype.addTimeaction = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecycleParam.prototype.clearTimeactionList = function() {
  this.setTimeactionList([]);
};


/**
 * repeated AttrItem WorkMode = 2;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.TicketRecycleParam.prototype.getWorkmodeList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 2));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.TicketRecycleParam.prototype.setWorkmodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.TicketRecycleParam.prototype.addWorkmode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecycleParam.prototype.clearWorkmodeList = function() {
  this.setWorkmodeList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TicketRecycleRuleAttr.repeatedFields_ = [2,3,6,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketRecycleRuleAttr.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketRecycleRuleAttr} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketRecycleRuleAttr.toObject = function(includeInstance, msg) {
  var f, obj = {
    tasktime: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticketattrList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    userattrList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    ticketattrdesc: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    adminattrList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    begintime: jspb.Message.getFieldWithDefault(msg, 7, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 8, ""),
    timeaction: jspb.Message.getFieldWithDefault(msg, 9, 0),
    loadattrList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    workday: jspb.Message.getFieldWithDefault(msg, 11, ""),
    workstatus: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketRecycleRuleAttr}
 */
proto.xcommon.TicketRecycleRuleAttr.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketRecycleRuleAttr;
  return proto.xcommon.TicketRecycleRuleAttr.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketRecycleRuleAttr} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketRecycleRuleAttr}
 */
proto.xcommon.TicketRecycleRuleAttr.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasktime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTicketattr(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserattr(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketattrdesc(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addAdminattr(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegintime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeaction(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addLoadattr(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkday(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketRecycleRuleAttr.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketRecycleRuleAttr} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketRecycleRuleAttr.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTasktime();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicketattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getUserattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getTicketattrdesc();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAdminattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getBegintime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTimeaction();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getLoadattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getWorkday();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getWorkstatus();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
};


/**
 * optional string TaskTime = 1;
 * @return {string}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getTasktime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setTasktime = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string TicketAttr = 2;
 * @return {!Array<string>}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getTicketattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setTicketattrList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.addTicketattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.clearTicketattrList = function() {
  this.setTicketattrList([]);
};


/**
 * repeated string UserAttr = 3;
 * @return {!Array<string>}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getUserattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setUserattrList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.addUserattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.clearUserattrList = function() {
  this.setUserattrList([]);
};


/**
 * optional string TicketAttrDesc = 4;
 * @return {string}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getTicketattrdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setTicketattrdesc = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Name = 5;
 * @return {string}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated string AdminAttr = 6;
 * @return {!Array<string>}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getAdminattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setAdminattrList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.addAdminattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.clearAdminattrList = function() {
  this.setAdminattrList([]);
};


/**
 * optional string BeginTime = 7;
 * @return {string}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getBegintime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setBegintime = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string EndTime = 8;
 * @return {string}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setEndtime = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 TimeAction = 9;
 * @return {number}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getTimeaction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setTimeaction = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated string LoadAttr = 10;
 * @return {!Array<string>}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getLoadattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setLoadattrList = function(value) {
  jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.addLoadattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.clearLoadattrList = function() {
  this.setLoadattrList([]);
};


/**
 * optional string WorkDay = 11;
 * @return {string}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getWorkday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setWorkday = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int32 WorkStatus = 12;
 * @return {number}
 */
proto.xcommon.TicketRecycleRuleAttr.prototype.getWorkstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.TicketRecycleRuleAttr.prototype.setWorkstatus = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TicketEntrustRuleAttr.repeatedFields_ = [2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketEntrustRuleAttr.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketEntrustRuleAttr} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketEntrustRuleAttr.toObject = function(includeInstance, msg) {
  var f, obj = {
    tasktime: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticketattrList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    sortticketList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    loadattrList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    thirdidList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    ticketattrdesc: jspb.Message.getFieldWithDefault(msg, 6, ""),
    name: jspb.Message.getFieldWithDefault(msg, 7, ""),
    workday: jspb.Message.getFieldWithDefault(msg, 8, ""),
    workstatus: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketEntrustRuleAttr}
 */
proto.xcommon.TicketEntrustRuleAttr.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketEntrustRuleAttr;
  return proto.xcommon.TicketEntrustRuleAttr.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketEntrustRuleAttr} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketEntrustRuleAttr}
 */
proto.xcommon.TicketEntrustRuleAttr.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasktime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTicketattr(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSortticket(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addLoadattr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addThirdid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketattrdesc(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkday(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketEntrustRuleAttr.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketEntrustRuleAttr} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketEntrustRuleAttr.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTasktime();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicketattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getSortticketList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getLoadattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getThirdidList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getTicketattrdesc();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getWorkday();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getWorkstatus();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string TaskTime = 1;
 * @return {string}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getTasktime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setTasktime = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string TicketAttr = 2;
 * @return {!Array<string>}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getTicketattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setTicketattrList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.addTicketattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.clearTicketattrList = function() {
  this.setTicketattrList([]);
};


/**
 * repeated string SortTicket = 3;
 * @return {!Array<string>}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getSortticketList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setSortticketList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.addSortticket = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.clearSortticketList = function() {
  this.setSortticketList([]);
};


/**
 * repeated string LoadAttr = 4;
 * @return {!Array<string>}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getLoadattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setLoadattrList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.addLoadattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.clearLoadattrList = function() {
  this.setLoadattrList([]);
};


/**
 * repeated string ThirdID = 5;
 * @return {!Array<string>}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getThirdidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setThirdidList = function(value) {
  jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.addThirdid = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.clearThirdidList = function() {
  this.setThirdidList([]);
};


/**
 * optional string TicketAttrDesc = 6;
 * @return {string}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getTicketattrdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setTicketattrdesc = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Name = 7;
 * @return {string}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string WorkDay = 8;
 * @return {string}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getWorkday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setWorkday = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 WorkStatus = 9;
 * @return {number}
 */
proto.xcommon.TicketEntrustRuleAttr.prototype.getWorkstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.TicketEntrustRuleAttr.prototype.setWorkstatus = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketAssignRulesItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketAssignRulesItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignRulesItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attrs: (f = msg.getAttrs()) && proto.xcommon.TicketAssignRuleAttr.toObject(includeInstance, f),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketAssignRulesItem}
 */
proto.xcommon.GetTicketAssignRulesItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketAssignRulesItem;
  return proto.xcommon.GetTicketAssignRulesItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketAssignRulesItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketAssignRulesItem}
 */
proto.xcommon.GetTicketAssignRulesItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.xcommon.TicketAssignRuleAttr;
      reader.readMessage(value,proto.xcommon.TicketAssignRuleAttr.deserializeBinaryFromReader);
      msg.setAttrs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketAssignRulesItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketAssignRulesItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketAssignRulesItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAttrs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.TicketAssignRuleAttr.serializeBinaryToWriter
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketAssignRulesItem.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TicketAssignRuleAttr Attrs = 2;
 * @return {?proto.xcommon.TicketAssignRuleAttr}
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.getAttrs = function() {
  return /** @type{?proto.xcommon.TicketAssignRuleAttr} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketAssignRuleAttr, 2));
};


/** @param {?proto.xcommon.TicketAssignRuleAttr|undefined} value */
proto.xcommon.GetTicketAssignRulesItem.prototype.setAttrs = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.clearAttrs = function() {
  this.setAttrs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.hasAttrs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 AdminUid = 3;
 * @return {number}
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketAssignRulesItem.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Ctime = 4;
 * @return {number}
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketAssignRulesItem.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 Utime = 5;
 * @return {number}
 */
proto.xcommon.GetTicketAssignRulesItem.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketAssignRulesItem.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecycleRulesItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecycleRulesItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleRulesItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attrs: (f = msg.getAttrs()) && proto.xcommon.TicketRecycleRuleAttr.toObject(includeInstance, f),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecycleRulesItem}
 */
proto.xcommon.GetTicketRecycleRulesItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecycleRulesItem;
  return proto.xcommon.GetTicketRecycleRulesItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecycleRulesItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecycleRulesItem}
 */
proto.xcommon.GetTicketRecycleRulesItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.xcommon.TicketRecycleRuleAttr;
      reader.readMessage(value,proto.xcommon.TicketRecycleRuleAttr.deserializeBinaryFromReader);
      msg.setAttrs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecycleRulesItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecycleRulesItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecycleRulesItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAttrs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.TicketRecycleRuleAttr.serializeBinaryToWriter
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketRecycleRulesItem.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TicketRecycleRuleAttr Attrs = 2;
 * @return {?proto.xcommon.TicketRecycleRuleAttr}
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.getAttrs = function() {
  return /** @type{?proto.xcommon.TicketRecycleRuleAttr} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketRecycleRuleAttr, 2));
};


/** @param {?proto.xcommon.TicketRecycleRuleAttr|undefined} value */
proto.xcommon.GetTicketRecycleRulesItem.prototype.setAttrs = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.clearAttrs = function() {
  this.setAttrs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.hasAttrs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 AdminUid = 3;
 * @return {number}
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketRecycleRulesItem.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Ctime = 4;
 * @return {number}
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketRecycleRulesItem.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 Utime = 5;
 * @return {number}
 */
proto.xcommon.GetTicketRecycleRulesItem.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketRecycleRulesItem.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketEntrustRulesItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketEntrustRulesItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustRulesItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attrs: (f = msg.getAttrs()) && proto.xcommon.TicketEntrustRuleAttr.toObject(includeInstance, f),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketEntrustRulesItem}
 */
proto.xcommon.GetTicketEntrustRulesItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketEntrustRulesItem;
  return proto.xcommon.GetTicketEntrustRulesItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketEntrustRulesItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketEntrustRulesItem}
 */
proto.xcommon.GetTicketEntrustRulesItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.xcommon.TicketEntrustRuleAttr;
      reader.readMessage(value,proto.xcommon.TicketEntrustRuleAttr.deserializeBinaryFromReader);
      msg.setAttrs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketEntrustRulesItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketEntrustRulesItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketEntrustRulesItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAttrs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.TicketEntrustRuleAttr.serializeBinaryToWriter
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketEntrustRulesItem.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TicketEntrustRuleAttr Attrs = 2;
 * @return {?proto.xcommon.TicketEntrustRuleAttr}
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.getAttrs = function() {
  return /** @type{?proto.xcommon.TicketEntrustRuleAttr} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketEntrustRuleAttr, 2));
};


/** @param {?proto.xcommon.TicketEntrustRuleAttr|undefined} value */
proto.xcommon.GetTicketEntrustRulesItem.prototype.setAttrs = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.clearAttrs = function() {
  this.setAttrs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.hasAttrs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 AdminUid = 3;
 * @return {number}
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketEntrustRulesItem.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Ctime = 4;
 * @return {number}
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketEntrustRulesItem.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 Utime = 5;
 * @return {number}
 */
proto.xcommon.GetTicketEntrustRulesItem.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketEntrustRulesItem.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TicketRecallRuleAttr.repeatedFields_ = [2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketRecallRuleAttr.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketRecallRuleAttr} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketRecallRuleAttr.toObject = function(includeInstance, msg) {
  var f, obj = {
    tasktime: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticketattrList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    sortticketList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    loadattrList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    thirdidList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    ticketattrdesc: jspb.Message.getFieldWithDefault(msg, 6, ""),
    name: jspb.Message.getFieldWithDefault(msg, 7, ""),
    workday: jspb.Message.getFieldWithDefault(msg, 8, ""),
    workstatus: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketRecallRuleAttr}
 */
proto.xcommon.TicketRecallRuleAttr.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketRecallRuleAttr;
  return proto.xcommon.TicketRecallRuleAttr.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketRecallRuleAttr} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketRecallRuleAttr}
 */
proto.xcommon.TicketRecallRuleAttr.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasktime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTicketattr(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSortticket(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addLoadattr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addThirdid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketattrdesc(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkday(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketRecallRuleAttr.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketRecallRuleAttr} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketRecallRuleAttr.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTasktime();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicketattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getSortticketList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getLoadattrList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getThirdidList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getTicketattrdesc();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getWorkday();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getWorkstatus();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string TaskTime = 1;
 * @return {string}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getTasktime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setTasktime = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string TicketAttr = 2;
 * @return {!Array<string>}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getTicketattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setTicketattrList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketRecallRuleAttr.prototype.addTicketattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecallRuleAttr.prototype.clearTicketattrList = function() {
  this.setTicketattrList([]);
};


/**
 * repeated string SortTicket = 3;
 * @return {!Array<string>}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getSortticketList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setSortticketList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketRecallRuleAttr.prototype.addSortticket = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecallRuleAttr.prototype.clearSortticketList = function() {
  this.setSortticketList([]);
};


/**
 * repeated string LoadAttr = 4;
 * @return {!Array<string>}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getLoadattrList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setLoadattrList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketRecallRuleAttr.prototype.addLoadattr = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecallRuleAttr.prototype.clearLoadattrList = function() {
  this.setLoadattrList([]);
};


/**
 * repeated string ThirdID = 5;
 * @return {!Array<string>}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getThirdidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setThirdidList = function(value) {
  jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketRecallRuleAttr.prototype.addThirdid = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketRecallRuleAttr.prototype.clearThirdidList = function() {
  this.setThirdidList([]);
};


/**
 * optional string TicketAttrDesc = 6;
 * @return {string}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getTicketattrdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setTicketattrdesc = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Name = 7;
 * @return {string}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string WorkDay = 8;
 * @return {string}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getWorkday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setWorkday = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 WorkStatus = 9;
 * @return {number}
 */
proto.xcommon.TicketRecallRuleAttr.prototype.getWorkstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.TicketRecallRuleAttr.prototype.setWorkstatus = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketRecallRulesItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketRecallRulesItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallRulesItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attrs: (f = msg.getAttrs()) && proto.xcommon.TicketRecallRuleAttr.toObject(includeInstance, f),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketRecallRulesItem}
 */
proto.xcommon.GetTicketRecallRulesItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketRecallRulesItem;
  return proto.xcommon.GetTicketRecallRulesItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketRecallRulesItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketRecallRulesItem}
 */
proto.xcommon.GetTicketRecallRulesItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.xcommon.TicketRecallRuleAttr;
      reader.readMessage(value,proto.xcommon.TicketRecallRuleAttr.deserializeBinaryFromReader);
      msg.setAttrs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketRecallRulesItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketRecallRulesItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketRecallRulesItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAttrs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.TicketRecallRuleAttr.serializeBinaryToWriter
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketRecallRulesItem.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TicketRecallRuleAttr Attrs = 2;
 * @return {?proto.xcommon.TicketRecallRuleAttr}
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.getAttrs = function() {
  return /** @type{?proto.xcommon.TicketRecallRuleAttr} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TicketRecallRuleAttr, 2));
};


/** @param {?proto.xcommon.TicketRecallRuleAttr|undefined} value */
proto.xcommon.GetTicketRecallRulesItem.prototype.setAttrs = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.clearAttrs = function() {
  this.setAttrs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.hasAttrs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 AdminUid = 3;
 * @return {number}
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketRecallRulesItem.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Ctime = 4;
 * @return {number}
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketRecallRulesItem.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 Utime = 5;
 * @return {number}
 */
proto.xcommon.GetTicketRecallRulesItem.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketRecallRulesItem.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Ticket.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Ticket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Ticket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Ticket.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    relatedid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    createuid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    closeuid: jspb.Message.getFieldWithDefault(msg, 9, 0),
    assignuid: jspb.Message.getFieldWithDefault(msg, 10, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 11, 0),
    link: jspb.Message.getFieldWithDefault(msg, 12, ""),
    data: jspb.Message.getFieldWithDefault(msg, 13, ""),
    priority: jspb.Message.getFieldWithDefault(msg, 14, 0),
    communicationway: jspb.Message.getFieldWithDefault(msg, 15, 0),
    isemptynumber: jspb.Message.getFieldWithDefault(msg, 16, 0),
    risklevel: jspb.Message.getFieldWithDefault(msg, 17, 0),
    caselevel: jspb.Message.getFieldWithDefault(msg, 18, ""),
    status: jspb.Message.getFieldWithDefault(msg, 19, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 20, 0),
    expiretime: jspb.Message.getFieldWithDefault(msg, 21, 0),
    assigntime: jspb.Message.getFieldWithDefault(msg, 22, 0),
    starttime: jspb.Message.getFieldWithDefault(msg, 23, 0),
    handlenum: jspb.Message.getFieldWithDefault(msg, 24, 0),
    lasthandletime: jspb.Message.getFieldWithDefault(msg, 25, 0),
    nexthandletime: jspb.Message.getFieldWithDefault(msg, 26, 0),
    customerbesttime: jspb.Message.getFieldWithDefault(msg, 27, ""),
    partialcompletetime: jspb.Message.getFieldWithDefault(msg, 28, 0),
    completetime: jspb.Message.getFieldWithDefault(msg, 29, 0),
    closetime: jspb.Message.getFieldWithDefault(msg, 30, 0),
    applyentrusttime: jspb.Message.getFieldWithDefault(msg, 31, 0),
    closereason: jspb.Message.getFieldWithDefault(msg, 32, ""),
    utime: jspb.Message.getFieldWithDefault(msg, 33, 0),
    shouldrepaydate: jspb.Message.getFieldWithDefault(msg, 34, 0),
    tagitem: jspb.Message.getFieldWithDefault(msg, 35, 0),
    speciallabel: jspb.Message.getFieldWithDefault(msg, 36, 0),
    callbacktime: jspb.Message.getFieldWithDefault(msg, 37, 0),
    stagenum: jspb.Message.getFieldWithDefault(msg, 38, 0),
    isreloan: jspb.Message.getFieldWithDefault(msg, 39, 0),
    isroll: jspb.Message.getFieldWithDefault(msg, 40, 0),
    isstage: jspb.Message.getFieldWithDefault(msg, 41, 0),
    isentrust: jspb.Message.getFieldWithDefault(msg, 42, 0),
    customersource: jspb.Message.getFieldWithDefault(msg, 43, 0),
    ticketpool: jspb.Message.getFieldWithDefault(msg, 44, 0),
    entrustcompany: jspb.Message.getFieldWithDefault(msg, 45, 0),
    lasturgeresult: jspb.Message.getFieldWithDefault(msg, 46, 0),
    remainamount: jspb.Message.getFieldWithDefault(msg, 47, 0),
    repayamount: jspb.Message.getFieldWithDefault(msg, 48, 0),
    stageidx: jspb.Message.getFieldWithDefault(msg, 49, 0),
    lastoverduereason: jspb.Message.getFieldWithDefault(msg, 50, 0),
    lastverifyresult: jspb.Message.getFieldWithDefault(msg, 52, 0),
    assignruleid: jspb.Message.getFieldWithDefault(msg, 53, 0),
    lastinspectionresult: jspb.Message.getFieldWithDefault(msg, 54, 0),
    previtemid: jspb.Message.getFieldWithDefault(msg, 55, 0),
    tags: jspb.Message.getFieldWithDefault(msg, 56, ""),
    fromios: jspb.Message.getFieldWithDefault(msg, 57, 0),
    lastphoneconnect: jspb.Message.getFieldWithDefault(msg, 58, 0),
    isgp: jspb.Message.getFieldWithDefault(msg, 59, 0),
    isrobot: jspb.Message.getFieldWithDefault(msg, 60, 0),
    promiserepayamount: jspb.Message.getFieldWithDefault(msg, 61, ""),
    pretime: jspb.Message.getFieldWithDefault(msg, 62, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 63, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 64, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Ticket}
 */
proto.xcommon.Ticket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Ticket;
  return proto.xcommon.Ticket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Ticket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Ticket}
 */
proto.xcommon.Ticket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRelatedid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreateuid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCloseuid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriority(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCommunicationway(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsemptynumber(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRisklevel(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiretime(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssigntime(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarttime(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHandlenum(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLasthandletime(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNexthandletime(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerbesttime(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPartialcompletetime(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletetime(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClosetime(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplyentrusttime(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosereason(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setShouldrepaydate(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTagitem(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSpeciallabel(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallbacktime(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStagenum(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreloan(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsroll(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsstage(value);
      break;
    case 42:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsentrust(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomersource(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketpool(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEntrustcompany(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLasturgeresult(value);
      break;
    case 47:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRemainamount(value);
      break;
    case 48:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayamount(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStageidx(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastoverduereason(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastverifyresult(value);
      break;
    case 53:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignruleid(value);
      break;
    case 54:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastinspectionresult(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrevitemid(value);
      break;
    case 56:
      var value = /** @type {string} */ (reader.readString());
      msg.setTags(value);
      break;
    case 57:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFromios(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastphoneconnect(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsgp(value);
      break;
    case 60:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsrobot(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromiserepayamount(value);
      break;
    case 62:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPretime(value);
      break;
    case 63:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 64:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Ticket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Ticket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Ticket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Ticket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRelatedid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      7,
      f
    );
  }
  f = message.getCreateuid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCloseuid();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getCommunicationway();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getIsemptynumber();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getRisklevel();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getExpiretime();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getAssigntime();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getStarttime();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getHandlenum();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getLasthandletime();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getNexthandletime();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getCustomerbesttime();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getPartialcompletetime();
  if (f !== 0) {
    writer.writeInt64(
      28,
      f
    );
  }
  f = message.getCompletetime();
  if (f !== 0) {
    writer.writeInt64(
      29,
      f
    );
  }
  f = message.getClosetime();
  if (f !== 0) {
    writer.writeInt64(
      30,
      f
    );
  }
  f = message.getApplyentrusttime();
  if (f !== 0) {
    writer.writeInt64(
      31,
      f
    );
  }
  f = message.getClosereason();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      33,
      f
    );
  }
  f = message.getShouldrepaydate();
  if (f !== 0) {
    writer.writeInt64(
      34,
      f
    );
  }
  f = message.getTagitem();
  if (f !== 0) {
    writer.writeInt64(
      35,
      f
    );
  }
  f = message.getSpeciallabel();
  if (f !== 0) {
    writer.writeInt64(
      36,
      f
    );
  }
  f = message.getCallbacktime();
  if (f !== 0) {
    writer.writeInt64(
      37,
      f
    );
  }
  f = message.getStagenum();
  if (f !== 0) {
    writer.writeInt32(
      38,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt32(
      39,
      f
    );
  }
  f = message.getIsroll();
  if (f !== 0) {
    writer.writeInt32(
      40,
      f
    );
  }
  f = message.getIsstage();
  if (f !== 0) {
    writer.writeInt32(
      41,
      f
    );
  }
  f = message.getIsentrust();
  if (f !== 0) {
    writer.writeInt32(
      42,
      f
    );
  }
  f = message.getCustomersource();
  if (f !== 0) {
    writer.writeInt32(
      43,
      f
    );
  }
  f = message.getTicketpool();
  if (f !== 0) {
    writer.writeInt32(
      44,
      f
    );
  }
  f = message.getEntrustcompany();
  if (f !== 0) {
    writer.writeInt32(
      45,
      f
    );
  }
  f = message.getLasturgeresult();
  if (f !== 0) {
    writer.writeInt32(
      46,
      f
    );
  }
  f = message.getRemainamount();
  if (f !== 0) {
    writer.writeInt64(
      47,
      f
    );
  }
  f = message.getRepayamount();
  if (f !== 0) {
    writer.writeInt64(
      48,
      f
    );
  }
  f = message.getStageidx();
  if (f !== 0) {
    writer.writeInt32(
      49,
      f
    );
  }
  f = message.getLastoverduereason();
  if (f !== 0) {
    writer.writeInt32(
      50,
      f
    );
  }
  f = message.getLastverifyresult();
  if (f !== 0) {
    writer.writeInt32(
      52,
      f
    );
  }
  f = message.getAssignruleid();
  if (f !== 0) {
    writer.writeInt64(
      53,
      f
    );
  }
  f = message.getLastinspectionresult();
  if (f !== 0) {
    writer.writeInt32(
      54,
      f
    );
  }
  f = message.getPrevitemid();
  if (f !== 0) {
    writer.writeInt32(
      55,
      f
    );
  }
  f = message.getTags();
  if (f.length > 0) {
    writer.writeString(
      56,
      f
    );
  }
  f = message.getFromios();
  if (f !== 0) {
    writer.writeInt32(
      57,
      f
    );
  }
  f = message.getLastphoneconnect();
  if (f !== 0) {
    writer.writeInt32(
      58,
      f
    );
  }
  f = message.getIsgp();
  if (f !== 0) {
    writer.writeInt32(
      59,
      f
    );
  }
  f = message.getIsrobot();
  if (f !== 0.0) {
    writer.writeEnum(
      60,
      f
    );
  }
  f = message.getPromiserepayamount();
  if (f.length > 0) {
    writer.writeString(
      61,
      f
    );
  }
  f = message.getPretime();
  if (f !== 0) {
    writer.writeInt64(
      62,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      63,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      64,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Title = 2;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Description = 3;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 ItemID = 4;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 RelatedID = 5;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getRelatedid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setRelatedid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 OrderID = 6;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional int64 CustomerID = 7;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional int64 CreateUID = 8;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getCreateuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setCreateuid = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 CloseUID = 9;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getCloseuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setCloseuid = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 AssignUID = 10;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 Amount = 11;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string Link = 12;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setLink = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string Data = 13;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setData = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 Priority = 14;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setPriority = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 CommunicationWay = 15;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getCommunicationway = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setCommunicationway = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 IsEmptyNumber = 16;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getIsemptynumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setIsemptynumber = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 RiskLevel = 17;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getRisklevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setRisklevel = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string CaseLevel = 18;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setCaselevel = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int32 Status = 19;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 Ctime = 20;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 ExpireTime = 21;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getExpiretime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setExpiretime = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 AssignTime = 22;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getAssigntime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setAssigntime = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 StartTime = 23;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getStarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setStarttime = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int32 HandleNum = 24;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getHandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setHandlenum = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 LastHandleTime = 25;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getLasthandletime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setLasthandletime = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 NextHandleTime = 26;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getNexthandletime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setNexthandletime = function(value) {
  jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional string CustomerBestTime = 27;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getCustomerbesttime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setCustomerbesttime = function(value) {
  jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional int64 PartialCompleteTime = 28;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getPartialcompletetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setPartialcompletetime = function(value) {
  jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * optional int64 CompleteTime = 29;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getCompletetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setCompletetime = function(value) {
  jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional int64 CloseTime = 30;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getClosetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setClosetime = function(value) {
  jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional int64 ApplyEntrustTime = 31;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getApplyentrusttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setApplyentrusttime = function(value) {
  jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional string CloseReason = 32;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getClosereason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setClosereason = function(value) {
  jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional int64 Utime = 33;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional int64 ShouldRepayDate = 34;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getShouldrepaydate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setShouldrepaydate = function(value) {
  jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional int64 TagItem = 35;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getTagitem = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setTagitem = function(value) {
  jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional int64 SpecialLabel = 36;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getSpeciallabel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setSpeciallabel = function(value) {
  jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional int64 CallBackTime = 37;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getCallbacktime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setCallbacktime = function(value) {
  jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * optional int32 StageNum = 38;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getStagenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setStagenum = function(value) {
  jspb.Message.setProto3IntField(this, 38, value);
};


/**
 * optional int32 IsReloan = 39;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3IntField(this, 39, value);
};


/**
 * optional int32 IsRoll = 40;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getIsroll = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setIsroll = function(value) {
  jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional int32 IsStage = 41;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getIsstage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setIsstage = function(value) {
  jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional int32 IsEntrust = 42;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getIsentrust = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 42, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setIsentrust = function(value) {
  jspb.Message.setProto3IntField(this, 42, value);
};


/**
 * optional int32 CustomerSource = 43;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getCustomersource = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 43, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setCustomersource = function(value) {
  jspb.Message.setProto3IntField(this, 43, value);
};


/**
 * optional int32 TicketPool = 44;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getTicketpool = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setTicketpool = function(value) {
  jspb.Message.setProto3IntField(this, 44, value);
};


/**
 * optional int32 EntrustCompany = 45;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getEntrustcompany = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setEntrustcompany = function(value) {
  jspb.Message.setProto3IntField(this, 45, value);
};


/**
 * optional int32 LastUrgeResult = 46;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getLasturgeresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setLasturgeresult = function(value) {
  jspb.Message.setProto3IntField(this, 46, value);
};


/**
 * optional int64 RemainAmount = 47;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getRemainamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setRemainamount = function(value) {
  jspb.Message.setProto3IntField(this, 47, value);
};


/**
 * optional int64 RepayAmount = 48;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getRepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 48, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setRepayamount = function(value) {
  jspb.Message.setProto3IntField(this, 48, value);
};


/**
 * optional int32 StageIdx = 49;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getStageidx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setStageidx = function(value) {
  jspb.Message.setProto3IntField(this, 49, value);
};


/**
 * optional int32 LastOverdueReason = 50;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getLastoverduereason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setLastoverduereason = function(value) {
  jspb.Message.setProto3IntField(this, 50, value);
};


/**
 * optional int32 LastVerifyResult = 52;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getLastverifyresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setLastverifyresult = function(value) {
  jspb.Message.setProto3IntField(this, 52, value);
};


/**
 * optional int64 AssignRuleID = 53;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getAssignruleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setAssignruleid = function(value) {
  jspb.Message.setProto3IntField(this, 53, value);
};


/**
 * optional int32 LastInspectionResult = 54;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getLastinspectionresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setLastinspectionresult = function(value) {
  jspb.Message.setProto3IntField(this, 54, value);
};


/**
 * optional int32 PrevItemID = 55;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getPrevitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setPrevitemid = function(value) {
  jspb.Message.setProto3IntField(this, 55, value);
};


/**
 * optional string Tags = 56;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getTags = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setTags = function(value) {
  jspb.Message.setProto3StringField(this, 56, value);
};


/**
 * optional int32 FromIos = 57;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getFromios = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 57, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setFromios = function(value) {
  jspb.Message.setProto3IntField(this, 57, value);
};


/**
 * optional int32 LastPhoneConnect = 58;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getLastphoneconnect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 58, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setLastphoneconnect = function(value) {
  jspb.Message.setProto3IntField(this, 58, value);
};


/**
 * optional int32 IsGP = 59;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getIsgp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 59, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setIsgp = function(value) {
  jspb.Message.setProto3IntField(this, 59, value);
};


/**
 * optional Bool IsRobot = 60;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.Ticket.prototype.getIsrobot = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 60, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.Ticket.prototype.setIsrobot = function(value) {
  jspb.Message.setProto3EnumField(this, 60, value);
};


/**
 * optional string PromiseRepayAmount = 61;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getPromiserepayamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setPromiserepayamount = function(value) {
  jspb.Message.setProto3StringField(this, 61, value);
};


/**
 * optional int64 PreTime = 62;
 * @return {number}
 */
proto.xcommon.Ticket.prototype.getPretime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 62, 0));
};


/** @param {number} value */
proto.xcommon.Ticket.prototype.setPretime = function(value) {
  jspb.Message.setProto3IntField(this, 62, value);
};


/**
 * optional string AppName = 63;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 63, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 63, value);
};


/**
 * optional string Mobile = 64;
 * @return {string}
 */
proto.xcommon.Ticket.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 64, ""));
};


/** @param {string} value */
proto.xcommon.Ticket.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 64, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.VerifyTicketBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.VerifyTicketBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.VerifyTicketBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VerifyTicketBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && proto.xcommon.Ticket.toObject(includeInstance, f),
    casename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 4, ""),
    verifyresult: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isstatusdone: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    appname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    auditorname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    assignworkstatus: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.VerifyTicketBackend}
 */
proto.xcommon.VerifyTicketBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.VerifyTicketBackend;
  return proto.xcommon.VerifyTicketBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.VerifyTicketBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.VerifyTicketBackend}
 */
proto.xcommon.VerifyTicketBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.Ticket;
      reader.readMessage(value,proto.xcommon.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerifyresult(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsstatusdone(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditorname(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.UserWorkStatus} */ (reader.readEnum());
      msg.setAssignworkstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.VerifyTicketBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.VerifyTicketBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.VerifyTicketBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VerifyTicketBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVerifyresult();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsstatusdone();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAuditorname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAssignworkstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.VerifyTicketBackend.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Ticket, 1));
};


/** @param {?proto.xcommon.Ticket|undefined} value */
proto.xcommon.VerifyTicketBackend.prototype.setTicket = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.VerifyTicketBackend.prototype.clearTicket = function() {
  this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.VerifyTicketBackend.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string CaseName = 2;
 * @return {string}
 */
proto.xcommon.VerifyTicketBackend.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.VerifyTicketBackend.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AssignName = 3;
 * @return {string}
 */
proto.xcommon.VerifyTicketBackend.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.VerifyTicketBackend.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TicketStatus = 4;
 * @return {string}
 */
proto.xcommon.VerifyTicketBackend.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.VerifyTicketBackend.prototype.setTicketstatus = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string VerifyResult = 5;
 * @return {string}
 */
proto.xcommon.VerifyTicketBackend.prototype.getVerifyresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.VerifyTicketBackend.prototype.setVerifyresult = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool IsStatusDone = 6;
 * @return {boolean}
 */
proto.xcommon.VerifyTicketBackend.prototype.getIsstatusdone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.xcommon.VerifyTicketBackend.prototype.setIsstatusdone = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string AppName = 7;
 * @return {string}
 */
proto.xcommon.VerifyTicketBackend.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.VerifyTicketBackend.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string AuditorName = 8;
 * @return {string}
 */
proto.xcommon.VerifyTicketBackend.prototype.getAuditorname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.VerifyTicketBackend.prototype.setAuditorname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional UserWorkStatus AssignWorkStatus = 9;
 * @return {!proto.xcommon.UserWorkStatus}
 */
proto.xcommon.VerifyTicketBackend.prototype.getAssignworkstatus = function() {
  return /** @type {!proto.xcommon.UserWorkStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.UserWorkStatus} value */
proto.xcommon.VerifyTicketBackend.prototype.setAssignworkstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TicketBackend.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && proto.xcommon.Ticket.toObject(includeInstance, f),
    casename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 4, ""),
    urgeresult: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isstatusdone: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    entrustcompany: jspb.Message.getFieldWithDefault(msg, 7, ""),
    lasturgeremark: jspb.Message.getFieldWithDefault(msg, 8, ""),
    overdueday: jspb.Message.getFieldWithDefault(msg, 9, 0),
    risklevel: jspb.Message.getFieldWithDefault(msg, 10, ""),
    phoneobjectset: jspb.Message.getFieldWithDefault(msg, 11, ""),
    urgetypeset: jspb.Message.getFieldWithDefault(msg, 12, ""),
    overduereason: jspb.Message.getFieldWithDefault(msg, 13, ""),
    ordertags: (f = msg.getOrdertags()) && xcommon_core_pb.OrderTagExtInfo.toObject(includeInstance, f),
    casetype: jspb.Message.getFieldWithDefault(msg, 15, 0),
    orderstatus: jspb.Message.getFieldWithDefault(msg, 16, ""),
    tickettagsList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    phonesaletag: jspb.Message.getFieldWithDefault(msg, 18, ""),
    accountstatus: jspb.Message.getFieldWithDefault(msg, 19, ""),
    prestatus: jspb.Message.getFieldWithDefault(msg, 21, ""),
    suspendtime: jspb.Message.getFieldWithDefault(msg, 22, 0),
    suspenduid: jspb.Message.getFieldWithDefault(msg, 23, 0),
    suspenduser: jspb.Message.getFieldWithDefault(msg, 24, ""),
    customization: (f = msg.getCustomization()) && xcommon_core_pb.OrderCustomization.toObject(includeInstance, f),
    appname: jspb.Message.getFieldWithDefault(msg, 26, ""),
    isnewticket: jspb.Message.getFieldWithDefault(msg, 27, 0),
    mobile: jspb.Message.getFieldWithDefault(msg, 28, ""),
    contact1: jspb.Message.getFieldWithDefault(msg, 29, ""),
    contact2: jspb.Message.getFieldWithDefault(msg, 30, ""),
    contact3: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketBackend}
 */
proto.xcommon.TicketBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketBackend;
  return proto.xcommon.TicketBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketBackend}
 */
proto.xcommon.TicketBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.Ticket;
      reader.readMessage(value,proto.xcommon.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrgeresult(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsstatusdone(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntrustcompany(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLasturgeremark(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverdueday(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRisklevel(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobjectset(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrgetypeset(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverduereason(value);
      break;
    case 14:
      var value = new xcommon_core_pb.OrderTagExtInfo;
      reader.readMessage(value,xcommon_core_pb.OrderTagExtInfo.deserializeBinaryFromReader);
      msg.setOrdertags(value);
      break;
    case 15:
      var value = /** @type {!proto.xcommon.CollectionType} */ (reader.readEnum());
      msg.setCasetype(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderstatus(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickettags(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonesaletag(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountstatus(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrestatus(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuspendtime(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuspenduid(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuspenduser(value);
      break;
    case 25:
      var value = new xcommon_core_pb.OrderCustomization;
      reader.readMessage(value,xcommon_core_pb.OrderCustomization.deserializeBinaryFromReader);
      msg.setCustomization(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsnewticket(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact1(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact2(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrgeresult();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsstatusdone();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getEntrustcompany();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLasturgeremark();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOverdueday();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getRisklevel();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPhoneobjectset();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getUrgetypeset();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getOverduereason();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOrdertags();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      xcommon_core_pb.OrderTagExtInfo.serializeBinaryToWriter
    );
  }
  f = message.getCasetype();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getOrderstatus();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTickettagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = message.getPhonesaletag();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAccountstatus();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getPrestatus();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getSuspendtime();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getSuspenduid();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getSuspenduser();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getCustomization();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      xcommon_core_pb.OrderCustomization.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getIsnewticket();
  if (f !== 0) {
    writer.writeInt64(
      27,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getContact1();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getContact2();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getContact3();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.TicketBackend.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Ticket, 1));
};


/** @param {?proto.xcommon.Ticket|undefined} value */
proto.xcommon.TicketBackend.prototype.setTicket = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.TicketBackend.prototype.clearTicket = function() {
  this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.TicketBackend.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string CaseName = 2;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AssignName = 3;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TicketStatus = 4;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setTicketstatus = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UrgeResult = 5;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getUrgeresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setUrgeresult = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool IsStatusDone = 6;
 * @return {boolean}
 */
proto.xcommon.TicketBackend.prototype.getIsstatusdone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.xcommon.TicketBackend.prototype.setIsstatusdone = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string EntrustCompany = 7;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getEntrustcompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setEntrustcompany = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string LastUrgeRemark = 8;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getLasturgeremark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setLasturgeremark = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 OverdueDay = 9;
 * @return {number}
 */
proto.xcommon.TicketBackend.prototype.getOverdueday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.TicketBackend.prototype.setOverdueday = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string RiskLevel = 10;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getRisklevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setRisklevel = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string PhoneObjectSet = 11;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getPhoneobjectset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setPhoneobjectset = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string UrgeTypeSet = 12;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getUrgetypeset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setUrgetypeset = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string OverdueReason = 13;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getOverduereason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setOverduereason = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional OrderTagExtInfo OrderTags = 14;
 * @return {?proto.xcommon.OrderTagExtInfo}
 */
proto.xcommon.TicketBackend.prototype.getOrdertags = function() {
  return /** @type{?proto.xcommon.OrderTagExtInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.OrderTagExtInfo, 14));
};


/** @param {?proto.xcommon.OrderTagExtInfo|undefined} value */
proto.xcommon.TicketBackend.prototype.setOrdertags = function(value) {
  jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.TicketBackend.prototype.clearOrdertags = function() {
  this.setOrdertags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.TicketBackend.prototype.hasOrdertags = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional CollectionType CaseType = 15;
 * @return {!proto.xcommon.CollectionType}
 */
proto.xcommon.TicketBackend.prototype.getCasetype = function() {
  return /** @type {!proto.xcommon.CollectionType} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {!proto.xcommon.CollectionType} value */
proto.xcommon.TicketBackend.prototype.setCasetype = function(value) {
  jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string OrderStatus = 16;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getOrderstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setOrderstatus = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * repeated string TicketTags = 17;
 * @return {!Array<string>}
 */
proto.xcommon.TicketBackend.prototype.getTickettagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/** @param {!Array<string>} value */
proto.xcommon.TicketBackend.prototype.setTickettagsList = function(value) {
  jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TicketBackend.prototype.addTickettags = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TicketBackend.prototype.clearTickettagsList = function() {
  this.setTickettagsList([]);
};


/**
 * optional string PhoneSaleTag = 18;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getPhonesaletag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setPhonesaletag = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string AccountStatus = 19;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getAccountstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setAccountstatus = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string PreStatus = 21;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getPrestatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setPrestatus = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional int64 SuspendTime = 22;
 * @return {number}
 */
proto.xcommon.TicketBackend.prototype.getSuspendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.TicketBackend.prototype.setSuspendtime = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 SuspendUID = 23;
 * @return {number}
 */
proto.xcommon.TicketBackend.prototype.getSuspenduid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.TicketBackend.prototype.setSuspenduid = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string SuspendUser = 24;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getSuspenduser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setSuspenduser = function(value) {
  jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional OrderCustomization Customization = 25;
 * @return {?proto.xcommon.OrderCustomization}
 */
proto.xcommon.TicketBackend.prototype.getCustomization = function() {
  return /** @type{?proto.xcommon.OrderCustomization} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.OrderCustomization, 25));
};


/** @param {?proto.xcommon.OrderCustomization|undefined} value */
proto.xcommon.TicketBackend.prototype.setCustomization = function(value) {
  jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.TicketBackend.prototype.clearCustomization = function() {
  this.setCustomization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.TicketBackend.prototype.hasCustomization = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional string AppName = 26;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional int64 IsNewTicket = 27;
 * @return {number}
 */
proto.xcommon.TicketBackend.prototype.getIsnewticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/** @param {number} value */
proto.xcommon.TicketBackend.prototype.setIsnewticket = function(value) {
  jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional string Mobile = 28;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string Contact1 = 29;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getContact1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setContact1 = function(value) {
  jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string Contact2 = 30;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getContact2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setContact2 = function(value) {
  jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string Contact3 = 31;
 * @return {string}
 */
proto.xcommon.TicketBackend.prototype.getContact3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/** @param {string} value */
proto.xcommon.TicketBackend.prototype.setContact3 = function(value) {
  jspb.Message.setProto3StringField(this, 31, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketItemListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketItemListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketItemListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketItemListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    isstage: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketItemListReq}
 */
proto.xcommon.GetTicketItemListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketItemListReq;
  return proto.xcommon.GetTicketItemListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketItemListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketItemListReq}
 */
proto.xcommon.GetTicketItemListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsstage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketItemListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketItemListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketItemListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketItemListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getIsstage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketItemListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketItemListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketItemListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketItemListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 IsStage = 2;
 * @return {number}
 */
proto.xcommon.GetTicketItemListReq.prototype.getIsstage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketItemListReq.prototype.setIsstage = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketItemListResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketItemListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketItemListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketItemListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketItemListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.TicketItem.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketItemListResp}
 */
proto.xcommon.GetTicketItemListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketItemListResp;
  return proto.xcommon.GetTicketItemListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketItemListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketItemListResp}
 */
proto.xcommon.GetTicketItemListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.TicketItem;
      reader.readMessage(value,proto.xcommon.TicketItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketItemListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketItemListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketItemListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketItemListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.TicketItem.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketItemListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketItemListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketItemListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketItemListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TicketItem List = 2;
 * @return {!Array<!proto.xcommon.TicketItem>}
 */
proto.xcommon.GetTicketItemListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.TicketItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketItem, 2));
};


/** @param {!Array<!proto.xcommon.TicketItem>} value */
proto.xcommon.GetTicketItemListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.TicketItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketItem}
 */
proto.xcommon.GetTicketItemListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.TicketItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketItemListResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional int64 Total = 3;
 * @return {number}
 */
proto.xcommon.GetTicketItemListResp.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketItemListResp.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketCaseNameListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketCaseNameListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketCaseNameListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketCaseNameListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    isstage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketCaseNameListReq}
 */
proto.xcommon.GetTicketCaseNameListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketCaseNameListReq;
  return proto.xcommon.GetTicketCaseNameListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketCaseNameListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketCaseNameListReq}
 */
proto.xcommon.GetTicketCaseNameListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsstage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketCaseNameListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketCaseNameListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketCaseNameListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketCaseNameListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getIsstage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketCaseNameListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketCaseNameListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketCaseNameListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketCaseNameListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 IsStage = 2;
 * @return {number}
 */
proto.xcommon.GetTicketCaseNameListReq.prototype.getIsstage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.GetTicketCaseNameListReq.prototype.setIsstage = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.GetTicketCaseNameListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetTicketCaseNameListReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketCaseNameListResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketCaseNameListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketCaseNameListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketCaseNameListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketCaseNameListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketCaseNameListResp}
 */
proto.xcommon.GetTicketCaseNameListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketCaseNameListResp;
  return proto.xcommon.GetTicketCaseNameListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketCaseNameListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketCaseNameListResp}
 */
proto.xcommon.GetTicketCaseNameListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketCaseNameListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketCaseNameListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketCaseNameListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketCaseNameListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketCaseNameListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketCaseNameListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketCaseNameListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketCaseNameListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string List = 2;
 * @return {!Array<string>}
 */
proto.xcommon.GetTicketCaseNameListResp.prototype.getListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.GetTicketCaseNameListResp.prototype.setListList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.GetTicketCaseNameListResp.prototype.addList = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketCaseNameListResp.prototype.clearListList = function() {
  this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SaveTicketItemsReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveTicketItemsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveTicketItemsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveTicketItemsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketItemsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    isstage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.TicketItem.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveTicketItemsReq}
 */
proto.xcommon.SaveTicketItemsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveTicketItemsReq;
  return proto.xcommon.SaveTicketItemsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveTicketItemsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveTicketItemsReq}
 */
proto.xcommon.SaveTicketItemsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsstage(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketItem;
      reader.readMessage(value,proto.xcommon.TicketItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveTicketItemsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveTicketItemsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveTicketItemsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveTicketItemsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getIsstage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.TicketItem.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveTicketItemsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveTicketItemsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveTicketItemsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveTicketItemsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 IsStage = 2;
 * @return {number}
 */
proto.xcommon.SaveTicketItemsReq.prototype.getIsstage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveTicketItemsReq.prototype.setIsstage = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated TicketItem List = 3;
 * @return {!Array<!proto.xcommon.TicketItem>}
 */
proto.xcommon.SaveTicketItemsReq.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.TicketItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketItem, 3));
};


/** @param {!Array<!proto.xcommon.TicketItem>} value */
proto.xcommon.SaveTicketItemsReq.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.TicketItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketItem}
 */
proto.xcommon.SaveTicketItemsReq.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.TicketItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SaveTicketItemsReq.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.SaveTicketItemsReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SaveTicketItemsReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DelTicketItemReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DelTicketItemReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DelTicketItemReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelTicketItemReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    isstage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    casename: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DelTicketItemReq}
 */
proto.xcommon.DelTicketItemReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DelTicketItemReq;
  return proto.xcommon.DelTicketItemReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DelTicketItemReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DelTicketItemReq}
 */
proto.xcommon.DelTicketItemReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsstage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DelTicketItemReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DelTicketItemReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DelTicketItemReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelTicketItemReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getIsstage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DelTicketItemReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DelTicketItemReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DelTicketItemReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DelTicketItemReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 IsStage = 2;
 * @return {number}
 */
proto.xcommon.DelTicketItemReq.prototype.getIsstage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DelTicketItemReq.prototype.setIsstage = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string CaseName = 3;
 * @return {string}
 */
proto.xcommon.DelTicketItemReq.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.DelTicketItemReq.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    casename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    casetype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isstage: jspb.Message.getFieldWithDefault(msg, 5, 0),
    startday: jspb.Message.getFieldWithDefault(msg, 6, 0),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0),
    outsource: jspb.Message.getFieldWithDefault(msg, 8, 0),
    isdeleted: jspb.Message.getFieldWithDefault(msg, 9, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketItem}
 */
proto.xcommon.TicketItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketItem;
  return proto.xcommon.TicketItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketItem}
 */
proto.xcommon.TicketItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCasetype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsstage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStartday(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOutsource(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsdeleted(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCasetype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIsstage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStartday();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getOutsource();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getIsdeleted();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string CaseName = 2;
 * @return {string}
 */
proto.xcommon.TicketItem.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.TicketItem.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Description = 3;
 * @return {string}
 */
proto.xcommon.TicketItem.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.TicketItem.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 CaseType = 4;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getCasetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setCasetype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 IsStage = 5;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getIsstage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setIsstage = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 StartDay = 6;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getStartday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setStartday = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 Status = 7;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 OutSource = 8;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getOutsource = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setOutsource = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 IsDeleted = 9;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getIsdeleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setIsdeleted = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Ctime = 10;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 Utime = 11;
 * @return {number}
 */
proto.xcommon.TicketItem.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.TicketItem.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWorkerPerformanceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWorkerPerformanceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerPerformanceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    statstype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    statssort: jspb.Message.getFieldWithDefault(msg, 4, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    username: jspb.Message.getFieldWithDefault(msg, 7, ""),
    timerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    email: jspb.Message.getFieldWithDefault(msg, 9, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 10, 0),
    hour: jspb.Message.getFieldWithDefault(msg, 11, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 12, ""),
    loantype: jspb.Message.getFieldWithDefault(msg, 13, 0),
    iscompleted: jspb.Message.getFieldWithDefault(msg, 14, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 15, ""),
    starthour: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWorkerPerformanceReq}
 */
proto.xcommon.GetWorkerPerformanceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWorkerPerformanceReq;
  return proto.xcommon.GetWorkerPerformanceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWorkerPerformanceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWorkerPerformanceReq}
 */
proto.xcommon.GetWorkerPerformanceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.StatsType} */ (reader.readEnum());
      msg.setStatstype(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.StatsSort} */ (reader.readEnum());
      msg.setStatssort(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHour(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIscompleted(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarthour(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWorkerPerformanceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWorkerPerformanceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerPerformanceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getStatstype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatssort();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getHour();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getIscompleted();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getStarthour();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StatsType StatsType = 3;
 * @return {!proto.xcommon.StatsType}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getStatstype = function() {
  return /** @type {!proto.xcommon.StatsType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.StatsType} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setStatstype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional StatsSort StatsSort = 4;
 * @return {!proto.xcommon.StatsSort}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getStatssort = function() {
  return /** @type {!proto.xcommon.StatsSort} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.StatsSort} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setStatssort = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 UserGroupId = 5;
 * @return {number}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 ItemId = 6;
 * @return {number}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string UserName = 7;
 * @return {string}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string TimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Email = 9;
 * @return {string}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 UserId = 10;
 * @return {number}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 Hour = 11;
 * @return {number}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setHour = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string EmployeeID = 12;
 * @return {string}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional LoanTypeEnum LoanType = 13;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional int32 IsCompleted = 14;
 * @return {number}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getIscompleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setIscompleted = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string AppName = 15;
 * @return {string}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int64 StartHour = 16;
 * @return {number}
 */
proto.xcommon.GetWorkerPerformanceReq.prototype.getStarthour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerPerformanceReq.prototype.setStarthour = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetWorkerPerformanceResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWorkerPerformanceResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWorkerPerformanceResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerPerformanceResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    totalstats: (f = msg.getTotalstats()) && proto.xcommon.PerformanceStat.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.PerformanceStat.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updatetime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWorkerPerformanceResp}
 */
proto.xcommon.GetWorkerPerformanceResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWorkerPerformanceResp;
  return proto.xcommon.GetWorkerPerformanceResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWorkerPerformanceResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWorkerPerformanceResp}
 */
proto.xcommon.GetWorkerPerformanceResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.PerformanceStat;
      reader.readMessage(value,proto.xcommon.PerformanceStat.deserializeBinaryFromReader);
      msg.setTotalstats(value);
      break;
    case 3:
      var value = new proto.xcommon.PerformanceStat;
      reader.readMessage(value,proto.xcommon.PerformanceStat.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWorkerPerformanceResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWorkerPerformanceResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerPerformanceResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTotalstats();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.PerformanceStat.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.PerformanceStat.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetWorkerPerformanceResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PerformanceStat TotalStats = 2;
 * @return {?proto.xcommon.PerformanceStat}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.getTotalstats = function() {
  return /** @type{?proto.xcommon.PerformanceStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.PerformanceStat, 2));
};


/** @param {?proto.xcommon.PerformanceStat|undefined} value */
proto.xcommon.GetWorkerPerformanceResp.prototype.setTotalstats = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.clearTotalstats = function() {
  this.setTotalstats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.hasTotalstats = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PerformanceStat List = 3;
 * @return {!Array<!proto.xcommon.PerformanceStat>}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.PerformanceStat>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PerformanceStat, 3));
};


/** @param {!Array<!proto.xcommon.PerformanceStat>} value */
proto.xcommon.GetWorkerPerformanceResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.PerformanceStat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PerformanceStat}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.PerformanceStat, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional int64 Total = 4;
 * @return {number}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerPerformanceResp.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 UpdateTime = 5;
 * @return {number}
 */
proto.xcommon.GetWorkerPerformanceResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerPerformanceResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PerformanceStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PerformanceStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PerformanceStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PerformanceStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ranking: jspb.Message.getFieldWithDefault(msg, 4, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    leaderroleid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assignnum: jspb.Message.getFieldWithDefault(msg, 7, 0),
    handlenum: jspb.Message.getFieldWithDefault(msg, 8, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 9, 0),
    loadnum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    avgcosttime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    loadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 12, 0),
    subloadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 13, 0),
    repayprincipal: jspb.Message.getFieldWithDefault(msg, 14, 0),
    repayinterest: jspb.Message.getFieldWithDefault(msg, 15, 0),
    repaytotal: jspb.Message.getFieldWithDefault(msg, 16, 0),
    bonusamount: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
    difftargetrepay: jspb.Message.getFieldWithDefault(msg, 18, 0),
    numberofcollections: jspb.Message.getFieldWithDefault(msg, 19, 0),
    deductionamount: jspb.Message.getFieldWithDefault(msg, 20, 0),
    deductionnumber: jspb.Message.getFieldWithDefault(msg, 21, 0),
    rollneworderrepayment: jspb.Message.getFieldWithDefault(msg, 22, 0),
    rolltotalrepayment: jspb.Message.getFieldWithDefault(msg, 23, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 24, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 25, 0),
    handlepoint: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
    completepoint: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
    repayamountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
    targetrepayrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
    casename: jspb.Message.getFieldWithDefault(msg, 30, ""),
    username: jspb.Message.getFieldWithDefault(msg, 31, ""),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 32, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 33, ""),
    loantype: jspb.Message.getFieldWithDefault(msg, 34, 0),
    rollnum: jspb.Message.getFieldWithDefault(msg, 35, 0),
    iscompleted: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
    outurgerate: jspb.Message.getFloatingPointFieldWithDefault(msg, 37, 0.0),
    targetouturgerate: jspb.Message.getFloatingPointFieldWithDefault(msg, 38, 0.0),
    rollfinishnum: jspb.Message.getFieldWithDefault(msg, 39, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 40, ""),
    lasthandletime: jspb.Message.getFieldWithDefault(msg, 41, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PerformanceStat}
 */
proto.xcommon.PerformanceStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PerformanceStat;
  return proto.xcommon.PerformanceStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PerformanceStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PerformanceStat}
 */
proto.xcommon.PerformanceStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRanking(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeaderroleid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignnum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandlenum(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadnum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvgcosttime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadleftunpaidprincipal(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubloadleftunpaidprincipal(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayprincipal(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayinterest(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytotal(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBonusamount(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDifftargetrepay(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumberofcollections(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeductionamount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeductionnumber(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRollneworderrepayment(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRolltotalrepayment(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHandlepoint(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCompletepoint(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepayamountrate(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetrepayrate(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 34:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRollnum(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscompleted(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOuturgerate(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetouturgerate(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRollfinishnum(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLasthandletime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PerformanceStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PerformanceStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PerformanceStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PerformanceStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRanking();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getLeaderroleid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAssignnum();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getHandlenum();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getLoadnum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAvgcosttime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getLoadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getSubloadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getRepayprincipal();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getRepayinterest();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getRepaytotal();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getBonusamount();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getDifftargetrepay();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getNumberofcollections();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getDeductionamount();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getDeductionnumber();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getRollneworderrepayment();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getRolltotalrepayment();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getHandlepoint();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getCompletepoint();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getRepayamountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getTargetrepayrate();
  if (f !== 0.0) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      34,
      f
    );
  }
  f = message.getRollnum();
  if (f !== 0) {
    writer.writeInt64(
      35,
      f
    );
  }
  f = message.getIscompleted();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getOuturgerate();
  if (f !== 0.0) {
    writer.writeDouble(
      37,
      f
    );
  }
  f = message.getTargetouturgerate();
  if (f !== 0.0) {
    writer.writeDouble(
      38,
      f
    );
  }
  f = message.getRollfinishnum();
  if (f !== 0) {
    writer.writeInt64(
      39,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getLasthandletime();
  if (f !== 0) {
    writer.writeInt64(
      41,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Date = 2;
 * @return {string}
 */
proto.xcommon.PerformanceStat.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.PerformanceStat.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 TicketItemID = 3;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 Ranking = 4;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRanking = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRanking = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 AdminUID = 5;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 LeaderRoleID = 6;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getLeaderroleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setLeaderroleid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AssignNum = 7;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getAssignnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setAssignnum = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 HandleNum = 8;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getHandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setHandlenum = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 CompleteNum = 9;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 LoadNum = 10;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getLoadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setLoadnum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 AvgCostTime = 11;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getAvgcosttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setAvgcosttime = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 LoadLeftUnpaidPrincipal = 12;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getLoadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setLoadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 SubLoadLeftUnpaidPrincipal = 13;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getSubloadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setSubloadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 RepayPrincipal = 14;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRepayprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRepayprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 RepayInterest = 15;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRepayinterest = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRepayinterest = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 RepayTotal = 16;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRepaytotal = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional double BonusAmount = 17;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getBonusamount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setBonusamount = function(value) {
  jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional int64 DiffTargetRepay = 18;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getDifftargetrepay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setDifftargetrepay = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 NumberOfCollections = 19;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getNumberofcollections = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setNumberofcollections = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 DeductionAmount = 20;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getDeductionamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setDeductionamount = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 DeductionNumber = 21;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getDeductionnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setDeductionnumber = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 RollNewOrderRepayment = 22;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRollneworderrepayment = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRollneworderrepayment = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 RollTotalRepayment = 23;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRolltotalrepayment = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRolltotalrepayment = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int64 Ctime = 24;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 Utime = 25;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional double HandlePoint = 26;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getHandlepoint = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setHandlepoint = function(value) {
  jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double CompletePoint = 27;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getCompletepoint = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setCompletepoint = function(value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional double RepayAmountRate = 28;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRepayamountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRepayamountrate = function(value) {
  jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional double TargetRepayRate = 29;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getTargetrepayrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setTargetrepayrate = function(value) {
  jspb.Message.setProto3FloatField(this, 29, value);
};


/**
 * optional string CaseName = 30;
 * @return {string}
 */
proto.xcommon.PerformanceStat.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/** @param {string} value */
proto.xcommon.PerformanceStat.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string UserName = 31;
 * @return {string}
 */
proto.xcommon.PerformanceStat.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/** @param {string} value */
proto.xcommon.PerformanceStat.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string UserGroupName = 32;
 * @return {string}
 */
proto.xcommon.PerformanceStat.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/** @param {string} value */
proto.xcommon.PerformanceStat.prototype.setUsergroupname = function(value) {
  jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string EmployeeID = 33;
 * @return {string}
 */
proto.xcommon.PerformanceStat.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/** @param {string} value */
proto.xcommon.PerformanceStat.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional LoanTypeEnum LoanType = 34;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.PerformanceStat.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.PerformanceStat.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 34, value);
};


/**
 * optional int64 RollNum = 35;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRollnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRollnum = function(value) {
  jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional bool IsCompleted = 36;
 * @return {boolean}
 */
proto.xcommon.PerformanceStat.prototype.getIscompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/** @param {boolean} value */
proto.xcommon.PerformanceStat.prototype.setIscompleted = function(value) {
  jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional double OutUrgeRate = 37;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getOuturgerate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 37, 0.0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setOuturgerate = function(value) {
  jspb.Message.setProto3FloatField(this, 37, value);
};


/**
 * optional double TargetOutUrgeRate = 38;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getTargetouturgerate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 38, 0.0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setTargetouturgerate = function(value) {
  jspb.Message.setProto3FloatField(this, 38, value);
};


/**
 * optional int64 RollFinishNum = 39;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getRollfinishnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setRollfinishnum = function(value) {
  jspb.Message.setProto3IntField(this, 39, value);
};


/**
 * optional string AppName = 40;
 * @return {string}
 */
proto.xcommon.PerformanceStat.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/** @param {string} value */
proto.xcommon.PerformanceStat.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional int64 LastHandleTime = 41;
 * @return {number}
 */
proto.xcommon.PerformanceStat.prototype.getLasthandletime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/** @param {number} value */
proto.xcommon.PerformanceStat.prototype.setLasthandletime = function(value) {
  jspb.Message.setProto3IntField(this, 41, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRolePerformanceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRolePerformanceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRolePerformanceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRolePerformanceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    timerange: jspb.Message.getFieldWithDefault(msg, 3, ""),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    comparetype: jspb.Message.getFieldWithDefault(msg, 8, 0),
    statstype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRolePerformanceReq}
 */
proto.xcommon.GetRolePerformanceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRolePerformanceReq;
  return proto.xcommon.GetRolePerformanceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRolePerformanceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRolePerformanceReq}
 */
proto.xcommon.GetRolePerformanceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.CompareType} */ (reader.readEnum());
      msg.setComparetype(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.StatsType} */ (reader.readEnum());
      msg.setStatstype(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRolePerformanceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRolePerformanceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRolePerformanceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRolePerformanceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getComparetype();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getStatstype();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetRolePerformanceReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRolePerformanceReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRolePerformanceReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetRolePerformanceReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRolePerformanceReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRolePerformanceReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string TimeRange = 3;
 * @return {string}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetRolePerformanceReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 UserGroupId = 4;
 * @return {number}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetRolePerformanceReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string UserName = 5;
 * @return {string}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetRolePerformanceReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 UserId = 6;
 * @return {number}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.GetRolePerformanceReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 ItemId = 7;
 * @return {number}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.GetRolePerformanceReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional CompareType CompareType = 8;
 * @return {!proto.xcommon.CompareType}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getComparetype = function() {
  return /** @type {!proto.xcommon.CompareType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.CompareType} value */
proto.xcommon.GetRolePerformanceReq.prototype.setComparetype = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional StatsType StatsType = 9;
 * @return {!proto.xcommon.StatsType}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getStatstype = function() {
  return /** @type {!proto.xcommon.StatsType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.StatsType} value */
proto.xcommon.GetRolePerformanceReq.prototype.setStatstype = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string AppName = 10;
 * @return {string}
 */
proto.xcommon.GetRolePerformanceReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.GetRolePerformanceReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRolePerformanceResp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRolePerformanceResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRolePerformanceResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRolePerformanceResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRolePerformanceResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    updatetime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.RoleStats.toObject, includeInstance),
    totalstats: (f = msg.getTotalstats()) && proto.xcommon.RoleStats.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRolePerformanceResp}
 */
proto.xcommon.GetRolePerformanceResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRolePerformanceResp;
  return proto.xcommon.GetRolePerformanceResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRolePerformanceResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRolePerformanceResp}
 */
proto.xcommon.GetRolePerformanceResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    case 4:
      var value = new proto.xcommon.RoleStats;
      reader.readMessage(value,proto.xcommon.RoleStats.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 5:
      var value = new proto.xcommon.RoleStats;
      reader.readMessage(value,proto.xcommon.RoleStats.deserializeBinaryFromReader);
      msg.setTotalstats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRolePerformanceResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRolePerformanceResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRolePerformanceResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRolePerformanceResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.RoleStats.serializeBinaryToWriter
    );
  }
  f = message.getTotalstats();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.RoleStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRolePerformanceResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetRolePerformanceResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRolePerformanceResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRolePerformanceResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetRolePerformanceResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetRolePerformanceResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRolePerformanceResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRolePerformanceResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 UpdateTime = 3;
 * @return {number}
 */
proto.xcommon.GetRolePerformanceResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetRolePerformanceResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated RoleStats List = 4;
 * @return {!Array<!proto.xcommon.RoleStats>}
 */
proto.xcommon.GetRolePerformanceResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.RoleStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RoleStats, 4));
};


/** @param {!Array<!proto.xcommon.RoleStats>} value */
proto.xcommon.GetRolePerformanceResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.RoleStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RoleStats}
 */
proto.xcommon.GetRolePerformanceResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.RoleStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetRolePerformanceResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional RoleStats TotalStats = 5;
 * @return {?proto.xcommon.RoleStats}
 */
proto.xcommon.GetRolePerformanceResp.prototype.getTotalstats = function() {
  return /** @type{?proto.xcommon.RoleStats} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.RoleStats, 5));
};


/** @param {?proto.xcommon.RoleStats|undefined} value */
proto.xcommon.GetRolePerformanceResp.prototype.setTotalstats = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRolePerformanceResp.prototype.clearTotalstats = function() {
  this.setTotalstats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRolePerformanceResp.prototype.hasTotalstats = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RoleStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RoleStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RoleStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RoleStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    daterange: jspb.Message.getFieldWithDefault(msg, 1, ""),
    casename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    username: jspb.Message.getFieldWithDefault(msg, 3, ""),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ranking: jspb.Message.getFieldWithDefault(msg, 5, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assignnum: jspb.Message.getFieldWithDefault(msg, 7, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 8, 0),
    loadnum: jspb.Message.getFieldWithDefault(msg, 9, 0),
    handlenum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    avgcosttime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    loadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 12, 0),
    subloadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 13, 0),
    repayprincipal: jspb.Message.getFieldWithDefault(msg, 14, 0),
    repayinterest: jspb.Message.getFieldWithDefault(msg, 15, 0),
    repaytotal: jspb.Message.getFieldWithDefault(msg, 16, 0),
    bonusamount: jspb.Message.getFieldWithDefault(msg, 17, 0),
    difftargetrepay: jspb.Message.getFieldWithDefault(msg, 18, 0),
    numberofcollections: jspb.Message.getFieldWithDefault(msg, 19, 0),
    deductionamount: jspb.Message.getFieldWithDefault(msg, 20, 0),
    deductionnumber: jspb.Message.getFieldWithDefault(msg, 21, 0),
    rollneworderrepayment: jspb.Message.getFieldWithDefault(msg, 22, 0),
    rolltotalrepayment: jspb.Message.getFieldWithDefault(msg, 23, 0),
    handlepoint: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
    completepoint: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    repayamountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
    targetrepayrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RoleStats}
 */
proto.xcommon.RoleStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RoleStats;
  return proto.xcommon.RoleStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RoleStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RoleStats}
 */
proto.xcommon.RoleStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDaterange(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRanking(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignnum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadnum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandlenum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvgcosttime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadleftunpaidprincipal(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubloadleftunpaidprincipal(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayprincipal(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayinterest(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytotal(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBonusamount(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDifftargetrepay(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumberofcollections(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeductionamount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeductionnumber(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRollneworderrepayment(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRolltotalrepayment(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHandlepoint(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCompletepoint(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepayamountrate(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetrepayrate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RoleStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RoleStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RoleStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RoleStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaterange();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRanking();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAssignnum();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getLoadnum();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getHandlenum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAvgcosttime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getLoadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getSubloadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getRepayprincipal();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getRepayinterest();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getRepaytotal();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getBonusamount();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getDifftargetrepay();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getNumberofcollections();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getDeductionamount();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getDeductionnumber();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getRollneworderrepayment();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getRolltotalrepayment();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getHandlepoint();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getCompletepoint();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getRepayamountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getTargetrepayrate();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
};


/**
 * optional string DateRange = 1;
 * @return {string}
 */
proto.xcommon.RoleStats.prototype.getDaterange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.RoleStats.prototype.setDaterange = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string CaseName = 2;
 * @return {string}
 */
proto.xcommon.RoleStats.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.RoleStats.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string UserName = 3;
 * @return {string}
 */
proto.xcommon.RoleStats.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.RoleStats.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UserGroupName = 4;
 * @return {string}
 */
proto.xcommon.RoleStats.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.RoleStats.prototype.setUsergroupname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 Ranking = 5;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getRanking = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setRanking = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AdminUID = 6;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AssignNum = 7;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getAssignnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setAssignnum = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 CompleteNum = 8;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 LoadNum = 9;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getLoadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setLoadnum = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 HandleNum = 10;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getHandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setHandlenum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 AvgCostTime = 11;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getAvgcosttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setAvgcosttime = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 LoadLeftUnpaidPrincipal = 12;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getLoadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setLoadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 SubLoadLeftUnpaidPrincipal = 13;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getSubloadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setSubloadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 RepayPrincipal = 14;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getRepayprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setRepayprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 RepayInterest = 15;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getRepayinterest = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setRepayinterest = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 RepayTotal = 16;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getRepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setRepaytotal = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 BonusAmount = 17;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getBonusamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setBonusamount = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 DiffTargetRepay = 18;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getDifftargetrepay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setDifftargetrepay = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 NumberOfCollections = 19;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getNumberofcollections = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setNumberofcollections = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 DeductionAmount = 20;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getDeductionamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setDeductionamount = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 DeductionNumber = 21;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getDeductionnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setDeductionnumber = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 RollNewOrderRepayment = 22;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getRollneworderrepayment = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setRollneworderrepayment = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 RollTotalRepayment = 23;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getRolltotalrepayment = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setRolltotalrepayment = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional double HandlePoint = 24;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getHandlepoint = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setHandlepoint = function(value) {
  jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional double CompletePoint = 25;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getCompletepoint = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setCompletepoint = function(value) {
  jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double RepayAmountRate = 26;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getRepayamountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setRepayamountrate = function(value) {
  jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double TargetRepayRate = 27;
 * @return {number}
 */
proto.xcommon.RoleStats.prototype.getTargetrepayrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/** @param {number} value */
proto.xcommon.RoleStats.prototype.setTargetrepayrate = function(value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAppPerformanceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAppPerformanceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAppPerformanceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAppPerformanceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    timerange: jspb.Message.getFieldWithDefault(msg, 3, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    statstype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    statssort: jspb.Message.getFieldWithDefault(msg, 6, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    loantype: jspb.Message.getFieldWithDefault(msg, 8, 0),
    starthour: jspb.Message.getFieldWithDefault(msg, 9, 0),
    endhour: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAppPerformanceReq}
 */
proto.xcommon.GetAppPerformanceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAppPerformanceReq;
  return proto.xcommon.GetAppPerformanceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAppPerformanceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAppPerformanceReq}
 */
proto.xcommon.GetAppPerformanceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.StatsType} */ (reader.readEnum());
      msg.setStatstype(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.StatsSort} */ (reader.readEnum());
      msg.setStatssort(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarthour(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndhour(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAppPerformanceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAppPerformanceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAppPerformanceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAppPerformanceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getStatstype();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStatssort();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getStarthour();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getEndhour();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetAppPerformanceReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAppPerformanceReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAppPerformanceReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetAppPerformanceReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAppPerformanceReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAppPerformanceReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string TimeRange = 3;
 * @return {string}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetAppPerformanceReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 ItemId = 4;
 * @return {number}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetAppPerformanceReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional StatsType StatsType = 5;
 * @return {!proto.xcommon.StatsType}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getStatstype = function() {
  return /** @type {!proto.xcommon.StatsType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.StatsType} value */
proto.xcommon.GetAppPerformanceReq.prototype.setStatstype = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional StatsSort StatsSort = 6;
 * @return {!proto.xcommon.StatsSort}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getStatssort = function() {
  return /** @type {!proto.xcommon.StatsSort} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.StatsSort} value */
proto.xcommon.GetAppPerformanceReq.prototype.setStatssort = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string AppName = 7;
 * @return {string}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetAppPerformanceReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional LoanTypeEnum LoanType = 8;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.GetAppPerformanceReq.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int64 StartHour = 9;
 * @return {number}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getStarthour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.GetAppPerformanceReq.prototype.setStarthour = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 EndHour = 10;
 * @return {number}
 */
proto.xcommon.GetAppPerformanceReq.prototype.getEndhour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.GetAppPerformanceReq.prototype.setEndhour = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetAppPerformanceResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAppPerformanceResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAppPerformanceResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAppPerformanceResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAppPerformanceResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    totalstats: (f = msg.getTotalstats()) && proto.xcommon.AppStats.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AppStats.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updatetime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAppPerformanceResp}
 */
proto.xcommon.GetAppPerformanceResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAppPerformanceResp;
  return proto.xcommon.GetAppPerformanceResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAppPerformanceResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAppPerformanceResp}
 */
proto.xcommon.GetAppPerformanceResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AppStats;
      reader.readMessage(value,proto.xcommon.AppStats.deserializeBinaryFromReader);
      msg.setTotalstats(value);
      break;
    case 3:
      var value = new proto.xcommon.AppStats;
      reader.readMessage(value,proto.xcommon.AppStats.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAppPerformanceResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAppPerformanceResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAppPerformanceResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAppPerformanceResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTotalstats();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.AppStats.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AppStats.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAppPerformanceResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetAppPerformanceResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAppPerformanceResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAppPerformanceResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AppStats TotalStats = 2;
 * @return {?proto.xcommon.AppStats}
 */
proto.xcommon.GetAppPerformanceResp.prototype.getTotalstats = function() {
  return /** @type{?proto.xcommon.AppStats} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AppStats, 2));
};


/** @param {?proto.xcommon.AppStats|undefined} value */
proto.xcommon.GetAppPerformanceResp.prototype.setTotalstats = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetAppPerformanceResp.prototype.clearTotalstats = function() {
  this.setTotalstats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAppPerformanceResp.prototype.hasTotalstats = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AppStats List = 3;
 * @return {!Array<!proto.xcommon.AppStats>}
 */
proto.xcommon.GetAppPerformanceResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AppStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AppStats, 3));
};


/** @param {!Array<!proto.xcommon.AppStats>} value */
proto.xcommon.GetAppPerformanceResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AppStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AppStats}
 */
proto.xcommon.GetAppPerformanceResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AppStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetAppPerformanceResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional int64 Total = 4;
 * @return {number}
 */
proto.xcommon.GetAppPerformanceResp.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetAppPerformanceResp.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 UpdateTime = 5;
 * @return {number}
 */
proto.xcommon.GetAppPerformanceResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetAppPerformanceResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AppStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AppStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AppStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AppStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    appname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    loantype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    loadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 5, 0),
    repayprincipal: jspb.Message.getFieldWithDefault(msg, 6, 0),
    repaytotal: jspb.Message.getFieldWithDefault(msg, 7, 0),
    repayamountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    assignnum: jspb.Message.getFieldWithDefault(msg, 9, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    loadnum: jspb.Message.getFieldWithDefault(msg, 11, 0),
    ranking: jspb.Message.getFieldWithDefault(msg, 12, 0),
    casename: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AppStats}
 */
proto.xcommon.AppStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AppStats;
  return proto.xcommon.AppStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AppStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AppStats}
 */
proto.xcommon.AppStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadleftunpaidprincipal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayprincipal(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytotal(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepayamountrate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignnum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadnum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRanking(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AppStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AppStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AppStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AppStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLoadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRepayprincipal();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getRepaytotal();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getRepayamountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getAssignnum();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getLoadnum();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getRanking();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string AppName = 1;
 * @return {string}
 */
proto.xcommon.AppStats.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.AppStats.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Date = 2;
 * @return {string}
 */
proto.xcommon.AppStats.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AppStats.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 TicketItemID = 3;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional LoanTypeEnum LoanType = 4;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.AppStats.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.AppStats.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 LoadLeftUnpaidPrincipal = 5;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getLoadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setLoadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 RepayPrincipal = 6;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getRepayprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setRepayprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 RepayTotal = 7;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getRepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setRepaytotal = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double RepayAmountRate = 8;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getRepayamountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setRepayamountrate = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int64 AssignNum = 9;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getAssignnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setAssignnum = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 CompleteNum = 10;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 LoadNum = 11;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getLoadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setLoadnum = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 Ranking = 12;
 * @return {number}
 */
proto.xcommon.AppStats.prototype.getRanking = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.AppStats.prototype.setRanking = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string CaseName = 13;
 * @return {string}
 */
proto.xcommon.AppStats.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.AppStats.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.FileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.FileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.FileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.FileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    filename: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filechunk: msg.getFilechunk_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.FileResponse}
 */
proto.xcommon.FileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.FileResponse;
  return proto.xcommon.FileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.FileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.FileResponse}
 */
proto.xcommon.FileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFilechunk(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.FileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.FileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.FileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.FileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilechunk_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.FileResponse.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.FileResponse.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.FileResponse.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.FileResponse.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string FileName = 3;
 * @return {string}
 */
proto.xcommon.FileResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.FileResponse.prototype.setFilename = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes FileChunk = 4;
 * @return {!(string|Uint8Array)}
 */
proto.xcommon.FileResponse.prototype.getFilechunk = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes FileChunk = 4;
 * This is a type-conversion wrapper around `getFilechunk()`
 * @return {string}
 */
proto.xcommon.FileResponse.prototype.getFilechunk_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFilechunk()));
};


/**
 * optional bytes FileChunk = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFilechunk()`
 * @return {!Uint8Array}
 */
proto.xcommon.FileResponse.prototype.getFilechunk_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFilechunk()));
};


/** @param {!(string|Uint8Array)} value */
proto.xcommon.FileResponse.prototype.setFilechunk = function(value) {
  jspb.Message.setProto3BytesField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DashboardReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DashboardReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DashboardReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DashboardReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DashboardReq}
 */
proto.xcommon.DashboardReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DashboardReq;
  return proto.xcommon.DashboardReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DashboardReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DashboardReq}
 */
proto.xcommon.DashboardReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DashboardReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DashboardReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DashboardReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DashboardReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DashboardReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DashboardReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DashboardReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DashboardReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.xcommon.DashboardReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DashboardReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.DashboardResp.repeatedFields_ = [4,5,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DashboardResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DashboardResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DashboardResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DashboardResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    roletype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pies: (f = msg.getPies()) && proto.xcommon.Pies.toObject(includeInstance, f),
    chartList: jspb.Message.toObjectList(msg.getChartList(),
    proto.xcommon.ChartItem.toObject, includeInstance),
    staffstatsList: jspb.Message.toObjectList(msg.getStaffstatsList(),
    proto.xcommon.DashboardStats.toObject, includeInstance),
    leaderstatsList: jspb.Message.toObjectList(msg.getLeaderstatsList(),
    proto.xcommon.DashboardStats.toObject, includeInstance),
    seniorleaderstatsList: jspb.Message.toObjectList(msg.getSeniorleaderstatsList(),
    proto.xcommon.DashboardStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DashboardResp}
 */
proto.xcommon.DashboardResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DashboardResp;
  return proto.xcommon.DashboardResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DashboardResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DashboardResp}
 */
proto.xcommon.DashboardResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoletype(value);
      break;
    case 3:
      var value = new proto.xcommon.Pies;
      reader.readMessage(value,proto.xcommon.Pies.deserializeBinaryFromReader);
      msg.setPies(value);
      break;
    case 4:
      var value = new proto.xcommon.ChartItem;
      reader.readMessage(value,proto.xcommon.ChartItem.deserializeBinaryFromReader);
      msg.addChart(value);
      break;
    case 5:
      var value = new proto.xcommon.DashboardStats;
      reader.readMessage(value,proto.xcommon.DashboardStats.deserializeBinaryFromReader);
      msg.addStaffstats(value);
      break;
    case 6:
      var value = new proto.xcommon.DashboardStats;
      reader.readMessage(value,proto.xcommon.DashboardStats.deserializeBinaryFromReader);
      msg.addLeaderstats(value);
      break;
    case 7:
      var value = new proto.xcommon.DashboardStats;
      reader.readMessage(value,proto.xcommon.DashboardStats.deserializeBinaryFromReader);
      msg.addSeniorleaderstats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DashboardResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DashboardResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DashboardResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DashboardResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getRoletype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPies();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.Pies.serializeBinaryToWriter
    );
  }
  f = message.getChartList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.ChartItem.serializeBinaryToWriter
    );
  }
  f = message.getStaffstatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.DashboardStats.serializeBinaryToWriter
    );
  }
  f = message.getLeaderstatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.xcommon.DashboardStats.serializeBinaryToWriter
    );
  }
  f = message.getSeniorleaderstatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.xcommon.DashboardStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DashboardResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DashboardResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DashboardResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DashboardResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 RoleType = 2;
 * @return {number}
 */
proto.xcommon.DashboardResp.prototype.getRoletype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DashboardResp.prototype.setRoletype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Pies Pies = 3;
 * @return {?proto.xcommon.Pies}
 */
proto.xcommon.DashboardResp.prototype.getPies = function() {
  return /** @type{?proto.xcommon.Pies} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Pies, 3));
};


/** @param {?proto.xcommon.Pies|undefined} value */
proto.xcommon.DashboardResp.prototype.setPies = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DashboardResp.prototype.clearPies = function() {
  this.setPies(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DashboardResp.prototype.hasPies = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated ChartItem Chart = 4;
 * @return {!Array<!proto.xcommon.ChartItem>}
 */
proto.xcommon.DashboardResp.prototype.getChartList = function() {
  return /** @type{!Array<!proto.xcommon.ChartItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ChartItem, 4));
};


/** @param {!Array<!proto.xcommon.ChartItem>} value */
proto.xcommon.DashboardResp.prototype.setChartList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.ChartItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ChartItem}
 */
proto.xcommon.DashboardResp.prototype.addChart = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.ChartItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.DashboardResp.prototype.clearChartList = function() {
  this.setChartList([]);
};


/**
 * repeated DashboardStats StaffStats = 5;
 * @return {!Array<!proto.xcommon.DashboardStats>}
 */
proto.xcommon.DashboardResp.prototype.getStaffstatsList = function() {
  return /** @type{!Array<!proto.xcommon.DashboardStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DashboardStats, 5));
};


/** @param {!Array<!proto.xcommon.DashboardStats>} value */
proto.xcommon.DashboardResp.prototype.setStaffstatsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.DashboardStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DashboardStats}
 */
proto.xcommon.DashboardResp.prototype.addStaffstats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.DashboardStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.DashboardResp.prototype.clearStaffstatsList = function() {
  this.setStaffstatsList([]);
};


/**
 * repeated DashboardStats LeaderStats = 6;
 * @return {!Array<!proto.xcommon.DashboardStats>}
 */
proto.xcommon.DashboardResp.prototype.getLeaderstatsList = function() {
  return /** @type{!Array<!proto.xcommon.DashboardStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DashboardStats, 6));
};


/** @param {!Array<!proto.xcommon.DashboardStats>} value */
proto.xcommon.DashboardResp.prototype.setLeaderstatsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.xcommon.DashboardStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DashboardStats}
 */
proto.xcommon.DashboardResp.prototype.addLeaderstats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.xcommon.DashboardStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.DashboardResp.prototype.clearLeaderstatsList = function() {
  this.setLeaderstatsList([]);
};


/**
 * repeated DashboardStats SeniorLeaderStats = 7;
 * @return {!Array<!proto.xcommon.DashboardStats>}
 */
proto.xcommon.DashboardResp.prototype.getSeniorleaderstatsList = function() {
  return /** @type{!Array<!proto.xcommon.DashboardStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DashboardStats, 7));
};


/** @param {!Array<!proto.xcommon.DashboardStats>} value */
proto.xcommon.DashboardResp.prototype.setSeniorleaderstatsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.xcommon.DashboardStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DashboardStats}
 */
proto.xcommon.DashboardResp.prototype.addSeniorleaderstats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.xcommon.DashboardStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.DashboardResp.prototype.clearSeniorleaderstatsList = function() {
  this.setSeniorleaderstatsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Pies.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Pies.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Pies} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Pies.toObject = function(includeInstance, msg) {
  var f, obj = {
    kpi: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    repaytotal: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    repayamountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    loadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 4, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    updatetime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    halfmonthkpi: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    halfmonthrepaytotal: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    todaydiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    halfmonthdiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Pies}
 */
proto.xcommon.Pies.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Pies;
  return proto.xcommon.Pies.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Pies} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Pies}
 */
proto.xcommon.Pies.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setKpi(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepaytotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepayamountrate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadleftunpaidprincipal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHalfmonthkpi(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHalfmonthrepaytotal(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTodaydiff(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHalfmonthdiff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Pies.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Pies.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Pies} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Pies.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKpi();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getRepaytotal();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getRepayamountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getLoadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getHalfmonthkpi();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getHalfmonthrepaytotal();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getTodaydiff();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getHalfmonthdiff();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
};


/**
 * optional double Kpi = 1;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getKpi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setKpi = function(value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double RepayTotal = 2;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getRepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setRepaytotal = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double RepayAmountRate = 3;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getRepayamountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setRepayamountrate = function(value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int64 LoadLeftUnpaidPrincipal = 4;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getLoadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setLoadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 CompleteNum = 5;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 UpdateTime = 6;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double HalfMonthKpi = 7;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getHalfmonthkpi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setHalfmonthkpi = function(value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double HalfMonthRepayTotal = 8;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getHalfmonthrepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setHalfmonthrepaytotal = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double TodayDiff = 9;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getTodaydiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setTodaydiff = function(value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double HalfMonthDiff = 10;
 * @return {number}
 */
proto.xcommon.Pies.prototype.getHalfmonthdiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/** @param {number} value */
proto.xcommon.Pies.prototype.setHalfmonthdiff = function(value) {
  jspb.Message.setProto3FloatField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ChartItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ChartItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ChartItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ChartItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, 0),
    repaytotal: jspb.Message.getFieldWithDefault(msg, 2, 0),
    loadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ChartItem}
 */
proto.xcommon.ChartItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ChartItem;
  return proto.xcommon.ChartItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ChartItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ChartItem}
 */
proto.xcommon.ChartItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadleftunpaidprincipal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ChartItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ChartItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ChartItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ChartItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRepaytotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLoadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 Date = 1;
 * @return {number}
 */
proto.xcommon.ChartItem.prototype.getDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.ChartItem.prototype.setDate = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 RepayTotal = 2;
 * @return {number}
 */
proto.xcommon.ChartItem.prototype.getRepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ChartItem.prototype.setRepaytotal = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 LoadLeftUnpaidPrincipal = 3;
 * @return {number}
 */
proto.xcommon.ChartItem.prototype.getLoadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.ChartItem.prototype.setLoadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DashboardStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DashboardStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DashboardStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DashboardStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ranking: jspb.Message.getFieldWithDefault(msg, 3, 0),
    repaytotal: jspb.Message.getFieldWithDefault(msg, 4, 0),
    loadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 5, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    repayamountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    targetrepayrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    targetrepayamount: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DashboardStats}
 */
proto.xcommon.DashboardStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DashboardStats;
  return proto.xcommon.DashboardStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DashboardStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DashboardStats}
 */
proto.xcommon.DashboardStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRanking(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytotal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadleftunpaidprincipal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepayamountrate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetrepayrate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetrepayamount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DashboardStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DashboardStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DashboardStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DashboardStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRanking();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRepaytotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLoadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getRepayamountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getTargetrepayrate();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getTargetrepayamount();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.xcommon.DashboardStats.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.DashboardStats.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 AdminUid = 2;
 * @return {number}
 */
proto.xcommon.DashboardStats.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DashboardStats.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Ranking = 3;
 * @return {number}
 */
proto.xcommon.DashboardStats.prototype.getRanking = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.DashboardStats.prototype.setRanking = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 RepayTotal = 4;
 * @return {number}
 */
proto.xcommon.DashboardStats.prototype.getRepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.DashboardStats.prototype.setRepaytotal = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 LoadLeftUnpaidPrincipal = 5;
 * @return {number}
 */
proto.xcommon.DashboardStats.prototype.getLoadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.DashboardStats.prototype.setLoadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 CompleteNum = 6;
 * @return {number}
 */
proto.xcommon.DashboardStats.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.DashboardStats.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double RepayAmountRate = 7;
 * @return {number}
 */
proto.xcommon.DashboardStats.prototype.getRepayamountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/** @param {number} value */
proto.xcommon.DashboardStats.prototype.setRepayamountrate = function(value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double TargetRepayRate = 8;
 * @return {number}
 */
proto.xcommon.DashboardStats.prototype.getTargetrepayrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.xcommon.DashboardStats.prototype.setTargetrepayrate = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double TargetRepayAmount = 9;
 * @return {number}
 */
proto.xcommon.DashboardStats.prototype.getTargetrepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/** @param {number} value */
proto.xcommon.DashboardStats.prototype.setTargetrepayamount = function(value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUrgeEfficiencyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUrgeEfficiencyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeEfficiencyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    statstype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    username: jspb.Message.getFieldWithDefault(msg, 7, ""),
    timerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    email: jspb.Message.getFieldWithDefault(msg, 9, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 10, 0),
    hour: jspb.Message.getFieldWithDefault(msg, 11, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUrgeEfficiencyReq}
 */
proto.xcommon.GetUrgeEfficiencyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUrgeEfficiencyReq;
  return proto.xcommon.GetUrgeEfficiencyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUrgeEfficiencyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUrgeEfficiencyReq}
 */
proto.xcommon.GetUrgeEfficiencyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.StatsType} */ (reader.readEnum());
      msg.setStatstype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHour(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUrgeEfficiencyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUrgeEfficiencyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeEfficiencyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getStatstype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getHour();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StatsType StatsType = 3;
 * @return {!proto.xcommon.StatsType}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getStatstype = function() {
  return /** @type {!proto.xcommon.StatsType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.StatsType} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setStatstype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 UserGroupId = 5;
 * @return {number}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 ItemId = 6;
 * @return {number}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string UserName = 7;
 * @return {string}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string TimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Email = 9;
 * @return {string}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 UserId = 10;
 * @return {number}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 Hour = 11;
 * @return {number}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setHour = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string EmployeeID = 12;
 * @return {string}
 */
proto.xcommon.GetUrgeEfficiencyReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetUrgeEfficiencyReq.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetUrgeEfficiencyResp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUrgeEfficiencyResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUrgeEfficiencyResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeEfficiencyResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    updatetime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.UrgeEfficiency.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUrgeEfficiencyResp}
 */
proto.xcommon.GetUrgeEfficiencyResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUrgeEfficiencyResp;
  return proto.xcommon.GetUrgeEfficiencyResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUrgeEfficiencyResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUrgeEfficiencyResp}
 */
proto.xcommon.GetUrgeEfficiencyResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    case 4:
      var value = new proto.xcommon.UrgeEfficiency;
      reader.readMessage(value,proto.xcommon.UrgeEfficiency.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUrgeEfficiencyResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUrgeEfficiencyResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeEfficiencyResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.UrgeEfficiency.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetUrgeEfficiencyResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetUrgeEfficiencyResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 UpdateTime = 3;
 * @return {number}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeEfficiencyResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated UrgeEfficiency List = 4;
 * @return {!Array<!proto.xcommon.UrgeEfficiency>}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.UrgeEfficiency>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UrgeEfficiency, 4));
};


/** @param {!Array<!proto.xcommon.UrgeEfficiency>} value */
proto.xcommon.GetUrgeEfficiencyResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.UrgeEfficiency=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeEfficiency}
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.UrgeEfficiency, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetUrgeEfficiencyResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUrgeFollowReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUrgeFollowReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUrgeFollowReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeFollowReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    statstype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    username: jspb.Message.getFieldWithDefault(msg, 7, ""),
    timerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    email: jspb.Message.getFieldWithDefault(msg, 9, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 10, 0),
    hour: jspb.Message.getFieldWithDefault(msg, 11, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUrgeFollowReq}
 */
proto.xcommon.GetUrgeFollowReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUrgeFollowReq;
  return proto.xcommon.GetUrgeFollowReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUrgeFollowReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUrgeFollowReq}
 */
proto.xcommon.GetUrgeFollowReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.StatsType} */ (reader.readEnum());
      msg.setStatstype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHour(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUrgeFollowReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUrgeFollowReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUrgeFollowReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeFollowReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getStatstype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getHour();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetUrgeFollowReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUrgeFollowReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeFollowReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetUrgeFollowReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUrgeFollowReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeFollowReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StatsType StatsType = 3;
 * @return {!proto.xcommon.StatsType}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getStatstype = function() {
  return /** @type {!proto.xcommon.StatsType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.StatsType} value */
proto.xcommon.GetUrgeFollowReq.prototype.setStatstype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 UserGroupId = 5;
 * @return {number}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeFollowReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 ItemId = 6;
 * @return {number}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeFollowReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string UserName = 7;
 * @return {string}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetUrgeFollowReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string TimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.GetUrgeFollowReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Email = 9;
 * @return {string}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.GetUrgeFollowReq.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 UserId = 10;
 * @return {number}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeFollowReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 Hour = 11;
 * @return {number}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeFollowReq.prototype.setHour = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string EmployeeID = 12;
 * @return {string}
 */
proto.xcommon.GetUrgeFollowReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetUrgeFollowReq.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetUrgeFollowResp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUrgeFollowResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUrgeFollowResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUrgeFollowResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeFollowResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    updatetime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.Follow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUrgeFollowResp}
 */
proto.xcommon.GetUrgeFollowResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUrgeFollowResp;
  return proto.xcommon.GetUrgeFollowResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUrgeFollowResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUrgeFollowResp}
 */
proto.xcommon.GetUrgeFollowResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    case 4:
      var value = new proto.xcommon.Follow;
      reader.readMessage(value,proto.xcommon.Follow.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUrgeFollowResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUrgeFollowResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUrgeFollowResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeFollowResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.Follow.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetUrgeFollowResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetUrgeFollowResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUrgeFollowResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeFollowResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetUrgeFollowResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetUrgeFollowResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUrgeFollowResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeFollowResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 UpdateTime = 3;
 * @return {number}
 */
proto.xcommon.GetUrgeFollowResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetUrgeFollowResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Follow List = 4;
 * @return {!Array<!proto.xcommon.Follow>}
 */
proto.xcommon.GetUrgeFollowResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.Follow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.Follow, 4));
};


/** @param {!Array<!proto.xcommon.Follow>} value */
proto.xcommon.GetUrgeFollowResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.Follow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Follow}
 */
proto.xcommon.GetUrgeFollowResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.Follow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetUrgeFollowResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UrgeEfficiency.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UrgeEfficiency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UrgeEfficiency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeEfficiency.toObject = function(includeInstance, msg) {
  var f, obj = {
    bucket: jspb.Message.getFieldWithDefault(msg, 1, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    leaderusergroupid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    adminname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    loadnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    newnum: jspb.Message.getFieldWithDefault(msg, 7, 0),
    selfcollectiontimes: jspb.Message.getFieldWithDefault(msg, 8, 0),
    contactscollectiontimes: jspb.Message.getFieldWithDefault(msg, 9, 0),
    currentptp: jspb.Message.getFieldWithDefault(msg, 10, 0),
    currentbp: jspb.Message.getFieldWithDefault(msg, 11, 0),
    ptpuniquecollectionrecord: jspb.Message.getFieldWithDefault(msg, 12, 0),
    callbackticketnum: jspb.Message.getFieldWithDefault(msg, 13, 0),
    oldticketnum: jspb.Message.getFieldWithDefault(msg, 14, 0),
    newticketnum: jspb.Message.getFieldWithDefault(msg, 15, 0),
    collectiontimes: jspb.Message.getFieldWithDefault(msg, 16, 0),
    ptpnotfollowupnum: jspb.Message.getFieldWithDefault(msg, 17, 0),
    newticketfinishtime: jspb.Message.getFieldWithDefault(msg, 18, 0),
    newticketnotfinishnum: jspb.Message.getFieldWithDefault(msg, 19, 0),
    statsdate: jspb.Message.getFieldWithDefault(msg, 20, 0),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 21, ""),
    casename: jspb.Message.getFieldWithDefault(msg, 22, ""),
    date: jspb.Message.getFieldWithDefault(msg, 23, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 24, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UrgeEfficiency}
 */
proto.xcommon.UrgeEfficiency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UrgeEfficiency;
  return proto.xcommon.UrgeEfficiency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UrgeEfficiency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UrgeEfficiency}
 */
proto.xcommon.UrgeEfficiency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBucket(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeaderusergroupid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdminname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadnum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNewnum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSelfcollectiontimes(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContactscollectiontimes(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentptp(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentbp(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPtpuniquecollectionrecord(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallbackticketnum(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOldticketnum(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNewticketnum(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCollectiontimes(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPtpnotfollowupnum(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNewticketfinishtime(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNewticketnotfinishnum(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStatsdate(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UrgeEfficiency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UrgeEfficiency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UrgeEfficiency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeEfficiency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucket();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLeaderusergroupid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAdminname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getLoadnum();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getNewnum();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getSelfcollectiontimes();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getContactscollectiontimes();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getCurrentptp();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCurrentbp();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getPtpuniquecollectionrecord();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getCallbackticketnum();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getOldticketnum();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getNewticketnum();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getCollectiontimes();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getPtpnotfollowupnum();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getNewticketfinishtime();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getNewticketnotfinishnum();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getStatsdate();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
};


/**
 * optional int64 Bucket = 1;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getBucket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setBucket = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 UserGroupID = 2;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 LeaderUserGroupID = 3;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getLeaderusergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setLeaderusergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string AdminName = 4;
 * @return {string}
 */
proto.xcommon.UrgeEfficiency.prototype.getAdminname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.UrgeEfficiency.prototype.setAdminname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 AdminUID = 5;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 LoadNum = 6;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getLoadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setLoadnum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 NewNum = 7;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getNewnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setNewnum = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 SelfCollectionTimes = 8;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getSelfcollectiontimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setSelfcollectiontimes = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 ContactsCollectionTimes = 9;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getContactscollectiontimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setContactscollectiontimes = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 CurrentPtp = 10;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getCurrentptp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setCurrentptp = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 CurrentBp = 11;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getCurrentbp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setCurrentbp = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 PtpUniqueCollectionRecord = 12;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getPtpuniquecollectionrecord = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setPtpuniquecollectionrecord = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 CallbackTicketNum = 13;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getCallbackticketnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setCallbackticketnum = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 OldTicketNum = 14;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getOldticketnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setOldticketnum = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 NewTicketNum = 15;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getNewticketnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setNewticketnum = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 CollectionTimes = 16;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getCollectiontimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setCollectiontimes = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 PtpNotFollowUpNum = 17;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getPtpnotfollowupnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setPtpnotfollowupnum = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 NewTicketFinishTime = 18;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getNewticketfinishtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setNewticketfinishtime = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 NewTicketNotFinishNum = 19;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getNewticketnotfinishnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setNewticketnotfinishnum = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 StatsDate = 20;
 * @return {number}
 */
proto.xcommon.UrgeEfficiency.prototype.getStatsdate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.UrgeEfficiency.prototype.setStatsdate = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string UserGroupName = 21;
 * @return {string}
 */
proto.xcommon.UrgeEfficiency.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.UrgeEfficiency.prototype.setUsergroupname = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string CaseName = 22;
 * @return {string}
 */
proto.xcommon.UrgeEfficiency.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.xcommon.UrgeEfficiency.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string Date = 23;
 * @return {string}
 */
proto.xcommon.UrgeEfficiency.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/** @param {string} value */
proto.xcommon.UrgeEfficiency.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string EmployeeID = 24;
 * @return {string}
 */
proto.xcommon.UrgeEfficiency.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/** @param {string} value */
proto.xcommon.UrgeEfficiency.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Follow.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Follow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Follow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Follow.toObject = function(includeInstance, msg) {
  var f, obj = {
    bucket: jspb.Message.getFieldWithDefault(msg, 1, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    leaderusergroupid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    adminname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    dialnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    answernum: jspb.Message.getFieldWithDefault(msg, 7, 0),
    answerrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    callduration: jspb.Message.getFieldWithDefault(msg, 9, 0),
    avgcallduration: jspb.Message.getFieldWithDefault(msg, 10, 0),
    onedayselfnotfollownum: jspb.Message.getFieldWithDefault(msg, 11, 0),
    onedayselfnotfollowrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    threedayselfnotfollownum: jspb.Message.getFieldWithDefault(msg, 13, 0),
    threedayselfnotfollowrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    sevendayselfnotfollownum: jspb.Message.getFieldWithDefault(msg, 15, 0),
    sevendayselfnotfollowrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    onedaycontactsnotfollownum: jspb.Message.getFieldWithDefault(msg, 17, 0),
    onedaycontactsnotfollowrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
    threedaycontactsnotfollownum: jspb.Message.getFieldWithDefault(msg, 19, 0),
    threedaycontactsnotfollowrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    sevendaycontactsnotfollownum: jspb.Message.getFieldWithDefault(msg, 21, 0),
    sevendaycontactsnotfollowrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
    firstlogintime: jspb.Message.getFieldWithDefault(msg, 23, 0),
    firstoperatetime: jspb.Message.getFieldWithDefault(msg, 24, 0),
    lastoperatetime: jspb.Message.getFieldWithDefault(msg, 25, 0),
    logouttimes: jspb.Message.getFieldWithDefault(msg, 26, 0),
    statsdate: jspb.Message.getFieldWithDefault(msg, 27, 0),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 28, ""),
    casename: jspb.Message.getFieldWithDefault(msg, 29, ""),
    date: jspb.Message.getFieldWithDefault(msg, 30, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Follow}
 */
proto.xcommon.Follow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Follow;
  return proto.xcommon.Follow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Follow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Follow}
 */
proto.xcommon.Follow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBucket(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeaderusergroupid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdminname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDialnum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswernum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAnswerrate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallduration(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvgcallduration(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOnedayselfnotfollownum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOnedayselfnotfollowrate(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThreedayselfnotfollownum(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setThreedayselfnotfollowrate(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSevendayselfnotfollownum(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSevendayselfnotfollowrate(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOnedaycontactsnotfollownum(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOnedaycontactsnotfollowrate(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThreedaycontactsnotfollownum(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setThreedaycontactsnotfollowrate(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSevendaycontactsnotfollownum(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSevendaycontactsnotfollowrate(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFirstlogintime(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFirstoperatetime(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastoperatetime(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLogouttimes(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStatsdate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Follow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Follow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Follow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Follow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucket();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLeaderusergroupid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAdminname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getDialnum();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAnswernum();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAnswerrate();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getCallduration();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getAvgcallduration();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getOnedayselfnotfollownum();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getOnedayselfnotfollowrate();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getThreedayselfnotfollownum();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getThreedayselfnotfollowrate();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getSevendayselfnotfollownum();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getSevendayselfnotfollowrate();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getOnedaycontactsnotfollownum();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getOnedaycontactsnotfollowrate();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getThreedaycontactsnotfollownum();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getThreedaycontactsnotfollowrate();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getSevendaycontactsnotfollownum();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getSevendaycontactsnotfollowrate();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getFirstlogintime();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getFirstoperatetime();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getLastoperatetime();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getLogouttimes();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getStatsdate();
  if (f !== 0) {
    writer.writeInt64(
      27,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional int64 Bucket = 1;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getBucket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setBucket = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 UserGroupID = 2;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 LeaderUserGroupID = 3;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getLeaderusergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setLeaderusergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string AdminName = 4;
 * @return {string}
 */
proto.xcommon.Follow.prototype.getAdminname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.Follow.prototype.setAdminname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 AdminUID = 5;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 DialNum = 6;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getDialnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setDialnum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AnswerNum = 7;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getAnswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setAnswernum = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double AnswerRate = 8;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getAnswerrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setAnswerrate = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int64 CallDuration = 9;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getCallduration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setCallduration = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 AvgCallDuration = 10;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getAvgcallduration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setAvgcallduration = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 OneDaySelfNotFollowNum = 11;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getOnedayselfnotfollownum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setOnedayselfnotfollownum = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional double OneDaySelfNotFollowRate = 12;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getOnedayselfnotfollowrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setOnedayselfnotfollowrate = function(value) {
  jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional int64 ThreeDaySelfNotFollowNum = 13;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getThreedayselfnotfollownum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setThreedayselfnotfollownum = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional double ThreeDaySelfNotFollowRate = 14;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getThreedayselfnotfollowrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setThreedayselfnotfollowrate = function(value) {
  jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional int64 SevenDaySelfNotFollowNum = 15;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getSevendayselfnotfollownum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setSevendayselfnotfollownum = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional double SevenDaySelfNotFollowRate = 16;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getSevendayselfnotfollowrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setSevendayselfnotfollowrate = function(value) {
  jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional int64 OneDayContactsNotFollowNum = 17;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getOnedaycontactsnotfollownum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setOnedaycontactsnotfollownum = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional double OneDayContactsNotFollowRate = 18;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getOnedaycontactsnotfollowrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setOnedaycontactsnotfollowrate = function(value) {
  jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional int64 ThreeDayContactsNotFollowNum = 19;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getThreedaycontactsnotfollownum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setThreedaycontactsnotfollownum = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional double ThreeDayContactsNotFollowRate = 20;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getThreedaycontactsnotfollowrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setThreedaycontactsnotfollowrate = function(value) {
  jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional int64 SevenDayContactsNotFollowNum = 21;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getSevendaycontactsnotfollownum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setSevendaycontactsnotfollownum = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional double SevenDayContactsNotFollowRate = 22;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getSevendaycontactsnotfollowrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setSevendaycontactsnotfollowrate = function(value) {
  jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional int64 FirstLoginTime = 23;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getFirstlogintime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setFirstlogintime = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int64 FirstOperateTime = 24;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getFirstoperatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setFirstoperatetime = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 LastOperateTime = 25;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getLastoperatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setLastoperatetime = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 LogoutTimes = 26;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getLogouttimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setLogouttimes = function(value) {
  jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int64 StatsDate = 27;
 * @return {number}
 */
proto.xcommon.Follow.prototype.getStatsdate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/** @param {number} value */
proto.xcommon.Follow.prototype.setStatsdate = function(value) {
  jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional string UserGroupName = 28;
 * @return {string}
 */
proto.xcommon.Follow.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.xcommon.Follow.prototype.setUsergroupname = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string CaseName = 29;
 * @return {string}
 */
proto.xcommon.Follow.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/** @param {string} value */
proto.xcommon.Follow.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string Date = 30;
 * @return {string}
 */
proto.xcommon.Follow.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/** @param {string} value */
proto.xcommon.Follow.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string EmployeeID = 31;
 * @return {string}
 */
proto.xcommon.Follow.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/** @param {string} value */
proto.xcommon.Follow.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 31, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReportReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReportReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReportReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReportReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    report: (f = msg.getReport()) && proto.xcommon.Report.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReportReq}
 */
proto.xcommon.ReportReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReportReq;
  return proto.xcommon.ReportReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReportReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReportReq}
 */
proto.xcommon.ReportReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 4:
      var value = new proto.xcommon.Report;
      reader.readMessage(value,proto.xcommon.Report.deserializeBinaryFromReader);
      msg.setReport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReportReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReportReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReportReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReportReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getReport();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.Report.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ReportReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ReportReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ReportReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReportReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Report Report = 4;
 * @return {?proto.xcommon.Report}
 */
proto.xcommon.ReportReq.prototype.getReport = function() {
  return /** @type{?proto.xcommon.Report} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Report, 4));
};


/** @param {?proto.xcommon.Report|undefined} value */
proto.xcommon.ReportReq.prototype.setReport = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ReportReq.prototype.clearReport = function() {
  this.setReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReportReq.prototype.hasReport = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Report.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Report.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Report} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Report.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reporttype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    stagenum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assignnum: jspb.Message.getFieldWithDefault(msg, 7, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 8, 0),
    loadnum: jspb.Message.getFieldWithDefault(msg, 9, 0),
    handlenum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    avgcosttime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    loadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 12, 0),
    subloadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 13, 0),
    repayprincipal: jspb.Message.getFieldWithDefault(msg, 14, 0),
    repayinterest: jspb.Message.getFieldWithDefault(msg, 15, 0),
    repaytotal: jspb.Message.getFieldWithDefault(msg, 16, 0),
    bonusamount: jspb.Message.getFieldWithDefault(msg, 17, 0),
    difftargetrepay: jspb.Message.getFieldWithDefault(msg, 18, 0),
    numberofcollections: jspb.Message.getFieldWithDefault(msg, 19, 0),
    deductionamount: jspb.Message.getFieldWithDefault(msg, 20, 0),
    deductionnumber: jspb.Message.getFieldWithDefault(msg, 21, 0),
    rollneworderrepayment: jspb.Message.getFieldWithDefault(msg, 22, 0),
    rolltotalrepayment: jspb.Message.getFieldWithDefault(msg, 23, 0),
    handlepoint: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
    completepoint: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    repayamountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
    targetrepayrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
    name: jspb.Message.getFieldWithDefault(msg, 28, ""),
    daterange: jspb.Message.getFieldWithDefault(msg, 29, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Report}
 */
proto.xcommon.Report.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Report;
  return proto.xcommon.Report.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Report} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Report}
 */
proto.xcommon.Report.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReporttype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStagenum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignnum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadnum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandlenum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvgcosttime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadleftunpaidprincipal(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubloadleftunpaidprincipal(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayprincipal(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayinterest(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytotal(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBonusamount(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDifftargetrepay(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumberofcollections(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeductionamount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeductionnumber(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRollneworderrepayment(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRolltotalrepayment(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHandlepoint(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCompletepoint(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepayamountrate(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetrepayrate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setDaterange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Report.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Report.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Report} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Report.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getReporttype();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStagenum();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAssignnum();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getLoadnum();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getHandlenum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAvgcosttime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getLoadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getSubloadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getRepayprincipal();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getRepayinterest();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getRepaytotal();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getBonusamount();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getDifftargetrepay();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getNumberofcollections();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getDeductionamount();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getDeductionnumber();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getRollneworderrepayment();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getRolltotalrepayment();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getHandlepoint();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getCompletepoint();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getRepayamountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getTargetrepayrate();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getDaterange();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.Report.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 ReportType = 2;
 * @return {number}
 */
proto.xcommon.Report.prototype.getReporttype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setReporttype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 TicketItemID = 3;
 * @return {number}
 */
proto.xcommon.Report.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 UserGroupID = 4;
 * @return {number}
 */
proto.xcommon.Report.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 StageNum = 5;
 * @return {number}
 */
proto.xcommon.Report.prototype.getStagenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setStagenum = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AdminUID = 6;
 * @return {number}
 */
proto.xcommon.Report.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AssignNum = 7;
 * @return {number}
 */
proto.xcommon.Report.prototype.getAssignnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setAssignnum = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 CompleteNum = 8;
 * @return {number}
 */
proto.xcommon.Report.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 LoadNum = 9;
 * @return {number}
 */
proto.xcommon.Report.prototype.getLoadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setLoadnum = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 HandleNum = 10;
 * @return {number}
 */
proto.xcommon.Report.prototype.getHandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setHandlenum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 AvgCostTime = 11;
 * @return {number}
 */
proto.xcommon.Report.prototype.getAvgcosttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setAvgcosttime = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 LoadLeftUnpaidPrincipal = 12;
 * @return {number}
 */
proto.xcommon.Report.prototype.getLoadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setLoadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 SubLoadLeftUnpaidPrincipal = 13;
 * @return {number}
 */
proto.xcommon.Report.prototype.getSubloadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setSubloadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 RepayPrincipal = 14;
 * @return {number}
 */
proto.xcommon.Report.prototype.getRepayprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setRepayprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 RepayInterest = 15;
 * @return {number}
 */
proto.xcommon.Report.prototype.getRepayinterest = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setRepayinterest = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 RepayTotal = 16;
 * @return {number}
 */
proto.xcommon.Report.prototype.getRepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setRepaytotal = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 BonusAmount = 17;
 * @return {number}
 */
proto.xcommon.Report.prototype.getBonusamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setBonusamount = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 DiffTargetRepay = 18;
 * @return {number}
 */
proto.xcommon.Report.prototype.getDifftargetrepay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setDifftargetrepay = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 NumberOfCollections = 19;
 * @return {number}
 */
proto.xcommon.Report.prototype.getNumberofcollections = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setNumberofcollections = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 DeductionAmount = 20;
 * @return {number}
 */
proto.xcommon.Report.prototype.getDeductionamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setDeductionamount = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 DeductionNumber = 21;
 * @return {number}
 */
proto.xcommon.Report.prototype.getDeductionnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setDeductionnumber = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 RollNewOrderRepayment = 22;
 * @return {number}
 */
proto.xcommon.Report.prototype.getRollneworderrepayment = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setRollneworderrepayment = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 RollTotalRepayment = 23;
 * @return {number}
 */
proto.xcommon.Report.prototype.getRolltotalrepayment = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setRolltotalrepayment = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional double HandlePoint = 24;
 * @return {number}
 */
proto.xcommon.Report.prototype.getHandlepoint = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setHandlepoint = function(value) {
  jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional double CompletePoint = 25;
 * @return {number}
 */
proto.xcommon.Report.prototype.getCompletepoint = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setCompletepoint = function(value) {
  jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double RepayAmountRate = 26;
 * @return {number}
 */
proto.xcommon.Report.prototype.getRepayamountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setRepayamountrate = function(value) {
  jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double TargetRepayRate = 27;
 * @return {number}
 */
proto.xcommon.Report.prototype.getTargetrepayrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/** @param {number} value */
proto.xcommon.Report.prototype.setTargetrepayrate = function(value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional string Name = 28;
 * @return {string}
 */
proto.xcommon.Report.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.xcommon.Report.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string DateRange = 29;
 * @return {string}
 */
proto.xcommon.Report.prototype.getDaterange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/** @param {string} value */
proto.xcommon.Report.prototype.setDaterange = function(value) {
  jspb.Message.setProto3StringField(this, 29, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DelReportReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DelReportReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DelReportReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelReportReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    reportid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DelReportReq}
 */
proto.xcommon.DelReportReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DelReportReq;
  return proto.xcommon.DelReportReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DelReportReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DelReportReq}
 */
proto.xcommon.DelReportReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReportid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DelReportReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DelReportReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DelReportReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelReportReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getReportid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DelReportReq.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DelReportReq.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DelReportReq.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DelReportReq.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 ReportId = 2;
 * @return {number}
 */
proto.xcommon.DelReportReq.prototype.getReportid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DelReportReq.prototype.setReportid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetReportListResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReportListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReportListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReportListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReportListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.Report.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReportListResp}
 */
proto.xcommon.GetReportListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReportListResp;
  return proto.xcommon.GetReportListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReportListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReportListResp}
 */
proto.xcommon.GetReportListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.Report;
      reader.readMessage(value,proto.xcommon.Report.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReportListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReportListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReportListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReportListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.Report.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetReportListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetReportListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReportListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReportListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Report list = 2;
 * @return {!Array<!proto.xcommon.Report>}
 */
proto.xcommon.GetReportListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.Report>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.Report, 2));
};


/** @param {!Array<!proto.xcommon.Report>} value */
proto.xcommon.GetReportListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.Report=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Report}
 */
proto.xcommon.GetReportListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.Report, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetReportListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodePageCondReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodePageCondReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodePageCondReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageCondReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodePageCondReq}
 */
proto.xcommon.GetRepayCodePageCondReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodePageCondReq;
  return proto.xcommon.GetRepayCodePageCondReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodePageCondReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodePageCondReq}
 */
proto.xcommon.GetRepayCodePageCondReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodePageCondReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodePageCondReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodePageCondReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageCondReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRepayCodePageCondReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetRepayCodePageCondReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodePageCondReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodePageCondReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodePageCondResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodePageCondResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodePageCondResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageCondResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    channelcond: jspb.Message.getFieldWithDefault(msg, 2, ""),
    applist: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodePageCondResp}
 */
proto.xcommon.GetRepayCodePageCondResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodePageCondResp;
  return proto.xcommon.GetRepayCodePageCondResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodePageCondResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodePageCondResp}
 */
proto.xcommon.GetRepayCodePageCondResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelcond(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodePageCondResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodePageCondResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodePageCondResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageCondResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getChannelcond();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApplist();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRepayCodePageCondResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetRepayCodePageCondResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodePageCondResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodePageCondResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ChannelCond = 2;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCondResp.prototype.getChannelcond = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCondResp.prototype.setChannelcond = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AppList = 3;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCondResp.prototype.getApplist = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCondResp.prototype.setApplist = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodePageReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodePageReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodePageReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    cond: (f = msg.getCond()) && proto.xcommon.GetRepayCodePageCond.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodePageReq}
 */
proto.xcommon.GetRepayCodePageReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodePageReq;
  return proto.xcommon.GetRepayCodePageReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodePageReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodePageReq}
 */
proto.xcommon.GetRepayCodePageReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = new proto.xcommon.GetRepayCodePageCond;
      reader.readMessage(value,proto.xcommon.GetRepayCodePageCond.deserializeBinaryFromReader);
      msg.setCond(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodePageReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodePageReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodePageReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getCond();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.GetRepayCodePageCond.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRepayCodePageReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetRepayCodePageReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodePageReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodePageReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetRepayCodePageReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetRepayCodePageReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodePageReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodePageReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional GetRepayCodePageCond Cond = 3;
 * @return {?proto.xcommon.GetRepayCodePageCond}
 */
proto.xcommon.GetRepayCodePageReq.prototype.getCond = function() {
  return /** @type{?proto.xcommon.GetRepayCodePageCond} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.GetRepayCodePageCond, 3));
};


/** @param {?proto.xcommon.GetRepayCodePageCond|undefined} value */
proto.xcommon.GetRepayCodePageReq.prototype.setCond = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodePageReq.prototype.clearCond = function() {
  this.setCond(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodePageReq.prototype.hasCond = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRepayCodePageResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodePageResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodePageResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodePageResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.GetRepayCodePageItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodePageResp}
 */
proto.xcommon.GetRepayCodePageResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodePageResp;
  return proto.xcommon.GetRepayCodePageResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodePageResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodePageResp}
 */
proto.xcommon.GetRepayCodePageResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.GetRepayCodePageItem;
      reader.readMessage(value,proto.xcommon.GetRepayCodePageItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodePageResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodePageResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodePageResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetRepayCodePageItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRepayCodePageResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetRepayCodePageResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodePageResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodePageResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetRepayCodePageResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetRepayCodePageResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodePageResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodePageResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated GetRepayCodePageItem List = 3;
 * @return {!Array<!proto.xcommon.GetRepayCodePageItem>}
 */
proto.xcommon.GetRepayCodePageResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.GetRepayCodePageItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetRepayCodePageItem, 3));
};


/** @param {!Array<!proto.xcommon.GetRepayCodePageItem>} value */
proto.xcommon.GetRepayCodePageResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetRepayCodePageItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetRepayCodePageItem}
 */
proto.xcommon.GetRepayCodePageResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetRepayCodePageItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetRepayCodePageResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodePageItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodePageItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodePageItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    customername: jspb.Message.getFieldWithDefault(msg, 3, ""),
    eaccountnumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    repaycodeMap: (f = msg.getRepaycodeMap()) ? f.toObject(includeInstance, proto.xcommon.MarketPaymentItemList.toObject) : [],
    leftamount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodePageItem}
 */
proto.xcommon.GetRepayCodePageItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodePageItem;
  return proto.xcommon.GetRepayCodePageItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodePageItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodePageItem}
 */
proto.xcommon.GetRepayCodePageItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaccountnumber(value);
      break;
    case 5:
      var value = msg.getRepaycodeMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.MarketPaymentItemList.deserializeBinaryFromReader, 0);
         });
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftamount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodePageItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodePageItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodePageItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getCustomername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRepaycodeMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.MarketPaymentItemList.serializeBinaryToWriter);
  }
  f = message.getLeftamount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageItem.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageItem.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 CustomerId = 2;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageItem.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageItem.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string CustomerName = 3;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageItem.prototype.getCustomername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageItem.prototype.setCustomername = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string EAccountNumber = 4;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageItem.prototype.getEaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageItem.prototype.setEaccountnumber = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * map<int32, MarketPaymentItemList> RepayCode = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.MarketPaymentItemList>}
 */
proto.xcommon.GetRepayCodePageItem.prototype.getRepaycodeMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.MarketPaymentItemList>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.xcommon.MarketPaymentItemList));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetRepayCodePageItem.prototype.clearRepaycodeMap = function() {
  this.getRepaycodeMap().clear();
};


/**
 * optional int64 LeftAmount = 6;
 * @return {number}
 */
proto.xcommon.GetRepayCodePageItem.prototype.getLeftamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.GetRepayCodePageItem.prototype.setLeftamount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string AppName = 7;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageItem.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageItem.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRepayCodePageCond.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodePageCond.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodePageCond.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodePageCond} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageCond.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    mobile: jspb.Message.getFieldWithDefault(msg, 3, ""),
    customername: jspb.Message.getFieldWithDefault(msg, 4, ""),
    eaccountnumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
    repaycodeList: jspb.Message.toObjectList(msg.getRepaycodeList(),
    proto.xcommon.GetRepayCodePageCond.RepayCodeItem.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodePageCond}
 */
proto.xcommon.GetRepayCodePageCond.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodePageCond;
  return proto.xcommon.GetRepayCodePageCond.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodePageCond} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodePageCond}
 */
proto.xcommon.GetRepayCodePageCond.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaccountnumber(value);
      break;
    case 6:
      var value = new proto.xcommon.GetRepayCodePageCond.RepayCodeItem;
      reader.readMessage(value,proto.xcommon.GetRepayCodePageCond.RepayCodeItem.deserializeBinaryFromReader);
      msg.addRepaycode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodePageCond.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodePageCond.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodePageCond} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageCond.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCustomername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRepaycodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.xcommon.GetRepayCodePageCond.RepayCodeItem.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodePageCond.RepayCodeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodePageCond.RepayCodeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentcode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    paymentchannel: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodePageCond.RepayCodeItem}
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodePageCond.RepayCodeItem;
  return proto.xcommon.GetRepayCodePageCond.RepayCodeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodePageCond.RepayCodeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodePageCond.RepayCodeItem}
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentcode(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentchannel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodePageCond.RepayCodeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodePageCond.RepayCodeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaymentchannel();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string PaymentName = 1;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.prototype.getPaymentname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.prototype.setPaymentname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PaymentCode = 2;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.prototype.getPaymentcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.prototype.setPaymentcode = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 PaymentChannel = 3;
 * @return {number}
 */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.prototype.getPaymentchannel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetRepayCodePageCond.RepayCodeItem.prototype.setPaymentchannel = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCond.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCond.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 CustomerId = 2;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCond.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCond.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string Mobile = 3;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCond.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCond.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string CustomerName = 4;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCond.prototype.getCustomername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCond.prototype.setCustomername = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string EAccountNumber = 5;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCond.prototype.getEaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCond.prototype.setEaccountnumber = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated RepayCodeItem RepayCode = 6;
 * @return {!Array<!proto.xcommon.GetRepayCodePageCond.RepayCodeItem>}
 */
proto.xcommon.GetRepayCodePageCond.prototype.getRepaycodeList = function() {
  return /** @type{!Array<!proto.xcommon.GetRepayCodePageCond.RepayCodeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetRepayCodePageCond.RepayCodeItem, 6));
};


/** @param {!Array<!proto.xcommon.GetRepayCodePageCond.RepayCodeItem>} value */
proto.xcommon.GetRepayCodePageCond.prototype.setRepaycodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.xcommon.GetRepayCodePageCond.RepayCodeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetRepayCodePageCond.RepayCodeItem}
 */
proto.xcommon.GetRepayCodePageCond.prototype.addRepaycode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.xcommon.GetRepayCodePageCond.RepayCodeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetRepayCodePageCond.prototype.clearRepaycodeList = function() {
  this.setRepaycodeList([]);
};


/**
 * optional string AppName = 7;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageCond.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageCond.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRepayCodePageResult.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodePageResult.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodePageResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodePageResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    mobile: jspb.Message.getFieldWithDefault(msg, 3, ""),
    customername: jspb.Message.getFieldWithDefault(msg, 4, ""),
    eaccountnumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
    repaycodeList: jspb.Message.toObjectList(msg.getRepaycodeList(),
    xcommon_core_pb.MarketPaymentItem.toObject, includeInstance),
    leftamount: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodePageResult}
 */
proto.xcommon.GetRepayCodePageResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodePageResult;
  return proto.xcommon.GetRepayCodePageResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodePageResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodePageResult}
 */
proto.xcommon.GetRepayCodePageResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaccountnumber(value);
      break;
    case 6:
      var value = new xcommon_core_pb.MarketPaymentItem;
      reader.readMessage(value,xcommon_core_pb.MarketPaymentItem.deserializeBinaryFromReader);
      msg.addRepaycode(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftamount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodePageResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodePageResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodePageResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodePageResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCustomername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRepaycodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      xcommon_core_pb.MarketPaymentItem.serializeBinaryToWriter
    );
  }
  f = message.getLeftamount();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageResult.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageResult.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 CustomerId = 2;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageResult.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageResult.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string Mobile = 3;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageResult.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageResult.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string CustomerName = 4;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageResult.prototype.getCustomername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageResult.prototype.setCustomername = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string EAccountNumber = 5;
 * @return {string}
 */
proto.xcommon.GetRepayCodePageResult.prototype.getEaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodePageResult.prototype.setEaccountnumber = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated MarketPaymentItem RepayCode = 6;
 * @return {!Array<!proto.xcommon.MarketPaymentItem>}
 */
proto.xcommon.GetRepayCodePageResult.prototype.getRepaycodeList = function() {
  return /** @type{!Array<!proto.xcommon.MarketPaymentItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.MarketPaymentItem, 6));
};


/** @param {!Array<!proto.xcommon.MarketPaymentItem>} value */
proto.xcommon.GetRepayCodePageResult.prototype.setRepaycodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.xcommon.MarketPaymentItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.MarketPaymentItem}
 */
proto.xcommon.GetRepayCodePageResult.prototype.addRepaycode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.xcommon.MarketPaymentItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetRepayCodePageResult.prototype.clearRepaycodeList = function() {
  this.setRepaycodeList([]);
};


/**
 * optional int64 LeftAmount = 7;
 * @return {number}
 */
proto.xcommon.GetRepayCodePageResult.prototype.getLeftamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.GetRepayCodePageResult.prototype.setLeftamount = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodeHistoryListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodeHistoryListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodeHistoryListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodeHistoryListReq}
 */
proto.xcommon.GetRepayCodeHistoryListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodeHistoryListReq;
  return proto.xcommon.GetRepayCodeHistoryListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodeHistoryListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodeHistoryListReq}
 */
proto.xcommon.GetRepayCodeHistoryListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodeHistoryListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodeHistoryListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodeHistoryListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 CustomerId = 4;
 * @return {string}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetRepayCodeHistoryListReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRepayCodeHistoryListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayCodeHistoryListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayCodeHistoryListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodeHistoryListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    xcommon_core_pb.MarketPaymentItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayCodeHistoryListResp}
 */
proto.xcommon.GetRepayCodeHistoryListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayCodeHistoryListResp;
  return proto.xcommon.GetRepayCodeHistoryListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayCodeHistoryListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayCodeHistoryListResp}
 */
proto.xcommon.GetRepayCodeHistoryListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new xcommon_core_pb.MarketPaymentItem;
      reader.readMessage(value,xcommon_core_pb.MarketPaymentItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayCodeHistoryListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayCodeHistoryListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayCodeHistoryListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_core_pb.MarketPaymentItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated MarketPaymentItem List = 3;
 * @return {!Array<!proto.xcommon.MarketPaymentItem>}
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.MarketPaymentItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.MarketPaymentItem, 3));
};


/** @param {!Array<!proto.xcommon.MarketPaymentItem>} value */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.MarketPaymentItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.MarketPaymentItem}
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.MarketPaymentItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetRepayCodeHistoryListResp.prototype.clearListList = function() {
  this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetReduceListReq.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReduceListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReduceListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReduceListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    applytimerange: jspb.Message.getFieldWithDefault(msg, 5, ""),
    typeList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    statusList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    reduceid: jspb.Message.getFieldWithDefault(msg, 9, 0),
    approvedtype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    isrepay: jspb.Message.getFieldWithDefault(msg, 11, 0),
    tabidx: jspb.Message.getFieldWithDefault(msg, 12, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReduceListReq}
 */
proto.xcommon.GetReduceListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReduceListReq;
  return proto.xcommon.GetReduceListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReduceListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReduceListReq}
 */
proto.xcommon.GetReduceListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplytimerange(value);
      break;
    case 6:
      var value = /** @type {!Array<!proto.xcommon.ReduceType>} */ (reader.readPackedEnum());
      msg.setTypeList(value);
      break;
    case 7:
      var value = /** @type {!Array<!proto.xcommon.ReduceStatus>} */ (reader.readPackedEnum());
      msg.setStatusList(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReduceid(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.ReduceApprovedType} */ (reader.readEnum());
      msg.setApprovedtype(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsrepay(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTabidx(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReduceListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReduceListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReduceListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getApplytimerange();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTypeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getStatusList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getReduceid();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getApprovedtype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getIsrepay();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getTabidx();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetReduceListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetReduceListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetReduceListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetReduceListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.GetReduceListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.GetReduceListReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 CustomerId = 4;
 * @return {string}
 */
proto.xcommon.GetReduceListReq.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.GetReduceListReq.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string ApplyTimeRange = 5;
 * @return {string}
 */
proto.xcommon.GetReduceListReq.prototype.getApplytimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetReduceListReq.prototype.setApplytimerange = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated ReduceType Type = 6;
 * @return {!Array<!proto.xcommon.ReduceType>}
 */
proto.xcommon.GetReduceListReq.prototype.getTypeList = function() {
  return /** @type {!Array<!proto.xcommon.ReduceType>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<!proto.xcommon.ReduceType>} value */
proto.xcommon.GetReduceListReq.prototype.setTypeList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.xcommon.ReduceType} value
 * @param {number=} opt_index
 */
proto.xcommon.GetReduceListReq.prototype.addType = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetReduceListReq.prototype.clearTypeList = function() {
  this.setTypeList([]);
};


/**
 * repeated ReduceStatus Status = 7;
 * @return {!Array<!proto.xcommon.ReduceStatus>}
 */
proto.xcommon.GetReduceListReq.prototype.getStatusList = function() {
  return /** @type {!Array<!proto.xcommon.ReduceStatus>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<!proto.xcommon.ReduceStatus>} value */
proto.xcommon.GetReduceListReq.prototype.setStatusList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.xcommon.ReduceStatus} value
 * @param {number=} opt_index
 */
proto.xcommon.GetReduceListReq.prototype.addStatus = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetReduceListReq.prototype.clearStatusList = function() {
  this.setStatusList([]);
};


/**
 * optional int64 ReduceId = 9;
 * @return {number}
 */
proto.xcommon.GetReduceListReq.prototype.getReduceid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.GetReduceListReq.prototype.setReduceid = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional ReduceApprovedType ApprovedType = 10;
 * @return {!proto.xcommon.ReduceApprovedType}
 */
proto.xcommon.GetReduceListReq.prototype.getApprovedtype = function() {
  return /** @type {!proto.xcommon.ReduceApprovedType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.ReduceApprovedType} value */
proto.xcommon.GetReduceListReq.prototype.setApprovedtype = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional Bool IsRepay = 11;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetReduceListReq.prototype.getIsrepay = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.GetReduceListReq.prototype.setIsrepay = function(value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional int32 TabIdx = 12;
 * @return {number}
 */
proto.xcommon.GetReduceListReq.prototype.getTabidx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.GetReduceListReq.prototype.setTabidx = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string AppName = 13;
 * @return {string}
 */
proto.xcommon.GetReduceListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.GetReduceListReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetReduceListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReduceListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReduceListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReduceListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ReduceRecordBackend.toObject, includeInstance),
    applist: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReduceListResp}
 */
proto.xcommon.GetReduceListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReduceListResp;
  return proto.xcommon.GetReduceListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReduceListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReduceListResp}
 */
proto.xcommon.GetReduceListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.ReduceRecordBackend;
      reader.readMessage(value,proto.xcommon.ReduceRecordBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReduceListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReduceListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReduceListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.ReduceRecordBackend.serializeBinaryToWriter
    );
  }
  f = message.getApplist();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetReduceListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetReduceListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetReduceListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetReduceListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ReduceRecordBackend List = 3;
 * @return {!Array<!proto.xcommon.ReduceRecordBackend>}
 */
proto.xcommon.GetReduceListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ReduceRecordBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ReduceRecordBackend, 3));
};


/** @param {!Array<!proto.xcommon.ReduceRecordBackend>} value */
proto.xcommon.GetReduceListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.ReduceRecordBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ReduceRecordBackend}
 */
proto.xcommon.GetReduceListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.ReduceRecordBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetReduceListResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional string AppList = 4;
 * @return {string}
 */
proto.xcommon.GetReduceListResp.prototype.getApplist = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.GetReduceListResp.prototype.setApplist = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceRecordLog.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceRecordLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceRecordLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    customername: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    reduceamount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    reduceother: jspb.Message.getFieldWithDefault(msg, 7, ""),
    applyuid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    applytime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    applyreason: jspb.Message.getFieldWithDefault(msg, 10, ""),
    audituid: jspb.Message.getFieldWithDefault(msg, 11, 0),
    audittime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    auditmark: jspb.Message.getFieldWithDefault(msg, 13, ""),
    reducetype: jspb.Message.getFieldWithDefault(msg, 14, 0),
    reducestatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 16, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 17, 0),
    bindreduceid: jspb.Message.getFieldWithDefault(msg, 19, 0),
    reduceid: jspb.Message.getFieldWithDefault(msg, 20, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceRecordLog}
 */
proto.xcommon.ReduceRecordLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceRecordLog;
  return proto.xcommon.ReduceRecordLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceRecordLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceRecordLog}
 */
proto.xcommon.ReduceRecordLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReduceamount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setReduceother(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplyuid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplytime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplyreason(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAudituid(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAudittime(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditmark(value);
      break;
    case 14:
      var value = /** @type {!proto.xcommon.ReduceType} */ (reader.readEnum());
      msg.setReducetype(value);
      break;
    case 15:
      var value = /** @type {!proto.xcommon.ReduceStatus} */ (reader.readEnum());
      msg.setReducestatus(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBindreduceid(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReduceid(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceRecordLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceRecordLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceRecordLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCustomername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getReduceamount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getReduceother();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getApplyuid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getApplytime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getApplyreason();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAudituid();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getAudittime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getAuditmark();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getReducetype();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getReducestatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getBindreduceid();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getReduceid();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.ReduceRecordLog.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.ReduceRecordLog.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 CustomerId = 3;
 * @return {string}
 */
proto.xcommon.ReduceRecordLog.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.ReduceRecordLog.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string CustomerName = 4;
 * @return {string}
 */
proto.xcommon.ReduceRecordLog.prototype.getCustomername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordLog.prototype.setCustomername = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Mobile = 5;
 * @return {string}
 */
proto.xcommon.ReduceRecordLog.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordLog.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 ReduceAmount = 6;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getReduceamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setReduceamount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string ReduceOther = 7;
 * @return {string}
 */
proto.xcommon.ReduceRecordLog.prototype.getReduceother = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordLog.prototype.setReduceother = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 ApplyUid = 8;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getApplyuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setApplyuid = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 ApplyTime = 9;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getApplytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setApplytime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string ApplyReason = 10;
 * @return {string}
 */
proto.xcommon.ReduceRecordLog.prototype.getApplyreason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordLog.prototype.setApplyreason = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 AuditUid = 11;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getAudituid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setAudituid = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 AuditTime = 12;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getAudittime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setAudittime = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string AuditMark = 13;
 * @return {string}
 */
proto.xcommon.ReduceRecordLog.prototype.getAuditmark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordLog.prototype.setAuditmark = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional ReduceType ReduceType = 14;
 * @return {!proto.xcommon.ReduceType}
 */
proto.xcommon.ReduceRecordLog.prototype.getReducetype = function() {
  return /** @type {!proto.xcommon.ReduceType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {!proto.xcommon.ReduceType} value */
proto.xcommon.ReduceRecordLog.prototype.setReducetype = function(value) {
  jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional ReduceStatus ReduceStatus = 15;
 * @return {!proto.xcommon.ReduceStatus}
 */
proto.xcommon.ReduceRecordLog.prototype.getReducestatus = function() {
  return /** @type {!proto.xcommon.ReduceStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {!proto.xcommon.ReduceStatus} value */
proto.xcommon.ReduceRecordLog.prototype.setReducestatus = function(value) {
  jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional int64 Ctime = 16;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 Utime = 17;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 BindReduceId = 19;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getBindreduceid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setBindreduceid = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 ReduceId = 20;
 * @return {number}
 */
proto.xcommon.ReduceRecordLog.prototype.getReduceid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordLog.prototype.setReduceid = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string AppName = 21;
 * @return {string}
 */
proto.xcommon.ReduceRecordLog.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordLog.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ReduceRecordBackend.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceRecordBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceRecordBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceRecordBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    reducerecord: (f = msg.getReducerecord()) && proto.xcommon.ReduceRecordLog.toObject(includeInstance, f),
    applyusername: jspb.Message.getFieldWithDefault(msg, 2, ""),
    auditusername: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reduceotherlistList: jspb.Message.toObjectList(msg.getReduceotherlistList(),
    proto.xcommon.ReduceRecordBackend.ReduceOtherItem.toObject, includeInstance),
    nextauditusername: jspb.Message.getFieldWithDefault(msg, 6, ""),
    tlname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    omname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    approvedtype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    canaudit: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    auditresult: jspb.Message.getFieldWithDefault(msg, 12, ""),
    auditstatus: jspb.Message.getFieldWithDefault(msg, 13, ""),
    reduceresult: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceRecordBackend}
 */
proto.xcommon.ReduceRecordBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceRecordBackend;
  return proto.xcommon.ReduceRecordBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceRecordBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceRecordBackend}
 */
proto.xcommon.ReduceRecordBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.ReduceRecordLog;
      reader.readMessage(value,proto.xcommon.ReduceRecordLog.deserializeBinaryFromReader);
      msg.setReducerecord(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplyusername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditusername(value);
      break;
    case 5:
      var value = new proto.xcommon.ReduceRecordBackend.ReduceOtherItem;
      reader.readMessage(value,proto.xcommon.ReduceRecordBackend.ReduceOtherItem.deserializeBinaryFromReader);
      msg.addReduceotherlist(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextauditusername(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTlname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOmname(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.ReduceApprovedType} */ (reader.readEnum());
      msg.setApprovedtype(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanaudit(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditresult(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditstatus(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setReduceresult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceRecordBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceRecordBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceRecordBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReducerecord();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.ReduceRecordLog.serializeBinaryToWriter
    );
  }
  f = message.getApplyusername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuditusername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReduceotherlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.ReduceRecordBackend.ReduceOtherItem.serializeBinaryToWriter
    );
  }
  f = message.getNextauditusername();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTlname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOmname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getApprovedtype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getCanaudit();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getAuditresult();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAuditstatus();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getReduceresult();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceRecordBackend.ReduceOtherItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceRecordBackend.ReduceOtherItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fieldamount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceRecordBackend.ReduceOtherItem}
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceRecordBackend.ReduceOtherItem;
  return proto.xcommon.ReduceRecordBackend.ReduceOtherItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceRecordBackend.ReduceOtherItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceRecordBackend.ReduceOtherItem}
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFieldamount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceRecordBackend.ReduceOtherItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceRecordBackend.ReduceOtherItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFieldamount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string FieldName = 1;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.prototype.getFieldname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.prototype.setFieldname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 FieldAmount = 2;
 * @return {number}
 */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.prototype.getFieldamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordBackend.ReduceOtherItem.prototype.setFieldamount = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ReduceRecordLog ReduceRecord = 1;
 * @return {?proto.xcommon.ReduceRecordLog}
 */
proto.xcommon.ReduceRecordBackend.prototype.getReducerecord = function() {
  return /** @type{?proto.xcommon.ReduceRecordLog} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ReduceRecordLog, 1));
};


/** @param {?proto.xcommon.ReduceRecordLog|undefined} value */
proto.xcommon.ReduceRecordBackend.prototype.setReducerecord = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ReduceRecordBackend.prototype.clearReducerecord = function() {
  this.setReducerecord(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReduceRecordBackend.prototype.hasReducerecord = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ApplyUserName = 2;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.prototype.getApplyusername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.prototype.setApplyusername = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AuditUserName = 3;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.prototype.getAuditusername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.prototype.setAuditusername = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ReduceOtherItem ReduceOtherList = 5;
 * @return {!Array<!proto.xcommon.ReduceRecordBackend.ReduceOtherItem>}
 */
proto.xcommon.ReduceRecordBackend.prototype.getReduceotherlistList = function() {
  return /** @type{!Array<!proto.xcommon.ReduceRecordBackend.ReduceOtherItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ReduceRecordBackend.ReduceOtherItem, 5));
};


/** @param {!Array<!proto.xcommon.ReduceRecordBackend.ReduceOtherItem>} value */
proto.xcommon.ReduceRecordBackend.prototype.setReduceotherlistList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.ReduceRecordBackend.ReduceOtherItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ReduceRecordBackend.ReduceOtherItem}
 */
proto.xcommon.ReduceRecordBackend.prototype.addReduceotherlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.ReduceRecordBackend.ReduceOtherItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ReduceRecordBackend.prototype.clearReduceotherlistList = function() {
  this.setReduceotherlistList([]);
};


/**
 * optional string NextAuditUserName = 6;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.prototype.getNextauditusername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.prototype.setNextauditusername = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string TLName = 7;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.prototype.getTlname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.prototype.setTlname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string OMName = 8;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.prototype.getOmname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.prototype.setOmname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional ReduceApprovedType ApprovedType = 10;
 * @return {!proto.xcommon.ReduceApprovedType}
 */
proto.xcommon.ReduceRecordBackend.prototype.getApprovedtype = function() {
  return /** @type {!proto.xcommon.ReduceApprovedType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.ReduceApprovedType} value */
proto.xcommon.ReduceRecordBackend.prototype.setApprovedtype = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional bool CanAudit = 11;
 * @return {boolean}
 */
proto.xcommon.ReduceRecordBackend.prototype.getCanaudit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/** @param {boolean} value */
proto.xcommon.ReduceRecordBackend.prototype.setCanaudit = function(value) {
  jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string AuditResult = 12;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.prototype.getAuditresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.prototype.setAuditresult = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string AuditStatus = 13;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.prototype.getAuditstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.prototype.setAuditstatus = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string ReduceResult = 14;
 * @return {string}
 */
proto.xcommon.ReduceRecordBackend.prototype.getReduceresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordBackend.prototype.setReduceresult = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReduceDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReduceDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReduceDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReduceDetailReq}
 */
proto.xcommon.GetReduceDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReduceDetailReq;
  return proto.xcommon.GetReduceDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReduceDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReduceDetailReq}
 */
proto.xcommon.GetReduceDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReduceDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReduceDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReduceDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetReduceDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetReduceDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.GetReduceDetailReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.GetReduceDetailReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.GetReduceDetailReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetReduceDetailReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetReduceDetailResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReduceDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReduceDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReduceDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    repayplan: (f = msg.getRepayplan()) && xcommon_core_pb.RepayPlanInfo.toObject(includeInstance, f),
    repayplanstageList: jspb.Message.toObjectList(msg.getRepayplanstageList(),
    xcommon_core_pb.RepayPlanStageInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReduceDetailResp}
 */
proto.xcommon.GetReduceDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReduceDetailResp;
  return proto.xcommon.GetReduceDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReduceDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReduceDetailResp}
 */
proto.xcommon.GetReduceDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_core_pb.RepayPlanInfo;
      reader.readMessage(value,xcommon_core_pb.RepayPlanInfo.deserializeBinaryFromReader);
      msg.setRepayplan(value);
      break;
    case 3:
      var value = new xcommon_core_pb.RepayPlanStageInfo;
      reader.readMessage(value,xcommon_core_pb.RepayPlanStageInfo.deserializeBinaryFromReader);
      msg.addRepayplanstage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReduceDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReduceDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReduceDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getRepayplan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_core_pb.RepayPlanInfo.serializeBinaryToWriter
    );
  }
  f = message.getRepayplanstageList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_core_pb.RepayPlanStageInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetReduceDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetReduceDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RepayPlanInfo RepayPlan = 2;
 * @return {?proto.xcommon.RepayPlanInfo}
 */
proto.xcommon.GetReduceDetailResp.prototype.getRepayplan = function() {
  return /** @type{?proto.xcommon.RepayPlanInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.RepayPlanInfo, 2));
};


/** @param {?proto.xcommon.RepayPlanInfo|undefined} value */
proto.xcommon.GetReduceDetailResp.prototype.setRepayplan = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceDetailResp.prototype.clearRepayplan = function() {
  this.setRepayplan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceDetailResp.prototype.hasRepayplan = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated RepayPlanStageInfo RepayPlanStage = 3;
 * @return {!Array<!proto.xcommon.RepayPlanStageInfo>}
 */
proto.xcommon.GetReduceDetailResp.prototype.getRepayplanstageList = function() {
  return /** @type{!Array<!proto.xcommon.RepayPlanStageInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.RepayPlanStageInfo, 3));
};


/** @param {!Array<!proto.xcommon.RepayPlanStageInfo>} value */
proto.xcommon.GetReduceDetailResp.prototype.setRepayplanstageList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.RepayPlanStageInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RepayPlanStageInfo}
 */
proto.xcommon.GetReduceDetailResp.prototype.addRepayplanstage = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.RepayPlanStageInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetReduceDetailResp.prototype.clearRepayplanstageList = function() {
  this.setRepayplanstageList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReduceAuditListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReduceAuditListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReduceAuditListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceAuditListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    reduceid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReduceAuditListReq}
 */
proto.xcommon.GetReduceAuditListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReduceAuditListReq;
  return proto.xcommon.GetReduceAuditListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReduceAuditListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReduceAuditListReq}
 */
proto.xcommon.GetReduceAuditListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReduceid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReduceAuditListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReduceAuditListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReduceAuditListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceAuditListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getReduceid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetReduceAuditListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetReduceAuditListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceAuditListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceAuditListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.GetReduceAuditListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.GetReduceAuditListReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 ReduceId = 3;
 * @return {number}
 */
proto.xcommon.GetReduceAuditListReq.prototype.getReduceid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetReduceAuditListReq.prototype.setReduceid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetReduceAuditListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReduceAuditListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReduceAuditListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReduceAuditListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceAuditListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    reduceapply: (f = msg.getReduceapply()) && proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.toObject(includeInstance, f),
    auditlistList: jspb.Message.toObjectList(msg.getAuditlistList(),
    proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReduceAuditListResp}
 */
proto.xcommon.GetReduceAuditListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReduceAuditListResp;
  return proto.xcommon.GetReduceAuditListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReduceAuditListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReduceAuditListResp}
 */
proto.xcommon.GetReduceAuditListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.GetReduceAuditListResp.ReduceAuditItem;
      reader.readMessage(value,proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.deserializeBinaryFromReader);
      msg.setReduceapply(value);
      break;
    case 3:
      var value = new proto.xcommon.GetReduceAuditListResp.ReduceAuditItem;
      reader.readMessage(value,proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.deserializeBinaryFromReader);
      msg.addAuditlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReduceAuditListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReduceAuditListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReduceAuditListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceAuditListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getReduceapply();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.serializeBinaryToWriter
    );
  }
  f = message.getAuditlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    time: jspb.Message.getFieldWithDefault(msg, 1, 0),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    auditresult: jspb.Message.getFieldWithDefault(msg, 5, ""),
    auditstatus: jspb.Message.getFieldWithDefault(msg, 6, ""),
    audittime: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReduceAuditListResp.ReduceAuditItem;
  return proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditresult(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditstatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAudittime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuditresult();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAuditstatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAudittime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 Time = 1;
 * @return {number}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.setTime = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string UserName = 2;
 * @return {string}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AuditResult = 5;
 * @return {string}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.getAuditresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.setAuditresult = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AuditStatus = 6;
 * @return {string}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.getAuditstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.setAuditstatus = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 AuditTime = 7;
 * @return {number}
 */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.getAudittime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.GetReduceAuditListResp.ReduceAuditItem.prototype.setAudittime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetReduceAuditListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetReduceAuditListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceAuditListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceAuditListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ReduceAuditItem ReduceApply = 2;
 * @return {?proto.xcommon.GetReduceAuditListResp.ReduceAuditItem}
 */
proto.xcommon.GetReduceAuditListResp.prototype.getReduceapply = function() {
  return /** @type{?proto.xcommon.GetReduceAuditListResp.ReduceAuditItem} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.GetReduceAuditListResp.ReduceAuditItem, 2));
};


/** @param {?proto.xcommon.GetReduceAuditListResp.ReduceAuditItem|undefined} value */
proto.xcommon.GetReduceAuditListResp.prototype.setReduceapply = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetReduceAuditListResp.prototype.clearReduceapply = function() {
  this.setReduceapply(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReduceAuditListResp.prototype.hasReduceapply = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ReduceAuditItem AuditList = 3;
 * @return {!Array<!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem>}
 */
proto.xcommon.GetReduceAuditListResp.prototype.getAuditlistList = function() {
  return /** @type{!Array<!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetReduceAuditListResp.ReduceAuditItem, 3));
};


/** @param {!Array<!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem>} value */
proto.xcommon.GetReduceAuditListResp.prototype.setAuditlistList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetReduceAuditListResp.ReduceAuditItem}
 */
proto.xcommon.GetReduceAuditListResp.prototype.addAuditlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetReduceAuditListResp.ReduceAuditItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetReduceAuditListResp.prototype.clearAuditlistList = function() {
  this.setAuditlistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveReduceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveReduceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveReduceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveReduceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ispassed: jspb.Message.getFieldWithDefault(msg, 3, 0),
    auditmark: jspb.Message.getFieldWithDefault(msg, 4, ""),
    reduceid: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveReduceReq}
 */
proto.xcommon.SaveReduceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveReduceReq;
  return proto.xcommon.SaveReduceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveReduceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveReduceReq}
 */
proto.xcommon.SaveReduceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIspassed(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditmark(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReduceid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveReduceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveReduceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveReduceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveReduceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getIspassed();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAuditmark();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReduceid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveReduceReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveReduceReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveReduceReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveReduceReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bool IsPassed = 3;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.SaveReduceReq.prototype.getIspassed = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.SaveReduceReq.prototype.setIspassed = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string AuditMark = 4;
 * @return {string}
 */
proto.xcommon.SaveReduceReq.prototype.getAuditmark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SaveReduceReq.prototype.setAuditmark = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 ReduceId = 5;
 * @return {number}
 */
proto.xcommon.SaveReduceReq.prototype.getReduceid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.SaveReduceReq.prototype.setReduceid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveReduceResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveReduceResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveReduceResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveReduceResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    opmsg: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveReduceResp}
 */
proto.xcommon.SaveReduceResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveReduceResp;
  return proto.xcommon.SaveReduceResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveReduceResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveReduceResp}
 */
proto.xcommon.SaveReduceResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveReduceResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveReduceResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveReduceResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveReduceResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOpmsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveReduceResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveReduceResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveReduceResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveReduceResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string OpMsg = 2;
 * @return {string}
 */
proto.xcommon.SaveReduceResp.prototype.getOpmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SaveReduceResp.prototype.setOpmsg = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QuestionParameterI18n.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QuestionParameterI18n.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QuestionParameterI18n} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionParameterI18n.toObject = function(includeInstance, msg) {
  var f, obj = {
    lang: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QuestionParameterI18n}
 */
proto.xcommon.QuestionParameterI18n.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QuestionParameterI18n;
  return proto.xcommon.QuestionParameterI18n.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QuestionParameterI18n} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QuestionParameterI18n}
 */
proto.xcommon.QuestionParameterI18n.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLang(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QuestionParameterI18n.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QuestionParameterI18n.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QuestionParameterI18n} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionParameterI18n.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLang();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Lang = 1;
 * @return {string}
 */
proto.xcommon.QuestionParameterI18n.prototype.getLang = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.QuestionParameterI18n.prototype.setLang = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Value = 2;
 * @return {string}
 */
proto.xcommon.QuestionParameterI18n.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.QuestionParameterI18n.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.QuestionParameter.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QuestionParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QuestionParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QuestionParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    qptype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    value: jspb.Message.getFieldWithDefault(msg, 4, ""),
    action: jspb.Message.getFieldWithDefault(msg, 5, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    utime: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    i18nList: jspb.Message.toObjectList(msg.getI18nList(),
    proto.xcommon.QuestionParameterI18n.toObject, includeInstance),
    opname: jspb.Message.getFieldWithDefault(msg, 10, ""),
    reasonkey: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QuestionParameter}
 */
proto.xcommon.QuestionParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QuestionParameter;
  return proto.xcommon.QuestionParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QuestionParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QuestionParameter}
 */
proto.xcommon.QuestionParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.QpType} */ (reader.readEnum());
      msg.setQptype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.VerifyAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOpuid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setUtime(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.QStatusEnum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = new proto.xcommon.QuestionParameterI18n;
      reader.readMessage(value,proto.xcommon.QuestionParameterI18n.deserializeBinaryFromReader);
      msg.addI18n(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpname(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasonkey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QuestionParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QuestionParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QuestionParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getQptype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getOpuid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
  f = message.getUtime();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getI18nList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.xcommon.QuestionParameterI18n.serializeBinaryToWriter
    );
  }
  f = message.getOpname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getReasonkey();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.QuestionParameter.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.QuestionParameter.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional QpType QpType = 2;
 * @return {!proto.xcommon.QpType}
 */
proto.xcommon.QuestionParameter.prototype.getQptype = function() {
  return /** @type {!proto.xcommon.QpType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.QpType} value */
proto.xcommon.QuestionParameter.prototype.setQptype = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string Desc = 3;
 * @return {string}
 */
proto.xcommon.QuestionParameter.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.QuestionParameter.prototype.setDesc = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Value = 4;
 * @return {string}
 */
proto.xcommon.QuestionParameter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.QuestionParameter.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional VerifyAction Action = 5;
 * @return {!proto.xcommon.VerifyAction}
 */
proto.xcommon.QuestionParameter.prototype.getAction = function() {
  return /** @type {!proto.xcommon.VerifyAction} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.VerifyAction} value */
proto.xcommon.QuestionParameter.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 OpUid = 6;
 * @return {string}
 */
proto.xcommon.QuestionParameter.prototype.getOpuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/** @param {string} value */
proto.xcommon.QuestionParameter.prototype.setOpuid = function(value) {
  jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional int64 Utime = 7;
 * @return {string}
 */
proto.xcommon.QuestionParameter.prototype.getUtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/** @param {string} value */
proto.xcommon.QuestionParameter.prototype.setUtime = function(value) {
  jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional QStatusEnum Status = 8;
 * @return {!proto.xcommon.QStatusEnum}
 */
proto.xcommon.QuestionParameter.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.QStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.QStatusEnum} value */
proto.xcommon.QuestionParameter.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * repeated QuestionParameterI18n I18n = 9;
 * @return {!Array<!proto.xcommon.QuestionParameterI18n>}
 */
proto.xcommon.QuestionParameter.prototype.getI18nList = function() {
  return /** @type{!Array<!proto.xcommon.QuestionParameterI18n>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.QuestionParameterI18n, 9));
};


/** @param {!Array<!proto.xcommon.QuestionParameterI18n>} value */
proto.xcommon.QuestionParameter.prototype.setI18nList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.xcommon.QuestionParameterI18n=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.QuestionParameterI18n}
 */
proto.xcommon.QuestionParameter.prototype.addI18n = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.xcommon.QuestionParameterI18n, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.QuestionParameter.prototype.clearI18nList = function() {
  this.setI18nList([]);
};


/**
 * optional string OpName = 10;
 * @return {string}
 */
proto.xcommon.QuestionParameter.prototype.getOpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.QuestionParameter.prototype.setOpname = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string ReasonKey = 11;
 * @return {string}
 */
proto.xcommon.QuestionParameter.prototype.getReasonkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.QuestionParameter.prototype.setReasonkey = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QuestionParameterReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QuestionParameterReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QuestionParameterReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionParameterReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.QuestionParameter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QuestionParameterReq}
 */
proto.xcommon.QuestionParameterReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QuestionParameterReq;
  return proto.xcommon.QuestionParameterReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QuestionParameterReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QuestionParameterReq}
 */
proto.xcommon.QuestionParameterReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.QuestionParameter;
      reader.readMessage(value,proto.xcommon.QuestionParameter.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QuestionParameterReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QuestionParameterReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QuestionParameterReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionParameterReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.QuestionParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.QuestionParameterReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.QuestionParameterReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.QuestionParameterReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.QuestionParameterReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional QuestionParameter Data = 2;
 * @return {?proto.xcommon.QuestionParameter}
 */
proto.xcommon.QuestionParameterReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.QuestionParameter} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.QuestionParameter, 2));
};


/** @param {?proto.xcommon.QuestionParameter|undefined} value */
proto.xcommon.QuestionParameterReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.QuestionParameterReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.QuestionParameterReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListQuestionParameterReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListQuestionParameterReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListQuestionParameterReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionParameterReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    qptype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    action: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListQuestionParameterReq}
 */
proto.xcommon.ListQuestionParameterReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListQuestionParameterReq;
  return proto.xcommon.ListQuestionParameterReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListQuestionParameterReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListQuestionParameterReq}
 */
proto.xcommon.ListQuestionParameterReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.QpType} */ (reader.readEnum());
      msg.setQptype(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.VerifyAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListQuestionParameterReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListQuestionParameterReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListQuestionParameterReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionParameterReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getQptype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListQuestionParameterReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListQuestionParameterReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionParameterReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionParameterReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListQuestionParameterReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListQuestionParameterReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionParameterReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionParameterReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional QpType QpType = 3;
 * @return {!proto.xcommon.QpType}
 */
proto.xcommon.ListQuestionParameterReq.prototype.getQptype = function() {
  return /** @type {!proto.xcommon.QpType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.QpType} value */
proto.xcommon.ListQuestionParameterReq.prototype.setQptype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional VerifyAction Action = 4;
 * @return {!proto.xcommon.VerifyAction}
 */
proto.xcommon.ListQuestionParameterReq.prototype.getAction = function() {
  return /** @type {!proto.xcommon.VerifyAction} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.VerifyAction} value */
proto.xcommon.ListQuestionParameterReq.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string Status = 5;
 * @return {string}
 */
proto.xcommon.ListQuestionParameterReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ListQuestionParameterReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListQuestionParameterResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListQuestionParameterResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListQuestionParameterResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListQuestionParameterResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionParameterResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.QuestionParameter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListQuestionParameterResp}
 */
proto.xcommon.ListQuestionParameterResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListQuestionParameterResp;
  return proto.xcommon.ListQuestionParameterResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListQuestionParameterResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListQuestionParameterResp}
 */
proto.xcommon.ListQuestionParameterResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.QuestionParameter;
      reader.readMessage(value,proto.xcommon.QuestionParameter.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListQuestionParameterResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListQuestionParameterResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListQuestionParameterResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionParameterResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.QuestionParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListQuestionParameterResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListQuestionParameterResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionParameterResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionParameterResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListQuestionParameterResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListQuestionParameterResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionParameterResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionParameterResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated QuestionParameter List = 3;
 * @return {!Array<!proto.xcommon.QuestionParameter>}
 */
proto.xcommon.ListQuestionParameterResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.QuestionParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.QuestionParameter, 3));
};


/** @param {!Array<!proto.xcommon.QuestionParameter>} value */
proto.xcommon.ListQuestionParameterResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.QuestionParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.QuestionParameter}
 */
proto.xcommon.ListQuestionParameterResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.QuestionParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListQuestionParameterResp.prototype.clearListList = function() {
  this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.Question.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Question.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Question.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Question} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Question.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    qptype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    value: jspb.Message.getFieldWithDefault(msg, 4, ""),
    options: jspb.Message.getFieldWithDefault(msg, 5, ""),
    optionsdisplay: jspb.Message.getFieldWithDefault(msg, 6, ""),
    associateditemsList: jspb.Message.toObjectList(msg.getAssociateditemsList(),
    proto.xcommon.VerifyInfoItem.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 9, "0"),
    utime: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    opname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    questionkey: jspb.Message.getFieldWithDefault(msg, 12, ""),
    defaultnormal: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    appname: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Question}
 */
proto.xcommon.Question.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Question;
  return proto.xcommon.Question.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Question} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Question}
 */
proto.xcommon.Question.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.QpType} */ (reader.readEnum());
      msg.setQptype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptions(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionsdisplay(value);
      break;
    case 7:
      var value = new proto.xcommon.VerifyInfoItem;
      reader.readMessage(value,proto.xcommon.VerifyInfoItem.deserializeBinaryFromReader);
      msg.addAssociateditems(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.QStatusEnum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOpuid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setUtime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionkey(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDefaultnormal(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Question.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Question.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Question} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Question.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getQptype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOptions();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOptionsdisplay();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAssociateditemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.xcommon.VerifyInfoItem.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getOpuid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      9,
      f
    );
  }
  f = message.getUtime();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      10,
      f
    );
  }
  f = message.getOpname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getQuestionkey();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDefaultnormal();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.Question.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional QpType QpType = 2;
 * @return {!proto.xcommon.QpType}
 */
proto.xcommon.Question.prototype.getQptype = function() {
  return /** @type {!proto.xcommon.QpType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.QpType} value */
proto.xcommon.Question.prototype.setQptype = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string Desc = 3;
 * @return {string}
 */
proto.xcommon.Question.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setDesc = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Value = 4;
 * @return {string}
 */
proto.xcommon.Question.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Options = 5;
 * @return {string}
 */
proto.xcommon.Question.prototype.getOptions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setOptions = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string OptionsDisplay = 6;
 * @return {string}
 */
proto.xcommon.Question.prototype.getOptionsdisplay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setOptionsdisplay = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated VerifyInfoItem AssociatedItems = 7;
 * @return {!Array<!proto.xcommon.VerifyInfoItem>}
 */
proto.xcommon.Question.prototype.getAssociateditemsList = function() {
  return /** @type{!Array<!proto.xcommon.VerifyInfoItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.VerifyInfoItem, 7));
};


/** @param {!Array<!proto.xcommon.VerifyInfoItem>} value */
proto.xcommon.Question.prototype.setAssociateditemsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.xcommon.VerifyInfoItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.VerifyInfoItem}
 */
proto.xcommon.Question.prototype.addAssociateditems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.xcommon.VerifyInfoItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.Question.prototype.clearAssociateditemsList = function() {
  this.setAssociateditemsList([]);
};


/**
 * optional QStatusEnum Status = 8;
 * @return {!proto.xcommon.QStatusEnum}
 */
proto.xcommon.Question.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.QStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.QStatusEnum} value */
proto.xcommon.Question.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int64 OpUid = 9;
 * @return {string}
 */
proto.xcommon.Question.prototype.getOpuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setOpuid = function(value) {
  jspb.Message.setProto3StringIntField(this, 9, value);
};


/**
 * optional int64 Utime = 10;
 * @return {string}
 */
proto.xcommon.Question.prototype.getUtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setUtime = function(value) {
  jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional string OpName = 11;
 * @return {string}
 */
proto.xcommon.Question.prototype.getOpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setOpname = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string QuestionKey = 12;
 * @return {string}
 */
proto.xcommon.Question.prototype.getQuestionkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setQuestionkey = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool DefaultNormal = 13;
 * @return {boolean}
 */
proto.xcommon.Question.prototype.getDefaultnormal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/** @param {boolean} value */
proto.xcommon.Question.prototype.setDefaultnormal = function(value) {
  jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string AppName = 14;
 * @return {string}
 */
proto.xcommon.Question.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.Question.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QuestionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QuestionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QuestionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.Question.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QuestionReq}
 */
proto.xcommon.QuestionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QuestionReq;
  return proto.xcommon.QuestionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QuestionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QuestionReq}
 */
proto.xcommon.QuestionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.Question;
      reader.readMessage(value,proto.xcommon.Question.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QuestionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QuestionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QuestionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.Question.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.QuestionReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.QuestionReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.QuestionReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.QuestionReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Question Data = 2;
 * @return {?proto.xcommon.Question}
 */
proto.xcommon.QuestionReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.Question} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Question, 2));
};


/** @param {?proto.xcommon.Question|undefined} value */
proto.xcommon.QuestionReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.QuestionReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.QuestionReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListQuestionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListQuestionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListQuestionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    qptype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    value: jspb.Message.getFieldWithDefault(msg, 4, ""),
    associated: jspb.Message.getFieldWithDefault(msg, 5, ""),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListQuestionReq}
 */
proto.xcommon.ListQuestionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListQuestionReq;
  return proto.xcommon.ListQuestionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListQuestionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListQuestionReq}
 */
proto.xcommon.ListQuestionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.QpType} */ (reader.readEnum());
      msg.setQptype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssociated(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.QStatusEnum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListQuestionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListQuestionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListQuestionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getQptype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssociated();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListQuestionReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListQuestionReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListQuestionReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListQuestionReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional QpType QpType = 3;
 * @return {!proto.xcommon.QpType}
 */
proto.xcommon.ListQuestionReq.prototype.getQptype = function() {
  return /** @type {!proto.xcommon.QpType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.QpType} value */
proto.xcommon.ListQuestionReq.prototype.setQptype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string Value = 4;
 * @return {string}
 */
proto.xcommon.ListQuestionReq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListQuestionReq.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Associated = 5;
 * @return {string}
 */
proto.xcommon.ListQuestionReq.prototype.getAssociated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ListQuestionReq.prototype.setAssociated = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional QStatusEnum Status = 6;
 * @return {!proto.xcommon.QStatusEnum}
 */
proto.xcommon.ListQuestionReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.QStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.QStatusEnum} value */
proto.xcommon.ListQuestionReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string AppName = 7;
 * @return {string}
 */
proto.xcommon.ListQuestionReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.ListQuestionReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListQuestionResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListQuestionResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListQuestionResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListQuestionResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.Question.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListQuestionResp}
 */
proto.xcommon.ListQuestionResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListQuestionResp;
  return proto.xcommon.ListQuestionResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListQuestionResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListQuestionResp}
 */
proto.xcommon.ListQuestionResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.Question;
      reader.readMessage(value,proto.xcommon.Question.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListQuestionResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListQuestionResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListQuestionResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.Question.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListQuestionResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListQuestionResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListQuestionResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListQuestionResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Question List = 3;
 * @return {!Array<!proto.xcommon.Question>}
 */
proto.xcommon.ListQuestionResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.Question>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.Question, 3));
};


/** @param {!Array<!proto.xcommon.Question>} value */
proto.xcommon.ListQuestionResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.Question=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Question}
 */
proto.xcommon.ListQuestionResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.Question, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListQuestionResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QuestionDisplay.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QuestionDisplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QuestionDisplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionDisplay.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    qptype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionsnum: jspb.Message.getFieldWithDefault(msg, 3, 0),
    displaynum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    display: jspb.Message.getFieldWithDefault(msg, 5, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    questions: jspb.Message.getFieldWithDefault(msg, 7, ""),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 9, "0"),
    utime: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    floatinfo: jspb.Message.getFieldWithDefault(msg, 11, ""),
    opname: jspb.Message.getFieldWithDefault(msg, 12, ""),
    loantype: jspb.Message.getFieldWithDefault(msg, 13, 0),
    idverify: jspb.Message.getFieldWithDefault(msg, 14, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QuestionDisplay}
 */
proto.xcommon.QuestionDisplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QuestionDisplay;
  return proto.xcommon.QuestionDisplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QuestionDisplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QuestionDisplay}
 */
proto.xcommon.QuestionDisplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.QpType} */ (reader.readEnum());
      msg.setQptype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuestionsnum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDisplaynum(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.QuestionDisplayEnum} */ (reader.readEnum());
      msg.setDisplay(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestions(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.QStatusEnum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOpuid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setUtime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFloatinfo(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpname(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 14:
      var value = /** @type {!proto.xcommon.IDVerifyEnum} */ (reader.readEnum());
      msg.setIdverify(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QuestionDisplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QuestionDisplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QuestionDisplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionDisplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getQptype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getQuestionsnum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDisplaynum();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDisplay();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getQuestions();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getOpuid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      9,
      f
    );
  }
  f = message.getUtime();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      10,
      f
    );
  }
  f = message.getFloatinfo();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getOpname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getIdverify();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.QuestionDisplay.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.QuestionDisplay.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional QpType QpType = 2;
 * @return {!proto.xcommon.QpType}
 */
proto.xcommon.QuestionDisplay.prototype.getQptype = function() {
  return /** @type {!proto.xcommon.QpType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.QpType} value */
proto.xcommon.QuestionDisplay.prototype.setQptype = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 QuestionsNum = 3;
 * @return {number}
 */
proto.xcommon.QuestionDisplay.prototype.getQuestionsnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.QuestionDisplay.prototype.setQuestionsnum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 DisplayNum = 4;
 * @return {number}
 */
proto.xcommon.QuestionDisplay.prototype.getDisplaynum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.QuestionDisplay.prototype.setDisplaynum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional QuestionDisplayEnum Display = 5;
 * @return {!proto.xcommon.QuestionDisplayEnum}
 */
proto.xcommon.QuestionDisplay.prototype.getDisplay = function() {
  return /** @type {!proto.xcommon.QuestionDisplayEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.QuestionDisplayEnum} value */
proto.xcommon.QuestionDisplay.prototype.setDisplay = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional TicketItemEnum ItemId = 6;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.QuestionDisplay.prototype.getItemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.QuestionDisplay.prototype.setItemid = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string Questions = 7;
 * @return {string}
 */
proto.xcommon.QuestionDisplay.prototype.getQuestions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.QuestionDisplay.prototype.setQuestions = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional QStatusEnum Status = 8;
 * @return {!proto.xcommon.QStatusEnum}
 */
proto.xcommon.QuestionDisplay.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.QStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.QStatusEnum} value */
proto.xcommon.QuestionDisplay.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int64 OpUid = 9;
 * @return {string}
 */
proto.xcommon.QuestionDisplay.prototype.getOpuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/** @param {string} value */
proto.xcommon.QuestionDisplay.prototype.setOpuid = function(value) {
  jspb.Message.setProto3StringIntField(this, 9, value);
};


/**
 * optional int64 Utime = 10;
 * @return {string}
 */
proto.xcommon.QuestionDisplay.prototype.getUtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/** @param {string} value */
proto.xcommon.QuestionDisplay.prototype.setUtime = function(value) {
  jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional string FloatInfo = 11;
 * @return {string}
 */
proto.xcommon.QuestionDisplay.prototype.getFloatinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.QuestionDisplay.prototype.setFloatinfo = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string OpName = 12;
 * @return {string}
 */
proto.xcommon.QuestionDisplay.prototype.getOpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.QuestionDisplay.prototype.setOpname = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional LoanTypeEnum LoanType = 13;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.QuestionDisplay.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.QuestionDisplay.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional IDVerifyEnum IDVerify = 14;
 * @return {!proto.xcommon.IDVerifyEnum}
 */
proto.xcommon.QuestionDisplay.prototype.getIdverify = function() {
  return /** @type {!proto.xcommon.IDVerifyEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {!proto.xcommon.IDVerifyEnum} value */
proto.xcommon.QuestionDisplay.prototype.setIdverify = function(value) {
  jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string AppName = 15;
 * @return {string}
 */
proto.xcommon.QuestionDisplay.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.QuestionDisplay.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QuestionDisplayReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QuestionDisplayReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QuestionDisplayReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionDisplayReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.QuestionDisplay.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QuestionDisplayReq}
 */
proto.xcommon.QuestionDisplayReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QuestionDisplayReq;
  return proto.xcommon.QuestionDisplayReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QuestionDisplayReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QuestionDisplayReq}
 */
proto.xcommon.QuestionDisplayReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.QuestionDisplay;
      reader.readMessage(value,proto.xcommon.QuestionDisplay.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QuestionDisplayReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QuestionDisplayReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QuestionDisplayReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QuestionDisplayReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.QuestionDisplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.QuestionDisplayReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.QuestionDisplayReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.QuestionDisplayReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.QuestionDisplayReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional QuestionDisplay Data = 2;
 * @return {?proto.xcommon.QuestionDisplay}
 */
proto.xcommon.QuestionDisplayReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.QuestionDisplay} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.QuestionDisplay, 2));
};


/** @param {?proto.xcommon.QuestionDisplay|undefined} value */
proto.xcommon.QuestionDisplayReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.QuestionDisplayReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.QuestionDisplayReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListQuestionDisplayReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListQuestionDisplayReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionDisplayReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    qptype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    value: jspb.Message.getFieldWithDefault(msg, 4, ""),
    associated: jspb.Message.getFieldWithDefault(msg, 5, ""),
    loantype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListQuestionDisplayReq}
 */
proto.xcommon.ListQuestionDisplayReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListQuestionDisplayReq;
  return proto.xcommon.ListQuestionDisplayReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListQuestionDisplayReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListQuestionDisplayReq}
 */
proto.xcommon.ListQuestionDisplayReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.QpType} */ (reader.readEnum());
      msg.setQptype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssociated(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListQuestionDisplayReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListQuestionDisplayReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionDisplayReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getQptype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssociated();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListQuestionDisplayReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionDisplayReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListQuestionDisplayReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionDisplayReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional QpType QpType = 3;
 * @return {!proto.xcommon.QpType}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.getQptype = function() {
  return /** @type {!proto.xcommon.QpType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.QpType} value */
proto.xcommon.ListQuestionDisplayReq.prototype.setQptype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string Value = 4;
 * @return {string}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListQuestionDisplayReq.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Associated = 5;
 * @return {string}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.getAssociated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ListQuestionDisplayReq.prototype.setAssociated = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional LoanTypeEnum LoanType = 6;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.ListQuestionDisplayReq.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string AppName = 7;
 * @return {string}
 */
proto.xcommon.ListQuestionDisplayReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.ListQuestionDisplayReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListQuestionDisplayResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListQuestionDisplayResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListQuestionDisplayResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionDisplayResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.QuestionDisplay.toObject, includeInstance),
    applist: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListQuestionDisplayResp}
 */
proto.xcommon.ListQuestionDisplayResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListQuestionDisplayResp;
  return proto.xcommon.ListQuestionDisplayResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListQuestionDisplayResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListQuestionDisplayResp}
 */
proto.xcommon.ListQuestionDisplayResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.QuestionDisplay;
      reader.readMessage(value,proto.xcommon.QuestionDisplay.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListQuestionDisplayResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListQuestionDisplayResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionDisplayResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.QuestionDisplay.serializeBinaryToWriter
    );
  }
  f = message.getApplist();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListQuestionDisplayResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionDisplayResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListQuestionDisplayResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionDisplayResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated QuestionDisplay List = 3;
 * @return {!Array<!proto.xcommon.QuestionDisplay>}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.QuestionDisplay>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.QuestionDisplay, 3));
};


/** @param {!Array<!proto.xcommon.QuestionDisplay>} value */
proto.xcommon.ListQuestionDisplayResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.QuestionDisplay=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.QuestionDisplay}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.QuestionDisplay, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListQuestionDisplayResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional string AppList = 4;
 * @return {string}
 */
proto.xcommon.ListQuestionDisplayResp.prototype.getApplist = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListQuestionDisplayResp.prototype.setApplist = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListQuestionAssociatedItemReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListQuestionAssociatedItemReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListQuestionAssociatedItemReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionAssociatedItemReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListQuestionAssociatedItemReq}
 */
proto.xcommon.ListQuestionAssociatedItemReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListQuestionAssociatedItemReq;
  return proto.xcommon.ListQuestionAssociatedItemReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListQuestionAssociatedItemReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListQuestionAssociatedItemReq}
 */
proto.xcommon.ListQuestionAssociatedItemReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListQuestionAssociatedItemReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListQuestionAssociatedItemReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListQuestionAssociatedItemReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionAssociatedItemReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListQuestionAssociatedItemReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListQuestionAssociatedItemReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionAssociatedItemReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionAssociatedItemReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListQuestionAssociatedItemResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListQuestionAssociatedItemResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListQuestionAssociatedItemResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionAssociatedItemResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.AssociatedItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListQuestionAssociatedItemResp}
 */
proto.xcommon.ListQuestionAssociatedItemResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListQuestionAssociatedItemResp;
  return proto.xcommon.ListQuestionAssociatedItemResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListQuestionAssociatedItemResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListQuestionAssociatedItemResp}
 */
proto.xcommon.ListQuestionAssociatedItemResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AssociatedItem;
      reader.readMessage(value,proto.xcommon.AssociatedItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListQuestionAssociatedItemResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListQuestionAssociatedItemResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListQuestionAssociatedItemResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AssociatedItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AssociatedItem List = 2;
 * @return {!Array<!proto.xcommon.AssociatedItem>}
 */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AssociatedItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AssociatedItem, 2));
};


/** @param {!Array<!proto.xcommon.AssociatedItem>} value */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AssociatedItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AssociatedItem}
 */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AssociatedItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListQuestionAssociatedItemResp.prototype.clearListList = function() {
  this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AssociatedItem.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssociatedItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssociatedItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssociatedItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssociatedItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    verifyinfogroupid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0),
    label: jspb.Message.getFieldWithDefault(msg, 3, ""),
    childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.xcommon.AssociatedItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssociatedItem}
 */
proto.xcommon.AssociatedItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssociatedItem;
  return proto.xcommon.AssociatedItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssociatedItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssociatedItem}
 */
proto.xcommon.AssociatedItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.VerifyInfoGroupEnum} */ (reader.readEnum());
      msg.setVerifyinfogroupid(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.VerifyInfoEnum} */ (reader.readEnum());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = new proto.xcommon.AssociatedItem;
      reader.readMessage(value,proto.xcommon.AssociatedItem.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssociatedItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssociatedItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssociatedItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssociatedItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerifyinfogroupid();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.AssociatedItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional VerifyInfoGroupEnum VerifyInfoGroupID = 1;
 * @return {!proto.xcommon.VerifyInfoGroupEnum}
 */
proto.xcommon.AssociatedItem.prototype.getVerifyinfogroupid = function() {
  return /** @type {!proto.xcommon.VerifyInfoGroupEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.VerifyInfoGroupEnum} value */
proto.xcommon.AssociatedItem.prototype.setVerifyinfogroupid = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional VerifyInfoEnum Value = 2;
 * @return {!proto.xcommon.VerifyInfoEnum}
 */
proto.xcommon.AssociatedItem.prototype.getValue = function() {
  return /** @type {!proto.xcommon.VerifyInfoEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.VerifyInfoEnum} value */
proto.xcommon.AssociatedItem.prototype.setValue = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string Label = 3;
 * @return {string}
 */
proto.xcommon.AssociatedItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AssociatedItem.prototype.setLabel = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated AssociatedItem Children = 4;
 * @return {!Array<!proto.xcommon.AssociatedItem>}
 */
proto.xcommon.AssociatedItem.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.xcommon.AssociatedItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AssociatedItem, 4));
};


/** @param {!Array<!proto.xcommon.AssociatedItem>} value */
proto.xcommon.AssociatedItem.prototype.setChildrenList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.AssociatedItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AssociatedItem}
 */
proto.xcommon.AssociatedItem.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.AssociatedItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AssociatedItem.prototype.clearChildrenList = function() {
  this.setChildrenList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.VerifyInfoItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.VerifyInfoItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.VerifyInfoItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VerifyInfoItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    verifyinfoid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.VerifyInfoItem}
 */
proto.xcommon.VerifyInfoItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.VerifyInfoItem;
  return proto.xcommon.VerifyInfoItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.VerifyInfoItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.VerifyInfoItem}
 */
proto.xcommon.VerifyInfoItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.VerifyInfoEnum} */ (reader.readEnum());
      msg.setVerifyinfoid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.VerifyInfoItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.VerifyInfoItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.VerifyInfoItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VerifyInfoItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerifyinfoid();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional VerifyInfoEnum VerifyInfoID = 1;
 * @return {!proto.xcommon.VerifyInfoEnum}
 */
proto.xcommon.VerifyInfoItem.prototype.getVerifyinfoid = function() {
  return /** @type {!proto.xcommon.VerifyInfoEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.VerifyInfoEnum} value */
proto.xcommon.VerifyInfoItem.prototype.setVerifyinfoid = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.VerifyInfoItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.VerifyInfoItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AutoCallParams.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AutoCallParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AutoCallParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    supplier: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    calledmobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    showmobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    createcalltimerange: jspb.Message.getFieldWithDefault(msg, 6, ""),
    truecalltimerange: jspb.Message.getFieldWithDefault(msg, 7, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AutoCallParams}
 */
proto.xcommon.AutoCallParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AutoCallParams;
  return proto.xcommon.AutoCallParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AutoCallParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AutoCallParams}
 */
proto.xcommon.AutoCallParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.AutoCallSupplier} */ (reader.readEnum());
      msg.setSupplier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalledmobile(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setShowmobile(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatecalltimerange(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTruecalltimerange(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AutoCallParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AutoCallParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AutoCallParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSupplier();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCalledmobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getShowmobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatecalltimerange();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTruecalltimerange();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional AutoCallSupplier Supplier = 1;
 * @return {!proto.xcommon.AutoCallSupplier}
 */
proto.xcommon.AutoCallParams.prototype.getSupplier = function() {
  return /** @type {!proto.xcommon.AutoCallSupplier} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.AutoCallSupplier} value */
proto.xcommon.AutoCallParams.prototype.setSupplier = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 AccountID = 2;
 * @return {string}
 */
proto.xcommon.AutoCallParams.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.AutoCallParams.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 OrderID = 3;
 * @return {string}
 */
proto.xcommon.AutoCallParams.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.AutoCallParams.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string CalledMobile = 4;
 * @return {string}
 */
proto.xcommon.AutoCallParams.prototype.getCalledmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallParams.prototype.setCalledmobile = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ShowMobile = 5;
 * @return {string}
 */
proto.xcommon.AutoCallParams.prototype.getShowmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallParams.prototype.setShowmobile = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string CreateCallTimeRange = 6;
 * @return {string}
 */
proto.xcommon.AutoCallParams.prototype.getCreatecalltimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallParams.prototype.setCreatecalltimerange = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string TrueCallTimeRange = 7;
 * @return {string}
 */
proto.xcommon.AutoCallParams.prototype.getTruecalltimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallParams.prototype.setTruecalltimerange = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string AppName = 8;
 * @return {string}
 */
proto.xcommon.AutoCallParams.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallParams.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AutoCallCoreReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AutoCallCoreReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AutoCallCoreReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallCoreReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    params: (f = msg.getParams()) && proto.xcommon.AutoCallParams.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AutoCallCoreReq}
 */
proto.xcommon.AutoCallCoreReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AutoCallCoreReq;
  return proto.xcommon.AutoCallCoreReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AutoCallCoreReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AutoCallCoreReq}
 */
proto.xcommon.AutoCallCoreReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = new proto.xcommon.AutoCallParams;
      reader.readMessage(value,proto.xcommon.AutoCallParams.deserializeBinaryFromReader);
      msg.setParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AutoCallCoreReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AutoCallCoreReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AutoCallCoreReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallCoreReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getParams();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.AutoCallParams.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.AutoCallCoreReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.AutoCallCoreReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AutoCallCoreReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AutoCallCoreReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.AutoCallCoreReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.AutoCallCoreReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AutoCallCoreReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AutoCallCoreReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AutoCallParams Params = 3;
 * @return {?proto.xcommon.AutoCallParams}
 */
proto.xcommon.AutoCallCoreReq.prototype.getParams = function() {
  return /** @type{?proto.xcommon.AutoCallParams} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AutoCallParams, 3));
};


/** @param {?proto.xcommon.AutoCallParams|undefined} value */
proto.xcommon.AutoCallCoreReq.prototype.setParams = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AutoCallCoreReq.prototype.clearParams = function() {
  this.setParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AutoCallCoreReq.prototype.hasParams = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AutoCallCoreResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AutoCallCoreResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AutoCallCoreResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AutoCallCoreResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallCoreResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    respdataList: jspb.Message.toObjectList(msg.getRespdataList(),
    xcommon_core_pb.AutoCallCoreResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AutoCallCoreResp}
 */
proto.xcommon.AutoCallCoreResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AutoCallCoreResp;
  return proto.xcommon.AutoCallCoreResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AutoCallCoreResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AutoCallCoreResp}
 */
proto.xcommon.AutoCallCoreResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new xcommon_core_pb.AutoCallCoreResult;
      reader.readMessage(value,xcommon_core_pb.AutoCallCoreResult.deserializeBinaryFromReader);
      msg.addRespdata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AutoCallCoreResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AutoCallCoreResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AutoCallCoreResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallCoreResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getRespdataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_core_pb.AutoCallCoreResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.AutoCallCoreResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.AutoCallCoreResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AutoCallCoreResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AutoCallCoreResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.AutoCallCoreResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.AutoCallCoreResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AutoCallCoreResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AutoCallCoreResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AutoCallCoreResult RespData = 3;
 * @return {!Array<!proto.xcommon.AutoCallCoreResult>}
 */
proto.xcommon.AutoCallCoreResp.prototype.getRespdataList = function() {
  return /** @type{!Array<!proto.xcommon.AutoCallCoreResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.AutoCallCoreResult, 3));
};


/** @param {!Array<!proto.xcommon.AutoCallCoreResult>} value */
proto.xcommon.AutoCallCoreResp.prototype.setRespdataList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AutoCallCoreResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AutoCallCoreResult}
 */
proto.xcommon.AutoCallCoreResp.prototype.addRespdata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AutoCallCoreResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AutoCallCoreResp.prototype.clearRespdataList = function() {
  this.setRespdataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ManualUpgradeTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ManualUpgradeTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ManualUpgradeTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ManualUpgradeTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    overdueday: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ManualUpgradeTicketReq}
 */
proto.xcommon.ManualUpgradeTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ManualUpgradeTicketReq;
  return proto.xcommon.ManualUpgradeTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ManualUpgradeTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ManualUpgradeTicketReq}
 */
proto.xcommon.ManualUpgradeTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOverdueday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ManualUpgradeTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ManualUpgradeTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ManualUpgradeTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ManualUpgradeTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOverdueday();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ManualUpgradeTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ManualUpgradeTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ManualUpgradeTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ManualUpgradeTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OverdueDay = 2;
 * @return {number}
 */
proto.xcommon.ManualUpgradeTicketReq.prototype.getOverdueday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ManualUpgradeTicketReq.prototype.setOverdueday = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ManualUpgradeTicketResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ManualUpgradeTicketResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ManualUpgradeTicketResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ManualUpgradeTicketResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    transactionid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ManualUpgradeTicketResp}
 */
proto.xcommon.ManualUpgradeTicketResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ManualUpgradeTicketResp;
  return proto.xcommon.ManualUpgradeTicketResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ManualUpgradeTicketResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ManualUpgradeTicketResp}
 */
proto.xcommon.ManualUpgradeTicketResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ManualUpgradeTicketResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ManualUpgradeTicketResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ManualUpgradeTicketResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ManualUpgradeTicketResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTransactionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ManualUpgradeTicketResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ManualUpgradeTicketResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ManualUpgradeTicketResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ManualUpgradeTicketResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string TransactionID = 2;
 * @return {string}
 */
proto.xcommon.ManualUpgradeTicketResp.prototype.getTransactionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ManualUpgradeTicketResp.prototype.setTransactionid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ManualUpgradeTicketResultReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ManualUpgradeTicketResultReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ManualUpgradeTicketResultReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ManualUpgradeTicketResultReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    transactionid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ManualUpgradeTicketResultReq}
 */
proto.xcommon.ManualUpgradeTicketResultReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ManualUpgradeTicketResultReq;
  return proto.xcommon.ManualUpgradeTicketResultReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ManualUpgradeTicketResultReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ManualUpgradeTicketResultReq}
 */
proto.xcommon.ManualUpgradeTicketResultReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ManualUpgradeTicketResultReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ManualUpgradeTicketResultReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ManualUpgradeTicketResultReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ManualUpgradeTicketResultReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTransactionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ManualUpgradeTicketResultReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ManualUpgradeTicketResultReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ManualUpgradeTicketResultReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ManualUpgradeTicketResultReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string TransactionID = 2;
 * @return {string}
 */
proto.xcommon.ManualUpgradeTicketResultReq.prototype.getTransactionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ManualUpgradeTicketResultReq.prototype.setTransactionid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ManualUpgradeTicketResultResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ManualUpgradeTicketResultResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ManualUpgradeTicketResultResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    code: jspb.Message.getFieldWithDefault(msg, 2, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ManualUpgradeTicketResultResp}
 */
proto.xcommon.ManualUpgradeTicketResultResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ManualUpgradeTicketResultResp;
  return proto.xcommon.ManualUpgradeTicketResultResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ManualUpgradeTicketResultResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ManualUpgradeTicketResultResp}
 */
proto.xcommon.ManualUpgradeTicketResultResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ManualUpgradeTicketResultResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ManualUpgradeTicketResultResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ManualUpgradeTicketResultResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Code = 2;
 * @return {number}
 */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.setCode = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Desc = 3;
 * @return {string}
 */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.setDesc = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 Total = 4;
 * @return {number}
 */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.ManualUpgradeTicketResultResp.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepaymentDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepaymentDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepaymentDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepaymentDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    statsdate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepaymentDetailReq}
 */
proto.xcommon.GetRepaymentDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepaymentDetailReq;
  return proto.xcommon.GetRepaymentDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepaymentDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepaymentDetailReq}
 */
proto.xcommon.GetRepaymentDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatsdate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepaymentDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepaymentDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepaymentDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepaymentDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getStatsdate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRepaymentDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetRepaymentDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepaymentDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepaymentDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string StatsDate = 2;
 * @return {string}
 */
proto.xcommon.GetRepaymentDetailReq.prototype.getStatsdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetRepaymentDetailReq.prototype.setStatsdate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 TicketItemID = 3;
 * @return {number}
 */
proto.xcommon.GetRepaymentDetailReq.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetRepaymentDetailReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 AdminUID = 4;
 * @return {number}
 */
proto.xcommon.GetRepaymentDetailReq.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetRepaymentDetailReq.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRepaymentDetailResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepaymentDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepaymentDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepaymentDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepaymentDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    xcommon_core_pb.OrderRepaymentDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepaymentDetailResp}
 */
proto.xcommon.GetRepaymentDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepaymentDetailResp;
  return proto.xcommon.GetRepaymentDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepaymentDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepaymentDetailResp}
 */
proto.xcommon.GetRepaymentDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_core_pb.OrderRepaymentDetail;
      reader.readMessage(value,xcommon_core_pb.OrderRepaymentDetail.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepaymentDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepaymentDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepaymentDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepaymentDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      xcommon_core_pb.OrderRepaymentDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRepaymentDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetRepaymentDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRepaymentDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepaymentDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OrderRepaymentDetail List = 2;
 * @return {!Array<!proto.xcommon.OrderRepaymentDetail>}
 */
proto.xcommon.GetRepaymentDetailResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.OrderRepaymentDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.OrderRepaymentDetail, 2));
};


/** @param {!Array<!proto.xcommon.OrderRepaymentDetail>} value */
proto.xcommon.GetRepaymentDetailResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.OrderRepaymentDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OrderRepaymentDetail}
 */
proto.xcommon.GetRepaymentDetailResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.OrderRepaymentDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetRepaymentDetailResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWorkerRepayDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWorkerRepayDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWorkerRepayDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerRepayDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    statsdate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWorkerRepayDetailReq}
 */
proto.xcommon.GetWorkerRepayDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWorkerRepayDetailReq;
  return proto.xcommon.GetWorkerRepayDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWorkerRepayDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWorkerRepayDetailReq}
 */
proto.xcommon.GetWorkerRepayDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatsdate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWorkerRepayDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWorkerRepayDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWorkerRepayDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerRepayDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getStatsdate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetWorkerRepayDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetWorkerRepayDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWorkerRepayDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWorkerRepayDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string StatsDate = 2;
 * @return {string}
 */
proto.xcommon.GetWorkerRepayDetailReq.prototype.getStatsdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetWorkerRepayDetailReq.prototype.setStatsdate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 TicketItemID = 3;
 * @return {number}
 */
proto.xcommon.GetWorkerRepayDetailReq.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerRepayDetailReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 AdminUID = 4;
 * @return {number}
 */
proto.xcommon.GetWorkerRepayDetailReq.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerRepayDetailReq.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetWorkerRepayDetailResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWorkerRepayDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWorkerRepayDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWorkerRepayDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerRepayDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    xcommon_core_pb.OrderRepayDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWorkerRepayDetailResp}
 */
proto.xcommon.GetWorkerRepayDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWorkerRepayDetailResp;
  return proto.xcommon.GetWorkerRepayDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWorkerRepayDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWorkerRepayDetailResp}
 */
proto.xcommon.GetWorkerRepayDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_core_pb.OrderRepayDetail;
      reader.readMessage(value,xcommon_core_pb.OrderRepayDetail.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWorkerRepayDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWorkerRepayDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWorkerRepayDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerRepayDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      xcommon_core_pb.OrderRepayDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetWorkerRepayDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetWorkerRepayDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWorkerRepayDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWorkerRepayDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OrderRepayDetail List = 2;
 * @return {!Array<!proto.xcommon.OrderRepayDetail>}
 */
proto.xcommon.GetWorkerRepayDetailResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.OrderRepayDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.OrderRepayDetail, 2));
};


/** @param {!Array<!proto.xcommon.OrderRepayDetail>} value */
proto.xcommon.GetWorkerRepayDetailResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.OrderRepayDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OrderRepayDetail}
 */
proto.xcommon.GetWorkerRepayDetailResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.OrderRepayDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetWorkerRepayDetailResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWorkerLoanUnpaidDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    statsdate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    loantype: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWorkerLoanUnpaidDetailReq}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWorkerLoanUnpaidDetailReq;
  return proto.xcommon.GetWorkerLoanUnpaidDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWorkerLoanUnpaidDetailReq}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatsdate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWorkerLoanUnpaidDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getStatsdate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string StatsDate = 2;
 * @return {string}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.getStatsdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.setStatsdate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 TicketItemID = 3;
 * @return {number}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 AdminUID = 4;
 * @return {number}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional LoanTypeEnum LoanType = 6;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.GetWorkerLoanUnpaidDetailReq.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWorkerLoanUnpaidDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.OrderUnpaidDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWorkerLoanUnpaidDetailResp}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWorkerLoanUnpaidDetailResp;
  return proto.xcommon.GetWorkerLoanUnpaidDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWorkerLoanUnpaidDetailResp}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.OrderUnpaidDetail;
      reader.readMessage(value,proto.xcommon.OrderUnpaidDetail.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWorkerLoanUnpaidDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.OrderUnpaidDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OrderUnpaidDetail List = 2;
 * @return {!Array<!proto.xcommon.OrderUnpaidDetail>}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.OrderUnpaidDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.OrderUnpaidDetail, 2));
};


/** @param {!Array<!proto.xcommon.OrderUnpaidDetail>} value */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.OrderUnpaidDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OrderUnpaidDetail}
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.OrderUnpaidDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetWorkerLoanUnpaidDetailResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderUnpaidDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderUnpaidDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderUnpaidDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderUnpaidDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    leftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 5, 0),
    assigntime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderUnpaidDetail}
 */
proto.xcommon.OrderUnpaidDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderUnpaidDetail;
  return proto.xcommon.OrderUnpaidDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderUnpaidDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderUnpaidDetail}
 */
proto.xcommon.OrderUnpaidDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftunpaidprincipal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssigntime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderUnpaidDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderUnpaidDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderUnpaidDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderUnpaidDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLeftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAssigntime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.OrderUnpaidDetail.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.OrderUnpaidDetail.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.OrderUnpaidDetail.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.OrderUnpaidDetail.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.OrderUnpaidDetail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.OrderUnpaidDetail.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string EmployeeId = 4;
 * @return {string}
 */
proto.xcommon.OrderUnpaidDetail.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.OrderUnpaidDetail.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 LeftUnpaidPrincipal = 5;
 * @return {number}
 */
proto.xcommon.OrderUnpaidDetail.prototype.getLeftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.OrderUnpaidDetail.prototype.setLeftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AssignTime = 6;
 * @return {number}
 */
proto.xcommon.OrderUnpaidDetail.prototype.getAssigntime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.OrderUnpaidDetail.prototype.setAssigntime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Ctime = 7;
 * @return {number}
 */
proto.xcommon.OrderUnpaidDetail.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.OrderUnpaidDetail.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOrderRepayDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOrderRepayDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOrderRepayDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOrderRepayDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOrderRepayDetailReq}
 */
proto.xcommon.GetOrderRepayDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOrderRepayDetailReq;
  return proto.xcommon.GetOrderRepayDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOrderRepayDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOrderRepayDetailReq}
 */
proto.xcommon.GetOrderRepayDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOrderRepayDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOrderRepayDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOrderRepayDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOrderRepayDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetOrderRepayDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetOrderRepayDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOrderRepayDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOrderRepayDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.GetOrderRepayDetailReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.GetOrderRepayDetailReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetOrderRepayDetailResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOrderRepayDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOrderRepayDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOrderRepayDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOrderRepayDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    xcommon_core_pb.OrderRepayDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOrderRepayDetailResp}
 */
proto.xcommon.GetOrderRepayDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOrderRepayDetailResp;
  return proto.xcommon.GetOrderRepayDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOrderRepayDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOrderRepayDetailResp}
 */
proto.xcommon.GetOrderRepayDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_core_pb.OrderRepayDetail;
      reader.readMessage(value,xcommon_core_pb.OrderRepayDetail.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOrderRepayDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOrderRepayDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOrderRepayDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOrderRepayDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      xcommon_core_pb.OrderRepayDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetOrderRepayDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetOrderRepayDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOrderRepayDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOrderRepayDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OrderRepayDetail List = 2;
 * @return {!Array<!proto.xcommon.OrderRepayDetail>}
 */
proto.xcommon.GetOrderRepayDetailResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.OrderRepayDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.OrderRepayDetail, 2));
};


/** @param {!Array<!proto.xcommon.OrderRepayDetail>} value */
proto.xcommon.GetOrderRepayDetailResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.OrderRepayDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OrderRepayDetail}
 */
proto.xcommon.GetOrderRepayDetailResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.OrderRepayDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetOrderRepayDetailResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CallingPlanReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CallingPlanReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CallingPlanReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallingPlanReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    planname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    strategy: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timerange: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sequence: jspb.Message.getFieldWithDefault(msg, 6, 0),
    itemids: jspb.Message.getFieldWithDefault(msg, 7, ""),
    usergroupids: jspb.Message.getFieldWithDefault(msg, 8, ""),
    company: jspb.Message.getFieldWithDefault(msg, 9, ""),
    hours: jspb.Message.getFieldWithDefault(msg, 10, ""),
    status: jspb.Message.getFieldWithDefault(msg, 11, 0),
    groupname: jspb.Message.getFieldWithDefault(msg, 12, ""),
    agentname: jspb.Message.getFieldWithDefault(msg, 13, ""),
    callingtype: jspb.Message.getFieldWithDefault(msg, 14, 0),
    repeattimes: jspb.Message.getFieldWithDefault(msg, 15, 0),
    maxlostrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    templatename: jspb.Message.getFieldWithDefault(msg, 17, ""),
    voicemailredial: jspb.Message.getFieldWithDefault(msg, 18, 0),
    resultstrategies: jspb.Message.getFieldWithDefault(msg, 19, ""),
    userids: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CallingPlanReq}
 */
proto.xcommon.CallingPlanReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CallingPlanReq;
  return proto.xcommon.CallingPlanReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CallingPlanReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CallingPlanReq}
 */
proto.xcommon.CallingPlanReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrategy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSequence(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemids(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupids(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHours(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupname(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgentname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallingtype(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepeattimes(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxlostrate(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplatename(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVoicemailredial(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setResultstrategies(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CallingPlanReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CallingPlanReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CallingPlanReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallingPlanReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPlanname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStrategy();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSequence();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getItemids();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUsergroupids();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHours();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getGroupname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAgentname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCallingtype();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getRepeattimes();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getMaxlostrate();
  if (f !== 0.0) {
    writer.writeFloat(
      16,
      f
    );
  }
  f = message.getTemplatename();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getVoicemailredial();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getResultstrategies();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getUserids();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CallingPlanReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.CallingPlanReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CallingPlanReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CallingPlanReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.CallingPlanReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.CallingPlanReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string PlanName = 3;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getPlanname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setPlanname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Strategy = 4;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getStrategy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setStrategy = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string TimeRange = 5;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 Sequence = 6;
 * @return {number}
 */
proto.xcommon.CallingPlanReq.prototype.getSequence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.CallingPlanReq.prototype.setSequence = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string ItemIDs = 7;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getItemids = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setItemids = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string UserGroupIDs = 8;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getUsergroupids = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setUsergroupids = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Company = 9;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setCompany = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Hours = 10;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getHours = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setHours = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional CommonStatus Status = 11;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.CallingPlanReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.CallingPlanReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string GroupName = 12;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getGroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setGroupname = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string AgentName = 13;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getAgentname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setAgentname = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 CallingType = 14;
 * @return {number}
 */
proto.xcommon.CallingPlanReq.prototype.getCallingtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.CallingPlanReq.prototype.setCallingtype = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 RepeatTimes = 15;
 * @return {number}
 */
proto.xcommon.CallingPlanReq.prototype.getRepeattimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.CallingPlanReq.prototype.setRepeattimes = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional float MaxLostRate = 16;
 * @return {number}
 */
proto.xcommon.CallingPlanReq.prototype.getMaxlostrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/** @param {number} value */
proto.xcommon.CallingPlanReq.prototype.setMaxlostrate = function(value) {
  jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional string TemplateName = 17;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getTemplatename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setTemplatename = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int64 VoicemailRedial = 18;
 * @return {number}
 */
proto.xcommon.CallingPlanReq.prototype.getVoicemailredial = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.CallingPlanReq.prototype.setVoicemailredial = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string ResultStrategies = 19;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getResultstrategies = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setResultstrategies = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string UserIds = 20;
 * @return {string}
 */
proto.xcommon.CallingPlanReq.prototype.getUserids = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/** @param {string} value */
proto.xcommon.CallingPlanReq.prototype.setUserids = function(value) {
  jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RestTimes.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RestTimes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RestTimes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RestTimes.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, ""),
    end: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RestTimes}
 */
proto.xcommon.RestTimes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RestTimes;
  return proto.xcommon.RestTimes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RestTimes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RestTimes}
 */
proto.xcommon.RestTimes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RestTimes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RestTimes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RestTimes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RestTimes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Start = 1;
 * @return {string}
 */
proto.xcommon.RestTimes.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.RestTimes.prototype.setStart = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string End = 2;
 * @return {string}
 */
proto.xcommon.RestTimes.prototype.getEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.RestTimes.prototype.setEnd = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ResultStrategies.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ResultStrategies.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ResultStrategies.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ResultStrategies} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ResultStrategies.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    oper: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, ""),
    actionList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    dncday: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ResultStrategies}
 */
proto.xcommon.ResultStrategies.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ResultStrategies;
  return proto.xcommon.ResultStrategies.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ResultStrategies} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ResultStrategies}
 */
proto.xcommon.ResultStrategies.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOper(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setActionList(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDncday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ResultStrategies.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ResultStrategies.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ResultStrategies} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ResultStrategies.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOper();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActionList();
  if (f.length > 0) {
    writer.writePackedInt64(
      4,
      f
    );
  }
  f = message.getDncday();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string Title = 1;
 * @return {string}
 */
proto.xcommon.ResultStrategies.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.ResultStrategies.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Oper = 2;
 * @return {string}
 */
proto.xcommon.ResultStrategies.prototype.getOper = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ResultStrategies.prototype.setOper = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Value = 3;
 * @return {string}
 */
proto.xcommon.ResultStrategies.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ResultStrategies.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated int64 Action = 4;
 * @return {!Array<number>}
 */
proto.xcommon.ResultStrategies.prototype.getActionList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<number>} value */
proto.xcommon.ResultStrategies.prototype.setActionList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.ResultStrategies.prototype.addAction = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ResultStrategies.prototype.clearActionList = function() {
  this.setActionList([]);
};


/**
 * optional int64 DncDay = 5;
 * @return {number}
 */
proto.xcommon.ResultStrategies.prototype.getDncday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.ResultStrategies.prototype.setDncday = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QaResultSelect.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QaResultSelect.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QaResultSelect} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QaResultSelect.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QaResultSelect}
 */
proto.xcommon.QaResultSelect.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QaResultSelect;
  return proto.xcommon.QaResultSelect.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QaResultSelect} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QaResultSelect}
 */
proto.xcommon.QaResultSelect.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QaResultSelect.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QaResultSelect.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QaResultSelect} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QaResultSelect.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Title = 1;
 * @return {string}
 */
proto.xcommon.QaResultSelect.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.QaResultSelect.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Value = 2;
 * @return {string}
 */
proto.xcommon.QaResultSelect.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.QaResultSelect.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CallingPlanResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CallingPlanResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CallingPlanResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallingPlanResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CallingPlanResp}
 */
proto.xcommon.CallingPlanResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CallingPlanResp;
  return proto.xcommon.CallingPlanResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CallingPlanResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CallingPlanResp}
 */
proto.xcommon.CallingPlanResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CallingPlanResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CallingPlanResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CallingPlanResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallingPlanResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CallingPlanResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.CallingPlanResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CallingPlanResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CallingPlanResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCallingPlanConfigReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCallingPlanConfigReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCallingPlanConfigReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCallingPlanConfigReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCallingPlanConfigReq}
 */
proto.xcommon.GetCallingPlanConfigReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCallingPlanConfigReq;
  return proto.xcommon.GetCallingPlanConfigReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCallingPlanConfigReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCallingPlanConfigReq}
 */
proto.xcommon.GetCallingPlanConfigReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCallingPlanConfigReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCallingPlanConfigReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCallingPlanConfigReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCallingPlanConfigReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetCallingPlanConfigReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetCallingPlanConfigReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetCallingPlanConfigReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCallingPlanConfigReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetCallingPlanConfigResp.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCallingPlanConfigResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCallingPlanConfigResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCallingPlanConfigResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    talkresult: (f = msg.getTalkresult()) && proto.xcommon.TalkResult.toObject(includeInstance, f),
    seattreeList: jspb.Message.toObjectList(msg.getSeattreeList(),
    proto.xcommon.SeatTreeNode.toObject, includeInstance),
    dealmethodList: jspb.Message.toObjectList(msg.getDealmethodList(),
    proto.xcommon.DealMethod.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCallingPlanConfigResp}
 */
proto.xcommon.GetCallingPlanConfigResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCallingPlanConfigResp;
  return proto.xcommon.GetCallingPlanConfigResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCallingPlanConfigResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCallingPlanConfigResp}
 */
proto.xcommon.GetCallingPlanConfigResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.TalkResult;
      reader.readMessage(value,proto.xcommon.TalkResult.deserializeBinaryFromReader);
      msg.setTalkresult(value);
      break;
    case 3:
      var value = new proto.xcommon.SeatTreeNode;
      reader.readMessage(value,proto.xcommon.SeatTreeNode.deserializeBinaryFromReader);
      msg.addSeattree(value);
      break;
    case 4:
      var value = new proto.xcommon.DealMethod;
      reader.readMessage(value,proto.xcommon.DealMethod.deserializeBinaryFromReader);
      msg.addDealmethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCallingPlanConfigResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCallingPlanConfigResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCallingPlanConfigResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTalkresult();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.TalkResult.serializeBinaryToWriter
    );
  }
  f = message.getSeattreeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.SeatTreeNode.serializeBinaryToWriter
    );
  }
  f = message.getDealmethodList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.DealMethod.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetCallingPlanConfigResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TalkResult TalkResult = 2;
 * @return {?proto.xcommon.TalkResult}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.getTalkresult = function() {
  return /** @type{?proto.xcommon.TalkResult} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.TalkResult, 2));
};


/** @param {?proto.xcommon.TalkResult|undefined} value */
proto.xcommon.GetCallingPlanConfigResp.prototype.setTalkresult = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.clearTalkresult = function() {
  this.setTalkresult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.hasTalkresult = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated SeatTreeNode SeatTree = 3;
 * @return {!Array<!proto.xcommon.SeatTreeNode>}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.getSeattreeList = function() {
  return /** @type{!Array<!proto.xcommon.SeatTreeNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SeatTreeNode, 3));
};


/** @param {!Array<!proto.xcommon.SeatTreeNode>} value */
proto.xcommon.GetCallingPlanConfigResp.prototype.setSeattreeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.SeatTreeNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SeatTreeNode}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.addSeattree = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.SeatTreeNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.clearSeattreeList = function() {
  this.setSeattreeList([]);
};


/**
 * repeated DealMethod DealMethod = 4;
 * @return {!Array<!proto.xcommon.DealMethod>}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.getDealmethodList = function() {
  return /** @type{!Array<!proto.xcommon.DealMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DealMethod, 4));
};


/** @param {!Array<!proto.xcommon.DealMethod>} value */
proto.xcommon.GetCallingPlanConfigResp.prototype.setDealmethodList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.DealMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DealMethod}
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.addDealmethod = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.DealMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetCallingPlanConfigResp.prototype.clearDealmethodList = function() {
  this.setDealmethodList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DealMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DealMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DealMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DealMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DealMethod}
 */
proto.xcommon.DealMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DealMethod;
  return proto.xcommon.DealMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DealMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DealMethod}
 */
proto.xcommon.DealMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DealMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DealMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DealMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DealMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Title = 1;
 * @return {string}
 */
proto.xcommon.DealMethod.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.DealMethod.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Value = 2;
 * @return {string}
 */
proto.xcommon.DealMethod.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.DealMethod.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SeatTreeNode.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SeatTreeNode.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SeatTreeNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SeatTreeNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SeatTreeNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.xcommon.SeatTreeNode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SeatTreeNode}
 */
proto.xcommon.SeatTreeNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SeatTreeNode;
  return proto.xcommon.SeatTreeNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SeatTreeNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SeatTreeNode}
 */
proto.xcommon.SeatTreeNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = new proto.xcommon.SeatTreeNode;
      reader.readMessage(value,proto.xcommon.SeatTreeNode.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SeatTreeNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SeatTreeNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SeatTreeNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SeatTreeNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.SeatTreeNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Label = 1;
 * @return {string}
 */
proto.xcommon.SeatTreeNode.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.SeatTreeNode.prototype.setLabel = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Value = 2;
 * @return {string}
 */
proto.xcommon.SeatTreeNode.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SeatTreeNode.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Type = 3;
 * @return {string}
 */
proto.xcommon.SeatTreeNode.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SeatTreeNode.prototype.setType = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated SeatTreeNode Children = 4;
 * @return {!Array<!proto.xcommon.SeatTreeNode>}
 */
proto.xcommon.SeatTreeNode.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.xcommon.SeatTreeNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SeatTreeNode, 4));
};


/** @param {!Array<!proto.xcommon.SeatTreeNode>} value */
proto.xcommon.SeatTreeNode.prototype.setChildrenList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.SeatTreeNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SeatTreeNode}
 */
proto.xcommon.SeatTreeNode.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.SeatTreeNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SeatTreeNode.prototype.clearChildrenList = function() {
  this.setChildrenList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TalkResult.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TalkResult.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TalkResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TalkResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TalkResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    groupname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    optionsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    required: jspb.Message.getFieldWithDefault(msg, 4, ""),
    filetype: jspb.Message.getFieldWithDefault(msg, 5, ""),
    hidden: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    componentprops: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TalkResult}
 */
proto.xcommon.TalkResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TalkResult;
  return proto.xcommon.TalkResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TalkResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TalkResult}
 */
proto.xcommon.TalkResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addOptions(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequired(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFiletype(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setComponentprops(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TalkResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TalkResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TalkResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TalkResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getRequired();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFiletype();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getComponentprops();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string Title = 1;
 * @return {string}
 */
proto.xcommon.TalkResult.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.TalkResult.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string GroupName = 2;
 * @return {string}
 */
proto.xcommon.TalkResult.prototype.getGroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.TalkResult.prototype.setGroupname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string Options = 3;
 * @return {!Array<string>}
 */
proto.xcommon.TalkResult.prototype.getOptionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.xcommon.TalkResult.prototype.setOptionsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.TalkResult.prototype.addOptions = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.TalkResult.prototype.clearOptionsList = function() {
  this.setOptionsList([]);
};


/**
 * optional string Required = 4;
 * @return {string}
 */
proto.xcommon.TalkResult.prototype.getRequired = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.TalkResult.prototype.setRequired = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string FileType = 5;
 * @return {string}
 */
proto.xcommon.TalkResult.prototype.getFiletype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.TalkResult.prototype.setFiletype = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool Hidden = 6;
 * @return {boolean}
 */
proto.xcommon.TalkResult.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.xcommon.TalkResult.prototype.setHidden = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string ComponentProps = 7;
 * @return {string}
 */
proto.xcommon.TalkResult.prototype.getComponentprops = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.TalkResult.prototype.setComponentprops = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListCallingPlanReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListCallingPlanReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListCallingPlanReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListCallingPlanReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    planname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    strategy: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timerange: jspb.Message.getFieldWithDefault(msg, 5, ""),
    company: jspb.Message.getFieldWithDefault(msg, 6, ""),
    callingtype: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListCallingPlanReq}
 */
proto.xcommon.ListCallingPlanReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListCallingPlanReq;
  return proto.xcommon.ListCallingPlanReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListCallingPlanReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListCallingPlanReq}
 */
proto.xcommon.ListCallingPlanReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrategy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallingtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListCallingPlanReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListCallingPlanReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListCallingPlanReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListCallingPlanReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getPlanname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStrategy();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCallingtype();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListCallingPlanReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListCallingPlanReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListCallingPlanReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListCallingPlanReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListCallingPlanReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListCallingPlanReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListCallingPlanReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListCallingPlanReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string PlanName = 3;
 * @return {string}
 */
proto.xcommon.ListCallingPlanReq.prototype.getPlanname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanReq.prototype.setPlanname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Strategy = 4;
 * @return {string}
 */
proto.xcommon.ListCallingPlanReq.prototype.getStrategy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanReq.prototype.setStrategy = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string TimeRange = 5;
 * @return {string}
 */
proto.xcommon.ListCallingPlanReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Company = 6;
 * @return {string}
 */
proto.xcommon.ListCallingPlanReq.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanReq.prototype.setCompany = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 CallingType = 7;
 * @return {number}
 */
proto.xcommon.ListCallingPlanReq.prototype.getCallingtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanReq.prototype.setCallingtype = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListCallingPlanResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListCallingPlanResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListCallingPlanResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListCallingPlanResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListCallingPlanResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ListCallingPlanResp.CallingPlan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListCallingPlanResp}
 */
proto.xcommon.ListCallingPlanResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListCallingPlanResp;
  return proto.xcommon.ListCallingPlanResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListCallingPlanResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListCallingPlanResp}
 */
proto.xcommon.ListCallingPlanResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.ListCallingPlanResp.CallingPlan;
      reader.readMessage(value,proto.xcommon.ListCallingPlanResp.CallingPlan.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListCallingPlanResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListCallingPlanResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListCallingPlanResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListCallingPlanResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.ListCallingPlanResp.CallingPlan.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.repeatedFields_ = [12,13,18,25];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListCallingPlanResp.CallingPlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListCallingPlanResp.CallingPlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    planname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    strategy: jspb.Message.getFieldWithDefault(msg, 3, ""),
    todaytask: jspb.Message.getFieldWithDefault(msg, 4, ""),
    starttime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 9, 0),
    opname: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sequence: jspb.Message.getFieldWithDefault(msg, 11, 0),
    itemidsList: jspb.Message.toObjectList(msg.getItemidsList(),
    proto.xcommon.CommonItem.toObject, includeInstance),
    usergroupidsList: jspb.Message.toObjectList(msg.getUsergroupidsList(),
    proto.xcommon.CommonItem.toObject, includeInstance),
    company: jspb.Message.getFieldWithDefault(msg, 14, ""),
    hours: jspb.Message.getFieldWithDefault(msg, 15, ""),
    status: jspb.Message.getFieldWithDefault(msg, 16, 0),
    groupname: jspb.Message.getFieldWithDefault(msg, 17, ""),
    agentnameList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f,
    callingtype: jspb.Message.getFieldWithDefault(msg, 19, 0),
    repeattimes: jspb.Message.getFieldWithDefault(msg, 20, 0),
    maxlostrate: jspb.Message.getFieldWithDefault(msg, 21, ""),
    templatename: jspb.Message.getFieldWithDefault(msg, 22, ""),
    voicemailredial: jspb.Message.getFieldWithDefault(msg, 23, 0),
    resultstrategies: jspb.Message.getFieldWithDefault(msg, 24, ""),
    useridsList: jspb.Message.toObjectList(msg.getUseridsList(),
    proto.xcommon.CommonItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListCallingPlanResp.CallingPlan}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListCallingPlanResp.CallingPlan;
  return proto.xcommon.ListCallingPlanResp.CallingPlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListCallingPlanResp.CallingPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListCallingPlanResp.CallingPlan}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrategy(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTodaytask(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarttime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpname(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSequence(value);
      break;
    case 12:
      var value = new proto.xcommon.CommonItem;
      reader.readMessage(value,proto.xcommon.CommonItem.deserializeBinaryFromReader);
      msg.addItemids(value);
      break;
    case 13:
      var value = new proto.xcommon.CommonItem;
      reader.readMessage(value,proto.xcommon.CommonItem.deserializeBinaryFromReader);
      msg.addUsergroupids(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setHours(value);
      break;
    case 16:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupname(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.addAgentname(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallingtype(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepeattimes(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaxlostrate(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplatename(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVoicemailredial(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setResultstrategies(value);
      break;
    case 25:
      var value = new proto.xcommon.CommonItem;
      reader.readMessage(value,proto.xcommon.CommonItem.deserializeBinaryFromReader);
      msg.addUserids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListCallingPlanResp.CallingPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListCallingPlanResp.CallingPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPlanname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStrategy();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTodaytask();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStarttime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getOpname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSequence();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getItemidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.xcommon.CommonItem.serializeBinaryToWriter
    );
  }
  f = message.getUsergroupidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.xcommon.CommonItem.serializeBinaryToWriter
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getHours();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getGroupname();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getAgentnameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      18,
      f
    );
  }
  f = message.getCallingtype();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getRepeattimes();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getMaxlostrate();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getTemplatename();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getVoicemailredial();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getResultstrategies();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getUseridsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      25,
      f,
      proto.xcommon.CommonItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string PlanName = 2;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getPlanname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setPlanname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Strategy = 3;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getStrategy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setStrategy = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TodayTask = 4;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getTodaytask = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setTodaytask = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 StartTime = 5;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getStarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setStarttime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 EndTime = 6;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setEndtime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Ctime = 7;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 Utime = 8;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 OpUid = 9;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setOpuid = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string OpName = 10;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getOpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setOpname = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 Sequence = 11;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getSequence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setSequence = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated CommonItem ItemIDs = 12;
 * @return {!Array<!proto.xcommon.CommonItem>}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getItemidsList = function() {
  return /** @type{!Array<!proto.xcommon.CommonItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.CommonItem, 12));
};


/** @param {!Array<!proto.xcommon.CommonItem>} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setItemidsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.xcommon.CommonItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CommonItem}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.addItemids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.xcommon.CommonItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.clearItemidsList = function() {
  this.setItemidsList([]);
};


/**
 * repeated CommonItem UserGroupIDs = 13;
 * @return {!Array<!proto.xcommon.CommonItem>}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getUsergroupidsList = function() {
  return /** @type{!Array<!proto.xcommon.CommonItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.CommonItem, 13));
};


/** @param {!Array<!proto.xcommon.CommonItem>} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setUsergroupidsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.xcommon.CommonItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CommonItem}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.addUsergroupids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.xcommon.CommonItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.clearUsergroupidsList = function() {
  this.setUsergroupidsList([]);
};


/**
 * optional string Company = 14;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setCompany = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string Hours = 15;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getHours = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setHours = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional CommonStatus Status = 16;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional string GroupName = 17;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getGroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setGroupname = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * repeated string AgentName = 18;
 * @return {!Array<string>}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getAgentnameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 18));
};


/** @param {!Array<string>} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setAgentnameList = function(value) {
  jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.addAgentname = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.clearAgentnameList = function() {
  this.setAgentnameList([]);
};


/**
 * optional int64 CallingType = 19;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getCallingtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setCallingtype = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 RepeatTimes = 20;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getRepeattimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setRepeattimes = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string MaxLostRate = 21;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getMaxlostrate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setMaxlostrate = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string TemplateName = 22;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getTemplatename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setTemplatename = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional int64 VoicemailRedial = 23;
 * @return {number}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getVoicemailredial = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setVoicemailredial = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string ResultStrategies = 24;
 * @return {string}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getResultstrategies = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/** @param {string} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setResultstrategies = function(value) {
  jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * repeated CommonItem UserIds = 25;
 * @return {!Array<!proto.xcommon.CommonItem>}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.getUseridsList = function() {
  return /** @type{!Array<!proto.xcommon.CommonItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.CommonItem, 25));
};


/** @param {!Array<!proto.xcommon.CommonItem>} value */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.setUseridsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 25, value);
};


/**
 * @param {!proto.xcommon.CommonItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CommonItem}
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.addUserids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 25, opt_value, proto.xcommon.CommonItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListCallingPlanResp.CallingPlan.prototype.clearUseridsList = function() {
  this.setUseridsList([]);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListCallingPlanResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListCallingPlanResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListCallingPlanResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListCallingPlanResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListCallingPlanResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListCallingPlanResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListCallingPlanResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListCallingPlanResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated CallingPlan List = 3;
 * @return {!Array<!proto.xcommon.ListCallingPlanResp.CallingPlan>}
 */
proto.xcommon.ListCallingPlanResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ListCallingPlanResp.CallingPlan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ListCallingPlanResp.CallingPlan, 3));
};


/** @param {!Array<!proto.xcommon.ListCallingPlanResp.CallingPlan>} value */
proto.xcommon.ListCallingPlanResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.ListCallingPlanResp.CallingPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ListCallingPlanResp.CallingPlan}
 */
proto.xcommon.ListCallingPlanResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.ListCallingPlanResp.CallingPlan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListCallingPlanResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.StopTaskReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.StopTaskReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.StopTaskReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.StopTaskReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    taskid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.StopTaskReq}
 */
proto.xcommon.StopTaskReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.StopTaskReq;
  return proto.xcommon.StopTaskReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.StopTaskReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.StopTaskReq}
 */
proto.xcommon.StopTaskReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.StopTaskReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.StopTaskReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.StopTaskReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.StopTaskReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTaskid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.StopTaskReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.StopTaskReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.StopTaskReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.StopTaskReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string TaskId = 2;
 * @return {string}
 */
proto.xcommon.StopTaskReq.prototype.getTaskid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.StopTaskReq.prototype.setTaskid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Dialer.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Dialer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Dialer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Dialer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ticketaction: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketorder: jspb.Message.getFieldWithDefault(msg, 5, 0),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    phoneobjects: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Dialer}
 */
proto.xcommon.Dialer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Dialer;
  return proto.xcommon.Dialer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Dialer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Dialer}
 */
proto.xcommon.Dialer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketaction(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketorder(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobjects(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Dialer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Dialer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Dialer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Dialer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTicketaction();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTicketorder();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getPhoneobjects();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.Dialer.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.Dialer.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 TicketAction = 3;
 * @return {number}
 */
proto.xcommon.Dialer.prototype.getTicketaction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.Dialer.prototype.setTicketaction = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 TicketOrder = 5;
 * @return {number}
 */
proto.xcommon.Dialer.prototype.getTicketorder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.Dialer.prototype.setTicketorder = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 Status = 7;
 * @return {number}
 */
proto.xcommon.Dialer.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.Dialer.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 OpUid = 8;
 * @return {number}
 */
proto.xcommon.Dialer.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.Dialer.prototype.setOpuid = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Ctime = 9;
 * @return {number}
 */
proto.xcommon.Dialer.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.Dialer.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Utime = 10;
 * @return {number}
 */
proto.xcommon.Dialer.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.Dialer.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string PhoneObjects = 11;
 * @return {string}
 */
proto.xcommon.Dialer.prototype.getPhoneobjects = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.Dialer.prototype.setPhoneobjects = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    dialer: (f = msg.getDialer()) && proto.xcommon.Dialer.toObject(includeInstance, f),
    ticketaction: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ticketorder: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerBackend}
 */
proto.xcommon.DialerBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerBackend;
  return proto.xcommon.DialerBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerBackend}
 */
proto.xcommon.DialerBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.Dialer;
      reader.readMessage(value,proto.xcommon.Dialer.deserializeBinaryFromReader);
      msg.setDialer(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketaction(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobject(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketorder(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDialer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.Dialer.serializeBinaryToWriter
    );
  }
  f = message.getTicketaction();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhoneobject();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTicketorder();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional Dialer Dialer = 1;
 * @return {?proto.xcommon.Dialer}
 */
proto.xcommon.DialerBackend.prototype.getDialer = function() {
  return /** @type{?proto.xcommon.Dialer} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Dialer, 1));
};


/** @param {?proto.xcommon.Dialer|undefined} value */
proto.xcommon.DialerBackend.prototype.setDialer = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerBackend.prototype.clearDialer = function() {
  this.setDialer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerBackend.prototype.hasDialer = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string TicketAction = 2;
 * @return {string}
 */
proto.xcommon.DialerBackend.prototype.getTicketaction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.DialerBackend.prototype.setTicketaction = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string PhoneObject = 3;
 * @return {string}
 */
proto.xcommon.DialerBackend.prototype.getPhoneobject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.DialerBackend.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TicketOrder = 4;
 * @return {string}
 */
proto.xcommon.DialerBackend.prototype.getTicketorder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.DialerBackend.prototype.setTicketorder = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Status = 5;
 * @return {string}
 */
proto.xcommon.DialerBackend.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.DialerBackend.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerListOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerListOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerListOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerListOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    listid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerListOrder}
 */
proto.xcommon.DialerListOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerListOrder;
  return proto.xcommon.DialerListOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerListOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerListOrder}
 */
proto.xcommon.DialerListOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setListid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerListOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerListOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerListOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerListOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getListid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.DialerListOrder.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.DialerListOrder.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 ItemID = 2;
 * @return {number}
 */
proto.xcommon.DialerListOrder.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DialerListOrder.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ListId = 3;
 * @return {string}
 */
proto.xcommon.DialerListOrder.prototype.getListid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.DialerListOrder.prototype.setListid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 Status = 4;
 * @return {number}
 */
proto.xcommon.DialerListOrder.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.DialerListOrder.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OpUid = 5;
 * @return {number}
 */
proto.xcommon.DialerListOrder.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.DialerListOrder.prototype.setOpuid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 Ctime = 6;
 * @return {number}
 */
proto.xcommon.DialerListOrder.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.DialerListOrder.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Utime = 7;
 * @return {number}
 */
proto.xcommon.DialerListOrder.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.DialerListOrder.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerListOrderBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerListOrderBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerListOrderBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerListOrderBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    dialerlistorder: (f = msg.getDialerlistorder()) && proto.xcommon.DialerListOrder.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerListOrderBackend}
 */
proto.xcommon.DialerListOrderBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerListOrderBackend;
  return proto.xcommon.DialerListOrderBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerListOrderBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerListOrderBackend}
 */
proto.xcommon.DialerListOrderBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.DialerListOrder;
      reader.readMessage(value,proto.xcommon.DialerListOrder.deserializeBinaryFromReader);
      msg.setDialerlistorder(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerListOrderBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerListOrderBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerListOrderBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerListOrderBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDialerlistorder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.DialerListOrder.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional DialerListOrder DialerListOrder = 1;
 * @return {?proto.xcommon.DialerListOrder}
 */
proto.xcommon.DialerListOrderBackend.prototype.getDialerlistorder = function() {
  return /** @type{?proto.xcommon.DialerListOrder} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.DialerListOrder, 1));
};


/** @param {?proto.xcommon.DialerListOrder|undefined} value */
proto.xcommon.DialerListOrderBackend.prototype.setDialerlistorder = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerListOrderBackend.prototype.clearDialerlistorder = function() {
  this.setDialerlistorder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerListOrderBackend.prototype.hasDialerlistorder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ItemID = 2;
 * @return {string}
 */
proto.xcommon.DialerListOrderBackend.prototype.getItemid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.DialerListOrderBackend.prototype.setItemid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Status = 3;
 * @return {string}
 */
proto.xcommon.DialerListOrderBackend.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.DialerListOrderBackend.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialerListParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialerListParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialerListParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialerListParamReq}
 */
proto.xcommon.GetDialerListParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialerListParamReq;
  return proto.xcommon.GetDialerListParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialerListParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialerListParamReq}
 */
proto.xcommon.GetDialerListParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialerListParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialerListParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialerListParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetDialerListParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetDialerListParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetDialerListParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialerListParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetDialerListParamResp.repeatedFields_ = [2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialerListParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialerListParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialerListParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    ticketclassifyList: jspb.Message.toObjectList(msg.getTicketclassifyList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    phoneobjectList: jspb.Message.toObjectList(msg.getPhoneobjectList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    ticketorderList: jspb.Message.toObjectList(msg.getTicketorderList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    ticketitemList: jspb.Message.toObjectList(msg.getTicketitemList(),
    proto.xcommon.AttrItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialerListParamResp}
 */
proto.xcommon.GetDialerListParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialerListParamResp;
  return proto.xcommon.GetDialerListParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialerListParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialerListParamResp}
 */
proto.xcommon.GetDialerListParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketclassify(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addPhoneobject(value);
      break;
    case 4:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketorder(value);
      break;
    case 5:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketitem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialerListParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialerListParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialerListParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTicketclassifyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getPhoneobjectList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getTicketorderList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getTicketitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetDialerListParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetDialerListParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetDialerListParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialerListParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AttrItem TicketClassify = 2;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetDialerListParamResp.prototype.getTicketclassifyList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 2));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetDialerListParamResp.prototype.setTicketclassifyList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetDialerListParamResp.prototype.addTicketclassify = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetDialerListParamResp.prototype.clearTicketclassifyList = function() {
  this.setTicketclassifyList([]);
};


/**
 * repeated AttrItem PhoneObject = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetDialerListParamResp.prototype.getPhoneobjectList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetDialerListParamResp.prototype.setPhoneobjectList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetDialerListParamResp.prototype.addPhoneobject = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetDialerListParamResp.prototype.clearPhoneobjectList = function() {
  this.setPhoneobjectList([]);
};


/**
 * repeated AttrItem TicketOrder = 4;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetDialerListParamResp.prototype.getTicketorderList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 4));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetDialerListParamResp.prototype.setTicketorderList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetDialerListParamResp.prototype.addTicketorder = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetDialerListParamResp.prototype.clearTicketorderList = function() {
  this.setTicketorderList([]);
};


/**
 * repeated AttrItem TicketItem = 5;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.GetDialerListParamResp.prototype.getTicketitemList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 5));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.GetDialerListParamResp.prototype.setTicketitemList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.GetDialerListParamResp.prototype.addTicketitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetDialerListParamResp.prototype.clearTicketitemList = function() {
  this.setTicketitemList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialerListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialerListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialerListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialerListReq}
 */
proto.xcommon.GetDialerListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialerListReq;
  return proto.xcommon.GetDialerListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialerListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialerListReq}
 */
proto.xcommon.GetDialerListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialerListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialerListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialerListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetDialerListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetDialerListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetDialerListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialerListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetDialerListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetDialerListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetDialerListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialerListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetDialerListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialerListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialerListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialerListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.DialerBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialerListResp}
 */
proto.xcommon.GetDialerListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialerListResp;
  return proto.xcommon.GetDialerListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialerListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialerListResp}
 */
proto.xcommon.GetDialerListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.DialerBackend;
      reader.readMessage(value,proto.xcommon.DialerBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialerListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialerListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialerListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.DialerBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetDialerListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetDialerListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetDialerListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialerListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetDialerListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetDialerListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetDialerListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialerListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated DialerBackend List = 3;
 * @return {!Array<!proto.xcommon.DialerBackend>}
 */
proto.xcommon.GetDialerListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.DialerBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DialerBackend, 3));
};


/** @param {!Array<!proto.xcommon.DialerBackend>} value */
proto.xcommon.GetDialerListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.DialerBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DialerBackend}
 */
proto.xcommon.GetDialerListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.DialerBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetDialerListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveDialerReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveDialerReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveDialerReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveDialerReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    detail: (f = msg.getDetail()) && proto.xcommon.Dialer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveDialerReq}
 */
proto.xcommon.SaveDialerReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveDialerReq;
  return proto.xcommon.SaveDialerReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveDialerReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveDialerReq}
 */
proto.xcommon.SaveDialerReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.Dialer;
      reader.readMessage(value,proto.xcommon.Dialer.deserializeBinaryFromReader);
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveDialerReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveDialerReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveDialerReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveDialerReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getDetail();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.Dialer.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveDialerReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveDialerReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveDialerReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveDialerReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Dialer Detail = 2;
 * @return {?proto.xcommon.Dialer}
 */
proto.xcommon.SaveDialerReq.prototype.getDetail = function() {
  return /** @type{?proto.xcommon.Dialer} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Dialer, 2));
};


/** @param {?proto.xcommon.Dialer|undefined} value */
proto.xcommon.SaveDialerReq.prototype.setDetail = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveDialerReq.prototype.clearDetail = function() {
  this.setDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveDialerReq.prototype.hasDetail = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveDialerResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveDialerResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveDialerResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveDialerResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveDialerResp}
 */
proto.xcommon.SaveDialerResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveDialerResp;
  return proto.xcommon.SaveDialerResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveDialerResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveDialerResp}
 */
proto.xcommon.SaveDialerResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveDialerResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveDialerResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveDialerResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveDialerResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveDialerResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveDialerResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveDialerResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveDialerResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveDialerResp.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveDialerResp.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialerListOrderReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialerListOrderReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialerListOrderReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListOrderReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialerListOrderReq}
 */
proto.xcommon.GetDialerListOrderReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialerListOrderReq;
  return proto.xcommon.GetDialerListOrderReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialerListOrderReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialerListOrderReq}
 */
proto.xcommon.GetDialerListOrderReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialerListOrderReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialerListOrderReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialerListOrderReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListOrderReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetDialerListOrderReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetDialerListOrderReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetDialerListOrderReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialerListOrderReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetDialerListOrderResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetDialerListOrderResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetDialerListOrderResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetDialerListOrderResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListOrderResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.DialerListOrderBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetDialerListOrderResp}
 */
proto.xcommon.GetDialerListOrderResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetDialerListOrderResp;
  return proto.xcommon.GetDialerListOrderResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetDialerListOrderResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetDialerListOrderResp}
 */
proto.xcommon.GetDialerListOrderResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.DialerListOrderBackend;
      reader.readMessage(value,proto.xcommon.DialerListOrderBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetDialerListOrderResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetDialerListOrderResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetDialerListOrderResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetDialerListOrderResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.DialerListOrderBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetDialerListOrderResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetDialerListOrderResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetDialerListOrderResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetDialerListOrderResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DialerListOrderBackend List = 2;
 * @return {!Array<!proto.xcommon.DialerListOrderBackend>}
 */
proto.xcommon.GetDialerListOrderResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.DialerListOrderBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DialerListOrderBackend, 2));
};


/** @param {!Array<!proto.xcommon.DialerListOrderBackend>} value */
proto.xcommon.GetDialerListOrderResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.DialerListOrderBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DialerListOrderBackend}
 */
proto.xcommon.GetDialerListOrderResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.DialerListOrderBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetDialerListOrderResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveDialerListOrderReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveDialerListOrderReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveDialerListOrderReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveDialerListOrderReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.DialerListOrder.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveDialerListOrderReq}
 */
proto.xcommon.SaveDialerListOrderReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveDialerListOrderReq;
  return proto.xcommon.SaveDialerListOrderReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveDialerListOrderReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveDialerListOrderReq}
 */
proto.xcommon.SaveDialerListOrderReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.DialerListOrder;
      reader.readMessage(value,proto.xcommon.DialerListOrder.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveDialerListOrderReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveDialerListOrderReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveDialerListOrderReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveDialerListOrderReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.DialerListOrder.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveDialerListOrderReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveDialerListOrderReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveDialerListOrderReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveDialerListOrderReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DialerListOrder Data = 2;
 * @return {?proto.xcommon.DialerListOrder}
 */
proto.xcommon.SaveDialerListOrderReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.DialerListOrder} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.DialerListOrder, 2));
};


/** @param {?proto.xcommon.DialerListOrder|undefined} value */
proto.xcommon.SaveDialerListOrderReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveDialerListOrderReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveDialerListOrderReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveDialerListOrderResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveDialerListOrderResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveDialerListOrderResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveDialerListOrderResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveDialerListOrderResp}
 */
proto.xcommon.SaveDialerListOrderResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveDialerListOrderResp;
  return proto.xcommon.SaveDialerListOrderResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveDialerListOrderResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveDialerListOrderResp}
 */
proto.xcommon.SaveDialerListOrderResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveDialerListOrderResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveDialerListOrderResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveDialerListOrderResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveDialerListOrderResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveDialerListOrderResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveDialerListOrderResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveDialerListOrderResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveDialerListOrderResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerCurrentInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerCurrentInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerCurrentInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerCurrentInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerCurrentInfoReq}
 */
proto.xcommon.DialerCurrentInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerCurrentInfoReq;
  return proto.xcommon.DialerCurrentInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerCurrentInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerCurrentInfoReq}
 */
proto.xcommon.DialerCurrentInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerCurrentInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerCurrentInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerCurrentInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerCurrentInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DialerCurrentInfoReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DialerCurrentInfoReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerCurrentInfoReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerCurrentInfoReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerCurrentInfoResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerCurrentInfoResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerCurrentInfoResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerCurrentInfoResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    supplier: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerCurrentInfoResp}
 */
proto.xcommon.DialerCurrentInfoResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerCurrentInfoResp;
  return proto.xcommon.DialerCurrentInfoResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerCurrentInfoResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerCurrentInfoResp}
 */
proto.xcommon.DialerCurrentInfoResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.DialerStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerCurrentInfoResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerCurrentInfoResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerCurrentInfoResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerCurrentInfoResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DialerCurrentInfoResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DialerCurrentInfoResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerCurrentInfoResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerCurrentInfoResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Supplier = 2;
 * @return {number}
 */
proto.xcommon.DialerCurrentInfoResp.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DialerCurrentInfoResp.prototype.setSupplier = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional DialerStatus Status = 3;
 * @return {!proto.xcommon.DialerStatus}
 */
proto.xcommon.DialerCurrentInfoResp.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.DialerStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.DialerStatus} value */
proto.xcommon.DialerCurrentInfoResp.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerAutoStartReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerAutoStartReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerAutoStartReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoStartReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    supplier: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerAutoStartReq}
 */
proto.xcommon.DialerAutoStartReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerAutoStartReq;
  return proto.xcommon.DialerAutoStartReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerAutoStartReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerAutoStartReq}
 */
proto.xcommon.DialerAutoStartReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerAutoStartReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerAutoStartReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerAutoStartReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoStartReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DialerAutoStartReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DialerAutoStartReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerAutoStartReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerAutoStartReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Supplier = 2;
 * @return {number}
 */
proto.xcommon.DialerAutoStartReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DialerAutoStartReq.prototype.setSupplier = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerAutoStartResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerAutoStartResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerAutoStartResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoStartResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerAutoStartResp}
 */
proto.xcommon.DialerAutoStartResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerAutoStartResp;
  return proto.xcommon.DialerAutoStartResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerAutoStartResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerAutoStartResp}
 */
proto.xcommon.DialerAutoStartResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerAutoStartResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerAutoStartResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerAutoStartResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoStartResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DialerAutoStartResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DialerAutoStartResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerAutoStartResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerAutoStartResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerAutoStopReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerAutoStopReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerAutoStopReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoStopReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    supplier: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerAutoStopReq}
 */
proto.xcommon.DialerAutoStopReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerAutoStopReq;
  return proto.xcommon.DialerAutoStopReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerAutoStopReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerAutoStopReq}
 */
proto.xcommon.DialerAutoStopReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerAutoStopReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerAutoStopReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerAutoStopReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoStopReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getSupplier();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DialerAutoStopReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DialerAutoStopReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerAutoStopReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerAutoStopReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Supplier = 2;
 * @return {number}
 */
proto.xcommon.DialerAutoStopReq.prototype.getSupplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DialerAutoStopReq.prototype.setSupplier = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerAutoStopResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerAutoStopResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerAutoStopResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoStopResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerAutoStopResp}
 */
proto.xcommon.DialerAutoStopResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerAutoStopResp;
  return proto.xcommon.DialerAutoStopResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerAutoStopResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerAutoStopResp}
 */
proto.xcommon.DialerAutoStopResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerAutoStopResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerAutoStopResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerAutoStopResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoStopResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DialerAutoStopResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DialerAutoStopResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerAutoStopResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerAutoStopResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerAutoNextReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerAutoNextReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerAutoNextReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoNextReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerAutoNextReq}
 */
proto.xcommon.DialerAutoNextReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerAutoNextReq;
  return proto.xcommon.DialerAutoNextReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerAutoNextReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerAutoNextReq}
 */
proto.xcommon.DialerAutoNextReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerAutoNextReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerAutoNextReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerAutoNextReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoNextReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DialerAutoNextReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DialerAutoNextReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerAutoNextReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerAutoNextReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DialerAutoNextResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DialerAutoNextResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DialerAutoNextResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoNextResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 4, 0),
    phone: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DialerAutoNextResp}
 */
proto.xcommon.DialerAutoNextResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DialerAutoNextResp;
  return proto.xcommon.DialerAutoNextResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DialerAutoNextResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DialerAutoNextResp}
 */
proto.xcommon.DialerAutoNextResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DialerAutoNextResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DialerAutoNextResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DialerAutoNextResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DialerAutoNextResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DialerAutoNextResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DialerAutoNextResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DialerAutoNextResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DialerAutoNextResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.DialerAutoNextResp.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DialerAutoNextResp.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.DialerAutoNextResp.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.DialerAutoNextResp.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int32 PhoneObject = 4;
 * @return {number}
 */
proto.xcommon.DialerAutoNextResp.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.DialerAutoNextResp.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string Phone = 5;
 * @return {string}
 */
proto.xcommon.DialerAutoNextResp.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.DialerAutoNextResp.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LawyerLetterListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LawyerLetterListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LawyerLetterListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LawyerLetterListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    customername: jspb.Message.getFieldWithDefault(msg, 5, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 6, ""),
    identity: jspb.Message.getFieldWithDefault(msg, 7, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    modifytimerange: jspb.Message.getFieldWithDefault(msg, 9, ""),
    pagetype: jspb.Message.getFieldWithDefault(msg, 10, ""),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 11, 0),
    sequence: jspb.Message.getFieldWithDefault(msg, 12, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LawyerLetterListReq}
 */
proto.xcommon.LawyerLetterListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LawyerLetterListReq;
  return proto.xcommon.LawyerLetterListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LawyerLetterListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LawyerLetterListReq}
 */
proto.xcommon.LawyerLetterListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentity(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setModifytimerange(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPagetype(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSequence(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LawyerLetterListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LawyerLetterListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LawyerLetterListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LawyerLetterListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getCustomername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIdentity();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getModifytimerange();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPagetype();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getSequence();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.LawyerLetterListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.LawyerLetterListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LawyerLetterListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LawyerLetterListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.LawyerLetterListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.LawyerLetterListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LawyerLetterListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LawyerLetterListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 CustomerId = 4;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string CustomerName = 5;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getCustomername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setCustomername = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Mobile = 6;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Identity = 7;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setIdentity = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string AssignTimeRange = 8;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setAssigntimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string ModifyTimeRange = 9;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getModifytimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setModifytimerange = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string PageType = 10;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getPagetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setPagetype = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 UserGroupID = 11;
 * @return {number}
 */
proto.xcommon.LawyerLetterListReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.LawyerLetterListReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 Sequence = 12;
 * @return {number}
 */
proto.xcommon.LawyerLetterListReq.prototype.getSequence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.LawyerLetterListReq.prototype.setSequence = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string AppName = 13;
 * @return {string}
 */
proto.xcommon.LawyerLetterListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetterListReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.LawyerLetterListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LawyerLetterListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LawyerLetterListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LawyerLetterListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LawyerLetterListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.LawyerLetter.toObject, includeInstance),
    enable: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LawyerLetterListResp}
 */
proto.xcommon.LawyerLetterListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LawyerLetterListResp;
  return proto.xcommon.LawyerLetterListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LawyerLetterListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LawyerLetterListResp}
 */
proto.xcommon.LawyerLetterListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.LawyerLetter;
      reader.readMessage(value,proto.xcommon.LawyerLetter.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LawyerLetterListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LawyerLetterListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LawyerLetterListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LawyerLetterListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.LawyerLetter.serializeBinaryToWriter
    );
  }
  f = message.getEnable();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.LawyerLetterListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.LawyerLetterListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LawyerLetterListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LawyerLetterListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.LawyerLetterListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.LawyerLetterListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LawyerLetterListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LawyerLetterListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated LawyerLetter List = 3;
 * @return {!Array<!proto.xcommon.LawyerLetter>}
 */
proto.xcommon.LawyerLetterListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.LawyerLetter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.LawyerLetter, 3));
};


/** @param {!Array<!proto.xcommon.LawyerLetter>} value */
proto.xcommon.LawyerLetterListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.LawyerLetter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.LawyerLetter}
 */
proto.xcommon.LawyerLetterListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.LawyerLetter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.LawyerLetterListResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional Bool Enable = 4;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.LawyerLetterListResp.prototype.getEnable = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.LawyerLetterListResp.prototype.setEnable = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LawyerLetter.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LawyerLetter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LawyerLetter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LawyerLetter.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    customername: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    identity: jspb.Message.getFieldWithDefault(msg, 6, ""),
    email: jspb.Message.getFieldWithDefault(msg, 7, ""),
    address: jspb.Message.getFieldWithDefault(msg, 8, ""),
    idphoto: jspb.Message.getFieldWithDefault(msg, 9, ""),
    letterstatus: jspb.Message.getFieldWithDefault(msg, 10, 0),
    assigntime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    modifytime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    sequence: jspb.Message.getFieldWithDefault(msg, 13, 0),
    sendtype: jspb.Message.getFieldWithDefault(msg, 14, 0),
    orderids: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LawyerLetter}
 */
proto.xcommon.LawyerLetter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LawyerLetter;
  return proto.xcommon.LawyerLetter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LawyerLetter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LawyerLetter}
 */
proto.xcommon.LawyerLetter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentity(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdphoto(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.LawyerLetterStatus} */ (reader.readEnum());
      msg.setLetterstatus(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssigntime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setModifytime(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSequence(value);
      break;
    case 14:
      var value = /** @type {!proto.xcommon.LawyerLetterSendType} */ (reader.readEnum());
      msg.setSendtype(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LawyerLetter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LawyerLetter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LawyerLetter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LawyerLetter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCustomername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIdentity();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIdphoto();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLetterstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getAssigntime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getModifytime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getSequence();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getSendtype();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getOrderids();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.LawyerLetter.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LawyerLetter.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 CustomerId = 3;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string CustomerName = 4;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getCustomername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setCustomername = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Mobile = 5;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Identity = 6;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setIdentity = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Email = 7;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Address = 8;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setAddress = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string IdPhoto = 9;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getIdphoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setIdphoto = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional LawyerLetterStatus LetterStatus = 10;
 * @return {!proto.xcommon.LawyerLetterStatus}
 */
proto.xcommon.LawyerLetter.prototype.getLetterstatus = function() {
  return /** @type {!proto.xcommon.LawyerLetterStatus} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.LawyerLetterStatus} value */
proto.xcommon.LawyerLetter.prototype.setLetterstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional int64 AssignTime = 11;
 * @return {number}
 */
proto.xcommon.LawyerLetter.prototype.getAssigntime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.LawyerLetter.prototype.setAssigntime = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 ModifyTime = 12;
 * @return {number}
 */
proto.xcommon.LawyerLetter.prototype.getModifytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.LawyerLetter.prototype.setModifytime = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 Sequence = 13;
 * @return {number}
 */
proto.xcommon.LawyerLetter.prototype.getSequence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.LawyerLetter.prototype.setSequence = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional LawyerLetterSendType SendType = 14;
 * @return {!proto.xcommon.LawyerLetterSendType}
 */
proto.xcommon.LawyerLetter.prototype.getSendtype = function() {
  return /** @type {!proto.xcommon.LawyerLetterSendType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {!proto.xcommon.LawyerLetterSendType} value */
proto.xcommon.LawyerLetter.prototype.setSendtype = function(value) {
  jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string OrderIds = 15;
 * @return {string}
 */
proto.xcommon.LawyerLetter.prototype.getOrderids = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.LawyerLetter.prototype.setOrderids = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LawyerLetterReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LawyerLetterReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LawyerLetterReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LawyerLetterReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.LawyerLetter.toObject(includeInstance, f),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LawyerLetterReq}
 */
proto.xcommon.LawyerLetterReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LawyerLetterReq;
  return proto.xcommon.LawyerLetterReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LawyerLetterReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LawyerLetterReq}
 */
proto.xcommon.LawyerLetterReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.LawyerLetter;
      reader.readMessage(value,proto.xcommon.LawyerLetter.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LawyerLetterReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LawyerLetterReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LawyerLetterReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LawyerLetterReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.LawyerLetter.serializeBinaryToWriter
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.LawyerLetterReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.LawyerLetterReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LawyerLetterReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LawyerLetterReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LawyerLetter Data = 2;
 * @return {?proto.xcommon.LawyerLetter}
 */
proto.xcommon.LawyerLetterReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.LawyerLetter} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LawyerLetter, 2));
};


/** @param {?proto.xcommon.LawyerLetter|undefined} value */
proto.xcommon.LawyerLetterReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LawyerLetterReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LawyerLetterReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 UserGroupID = 3;
 * @return {number}
 */
proto.xcommon.LawyerLetterReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LawyerLetterReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListVerifyQuestionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListVerifyQuestionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListVerifyQuestionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    accountid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    ticketid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListVerifyQuestionReq}
 */
proto.xcommon.ListVerifyQuestionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListVerifyQuestionReq;
  return proto.xcommon.ListVerifyQuestionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListVerifyQuestionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListVerifyQuestionReq}
 */
proto.xcommon.ListVerifyQuestionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListVerifyQuestionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListVerifyQuestionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListVerifyQuestionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListVerifyQuestionReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListVerifyQuestionReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TicketItemEnum TicketItemId = 2;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.ListVerifyQuestionReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 AccountID = 4;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionReq.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional int64 TicketId = 5;
 * @return {number}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.ListVerifyQuestionReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string AppName = 6;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListVerifyQuestionResp.repeatedFields_ = [3,8,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListVerifyQuestionResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListVerifyQuestionResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListVerifyQuestionResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    accountbase: (f = msg.getAccountbase()) && xcommon_core_pb.AccountBaseInfo.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ListVerifyQuestionResp.Question.toObject, includeInstance),
    pvcallingswitch: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    phoneobjectMap: (f = msg.getPhoneobjectMap()) ? f.toObject(includeInstance, undefined) : [],
    phoneobjectmobileMap: (f = msg.getPhoneobjectmobileMap()) ? f.toObject(includeInstance, undefined) : [],
    phoneobjectmobilesaltMap: (f = msg.getPhoneobjectmobilesaltMap()) ? f.toObject(includeInstance, undefined) : [],
    suppliertypeList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    pmdswitch: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    phonestatusMap: (f = msg.getPhonestatusMap()) ? f.toObject(includeInstance, undefined) : [],
    idphotosourceswitch: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    customerinfo: (f = msg.getCustomerinfo()) && xcommon_core_pb.CustomerInfo.toObject(includeInstance, f),
    optionradioswitch: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    tickettagsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    isreloan: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListVerifyQuestionResp}
 */
proto.xcommon.ListVerifyQuestionResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListVerifyQuestionResp;
  return proto.xcommon.ListVerifyQuestionResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListVerifyQuestionResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListVerifyQuestionResp}
 */
proto.xcommon.ListVerifyQuestionResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_core_pb.AccountBaseInfo;
      reader.readMessage(value,xcommon_core_pb.AccountBaseInfo.deserializeBinaryFromReader);
      msg.setAccountbase(value);
      break;
    case 3:
      var value = new proto.xcommon.ListVerifyQuestionResp.Question;
      reader.readMessage(value,proto.xcommon.ListVerifyQuestionResp.Question.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPvcallingswitch(value);
      break;
    case 5:
      var value = msg.getPhoneobjectMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 6:
      var value = msg.getPhoneobjectmobileMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 7:
      var value = msg.getPhoneobjectmobilesaltMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuppliertype(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPmdswitch(value);
      break;
    case 10:
      var value = msg.getPhonestatusMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readEnum, null, "");
         });
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIdphotosourceswitch(value);
      break;
    case 12:
      var value = new xcommon_core_pb.CustomerInfo;
      reader.readMessage(value,xcommon_core_pb.CustomerInfo.deserializeBinaryFromReader);
      msg.setCustomerinfo(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOptionradioswitch(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickettags(value);
      break;
    case 15:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsreloan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListVerifyQuestionResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListVerifyQuestionResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListVerifyQuestionResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getAccountbase();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_core_pb.AccountBaseInfo.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.ListVerifyQuestionResp.Question.serializeBinaryToWriter
    );
  }
  f = message.getPvcallingswitch();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPhoneobjectMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPhoneobjectmobileMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPhoneobjectmobilesaltMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getSuppliertypeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getPmdswitch();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getPhonestatusMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeEnum);
  }
  f = message.getIdphotosourceswitch();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getCustomerinfo();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      xcommon_core_pb.CustomerInfo.serializeBinaryToWriter
    );
  }
  f = message.getOptionradioswitch();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getTickettagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListVerifyQuestionResp.Question.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListVerifyQuestionResp.Question.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListVerifyQuestionResp.Question} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListVerifyQuestionResp.Question.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    qptype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    value: jspb.Message.getFieldWithDefault(msg, 4, ""),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.xcommon.QOptionItem.toObject, includeInstance),
    associateditemsList: jspb.Message.toObjectList(msg.getAssociateditemsList(),
    proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.toObject, includeInstance),
    qgroup: jspb.Message.getFieldWithDefault(msg, 7, 0),
    defaultoption: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListVerifyQuestionResp.Question}
 */
proto.xcommon.ListVerifyQuestionResp.Question.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListVerifyQuestionResp.Question;
  return proto.xcommon.ListVerifyQuestionResp.Question.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListVerifyQuestionResp.Question} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListVerifyQuestionResp.Question}
 */
proto.xcommon.ListVerifyQuestionResp.Question.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.QpType} */ (reader.readEnum());
      msg.setQptype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 5:
      var value = new proto.xcommon.QOptionItem;
      reader.readMessage(value,proto.xcommon.QOptionItem.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 6:
      var value = new proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem;
      reader.readMessage(value,proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.deserializeBinaryFromReader);
      msg.addAssociateditems(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.VerifyInfoGroupEnum} */ (reader.readEnum());
      msg.setQgroup(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDefaultoption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListVerifyQuestionResp.Question.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListVerifyQuestionResp.Question} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListVerifyQuestionResp.Question.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getQptype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.QOptionItem.serializeBinaryToWriter
    );
  }
  f = message.getAssociateditemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.serializeBinaryToWriter
    );
  }
  f = message.getQgroup();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getDefaultoption();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    key: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, ""),
    source: jspb.Message.getFieldWithDefault(msg, 4, ""),
    imagetype: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem;
  return proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.ImageTypeEnum} */ (reader.readEnum());
      msg.setImagetype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getImagetype();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string Type = 1;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.setType = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Key = 2;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Value = 3;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Source = 4;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.setSource = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional ImageTypeEnum ImageType = 5;
 * @return {!proto.xcommon.ImageTypeEnum}
 */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.getImagetype = function() {
  return /** @type {!proto.xcommon.ImageTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.ImageTypeEnum} value */
proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem.prototype.setImagetype = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional QpType QpType = 2;
 * @return {!proto.xcommon.QpType}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.getQptype = function() {
  return /** @type {!proto.xcommon.QpType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.QpType} value */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.setQptype = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string Desc = 3;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.setDesc = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Value = 4;
 * @return {string}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated QOptionItem options = 5;
 * @return {!Array<!proto.xcommon.QOptionItem>}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.xcommon.QOptionItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.QOptionItem, 5));
};


/** @param {!Array<!proto.xcommon.QOptionItem>} value */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.setOptionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.QOptionItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.QOptionItem}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.QOptionItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.clearOptionsList = function() {
  this.setOptionsList([]);
};


/**
 * repeated AssociatedItem AssociatedItems = 6;
 * @return {!Array<!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem>}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.getAssociateditemsList = function() {
  return /** @type{!Array<!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem, 6));
};


/** @param {!Array<!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem>} value */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.setAssociateditemsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.addAssociateditems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.xcommon.ListVerifyQuestionResp.Question.AssociatedItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.clearAssociateditemsList = function() {
  this.setAssociateditemsList([]);
};


/**
 * optional VerifyInfoGroupEnum QGroup = 7;
 * @return {!proto.xcommon.VerifyInfoGroupEnum}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.getQgroup = function() {
  return /** @type {!proto.xcommon.VerifyInfoGroupEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.xcommon.VerifyInfoGroupEnum} value */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.setQgroup = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int64 DefaultOption = 8;
 * @return {number}
 */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.getDefaultoption = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.ListVerifyQuestionResp.Question.prototype.setDefaultoption = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AccountBaseInfo AccountBase = 2;
 * @return {?proto.xcommon.AccountBaseInfo}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getAccountbase = function() {
  return /** @type{?proto.xcommon.AccountBaseInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.AccountBaseInfo, 2));
};


/** @param {?proto.xcommon.AccountBaseInfo|undefined} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setAccountbase = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearAccountbase = function() {
  this.setAccountbase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.hasAccountbase = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Question List = 3;
 * @return {!Array<!proto.xcommon.ListVerifyQuestionResp.Question>}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ListVerifyQuestionResp.Question>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ListVerifyQuestionResp.Question, 3));
};


/** @param {!Array<!proto.xcommon.ListVerifyQuestionResp.Question>} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.ListVerifyQuestionResp.Question=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ListVerifyQuestionResp.Question}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.ListVerifyQuestionResp.Question, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional bool PVCallingSwitch = 4;
 * @return {boolean}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getPvcallingswitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setPvcallingswitch = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * map<int32, string> PhoneObject = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getPhoneobjectMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearPhoneobjectMap = function() {
  this.getPhoneobjectMap().clear();
};


/**
 * map<int32, string> PhoneObjectMobile = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getPhoneobjectmobileMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearPhoneobjectmobileMap = function() {
  this.getPhoneobjectmobileMap().clear();
};


/**
 * map<int32, string> PhoneObjectMobileSalt = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getPhoneobjectmobilesaltMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearPhoneobjectmobilesaltMap = function() {
  this.getPhoneobjectmobilesaltMap().clear();
};


/**
 * repeated string SupplierType = 8;
 * @return {!Array<string>}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getSuppliertypeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/** @param {!Array<string>} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setSuppliertypeList = function(value) {
  jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.ListVerifyQuestionResp.prototype.addSuppliertype = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearSuppliertypeList = function() {
  this.setSuppliertypeList([]);
};


/**
 * optional bool PMDSwitch = 9;
 * @return {boolean}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getPmdswitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/** @param {boolean} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setPmdswitch = function(value) {
  jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * map<string, ContactStatusEnum> PhoneStatus = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.xcommon.ContactStatusEnum>}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getPhonestatusMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.xcommon.ContactStatusEnum>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearPhonestatusMap = function() {
  this.getPhonestatusMap().clear();
};


/**
 * optional bool IdPhotoSourceSwitch = 11;
 * @return {boolean}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getIdphotosourceswitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/** @param {boolean} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setIdphotosourceswitch = function(value) {
  jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional CustomerInfo CustomerInfo = 12;
 * @return {?proto.xcommon.CustomerInfo}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getCustomerinfo = function() {
  return /** @type{?proto.xcommon.CustomerInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.CustomerInfo, 12));
};


/** @param {?proto.xcommon.CustomerInfo|undefined} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setCustomerinfo = function(value) {
  jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearCustomerinfo = function() {
  this.setCustomerinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.hasCustomerinfo = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool OptionRadioSwitch = 13;
 * @return {boolean}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getOptionradioswitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/** @param {boolean} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setOptionradioswitch = function(value) {
  jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * repeated string TicketTags = 14;
 * @return {!Array<string>}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getTickettagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/** @param {!Array<string>} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setTickettagsList = function(value) {
  jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.ListVerifyQuestionResp.prototype.addTickettags = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListVerifyQuestionResp.prototype.clearTickettagsList = function() {
  this.setTickettagsList([]);
};


/**
 * optional Bool IsReloan = 15;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.ListVerifyQuestionResp.prototype.getIsreloan = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.ListVerifyQuestionResp.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3EnumField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QOptionItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QOptionItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QOptionItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QOptionItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    index: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    action: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QOptionItem}
 */
proto.xcommon.QOptionItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QOptionItem;
  return proto.xcommon.QOptionItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QOptionItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QOptionItem}
 */
proto.xcommon.QOptionItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.VerifyAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QOptionItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QOptionItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QOptionItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QOptionItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 Index = 1;
 * @return {number}
 */
proto.xcommon.QOptionItem.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.QOptionItem.prototype.setIndex = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Value = 2;
 * @return {string}
 */
proto.xcommon.QOptionItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.QOptionItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional VerifyAction Action = 3;
 * @return {!proto.xcommon.VerifyAction}
 */
proto.xcommon.QOptionItem.prototype.getAction = function() {
  return /** @type {!proto.xcommon.VerifyAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.VerifyAction} value */
proto.xcommon.QOptionItem.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SavePVRecordReq.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePVRecordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePVRecordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePVRecordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVRecordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    answersList: jspb.Message.toObjectList(msg.getAnswersList(),
    proto.xcommon.SavePVRecordReq.Answer.toObject, includeInstance),
    pvstatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    remark: jspb.Message.getFieldWithDefault(msg, 7, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePVRecordReq}
 */
proto.xcommon.SavePVRecordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePVRecordReq;
  return proto.xcommon.SavePVRecordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePVRecordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePVRecordReq}
 */
proto.xcommon.SavePVRecordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 5:
      var value = new proto.xcommon.SavePVRecordReq.Answer;
      reader.readMessage(value,proto.xcommon.SavePVRecordReq.Answer.deserializeBinaryFromReader);
      msg.addAnswers(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.PVStatus} */ (reader.readEnum());
      msg.setPvstatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePVRecordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePVRecordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePVRecordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVRecordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.SavePVRecordReq.Answer.serializeBinaryToWriter
    );
  }
  f = message.getPvstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePVRecordReq.Answer.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePVRecordReq.Answer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePVRecordReq.Answer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVRecordReq.Answer.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    option: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePVRecordReq.Answer}
 */
proto.xcommon.SavePVRecordReq.Answer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePVRecordReq.Answer;
  return proto.xcommon.SavePVRecordReq.Answer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePVRecordReq.Answer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePVRecordReq.Answer}
 */
proto.xcommon.SavePVRecordReq.Answer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuestionid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePVRecordReq.Answer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePVRecordReq.Answer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePVRecordReq.Answer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVRecordReq.Answer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOption();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 QuestionId = 1;
 * @return {number}
 */
proto.xcommon.SavePVRecordReq.Answer.prototype.getQuestionid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.SavePVRecordReq.Answer.prototype.setQuestionid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Option = 2;
 * @return {number}
 */
proto.xcommon.SavePVRecordReq.Answer.prototype.getOption = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SavePVRecordReq.Answer.prototype.setOption = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SavePVRecordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SavePVRecordReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SavePVRecordReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePVRecordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.SavePVRecordReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.SavePVRecordReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional TicketItemEnum TicketItemId = 3;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.SavePVRecordReq.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.SavePVRecordReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.SavePVRecordReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.SavePVRecordReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated Answer Answers = 5;
 * @return {!Array<!proto.xcommon.SavePVRecordReq.Answer>}
 */
proto.xcommon.SavePVRecordReq.prototype.getAnswersList = function() {
  return /** @type{!Array<!proto.xcommon.SavePVRecordReq.Answer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SavePVRecordReq.Answer, 5));
};


/** @param {!Array<!proto.xcommon.SavePVRecordReq.Answer>} value */
proto.xcommon.SavePVRecordReq.prototype.setAnswersList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.SavePVRecordReq.Answer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SavePVRecordReq.Answer}
 */
proto.xcommon.SavePVRecordReq.prototype.addAnswers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.SavePVRecordReq.Answer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SavePVRecordReq.prototype.clearAnswersList = function() {
  this.setAnswersList([]);
};


/**
 * optional PVStatus PVStatus = 6;
 * @return {!proto.xcommon.PVStatus}
 */
proto.xcommon.SavePVRecordReq.prototype.getPvstatus = function() {
  return /** @type {!proto.xcommon.PVStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.PVStatus} value */
proto.xcommon.SavePVRecordReq.prototype.setPvstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string Remark = 7;
 * @return {string}
 */
proto.xcommon.SavePVRecordReq.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.SavePVRecordReq.prototype.setRemark = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string AppName = 8;
 * @return {string}
 */
proto.xcommon.SavePVRecordReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.SavePVRecordReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePVRecordResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePVRecordResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePVRecordResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVRecordResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    nextpage: (f = msg.getNextpage()) && proto.xcommon.PVNextPage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePVRecordResp}
 */
proto.xcommon.SavePVRecordResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePVRecordResp;
  return proto.xcommon.SavePVRecordResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePVRecordResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePVRecordResp}
 */
proto.xcommon.SavePVRecordResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.PVNextPage;
      reader.readMessage(value,proto.xcommon.PVNextPage.deserializeBinaryFromReader);
      msg.setNextpage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePVRecordResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePVRecordResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePVRecordResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVRecordResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getNextpage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.PVNextPage.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SavePVRecordResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SavePVRecordResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SavePVRecordResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePVRecordResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PVNextPage NextPage = 2;
 * @return {?proto.xcommon.PVNextPage}
 */
proto.xcommon.SavePVRecordResp.prototype.getNextpage = function() {
  return /** @type{?proto.xcommon.PVNextPage} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.PVNextPage, 2));
};


/** @param {?proto.xcommon.PVNextPage|undefined} value */
proto.xcommon.SavePVRecordResp.prototype.setNextpage = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SavePVRecordResp.prototype.clearNextpage = function() {
  this.setNextpage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePVRecordResp.prototype.hasNextpage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PVNextPage.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PVNextPage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PVNextPage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVNextPage.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    customerid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    assignuid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    pb_switch: jspb.Message.getFieldWithDefault(msg, 7, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PVNextPage}
 */
proto.xcommon.PVNextPage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PVNextPage;
  return proto.xcommon.PVNextPage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PVNextPage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PVNextPage}
 */
proto.xcommon.PVNextPage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setSwitch(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PVNextPage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PVNextPage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PVNextPage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVNextPage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSwitch();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.PVNextPage.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.PVNextPage.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional TicketItemEnum TicketItemId = 2;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.PVNextPage.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.PVNextPage.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 TicketId = 3;
 * @return {number}
 */
proto.xcommon.PVNextPage.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PVNextPage.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 CustomerId = 4;
 * @return {string}
 */
proto.xcommon.PVNextPage.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.PVNextPage.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional int64 AssignUid = 5;
 * @return {number}
 */
proto.xcommon.PVNextPage.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.PVNextPage.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 Status = 6;
 * @return {number}
 */
proto.xcommon.PVNextPage.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.PVNextPage.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional Bool Switch = 7;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.PVNextPage.prototype.getSwitch = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.PVNextPage.prototype.setSwitch = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string AppName = 8;
 * @return {string}
 */
proto.xcommon.PVNextPage.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.PVNextPage.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPVRecordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPVRecordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPVRecordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVRecordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPVRecordReq}
 */
proto.xcommon.GetPVRecordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPVRecordReq;
  return proto.xcommon.GetPVRecordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPVRecordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPVRecordReq}
 */
proto.xcommon.GetPVRecordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPVRecordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPVRecordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPVRecordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVRecordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetPVRecordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetPVRecordReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetPVRecordReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPVRecordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.GetPVRecordReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.GetPVRecordReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional TicketItemEnum TicketItemId = 3;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.GetPVRecordReq.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.GetPVRecordReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.GetPVRecordReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetPVRecordReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetPVRecordResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPVRecordResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPVRecordResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPVRecordResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVRecordResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pvstatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    answersList: jspb.Message.toObjectList(msg.getAnswersList(),
    proto.xcommon.GetPVRecordResp.Answer.toObject, includeInstance),
    remark: jspb.Message.getFieldWithDefault(msg, 4, ""),
    qiremark: jspb.Message.getFieldWithDefault(msg, 5, ""),
    qistatus: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPVRecordResp}
 */
proto.xcommon.GetPVRecordResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPVRecordResp;
  return proto.xcommon.GetPVRecordResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPVRecordResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPVRecordResp}
 */
proto.xcommon.GetPVRecordResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.PVStatus} */ (reader.readEnum());
      msg.setPvstatus(value);
      break;
    case 3:
      var value = new proto.xcommon.GetPVRecordResp.Answer;
      reader.readMessage(value,proto.xcommon.GetPVRecordResp.Answer.deserializeBinaryFromReader);
      msg.addAnswers(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQiremark(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.PVStatus} */ (reader.readEnum());
      msg.setQistatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPVRecordResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPVRecordResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPVRecordResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVRecordResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPvstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetPVRecordResp.Answer.serializeBinaryToWriter
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQiremark();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQistatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPVRecordResp.Answer.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPVRecordResp.Answer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPVRecordResp.Answer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVRecordResp.Answer.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    option: jspb.Message.getFieldWithDefault(msg, 2, 0),
    opvalue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    opaction: jspb.Message.getFieldWithDefault(msg, 4, 0),
    opactionname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPVRecordResp.Answer}
 */
proto.xcommon.GetPVRecordResp.Answer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPVRecordResp.Answer;
  return proto.xcommon.GetPVRecordResp.Answer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPVRecordResp.Answer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPVRecordResp.Answer}
 */
proto.xcommon.GetPVRecordResp.Answer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuestionid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOption(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpvalue(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.VerifyAction} */ (reader.readEnum());
      msg.setOpaction(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpactionname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPVRecordResp.Answer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPVRecordResp.Answer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPVRecordResp.Answer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVRecordResp.Answer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOption();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOpvalue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOpaction();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getOpactionname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int64 QuestionId = 1;
 * @return {number}
 */
proto.xcommon.GetPVRecordResp.Answer.prototype.getQuestionid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.GetPVRecordResp.Answer.prototype.setQuestionid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Option = 2;
 * @return {number}
 */
proto.xcommon.GetPVRecordResp.Answer.prototype.getOption = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.GetPVRecordResp.Answer.prototype.setOption = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string OpValue = 3;
 * @return {string}
 */
proto.xcommon.GetPVRecordResp.Answer.prototype.getOpvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.GetPVRecordResp.Answer.prototype.setOpvalue = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional VerifyAction OpAction = 4;
 * @return {!proto.xcommon.VerifyAction}
 */
proto.xcommon.GetPVRecordResp.Answer.prototype.getOpaction = function() {
  return /** @type {!proto.xcommon.VerifyAction} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.VerifyAction} value */
proto.xcommon.GetPVRecordResp.Answer.prototype.setOpaction = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string OpActionName = 5;
 * @return {string}
 */
proto.xcommon.GetPVRecordResp.Answer.prototype.getOpactionname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetPVRecordResp.Answer.prototype.setOpactionname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetPVRecordResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetPVRecordResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetPVRecordResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPVRecordResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PVStatus PVStatus = 2;
 * @return {!proto.xcommon.PVStatus}
 */
proto.xcommon.GetPVRecordResp.prototype.getPvstatus = function() {
  return /** @type {!proto.xcommon.PVStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.PVStatus} value */
proto.xcommon.GetPVRecordResp.prototype.setPvstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated Answer Answers = 3;
 * @return {!Array<!proto.xcommon.GetPVRecordResp.Answer>}
 */
proto.xcommon.GetPVRecordResp.prototype.getAnswersList = function() {
  return /** @type{!Array<!proto.xcommon.GetPVRecordResp.Answer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetPVRecordResp.Answer, 3));
};


/** @param {!Array<!proto.xcommon.GetPVRecordResp.Answer>} value */
proto.xcommon.GetPVRecordResp.prototype.setAnswersList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetPVRecordResp.Answer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetPVRecordResp.Answer}
 */
proto.xcommon.GetPVRecordResp.prototype.addAnswers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetPVRecordResp.Answer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetPVRecordResp.prototype.clearAnswersList = function() {
  this.setAnswersList([]);
};


/**
 * optional string Remark = 4;
 * @return {string}
 */
proto.xcommon.GetPVRecordResp.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.GetPVRecordResp.prototype.setRemark = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string QIRemark = 5;
 * @return {string}
 */
proto.xcommon.GetPVRecordResp.prototype.getQiremark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetPVRecordResp.prototype.setQiremark = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional PVStatus QIStatus = 6;
 * @return {!proto.xcommon.PVStatus}
 */
proto.xcommon.GetPVRecordResp.prototype.getQistatus = function() {
  return /** @type {!proto.xcommon.PVStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.PVStatus} value */
proto.xcommon.GetPVRecordResp.prototype.setQistatus = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePVCallReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePVCallReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePVCallReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVCallReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    baseinfo: (f = msg.getBaseinfo()) && proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePVCallReq}
 */
proto.xcommon.SavePVCallReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePVCallReq;
  return proto.xcommon.SavePVCallReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePVCallReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePVCallReq}
 */
proto.xcommon.SavePVCallReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.SavePVCallReq.SavePVCallBaseInfo;
      reader.readMessage(value,proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.deserializeBinaryFromReader);
      msg.setBaseinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePVCallReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePVCallReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePVCallReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVCallReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getBaseinfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePVCallReq.SavePVCallBaseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0),
    remark: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticketid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    phoneconnected: jspb.Message.getFieldWithDefault(msg, 5, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 6, 0),
    phonecallinput: jspb.Message.getFieldWithDefault(msg, 7, ""),
    phonetime: jspb.Message.getFieldWithDefault(msg, 8, ""),
    callid: jspb.Message.getFieldWithDefault(msg, 9, "0"),
    itemid: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePVCallReq.SavePVCallBaseInfo}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePVCallReq.SavePVCallBaseInfo;
  return proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePVCallReq.SavePVCallBaseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePVCallReq.SavePVCallBaseInfo}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.PVStatus} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneconnected(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonecallinput(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonetime(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCallid(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setItemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePVCallReq.SavePVCallBaseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getPhoneconnected();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPhonecallinput();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPhonetime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCallid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      9,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional PVStatus Result = 1;
 * @return {!proto.xcommon.PVStatus}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getResult = function() {
  return /** @type {!proto.xcommon.PVStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.PVStatus} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setResult = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Remark = 2;
 * @return {string}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setRemark = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 TicketId = 3;
 * @return {number}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional int32 PhoneConnected = 5;
 * @return {number}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getPhoneconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setPhoneconnected = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 PhoneObject = 6;
 * @return {number}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string PhoneCallInput = 7;
 * @return {string}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getPhonecallinput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setPhonecallinput = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string PhoneTime = 8;
 * @return {string}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getPhonetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setPhonetime = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 CallId = 9;
 * @return {string}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getCallid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/** @param {string} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setCallid = function(value) {
  jspb.Message.setProto3StringIntField(this, 9, value);
};


/**
 * optional TicketItemEnum ItemId = 10;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.getItemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.SavePVCallReq.SavePVCallBaseInfo.prototype.setItemid = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SavePVCallReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SavePVCallReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SavePVCallReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePVCallReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SavePVCallBaseInfo BaseInfo = 2;
 * @return {?proto.xcommon.SavePVCallReq.SavePVCallBaseInfo}
 */
proto.xcommon.SavePVCallReq.prototype.getBaseinfo = function() {
  return /** @type{?proto.xcommon.SavePVCallReq.SavePVCallBaseInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.SavePVCallReq.SavePVCallBaseInfo, 2));
};


/** @param {?proto.xcommon.SavePVCallReq.SavePVCallBaseInfo|undefined} value */
proto.xcommon.SavePVCallReq.prototype.setBaseinfo = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SavePVCallReq.prototype.clearBaseinfo = function() {
  this.setBaseinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePVCallReq.prototype.hasBaseinfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePVCallResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePVCallResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePVCallResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVCallResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    opmessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePVCallResp}
 */
proto.xcommon.SavePVCallResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePVCallResp;
  return proto.xcommon.SavePVCallResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePVCallResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePVCallResp}
 */
proto.xcommon.SavePVCallResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePVCallResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePVCallResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePVCallResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePVCallResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOpmessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SavePVCallResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SavePVCallResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SavePVCallResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePVCallResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string OpMessage = 2;
 * @return {string}
 */
proto.xcommon.SavePVCallResp.prototype.getOpmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SavePVCallResp.prototype.setOpmessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPVCallReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPVCallReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPVCallReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPVCallReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPVCallReq}
 */
proto.xcommon.ListPVCallReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPVCallReq;
  return proto.xcommon.ListPVCallReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPVCallReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPVCallReq}
 */
proto.xcommon.ListPVCallReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPVCallReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPVCallReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPVCallReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPVCallReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListPVCallReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListPVCallReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPVCallReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPVCallReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListPVCallReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListPVCallReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPVCallReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPVCallReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.ListPVCallReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.ListPVCallReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional TicketItemEnum TicketItemId = 4;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.ListPVCallReq.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.ListPVCallReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 TicketId = 5;
 * @return {number}
 */
proto.xcommon.ListPVCallReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.ListPVCallReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string AppName = 6;
 * @return {string}
 */
proto.xcommon.ListPVCallReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListPVCallResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPVCallResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPVCallResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPVCallResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPVCallResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ListPVCallResp.CallDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPVCallResp}
 */
proto.xcommon.ListPVCallResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPVCallResp;
  return proto.xcommon.ListPVCallResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPVCallResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPVCallResp}
 */
proto.xcommon.ListPVCallResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.ListPVCallResp.CallDetail;
      reader.readMessage(value,proto.xcommon.ListPVCallResp.CallDetail.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPVCallResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPVCallResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPVCallResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPVCallResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.ListPVCallResp.CallDetail.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPVCallResp.CallDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPVCallResp.CallDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPVCallResp.CallDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    opname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 3, ""),
    urgetype: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phoneobjectmobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    phonetime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    answertimestamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
    endtimestamp: jspb.Message.getFieldWithDefault(msg, 8, 0),
    hangupdirection: jspb.Message.getFieldWithDefault(msg, 9, ""),
    hangupcause: jspb.Message.getFieldWithDefault(msg, 10, ""),
    phoneconnect: jspb.Message.getFieldWithDefault(msg, 11, ""),
    result: jspb.Message.getFieldWithDefault(msg, 12, ""),
    remark: jspb.Message.getFieldWithDefault(msg, 13, ""),
    dialway: jspb.Message.getFieldWithDefault(msg, 14, ""),
    audiorecordname: jspb.Message.getFieldWithDefault(msg, 15, ""),
    audiorecordurl: jspb.Message.getFieldWithDefault(msg, 16, ""),
    callid: jspb.Message.getFieldWithDefault(msg, 17, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPVCallResp.CallDetail}
 */
proto.xcommon.ListPVCallResp.CallDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPVCallResp.CallDetail;
  return proto.xcommon.ListPVCallResp.CallDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPVCallResp.CallDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPVCallResp.CallDetail}
 */
proto.xcommon.ListPVCallResp.CallDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobject(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrgetype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobjectmobile(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhonetime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswertimestamp(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtimestamp(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupdirection(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupcause(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneconnect(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setDialway(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiorecordname(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiorecordurl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCallid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPVCallResp.CallDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPVCallResp.CallDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPVCallResp.CallDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOpname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhoneobject();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrgetype();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhoneobjectmobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPhonetime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAnswertimestamp();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getEndtimestamp();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getHangupdirection();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHangupcause();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPhoneconnect();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDialway();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAudiorecordname();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAudiorecordurl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCallid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      17,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string OpName = 2;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getOpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setOpname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string PhoneObject = 3;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getPhoneobject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UrgeType = 4;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getUrgetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setUrgetype = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string PhoneObjectMobile = 5;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getPhoneobjectmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setPhoneobjectmobile = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 PhoneTime = 6;
 * @return {number}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getPhonetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setPhonetime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AnswerTimestamp = 7;
 * @return {number}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getAnswertimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setAnswertimestamp = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 EndTimestamp = 8;
 * @return {number}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getEndtimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setEndtimestamp = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string HangupDirection = 9;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getHangupdirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setHangupdirection = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string HangupCause = 10;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getHangupcause = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setHangupcause = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string PhoneConnect = 11;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getPhoneconnect = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setPhoneconnect = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string Result = 12;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setResult = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string Remark = 13;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setRemark = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string DialWay = 14;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getDialway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setDialway = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string AudioRecordName = 15;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getAudiorecordname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setAudiorecordname = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string AudioRecordURL = 16;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getAudiorecordurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setAudiorecordurl = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 CallId = 17;
 * @return {string}
 */
proto.xcommon.ListPVCallResp.CallDetail.prototype.getCallid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, "0"));
};


/** @param {string} value */
proto.xcommon.ListPVCallResp.CallDetail.prototype.setCallid = function(value) {
  jspb.Message.setProto3StringIntField(this, 17, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListPVCallResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListPVCallResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPVCallResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPVCallResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListPVCallResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListPVCallResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPVCallResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPVCallResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated CallDetail List = 3;
 * @return {!Array<!proto.xcommon.ListPVCallResp.CallDetail>}
 */
proto.xcommon.ListPVCallResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ListPVCallResp.CallDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ListPVCallResp.CallDetail, 3));
};


/** @param {!Array<!proto.xcommon.ListPVCallResp.CallDetail>} value */
proto.xcommon.ListPVCallResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.ListPVCallResp.CallDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ListPVCallResp.CallDetail}
 */
proto.xcommon.ListPVCallResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.ListPVCallResp.CallDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListPVCallResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveQIRecordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveQIRecordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveQIRecordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveQIRecordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    qistatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    remark: jspb.Message.getFieldWithDefault(msg, 6, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveQIRecordReq}
 */
proto.xcommon.SaveQIRecordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveQIRecordReq;
  return proto.xcommon.SaveQIRecordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveQIRecordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveQIRecordReq}
 */
proto.xcommon.SaveQIRecordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.PVStatus} */ (reader.readEnum());
      msg.setQistatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveQIRecordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveQIRecordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveQIRecordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveQIRecordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getQistatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveQIRecordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveQIRecordReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveQIRecordReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveQIRecordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.SaveQIRecordReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.SaveQIRecordReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional TicketItemEnum TicketItemId = 3;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.SaveQIRecordReq.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.SaveQIRecordReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.SaveQIRecordReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.SaveQIRecordReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional PVStatus QIStatus = 5;
 * @return {!proto.xcommon.PVStatus}
 */
proto.xcommon.SaveQIRecordReq.prototype.getQistatus = function() {
  return /** @type {!proto.xcommon.PVStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.PVStatus} value */
proto.xcommon.SaveQIRecordReq.prototype.setQistatus = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string Remark = 6;
 * @return {string}
 */
proto.xcommon.SaveQIRecordReq.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.SaveQIRecordReq.prototype.setRemark = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string AppName = 7;
 * @return {string}
 */
proto.xcommon.SaveQIRecordReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.SaveQIRecordReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveQIRecordResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveQIRecordResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveQIRecordResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveQIRecordResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    nextpage: (f = msg.getNextpage()) && proto.xcommon.PVNextPage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveQIRecordResp}
 */
proto.xcommon.SaveQIRecordResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveQIRecordResp;
  return proto.xcommon.SaveQIRecordResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveQIRecordResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveQIRecordResp}
 */
proto.xcommon.SaveQIRecordResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.PVNextPage;
      reader.readMessage(value,proto.xcommon.PVNextPage.deserializeBinaryFromReader);
      msg.setNextpage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveQIRecordResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveQIRecordResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveQIRecordResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveQIRecordResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getNextpage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.PVNextPage.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveQIRecordResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveQIRecordResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveQIRecordResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveQIRecordResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PVNextPage NextPage = 2;
 * @return {?proto.xcommon.PVNextPage}
 */
proto.xcommon.SaveQIRecordResp.prototype.getNextpage = function() {
  return /** @type{?proto.xcommon.PVNextPage} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.PVNextPage, 2));
};


/** @param {?proto.xcommon.PVNextPage|undefined} value */
proto.xcommon.SaveQIRecordResp.prototype.setNextpage = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveQIRecordResp.prototype.clearNextpage = function() {
  this.setNextpage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveQIRecordResp.prototype.hasNextpage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WarningLetterListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WarningLetterListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WarningLetterListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WarningLetterListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WarningLetterListReq}
 */
proto.xcommon.WarningLetterListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WarningLetterListReq;
  return proto.xcommon.WarningLetterListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WarningLetterListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WarningLetterListReq}
 */
proto.xcommon.WarningLetterListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WarningLetterListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WarningLetterListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WarningLetterListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WarningLetterListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WarningLetterListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WarningLetterListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WarningLetterListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WarningLetterListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.WarningLetterListReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WarningLetterListReq.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WarningLetterListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WarningLetterListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WarningLetterListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WarningLetterListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WarningLetterListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    showletter: jspb.Message.getFieldWithDefault(msg, 2, 0),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.WarningLetter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WarningLetterListResp}
 */
proto.xcommon.WarningLetterListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WarningLetterListResp;
  return proto.xcommon.WarningLetterListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WarningLetterListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WarningLetterListResp}
 */
proto.xcommon.WarningLetterListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setShowletter(value);
      break;
    case 3:
      var value = new proto.xcommon.WarningLetter;
      reader.readMessage(value,proto.xcommon.WarningLetter.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WarningLetterListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WarningLetterListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WarningLetterListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WarningLetterListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getShowletter();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.WarningLetter.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WarningLetterListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WarningLetterListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WarningLetterListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WarningLetterListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bool ShowLetter = 2;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.WarningLetterListResp.prototype.getShowletter = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.WarningLetterListResp.prototype.setShowletter = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated WarningLetter List = 3;
 * @return {!Array<!proto.xcommon.WarningLetter>}
 */
proto.xcommon.WarningLetterListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.WarningLetter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WarningLetter, 3));
};


/** @param {!Array<!proto.xcommon.WarningLetter>} value */
proto.xcommon.WarningLetterListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.WarningLetter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WarningLetter}
 */
proto.xcommon.WarningLetterListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.WarningLetter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WarningLetterListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WarningLetter.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WarningLetter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WarningLetter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WarningLetter.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    template: jspb.Message.getFieldWithDefault(msg, 3, ""),
    letterid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    letterdata: jspb.Message.getFieldWithDefault(msg, 5, ""),
    letterstatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WarningLetter}
 */
proto.xcommon.WarningLetter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WarningLetter;
  return proto.xcommon.WarningLetter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WarningLetter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WarningLetter}
 */
proto.xcommon.WarningLetter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLetterid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLetterdata(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.WarningLetterStatus} */ (reader.readEnum());
      msg.setLetterstatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WarningLetter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WarningLetter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WarningLetter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WarningLetter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getTemplate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLetterid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLetterdata();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLetterstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.WarningLetter.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.WarningLetter.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.WarningLetter.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.WarningLetter.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string Template = 3;
 * @return {string}
 */
proto.xcommon.WarningLetter.prototype.getTemplate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WarningLetter.prototype.setTemplate = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string LetterID = 4;
 * @return {string}
 */
proto.xcommon.WarningLetter.prototype.getLetterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.WarningLetter.prototype.setLetterid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string LetterData = 5;
 * @return {string}
 */
proto.xcommon.WarningLetter.prototype.getLetterdata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.WarningLetter.prototype.setLetterdata = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional WarningLetterStatus LetterStatus = 6;
 * @return {!proto.xcommon.WarningLetterStatus}
 */
proto.xcommon.WarningLetter.prototype.getLetterstatus = function() {
  return /** @type {!proto.xcommon.WarningLetterStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.WarningLetterStatus} value */
proto.xcommon.WarningLetter.prototype.setLetterstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int64 Ctime = 7;
 * @return {number}
 */
proto.xcommon.WarningLetter.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.WarningLetter.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DownWarningLetterReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DownWarningLetterReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DownWarningLetterReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownWarningLetterReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    caseid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 4, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DownWarningLetterReq}
 */
proto.xcommon.DownWarningLetterReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DownWarningLetterReq;
  return proto.xcommon.DownWarningLetterReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DownWarningLetterReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DownWarningLetterReq}
 */
proto.xcommon.DownWarningLetterReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DownWarningLetterReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DownWarningLetterReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DownWarningLetterReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownWarningLetterReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DownWarningLetterReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DownWarningLetterReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DownWarningLetterReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DownWarningLetterReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.DownWarningLetterReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DownWarningLetterReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 CaseId = 3;
 * @return {number}
 */
proto.xcommon.DownWarningLetterReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.DownWarningLetterReq.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 AccountId = 4;
 * @return {string}
 */
proto.xcommon.DownWarningLetterReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.DownWarningLetterReq.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DownWarningLetterResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DownWarningLetterResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DownWarningLetterResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownWarningLetterResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    mediaheader: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mediabody: msg.getMediabody_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DownWarningLetterResp}
 */
proto.xcommon.DownWarningLetterResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DownWarningLetterResp;
  return proto.xcommon.DownWarningLetterResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DownWarningLetterResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DownWarningLetterResp}
 */
proto.xcommon.DownWarningLetterResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMediaheader(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMediabody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DownWarningLetterResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DownWarningLetterResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DownWarningLetterResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownWarningLetterResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getMediaheader();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMediabody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DownWarningLetterResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DownWarningLetterResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DownWarningLetterResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DownWarningLetterResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string MediaHeader = 2;
 * @return {string}
 */
proto.xcommon.DownWarningLetterResp.prototype.getMediaheader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.DownWarningLetterResp.prototype.setMediaheader = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes MediaBody = 3;
 * @return {!(string|Uint8Array)}
 */
proto.xcommon.DownWarningLetterResp.prototype.getMediabody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes MediaBody = 3;
 * This is a type-conversion wrapper around `getMediabody()`
 * @return {string}
 */
proto.xcommon.DownWarningLetterResp.prototype.getMediabody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMediabody()));
};


/**
 * optional bytes MediaBody = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMediabody()`
 * @return {!Uint8Array}
 */
proto.xcommon.DownWarningLetterResp.prototype.getMediabody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMediabody()));
};


/** @param {!(string|Uint8Array)} value */
proto.xcommon.DownWarningLetterResp.prototype.setMediabody = function(value) {
  jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WarningLetterReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WarningLetterReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WarningLetterReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WarningLetterReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WarningLetterReq}
 */
proto.xcommon.WarningLetterReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WarningLetterReq;
  return proto.xcommon.WarningLetterReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WarningLetterReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WarningLetterReq}
 */
proto.xcommon.WarningLetterReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WarningLetterReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WarningLetterReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WarningLetterReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WarningLetterReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WarningLetterReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WarningLetterReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WarningLetterReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WarningLetterReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.WarningLetterReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WarningLetterReq.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetUserTicketLoadReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserTicketLoadReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserTicketLoadReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserTicketLoadReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserTicketLoadReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    useridsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserTicketLoadReq}
 */
proto.xcommon.GetUserTicketLoadReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserTicketLoadReq;
  return proto.xcommon.GetUserTicketLoadReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserTicketLoadReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserTicketLoadReq}
 */
proto.xcommon.GetUserTicketLoadReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setUseridsList(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserTicketLoadReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserTicketLoadReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserTicketLoadReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserTicketLoadReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUseridsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetUserTicketLoadReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetUserTicketLoadReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserTicketLoadReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserTicketLoadReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 UserIds = 2;
 * @return {!Array<number>}
 */
proto.xcommon.GetUserTicketLoadReq.prototype.getUseridsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<number>} value */
proto.xcommon.GetUserTicketLoadReq.prototype.setUseridsList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetUserTicketLoadReq.prototype.addUserids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetUserTicketLoadReq.prototype.clearUseridsList = function() {
  this.setUseridsList([]);
};


/**
 * optional TicketItemEnum TicketItemId = 3;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.GetUserTicketLoadReq.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.GetUserTicketLoadReq.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetUserTicketLoadResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserTicketLoadResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserTicketLoadResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserTicketLoadResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserTicketLoadResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.UserLoad.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserTicketLoadResp}
 */
proto.xcommon.GetUserTicketLoadResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserTicketLoadResp;
  return proto.xcommon.GetUserTicketLoadResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserTicketLoadResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserTicketLoadResp}
 */
proto.xcommon.GetUserTicketLoadResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.UserLoad;
      reader.readMessage(value,proto.xcommon.UserLoad.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserTicketLoadResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserTicketLoadResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserTicketLoadResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserTicketLoadResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.UserLoad.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetUserTicketLoadResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetUserTicketLoadResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserTicketLoadResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserTicketLoadResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UserLoad List = 2;
 * @return {!Array<!proto.xcommon.UserLoad>}
 */
proto.xcommon.GetUserTicketLoadResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.UserLoad>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UserLoad, 2));
};


/** @param {!Array<!proto.xcommon.UserLoad>} value */
proto.xcommon.GetUserTicketLoadResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.UserLoad=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UserLoad}
 */
proto.xcommon.GetUserTicketLoadResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.UserLoad, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetUserTicketLoadResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UserLoad.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UserLoad.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UserLoad} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserLoad.toObject = function(includeInstance, msg) {
  var f, obj = {
    adminuid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    loadnum: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UserLoad}
 */
proto.xcommon.UserLoad.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UserLoad;
  return proto.xcommon.UserLoad.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UserLoad} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UserLoad}
 */
proto.xcommon.UserLoad.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setLoadnum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UserLoad.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UserLoad.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UserLoad} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UserLoad.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLoadnum();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional int64 AdminUID = 1;
 * @return {number}
 */
proto.xcommon.UserLoad.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.UserLoad.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 LoadNum = 2;
 * @return {string}
 */
proto.xcommon.UserLoad.prototype.getLoadnum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.UserLoad.prototype.setLoadnum = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListUrgeDetailStatsReq.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListUrgeDetailStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListUrgeDetailStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListUrgeDetailStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    calltype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isreloan: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 9, ""),
    communicationway: jspb.Message.getFieldWithDefault(msg, 10, 0),
    dimensionList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    timerange: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListUrgeDetailStatsReq}
 */
proto.xcommon.ListUrgeDetailStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListUrgeDetailStatsReq;
  return proto.xcommon.ListUrgeDetailStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListUrgeDetailStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListUrgeDetailStatsReq}
 */
proto.xcommon.ListUrgeDetailStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.CallTypeEnum} */ (reader.readEnum());
      msg.setCalltype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobject(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsreloan(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCommunicationway(value);
      break;
    case 11:
      var value = /** @type {!Array<!proto.xcommon.UDDimension>} */ (reader.readPackedEnum());
      msg.setDimensionList(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListUrgeDetailStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListUrgeDetailStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListUrgeDetailStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCalltype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPhoneobject();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCommunicationway();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getDimensionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      11,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 ItemID = 3;
 * @return {number}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 UserGroupId = 4;
 * @return {number}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string UserName = 5;
 * @return {string}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional CallTypeEnum CallType = 6;
 * @return {!proto.xcommon.CallTypeEnum}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getCalltype = function() {
  return /** @type {!proto.xcommon.CallTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.CallTypeEnum} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setCalltype = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string PhoneObject = 7;
 * @return {string}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getPhoneobject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Bool IsReloan = 8;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getIsreloan = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string TicketStatus = 9;
 * @return {string}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setTicketstatus = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 CommunicationWay = 10;
 * @return {number}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getCommunicationway = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setCommunicationway = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * repeated UDDimension Dimension = 11;
 * @return {!Array<!proto.xcommon.UDDimension>}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getDimensionList = function() {
  return /** @type {!Array<!proto.xcommon.UDDimension>} */ (jspb.Message.getRepeatedField(this, 11));
};


/** @param {!Array<!proto.xcommon.UDDimension>} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setDimensionList = function(value) {
  jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {!proto.xcommon.UDDimension} value
 * @param {number=} opt_index
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.addDimension = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.clearDimensionList = function() {
  this.setDimensionList([]);
};


/**
 * optional string TimeRange = 12;
 * @return {string}
 */
proto.xcommon.ListUrgeDetailStatsReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.ListUrgeDetailStatsReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListUrgeDetailStatsResp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListUrgeDetailStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListUrgeDetailStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListUrgeDetailStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    updatetime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.UrgeDetailStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListUrgeDetailStatsResp}
 */
proto.xcommon.ListUrgeDetailStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListUrgeDetailStatsResp;
  return proto.xcommon.ListUrgeDetailStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListUrgeDetailStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListUrgeDetailStatsResp}
 */
proto.xcommon.ListUrgeDetailStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    case 4:
      var value = new proto.xcommon.UrgeDetailStats;
      reader.readMessage(value,proto.xcommon.UrgeDetailStats.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListUrgeDetailStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListUrgeDetailStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListUrgeDetailStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.UrgeDetailStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListUrgeDetailStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListUrgeDetailStatsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 UpdateTime = 3;
 * @return {number}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.ListUrgeDetailStatsResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated UrgeDetailStats List = 4;
 * @return {!Array<!proto.xcommon.UrgeDetailStats>}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.UrgeDetailStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UrgeDetailStats, 4));
};


/** @param {!Array<!proto.xcommon.UrgeDetailStats>} value */
proto.xcommon.ListUrgeDetailStatsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.UrgeDetailStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeDetailStats}
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.UrgeDetailStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListUrgeDetailStatsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UrgeDetailStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UrgeDetailStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UrgeDetailStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeDetailStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    itemname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    communicationway: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dialnum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    answernum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    unconnectnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    answerrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UrgeDetailStats}
 */
proto.xcommon.UrgeDetailStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UrgeDetailStats;
  return proto.xcommon.UrgeDetailStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UrgeDetailStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UrgeDetailStats}
 */
proto.xcommon.UrgeDetailStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCommunicationway(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDialnum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswernum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnconnectnum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAnswerrate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UrgeDetailStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UrgeDetailStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UrgeDetailStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeDetailStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCommunicationway();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDialnum();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAnswernum();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUnconnectnum();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAnswerrate();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional string Date = 1;
 * @return {string}
 */
proto.xcommon.UrgeDetailStats.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.UrgeDetailStats.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ItemName = 2;
 * @return {string}
 */
proto.xcommon.UrgeDetailStats.prototype.getItemname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.UrgeDetailStats.prototype.setItemname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 CommunicationWay = 3;
 * @return {number}
 */
proto.xcommon.UrgeDetailStats.prototype.getCommunicationway = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.UrgeDetailStats.prototype.setCommunicationway = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 DialNum = 4;
 * @return {number}
 */
proto.xcommon.UrgeDetailStats.prototype.getDialnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.UrgeDetailStats.prototype.setDialnum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 AnswerNum = 5;
 * @return {number}
 */
proto.xcommon.UrgeDetailStats.prototype.getAnswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.UrgeDetailStats.prototype.setAnswernum = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 UnconnectNum = 6;
 * @return {number}
 */
proto.xcommon.UrgeDetailStats.prototype.getUnconnectnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.UrgeDetailStats.prototype.setUnconnectnum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double AnswerRate = 7;
 * @return {number}
 */
proto.xcommon.UrgeDetailStats.prototype.getAnswerrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/** @param {number} value */
proto.xcommon.UrgeDetailStats.prototype.setAnswerrate = function(value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListUrgeDetailStatsParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListUrgeDetailStatsParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListUrgeDetailStatsParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListUrgeDetailStatsParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListUrgeDetailStatsParamReq}
 */
proto.xcommon.ListUrgeDetailStatsParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListUrgeDetailStatsParamReq;
  return proto.xcommon.ListUrgeDetailStatsParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListUrgeDetailStatsParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListUrgeDetailStatsParamReq}
 */
proto.xcommon.ListUrgeDetailStatsParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListUrgeDetailStatsParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListUrgeDetailStatsParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListUrgeDetailStatsParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListUrgeDetailStatsParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListUrgeDetailStatsParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListUrgeDetailStatsParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListUrgeDetailStatsParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListUrgeDetailStatsParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListUrgeDetailStatsParamResp.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListUrgeDetailStatsParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListUrgeDetailStatsParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListUrgeDetailStatsParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    ticketstatusList: jspb.Message.toObjectList(msg.getTicketstatusList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    ticketitemList: jspb.Message.toObjectList(msg.getTicketitemList(),
    proto.xcommon.AttrItem.toObject, includeInstance),
    communicationwaymapMap: (f = msg.getCommunicationwaymapMap()) ? f.toObject(includeInstance, undefined) : [],
    phoneobjectMap: (f = msg.getPhoneobjectMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListUrgeDetailStatsParamResp}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListUrgeDetailStatsParamResp;
  return proto.xcommon.ListUrgeDetailStatsParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListUrgeDetailStatsParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListUrgeDetailStatsParamResp}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketstatus(value);
      break;
    case 3:
      var value = new proto.xcommon.AttrItem;
      reader.readMessage(value,proto.xcommon.AttrItem.deserializeBinaryFromReader);
      msg.addTicketitem(value);
      break;
    case 4:
      var value = msg.getCommunicationwaymapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 5:
      var value = msg.getPhoneobjectMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListUrgeDetailStatsParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListUrgeDetailStatsParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListUrgeDetailStatsParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTicketstatusList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getTicketitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.AttrItem.serializeBinaryToWriter
    );
  }
  f = message.getCommunicationwaymapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPhoneobjectMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AttrItem TicketStatus = 2;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.getTicketstatusList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 2));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.setTicketstatusList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.addTicketstatus = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.clearTicketstatusList = function() {
  this.setTicketstatusList([]);
};


/**
 * repeated AttrItem TicketItem = 3;
 * @return {!Array<!proto.xcommon.AttrItem>}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.getTicketitemList = function() {
  return /** @type{!Array<!proto.xcommon.AttrItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.AttrItem, 3));
};


/** @param {!Array<!proto.xcommon.AttrItem>} value */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.setTicketitemList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AttrItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AttrItem}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.addTicketitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AttrItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.clearTicketitemList = function() {
  this.setTicketitemList([]);
};


/**
 * map<int32, string> CommunicationWayMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.getCommunicationwaymapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.clearCommunicationwaymapMap = function() {
  this.getCommunicationwaymapMap().clear();
};


/**
 * map<int32, string> PhoneObject = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.getPhoneobjectMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.ListUrgeDetailStatsParamResp.prototype.clearPhoneobjectMap = function() {
  this.getPhoneobjectMap().clear();
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.HourlyUrgeStatsReq.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.HourlyUrgeStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.HourlyUrgeStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.HourlyUrgeStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isreloan: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 9, ""),
    communicationway: jspb.Message.getFieldWithDefault(msg, 10, 0),
    dimensionList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.HourlyUrgeStatsReq}
 */
proto.xcommon.HourlyUrgeStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.HourlyUrgeStatsReq;
  return proto.xcommon.HourlyUrgeStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.HourlyUrgeStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.HourlyUrgeStatsReq}
 */
proto.xcommon.HourlyUrgeStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobject(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsreloan(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCommunicationway(value);
      break;
    case 11:
      var value = /** @type {!Array<!proto.xcommon.UDDimension>} */ (reader.readPackedEnum());
      msg.setDimensionList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.HourlyUrgeStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.HourlyUrgeStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.HourlyUrgeStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPhoneobject();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCommunicationway();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getDimensionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      11,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Date = 2;
 * @return {string}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 ItemID = 3;
 * @return {number}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 UserGroupId = 4;
 * @return {number}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string UserName = 5;
 * @return {string}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string PhoneObject = 7;
 * @return {string}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getPhoneobject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Bool IsReloan = 8;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getIsreloan = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string TicketStatus = 9;
 * @return {string}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setTicketstatus = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 CommunicationWay = 10;
 * @return {number}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getCommunicationway = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setCommunicationway = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * repeated UDDimension Dimension = 11;
 * @return {!Array<!proto.xcommon.UDDimension>}
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.getDimensionList = function() {
  return /** @type {!Array<!proto.xcommon.UDDimension>} */ (jspb.Message.getRepeatedField(this, 11));
};


/** @param {!Array<!proto.xcommon.UDDimension>} value */
proto.xcommon.HourlyUrgeStatsReq.prototype.setDimensionList = function(value) {
  jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {!proto.xcommon.UDDimension} value
 * @param {number=} opt_index
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.addDimension = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.HourlyUrgeStatsReq.prototype.clearDimensionList = function() {
  this.setDimensionList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.HourlyUrgeStatsResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.HourlyUrgeStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.HourlyUrgeStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.HourlyUrgeStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.HourlyUrgeStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    chartList: jspb.Message.toObjectList(msg.getChartList(),
    proto.xcommon.UrgeStatsItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.HourlyUrgeStatsResp}
 */
proto.xcommon.HourlyUrgeStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.HourlyUrgeStatsResp;
  return proto.xcommon.HourlyUrgeStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.HourlyUrgeStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.HourlyUrgeStatsResp}
 */
proto.xcommon.HourlyUrgeStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.UrgeStatsItem;
      reader.readMessage(value,proto.xcommon.UrgeStatsItem.deserializeBinaryFromReader);
      msg.addChart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.HourlyUrgeStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.HourlyUrgeStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.HourlyUrgeStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.HourlyUrgeStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getChartList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.UrgeStatsItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.HourlyUrgeStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.HourlyUrgeStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.HourlyUrgeStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.HourlyUrgeStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UrgeStatsItem Chart = 2;
 * @return {!Array<!proto.xcommon.UrgeStatsItem>}
 */
proto.xcommon.HourlyUrgeStatsResp.prototype.getChartList = function() {
  return /** @type{!Array<!proto.xcommon.UrgeStatsItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UrgeStatsItem, 2));
};


/** @param {!Array<!proto.xcommon.UrgeStatsItem>} value */
proto.xcommon.HourlyUrgeStatsResp.prototype.setChartList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.UrgeStatsItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeStatsItem}
 */
proto.xcommon.HourlyUrgeStatsResp.prototype.addChart = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.UrgeStatsItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.HourlyUrgeStatsResp.prototype.clearChartList = function() {
  this.setChartList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UrgeStatsItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UrgeStatsItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UrgeStatsItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeStatsItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    hour: jspb.Message.getFieldWithDefault(msg, 1, 0),
    answerrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    detail: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UrgeStatsItem}
 */
proto.xcommon.UrgeStatsItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UrgeStatsItem;
  return proto.xcommon.UrgeStatsItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UrgeStatsItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UrgeStatsItem}
 */
proto.xcommon.UrgeStatsItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHour(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAnswerrate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UrgeStatsItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UrgeStatsItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UrgeStatsItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeStatsItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHour();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAnswerrate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 Hour = 1;
 * @return {number}
 */
proto.xcommon.UrgeStatsItem.prototype.getHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.UrgeStatsItem.prototype.setHour = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double AnswerRate = 2;
 * @return {number}
 */
proto.xcommon.UrgeStatsItem.prototype.getAnswerrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.xcommon.UrgeStatsItem.prototype.setAnswerrate = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string Detail = 3;
 * @return {string}
 */
proto.xcommon.UrgeStatsItem.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.UrgeStatsItem.prototype.setDetail = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallOutRecordListParamsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallOutRecordListParamsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallOutRecordListParamsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallOutRecordListParamsReq}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallOutRecordListParamsReq;
  return proto.xcommon.RobotCallOutRecordListParamsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallOutRecordListParamsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallOutRecordListParamsReq}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallOutRecordListParamsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallOutRecordListParamsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallOutRecordListParamsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional PageIn PageIn = 3;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 3));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallOutRecordListParamsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallOutRecordItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallOutRecordItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallOutRecordItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallOutRecordItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    callouttime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    isdial: jspb.Message.getFieldWithDefault(msg, 2, ""),
    intentionlabel: jspb.Message.getFieldWithDefault(msg, 3, ""),
    dialoguetext: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallOutRecordItem}
 */
proto.xcommon.RobotCallOutRecordItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallOutRecordItem;
  return proto.xcommon.RobotCallOutRecordItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallOutRecordItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallOutRecordItem}
 */
proto.xcommon.RobotCallOutRecordItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallouttime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsdial(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntentionlabel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDialoguetext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallOutRecordItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallOutRecordItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallOutRecordItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallOutRecordItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCallouttime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIsdial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIntentionlabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDialoguetext();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 CallOutTime = 1;
 * @return {number}
 */
proto.xcommon.RobotCallOutRecordItem.prototype.getCallouttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.RobotCallOutRecordItem.prototype.setCallouttime = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string IsDial = 2;
 * @return {string}
 */
proto.xcommon.RobotCallOutRecordItem.prototype.getIsdial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.RobotCallOutRecordItem.prototype.setIsdial = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string IntentionLabel = 3;
 * @return {string}
 */
proto.xcommon.RobotCallOutRecordItem.prototype.getIntentionlabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.RobotCallOutRecordItem.prototype.setIntentionlabel = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string DialogueText = 4;
 * @return {string}
 */
proto.xcommon.RobotCallOutRecordItem.prototype.getDialoguetext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.RobotCallOutRecordItem.prototype.setDialoguetext = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.RobotCallOutRecordListParamsResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCallOutRecordListParamsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCallOutRecordListParamsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallOutRecordListParamsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.xcommon.RobotCallOutRecordItem.toObject, includeInstance),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCallOutRecordListParamsResp}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCallOutRecordListParamsResp;
  return proto.xcommon.RobotCallOutRecordListParamsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCallOutRecordListParamsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCallOutRecordListParamsResp}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.RobotCallOutRecordItem;
      reader.readMessage(value,proto.xcommon.RobotCallOutRecordItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 3:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCallOutRecordListParamsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCallOutRecordListParamsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCallOutRecordListParamsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.RobotCallOutRecordItem.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated RobotCallOutRecordItem Items = 2;
 * @return {!Array<!proto.xcommon.RobotCallOutRecordItem>}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.xcommon.RobotCallOutRecordItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RobotCallOutRecordItem, 2));
};


/** @param {!Array<!proto.xcommon.RobotCallOutRecordItem>} value */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.setItemsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.RobotCallOutRecordItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RobotCallOutRecordItem}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.RobotCallOutRecordItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.clearItemsList = function() {
  this.setItemsList([]);
};


/**
 * optional PageOut PageOut = 3;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 3));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCallOutRecordListParamsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PhoneVerifyReasonStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PhoneVerifyReasonStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneVerifyReasonStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    username: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    isreloan: jspb.Message.getFieldWithDefault(msg, 9, 0),
    result: jspb.Message.getFieldWithDefault(msg, 10, 0),
    resultstr: jspb.Message.getFieldWithDefault(msg, 11, ""),
    questionid: jspb.Message.getFieldWithDefault(msg, 12, 0),
    questionidstr: jspb.Message.getFieldWithDefault(msg, 13, ""),
    answerid: jspb.Message.getFieldWithDefault(msg, 14, 0),
    answeridstr: jspb.Message.getFieldWithDefault(msg, 15, ""),
    ticketitemidstr: jspb.Message.getFieldWithDefault(msg, 16, ""),
    total: jspb.Message.getFieldWithDefault(msg, 17, 0),
    isreloanstr: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PhoneVerifyReasonStat}
 */
proto.xcommon.PhoneVerifyReasonStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PhoneVerifyReasonStat;
  return proto.xcommon.PhoneVerifyReasonStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PhoneVerifyReasonStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PhoneVerifyReasonStat}
 */
proto.xcommon.PhoneVerifyReasonStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsreloan(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResult(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setResultstr(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuestionid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionidstr(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswerid(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnsweridstr(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketitemidstr(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsreloanstr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PhoneVerifyReasonStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PhoneVerifyReasonStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneVerifyReasonStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getResult();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getResultstr();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getQuestionid();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getQuestionidstr();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAnswerid();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getAnsweridstr();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTicketitemidstr();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getIsreloanstr();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Date = 2;
 * @return {string}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 AdminUID = 3;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string UserName = 4;
 * @return {string}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 TicketItemID = 5;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 Ctime = 6;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Utime = 7;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string AppName = 8;
 * @return {string}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 IsReloan = 9;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Result = 10;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getResult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setResult = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string ResultStr = 11;
 * @return {string}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getResultstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setResultstr = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 QuestionId = 12;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getQuestionid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setQuestionid = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string QuestionIdStr = 13;
 * @return {string}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getQuestionidstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setQuestionidstr = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 AnswerId = 14;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getAnswerid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setAnswerid = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string AnswerIdStr = 15;
 * @return {string}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getAnsweridstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setAnsweridstr = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string TicketItemIDStr = 16;
 * @return {string}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getTicketitemidstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setTicketitemidstr = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 Total = 17;
 * @return {number}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string IsReloanStr = 18;
 * @return {string}
 */
proto.xcommon.PhoneVerifyReasonStat.prototype.getIsreloanstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyReasonStat.prototype.setIsreloanstr = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPhoneVerifyReasonStatReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    timerange: jspb.Message.getFieldWithDefault(msg, 3, ""),
    querytype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isreloan: jspb.Message.getFieldWithDefault(msg, 5, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    isall: jspb.Message.getFieldWithDefault(msg, 8, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 9, ""),
    isexport: jspb.Message.getFieldWithDefault(msg, 10, 0),
    username: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPhoneVerifyReasonStatReq}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPhoneVerifyReasonStatReq;
  return proto.xcommon.ListPhoneVerifyReasonStatReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPhoneVerifyReasonStatReq}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuerytype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsreloan(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsall(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsexport(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPhoneVerifyReasonStatReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuerytype();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getIsall();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIsexport();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string TimeRange = 3;
 * @return {string}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 QueryType = 4;
 * @return {number}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getQuerytype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setQuerytype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 IsReloan = 5;
 * @return {number}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional TicketItemEnum ItemId = 6;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getItemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int64 AdminUid = 7;
 * @return {number}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 IsAll = 8;
 * @return {number}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getIsall = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setIsall = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string AppName = 9;
 * @return {string}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 IsExport = 10;
 * @return {number}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getIsexport = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setIsexport = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string UserName = 11;
 * @return {string}
 */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneVerifyReasonStatReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPhoneVerifyReasonStatResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.PhoneVerifyReasonStat.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPhoneVerifyReasonStatResp}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPhoneVerifyReasonStatResp;
  return proto.xcommon.ListPhoneVerifyReasonStatResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPhoneVerifyReasonStatResp}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.PhoneVerifyReasonStat;
      reader.readMessage(value,proto.xcommon.PhoneVerifyReasonStat.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPhoneVerifyReasonStatResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.PhoneVerifyReasonStat.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PhoneVerifyReasonStat List = 3;
 * @return {!Array<!proto.xcommon.PhoneVerifyReasonStat>}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneVerifyReasonStat>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PhoneVerifyReasonStat, 3));
};


/** @param {!Array<!proto.xcommon.PhoneVerifyReasonStat>} value */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.PhoneVerifyReasonStat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneVerifyReasonStat}
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.PhoneVerifyReasonStat, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListPhoneVerifyReasonStatResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPhoneVerifyStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPhoneVerifyStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneVerifyStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    statstype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    timerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    hour: jspb.Message.getFieldWithDefault(msg, 9, 0),
    isall: jspb.Message.getFieldWithDefault(msg, 10, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    isreloan: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPhoneVerifyStatsReq}
 */
proto.xcommon.ListPhoneVerifyStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPhoneVerifyStatsReq;
  return proto.xcommon.ListPhoneVerifyStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPhoneVerifyStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPhoneVerifyStatsReq}
 */
proto.xcommon.ListPhoneVerifyStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.StatsType} */ (reader.readEnum());
      msg.setStatstype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setItemid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHour(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsall(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsreloan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPhoneVerifyStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPhoneVerifyStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneVerifyStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getStatstype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHour();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getIsall();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getIsreloan();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StatsType StatsType = 3;
 * @return {!proto.xcommon.StatsType}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getStatstype = function() {
  return /** @type {!proto.xcommon.StatsType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.StatsType} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setStatstype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string Email = 4;
 * @return {string}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UserName = 5;
 * @return {string}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 UserGroupId = 6;
 * @return {number}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional TicketItemEnum ItemId = 7;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getItemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string TimeRange = 8;
 * @return {string}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 Hour = 9;
 * @return {number}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setHour = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 IsAll = 10;
 * @return {number}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getIsall = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setIsall = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string AppName = 11;
 * @return {string}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string IsReLoan = 12;
 * @return {string}
 */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.getIsreloan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneVerifyStatsReq.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListPhoneVerifyStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPhoneVerifyStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPhoneVerifyStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneVerifyStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.PhoneVerifyStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPhoneVerifyStatsResp}
 */
proto.xcommon.ListPhoneVerifyStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPhoneVerifyStatsResp;
  return proto.xcommon.ListPhoneVerifyStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPhoneVerifyStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPhoneVerifyStatsResp}
 */
proto.xcommon.ListPhoneVerifyStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.PhoneVerifyStats;
      reader.readMessage(value,proto.xcommon.PhoneVerifyStats.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPhoneVerifyStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPhoneVerifyStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneVerifyStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.PhoneVerifyStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PhoneVerifyStats List = 3;
 * @return {!Array<!proto.xcommon.PhoneVerifyStats>}
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneVerifyStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PhoneVerifyStats, 3));
};


/** @param {!Array<!proto.xcommon.PhoneVerifyStats>} value */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.PhoneVerifyStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneVerifyStats}
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.PhoneVerifyStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListPhoneVerifyStatsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CreateQualityInspectionVoipReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CreateQualityInspectionVoipReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreateQualityInspectionVoipReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    relatedid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CreateQualityInspectionVoipReq}
 */
proto.xcommon.CreateQualityInspectionVoipReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CreateQualityInspectionVoipReq;
  return proto.xcommon.CreateQualityInspectionVoipReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CreateQualityInspectionVoipReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CreateQualityInspectionVoipReq}
 */
proto.xcommon.CreateQualityInspectionVoipReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setRelatedid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CreateQualityInspectionVoipReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CreateQualityInspectionVoipReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreateQualityInspectionVoipReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getRelatedid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 RelatedId = 2;
 * @return {string}
 */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.getRelatedid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.setRelatedid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CreateQualityInspectionVoipReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVoipQITicketListReq.repeatedFields_ = [15,26];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVoipQITicketListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVoipQITicketListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQITicketListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    caseid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    createtimerange: jspb.Message.getFieldWithDefault(msg, 7, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    closetimerange: jspb.Message.getFieldWithDefault(msg, 9, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 10, ""),
    status: jspb.Message.getFieldWithDefault(msg, 11, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 12, ""),
    assignuid: jspb.Message.getFieldWithDefault(msg, 13, 0),
    result: jspb.Message.getFieldWithDefault(msg, 14, 0),
    roleidsList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
    rolename: jspb.Message.getFieldWithDefault(msg, 16, ""),
    callrecordid: jspb.Message.getFieldWithDefault(msg, 17, "0"),
    collectionuid: jspb.Message.getFieldWithDefault(msg, 18, 0),
    collectionname: jspb.Message.getFieldWithDefault(msg, 19, ""),
    aitimerange: jspb.Message.getFieldWithDefault(msg, 20, ""),
    aiscorerange: jspb.Message.getFieldWithDefault(msg, 21, ""),
    humantimerange: jspb.Message.getFieldWithDefault(msg, 22, ""),
    humanscorerange: jspb.Message.getFieldWithDefault(msg, 23, ""),
    aistatus: jspb.Message.getFieldWithDefault(msg, 24, 0),
    starttimerange: jspb.Message.getFieldWithDefault(msg, 25, ""),
    audioidsList: (f = jspb.Message.getRepeatedField(msg, 26)) == null ? undefined : f,
    finalscorerange: jspb.Message.getFieldWithDefault(msg, 27, ""),
    durationrange: jspb.Message.getFieldWithDefault(msg, 28, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVoipQITicketListReq}
 */
proto.xcommon.GetVoipQITicketListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVoipQITicketListReq;
  return proto.xcommon.GetVoipQITicketListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVoipQITicketListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVoipQITicketListReq}
 */
proto.xcommon.GetVoipQITicketListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosetimerange(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResult(value);
      break;
    case 15:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setRoleidsList(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRolename(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCallrecordid(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCollectionuid(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionname(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setAitimerange(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setAiscorerange(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setHumantimerange(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setHumanscorerange(value);
      break;
    case 24:
      var value = /** @type {!proto.xcommon.AiStatusEnum} */ (reader.readEnum());
      msg.setAistatus(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttimerange(value);
      break;
    case 26:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setAudioidsList(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinalscorerange(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setDurationrange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVoipQITicketListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVoipQITicketListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQITicketListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getClosetimerange();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getResult();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getRoleidsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      15,
      f
    );
  }
  f = message.getRolename();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCallrecordid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      17,
      f
    );
  }
  f = message.getCollectionuid();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getCollectionname();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getAitimerange();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getAiscorerange();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getHumantimerange();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getHumanscorerange();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getAistatus();
  if (f !== 0.0) {
    writer.writeEnum(
      24,
      f
    );
  }
  f = message.getStarttimerange();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getAudioidsList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      26,
      f
    );
  }
  f = message.getFinalscorerange();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getDurationrange();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVoipQITicketListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVoipQITicketListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 TicketId = 3;
 * @return {number}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 CaseId = 4;
 * @return {number}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 ItemId = 5;
 * @return {number}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 OrderId = 6;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional string CreateTimeRange = 7;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setCreatetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string CompleteTimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setCompletetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string CloseTimeRange = 9;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getClosetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setClosetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string AssignTimeRange = 10;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setAssigntimerange = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Status = 11;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string AssignName = 12;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 AssignUID = 13;
 * @return {number}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 Result = 14;
 * @return {number}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getResult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setResult = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * repeated int64 RoleIDs = 15;
 * @return {!Array<number>}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getRoleidsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 15));
};


/** @param {!Array<number>} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setRoleidsList = function(value) {
  jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetVoipQITicketListReq.prototype.addRoleids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetVoipQITicketListReq.prototype.clearRoleidsList = function() {
  this.setRoleidsList([]);
};


/**
 * optional string RoleName = 16;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getRolename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setRolename = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 CallRecordId = 17;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getCallrecordid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, "0"));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setCallrecordid = function(value) {
  jspb.Message.setProto3StringIntField(this, 17, value);
};


/**
 * optional int64 CollectionUid = 18;
 * @return {number}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getCollectionuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setCollectionuid = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string CollectionName = 19;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getCollectionname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setCollectionname = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string AiTimeRange = 20;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getAitimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setAitimerange = function(value) {
  jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string AiScoreRange = 21;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getAiscorerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setAiscorerange = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string HumanTimeRange = 22;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getHumantimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setHumantimerange = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string HumanScoreRange = 23;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getHumanscorerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setHumanscorerange = function(value) {
  jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional AiStatusEnum AiStatus = 24;
 * @return {!proto.xcommon.AiStatusEnum}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getAistatus = function() {
  return /** @type {!proto.xcommon.AiStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {!proto.xcommon.AiStatusEnum} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setAistatus = function(value) {
  jspb.Message.setProto3EnumField(this, 24, value);
};


/**
 * optional string StartTimeRange = 25;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getStarttimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setStarttimerange = function(value) {
  jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * repeated int64 AudioIds = 26;
 * @return {!Array<string>}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getAudioidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 26));
};


/** @param {!Array<string>} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setAudioidsList = function(value) {
  jspb.Message.setField(this, 26, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.GetVoipQITicketListReq.prototype.addAudioids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 26, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetVoipQITicketListReq.prototype.clearAudioidsList = function() {
  this.setAudioidsList([]);
};


/**
 * optional string FinalScoreRange = 27;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getFinalscorerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setFinalscorerange = function(value) {
  jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string DurationRange = 28;
 * @return {string}
 */
proto.xcommon.GetVoipQITicketListReq.prototype.getDurationrange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.xcommon.GetVoipQITicketListReq.prototype.setDurationrange = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVoipQITicketListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVoipQITicketListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVoipQITicketListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVoipQITicketListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQITicketListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.VoipQITicketBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVoipQITicketListResp}
 */
proto.xcommon.GetVoipQITicketListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVoipQITicketListResp;
  return proto.xcommon.GetVoipQITicketListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVoipQITicketListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVoipQITicketListResp}
 */
proto.xcommon.GetVoipQITicketListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.VoipQITicketBackend;
      reader.readMessage(value,proto.xcommon.VoipQITicketBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVoipQITicketListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVoipQITicketListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVoipQITicketListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQITicketListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.VoipQITicketBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetVoipQITicketListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetVoipQITicketListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVoipQITicketListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQITicketListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetVoipQITicketListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetVoipQITicketListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetVoipQITicketListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQITicketListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated VoipQITicketBackend List = 3;
 * @return {!Array<!proto.xcommon.VoipQITicketBackend>}
 */
proto.xcommon.GetVoipQITicketListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.VoipQITicketBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.VoipQITicketBackend, 3));
};


/** @param {!Array<!proto.xcommon.VoipQITicketBackend>} value */
proto.xcommon.GetVoipQITicketListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.VoipQITicketBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.VoipQITicketBackend}
 */
proto.xcommon.GetVoipQITicketListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.VoipQITicketBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetVoipQITicketListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.VoipQITicketBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.VoipQITicketBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.VoipQITicketBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VoipQITicketBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && proto.xcommon.Ticket.toObject(includeInstance, f),
    collectionname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 4, ""),
    result: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isstatusdone: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    audioid: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    caselevel: jspb.Message.getFieldWithDefault(msg, 8, ""),
    aistatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
    aiscore: jspb.Message.getFieldWithDefault(msg, 10, 0),
    aitime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    humanscore: jspb.Message.getFieldWithDefault(msg, 12, 0),
    humantime: jspb.Message.getFieldWithDefault(msg, 13, 0),
    finalscore: jspb.Message.getFieldWithDefault(msg, 14, 0),
    duration: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.VoipQITicketBackend}
 */
proto.xcommon.VoipQITicketBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.VoipQITicketBackend;
  return proto.xcommon.VoipQITicketBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.VoipQITicketBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.VoipQITicketBackend}
 */
proto.xcommon.VoipQITicketBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.Ticket;
      reader.readMessage(value,proto.xcommon.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsstatusdone(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAudioid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.AiStatusEnum} */ (reader.readEnum());
      msg.setAistatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiscore(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAitime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHumanscore(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHumantime(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFinalscore(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.VoipQITicketBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.VoipQITicketBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.VoipQITicketBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VoipQITicketBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getCollectionname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsstatusdone();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAudioid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      7,
      f
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAistatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getAiscore();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getAitime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getHumanscore();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getHumantime();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getFinalscore();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.VoipQITicketBackend.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Ticket, 1));
};


/** @param {?proto.xcommon.Ticket|undefined} value */
proto.xcommon.VoipQITicketBackend.prototype.setTicket = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.VoipQITicketBackend.prototype.clearTicket = function() {
  this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.VoipQITicketBackend.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string CollectionName = 2;
 * @return {string}
 */
proto.xcommon.VoipQITicketBackend.prototype.getCollectionname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.VoipQITicketBackend.prototype.setCollectionname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AssignName = 3;
 * @return {string}
 */
proto.xcommon.VoipQITicketBackend.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.VoipQITicketBackend.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TicketStatus = 4;
 * @return {string}
 */
proto.xcommon.VoipQITicketBackend.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.VoipQITicketBackend.prototype.setTicketstatus = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Result = 5;
 * @return {string}
 */
proto.xcommon.VoipQITicketBackend.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.VoipQITicketBackend.prototype.setResult = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool IsStatusDone = 6;
 * @return {boolean}
 */
proto.xcommon.VoipQITicketBackend.prototype.getIsstatusdone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.xcommon.VoipQITicketBackend.prototype.setIsstatusdone = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int64 AudioId = 7;
 * @return {string}
 */
proto.xcommon.VoipQITicketBackend.prototype.getAudioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/** @param {string} value */
proto.xcommon.VoipQITicketBackend.prototype.setAudioid = function(value) {
  jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional string CaseLevel = 8;
 * @return {string}
 */
proto.xcommon.VoipQITicketBackend.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.VoipQITicketBackend.prototype.setCaselevel = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional AiStatusEnum AiStatus = 9;
 * @return {!proto.xcommon.AiStatusEnum}
 */
proto.xcommon.VoipQITicketBackend.prototype.getAistatus = function() {
  return /** @type {!proto.xcommon.AiStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.AiStatusEnum} value */
proto.xcommon.VoipQITicketBackend.prototype.setAistatus = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional int32 AiScore = 10;
 * @return {number}
 */
proto.xcommon.VoipQITicketBackend.prototype.getAiscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.VoipQITicketBackend.prototype.setAiscore = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 AiTime = 11;
 * @return {number}
 */
proto.xcommon.VoipQITicketBackend.prototype.getAitime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.VoipQITicketBackend.prototype.setAitime = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 HumanScore = 12;
 * @return {number}
 */
proto.xcommon.VoipQITicketBackend.prototype.getHumanscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.VoipQITicketBackend.prototype.setHumanscore = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 HumanTime = 13;
 * @return {number}
 */
proto.xcommon.VoipQITicketBackend.prototype.getHumantime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.VoipQITicketBackend.prototype.setHumantime = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 FinalScore = 14;
 * @return {number}
 */
proto.xcommon.VoipQITicketBackend.prototype.getFinalscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.VoipQITicketBackend.prototype.setFinalscore = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 Duration = 15;
 * @return {number}
 */
proto.xcommon.VoipQITicketBackend.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.VoipQITicketBackend.prototype.setDuration = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.QualityReport.repeatedFields_ = [5,6,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.QualityReport.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.QualityReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.QualityReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QualityReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sentence: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ruleid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rulename: jspb.Message.getFieldWithDefault(msg, 4, ""),
    hitscriptidList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    hitwordList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    qualitykind: jspb.Message.getFieldWithDefault(msg, 7, 0),
    username: jspb.Message.getFieldWithDefault(msg, 8, ""),
    score: jspb.Message.getFieldWithDefault(msg, 9, 0),
    status: jspb.Message.getFieldWithDefault(msg, 10, 0),
    desc: jspb.Message.getFieldWithDefault(msg, 11, ""),
    contentmark: jspb.Message.getFieldWithDefault(msg, 12, ""),
    simlistList: jspb.Message.toObjectList(msg.getSimlistList(),
    proto.xcommon.SimInfo.toObject, includeInstance),
    discardreason: jspb.Message.getFieldWithDefault(msg, 14, 0),
    remark: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.QualityReport}
 */
proto.xcommon.QualityReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.QualityReport;
  return proto.xcommon.QualityReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.QualityReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.QualityReport}
 */
proto.xcommon.QualityReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSentence(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRuleid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRulename(value);
      break;
    case 5:
      var value = /** @type {!Array<string>} */ (reader.readPackedInt64String());
      msg.setHitscriptidList(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addHitword(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.QualityKindEnum} */ (reader.readEnum());
      msg.setQualitykind(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentmark(value);
      break;
    case 13:
      var value = new proto.xcommon.SimInfo;
      reader.readMessage(value,proto.xcommon.SimInfo.deserializeBinaryFromReader);
      msg.addSimlist(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscardreason(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.QualityReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.QualityReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.QualityReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.QualityReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSentence();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRuleid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRulename();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHitscriptidList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      5,
      f
    );
  }
  f = message.getHitwordList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getQualitykind();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getContentmark();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSimlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.xcommon.SimInfo.serializeBinaryToWriter
    );
  }
  f = message.getDiscardreason();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.QualityReport.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.QualityReport.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Sentence = 2;
 * @return {number}
 */
proto.xcommon.QualityReport.prototype.getSentence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.QualityReport.prototype.setSentence = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 RuleId = 3;
 * @return {number}
 */
proto.xcommon.QualityReport.prototype.getRuleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.QualityReport.prototype.setRuleid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string RuleName = 4;
 * @return {string}
 */
proto.xcommon.QualityReport.prototype.getRulename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.QualityReport.prototype.setRulename = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated int64 HitScriptId = 5;
 * @return {!Array<string>}
 */
proto.xcommon.QualityReport.prototype.getHitscriptidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/** @param {!Array<string>} value */
proto.xcommon.QualityReport.prototype.setHitscriptidList = function(value) {
  jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.QualityReport.prototype.addHitscriptid = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.QualityReport.prototype.clearHitscriptidList = function() {
  this.setHitscriptidList([]);
};


/**
 * repeated string HitWord = 6;
 * @return {!Array<string>}
 */
proto.xcommon.QualityReport.prototype.getHitwordList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.xcommon.QualityReport.prototype.setHitwordList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.QualityReport.prototype.addHitword = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.QualityReport.prototype.clearHitwordList = function() {
  this.setHitwordList([]);
};


/**
 * optional QualityKindEnum QualityKind = 7;
 * @return {!proto.xcommon.QualityKindEnum}
 */
proto.xcommon.QualityReport.prototype.getQualitykind = function() {
  return /** @type {!proto.xcommon.QualityKindEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.xcommon.QualityKindEnum} value */
proto.xcommon.QualityReport.prototype.setQualitykind = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string UserName = 8;
 * @return {string}
 */
proto.xcommon.QualityReport.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.QualityReport.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 Score = 9;
 * @return {number}
 */
proto.xcommon.QualityReport.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.QualityReport.prototype.setScore = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional CommonStatus Status = 10;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.QualityReport.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.QualityReport.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string Desc = 11;
 * @return {string}
 */
proto.xcommon.QualityReport.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.QualityReport.prototype.setDesc = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string ContentMark = 12;
 * @return {string}
 */
proto.xcommon.QualityReport.prototype.getContentmark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.QualityReport.prototype.setContentmark = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated SimInfo SimList = 13;
 * @return {!Array<!proto.xcommon.SimInfo>}
 */
proto.xcommon.QualityReport.prototype.getSimlistList = function() {
  return /** @type{!Array<!proto.xcommon.SimInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SimInfo, 13));
};


/** @param {!Array<!proto.xcommon.SimInfo>} value */
proto.xcommon.QualityReport.prototype.setSimlistList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.xcommon.SimInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SimInfo}
 */
proto.xcommon.QualityReport.prototype.addSimlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.xcommon.SimInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.QualityReport.prototype.clearSimlistList = function() {
  this.setSimlistList([]);
};


/**
 * optional int32 DiscardReason = 14;
 * @return {number}
 */
proto.xcommon.QualityReport.prototype.getDiscardreason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.QualityReport.prototype.setDiscardreason = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string remark = 15;
 * @return {string}
 */
proto.xcommon.QualityReport.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.QualityReport.prototype.setRemark = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SimInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SimInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SimInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SimInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    simtext: jspb.Message.getFieldWithDefault(msg, 2, ""),
    confidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SimInfo}
 */
proto.xcommon.SimInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SimInfo;
  return proto.xcommon.SimInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SimInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SimInfo}
 */
proto.xcommon.SimInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSimtext(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setConfidence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SimInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SimInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SimInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SimInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSimtext();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional string Label = 1;
 * @return {string}
 */
proto.xcommon.SimInfo.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.SimInfo.prototype.setLabel = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string SimText = 2;
 * @return {string}
 */
proto.xcommon.SimInfo.prototype.getSimtext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SimInfo.prototype.setSimtext = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional float Confidence = 3;
 * @return {number}
 */
proto.xcommon.SimInfo.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/** @param {number} value */
proto.xcommon.SimInfo.prototype.setConfidence = function(value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PhoneVerifyStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PhoneVerifyStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PhoneVerifyStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneVerifyStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    logincount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    casename: jspb.Message.getFieldWithDefault(msg, 9, ""),
    assignnum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 11, 0),
    passnum: jspb.Message.getFieldWithDefault(msg, 12, 0),
    invalidnum: jspb.Message.getFieldWithDefault(msg, 13, 0),
    rejectnum: jspb.Message.getFieldWithDefault(msg, 14, 0),
    inspectionnum: jspb.Message.getFieldWithDefault(msg, 15, 0),
    inspectionpassnum: jspb.Message.getFieldWithDefault(msg, 16, 0),
    inspectionrejectnum: jspb.Message.getFieldWithDefault(msg, 17, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 18, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 19, 0),
    passrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    invalidrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
    rejectrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
    appname: jspb.Message.getFieldWithDefault(msg, 23, ""),
    uncomplete: jspb.Message.getFieldWithDefault(msg, 24, 0),
    isreloan: jspb.Message.getFieldWithDefault(msg, 25, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PhoneVerifyStats}
 */
proto.xcommon.PhoneVerifyStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PhoneVerifyStats;
  return proto.xcommon.PhoneVerifyStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PhoneVerifyStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PhoneVerifyStats}
 */
proto.xcommon.PhoneVerifyStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLogincount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignnum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPassnum(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvalidnum(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRejectnum(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInspectionnum(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInspectionpassnum(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInspectionrejectnum(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPassrate(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInvalidrate(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRejectrate(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUncomplete(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsreloan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PhoneVerifyStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PhoneVerifyStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PhoneVerifyStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneVerifyStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLogincount();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAssignnum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getPassnum();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getInvalidnum();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getRejectnum();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getInspectionnum();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getInspectionpassnum();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getInspectionrejectnum();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getPassrate();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getInvalidrate();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getRejectrate();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getUncomplete();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Date = 2;
 * @return {string}
 */
proto.xcommon.PhoneVerifyStats.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyStats.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 AdminUID = 3;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string EmployeeID = 4;
 * @return {string}
 */
proto.xcommon.PhoneVerifyStats.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyStats.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UserName = 5;
 * @return {string}
 */
proto.xcommon.PhoneVerifyStats.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyStats.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string UserGroupName = 6;
 * @return {string}
 */
proto.xcommon.PhoneVerifyStats.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyStats.prototype.setUsergroupname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 LoginCount = 7;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getLogincount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setLogincount = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 TicketItemID = 8;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string CaseName = 9;
 * @return {string}
 */
proto.xcommon.PhoneVerifyStats.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyStats.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 AssignNum = 10;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getAssignnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setAssignnum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 CompleteNum = 11;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 PassNum = 12;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getPassnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setPassnum = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 InvalidNum = 13;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getInvalidnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setInvalidnum = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 RejectNum = 14;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getRejectnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setRejectnum = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 InspectionNum = 15;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getInspectionnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setInspectionnum = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 InspectionPassNum = 16;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getInspectionpassnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setInspectionpassnum = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 InspectionRejectNum = 17;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getInspectionrejectnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setInspectionrejectnum = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 Ctime = 18;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 Utime = 19;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional double PassRate = 20;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getPassrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setPassrate = function(value) {
  jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional double InvalidRate = 21;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getInvalidrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setInvalidrate = function(value) {
  jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional double RejectRate = 22;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getRejectrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setRejectrate = function(value) {
  jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional string AppName = 23;
 * @return {string}
 */
proto.xcommon.PhoneVerifyStats.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/** @param {string} value */
proto.xcommon.PhoneVerifyStats.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional int64 UnComplete = 24;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getUncomplete = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setUncomplete = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 IsReloan = 25;
 * @return {number}
 */
proto.xcommon.PhoneVerifyStats.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.xcommon.PhoneVerifyStats.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PVDashboardReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PVDashboardReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PVDashboardReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVDashboardReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PVDashboardReq}
 */
proto.xcommon.PVDashboardReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PVDashboardReq;
  return proto.xcommon.PVDashboardReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PVDashboardReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PVDashboardReq}
 */
proto.xcommon.PVDashboardReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PVDashboardReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PVDashboardReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PVDashboardReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVDashboardReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.PVDashboardReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.PVDashboardReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PVDashboardReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PVDashboardReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.xcommon.PVDashboardReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.PVDashboardReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PVDashboardResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PVDashboardResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PVDashboardResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVDashboardResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    roletype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pvmetrics: (f = msg.getPvmetrics()) && proto.xcommon.PVMetrics.toObject(includeInstance, f),
    updatetime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    leaderpvmetrics: (f = msg.getLeaderpvmetrics()) && proto.xcommon.LeaderPVMetrics.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PVDashboardResp}
 */
proto.xcommon.PVDashboardResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PVDashboardResp;
  return proto.xcommon.PVDashboardResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PVDashboardResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PVDashboardResp}
 */
proto.xcommon.PVDashboardResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoletype(value);
      break;
    case 3:
      var value = new proto.xcommon.PVMetrics;
      reader.readMessage(value,proto.xcommon.PVMetrics.deserializeBinaryFromReader);
      msg.setPvmetrics(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    case 5:
      var value = new proto.xcommon.LeaderPVMetrics;
      reader.readMessage(value,proto.xcommon.LeaderPVMetrics.deserializeBinaryFromReader);
      msg.setLeaderpvmetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PVDashboardResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PVDashboardResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PVDashboardResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVDashboardResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getRoletype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPvmetrics();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.PVMetrics.serializeBinaryToWriter
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLeaderpvmetrics();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.LeaderPVMetrics.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.PVDashboardResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.PVDashboardResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PVDashboardResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PVDashboardResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 RoleType = 2;
 * @return {number}
 */
proto.xcommon.PVDashboardResp.prototype.getRoletype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.PVDashboardResp.prototype.setRoletype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional PVMetrics PVMetrics = 3;
 * @return {?proto.xcommon.PVMetrics}
 */
proto.xcommon.PVDashboardResp.prototype.getPvmetrics = function() {
  return /** @type{?proto.xcommon.PVMetrics} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.PVMetrics, 3));
};


/** @param {?proto.xcommon.PVMetrics|undefined} value */
proto.xcommon.PVDashboardResp.prototype.setPvmetrics = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PVDashboardResp.prototype.clearPvmetrics = function() {
  this.setPvmetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PVDashboardResp.prototype.hasPvmetrics = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 UpdateTime = 4;
 * @return {number}
 */
proto.xcommon.PVDashboardResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.PVDashboardResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional LeaderPVMetrics LeaderPVMetrics = 5;
 * @return {?proto.xcommon.LeaderPVMetrics}
 */
proto.xcommon.PVDashboardResp.prototype.getLeaderpvmetrics = function() {
  return /** @type{?proto.xcommon.LeaderPVMetrics} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPVMetrics, 5));
};


/** @param {?proto.xcommon.LeaderPVMetrics|undefined} value */
proto.xcommon.PVDashboardResp.prototype.setLeaderpvmetrics = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PVDashboardResp.prototype.clearLeaderpvmetrics = function() {
  this.setLeaderpvmetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PVDashboardResp.prototype.hasLeaderpvmetrics = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PVGroupStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PVGroupStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PVGroupStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVGroupStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PVGroupStatsReq}
 */
proto.xcommon.PVGroupStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PVGroupStatsReq;
  return proto.xcommon.PVGroupStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PVGroupStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PVGroupStatsReq}
 */
proto.xcommon.PVGroupStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PVGroupStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PVGroupStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PVGroupStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVGroupStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.PVGroupStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.PVGroupStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PVGroupStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PVGroupStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TicketItemEnum ItemId = 2;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.PVGroupStatsReq.prototype.getItemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.PVGroupStatsReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 UserId = 3;
 * @return {number}
 */
proto.xcommon.PVGroupStatsReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PVGroupStatsReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.PVGroupStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PVGroupStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PVGroupStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PVGroupStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVGroupStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    roletype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    staffstatsList: jspb.Message.toObjectList(msg.getStaffstatsList(),
    proto.xcommon.SimplePVStats.toObject, includeInstance),
    order: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PVGroupStatsResp}
 */
proto.xcommon.PVGroupStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PVGroupStatsResp;
  return proto.xcommon.PVGroupStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PVGroupStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PVGroupStatsResp}
 */
proto.xcommon.PVGroupStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoletype(value);
      break;
    case 3:
      var value = new proto.xcommon.SimplePVStats;
      reader.readMessage(value,proto.xcommon.SimplePVStats.deserializeBinaryFromReader);
      msg.addStaffstats(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PVGroupStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PVGroupStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PVGroupStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVGroupStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getRoletype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStaffstatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.SimplePVStats.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.PVGroupStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.PVGroupStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PVGroupStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PVGroupStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 RoleType = 2;
 * @return {number}
 */
proto.xcommon.PVGroupStatsResp.prototype.getRoletype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.PVGroupStatsResp.prototype.setRoletype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated SimplePVStats StaffStats = 3;
 * @return {!Array<!proto.xcommon.SimplePVStats>}
 */
proto.xcommon.PVGroupStatsResp.prototype.getStaffstatsList = function() {
  return /** @type{!Array<!proto.xcommon.SimplePVStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SimplePVStats, 3));
};


/** @param {!Array<!proto.xcommon.SimplePVStats>} value */
proto.xcommon.PVGroupStatsResp.prototype.setStaffstatsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.SimplePVStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SimplePVStats}
 */
proto.xcommon.PVGroupStatsResp.prototype.addStaffstats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.SimplePVStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.PVGroupStatsResp.prototype.clearStaffstatsList = function() {
  this.setStaffstatsList([]);
};


/**
 * optional int64 Order = 4;
 * @return {number}
 */
proto.xcommon.PVGroupStatsResp.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.PVGroupStatsResp.prototype.setOrder = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PVMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PVMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PVMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketnum: jspb.Message.getFieldWithDefault(msg, 1, 0),
    assignnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 3, 0),
    passnum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    passrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    invalidnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    invalidrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    rejectnum: jspb.Message.getFieldWithDefault(msg, 8, 0),
    rejectrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    inspectionpassnum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    inspectionpassrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    avghandletime: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PVMetrics}
 */
proto.xcommon.PVMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PVMetrics;
  return proto.xcommon.PVMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PVMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PVMetrics}
 */
proto.xcommon.PVMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketnum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignnum(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPassnum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPassrate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvalidnum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInvalidrate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRejectnum(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRejectrate(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInspectionpassnum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInspectionpassrate(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvghandletime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PVMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PVMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PVMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PVMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketnum();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAssignnum();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPassnum();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPassrate();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getInvalidnum();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getInvalidrate();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getRejectnum();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getRejectrate();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getInspectionpassnum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getInspectionpassrate();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getAvghandletime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
};


/**
 * optional int64 TicketNum = 1;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getTicketnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setTicketnum = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 AssignNum = 2;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getAssignnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setAssignnum = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 CompleteNum = 3;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 PassNum = 4;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getPassnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setPassnum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double PassRate = 5;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getPassrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setPassrate = function(value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 InvalidNum = 6;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getInvalidnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setInvalidnum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double InvalidRate = 7;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getInvalidrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setInvalidrate = function(value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional int64 RejectNum = 8;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getRejectnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setRejectnum = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double RejectRate = 9;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getRejectrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setRejectrate = function(value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional int64 InspectionPassNum = 10;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getInspectionpassnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setInspectionpassnum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double InspectionPassRate = 11;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getInspectionpassrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setInspectionpassrate = function(value) {
  jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional int64 AvgHandleTime = 12;
 * @return {number}
 */
proto.xcommon.PVMetrics.prototype.getAvghandletime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.PVMetrics.prototype.setAvghandletime = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPVMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPVMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPVMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketnum: (f = msg.getTicketnum()) && proto.xcommon.LeaderPVMetrics.TicketNumStat.toObject(includeInstance, f),
    assignnum: (f = msg.getAssignnum()) && proto.xcommon.LeaderPVMetrics.AssignNumStat.toObject(includeInstance, f),
    completenum: (f = msg.getCompletenum()) && proto.xcommon.LeaderPVMetrics.CompleteNumStat.toObject(includeInstance, f),
    passnum: (f = msg.getPassnum()) && proto.xcommon.LeaderPVMetrics.PassNumStat.toObject(includeInstance, f),
    invalidnum: (f = msg.getInvalidnum()) && proto.xcommon.LeaderPVMetrics.InvalidNumStat.toObject(includeInstance, f),
    rejectnum: (f = msg.getRejectnum()) && proto.xcommon.LeaderPVMetrics.RejectNumStat.toObject(includeInstance, f),
    inspectionpassnum: (f = msg.getInspectionpassnum()) && proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.toObject(includeInstance, f),
    avghandletime: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPVMetrics}
 */
proto.xcommon.LeaderPVMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPVMetrics;
  return proto.xcommon.LeaderPVMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPVMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPVMetrics}
 */
proto.xcommon.LeaderPVMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.LeaderPVMetrics.TicketNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPVMetrics.TicketNumStat.deserializeBinaryFromReader);
      msg.setTicketnum(value);
      break;
    case 2:
      var value = new proto.xcommon.LeaderPVMetrics.AssignNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPVMetrics.AssignNumStat.deserializeBinaryFromReader);
      msg.setAssignnum(value);
      break;
    case 3:
      var value = new proto.xcommon.LeaderPVMetrics.CompleteNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPVMetrics.CompleteNumStat.deserializeBinaryFromReader);
      msg.setCompletenum(value);
      break;
    case 4:
      var value = new proto.xcommon.LeaderPVMetrics.PassNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPVMetrics.PassNumStat.deserializeBinaryFromReader);
      msg.setPassnum(value);
      break;
    case 5:
      var value = new proto.xcommon.LeaderPVMetrics.InvalidNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPVMetrics.InvalidNumStat.deserializeBinaryFromReader);
      msg.setInvalidnum(value);
      break;
    case 6:
      var value = new proto.xcommon.LeaderPVMetrics.RejectNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPVMetrics.RejectNumStat.deserializeBinaryFromReader);
      msg.setRejectnum(value);
      break;
    case 7:
      var value = new proto.xcommon.LeaderPVMetrics.InspectionPassNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.deserializeBinaryFromReader);
      msg.setInspectionpassnum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvghandletime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPVMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPVMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPVMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketnum();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.LeaderPVMetrics.TicketNumStat.serializeBinaryToWriter
    );
  }
  f = message.getAssignnum();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.LeaderPVMetrics.AssignNumStat.serializeBinaryToWriter
    );
  }
  f = message.getCompletenum();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.LeaderPVMetrics.CompleteNumStat.serializeBinaryToWriter
    );
  }
  f = message.getPassnum();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.LeaderPVMetrics.PassNumStat.serializeBinaryToWriter
    );
  }
  f = message.getInvalidnum();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.LeaderPVMetrics.InvalidNumStat.serializeBinaryToWriter
    );
  }
  f = message.getRejectnum();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.xcommon.LeaderPVMetrics.RejectNumStat.serializeBinaryToWriter
    );
  }
  f = message.getInspectionpassnum();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.serializeBinaryToWriter
    );
  }
  f = message.getAvghandletime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPVMetrics.TicketNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPVMetrics.TicketNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pv: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ir: jspb.Message.getFieldWithDefault(msg, 2, 0),
    qi: jspb.Message.getFieldWithDefault(msg, 3, 0),
    num: jspb.Message.getFieldWithDefault(msg, 4, 0),
    cpv: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPVMetrics.TicketNumStat}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPVMetrics.TicketNumStat;
  return proto.xcommon.LeaderPVMetrics.TicketNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPVMetrics.TicketNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPVMetrics.TicketNumStat}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPv(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIr(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQi(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCpv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPVMetrics.TicketNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPVMetrics.TicketNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPv();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIr();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getQi();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCpv();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 PV = 1;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.getPv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.setPv = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 IR = 2;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.getIr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.setIr = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 QI = 3;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.getQi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.setQi = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Num = 4;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 CPV = 5;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.getCpv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.TicketNumStat.prototype.setCpv = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPVMetrics.AssignNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPVMetrics.AssignNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pv: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ir: jspb.Message.getFieldWithDefault(msg, 2, 0),
    qi: jspb.Message.getFieldWithDefault(msg, 3, 0),
    num: jspb.Message.getFieldWithDefault(msg, 4, 0),
    cpv: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPVMetrics.AssignNumStat}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPVMetrics.AssignNumStat;
  return proto.xcommon.LeaderPVMetrics.AssignNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPVMetrics.AssignNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPVMetrics.AssignNumStat}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPv(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIr(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQi(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCpv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPVMetrics.AssignNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPVMetrics.AssignNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPv();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIr();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getQi();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCpv();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 PV = 1;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.getPv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.setPv = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 IR = 2;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.getIr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.setIr = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 QI = 3;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.getQi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.setQi = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Num = 4;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 CPV = 5;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.getCpv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.AssignNumStat.prototype.setCpv = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPVMetrics.CompleteNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPVMetrics.CompleteNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pv: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ir: jspb.Message.getFieldWithDefault(msg, 2, 0),
    qi: jspb.Message.getFieldWithDefault(msg, 3, 0),
    num: jspb.Message.getFieldWithDefault(msg, 4, 0),
    cpv: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPVMetrics.CompleteNumStat}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPVMetrics.CompleteNumStat;
  return proto.xcommon.LeaderPVMetrics.CompleteNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPVMetrics.CompleteNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPVMetrics.CompleteNumStat}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPv(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIr(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQi(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCpv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPVMetrics.CompleteNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPVMetrics.CompleteNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPv();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIr();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getQi();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCpv();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 PV = 1;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.getPv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.setPv = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 IR = 2;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.getIr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.setIr = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 QI = 3;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.getQi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.setQi = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Num = 4;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 CPV = 5;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.getCpv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.CompleteNumStat.prototype.setCpv = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPVMetrics.PassNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPVMetrics.PassNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pv: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ir: jspb.Message.getFieldWithDefault(msg, 2, 0),
    num: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    cpv: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPVMetrics.PassNumStat}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPVMetrics.PassNumStat;
  return proto.xcommon.LeaderPVMetrics.PassNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPVMetrics.PassNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPVMetrics.PassNumStat}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPv(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIr(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCpv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPVMetrics.PassNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPVMetrics.PassNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPv();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIr();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getCpv();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 PV = 1;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.getPv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.setPv = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 IR = 2;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.getIr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.setIr = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Num = 3;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double Rate = 4;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.setRate = function(value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int64 CPV = 5;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.getCpv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.PassNumStat.prototype.setCpv = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPVMetrics.InvalidNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPVMetrics.InvalidNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pv: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ir: jspb.Message.getFieldWithDefault(msg, 2, 0),
    num: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    cpv: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPVMetrics.InvalidNumStat}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPVMetrics.InvalidNumStat;
  return proto.xcommon.LeaderPVMetrics.InvalidNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPVMetrics.InvalidNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPVMetrics.InvalidNumStat}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPv(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIr(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCpv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPVMetrics.InvalidNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPVMetrics.InvalidNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPv();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIr();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getCpv();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 PV = 1;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.getPv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.setPv = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 IR = 2;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.getIr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.setIr = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Num = 3;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double Rate = 4;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.setRate = function(value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int64 CPV = 5;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.getCpv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.InvalidNumStat.prototype.setCpv = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPVMetrics.RejectNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPVMetrics.RejectNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pv: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ir: jspb.Message.getFieldWithDefault(msg, 2, 0),
    num: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    cpv: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPVMetrics.RejectNumStat}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPVMetrics.RejectNumStat;
  return proto.xcommon.LeaderPVMetrics.RejectNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPVMetrics.RejectNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPVMetrics.RejectNumStat}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPv(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIr(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCpv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPVMetrics.RejectNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPVMetrics.RejectNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPv();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIr();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getCpv();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 PV = 1;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.getPv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.setPv = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 IR = 2;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.getIr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.setIr = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Num = 3;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double Rate = 4;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.setRate = function(value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int64 CPV = 5;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.getCpv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.RejectNumStat.prototype.setCpv = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPVMetrics.InspectionPassNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    num: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPVMetrics.InspectionPassNumStat}
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPVMetrics.InspectionPassNumStat;
  return proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPVMetrics.InspectionPassNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPVMetrics.InspectionPassNumStat}
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPVMetrics.InspectionPassNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional int64 Num = 1;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double Rate = 2;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.InspectionPassNumStat.prototype.setRate = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional TicketNumStat TicketNum = 1;
 * @return {?proto.xcommon.LeaderPVMetrics.TicketNumStat}
 */
proto.xcommon.LeaderPVMetrics.prototype.getTicketnum = function() {
  return /** @type{?proto.xcommon.LeaderPVMetrics.TicketNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPVMetrics.TicketNumStat, 1));
};


/** @param {?proto.xcommon.LeaderPVMetrics.TicketNumStat|undefined} value */
proto.xcommon.LeaderPVMetrics.prototype.setTicketnum = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPVMetrics.prototype.clearTicketnum = function() {
  this.setTicketnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPVMetrics.prototype.hasTicketnum = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AssignNumStat AssignNum = 2;
 * @return {?proto.xcommon.LeaderPVMetrics.AssignNumStat}
 */
proto.xcommon.LeaderPVMetrics.prototype.getAssignnum = function() {
  return /** @type{?proto.xcommon.LeaderPVMetrics.AssignNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPVMetrics.AssignNumStat, 2));
};


/** @param {?proto.xcommon.LeaderPVMetrics.AssignNumStat|undefined} value */
proto.xcommon.LeaderPVMetrics.prototype.setAssignnum = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPVMetrics.prototype.clearAssignnum = function() {
  this.setAssignnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPVMetrics.prototype.hasAssignnum = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CompleteNumStat CompleteNum = 3;
 * @return {?proto.xcommon.LeaderPVMetrics.CompleteNumStat}
 */
proto.xcommon.LeaderPVMetrics.prototype.getCompletenum = function() {
  return /** @type{?proto.xcommon.LeaderPVMetrics.CompleteNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPVMetrics.CompleteNumStat, 3));
};


/** @param {?proto.xcommon.LeaderPVMetrics.CompleteNumStat|undefined} value */
proto.xcommon.LeaderPVMetrics.prototype.setCompletenum = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPVMetrics.prototype.clearCompletenum = function() {
  this.setCompletenum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPVMetrics.prototype.hasCompletenum = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PassNumStat PassNum = 4;
 * @return {?proto.xcommon.LeaderPVMetrics.PassNumStat}
 */
proto.xcommon.LeaderPVMetrics.prototype.getPassnum = function() {
  return /** @type{?proto.xcommon.LeaderPVMetrics.PassNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPVMetrics.PassNumStat, 4));
};


/** @param {?proto.xcommon.LeaderPVMetrics.PassNumStat|undefined} value */
proto.xcommon.LeaderPVMetrics.prototype.setPassnum = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPVMetrics.prototype.clearPassnum = function() {
  this.setPassnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPVMetrics.prototype.hasPassnum = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional InvalidNumStat InvalidNum = 5;
 * @return {?proto.xcommon.LeaderPVMetrics.InvalidNumStat}
 */
proto.xcommon.LeaderPVMetrics.prototype.getInvalidnum = function() {
  return /** @type{?proto.xcommon.LeaderPVMetrics.InvalidNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPVMetrics.InvalidNumStat, 5));
};


/** @param {?proto.xcommon.LeaderPVMetrics.InvalidNumStat|undefined} value */
proto.xcommon.LeaderPVMetrics.prototype.setInvalidnum = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPVMetrics.prototype.clearInvalidnum = function() {
  this.setInvalidnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPVMetrics.prototype.hasInvalidnum = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RejectNumStat RejectNum = 6;
 * @return {?proto.xcommon.LeaderPVMetrics.RejectNumStat}
 */
proto.xcommon.LeaderPVMetrics.prototype.getRejectnum = function() {
  return /** @type{?proto.xcommon.LeaderPVMetrics.RejectNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPVMetrics.RejectNumStat, 6));
};


/** @param {?proto.xcommon.LeaderPVMetrics.RejectNumStat|undefined} value */
proto.xcommon.LeaderPVMetrics.prototype.setRejectnum = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPVMetrics.prototype.clearRejectnum = function() {
  this.setRejectnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPVMetrics.prototype.hasRejectnum = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional InspectionPassNumStat InspectionPassNum = 7;
 * @return {?proto.xcommon.LeaderPVMetrics.InspectionPassNumStat}
 */
proto.xcommon.LeaderPVMetrics.prototype.getInspectionpassnum = function() {
  return /** @type{?proto.xcommon.LeaderPVMetrics.InspectionPassNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPVMetrics.InspectionPassNumStat, 7));
};


/** @param {?proto.xcommon.LeaderPVMetrics.InspectionPassNumStat|undefined} value */
proto.xcommon.LeaderPVMetrics.prototype.setInspectionpassnum = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPVMetrics.prototype.clearInspectionpassnum = function() {
  this.setInspectionpassnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPVMetrics.prototype.hasInspectionpassnum = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 AvgHandleTime = 8;
 * @return {number}
 */
proto.xcommon.LeaderPVMetrics.prototype.getAvghandletime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPVMetrics.prototype.setAvghandletime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SimplePVStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SimplePVStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SimplePVStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SimplePVStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    casename: jspb.Message.getFieldWithDefault(msg, 4, ""),
    completenum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    adminuid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    uncompletenum: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SimplePVStats}
 */
proto.xcommon.SimplePVStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SimplePVStats;
  return proto.xcommon.SimplePVStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SimplePVStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SimplePVStats}
 */
proto.xcommon.SimplePVStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUncompletenum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SimplePVStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SimplePVStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SimplePVStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SimplePVStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getUncompletenum();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.SimplePVStats.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.SimplePVStats.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string UserName = 2;
 * @return {string}
 */
proto.xcommon.SimplePVStats.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SimplePVStats.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string EmployeeID = 3;
 * @return {string}
 */
proto.xcommon.SimplePVStats.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SimplePVStats.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string CaseName = 4;
 * @return {string}
 */
proto.xcommon.SimplePVStats.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SimplePVStats.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 CompleteNum = 5;
 * @return {number}
 */
proto.xcommon.SimplePVStats.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.SimplePVStats.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AdminUid = 6;
 * @return {number}
 */
proto.xcommon.SimplePVStats.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.SimplePVStats.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 UnCompleteNum = 7;
 * @return {number}
 */
proto.xcommon.SimplePVStats.prototype.getUncompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.SimplePVStats.prototype.setUncompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketQuantityReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketQuantityReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketQuantityReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketQuantityReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketQuantityReq}
 */
proto.xcommon.GetTicketQuantityReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketQuantityReq;
  return proto.xcommon.GetTicketQuantityReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketQuantityReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketQuantityReq}
 */
proto.xcommon.GetTicketQuantityReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketQuantityReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketQuantityReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketQuantityReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketQuantityReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetTicketQuantityReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetTicketQuantityReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketQuantityReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketQuantityReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetTicketQuantityReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetTicketQuantityReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketQuantityReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketQuantityReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetTicketQuantityResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetTicketQuantityResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetTicketQuantityResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetTicketQuantityResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketQuantityResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.TicketQuantityStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetTicketQuantityResp}
 */
proto.xcommon.GetTicketQuantityResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetTicketQuantityResp;
  return proto.xcommon.GetTicketQuantityResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetTicketQuantityResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetTicketQuantityResp}
 */
proto.xcommon.GetTicketQuantityResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.TicketQuantityStats;
      reader.readMessage(value,proto.xcommon.TicketQuantityStats.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetTicketQuantityResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetTicketQuantityResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetTicketQuantityResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetTicketQuantityResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.TicketQuantityStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetTicketQuantityResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetTicketQuantityResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketQuantityResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketQuantityResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetTicketQuantityResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetTicketQuantityResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetTicketQuantityResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetTicketQuantityResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated TicketQuantityStats List = 3;
 * @return {!Array<!proto.xcommon.TicketQuantityStats>}
 */
proto.xcommon.GetTicketQuantityResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.TicketQuantityStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TicketQuantityStats, 3));
};


/** @param {!Array<!proto.xcommon.TicketQuantityStats>} value */
proto.xcommon.GetTicketQuantityResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.TicketQuantityStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TicketQuantityStats}
 */
proto.xcommon.GetTicketQuantityResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.TicketQuantityStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetTicketQuantityResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TicketQuantityStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TicketQuantityStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TicketQuantityStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketQuantityStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    totalticket: jspb.Message.getFieldWithDefault(msg, 2, 0),
    totalstaff: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalavg: jspb.Message.getFieldWithDefault(msg, 4, 0),
    d2ticket: jspb.Message.getFieldWithDefault(msg, 5, 0),
    d2staff: jspb.Message.getFieldWithDefault(msg, 6, 0),
    d2avg: jspb.Message.getFieldWithDefault(msg, 7, 0),
    d1ticket: jspb.Message.getFieldWithDefault(msg, 8, 0),
    d1staff: jspb.Message.getFieldWithDefault(msg, 9, 0),
    d1avg: jspb.Message.getFieldWithDefault(msg, 10, 0),
    d0ticket: jspb.Message.getFieldWithDefault(msg, 11, 0),
    d0staff: jspb.Message.getFieldWithDefault(msg, 12, 0),
    d0avg: jspb.Message.getFieldWithDefault(msg, 13, 0),
    m11ticket: jspb.Message.getFieldWithDefault(msg, 14, 0),
    m11staff: jspb.Message.getFieldWithDefault(msg, 15, 0),
    m11avg: jspb.Message.getFieldWithDefault(msg, 16, 0),
    m12ticket: jspb.Message.getFieldWithDefault(msg, 17, 0),
    m12staff: jspb.Message.getFieldWithDefault(msg, 18, 0),
    m12avg: jspb.Message.getFieldWithDefault(msg, 19, 0),
    m13ticket: jspb.Message.getFieldWithDefault(msg, 20, 0),
    m13staff: jspb.Message.getFieldWithDefault(msg, 21, 0),
    m13avg: jspb.Message.getFieldWithDefault(msg, 22, 0),
    statsdate: jspb.Message.getFieldWithDefault(msg, 23, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 24, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 25, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TicketQuantityStats}
 */
proto.xcommon.TicketQuantityStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TicketQuantityStats;
  return proto.xcommon.TicketQuantityStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TicketQuantityStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TicketQuantityStats}
 */
proto.xcommon.TicketQuantityStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalticket(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalstaff(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalavg(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD2ticket(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD2staff(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD2avg(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD1ticket(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD1staff(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD1avg(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD0ticket(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD0staff(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setD0avg(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM11ticket(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM11staff(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM11avg(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM12ticket(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM12staff(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM12avg(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM13ticket(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM13staff(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setM13avg(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStatsdate(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TicketQuantityStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TicketQuantityStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TicketQuantityStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TicketQuantityStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTotalticket();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTotalstaff();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalavg();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getD2ticket();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getD2staff();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getD2avg();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getD1ticket();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getD1staff();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getD1avg();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getD0ticket();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getD0staff();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getD0avg();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getM11ticket();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getM11staff();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getM11avg();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getM12ticket();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getM12staff();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getM12avg();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getM13ticket();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getM13staff();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getM13avg();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getStatsdate();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 TotalTicket = 2;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getTotalticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setTotalticket = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 TotalStaff = 3;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getTotalstaff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setTotalstaff = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TotalAvg = 4;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getTotalavg = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setTotalavg = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 D2Ticket = 5;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD2ticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD2ticket = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 D2Staff = 6;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD2staff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD2staff = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 D2Avg = 7;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD2avg = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD2avg = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 D1Ticket = 8;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD1ticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD1ticket = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 D1Staff = 9;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD1staff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD1staff = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 D1Avg = 10;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD1avg = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD1avg = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 D0Ticket = 11;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD0ticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD0ticket = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 D0Staff = 12;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD0staff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD0staff = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 D0Avg = 13;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getD0avg = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setD0avg = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 M11Ticket = 14;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM11ticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM11ticket = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 M11Staff = 15;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM11staff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM11staff = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 M11Avg = 16;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM11avg = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM11avg = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 M12Ticket = 17;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM12ticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM12ticket = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 M12Staff = 18;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM12staff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM12staff = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 M12Avg = 19;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM12avg = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM12avg = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 M13Ticket = 20;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM13ticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM13ticket = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 M13Staff = 21;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM13staff = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM13staff = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 M13Avg = 22;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getM13avg = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setM13avg = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 StatsDate = 23;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getStatsdate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setStatsdate = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int64 Ctime = 24;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 Utime = 25;
 * @return {number}
 */
proto.xcommon.TicketQuantityStats.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.xcommon.TicketQuantityStats.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SmsStatsReq.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    date: jspb.Message.getFieldWithDefault(msg, 3, ""),
    user: jspb.Message.getFieldWithDefault(msg, 4, ""),
    roleids: jspb.Message.getFieldWithDefault(msg, 5, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    dimensionList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    userid: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsStatsReq}
 */
proto.xcommon.SmsStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsStatsReq;
  return proto.xcommon.SmsStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsStatsReq}
 */
proto.xcommon.SmsStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUser(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoleids(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemid(value);
      break;
    case 7:
      var value = /** @type {!Array<!proto.xcommon.StatDimension>} */ (reader.readPackedEnum());
      msg.setDimensionList(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUser();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRoleids();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getItemid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDimensionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SmsStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SmsStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.SmsStatsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.SmsStatsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsStatsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsStatsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Date = 3;
 * @return {string}
 */
proto.xcommon.SmsStatsReq.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsReq.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string User = 4;
 * @return {string}
 */
proto.xcommon.SmsStatsReq.prototype.getUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsReq.prototype.setUser = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string RoleIDs = 5;
 * @return {string}
 */
proto.xcommon.SmsStatsReq.prototype.getRoleids = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsReq.prototype.setRoleids = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string ItemID = 6;
 * @return {string}
 */
proto.xcommon.SmsStatsReq.prototype.getItemid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated StatDimension Dimension = 7;
 * @return {!Array<!proto.xcommon.StatDimension>}
 */
proto.xcommon.SmsStatsReq.prototype.getDimensionList = function() {
  return /** @type {!Array<!proto.xcommon.StatDimension>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<!proto.xcommon.StatDimension>} value */
proto.xcommon.SmsStatsReq.prototype.setDimensionList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.xcommon.StatDimension} value
 * @param {number=} opt_index
 */
proto.xcommon.SmsStatsReq.prototype.addDimension = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SmsStatsReq.prototype.clearDimensionList = function() {
  this.setDimensionList([]);
};


/**
 * optional int64 UserID = 8;
 * @return {number}
 */
proto.xcommon.SmsStatsReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.SmsStatsReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SmsStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    smsstatsList: jspb.Message.toObjectList(msg.getSmsstatsList(),
    proto.xcommon.SmsStatsBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsStatsResp}
 */
proto.xcommon.SmsStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsStatsResp;
  return proto.xcommon.SmsStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsStatsResp}
 */
proto.xcommon.SmsStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.SmsStatsBackend;
      reader.readMessage(value,proto.xcommon.SmsStatsBackend.deserializeBinaryFromReader);
      msg.addSmsstats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getSmsstatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.SmsStatsBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SmsStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SmsStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.SmsStatsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.SmsStatsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsStatsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsStatsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated SmsStatsBackend SmsStats = 3;
 * @return {!Array<!proto.xcommon.SmsStatsBackend>}
 */
proto.xcommon.SmsStatsResp.prototype.getSmsstatsList = function() {
  return /** @type{!Array<!proto.xcommon.SmsStatsBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SmsStatsBackend, 3));
};


/** @param {!Array<!proto.xcommon.SmsStatsBackend>} value */
proto.xcommon.SmsStatsResp.prototype.setSmsstatsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.SmsStatsBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SmsStatsBackend}
 */
proto.xcommon.SmsStatsResp.prototype.addSmsstats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.SmsStatsBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SmsStatsResp.prototype.clearSmsstatsList = function() {
  this.setSmsstatsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsStatsBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsStatsBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsStatsBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsStatsBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    user: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    staffrole: jspb.Message.getFieldWithDefault(msg, 4, ""),
    itemname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    majorleaderrole: jspb.Message.getFieldWithDefault(msg, 6, ""),
    minorleaderrole: jspb.Message.getFieldWithDefault(msg, 7, ""),
    totalsendnum: jspb.Message.getFieldWithDefault(msg, 8, 0),
    selfsendnum: jspb.Message.getFieldWithDefault(msg, 9, 0),
    contactsendnum: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsStatsBackend}
 */
proto.xcommon.SmsStatsBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsStatsBackend;
  return proto.xcommon.SmsStatsBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsStatsBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsStatsBackend}
 */
proto.xcommon.SmsStatsBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUser(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStaffrole(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMajorleaderrole(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinorleaderrole(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalsendnum(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSelfsendnum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContactsendnum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsStatsBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsStatsBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsStatsBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsStatsBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUser();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStaffrole();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getItemname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMajorleaderrole();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMinorleaderrole();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTotalsendnum();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getSelfsendnum();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getContactsendnum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional string Date = 1;
 * @return {string}
 */
proto.xcommon.SmsStatsBackend.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsBackend.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string User = 2;
 * @return {string}
 */
proto.xcommon.SmsStatsBackend.prototype.getUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsBackend.prototype.setUser = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string UserID = 3;
 * @return {string}
 */
proto.xcommon.SmsStatsBackend.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsBackend.prototype.setUserid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string StaffRole = 4;
 * @return {string}
 */
proto.xcommon.SmsStatsBackend.prototype.getStaffrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsBackend.prototype.setStaffrole = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ItemName = 5;
 * @return {string}
 */
proto.xcommon.SmsStatsBackend.prototype.getItemname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsBackend.prototype.setItemname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string MajorLeaderRole = 6;
 * @return {string}
 */
proto.xcommon.SmsStatsBackend.prototype.getMajorleaderrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsBackend.prototype.setMajorleaderrole = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string MinorLeaderRole = 7;
 * @return {string}
 */
proto.xcommon.SmsStatsBackend.prototype.getMinorleaderrole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.SmsStatsBackend.prototype.setMinorleaderrole = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 TotalSendNum = 8;
 * @return {number}
 */
proto.xcommon.SmsStatsBackend.prototype.getTotalsendnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.SmsStatsBackend.prototype.setTotalsendnum = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 SelfSendNum = 9;
 * @return {number}
 */
proto.xcommon.SmsStatsBackend.prototype.getSelfsendnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.SmsStatsBackend.prototype.setSelfsendnum = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 ContactSendNum = 10;
 * @return {number}
 */
proto.xcommon.SmsStatsBackend.prototype.getContactsendnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.SmsStatsBackend.prototype.setContactsendnum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OutSourceRepayStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OutSourceRepayStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceRepayStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    timerange: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OutSourceRepayStatsReq}
 */
proto.xcommon.OutSourceRepayStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OutSourceRepayStatsReq;
  return proto.xcommon.OutSourceRepayStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OutSourceRepayStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OutSourceRepayStatsReq}
 */
proto.xcommon.OutSourceRepayStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OutSourceRepayStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OutSourceRepayStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceRepayStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.OutSourceRepayStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.OutSourceRepayStatsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string TimeRange = 3;
 * @return {string}
 */
proto.xcommon.OutSourceRepayStatsReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.OutSourceRepayStatsReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.OutSourceRepayStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OutSourceRepayStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OutSourceRepayStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceRepayStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.OutSourceRepayStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OutSourceRepayStatsResp}
 */
proto.xcommon.OutSourceRepayStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OutSourceRepayStatsResp;
  return proto.xcommon.OutSourceRepayStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OutSourceRepayStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OutSourceRepayStatsResp}
 */
proto.xcommon.OutSourceRepayStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.OutSourceRepayStats;
      reader.readMessage(value,proto.xcommon.OutSourceRepayStats.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OutSourceRepayStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OutSourceRepayStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceRepayStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.OutSourceRepayStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.OutSourceRepayStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.OutSourceRepayStatsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated OutSourceRepayStats List = 3;
 * @return {!Array<!proto.xcommon.OutSourceRepayStats>}
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.OutSourceRepayStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.OutSourceRepayStats, 3));
};


/** @param {!Array<!proto.xcommon.OutSourceRepayStats>} value */
proto.xcommon.OutSourceRepayStatsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.OutSourceRepayStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OutSourceRepayStats}
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.OutSourceRepayStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.OutSourceRepayStatsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OutSourceRepayStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OutSourceRepayStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OutSourceRepayStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceRepayStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    entrustcompany: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    repayamount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    overduedaysatrepaytime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    overduedays: jspb.Message.getFieldWithDefault(msg, 6, 0),
    repaytime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    applyentrusttime: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OutSourceRepayStats}
 */
proto.xcommon.OutSourceRepayStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OutSourceRepayStats;
  return proto.xcommon.OutSourceRepayStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OutSourceRepayStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OutSourceRepayStats}
 */
proto.xcommon.OutSourceRepayStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntrustcompany(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayamount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverduedaysatrepaytime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverduedays(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplyentrusttime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OutSourceRepayStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OutSourceRepayStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OutSourceRepayStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceRepayStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntrustcompany();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getRepayamount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOverduedaysatrepaytime();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOverduedays();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRepaytime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getApplyentrusttime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional string EntrustCompany = 1;
 * @return {string}
 */
proto.xcommon.OutSourceRepayStats.prototype.getEntrustcompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.OutSourceRepayStats.prototype.setEntrustcompany = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.OutSourceRepayStats.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.OutSourceRepayStats.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 CustomerId = 3;
 * @return {string}
 */
proto.xcommon.OutSourceRepayStats.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.OutSourceRepayStats.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 RepayAmount = 4;
 * @return {number}
 */
proto.xcommon.OutSourceRepayStats.prototype.getRepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.OutSourceRepayStats.prototype.setRepayamount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 OverdueDaysAtRepayTime = 5;
 * @return {number}
 */
proto.xcommon.OutSourceRepayStats.prototype.getOverduedaysatrepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.OutSourceRepayStats.prototype.setOverduedaysatrepaytime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 OverdueDays = 6;
 * @return {number}
 */
proto.xcommon.OutSourceRepayStats.prototype.getOverduedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.OutSourceRepayStats.prototype.setOverduedays = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 RepayTime = 7;
 * @return {number}
 */
proto.xcommon.OutSourceRepayStats.prototype.getRepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.OutSourceRepayStats.prototype.setRepaytime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 ApplyEntrustTime = 8;
 * @return {number}
 */
proto.xcommon.OutSourceRepayStats.prototype.getApplyentrusttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.OutSourceRepayStats.prototype.setApplyentrusttime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OutSourceStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OutSourceStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OutSourceStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    timerange: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OutSourceStatsReq}
 */
proto.xcommon.OutSourceStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OutSourceStatsReq;
  return proto.xcommon.OutSourceStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OutSourceStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OutSourceStatsReq}
 */
proto.xcommon.OutSourceStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OutSourceStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OutSourceStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OutSourceStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.OutSourceStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.OutSourceStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OutSourceStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OutSourceStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.OutSourceStatsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.OutSourceStatsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OutSourceStatsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OutSourceStatsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string TimeRange = 3;
 * @return {string}
 */
proto.xcommon.OutSourceStatsReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.OutSourceStatsReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.OutSourceStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OutSourceStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OutSourceStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OutSourceStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.OutSourceStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OutSourceStatsResp}
 */
proto.xcommon.OutSourceStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OutSourceStatsResp;
  return proto.xcommon.OutSourceStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OutSourceStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OutSourceStatsResp}
 */
proto.xcommon.OutSourceStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.OutSourceStats;
      reader.readMessage(value,proto.xcommon.OutSourceStats.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OutSourceStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OutSourceStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OutSourceStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.OutSourceStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.OutSourceStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.OutSourceStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OutSourceStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OutSourceStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.OutSourceStatsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.OutSourceStatsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OutSourceStatsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OutSourceStatsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated OutSourceStats List = 3;
 * @return {!Array<!proto.xcommon.OutSourceStats>}
 */
proto.xcommon.OutSourceStatsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.OutSourceStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.OutSourceStats, 3));
};


/** @param {!Array<!proto.xcommon.OutSourceStats>} value */
proto.xcommon.OutSourceStatsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.OutSourceStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OutSourceStats}
 */
proto.xcommon.OutSourceStatsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.OutSourceStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.OutSourceStatsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OutSourceStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OutSourceStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OutSourceStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    entrustcompany: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    customerid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    applyentrusttime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    leftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OutSourceStats}
 */
proto.xcommon.OutSourceStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OutSourceStats;
  return proto.xcommon.OutSourceStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OutSourceStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OutSourceStats}
 */
proto.xcommon.OutSourceStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntrustcompany(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCustomerid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplyentrusttime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftunpaidprincipal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OutSourceStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OutSourceStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OutSourceStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OutSourceStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntrustcompany();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getCustomerid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getApplyentrusttime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLeftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string EntrustCompany = 1;
 * @return {string}
 */
proto.xcommon.OutSourceStats.prototype.getEntrustcompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.OutSourceStats.prototype.setEntrustcompany = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.OutSourceStats.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.OutSourceStats.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 CustomerId = 3;
 * @return {string}
 */
proto.xcommon.OutSourceStats.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.OutSourceStats.prototype.setCustomerid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 ApplyEntrustTime = 4;
 * @return {number}
 */
proto.xcommon.OutSourceStats.prototype.getApplyentrusttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.OutSourceStats.prototype.setApplyentrusttime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 LeftUnpaidPrincipal = 5;
 * @return {number}
 */
proto.xcommon.OutSourceStats.prototype.getLeftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.OutSourceStats.prototype.setLeftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PSDashboardReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PSDashboardReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PSDashboardReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSDashboardReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PSDashboardReq}
 */
proto.xcommon.PSDashboardReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PSDashboardReq;
  return proto.xcommon.PSDashboardReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PSDashboardReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PSDashboardReq}
 */
proto.xcommon.PSDashboardReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PSDashboardReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PSDashboardReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PSDashboardReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSDashboardReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.PSDashboardReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.PSDashboardReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PSDashboardReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PSDashboardReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.xcommon.PSDashboardReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.PSDashboardReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PSDashboardResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PSDashboardResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PSDashboardResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSDashboardResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    roletype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    updatetime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    psmetrics: (f = msg.getPsmetrics()) && proto.xcommon.PSMetrics.toObject(includeInstance, f),
    leaderpsmetrics: (f = msg.getLeaderpsmetrics()) && proto.xcommon.LeaderPSMetrics.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PSDashboardResp}
 */
proto.xcommon.PSDashboardResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PSDashboardResp;
  return proto.xcommon.PSDashboardResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PSDashboardResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PSDashboardResp}
 */
proto.xcommon.PSDashboardResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoletype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    case 4:
      var value = new proto.xcommon.PSMetrics;
      reader.readMessage(value,proto.xcommon.PSMetrics.deserializeBinaryFromReader);
      msg.setPsmetrics(value);
      break;
    case 5:
      var value = new proto.xcommon.LeaderPSMetrics;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.deserializeBinaryFromReader);
      msg.setLeaderpsmetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PSDashboardResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PSDashboardResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PSDashboardResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSDashboardResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getRoletype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPsmetrics();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.PSMetrics.serializeBinaryToWriter
    );
  }
  f = message.getLeaderpsmetrics();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.LeaderPSMetrics.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.PSDashboardResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.PSDashboardResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PSDashboardResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PSDashboardResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 RoleType = 2;
 * @return {number}
 */
proto.xcommon.PSDashboardResp.prototype.getRoletype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.PSDashboardResp.prototype.setRoletype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 UpdateTime = 3;
 * @return {number}
 */
proto.xcommon.PSDashboardResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PSDashboardResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional PSMetrics PSMetrics = 4;
 * @return {?proto.xcommon.PSMetrics}
 */
proto.xcommon.PSDashboardResp.prototype.getPsmetrics = function() {
  return /** @type{?proto.xcommon.PSMetrics} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.PSMetrics, 4));
};


/** @param {?proto.xcommon.PSMetrics|undefined} value */
proto.xcommon.PSDashboardResp.prototype.setPsmetrics = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PSDashboardResp.prototype.clearPsmetrics = function() {
  this.setPsmetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PSDashboardResp.prototype.hasPsmetrics = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional LeaderPSMetrics LeaderPSMetrics = 5;
 * @return {?proto.xcommon.LeaderPSMetrics}
 */
proto.xcommon.PSDashboardResp.prototype.getLeaderpsmetrics = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics, 5));
};


/** @param {?proto.xcommon.LeaderPSMetrics|undefined} value */
proto.xcommon.PSDashboardResp.prototype.setLeaderpsmetrics = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PSDashboardResp.prototype.clearLeaderpsmetrics = function() {
  this.setLeaderpsmetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PSDashboardResp.prototype.hasLeaderpsmetrics = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PSGroupStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PSGroupStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PSGroupStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSGroupStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PSGroupStatsReq}
 */
proto.xcommon.PSGroupStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PSGroupStatsReq;
  return proto.xcommon.PSGroupStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PSGroupStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PSGroupStatsReq}
 */
proto.xcommon.PSGroupStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PSGroupStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PSGroupStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PSGroupStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSGroupStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.PSGroupStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.PSGroupStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PSGroupStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PSGroupStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TicketItemEnum ItemId = 2;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.PSGroupStatsReq.prototype.getItemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.PSGroupStatsReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 UserId = 3;
 * @return {number}
 */
proto.xcommon.PSGroupStatsReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PSGroupStatsReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.PSGroupStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PSGroupStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PSGroupStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PSGroupStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSGroupStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    roletype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    staffstatsList: jspb.Message.toObjectList(msg.getStaffstatsList(),
    proto.xcommon.SimplePSStats.toObject, includeInstance),
    order: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PSGroupStatsResp}
 */
proto.xcommon.PSGroupStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PSGroupStatsResp;
  return proto.xcommon.PSGroupStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PSGroupStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PSGroupStatsResp}
 */
proto.xcommon.PSGroupStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoletype(value);
      break;
    case 3:
      var value = new proto.xcommon.SimplePSStats;
      reader.readMessage(value,proto.xcommon.SimplePSStats.deserializeBinaryFromReader);
      msg.addStaffstats(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PSGroupStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PSGroupStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PSGroupStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSGroupStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getRoletype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStaffstatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.SimplePSStats.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.PSGroupStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.PSGroupStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PSGroupStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PSGroupStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 RoleType = 2;
 * @return {number}
 */
proto.xcommon.PSGroupStatsResp.prototype.getRoletype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.PSGroupStatsResp.prototype.setRoletype = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated SimplePSStats StaffStats = 3;
 * @return {!Array<!proto.xcommon.SimplePSStats>}
 */
proto.xcommon.PSGroupStatsResp.prototype.getStaffstatsList = function() {
  return /** @type{!Array<!proto.xcommon.SimplePSStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SimplePSStats, 3));
};


/** @param {!Array<!proto.xcommon.SimplePSStats>} value */
proto.xcommon.PSGroupStatsResp.prototype.setStaffstatsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.SimplePSStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SimplePSStats}
 */
proto.xcommon.PSGroupStatsResp.prototype.addStaffstats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.SimplePSStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.PSGroupStatsResp.prototype.clearStaffstatsList = function() {
  this.setStaffstatsList([]);
};


/**
 * optional int64 Order = 4;
 * @return {number}
 */
proto.xcommon.PSGroupStatsResp.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.PSGroupStatsResp.prototype.setOrder = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SimplePSStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SimplePSStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SimplePSStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SimplePSStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    casename: jspb.Message.getFieldWithDefault(msg, 5, ""),
    handlenum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    answernum: jspb.Message.getFieldWithDefault(msg, 7, 0),
    volumeratio: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SimplePSStats}
 */
proto.xcommon.SimplePSStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SimplePSStats;
  return proto.xcommon.SimplePSStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SimplePSStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SimplePSStats}
 */
proto.xcommon.SimplePSStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandlenum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswernum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVolumeratio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SimplePSStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SimplePSStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SimplePSStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SimplePSStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHandlenum();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAnswernum();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getVolumeratio();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.SimplePSStats.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.SimplePSStats.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string UserName = 2;
 * @return {string}
 */
proto.xcommon.SimplePSStats.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SimplePSStats.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 AdminUid = 3;
 * @return {number}
 */
proto.xcommon.SimplePSStats.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.SimplePSStats.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string EmployeeID = 4;
 * @return {string}
 */
proto.xcommon.SimplePSStats.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SimplePSStats.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string CaseName = 5;
 * @return {string}
 */
proto.xcommon.SimplePSStats.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.SimplePSStats.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 HandleNum = 6;
 * @return {number}
 */
proto.xcommon.SimplePSStats.prototype.getHandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.SimplePSStats.prototype.setHandlenum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AnswerNum = 7;
 * @return {number}
 */
proto.xcommon.SimplePSStats.prototype.getAnswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.SimplePSStats.prototype.setAnswernum = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double VolumeRatio = 8;
 * @return {number}
 */
proto.xcommon.SimplePSStats.prototype.getVolumeratio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.xcommon.SimplePSStats.prototype.setVolumeratio = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPSMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPSMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPSMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketnum: (f = msg.getTicketnum()) && proto.xcommon.LeaderPSMetrics.TicketNumStat.toObject(includeInstance, f),
    assignnum: (f = msg.getAssignnum()) && proto.xcommon.LeaderPSMetrics.AssignNumStat.toObject(includeInstance, f),
    handlenum: (f = msg.getHandlenum()) && proto.xcommon.LeaderPSMetrics.HandleNumStat.toObject(includeInstance, f),
    answernum: (f = msg.getAnswernum()) && proto.xcommon.LeaderPSMetrics.AnswerNumStat.toObject(includeInstance, f),
    closurenum: (f = msg.getClosurenum()) && proto.xcommon.LeaderPSMetrics.ClosureNumStat.toObject(includeInstance, f),
    newoncesoldnum: (f = msg.getNewoncesoldnum()) && proto.xcommon.LeaderPSMetrics.ClosureNumStat.toObject(includeInstance, f),
    newnotoncesoldnum: (f = msg.getNewnotoncesoldnum()) && proto.xcommon.LeaderPSMetrics.ClosureNumStat.toObject(includeInstance, f),
    oldsoldnum: (f = msg.getOldsoldnum()) && proto.xcommon.LeaderPSMetrics.ClosureNumStat.toObject(includeInstance, f),
    othersoldnum: (f = msg.getOthersoldnum()) && proto.xcommon.LeaderPSMetrics.ClosureNumStat.toObject(includeInstance, f),
    avgticketnum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    avganswernum: jspb.Message.getFieldWithDefault(msg, 11, 0),
    avghandletime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    avgvolume: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    volumeratio: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPSMetrics}
 */
proto.xcommon.LeaderPSMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPSMetrics;
  return proto.xcommon.LeaderPSMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPSMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPSMetrics}
 */
proto.xcommon.LeaderPSMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.LeaderPSMetrics.TicketNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.TicketNumStat.deserializeBinaryFromReader);
      msg.setTicketnum(value);
      break;
    case 2:
      var value = new proto.xcommon.LeaderPSMetrics.AssignNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.AssignNumStat.deserializeBinaryFromReader);
      msg.setAssignnum(value);
      break;
    case 3:
      var value = new proto.xcommon.LeaderPSMetrics.HandleNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.HandleNumStat.deserializeBinaryFromReader);
      msg.setHandlenum(value);
      break;
    case 4:
      var value = new proto.xcommon.LeaderPSMetrics.AnswerNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.AnswerNumStat.deserializeBinaryFromReader);
      msg.setAnswernum(value);
      break;
    case 5:
      var value = new proto.xcommon.LeaderPSMetrics.ClosureNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.ClosureNumStat.deserializeBinaryFromReader);
      msg.setClosurenum(value);
      break;
    case 6:
      var value = new proto.xcommon.LeaderPSMetrics.ClosureNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.ClosureNumStat.deserializeBinaryFromReader);
      msg.setNewoncesoldnum(value);
      break;
    case 7:
      var value = new proto.xcommon.LeaderPSMetrics.ClosureNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.ClosureNumStat.deserializeBinaryFromReader);
      msg.setNewnotoncesoldnum(value);
      break;
    case 8:
      var value = new proto.xcommon.LeaderPSMetrics.ClosureNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.ClosureNumStat.deserializeBinaryFromReader);
      msg.setOldsoldnum(value);
      break;
    case 9:
      var value = new proto.xcommon.LeaderPSMetrics.ClosureNumStat;
      reader.readMessage(value,proto.xcommon.LeaderPSMetrics.ClosureNumStat.deserializeBinaryFromReader);
      msg.setOthersoldnum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvgticketnum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvganswernum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvghandletime(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgvolume(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVolumeratio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPSMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPSMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPSMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketnum();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.LeaderPSMetrics.TicketNumStat.serializeBinaryToWriter
    );
  }
  f = message.getAssignnum();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.LeaderPSMetrics.AssignNumStat.serializeBinaryToWriter
    );
  }
  f = message.getHandlenum();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.LeaderPSMetrics.HandleNumStat.serializeBinaryToWriter
    );
  }
  f = message.getAnswernum();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.LeaderPSMetrics.AnswerNumStat.serializeBinaryToWriter
    );
  }
  f = message.getClosurenum();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.LeaderPSMetrics.ClosureNumStat.serializeBinaryToWriter
    );
  }
  f = message.getNewoncesoldnum();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.xcommon.LeaderPSMetrics.ClosureNumStat.serializeBinaryToWriter
    );
  }
  f = message.getNewnotoncesoldnum();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.xcommon.LeaderPSMetrics.ClosureNumStat.serializeBinaryToWriter
    );
  }
  f = message.getOldsoldnum();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.xcommon.LeaderPSMetrics.ClosureNumStat.serializeBinaryToWriter
    );
  }
  f = message.getOthersoldnum();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.xcommon.LeaderPSMetrics.ClosureNumStat.serializeBinaryToWriter
    );
  }
  f = message.getAvgticketnum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAvganswernum();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getAvghandletime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getAvgvolume();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getVolumeratio();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPSMetrics.TicketNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPSMetrics.TicketNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_new: jspb.Message.getFieldWithDefault(msg, 1, 0),
    old: jspb.Message.getFieldWithDefault(msg, 2, 0),
    num: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPSMetrics.TicketNumStat}
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPSMetrics.TicketNumStat;
  return proto.xcommon.LeaderPSMetrics.TicketNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPSMetrics.TicketNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPSMetrics.TicketNumStat}
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNew(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOld(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPSMetrics.TicketNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPSMetrics.TicketNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNew();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOld();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 New = 1;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.prototype.getNew = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.TicketNumStat.prototype.setNew = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Old = 2;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.prototype.getOld = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.TicketNumStat.prototype.setOld = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Num = 3;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.TicketNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.TicketNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPSMetrics.AssignNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPSMetrics.AssignNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_new: jspb.Message.getFieldWithDefault(msg, 1, 0),
    old: jspb.Message.getFieldWithDefault(msg, 2, 0),
    num: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPSMetrics.AssignNumStat}
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPSMetrics.AssignNumStat;
  return proto.xcommon.LeaderPSMetrics.AssignNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPSMetrics.AssignNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPSMetrics.AssignNumStat}
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNew(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOld(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPSMetrics.AssignNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPSMetrics.AssignNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNew();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOld();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 New = 1;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.prototype.getNew = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.AssignNumStat.prototype.setNew = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Old = 2;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.prototype.getOld = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.AssignNumStat.prototype.setOld = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Num = 3;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.AssignNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.AssignNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPSMetrics.HandleNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPSMetrics.HandleNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_new: jspb.Message.getFieldWithDefault(msg, 1, 0),
    old: jspb.Message.getFieldWithDefault(msg, 2, 0),
    num: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPSMetrics.HandleNumStat}
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPSMetrics.HandleNumStat;
  return proto.xcommon.LeaderPSMetrics.HandleNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPSMetrics.HandleNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPSMetrics.HandleNumStat}
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNew(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOld(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPSMetrics.HandleNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPSMetrics.HandleNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNew();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOld();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 New = 1;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.prototype.getNew = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.HandleNumStat.prototype.setNew = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Old = 2;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.prototype.getOld = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.HandleNumStat.prototype.setOld = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Num = 3;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.HandleNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.HandleNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPSMetrics.AnswerNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPSMetrics.AnswerNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_new: jspb.Message.getFieldWithDefault(msg, 1, 0),
    old: jspb.Message.getFieldWithDefault(msg, 2, 0),
    num: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPSMetrics.AnswerNumStat}
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPSMetrics.AnswerNumStat;
  return proto.xcommon.LeaderPSMetrics.AnswerNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPSMetrics.AnswerNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPSMetrics.AnswerNumStat}
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNew(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOld(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPSMetrics.AnswerNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPSMetrics.AnswerNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNew();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOld();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional int64 New = 1;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.getNew = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.setNew = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Old = 2;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.getOld = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.setOld = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Num = 3;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double Rate = 4;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.AnswerNumStat.prototype.setRate = function(value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LeaderPSMetrics.ClosureNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LeaderPSMetrics.ClosureNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    num: jspb.Message.getFieldWithDefault(msg, 1, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LeaderPSMetrics.ClosureNumStat}
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LeaderPSMetrics.ClosureNumStat;
  return proto.xcommon.LeaderPSMetrics.ClosureNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LeaderPSMetrics.ClosureNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LeaderPSMetrics.ClosureNumStat}
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LeaderPSMetrics.ClosureNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LeaderPSMetrics.ClosureNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional int64 Num = 1;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Amount = 2;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double Rate = 3;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.ClosureNumStat.prototype.setRate = function(value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional TicketNumStat TicketNum = 1;
 * @return {?proto.xcommon.LeaderPSMetrics.TicketNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getTicketnum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.TicketNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.TicketNumStat, 1));
};


/** @param {?proto.xcommon.LeaderPSMetrics.TicketNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setTicketnum = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearTicketnum = function() {
  this.setTicketnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasTicketnum = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AssignNumStat AssignNum = 2;
 * @return {?proto.xcommon.LeaderPSMetrics.AssignNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getAssignnum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.AssignNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.AssignNumStat, 2));
};


/** @param {?proto.xcommon.LeaderPSMetrics.AssignNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setAssignnum = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearAssignnum = function() {
  this.setAssignnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasAssignnum = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional HandleNumStat HandleNum = 3;
 * @return {?proto.xcommon.LeaderPSMetrics.HandleNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getHandlenum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.HandleNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.HandleNumStat, 3));
};


/** @param {?proto.xcommon.LeaderPSMetrics.HandleNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setHandlenum = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearHandlenum = function() {
  this.setHandlenum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasHandlenum = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AnswerNumStat AnswerNum = 4;
 * @return {?proto.xcommon.LeaderPSMetrics.AnswerNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getAnswernum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.AnswerNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.AnswerNumStat, 4));
};


/** @param {?proto.xcommon.LeaderPSMetrics.AnswerNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setAnswernum = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearAnswernum = function() {
  this.setAnswernum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasAnswernum = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ClosureNumStat ClosureNum = 5;
 * @return {?proto.xcommon.LeaderPSMetrics.ClosureNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getClosurenum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.ClosureNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.ClosureNumStat, 5));
};


/** @param {?proto.xcommon.LeaderPSMetrics.ClosureNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setClosurenum = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearClosurenum = function() {
  this.setClosurenum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasClosurenum = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ClosureNumStat NewOnceSoldNum = 6;
 * @return {?proto.xcommon.LeaderPSMetrics.ClosureNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getNewoncesoldnum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.ClosureNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.ClosureNumStat, 6));
};


/** @param {?proto.xcommon.LeaderPSMetrics.ClosureNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setNewoncesoldnum = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearNewoncesoldnum = function() {
  this.setNewoncesoldnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasNewoncesoldnum = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ClosureNumStat NewNotOnceSoldNum = 7;
 * @return {?proto.xcommon.LeaderPSMetrics.ClosureNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getNewnotoncesoldnum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.ClosureNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.ClosureNumStat, 7));
};


/** @param {?proto.xcommon.LeaderPSMetrics.ClosureNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setNewnotoncesoldnum = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearNewnotoncesoldnum = function() {
  this.setNewnotoncesoldnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasNewnotoncesoldnum = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ClosureNumStat OldSoldNum = 8;
 * @return {?proto.xcommon.LeaderPSMetrics.ClosureNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getOldsoldnum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.ClosureNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.ClosureNumStat, 8));
};


/** @param {?proto.xcommon.LeaderPSMetrics.ClosureNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setOldsoldnum = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearOldsoldnum = function() {
  this.setOldsoldnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasOldsoldnum = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ClosureNumStat OtherSoldNum = 9;
 * @return {?proto.xcommon.LeaderPSMetrics.ClosureNumStat}
 */
proto.xcommon.LeaderPSMetrics.prototype.getOthersoldnum = function() {
  return /** @type{?proto.xcommon.LeaderPSMetrics.ClosureNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LeaderPSMetrics.ClosureNumStat, 9));
};


/** @param {?proto.xcommon.LeaderPSMetrics.ClosureNumStat|undefined} value */
proto.xcommon.LeaderPSMetrics.prototype.setOthersoldnum = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.LeaderPSMetrics.prototype.clearOthersoldnum = function() {
  this.setOthersoldnum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.LeaderPSMetrics.prototype.hasOthersoldnum = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int64 AvgTicketNum = 10;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.prototype.getAvgticketnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.prototype.setAvgticketnum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 AvgAnswerNum = 11;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.prototype.getAvganswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.prototype.setAvganswernum = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 AvgHandleTime = 12;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.prototype.getAvghandletime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.prototype.setAvghandletime = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional double AvgVolume = 13;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.prototype.getAvgvolume = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.prototype.setAvgvolume = function(value) {
  jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double VolumeRatio = 14;
 * @return {number}
 */
proto.xcommon.LeaderPSMetrics.prototype.getVolumeratio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/** @param {number} value */
proto.xcommon.LeaderPSMetrics.prototype.setVolumeratio = function(value) {
  jspb.Message.setProto3FloatField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PSMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PSMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PSMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
    assignnum: jspb.Message.getFieldWithDefault(msg, 1, 0),
    handlenum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    answernum: (f = msg.getAnswernum()) && proto.xcommon.PSMetrics.AnswerNumStat.toObject(includeInstance, f),
    closurenum: (f = msg.getClosurenum()) && proto.xcommon.PSMetrics.ClosureNumStat.toObject(includeInstance, f),
    leftnum: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PSMetrics}
 */
proto.xcommon.PSMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PSMetrics;
  return proto.xcommon.PSMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PSMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PSMetrics}
 */
proto.xcommon.PSMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignnum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandlenum(value);
      break;
    case 3:
      var value = new proto.xcommon.PSMetrics.AnswerNumStat;
      reader.readMessage(value,proto.xcommon.PSMetrics.AnswerNumStat.deserializeBinaryFromReader);
      msg.setAnswernum(value);
      break;
    case 4:
      var value = new proto.xcommon.PSMetrics.ClosureNumStat;
      reader.readMessage(value,proto.xcommon.PSMetrics.ClosureNumStat.deserializeBinaryFromReader);
      msg.setClosurenum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftnum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PSMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PSMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PSMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssignnum();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getHandlenum();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAnswernum();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.PSMetrics.AnswerNumStat.serializeBinaryToWriter
    );
  }
  f = message.getClosurenum();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.PSMetrics.ClosureNumStat.serializeBinaryToWriter
    );
  }
  f = message.getLeftnum();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PSMetrics.AnswerNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PSMetrics.AnswerNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PSMetrics.AnswerNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSMetrics.AnswerNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    num: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PSMetrics.AnswerNumStat}
 */
proto.xcommon.PSMetrics.AnswerNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PSMetrics.AnswerNumStat;
  return proto.xcommon.PSMetrics.AnswerNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PSMetrics.AnswerNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PSMetrics.AnswerNumStat}
 */
proto.xcommon.PSMetrics.AnswerNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PSMetrics.AnswerNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PSMetrics.AnswerNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PSMetrics.AnswerNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSMetrics.AnswerNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional int64 Num = 1;
 * @return {number}
 */
proto.xcommon.PSMetrics.AnswerNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PSMetrics.AnswerNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double Rate = 2;
 * @return {number}
 */
proto.xcommon.PSMetrics.AnswerNumStat.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.xcommon.PSMetrics.AnswerNumStat.prototype.setRate = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PSMetrics.ClosureNumStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PSMetrics.ClosureNumStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PSMetrics.ClosureNumStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSMetrics.ClosureNumStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    num: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PSMetrics.ClosureNumStat}
 */
proto.xcommon.PSMetrics.ClosureNumStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PSMetrics.ClosureNumStat;
  return proto.xcommon.PSMetrics.ClosureNumStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PSMetrics.ClosureNumStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PSMetrics.ClosureNumStat}
 */
proto.xcommon.PSMetrics.ClosureNumStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PSMetrics.ClosureNumStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PSMetrics.ClosureNumStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PSMetrics.ClosureNumStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PSMetrics.ClosureNumStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNum();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional int64 Num = 1;
 * @return {number}
 */
proto.xcommon.PSMetrics.ClosureNumStat.prototype.getNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PSMetrics.ClosureNumStat.prototype.setNum = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double Rate = 2;
 * @return {number}
 */
proto.xcommon.PSMetrics.ClosureNumStat.prototype.getRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.xcommon.PSMetrics.ClosureNumStat.prototype.setRate = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int64 AssignNum = 1;
 * @return {number}
 */
proto.xcommon.PSMetrics.prototype.getAssignnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PSMetrics.prototype.setAssignnum = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 HandleNum = 2;
 * @return {number}
 */
proto.xcommon.PSMetrics.prototype.getHandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.PSMetrics.prototype.setHandlenum = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional AnswerNumStat AnswerNum = 3;
 * @return {?proto.xcommon.PSMetrics.AnswerNumStat}
 */
proto.xcommon.PSMetrics.prototype.getAnswernum = function() {
  return /** @type{?proto.xcommon.PSMetrics.AnswerNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.PSMetrics.AnswerNumStat, 3));
};


/** @param {?proto.xcommon.PSMetrics.AnswerNumStat|undefined} value */
proto.xcommon.PSMetrics.prototype.setAnswernum = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PSMetrics.prototype.clearAnswernum = function() {
  this.setAnswernum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PSMetrics.prototype.hasAnswernum = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ClosureNumStat ClosureNum = 4;
 * @return {?proto.xcommon.PSMetrics.ClosureNumStat}
 */
proto.xcommon.PSMetrics.prototype.getClosurenum = function() {
  return /** @type{?proto.xcommon.PSMetrics.ClosureNumStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.PSMetrics.ClosureNumStat, 4));
};


/** @param {?proto.xcommon.PSMetrics.ClosureNumStat|undefined} value */
proto.xcommon.PSMetrics.prototype.setClosurenum = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.PSMetrics.prototype.clearClosurenum = function() {
  this.setClosurenum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.PSMetrics.prototype.hasClosurenum = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 LeftNum = 5;
 * @return {number}
 */
proto.xcommon.PSMetrics.prototype.getLeftnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.PSMetrics.prototype.setLeftnum = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPhoneSaleStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPhoneSaleStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneSaleStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    statstype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    timerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    hour: jspb.Message.getFieldWithDefault(msg, 9, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPhoneSaleStatsReq}
 */
proto.xcommon.ListPhoneSaleStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPhoneSaleStatsReq;
  return proto.xcommon.ListPhoneSaleStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPhoneSaleStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPhoneSaleStatsReq}
 */
proto.xcommon.ListPhoneSaleStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.StatsType} */ (reader.readEnum());
      msg.setStatstype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setItemid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHour(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPhoneSaleStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPhoneSaleStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneSaleStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getStatstype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHour();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StatsType StatsType = 3;
 * @return {!proto.xcommon.StatsType}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getStatstype = function() {
  return /** @type {!proto.xcommon.StatsType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.StatsType} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setStatstype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string Email = 4;
 * @return {string}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UserName = 5;
 * @return {string}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 UserGroupId = 6;
 * @return {number}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setUsergroupid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional TicketItemEnum ItemId = 7;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getItemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string TimeRange = 8;
 * @return {string}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 Hour = 9;
 * @return {number}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setHour = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string EmployeeID = 10;
 * @return {string}
 */
proto.xcommon.ListPhoneSaleStatsReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.ListPhoneSaleStatsReq.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListPhoneSaleStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPhoneSaleStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPhoneSaleStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneSaleStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.PhoneSaleStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPhoneSaleStatsResp}
 */
proto.xcommon.ListPhoneSaleStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPhoneSaleStatsResp;
  return proto.xcommon.ListPhoneSaleStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPhoneSaleStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPhoneSaleStatsResp}
 */
proto.xcommon.ListPhoneSaleStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.PhoneSaleStats;
      reader.readMessage(value,proto.xcommon.PhoneSaleStats.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPhoneSaleStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPhoneSaleStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneSaleStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.PhoneSaleStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListPhoneSaleStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListPhoneSaleStatsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PhoneSaleStats List = 3;
 * @return {!Array<!proto.xcommon.PhoneSaleStats>}
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.PhoneSaleStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PhoneSaleStats, 3));
};


/** @param {!Array<!proto.xcommon.PhoneSaleStats>} value */
proto.xcommon.ListPhoneSaleStatsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.PhoneSaleStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PhoneSaleStats}
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.PhoneSaleStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListPhoneSaleStatsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PhoneSaleStats.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PhoneSaleStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PhoneSaleStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneSaleStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    adminuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    logincount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    casename: jspb.Message.getFieldWithDefault(msg, 9, ""),
    loadnum: jspb.Message.getFieldWithDefault(msg, 10, 0),
    assignnum: jspb.Message.getFieldWithDefault(msg, 11, 0),
    handlenum: jspb.Message.getFieldWithDefault(msg, 12, 0),
    handletimes: jspb.Message.getFieldWithDefault(msg, 13, 0),
    answernum: jspb.Message.getFieldWithDefault(msg, 14, 0),
    answertimes: jspb.Message.getFieldWithDefault(msg, 15, 0),
    completenum: jspb.Message.getFieldWithDefault(msg, 16, 0),
    phonecompletenum: jspb.Message.getFieldWithDefault(msg, 17, 0),
    volume: jspb.Message.getFieldWithDefault(msg, 18, 0),
    phonevolume: jspb.Message.getFieldWithDefault(msg, 19, 0),
    conversionrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    closurerate: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
    attendanceat: jspb.Message.getFieldWithDefault(msg, 22, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PhoneSaleStats}
 */
proto.xcommon.PhoneSaleStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PhoneSaleStats;
  return proto.xcommon.PhoneSaleStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PhoneSaleStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PhoneSaleStats}
 */
proto.xcommon.PhoneSaleStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdminuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLogincount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadnum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignnum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandlenum(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandletimes(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswernum(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswertimes(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletenum(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhonecompletenum(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVolume(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhonevolume(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConversionrate(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosurerate(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAttendanceat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PhoneSaleStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PhoneSaleStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PhoneSaleStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneSaleStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAdminuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLogincount();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLoadnum();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAssignnum();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getHandlenum();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getHandletimes();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getAnswernum();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getAnswertimes();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getCompletenum();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getPhonecompletenum();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getPhonevolume();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getConversionrate();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getClosurerate();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getAttendanceat();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Date = 2;
 * @return {string}
 */
proto.xcommon.PhoneSaleStats.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.PhoneSaleStats.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 AdminUID = 3;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getAdminuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setAdminuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string EmployeeID = 4;
 * @return {string}
 */
proto.xcommon.PhoneSaleStats.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.PhoneSaleStats.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UserName = 5;
 * @return {string}
 */
proto.xcommon.PhoneSaleStats.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.PhoneSaleStats.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string UserGroupName = 6;
 * @return {string}
 */
proto.xcommon.PhoneSaleStats.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.PhoneSaleStats.prototype.setUsergroupname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 LoginCount = 7;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getLogincount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setLogincount = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 TicketItemID = 8;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string CaseName = 9;
 * @return {string}
 */
proto.xcommon.PhoneSaleStats.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.PhoneSaleStats.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 LoadNum = 10;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getLoadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setLoadnum = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 AssignNum = 11;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getAssignnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setAssignnum = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 HandleNum = 12;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getHandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setHandlenum = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 HandleTimes = 13;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getHandletimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setHandletimes = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 AnswerNum = 14;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getAnswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setAnswernum = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 AnswerTimes = 15;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getAnswertimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setAnswertimes = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 CompleteNum = 16;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getCompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setCompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 PhoneCompleteNum = 17;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getPhonecompletenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setPhonecompletenum = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 Volume = 18;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setVolume = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 PhoneVolume = 19;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getPhonevolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setPhonevolume = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional double ConversionRate = 20;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getConversionrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setConversionrate = function(value) {
  jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional double ClosureRate = 21;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getClosurerate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setClosurerate = function(value) {
  jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional int64 AttendanceAt = 22;
 * @return {number}
 */
proto.xcommon.PhoneSaleStats.prototype.getAttendanceat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.PhoneSaleStats.prototype.setAttendanceat = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WorkOrderStatisticReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WorkOrderStatisticReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WorkOrderStatisticReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOrderStatisticReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    timerange: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WorkOrderStatisticReq}
 */
proto.xcommon.WorkOrderStatisticReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WorkOrderStatisticReq;
  return proto.xcommon.WorkOrderStatisticReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WorkOrderStatisticReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WorkOrderStatisticReq}
 */
proto.xcommon.WorkOrderStatisticReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WorkOrderStatisticReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WorkOrderStatisticReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WorkOrderStatisticReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOrderStatisticReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WorkOrderStatisticReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WorkOrderStatisticReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WorkOrderStatisticReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WorkOrderStatisticReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.WorkOrderStatisticReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.WorkOrderStatisticReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WorkOrderStatisticReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WorkOrderStatisticReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.WorkOrderStatisticReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatisticReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string TimeRange = 4;
 * @return {string}
 */
proto.xcommon.WorkOrderStatisticReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.WorkOrderStatisticReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WorkOrderStatisticResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WorkOrderStatisticResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WorkOrderStatisticResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOrderStatisticResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.WorkOrderStatistic.toObject, includeInstance),
    urgeresultconnectedmapMap: (f = msg.getUrgeresultconnectedmapMap()) ? f.toObject(includeInstance, undefined) : [],
    urgeresultunconnectedmapMap: (f = msg.getUrgeresultunconnectedmapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WorkOrderStatisticResp}
 */
proto.xcommon.WorkOrderStatisticResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WorkOrderStatisticResp;
  return proto.xcommon.WorkOrderStatisticResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WorkOrderStatisticResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WorkOrderStatisticResp}
 */
proto.xcommon.WorkOrderStatisticResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.WorkOrderStatistic;
      reader.readMessage(value,proto.xcommon.WorkOrderStatistic.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = msg.getUrgeresultconnectedmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 5:
      var value = msg.getUrgeresultunconnectedmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WorkOrderStatisticResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WorkOrderStatisticResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOrderStatisticResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.WorkOrderStatistic.serializeBinaryToWriter
    );
  }
  f = message.getUrgeresultconnectedmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getUrgeresultunconnectedmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WorkOrderStatisticResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WorkOrderStatisticResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.WorkOrderStatisticResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WorkOrderStatisticResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated WorkOrderStatistic List = 3;
 * @return {!Array<!proto.xcommon.WorkOrderStatistic>}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.WorkOrderStatistic>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WorkOrderStatistic, 3));
};


/** @param {!Array<!proto.xcommon.WorkOrderStatistic>} value */
proto.xcommon.WorkOrderStatisticResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.WorkOrderStatistic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WorkOrderStatistic}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.WorkOrderStatistic, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WorkOrderStatisticResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * map<int32, string> UrgeResultConnectedMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.getUrgeresultconnectedmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.WorkOrderStatisticResp.prototype.clearUrgeresultconnectedmapMap = function() {
  this.getUrgeresultconnectedmapMap().clear();
};


/**
 * map<int32, string> UrgeResultUnConnectedMap = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.WorkOrderStatisticResp.prototype.getUrgeresultunconnectedmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.WorkOrderStatisticResp.prototype.clearUrgeresultunconnectedmapMap = function() {
  this.getUrgeresultunconnectedmapMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WorkOrderStatistic.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WorkOrderStatistic.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WorkOrderStatistic} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOrderStatistic.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    totalticket: jspb.Message.getFieldWithDefault(msg, 4, 0),
    problemticket: jspb.Message.getFieldWithDefault(msg, 5, 0),
    problemticketpercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    nowanumber: jspb.Message.getFieldWithDefault(msg, 7, 0),
    nowanumberpercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    totalunconnected: jspb.Message.getFieldWithDefault(msg, 9, 0),
    totalunconnectedpercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    unconnectedMap: (f = msg.getUnconnectedMap()) ? f.toObject(includeInstance, proto.xcommon.ReasonItemTotal.toObject) : [],
    totalconnected: jspb.Message.getFieldWithDefault(msg, 12, 0),
    totalconnectedpercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    connectedMap: (f = msg.getConnectedMap()) ? f.toObject(includeInstance, proto.xcommon.ReasonItemTotal.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WorkOrderStatistic}
 */
proto.xcommon.WorkOrderStatistic.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WorkOrderStatistic;
  return proto.xcommon.WorkOrderStatistic.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WorkOrderStatistic} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WorkOrderStatistic}
 */
proto.xcommon.WorkOrderStatistic.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalticket(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemticket(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setProblemticketpercentage(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNowanumber(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setNowanumberpercentage(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalunconnected(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalunconnectedpercentage(value);
      break;
    case 11:
      var value = msg.getUnconnectedMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.ReasonItemTotal.deserializeBinaryFromReader, 0);
         });
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalconnected(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalconnectedpercentage(value);
      break;
    case 14:
      var value = msg.getConnectedMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.ReasonItemTotal.deserializeBinaryFromReader, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WorkOrderStatistic.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WorkOrderStatistic.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WorkOrderStatistic} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOrderStatistic.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDate();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalticket();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProblemticket();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getProblemticketpercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getNowanumber();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getNowanumberpercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getTotalunconnected();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTotalunconnectedpercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getUnconnectedMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.ReasonItemTotal.serializeBinaryToWriter);
  }
  f = message.getTotalconnected();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getTotalconnectedpercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = message.getConnectedMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(14, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.ReasonItemTotal.serializeBinaryToWriter);
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 Date = 2;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setDate = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ItemId = 3;
 * @return {string}
 */
proto.xcommon.WorkOrderStatistic.prototype.getItemid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WorkOrderStatistic.prototype.setItemid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 TotalTicket = 4;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getTotalticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setTotalticket = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 ProblemTicket = 5;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getProblemticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setProblemticket = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional float ProblemTicketPercentage = 6;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getProblemticketpercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setProblemticketpercentage = function(value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 NoWaNumber = 7;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getNowanumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setNowanumber = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional float NoWaNumberPercentage = 8;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getNowanumberpercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setNowanumberpercentage = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int32 TotalUnconnected = 9;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getTotalunconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setTotalunconnected = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional float TotalUnconnectedPercentage = 10;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getTotalunconnectedpercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setTotalunconnectedpercentage = function(value) {
  jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * map<int32, ReasonItemTotal> Unconnected = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.ReasonItemTotal>}
 */
proto.xcommon.WorkOrderStatistic.prototype.getUnconnectedMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.ReasonItemTotal>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      proto.xcommon.ReasonItemTotal));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.WorkOrderStatistic.prototype.clearUnconnectedMap = function() {
  this.getUnconnectedMap().clear();
};


/**
 * optional int32 TotalConnected = 12;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getTotalconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setTotalconnected = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional float TotalConnectedPercentage = 13;
 * @return {number}
 */
proto.xcommon.WorkOrderStatistic.prototype.getTotalconnectedpercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/** @param {number} value */
proto.xcommon.WorkOrderStatistic.prototype.setTotalconnectedpercentage = function(value) {
  jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * map<int32, ReasonItemTotal> Connected = 14;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.ReasonItemTotal>}
 */
proto.xcommon.WorkOrderStatistic.prototype.getConnectedMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.ReasonItemTotal>} */ (
      jspb.Message.getMapField(this, 14, opt_noLazyCreate,
      proto.xcommon.ReasonItemTotal));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.WorkOrderStatistic.prototype.clearConnectedMap = function() {
  this.getConnectedMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReasonItemTotal.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReasonItemTotal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReasonItemTotal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReasonItemTotal.toObject = function(includeInstance, msg) {
  var f, obj = {
    total: jspb.Message.getFieldWithDefault(msg, 1, 0),
    percentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReasonItemTotal}
 */
proto.xcommon.ReasonItemTotal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReasonItemTotal;
  return proto.xcommon.ReasonItemTotal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReasonItemTotal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReasonItemTotal}
 */
proto.xcommon.ReasonItemTotal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReasonItemTotal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReasonItemTotal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReasonItemTotal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReasonItemTotal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional int32 Total = 1;
 * @return {number}
 */
proto.xcommon.ReasonItemTotal.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.ReasonItemTotal.prototype.setTotal = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float Percentage = 2;
 * @return {number}
 */
proto.xcommon.ReasonItemTotal.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.xcommon.ReasonItemTotal.prototype.setPercentage = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsHistoryReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsHistoryReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsHistoryReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsHistoryReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsHistoryReq}
 */
proto.xcommon.SmsHistoryReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsHistoryReq;
  return proto.xcommon.SmsHistoryReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsHistoryReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsHistoryReq}
 */
proto.xcommon.SmsHistoryReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsHistoryReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsHistoryReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsHistoryReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsHistoryReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SmsHistoryReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SmsHistoryReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsHistoryReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsHistoryReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.SmsHistoryReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.SmsHistoryReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional PageIn PageIn = 3;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.SmsHistoryReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 3));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.SmsHistoryReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsHistoryReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsHistoryReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsHistoryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsHistoryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsHistoryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsHistoryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    sender: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sendtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    text: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsHistoryItem}
 */
proto.xcommon.SmsHistoryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsHistoryItem;
  return proto.xcommon.SmsHistoryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsHistoryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsHistoryItem}
 */
proto.xcommon.SmsHistoryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSender(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSendtime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsHistoryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsHistoryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsHistoryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsHistoryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSender();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSendtime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Sender = 1;
 * @return {string}
 */
proto.xcommon.SmsHistoryItem.prototype.getSender = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.SmsHistoryItem.prototype.setSender = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 SendTime = 2;
 * @return {number}
 */
proto.xcommon.SmsHistoryItem.prototype.getSendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SmsHistoryItem.prototype.setSendtime = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Text = 3;
 * @return {string}
 */
proto.xcommon.SmsHistoryItem.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SmsHistoryItem.prototype.setText = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SmsHistoryResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsHistoryResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsHistoryResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsHistoryResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsHistoryResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.xcommon.SmsHistoryItem.toObject, includeInstance),
    onoff: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsHistoryResp}
 */
proto.xcommon.SmsHistoryResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsHistoryResp;
  return proto.xcommon.SmsHistoryResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsHistoryResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsHistoryResp}
 */
proto.xcommon.SmsHistoryResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.SmsHistoryItem;
      reader.readMessage(value,proto.xcommon.SmsHistoryItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnoff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsHistoryResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsHistoryResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsHistoryResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsHistoryResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.SmsHistoryItem.serializeBinaryToWriter
    );
  }
  f = message.getOnoff();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SmsHistoryResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SmsHistoryResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsHistoryResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsHistoryResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.SmsHistoryResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.SmsHistoryResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsHistoryResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsHistoryResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated SmsHistoryItem Items = 3;
 * @return {!Array<!proto.xcommon.SmsHistoryItem>}
 */
proto.xcommon.SmsHistoryResp.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.xcommon.SmsHistoryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SmsHistoryItem, 3));
};


/** @param {!Array<!proto.xcommon.SmsHistoryItem>} value */
proto.xcommon.SmsHistoryResp.prototype.setItemsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.SmsHistoryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SmsHistoryItem}
 */
proto.xcommon.SmsHistoryResp.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.SmsHistoryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SmsHistoryResp.prototype.clearItemsList = function() {
  this.setItemsList([]);
};


/**
 * optional bool OnOff = 4;
 * @return {boolean}
 */
proto.xcommon.SmsHistoryResp.prototype.getOnoff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.xcommon.SmsHistoryResp.prototype.setOnoff = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WorkOverdueReasonStatReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WorkOverdueReasonStatReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOverdueReasonStatReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    timerange: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WorkOverdueReasonStatReq}
 */
proto.xcommon.WorkOverdueReasonStatReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WorkOverdueReasonStatReq;
  return proto.xcommon.WorkOverdueReasonStatReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WorkOverdueReasonStatReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WorkOverdueReasonStatReq}
 */
proto.xcommon.WorkOverdueReasonStatReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WorkOverdueReasonStatReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WorkOverdueReasonStatReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOverdueReasonStatReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WorkOverdueReasonStatReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.WorkOverdueReasonStatReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStatReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string TimeRange = 4;
 * @return {string}
 */
proto.xcommon.WorkOverdueReasonStatReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.WorkOverdueReasonStatReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WorkOverdueReasonStatResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WorkOverdueReasonStatResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WorkOverdueReasonStatResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOverdueReasonStatResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.WorkOverdueReasonStat.toObject, includeInstance),
    urgeresultconnectedmapMap: (f = msg.getUrgeresultconnectedmapMap()) ? f.toObject(includeInstance, undefined) : [],
    urgeresultunconnectedmapMap: (f = msg.getUrgeresultunconnectedmapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WorkOverdueReasonStatResp}
 */
proto.xcommon.WorkOverdueReasonStatResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WorkOverdueReasonStatResp;
  return proto.xcommon.WorkOverdueReasonStatResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WorkOverdueReasonStatResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WorkOverdueReasonStatResp}
 */
proto.xcommon.WorkOverdueReasonStatResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.WorkOverdueReasonStat;
      reader.readMessage(value,proto.xcommon.WorkOverdueReasonStat.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = msg.getUrgeresultconnectedmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 5:
      var value = msg.getUrgeresultunconnectedmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WorkOverdueReasonStatResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WorkOverdueReasonStatResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOverdueReasonStatResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.WorkOverdueReasonStat.serializeBinaryToWriter
    );
  }
  f = message.getUrgeresultconnectedmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getUrgeresultunconnectedmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WorkOverdueReasonStatResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.WorkOverdueReasonStatResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated WorkOverdueReasonStat List = 3;
 * @return {!Array<!proto.xcommon.WorkOverdueReasonStat>}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.WorkOverdueReasonStat>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WorkOverdueReasonStat, 3));
};


/** @param {!Array<!proto.xcommon.WorkOverdueReasonStat>} value */
proto.xcommon.WorkOverdueReasonStatResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.WorkOverdueReasonStat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WorkOverdueReasonStat}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.WorkOverdueReasonStat, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * map<int32, string> UrgeResultConnectedMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.getUrgeresultconnectedmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.clearUrgeresultconnectedmapMap = function() {
  this.getUrgeresultconnectedmapMap().clear();
};


/**
 * map<int32, string> UrgeResultUnConnectedMap = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.getUrgeresultunconnectedmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.WorkOverdueReasonStatResp.prototype.clearUrgeresultunconnectedmapMap = function() {
  this.getUrgeresultunconnectedmapMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WorkOverdueReasonStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WorkOverdueReasonStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOverdueReasonStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    totalticket: jspb.Message.getFieldWithDefault(msg, 4, 0),
    problemticket: jspb.Message.getFieldWithDefault(msg, 5, 0),
    problemticketpercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    totalunconnected: jspb.Message.getFieldWithDefault(msg, 9, 0),
    totalunconnectedpercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    unconnectedMap: (f = msg.getUnconnectedMap()) ? f.toObject(includeInstance, proto.xcommon.ReasonItemTotal.toObject) : [],
    totalconnected: jspb.Message.getFieldWithDefault(msg, 12, 0),
    totalconnectedpercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    connectedMap: (f = msg.getConnectedMap()) ? f.toObject(includeInstance, proto.xcommon.ReasonItemTotal.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WorkOverdueReasonStat}
 */
proto.xcommon.WorkOverdueReasonStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WorkOverdueReasonStat;
  return proto.xcommon.WorkOverdueReasonStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WorkOverdueReasonStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WorkOverdueReasonStat}
 */
proto.xcommon.WorkOverdueReasonStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalticket(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemticket(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setProblemticketpercentage(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalunconnected(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalunconnectedpercentage(value);
      break;
    case 11:
      var value = msg.getUnconnectedMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.ReasonItemTotal.deserializeBinaryFromReader, 0);
         });
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalconnected(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalconnectedpercentage(value);
      break;
    case 14:
      var value = msg.getConnectedMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.ReasonItemTotal.deserializeBinaryFromReader, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WorkOverdueReasonStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WorkOverdueReasonStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WorkOverdueReasonStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDate();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalticket();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProblemticket();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getProblemticketpercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getTotalunconnected();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTotalunconnectedpercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getUnconnectedMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.ReasonItemTotal.serializeBinaryToWriter);
  }
  f = message.getTotalconnected();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getTotalconnectedpercentage();
  if (f !== 0.0) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = message.getConnectedMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(14, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.ReasonItemTotal.serializeBinaryToWriter);
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 Date = 2;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setDate = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ItemId = 3;
 * @return {string}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getItemid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setItemid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 TotalTicket = 4;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getTotalticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setTotalticket = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 ProblemTicket = 5;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getProblemticket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setProblemticket = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional float ProblemTicketPercentage = 6;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getProblemticketpercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setProblemticketpercentage = function(value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 TotalUnconnected = 9;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getTotalunconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setTotalunconnected = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional float TotalUnconnectedPercentage = 10;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getTotalunconnectedpercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setTotalunconnectedpercentage = function(value) {
  jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * map<int32, ReasonItemTotal> Unconnected = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.ReasonItemTotal>}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getUnconnectedMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.ReasonItemTotal>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      proto.xcommon.ReasonItemTotal));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.WorkOverdueReasonStat.prototype.clearUnconnectedMap = function() {
  this.getUnconnectedMap().clear();
};


/**
 * optional int32 TotalConnected = 12;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getTotalconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setTotalconnected = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional float TotalConnectedPercentage = 13;
 * @return {number}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getTotalconnectedpercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/** @param {number} value */
proto.xcommon.WorkOverdueReasonStat.prototype.setTotalconnectedpercentage = function(value) {
  jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * map<int32, ReasonItemTotal> Connected = 14;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.ReasonItemTotal>}
 */
proto.xcommon.WorkOverdueReasonStat.prototype.getConnectedMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.ReasonItemTotal>} */ (
      jspb.Message.getMapField(this, 14, opt_noLazyCreate,
      proto.xcommon.ReasonItemTotal));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.WorkOverdueReasonStat.prototype.clearConnectedMap = function() {
  this.getConnectedMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CreateOcrMarkTicketReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CreateOcrMarkTicketReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreateOcrMarkTicketReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ocrtype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    thirdid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    thirdtime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    thirdstatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    imgurl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    originresult: jspb.Message.getFieldWithDefault(msg, 7, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CreateOcrMarkTicketReq}
 */
proto.xcommon.CreateOcrMarkTicketReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CreateOcrMarkTicketReq;
  return proto.xcommon.CreateOcrMarkTicketReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CreateOcrMarkTicketReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CreateOcrMarkTicketReq}
 */
proto.xcommon.CreateOcrMarkTicketReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.OcrTypeEnum} */ (reader.readEnum());
      msg.setOcrtype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setThirdid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThirdtime(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.ThirdStatus} */ (reader.readEnum());
      msg.setThirdstatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setImgurl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginresult(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CreateOcrMarkTicketReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CreateOcrMarkTicketReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreateOcrMarkTicketReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOcrtype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getThirdid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getThirdtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getThirdstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getImgurl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOriginresult();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.CreateOcrMarkTicketReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OcrTypeEnum OcrType = 2;
 * @return {!proto.xcommon.OcrTypeEnum}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.getOcrtype = function() {
  return /** @type {!proto.xcommon.OcrTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.OcrTypeEnum} value */
proto.xcommon.CreateOcrMarkTicketReq.prototype.setOcrtype = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 ThirdId = 3;
 * @return {string}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.getThirdid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.CreateOcrMarkTicketReq.prototype.setThirdid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 ThirdTime = 4;
 * @return {number}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.getThirdtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.CreateOcrMarkTicketReq.prototype.setThirdtime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional ThirdStatus ThirdStatus = 5;
 * @return {!proto.xcommon.ThirdStatus}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.getThirdstatus = function() {
  return /** @type {!proto.xcommon.ThirdStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.ThirdStatus} value */
proto.xcommon.CreateOcrMarkTicketReq.prototype.setThirdstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string ImgUrl = 6;
 * @return {string}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.getImgurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.CreateOcrMarkTicketReq.prototype.setImgurl = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string OriginResult = 7;
 * @return {string}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.getOriginresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.CreateOcrMarkTicketReq.prototype.setOriginresult = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string AppName = 8;
 * @return {string}
 */
proto.xcommon.CreateOcrMarkTicketReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.CreateOcrMarkTicketReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOcrMarkTicketListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOcrMarkTicketListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOcrMarkTicketListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    ocrtype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    thirdid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    thirdstatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    thirdtimerange: jspb.Message.getFieldWithDefault(msg, 6, ""),
    createtimerange: jspb.Message.getFieldWithDefault(msg, 7, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 10, ""),
    status: jspb.Message.getFieldWithDefault(msg, 11, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 12, ""),
    markstatus: jspb.Message.getFieldWithDefault(msg, 13, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOcrMarkTicketListReq}
 */
proto.xcommon.GetOcrMarkTicketListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOcrMarkTicketListReq;
  return proto.xcommon.GetOcrMarkTicketListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOcrMarkTicketListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOcrMarkTicketListReq}
 */
proto.xcommon.GetOcrMarkTicketListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.OcrTypeEnum} */ (reader.readEnum());
      msg.setOcrtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setThirdid(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.ThirdStatus} */ (reader.readEnum());
      msg.setThirdstatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setThirdtimerange(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.OcrMarkStatus} */ (reader.readEnum());
      msg.setMarkstatus(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOcrMarkTicketListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOcrMarkTicketListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOcrMarkTicketListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getOcrtype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getThirdid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getThirdstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getThirdtimerange();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getMarkstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OcrTypeEnum OcrType = 3;
 * @return {!proto.xcommon.OcrTypeEnum}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getOcrtype = function() {
  return /** @type {!proto.xcommon.OcrTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.OcrTypeEnum} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setOcrtype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 ThirdId = 4;
 * @return {string}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getThirdid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/** @param {string} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setThirdid = function(value) {
  jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional ThirdStatus ThirdStatus = 5;
 * @return {!proto.xcommon.ThirdStatus}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getThirdstatus = function() {
  return /** @type {!proto.xcommon.ThirdStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.ThirdStatus} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setThirdstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string ThirdTimeRange = 6;
 * @return {string}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getThirdtimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setThirdtimerange = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string CreateTimeRange = 7;
 * @return {string}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setCreatetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string CompleteTimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setCompletetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string AssignTimeRange = 10;
 * @return {string}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setAssigntimerange = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Status = 11;
 * @return {string}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string AssignName = 12;
 * @return {string}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional OcrMarkStatus MarkStatus = 13;
 * @return {!proto.xcommon.OcrMarkStatus}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getMarkstatus = function() {
  return /** @type {!proto.xcommon.OcrMarkStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {!proto.xcommon.OcrMarkStatus} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setMarkstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional int64 TicketId = 14;
 * @return {number}
 */
proto.xcommon.GetOcrMarkTicketListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.GetOcrMarkTicketListReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetOcrMarkTicketListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOcrMarkTicketListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOcrMarkTicketListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOcrMarkTicketListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.OcrMarkTicket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOcrMarkTicketListResp}
 */
proto.xcommon.GetOcrMarkTicketListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOcrMarkTicketListResp;
  return proto.xcommon.GetOcrMarkTicketListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOcrMarkTicketListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOcrMarkTicketListResp}
 */
proto.xcommon.GetOcrMarkTicketListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.OcrMarkTicket;
      reader.readMessage(value,proto.xcommon.OcrMarkTicket.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOcrMarkTicketListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOcrMarkTicketListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOcrMarkTicketListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.OcrMarkTicket.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetOcrMarkTicketListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetOcrMarkTicketListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated OcrMarkTicket List = 3;
 * @return {!Array<!proto.xcommon.OcrMarkTicket>}
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.OcrMarkTicket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.OcrMarkTicket, 3));
};


/** @param {!Array<!proto.xcommon.OcrMarkTicket>} value */
proto.xcommon.GetOcrMarkTicketListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.OcrMarkTicket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OcrMarkTicket}
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.OcrMarkTicket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetOcrMarkTicketListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OcrMarkTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OcrMarkTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OcrMarkTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OcrMarkTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && proto.xcommon.Ticket.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    assignname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 4, ""),
    caseid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    ocrtype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    thirdid: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    thirdtime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    thirdstatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
    isout: jspb.Message.getFieldWithDefault(msg, 10, 0),
    markstatus: jspb.Message.getFieldWithDefault(msg, 11, 0),
    imgurl: jspb.Message.getFieldWithDefault(msg, 12, ""),
    imgbody: msg.getImgbody_asB64(),
    originresult: jspb.Message.getFieldWithDefault(msg, 14, ""),
    markresult: jspb.Message.getFieldWithDefault(msg, 15, ""),
    markattribute: jspb.Message.getFieldWithDefault(msg, 16, ""),
    nextticketid: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OcrMarkTicket}
 */
proto.xcommon.OcrMarkTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OcrMarkTicket;
  return proto.xcommon.OcrMarkTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OcrMarkTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OcrMarkTicket}
 */
proto.xcommon.OcrMarkTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.Ticket;
      reader.readMessage(value,proto.xcommon.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.OcrTypeEnum} */ (reader.readEnum());
      msg.setOcrtype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setThirdid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThirdtime(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.ThirdStatus} */ (reader.readEnum());
      msg.setThirdstatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsout(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.OcrMarkStatus} */ (reader.readEnum());
      msg.setMarkstatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setImgurl(value);
      break;
    case 13:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setImgbody(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginresult(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkresult(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkattribute(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextticketid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OcrMarkTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OcrMarkTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OcrMarkTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OcrMarkTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOcrtype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getThirdid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      7,
      f
    );
  }
  f = message.getThirdtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getThirdstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getIsout();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getMarkstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getImgurl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getImgbody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      13,
      f
    );
  }
  f = message.getOriginresult();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getMarkresult();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getMarkattribute();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getNextticketid();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.OcrMarkTicket.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Ticket, 1));
};


/** @param {?proto.xcommon.Ticket|undefined} value */
proto.xcommon.OcrMarkTicket.prototype.setTicket = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OcrMarkTicket.prototype.clearTicket = function() {
  this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OcrMarkTicket.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.OcrMarkTicket.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.OcrMarkTicket.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string AssignName = 3;
 * @return {string}
 */
proto.xcommon.OcrMarkTicket.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.OcrMarkTicket.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TicketStatus = 4;
 * @return {string}
 */
proto.xcommon.OcrMarkTicket.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.OcrMarkTicket.prototype.setTicketstatus = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 CaseId = 5;
 * @return {number}
 */
proto.xcommon.OcrMarkTicket.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.OcrMarkTicket.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional OcrTypeEnum OcrType = 6;
 * @return {!proto.xcommon.OcrTypeEnum}
 */
proto.xcommon.OcrMarkTicket.prototype.getOcrtype = function() {
  return /** @type {!proto.xcommon.OcrTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.OcrTypeEnum} value */
proto.xcommon.OcrMarkTicket.prototype.setOcrtype = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int64 ThirdId = 7;
 * @return {string}
 */
proto.xcommon.OcrMarkTicket.prototype.getThirdid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/** @param {string} value */
proto.xcommon.OcrMarkTicket.prototype.setThirdid = function(value) {
  jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional int64 ThirdTime = 8;
 * @return {number}
 */
proto.xcommon.OcrMarkTicket.prototype.getThirdtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.OcrMarkTicket.prototype.setThirdtime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional ThirdStatus ThirdStatus = 9;
 * @return {!proto.xcommon.ThirdStatus}
 */
proto.xcommon.OcrMarkTicket.prototype.getThirdstatus = function() {
  return /** @type {!proto.xcommon.ThirdStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.ThirdStatus} value */
proto.xcommon.OcrMarkTicket.prototype.setThirdstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional int32 IsOut = 10;
 * @return {number}
 */
proto.xcommon.OcrMarkTicket.prototype.getIsout = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.OcrMarkTicket.prototype.setIsout = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional OcrMarkStatus MarkStatus = 11;
 * @return {!proto.xcommon.OcrMarkStatus}
 */
proto.xcommon.OcrMarkTicket.prototype.getMarkstatus = function() {
  return /** @type {!proto.xcommon.OcrMarkStatus} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {!proto.xcommon.OcrMarkStatus} value */
proto.xcommon.OcrMarkTicket.prototype.setMarkstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string ImgUrl = 12;
 * @return {string}
 */
proto.xcommon.OcrMarkTicket.prototype.getImgurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.OcrMarkTicket.prototype.setImgurl = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bytes ImgBody = 13;
 * @return {!(string|Uint8Array)}
 */
proto.xcommon.OcrMarkTicket.prototype.getImgbody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * optional bytes ImgBody = 13;
 * This is a type-conversion wrapper around `getImgbody()`
 * @return {string}
 */
proto.xcommon.OcrMarkTicket.prototype.getImgbody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getImgbody()));
};


/**
 * optional bytes ImgBody = 13;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImgbody()`
 * @return {!Uint8Array}
 */
proto.xcommon.OcrMarkTicket.prototype.getImgbody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getImgbody()));
};


/** @param {!(string|Uint8Array)} value */
proto.xcommon.OcrMarkTicket.prototype.setImgbody = function(value) {
  jspb.Message.setProto3BytesField(this, 13, value);
};


/**
 * optional string OriginResult = 14;
 * @return {string}
 */
proto.xcommon.OcrMarkTicket.prototype.getOriginresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.OcrMarkTicket.prototype.setOriginresult = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string MarkResult = 15;
 * @return {string}
 */
proto.xcommon.OcrMarkTicket.prototype.getMarkresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.OcrMarkTicket.prototype.setMarkresult = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string MarkAttribute = 16;
 * @return {string}
 */
proto.xcommon.OcrMarkTicket.prototype.getMarkattribute = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.OcrMarkTicket.prototype.setMarkattribute = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 NextTicketId = 17;
 * @return {number}
 */
proto.xcommon.OcrMarkTicket.prototype.getNextticketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.OcrMarkTicket.prototype.setNextticketid = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOcrMarkCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOcrMarkCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOcrMarkCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOcrMarkCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOcrMarkCaseReq}
 */
proto.xcommon.GetOcrMarkCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOcrMarkCaseReq;
  return proto.xcommon.GetOcrMarkCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOcrMarkCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOcrMarkCaseReq}
 */
proto.xcommon.GetOcrMarkCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOcrMarkCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOcrMarkCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOcrMarkCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOcrMarkCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetOcrMarkCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetOcrMarkCaseReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOcrMarkCaseReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOcrMarkCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.GetOcrMarkCaseReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.GetOcrMarkCaseReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOcrMarkCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOcrMarkCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOcrMarkCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOcrMarkCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.OcrMarkTicket.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOcrMarkCaseResp}
 */
proto.xcommon.GetOcrMarkCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOcrMarkCaseResp;
  return proto.xcommon.GetOcrMarkCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOcrMarkCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOcrMarkCaseResp}
 */
proto.xcommon.GetOcrMarkCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.OcrMarkTicket;
      reader.readMessage(value,proto.xcommon.OcrMarkTicket.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOcrMarkCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOcrMarkCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOcrMarkCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOcrMarkCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.OcrMarkTicket.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetOcrMarkCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetOcrMarkCaseResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOcrMarkCaseResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOcrMarkCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OcrMarkTicket Data = 2;
 * @return {?proto.xcommon.OcrMarkTicket}
 */
proto.xcommon.GetOcrMarkCaseResp.prototype.getData = function() {
  return /** @type{?proto.xcommon.OcrMarkTicket} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.OcrMarkTicket, 2));
};


/** @param {?proto.xcommon.OcrMarkTicket|undefined} value */
proto.xcommon.GetOcrMarkCaseResp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetOcrMarkCaseResp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOcrMarkCaseResp.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveOcrMarkCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveOcrMarkCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveOcrMarkCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.OcrMarkTicket.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveOcrMarkCaseReq}
 */
proto.xcommon.SaveOcrMarkCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveOcrMarkCaseReq;
  return proto.xcommon.SaveOcrMarkCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveOcrMarkCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveOcrMarkCaseReq}
 */
proto.xcommon.SaveOcrMarkCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = new proto.xcommon.OcrMarkTicket;
      reader.readMessage(value,proto.xcommon.OcrMarkTicket.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveOcrMarkCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveOcrMarkCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveOcrMarkCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.OcrMarkTicket.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveOcrMarkCaseReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveOcrMarkCaseReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional OcrMarkTicket Data = 3;
 * @return {?proto.xcommon.OcrMarkTicket}
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.OcrMarkTicket} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.OcrMarkTicket, 3));
};


/** @param {?proto.xcommon.OcrMarkTicket|undefined} value */
proto.xcommon.SaveOcrMarkCaseReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveOcrMarkCaseReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveOcrMarkCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveOcrMarkCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveOcrMarkCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveOcrMarkCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveOcrMarkCaseResp}
 */
proto.xcommon.SaveOcrMarkCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveOcrMarkCaseResp;
  return proto.xcommon.SaveOcrMarkCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveOcrMarkCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveOcrMarkCaseResp}
 */
proto.xcommon.SaveOcrMarkCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveOcrMarkCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveOcrMarkCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveOcrMarkCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveOcrMarkCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveOcrMarkCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveOcrMarkCaseResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveOcrMarkCaseResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveOcrMarkCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPVOptionStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPVOptionStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPVOptionStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVOptionStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    daterange: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPVOptionStatsReq}
 */
proto.xcommon.GetPVOptionStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPVOptionStatsReq;
  return proto.xcommon.GetPVOptionStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPVOptionStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPVOptionStatsReq}
 */
proto.xcommon.GetPVOptionStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDaterange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPVOptionStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPVOptionStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPVOptionStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVOptionStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getDaterange();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetPVOptionStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetPVOptionStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetPVOptionStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPVOptionStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string DateRange = 2;
 * @return {string}
 */
proto.xcommon.GetPVOptionStatsReq.prototype.getDaterange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetPVOptionStatsReq.prototype.setDaterange = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetPVOptionStatsResp.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPVOptionStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPVOptionStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPVOptionStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVOptionStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    daysList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.GetPVOptionStatsResp.OneRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPVOptionStatsResp}
 */
proto.xcommon.GetPVOptionStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPVOptionStatsResp;
  return proto.xcommon.GetPVOptionStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPVOptionStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPVOptionStatsResp}
 */
proto.xcommon.GetPVOptionStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addDays(value);
      break;
    case 3:
      var value = new proto.xcommon.GetPVOptionStatsResp.OneRow;
      reader.readMessage(value,proto.xcommon.GetPVOptionStatsResp.OneRow.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPVOptionStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPVOptionStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPVOptionStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVOptionStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDaysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetPVOptionStatsResp.OneRow.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPVOptionStatsResp.OneRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPVOptionStatsResp.OneRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    option: jspb.Message.getFieldWithDefault(msg, 2, ""),
    daysList: jspb.Message.toObjectList(msg.getDaysList(),
    proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPVOptionStatsResp.OneRow}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPVOptionStatsResp.OneRow;
  return proto.xcommon.GetPVOptionStatsResp.OneRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPVOptionStatsResp.OneRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPVOptionStatsResp.OneRow}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOption(value);
      break;
    case 3:
      var value = new proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay;
      reader.readMessage(value,proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.deserializeBinaryFromReader);
      msg.addDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPVOptionStatsResp.OneRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPVOptionStatsResp.OneRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDaysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.toObject = function(includeInstance, msg) {
  var f, obj = {
    day: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rate: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay;
  return proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDay(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDay();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Day = 1;
 * @return {string}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.prototype.getDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.prototype.setDay = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Rate = 2;
 * @return {string}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.prototype.getRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay.prototype.setRate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TicketItemEnum TicketItemId = 1;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.TicketItemEnum} value */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Option = 2;
 * @return {string}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.getOption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.setOption = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated OneDay Days = 3;
 * @return {!Array<!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay>}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.getDaysList = function() {
  return /** @type{!Array<!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay, 3));
};


/** @param {!Array<!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay>} value */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.setDaysList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay}
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.addDays = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetPVOptionStatsResp.OneRow.OneDay, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetPVOptionStatsResp.OneRow.prototype.clearDaysList = function() {
  this.setDaysList([]);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetPVOptionStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetPVOptionStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetPVOptionStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPVOptionStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string Days = 2;
 * @return {!Array<string>}
 */
proto.xcommon.GetPVOptionStatsResp.prototype.getDaysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.GetPVOptionStatsResp.prototype.setDaysList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.GetPVOptionStatsResp.prototype.addDays = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetPVOptionStatsResp.prototype.clearDaysList = function() {
  this.setDaysList([]);
};


/**
 * repeated OneRow List = 3;
 * @return {!Array<!proto.xcommon.GetPVOptionStatsResp.OneRow>}
 */
proto.xcommon.GetPVOptionStatsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.GetPVOptionStatsResp.OneRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.GetPVOptionStatsResp.OneRow, 3));
};


/** @param {!Array<!proto.xcommon.GetPVOptionStatsResp.OneRow>} value */
proto.xcommon.GetPVOptionStatsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.GetPVOptionStatsResp.OneRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetPVOptionStatsResp.OneRow}
 */
proto.xcommon.GetPVOptionStatsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.GetPVOptionStatsResp.OneRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetPVOptionStatsResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WALoginStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WALoginStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WALoginStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WALoginStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WALoginStatusReq}
 */
proto.xcommon.WALoginStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WALoginStatusReq;
  return proto.xcommon.WALoginStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WALoginStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WALoginStatusReq}
 */
proto.xcommon.WALoginStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WALoginStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WALoginStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WALoginStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WALoginStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WALoginStatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WALoginStatusReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WALoginStatusReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WALoginStatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.WALoginStatusReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WALoginStatusReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WALoginStatusResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WALoginStatusResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WALoginStatusResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WALoginStatusResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WALoginStatusResp}
 */
proto.xcommon.WALoginStatusResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WALoginStatusResp;
  return proto.xcommon.WALoginStatusResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WALoginStatusResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WALoginStatusResp}
 */
proto.xcommon.WALoginStatusResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WALoginStatusResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WALoginStatusResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WALoginStatusResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WALoginStatusResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WALoginStatusResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WALoginStatusResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WALoginStatusResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WALoginStatusResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 Status = 2;
 * @return {number}
 */
proto.xcommon.WALoginStatusResp.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WALoginStatusResp.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetQRCodeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetQRCodeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetQRCodeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetQRCodeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetQRCodeReq}
 */
proto.xcommon.WAGetQRCodeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetQRCodeReq;
  return proto.xcommon.WAGetQRCodeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetQRCodeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetQRCodeReq}
 */
proto.xcommon.WAGetQRCodeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetQRCodeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetQRCodeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetQRCodeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetQRCodeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WAGetQRCodeReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WAGetQRCodeReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetQRCodeReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetQRCodeReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.WAGetQRCodeReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WAGetQRCodeReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetQRCodeResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetQRCodeResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetQRCodeResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetQRCodeResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetQRCodeResp}
 */
proto.xcommon.WAGetQRCodeResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetQRCodeResp;
  return proto.xcommon.WAGetQRCodeResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetQRCodeResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetQRCodeResp}
 */
proto.xcommon.WAGetQRCodeResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetQRCodeResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetQRCodeResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetQRCodeResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetQRCodeResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WAGetQRCodeResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WAGetQRCodeResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetQRCodeResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetQRCodeResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Url = 2;
 * @return {string}
 */
proto.xcommon.WAGetQRCodeResp.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WAGetQRCodeResp.prototype.setUrl = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WASendTextMsgReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WASendTextMsgReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WASendTextMsgReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WASendTextMsgReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountid: jspb.Message.getFieldWithDefault(msg, 8, "0"),
    urgetype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 11, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 12, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 13, "0"),
    overduecaseid: jspb.Message.getFieldWithDefault(msg, 14, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 15, 0),
    watextmsg: jspb.Message.getFieldWithDefault(msg, 17, ""),
    wamobile: jspb.Message.getFieldWithDefault(msg, 18, ""),
    source: jspb.Message.getFieldWithDefault(msg, 19, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WASendTextMsgReq}
 */
proto.xcommon.WASendTextMsgReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WASendTextMsgReq;
  return proto.xcommon.WASendTextMsgReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WASendTextMsgReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WASendTextMsgReq}
 */
proto.xcommon.WASendTextMsgReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.CollectionType} */ (reader.readEnum());
      msg.setUrgetype(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOverduecaseid(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setWatextmsg(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setWamobile(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WASendTextMsgReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WASendTextMsgReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WASendTextMsgReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WASendTextMsgReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      8,
      f
    );
  }
  f = message.getUrgetype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      13,
      f
    );
  }
  f = message.getOverduecaseid();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getWatextmsg();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getWamobile();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getSource();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WASendTextMsgReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WASendTextMsgReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WASendTextMsgReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WASendTextMsgReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.WASendTextMsgReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WASendTextMsgReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 AccountId = 8;
 * @return {string}
 */
proto.xcommon.WASendTextMsgReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/** @param {string} value */
proto.xcommon.WASendTextMsgReq.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 8, value);
};


/**
 * optional CollectionType UrgeType = 10;
 * @return {!proto.xcommon.CollectionType}
 */
proto.xcommon.WASendTextMsgReq.prototype.getUrgetype = function() {
  return /** @type {!proto.xcommon.CollectionType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.CollectionType} value */
proto.xcommon.WASendTextMsgReq.prototype.setUrgetype = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional int64 TicketId = 11;
 * @return {number}
 */
proto.xcommon.WASendTextMsgReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.WASendTextMsgReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 ItemId = 12;
 * @return {number}
 */
proto.xcommon.WASendTextMsgReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.WASendTextMsgReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 OrderId = 13;
 * @return {string}
 */
proto.xcommon.WASendTextMsgReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, "0"));
};


/** @param {string} value */
proto.xcommon.WASendTextMsgReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 13, value);
};


/**
 * optional int64 OverdueCaseId = 14;
 * @return {number}
 */
proto.xcommon.WASendTextMsgReq.prototype.getOverduecaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.WASendTextMsgReq.prototype.setOverduecaseid = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 PhoneObject = 15;
 * @return {number}
 */
proto.xcommon.WASendTextMsgReq.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.WASendTextMsgReq.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string WATextMsg = 17;
 * @return {string}
 */
proto.xcommon.WASendTextMsgReq.prototype.getWatextmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.xcommon.WASendTextMsgReq.prototype.setWatextmsg = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string WAMobile = 18;
 * @return {string}
 */
proto.xcommon.WASendTextMsgReq.prototype.getWamobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.xcommon.WASendTextMsgReq.prototype.setWamobile = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int32 Source = 19;
 * @return {number}
 */
proto.xcommon.WASendTextMsgReq.prototype.getSource = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.WASendTextMsgReq.prototype.setSource = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WASendTextMsgResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WASendTextMsgResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WASendTextMsgResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WASendTextMsgResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WASendTextMsgResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    sensitivecheckcode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sensitivecheckrespList: jspb.Message.toObjectList(msg.getSensitivecheckrespList(),
    proto.xcommon.WASensitiveCheck.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WASendTextMsgResp}
 */
proto.xcommon.WASendTextMsgResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WASendTextMsgResp;
  return proto.xcommon.WASendTextMsgResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WASendTextMsgResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WASendTextMsgResp}
 */
proto.xcommon.WASendTextMsgResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSensitivecheckcode(value);
      break;
    case 3:
      var value = new proto.xcommon.WASensitiveCheck;
      reader.readMessage(value,proto.xcommon.WASensitiveCheck.deserializeBinaryFromReader);
      msg.addSensitivecheckresp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WASendTextMsgResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WASendTextMsgResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WASendTextMsgResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WASendTextMsgResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSensitivecheckcode();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSensitivecheckrespList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.WASensitiveCheck.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WASendTextMsgResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WASendTextMsgResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WASendTextMsgResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WASendTextMsgResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 SensitiveCheckCode = 2;
 * @return {number}
 */
proto.xcommon.WASendTextMsgResp.prototype.getSensitivecheckcode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WASendTextMsgResp.prototype.setSensitivecheckcode = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated WASensitiveCheck SensitiveCheckResp = 3;
 * @return {!Array<!proto.xcommon.WASensitiveCheck>}
 */
proto.xcommon.WASendTextMsgResp.prototype.getSensitivecheckrespList = function() {
  return /** @type{!Array<!proto.xcommon.WASensitiveCheck>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WASensitiveCheck, 3));
};


/** @param {!Array<!proto.xcommon.WASensitiveCheck>} value */
proto.xcommon.WASendTextMsgResp.prototype.setSensitivecheckrespList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.WASensitiveCheck=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WASensitiveCheck}
 */
proto.xcommon.WASendTextMsgResp.prototype.addSensitivecheckresp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.WASensitiveCheck, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WASendTextMsgResp.prototype.clearSensitivecheckrespList = function() {
  this.setSensitivecheckrespList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WASensitiveCheck.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WASensitiveCheck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WASensitiveCheck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WASensitiveCheck.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    end: jspb.Message.getFieldWithDefault(msg, 2, 0),
    word: jspb.Message.getFieldWithDefault(msg, 3, ""),
    category: jspb.Message.getFieldWithDefault(msg, 4, 0),
    categoryname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WASensitiveCheck}
 */
proto.xcommon.WASensitiveCheck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WASensitiveCheck;
  return proto.xcommon.WASensitiveCheck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WASensitiveCheck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WASensitiveCheck}
 */
proto.xcommon.WASensitiveCheck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEnd(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWord(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WASensitiveCheck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WASensitiveCheck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WASensitiveCheck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WASensitiveCheck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWord();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCategoryname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 Start = 1;
 * @return {number}
 */
proto.xcommon.WASensitiveCheck.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.WASensitiveCheck.prototype.setStart = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 End = 2;
 * @return {number}
 */
proto.xcommon.WASensitiveCheck.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WASensitiveCheck.prototype.setEnd = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Word = 3;
 * @return {string}
 */
proto.xcommon.WASensitiveCheck.prototype.getWord = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WASensitiveCheck.prototype.setWord = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 Category = 4;
 * @return {number}
 */
proto.xcommon.WASensitiveCheck.prototype.getCategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.WASensitiveCheck.prototype.setCategory = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string CategoryName = 5;
 * @return {string}
 */
proto.xcommon.WASensitiveCheck.prototype.getCategoryname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.WASensitiveCheck.prototype.setCategoryname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPhoneSaleProductReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPhoneSaleProductReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPhoneSaleProductReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneSaleProductReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPhoneSaleProductReq}
 */
proto.xcommon.ListPhoneSaleProductReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPhoneSaleProductReq;
  return proto.xcommon.ListPhoneSaleProductReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPhoneSaleProductReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPhoneSaleProductReq}
 */
proto.xcommon.ListPhoneSaleProductReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPhoneSaleProductReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPhoneSaleProductReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPhoneSaleProductReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneSaleProductReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListPhoneSaleProductReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListPhoneSaleProductReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneSaleProductReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneSaleProductReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.ListPhoneSaleProductReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.ListPhoneSaleProductReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPhoneSaleProductResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPhoneSaleProductResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPhoneSaleProductResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneSaleProductResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    products: (f = msg.getProducts()) && xcommon_common_pb.WebPageTab.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPhoneSaleProductResp}
 */
proto.xcommon.ListPhoneSaleProductResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPhoneSaleProductResp;
  return proto.xcommon.ListPhoneSaleProductResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPhoneSaleProductResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPhoneSaleProductResp}
 */
proto.xcommon.ListPhoneSaleProductResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.WebPageTab;
      reader.readMessage(value,xcommon_common_pb.WebPageTab.deserializeBinaryFromReader);
      msg.setProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPhoneSaleProductResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPhoneSaleProductResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPhoneSaleProductResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPhoneSaleProductResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getProducts();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.WebPageTab.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListPhoneSaleProductResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListPhoneSaleProductResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneSaleProductResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneSaleProductResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional WebPageTab Products = 2;
 * @return {?proto.xcommon.WebPageTab}
 */
proto.xcommon.ListPhoneSaleProductResp.prototype.getProducts = function() {
  return /** @type{?proto.xcommon.WebPageTab} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.WebPageTab, 2));
};


/** @param {?proto.xcommon.WebPageTab|undefined} value */
proto.xcommon.ListPhoneSaleProductResp.prototype.setProducts = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPhoneSaleProductResp.prototype.clearProducts = function() {
  this.setProducts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPhoneSaleProductResp.prototype.hasProducts = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAMsgReadReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAMsgReadReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAMsgReadReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAMsgReadReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, ""),
    wamobile: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAMsgReadReq}
 */
proto.xcommon.WAMsgReadReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAMsgReadReq;
  return proto.xcommon.WAMsgReadReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAMsgReadReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAMsgReadReq}
 */
proto.xcommon.WAMsgReadReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWamobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAMsgReadReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAMsgReadReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAMsgReadReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAMsgReadReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWamobile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WAMsgReadReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WAMsgReadReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAMsgReadReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAMsgReadReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.WAMsgReadReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgReadReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string WAMobile = 3;
 * @return {string}
 */
proto.xcommon.WAMsgReadReq.prototype.getWamobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgReadReq.prototype.setWamobile = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAMsgReadResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAMsgReadResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAMsgReadResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAMsgReadResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAMsgReadResp}
 */
proto.xcommon.WAMsgReadResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAMsgReadResp;
  return proto.xcommon.WAMsgReadResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAMsgReadResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAMsgReadResp}
 */
proto.xcommon.WAMsgReadResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAMsgReadResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAMsgReadResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAMsgReadResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAMsgReadResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WAMsgReadResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WAMsgReadResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAMsgReadResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAMsgReadResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetMobileByUIDReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetMobileByUIDReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetMobileByUIDReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMobileByUIDReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetMobileByUIDReq}
 */
proto.xcommon.WAGetMobileByUIDReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetMobileByUIDReq;
  return proto.xcommon.WAGetMobileByUIDReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetMobileByUIDReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetMobileByUIDReq}
 */
proto.xcommon.WAGetMobileByUIDReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetMobileByUIDReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetMobileByUIDReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetMobileByUIDReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMobileByUIDReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WAGetMobileByUIDReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WAGetMobileByUIDReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetMobileByUIDReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetMobileByUIDReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.xcommon.WAGetMobileByUIDReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WAGetMobileByUIDReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WAGetMobileByUIDResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetMobileByUIDResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetMobileByUIDResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetMobileByUIDResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMobileByUIDResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    infoList: jspb.Message.toObjectList(msg.getInfoList(),
    proto.xcommon.WAGetMobileByUIDResp.GroupInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetMobileByUIDResp}
 */
proto.xcommon.WAGetMobileByUIDResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetMobileByUIDResp;
  return proto.xcommon.WAGetMobileByUIDResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetMobileByUIDResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetMobileByUIDResp}
 */
proto.xcommon.WAGetMobileByUIDResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.WAGetMobileByUIDResp.GroupInfo;
      reader.readMessage(value,proto.xcommon.WAGetMobileByUIDResp.GroupInfo.deserializeBinaryFromReader);
      msg.addInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetMobileByUIDResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetMobileByUIDResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetMobileByUIDResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMobileByUIDResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.WAGetMobileByUIDResp.GroupInfo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetMobileByUIDResp.ChatInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetMobileByUIDResp.ChatInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    recvmobile: jspb.Message.getFieldWithDefault(msg, 1, ""),
    unreadnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    showname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sendaccounttype: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetMobileByUIDResp.ChatInfo}
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetMobileByUIDResp.ChatInfo;
  return proto.xcommon.WAGetMobileByUIDResp.ChatInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetMobileByUIDResp.ChatInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetMobileByUIDResp.ChatInfo}
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecvmobile(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnreadnum(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShowname(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSendaccounttype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetMobileByUIDResp.ChatInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetMobileByUIDResp.ChatInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecvmobile();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnreadnum();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getShowname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSendaccounttype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string RecvMobile = 1;
 * @return {string}
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.getRecvmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.setRecvmobile = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 UnReadNum = 2;
 * @return {number}
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.getUnreadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.setUnreadnum = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ShowName = 3;
 * @return {string}
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.getShowname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.setShowname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 SendAccountType = 4;
 * @return {number}
 */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.getSendaccounttype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.WAGetMobileByUIDResp.ChatInfo.prototype.setSendaccounttype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetMobileByUIDResp.GroupInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetMobileByUIDResp.GroupInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendmobile: jspb.Message.getFieldWithDefault(msg, 1, ""),
    unreadnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    infoList: jspb.Message.toObjectList(msg.getInfoList(),
    proto.xcommon.WAGetMobileByUIDResp.ChatInfo.toObject, includeInstance),
    sendaccounttype: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetMobileByUIDResp.GroupInfo}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetMobileByUIDResp.GroupInfo;
  return proto.xcommon.WAGetMobileByUIDResp.GroupInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetMobileByUIDResp.GroupInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetMobileByUIDResp.GroupInfo}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSendmobile(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnreadnum(value);
      break;
    case 3:
      var value = new proto.xcommon.WAGetMobileByUIDResp.ChatInfo;
      reader.readMessage(value,proto.xcommon.WAGetMobileByUIDResp.ChatInfo.deserializeBinaryFromReader);
      msg.addInfo(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSendaccounttype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetMobileByUIDResp.GroupInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetMobileByUIDResp.GroupInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendmobile();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnreadnum();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.WAGetMobileByUIDResp.ChatInfo.serializeBinaryToWriter
    );
  }
  f = message.getSendaccounttype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string SendMobile = 1;
 * @return {string}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.getSendmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.setSendmobile = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 UnReadNum = 2;
 * @return {number}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.getUnreadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.setUnreadnum = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated ChatInfo Info = 3;
 * @return {!Array<!proto.xcommon.WAGetMobileByUIDResp.ChatInfo>}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.getInfoList = function() {
  return /** @type{!Array<!proto.xcommon.WAGetMobileByUIDResp.ChatInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WAGetMobileByUIDResp.ChatInfo, 3));
};


/** @param {!Array<!proto.xcommon.WAGetMobileByUIDResp.ChatInfo>} value */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.setInfoList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.WAGetMobileByUIDResp.ChatInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WAGetMobileByUIDResp.ChatInfo}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.addInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.WAGetMobileByUIDResp.ChatInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.clearInfoList = function() {
  this.setInfoList([]);
};


/**
 * optional int32 SendAccountType = 4;
 * @return {number}
 */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.getSendaccounttype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.WAGetMobileByUIDResp.GroupInfo.prototype.setSendaccounttype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WAGetMobileByUIDResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WAGetMobileByUIDResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetMobileByUIDResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetMobileByUIDResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated GroupInfo Info = 2;
 * @return {!Array<!proto.xcommon.WAGetMobileByUIDResp.GroupInfo>}
 */
proto.xcommon.WAGetMobileByUIDResp.prototype.getInfoList = function() {
  return /** @type{!Array<!proto.xcommon.WAGetMobileByUIDResp.GroupInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WAGetMobileByUIDResp.GroupInfo, 2));
};


/** @param {!Array<!proto.xcommon.WAGetMobileByUIDResp.GroupInfo>} value */
proto.xcommon.WAGetMobileByUIDResp.prototype.setInfoList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.WAGetMobileByUIDResp.GroupInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WAGetMobileByUIDResp.GroupInfo}
 */
proto.xcommon.WAGetMobileByUIDResp.prototype.addInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.WAGetMobileByUIDResp.GroupInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WAGetMobileByUIDResp.prototype.clearInfoList = function() {
  this.setInfoList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetParamByUIDReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetParamByUIDReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetParamByUIDReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetParamByUIDReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    casename: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetParamByUIDReq}
 */
proto.xcommon.WAGetParamByUIDReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetParamByUIDReq;
  return proto.xcommon.WAGetParamByUIDReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetParamByUIDReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetParamByUIDReq}
 */
proto.xcommon.WAGetParamByUIDReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetParamByUIDReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetParamByUIDReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetParamByUIDReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetParamByUIDReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WAGetParamByUIDReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WAGetParamByUIDReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetParamByUIDReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetParamByUIDReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.xcommon.WAGetParamByUIDReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WAGetParamByUIDReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.WAGetParamByUIDReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.WAGetParamByUIDReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string CaseName = 4;
 * @return {string}
 */
proto.xcommon.WAGetParamByUIDReq.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.WAGetParamByUIDReq.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WAGetParamByUIDResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetParamByUIDResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetParamByUIDResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetParamByUIDResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetParamByUIDResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    templateList: jspb.Message.toObjectList(msg.getTemplateList(),
    proto.xcommon.WAGetParamByUIDResp.PushTemplate.toObject, includeInstance),
    ispoll: jspb.Message.getFieldWithDefault(msg, 3, 0),
    custommessage: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetParamByUIDResp}
 */
proto.xcommon.WAGetParamByUIDResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetParamByUIDResp;
  return proto.xcommon.WAGetParamByUIDResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetParamByUIDResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetParamByUIDResp}
 */
proto.xcommon.WAGetParamByUIDResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.WAGetParamByUIDResp.PushTemplate;
      reader.readMessage(value,proto.xcommon.WAGetParamByUIDResp.PushTemplate.deserializeBinaryFromReader);
      msg.addTemplate(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIspoll(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setCustommessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetParamByUIDResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetParamByUIDResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetParamByUIDResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetParamByUIDResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTemplateList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.WAGetParamByUIDResp.PushTemplate.serializeBinaryToWriter
    );
  }
  f = message.getIspoll();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCustommessage();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetParamByUIDResp.PushTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetParamByUIDResp.PushTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetParamByUIDResp.PushTemplate}
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetParamByUIDResp.PushTemplate;
  return proto.xcommon.WAGetParamByUIDResp.PushTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetParamByUIDResp.PushTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetParamByUIDResp.PushTemplate}
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetParamByUIDResp.PushTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetParamByUIDResp.PushTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Title = 1;
 * @return {string}
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Content = 2;
 * @return {string}
 */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WAGetParamByUIDResp.PushTemplate.prototype.setContent = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WAGetParamByUIDResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WAGetParamByUIDResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetParamByUIDResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetParamByUIDResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated PushTemplate Template = 2;
 * @return {!Array<!proto.xcommon.WAGetParamByUIDResp.PushTemplate>}
 */
proto.xcommon.WAGetParamByUIDResp.prototype.getTemplateList = function() {
  return /** @type{!Array<!proto.xcommon.WAGetParamByUIDResp.PushTemplate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WAGetParamByUIDResp.PushTemplate, 2));
};


/** @param {!Array<!proto.xcommon.WAGetParamByUIDResp.PushTemplate>} value */
proto.xcommon.WAGetParamByUIDResp.prototype.setTemplateList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.WAGetParamByUIDResp.PushTemplate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WAGetParamByUIDResp.PushTemplate}
 */
proto.xcommon.WAGetParamByUIDResp.prototype.addTemplate = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.WAGetParamByUIDResp.PushTemplate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WAGetParamByUIDResp.prototype.clearTemplateList = function() {
  this.setTemplateList([]);
};


/**
 * optional Bool IsPoll = 3;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.WAGetParamByUIDResp.prototype.getIspoll = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.WAGetParamByUIDResp.prototype.setIspoll = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Bool CustomMessage = 4;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.WAGetParamByUIDResp.prototype.getCustommessage = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.WAGetParamByUIDResp.prototype.setCustommessage = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetChatByMobileReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetChatByMobileReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetChatByMobileReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetChatByMobileReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetChatByMobileReq}
 */
proto.xcommon.WAGetChatByMobileReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetChatByMobileReq;
  return proto.xcommon.WAGetChatByMobileReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetChatByMobileReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetChatByMobileReq}
 */
proto.xcommon.WAGetChatByMobileReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetChatByMobileReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetChatByMobileReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetChatByMobileReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetChatByMobileReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WAGetChatByMobileReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WAGetChatByMobileReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetChatByMobileReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetChatByMobileReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.WAGetChatByMobileReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WAGetChatByMobileReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WAGetChatByMobileResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetChatByMobileResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetChatByMobileResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetChatByMobileResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetChatByMobileResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    chatList: jspb.Message.toObjectList(msg.getChatList(),
    proto.xcommon.WAGetChatByMobileResp.ChatInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetChatByMobileResp}
 */
proto.xcommon.WAGetChatByMobileResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetChatByMobileResp;
  return proto.xcommon.WAGetChatByMobileResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetChatByMobileResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetChatByMobileResp}
 */
proto.xcommon.WAGetChatByMobileResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.WAGetChatByMobileResp.ChatInfo;
      reader.readMessage(value,proto.xcommon.WAGetChatByMobileResp.ChatInfo.deserializeBinaryFromReader);
      msg.addChat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetChatByMobileResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetChatByMobileResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetChatByMobileResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetChatByMobileResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getChatList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.WAGetChatByMobileResp.ChatInfo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetChatByMobileResp.ChatInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetChatByMobileResp.ChatInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    recvmobile: jspb.Message.getFieldWithDefault(msg, 1, ""),
    showname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lastmessage: (f = msg.getLastmessage()) && proto.xcommon.WAMsgInfo.toObject(includeInstance, f),
    sendmobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    islogin: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sendaccounttype: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetChatByMobileResp.ChatInfo}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetChatByMobileResp.ChatInfo;
  return proto.xcommon.WAGetChatByMobileResp.ChatInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetChatByMobileResp.ChatInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetChatByMobileResp.ChatInfo}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecvmobile(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShowname(value);
      break;
    case 3:
      var value = new proto.xcommon.WAMsgInfo;
      reader.readMessage(value,proto.xcommon.WAMsgInfo.deserializeBinaryFromReader);
      msg.setLastmessage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSendmobile(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIslogin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSendaccounttype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetChatByMobileResp.ChatInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetChatByMobileResp.ChatInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecvmobile();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShowname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastmessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.WAMsgInfo.serializeBinaryToWriter
    );
  }
  f = message.getSendmobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIslogin();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSendaccounttype();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string RecvMobile = 1;
 * @return {string}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.getRecvmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.setRecvmobile = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ShowName = 2;
 * @return {string}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.getShowname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.setShowname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional WAMsgInfo LastMessage = 3;
 * @return {?proto.xcommon.WAMsgInfo}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.getLastmessage = function() {
  return /** @type{?proto.xcommon.WAMsgInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.WAMsgInfo, 3));
};


/** @param {?proto.xcommon.WAMsgInfo|undefined} value */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.setLastmessage = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.clearLastmessage = function() {
  this.setLastmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.hasLastmessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string SendMobile = 4;
 * @return {string}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.getSendmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.setSendmobile = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 IsLogin = 5;
 * @return {number}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.getIslogin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.setIslogin = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 SendAccountType = 6;
 * @return {number}
 */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.getSendaccounttype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.WAGetChatByMobileResp.ChatInfo.prototype.setSendaccounttype = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WAGetChatByMobileResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WAGetChatByMobileResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetChatByMobileResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetChatByMobileResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ChatInfo Chat = 2;
 * @return {!Array<!proto.xcommon.WAGetChatByMobileResp.ChatInfo>}
 */
proto.xcommon.WAGetChatByMobileResp.prototype.getChatList = function() {
  return /** @type{!Array<!proto.xcommon.WAGetChatByMobileResp.ChatInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WAGetChatByMobileResp.ChatInfo, 2));
};


/** @param {!Array<!proto.xcommon.WAGetChatByMobileResp.ChatInfo>} value */
proto.xcommon.WAGetChatByMobileResp.prototype.setChatList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.WAGetChatByMobileResp.ChatInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WAGetChatByMobileResp.ChatInfo}
 */
proto.xcommon.WAGetChatByMobileResp.prototype.addChat = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.WAGetChatByMobileResp.ChatInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WAGetChatByMobileResp.prototype.clearChatList = function() {
  this.setChatList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetMsgByMobileReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetMsgByMobileReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetMsgByMobileReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMsgByMobileReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, ""),
    recvmobile: jspb.Message.getFieldWithDefault(msg, 3, ""),
    offset: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetMsgByMobileReq}
 */
proto.xcommon.WAGetMsgByMobileReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetMsgByMobileReq;
  return proto.xcommon.WAGetMsgByMobileReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetMsgByMobileReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetMsgByMobileReq}
 */
proto.xcommon.WAGetMsgByMobileReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecvmobile(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetMsgByMobileReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetMsgByMobileReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetMsgByMobileReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMsgByMobileReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecvmobile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOffset();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WAGetMsgByMobileReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WAGetMsgByMobileReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetMsgByMobileReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetMsgByMobileReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.WAGetMsgByMobileReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WAGetMsgByMobileReq.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string RecvMobile = 3;
 * @return {string}
 */
proto.xcommon.WAGetMsgByMobileReq.prototype.getRecvmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WAGetMsgByMobileReq.prototype.setRecvmobile = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Offset = 4;
 * @return {string}
 */
proto.xcommon.WAGetMsgByMobileReq.prototype.getOffset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.WAGetMsgByMobileReq.prototype.setOffset = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAMsgInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAMsgInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAMsgInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAMsgInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    messageid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    remotejid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fromme: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    messagetimestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    messagetype: jspb.Message.getFieldWithDefault(msg, 6, ""),
    messagecontent: jspb.Message.getFieldWithDefault(msg, 7, ""),
    messagejsonstr: jspb.Message.getFieldWithDefault(msg, 8, ""),
    keyjsonstr: jspb.Message.getFieldWithDefault(msg, 9, ""),
    totaljsonstr: jspb.Message.getFieldWithDefault(msg, 10, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAMsgInfo}
 */
proto.xcommon.WAMsgInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAMsgInfo;
  return proto.xcommon.WAMsgInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAMsgInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAMsgInfo}
 */
proto.xcommon.WAMsgInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemotejid(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFromme(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMessagetimestamp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessagetype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessagecontent(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessagejsonstr(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyjsonstr(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotaljsonstr(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAMsgInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAMsgInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAMsgInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAMsgInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessageid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRemotejid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFromme();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMessagetimestamp();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMessagetype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMessagecontent();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMessagejsonstr();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getKeyjsonstr();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTotaljsonstr();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string MessageId = 1;
 * @return {string}
 */
proto.xcommon.WAMsgInfo.prototype.getMessageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgInfo.prototype.setMessageid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string RemoteJid = 2;
 * @return {string}
 */
proto.xcommon.WAMsgInfo.prototype.getRemotejid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgInfo.prototype.setRemotejid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool FromMe = 3;
 * @return {boolean}
 */
proto.xcommon.WAMsgInfo.prototype.getFromme = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.xcommon.WAMsgInfo.prototype.setFromme = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int64 MessageTimestamp = 4;
 * @return {number}
 */
proto.xcommon.WAMsgInfo.prototype.getMessagetimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.WAMsgInfo.prototype.setMessagetimestamp = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 Status = 5;
 * @return {number}
 */
proto.xcommon.WAMsgInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.WAMsgInfo.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string MessageType = 6;
 * @return {string}
 */
proto.xcommon.WAMsgInfo.prototype.getMessagetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgInfo.prototype.setMessagetype = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string MessageContent = 7;
 * @return {string}
 */
proto.xcommon.WAMsgInfo.prototype.getMessagecontent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgInfo.prototype.setMessagecontent = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string MessageJsonStr = 8;
 * @return {string}
 */
proto.xcommon.WAMsgInfo.prototype.getMessagejsonstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgInfo.prototype.setMessagejsonstr = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string KeyJsonStr = 9;
 * @return {string}
 */
proto.xcommon.WAMsgInfo.prototype.getKeyjsonstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgInfo.prototype.setKeyjsonstr = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string TotalJsonStr = 10;
 * @return {string}
 */
proto.xcommon.WAMsgInfo.prototype.getTotaljsonstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgInfo.prototype.setTotaljsonstr = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Phone = 11;
 * @return {string}
 */
proto.xcommon.WAMsgInfo.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.WAMsgInfo.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WAGetMsgByMobileResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAGetMsgByMobileResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAGetMsgByMobileResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMsgByMobileResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    msgList: jspb.Message.toObjectList(msg.getMsgList(),
    proto.xcommon.WAMsgInfo.toObject, includeInstance),
    offset: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAGetMsgByMobileResp}
 */
proto.xcommon.WAGetMsgByMobileResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAGetMsgByMobileResp;
  return proto.xcommon.WAGetMsgByMobileResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAGetMsgByMobileResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAGetMsgByMobileResp}
 */
proto.xcommon.WAGetMsgByMobileResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.WAMsgInfo;
      reader.readMessage(value,proto.xcommon.WAMsgInfo.deserializeBinaryFromReader);
      msg.addMsg(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAGetMsgByMobileResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAGetMsgByMobileResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAGetMsgByMobileResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getMsgList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.WAMsgInfo.serializeBinaryToWriter
    );
  }
  f = message.getOffset();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WAGetMsgByMobileResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated WAMsgInfo Msg = 2;
 * @return {!Array<!proto.xcommon.WAMsgInfo>}
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.getMsgList = function() {
  return /** @type{!Array<!proto.xcommon.WAMsgInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WAMsgInfo, 2));
};


/** @param {!Array<!proto.xcommon.WAMsgInfo>} value */
proto.xcommon.WAGetMsgByMobileResp.prototype.setMsgList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.WAMsgInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WAMsgInfo}
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.addMsg = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.WAMsgInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.clearMsgList = function() {
  this.setMsgList([]);
};


/**
 * optional string Offset = 3;
 * @return {string}
 */
proto.xcommon.WAGetMsgByMobileResp.prototype.getOffset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WAGetMsgByMobileResp.prototype.setOffset = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ImportWAPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ImportWAPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ImportWAPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ImportWAPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    phone: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ImportWAPhoneReq}
 */
proto.xcommon.ImportWAPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ImportWAPhoneReq;
  return proto.xcommon.ImportWAPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ImportWAPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ImportWAPhoneReq}
 */
proto.xcommon.ImportWAPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ImportWAPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ImportWAPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ImportWAPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ImportWAPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ImportWAPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ImportWAPhoneReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ImportWAPhoneReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ImportWAPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Phone = 2;
 * @return {string}
 */
proto.xcommon.ImportWAPhoneReq.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ImportWAPhoneReq.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 Type = 3;
 * @return {number}
 */
proto.xcommon.ImportWAPhoneReq.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.ImportWAPhoneReq.prototype.setType = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ImportWAPhoneResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ImportWAPhoneResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ImportWAPhoneResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ImportWAPhoneResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ImportWAPhoneResp}
 */
proto.xcommon.ImportWAPhoneResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ImportWAPhoneResp;
  return proto.xcommon.ImportWAPhoneResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ImportWAPhoneResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ImportWAPhoneResp}
 */
proto.xcommon.ImportWAPhoneResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ImportWAPhoneResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ImportWAPhoneResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ImportWAPhoneResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ImportWAPhoneResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ImportWAPhoneResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ImportWAPhoneResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ImportWAPhoneResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ImportWAPhoneResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
    assignuid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isassign: jspb.Message.getFieldWithDefault(msg, 5, 0),
    islogin: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAListReq}
 */
proto.xcommon.WAListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAListReq;
  return proto.xcommon.WAListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAListReq}
 */
proto.xcommon.WAListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsassign(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIslogin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getIsassign();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIslogin();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.WAListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.WAListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.WAListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.WAListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Phone = 3;
 * @return {string}
 */
proto.xcommon.WAListReq.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WAListReq.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 AssignUid = 4;
 * @return {number}
 */
proto.xcommon.WAListReq.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.WAListReq.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional Bool IsAssign = 5;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.WAListReq.prototype.getIsassign = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.WAListReq.prototype.setIsassign = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Bool IsLogin = 6;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.WAListReq.prototype.getIslogin = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.WAListReq.prototype.setIslogin = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WAListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.WAInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAListResp}
 */
proto.xcommon.WAListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAListResp;
  return proto.xcommon.WAListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAListResp}
 */
proto.xcommon.WAListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.WAInfo;
      reader.readMessage(value,proto.xcommon.WAInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.WAInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WAListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.WAListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.WAListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.WAListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.WAListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WAListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated WAInfo List = 3;
 * @return {!Array<!proto.xcommon.WAInfo>}
 */
proto.xcommon.WAListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.WAInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WAInfo, 3));
};


/** @param {!Array<!proto.xcommon.WAInfo>} value */
proto.xcommon.WAListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.WAInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WAInfo}
 */
proto.xcommon.WAListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.WAInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.WAListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WAInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WAInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WAInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    assignuid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
    assignstatus: jspb.Message.getFieldWithDefault(msg, 4, ""),
    loginstatus: jspb.Message.getFieldWithDefault(msg, 5, ""),
    islogin: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assignstatusenum: jspb.Message.getFieldWithDefault(msg, 7, 0),
    token: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WAInfo}
 */
proto.xcommon.WAInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WAInfo;
  return proto.xcommon.WAInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WAInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WAInfo}
 */
proto.xcommon.WAInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignstatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginstatus(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIslogin(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignstatusenum(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WAInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WAInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WAInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WAInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssignstatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLoginstatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIslogin();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAssignstatusenum();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.WAInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.WAInfo.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 AssignUid = 2;
 * @return {number}
 */
proto.xcommon.WAInfo.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WAInfo.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Phone = 3;
 * @return {string}
 */
proto.xcommon.WAInfo.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.WAInfo.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AssignStatus = 4;
 * @return {string}
 */
proto.xcommon.WAInfo.prototype.getAssignstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.WAInfo.prototype.setAssignstatus = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string LoginStatus = 5;
 * @return {string}
 */
proto.xcommon.WAInfo.prototype.getLoginstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.WAInfo.prototype.setLoginstatus = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Bool IsLogin = 6;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.WAInfo.prototype.getIslogin = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.WAInfo.prototype.setIslogin = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 AssignStatusEnum = 7;
 * @return {number}
 */
proto.xcommon.WAInfo.prototype.getAssignstatusenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.WAInfo.prototype.setAssignstatusenum = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string Token = 8;
 * @return {string}
 */
proto.xcommon.WAInfo.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.WAInfo.prototype.setToken = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssignWAPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssignWAPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssignWAPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignWAPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    assignuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssignWAPhoneReq}
 */
proto.xcommon.AssignWAPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssignWAPhoneReq;
  return proto.xcommon.AssignWAPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssignWAPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssignWAPhoneReq}
 */
proto.xcommon.AssignWAPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssignWAPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssignWAPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssignWAPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignWAPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.AssignWAPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.AssignWAPhoneReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AssignWAPhoneReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignWAPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.AssignWAPhoneReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.AssignWAPhoneReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AssignUid = 3;
 * @return {number}
 */
proto.xcommon.AssignWAPhoneReq.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.AssignWAPhoneReq.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 OpUid = 4;
 * @return {number}
 */
proto.xcommon.AssignWAPhoneReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.AssignWAPhoneReq.prototype.setOpuid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AssignWAPhoneResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AssignWAPhoneResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AssignWAPhoneResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignWAPhoneResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AssignWAPhoneResp}
 */
proto.xcommon.AssignWAPhoneResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AssignWAPhoneResp;
  return proto.xcommon.AssignWAPhoneResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AssignWAPhoneResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AssignWAPhoneResp}
 */
proto.xcommon.AssignWAPhoneResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AssignWAPhoneResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AssignWAPhoneResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AssignWAPhoneResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AssignWAPhoneResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.AssignWAPhoneResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.AssignWAPhoneResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AssignWAPhoneResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AssignWAPhoneResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MarkWAPhoneReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MarkWAPhoneReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MarkWAPhoneReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarkWAPhoneReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    marktype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MarkWAPhoneReq}
 */
proto.xcommon.MarkWAPhoneReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MarkWAPhoneReq;
  return proto.xcommon.MarkWAPhoneReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MarkWAPhoneReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MarkWAPhoneReq}
 */
proto.xcommon.MarkWAPhoneReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.MarkWAType} */ (reader.readEnum());
      msg.setMarktype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MarkWAPhoneReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MarkWAPhoneReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MarkWAPhoneReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarkWAPhoneReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMarktype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.MarkWAPhoneReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.MarkWAPhoneReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.MarkWAPhoneReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.MarkWAPhoneReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.MarkWAPhoneReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.MarkWAPhoneReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional MarkWAType MarkType = 3;
 * @return {!proto.xcommon.MarkWAType}
 */
proto.xcommon.MarkWAPhoneReq.prototype.getMarktype = function() {
  return /** @type {!proto.xcommon.MarkWAType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.MarkWAType} value */
proto.xcommon.MarkWAPhoneReq.prototype.setMarktype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 OpUid = 4;
 * @return {number}
 */
proto.xcommon.MarkWAPhoneReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.MarkWAPhoneReq.prototype.setOpuid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MarkWAPhoneResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MarkWAPhoneResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MarkWAPhoneResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarkWAPhoneResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MarkWAPhoneResp}
 */
proto.xcommon.MarkWAPhoneResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MarkWAPhoneResp;
  return proto.xcommon.MarkWAPhoneResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MarkWAPhoneResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MarkWAPhoneResp}
 */
proto.xcommon.MarkWAPhoneResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MarkWAPhoneResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MarkWAPhoneResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MarkWAPhoneResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarkWAPhoneResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.MarkWAPhoneResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.MarkWAPhoneResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.MarkWAPhoneResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.MarkWAPhoneResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWaKeywordListParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWaKeywordListParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWaKeywordListParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordListParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWaKeywordListParamReq}
 */
proto.xcommon.GetWaKeywordListParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWaKeywordListParamReq;
  return proto.xcommon.GetWaKeywordListParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWaKeywordListParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWaKeywordListParamReq}
 */
proto.xcommon.GetWaKeywordListParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWaKeywordListParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWaKeywordListParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWaKeywordListParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordListParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetWaKeywordListParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetWaKeywordListParamReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordListParamReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordListParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWaKeywordListParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWaKeywordListParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordListParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    typemapMap: (f = msg.getTypemapMap()) ? f.toObject(includeInstance, undefined) : [],
    blacklistcategorymapMap: (f = msg.getBlacklistcategorymapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWaKeywordListParamResp}
 */
proto.xcommon.GetWaKeywordListParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWaKeywordListParamResp;
  return proto.xcommon.GetWaKeywordListParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWaKeywordListParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWaKeywordListParamResp}
 */
proto.xcommon.GetWaKeywordListParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getTypemapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 3:
      var value = msg.getBlacklistcategorymapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWaKeywordListParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWaKeywordListParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordListParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTypemapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getBlacklistcategorymapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetWaKeywordListParamResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int32, string> TypeMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.getTypemapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.clearTypemapMap = function() {
  this.getTypemapMap().clear();
};


/**
 * map<int32, string> BlackListCategoryMap = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.getBlacklistcategorymapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.GetWaKeywordListParamResp.prototype.clearBlacklistcategorymapMap = function() {
  this.getBlacklistcategorymapMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWaKeywordListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWaKeywordListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWaKeywordListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.WaKeywordData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWaKeywordListReq}
 */
proto.xcommon.GetWaKeywordListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWaKeywordListReq;
  return proto.xcommon.GetWaKeywordListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWaKeywordListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWaKeywordListReq}
 */
proto.xcommon.GetWaKeywordListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = new proto.xcommon.WaKeywordData;
      reader.readMessage(value,proto.xcommon.WaKeywordData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWaKeywordListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWaKeywordListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWaKeywordListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.WaKeywordData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetWaKeywordListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetWaKeywordListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetWaKeywordListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetWaKeywordListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional WaKeywordData Data = 3;
 * @return {?proto.xcommon.WaKeywordData}
 */
proto.xcommon.GetWaKeywordListReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.WaKeywordData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.WaKeywordData, 3));
};


/** @param {?proto.xcommon.WaKeywordData|undefined} value */
proto.xcommon.GetWaKeywordListReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordListReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordListReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetWaKeywordListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWaKeywordListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWaKeywordListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWaKeywordListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.WaKeywordData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWaKeywordListResp}
 */
proto.xcommon.GetWaKeywordListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWaKeywordListResp;
  return proto.xcommon.GetWaKeywordListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWaKeywordListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWaKeywordListResp}
 */
proto.xcommon.GetWaKeywordListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.WaKeywordData;
      reader.readMessage(value,proto.xcommon.WaKeywordData.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWaKeywordListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWaKeywordListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWaKeywordListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.WaKeywordData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetWaKeywordListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetWaKeywordListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetWaKeywordListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetWaKeywordListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated WaKeywordData List = 3;
 * @return {!Array<!proto.xcommon.WaKeywordData>}
 */
proto.xcommon.GetWaKeywordListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.WaKeywordData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.WaKeywordData, 3));
};


/** @param {!Array<!proto.xcommon.WaKeywordData>} value */
proto.xcommon.GetWaKeywordListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.WaKeywordData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WaKeywordData}
 */
proto.xcommon.GetWaKeywordListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.WaKeywordData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetWaKeywordListResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWaKeywordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWaKeywordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWaKeywordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWaKeywordReq}
 */
proto.xcommon.GetWaKeywordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWaKeywordReq;
  return proto.xcommon.GetWaKeywordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWaKeywordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWaKeywordReq}
 */
proto.xcommon.GetWaKeywordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWaKeywordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWaKeywordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWaKeywordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetWaKeywordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetWaKeywordReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetWaKeywordReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetWaKeywordReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 Id = 3;
 * @return {number}
 */
proto.xcommon.GetWaKeywordReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetWaKeywordReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWaKeywordResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWaKeywordResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWaKeywordResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.WaKeywordData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWaKeywordResp}
 */
proto.xcommon.GetWaKeywordResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWaKeywordResp;
  return proto.xcommon.GetWaKeywordResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWaKeywordResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWaKeywordResp}
 */
proto.xcommon.GetWaKeywordResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.WaKeywordData;
      reader.readMessage(value,proto.xcommon.WaKeywordData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWaKeywordResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWaKeywordResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWaKeywordResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWaKeywordResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.WaKeywordData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetWaKeywordResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetWaKeywordResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional WaKeywordData Data = 2;
 * @return {?proto.xcommon.WaKeywordData}
 */
proto.xcommon.GetWaKeywordResp.prototype.getData = function() {
  return /** @type{?proto.xcommon.WaKeywordData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.WaKeywordData, 2));
};


/** @param {?proto.xcommon.WaKeywordData|undefined} value */
proto.xcommon.GetWaKeywordResp.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetWaKeywordResp.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWaKeywordResp.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveWaKeywordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveWaKeywordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveWaKeywordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveWaKeywordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    data: (f = msg.getData()) && proto.xcommon.WaKeywordData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveWaKeywordReq}
 */
proto.xcommon.SaveWaKeywordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveWaKeywordReq;
  return proto.xcommon.SaveWaKeywordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveWaKeywordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveWaKeywordReq}
 */
proto.xcommon.SaveWaKeywordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.xcommon.WaKeywordData;
      reader.readMessage(value,proto.xcommon.WaKeywordData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveWaKeywordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveWaKeywordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveWaKeywordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveWaKeywordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.WaKeywordData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveWaKeywordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveWaKeywordReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveWaKeywordReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveWaKeywordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveWaKeywordReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveWaKeywordReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional WaKeywordData Data = 3;
 * @return {?proto.xcommon.WaKeywordData}
 */
proto.xcommon.SaveWaKeywordReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.WaKeywordData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.WaKeywordData, 3));
};


/** @param {?proto.xcommon.WaKeywordData|undefined} value */
proto.xcommon.SaveWaKeywordReq.prototype.setData = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveWaKeywordReq.prototype.clearData = function() {
  this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveWaKeywordReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WaKeywordData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WaKeywordData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WaKeywordData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WaKeywordData.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    category: jspb.Message.getFieldWithDefault(msg, 3, 0),
    keyword: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WaKeywordData}
 */
proto.xcommon.WaKeywordData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WaKeywordData;
  return proto.xcommon.WaKeywordData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WaKeywordData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WaKeywordData}
 */
proto.xcommon.WaKeywordData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.CommonStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WaKeywordData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WaKeywordData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WaKeywordData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WaKeywordData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.WaKeywordData.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.WaKeywordData.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 Type = 2;
 * @return {number}
 */
proto.xcommon.WaKeywordData.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.WaKeywordData.prototype.setType = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 Category = 3;
 * @return {number}
 */
proto.xcommon.WaKeywordData.prototype.getCategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.WaKeywordData.prototype.setCategory = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Keyword = 4;
 * @return {string}
 */
proto.xcommon.WaKeywordData.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.WaKeywordData.prototype.setKeyword = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 Ctime = 5;
 * @return {number}
 */
proto.xcommon.WaKeywordData.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.WaKeywordData.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional CommonStatus Status = 6;
 * @return {!proto.xcommon.CommonStatus}
 */
proto.xcommon.WaKeywordData.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.CommonStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.CommonStatus} value */
proto.xcommon.WaKeywordData.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CreateRobotCorpusMarkReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CreateRobotCorpusMarkReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreateRobotCorpusMarkReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    audioid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    flag: jspb.Message.getFieldWithDefault(msg, 3, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CreateRobotCorpusMarkReq}
 */
proto.xcommon.CreateRobotCorpusMarkReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CreateRobotCorpusMarkReq;
  return proto.xcommon.CreateRobotCorpusMarkReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CreateRobotCorpusMarkReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CreateRobotCorpusMarkReq}
 */
proto.xcommon.CreateRobotCorpusMarkReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAudioid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlag(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CreateRobotCorpusMarkReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CreateRobotCorpusMarkReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreateRobotCorpusMarkReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAudioid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getFlag();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 AudioId = 2;
 * @return {string}
 */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.getAudioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.setAudioid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string Flag = 3;
 * @return {string}
 */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.getFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.setFlag = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.CreateRobotCorpusMarkReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRobotCorpusMarkListReq.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRobotCorpusMarkListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRobotCorpusMarkListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    caseid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    createtimerange: jspb.Message.getFieldWithDefault(msg, 7, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    closetimerange: jspb.Message.getFieldWithDefault(msg, 9, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 10, ""),
    status: jspb.Message.getFieldWithDefault(msg, 11, ""),
    assignname: jspb.Message.getFieldWithDefault(msg, 12, ""),
    assignuid: jspb.Message.getFieldWithDefault(msg, 13, 0),
    result: jspb.Message.getFieldWithDefault(msg, 14, 0),
    roleidsList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
    rolename: jspb.Message.getFieldWithDefault(msg, 16, ""),
    audioid: jspb.Message.getFieldWithDefault(msg, 17, "0"),
    collectionuid: jspb.Message.getFieldWithDefault(msg, 19, 0),
    collectionname: jspb.Message.getFieldWithDefault(msg, 20, ""),
    starttimerange: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRobotCorpusMarkListReq}
 */
proto.xcommon.GetRobotCorpusMarkListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRobotCorpusMarkListReq;
  return proto.xcommon.GetRobotCorpusMarkListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRobotCorpusMarkListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRobotCorpusMarkListReq}
 */
proto.xcommon.GetRobotCorpusMarkListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosetimerange(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResult(value);
      break;
    case 15:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setRoleidsList(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRolename(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAudioid(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCollectionuid(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionname(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRobotCorpusMarkListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRobotCorpusMarkListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getClosetimerange();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getResult();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getRoleidsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      15,
      f
    );
  }
  f = message.getRolename();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAudioid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      17,
      f
    );
  }
  f = message.getCollectionuid();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getCollectionname();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getStarttimerange();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 TicketId = 3;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 CaseId = 4;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 ItemId = 5;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 OrderId = 6;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional string CreateTimeRange = 7;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setCreatetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string CompleteTimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setCompletetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string CloseTimeRange = 9;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getClosetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setClosetimerange = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string AssignTimeRange = 10;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setAssigntimerange = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Status = 11;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string AssignName = 12;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 AssignUID = 13;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setAssignuid = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 Result = 14;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getResult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setResult = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * repeated int64 RoleIDs = 15;
 * @return {!Array<number>}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getRoleidsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 15));
};


/** @param {!Array<number>} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setRoleidsList = function(value) {
  jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.addRoleids = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.clearRoleidsList = function() {
  this.setRoleidsList([]);
};


/**
 * optional string RoleName = 16;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getRolename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setRolename = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 AudioId = 17;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getAudioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, "0"));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setAudioid = function(value) {
  jspb.Message.setProto3StringIntField(this, 17, value);
};


/**
 * optional int64 CollectionUid = 19;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getCollectionuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setCollectionuid = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional string CollectionName = 20;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getCollectionname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setCollectionname = function(value) {
  jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string StartTimeRange = 21;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.getStarttimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.GetRobotCorpusMarkListReq.prototype.setStarttimerange = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRobotCorpusMarkListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRobotCorpusMarkListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRobotCorpusMarkListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.RobotCorpusMarkData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRobotCorpusMarkListResp}
 */
proto.xcommon.GetRobotCorpusMarkListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRobotCorpusMarkListResp;
  return proto.xcommon.GetRobotCorpusMarkListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRobotCorpusMarkListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRobotCorpusMarkListResp}
 */
proto.xcommon.GetRobotCorpusMarkListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.RobotCorpusMarkData;
      reader.readMessage(value,proto.xcommon.RobotCorpusMarkData.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRobotCorpusMarkListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRobotCorpusMarkListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.RobotCorpusMarkData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated RobotCorpusMarkData List = 3;
 * @return {!Array<!proto.xcommon.RobotCorpusMarkData>}
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.RobotCorpusMarkData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RobotCorpusMarkData, 3));
};


/** @param {!Array<!proto.xcommon.RobotCorpusMarkData>} value */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.RobotCorpusMarkData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RobotCorpusMarkData}
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.RobotCorpusMarkData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetRobotCorpusMarkListResp.prototype.clearListList = function() {
  this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.RobotCorpusMarkData.repeatedFields_ = [16,17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RobotCorpusMarkData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RobotCorpusMarkData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RobotCorpusMarkData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCorpusMarkData.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && proto.xcommon.Ticket.toObject(includeInstance, f),
    assignname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 4, ""),
    isstatusdone: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    id: jspb.Message.getFieldWithDefault(msg, 6, 0),
    audioid: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    caselevel: jspb.Message.getFieldWithDefault(msg, 9, ""),
    urgeuid: jspb.Message.getFieldWithDefault(msg, 10, 0),
    urgeusername: jspb.Message.getFieldWithDefault(msg, 11, ""),
    caseid: jspb.Message.getFieldWithDefault(msg, 12, 0),
    isout: jspb.Message.getFieldWithDefault(msg, 13, 0),
    outurgetime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    entitymapMap: (f = msg.getEntitymapMap()) ? f.toObject(includeInstance, undefined) : [],
    intentnodeList: jspb.Message.toObjectList(msg.getIntentnodeList(),
    proto.xcommon.IntentNode.toObject, includeInstance),
    dialogmarkList: jspb.Message.toObjectList(msg.getDialogmarkList(),
    xcommon_common_pb.RobotDialog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RobotCorpusMarkData}
 */
proto.xcommon.RobotCorpusMarkData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RobotCorpusMarkData;
  return proto.xcommon.RobotCorpusMarkData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RobotCorpusMarkData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RobotCorpusMarkData}
 */
proto.xcommon.RobotCorpusMarkData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.Ticket;
      reader.readMessage(value,proto.xcommon.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsstatusdone(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAudioid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUrgeuid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrgeusername(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsout(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOuturgetime(value);
      break;
    case 15:
      var value = msg.getEntitymapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    case 16:
      var value = new proto.xcommon.IntentNode;
      reader.readMessage(value,proto.xcommon.IntentNode.deserializeBinaryFromReader);
      msg.addIntentnode(value);
      break;
    case 17:
      var value = new xcommon_common_pb.RobotDialog;
      reader.readMessage(value,xcommon_common_pb.RobotDialog.deserializeBinaryFromReader);
      msg.addDialogmark(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RobotCorpusMarkData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RobotCorpusMarkData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RobotCorpusMarkData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RobotCorpusMarkData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getAssignname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsstatusdone();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAudioid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      7,
      f
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUrgeuid();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getUrgeusername();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getIsout();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getOuturgetime();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getEntitymapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(15, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getIntentnodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.xcommon.IntentNode.serializeBinaryToWriter
    );
  }
  f = message.getDialogmarkList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      xcommon_common_pb.RobotDialog.serializeBinaryToWriter
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Ticket, 1));
};


/** @param {?proto.xcommon.Ticket|undefined} value */
proto.xcommon.RobotCorpusMarkData.prototype.setTicket = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RobotCorpusMarkData.prototype.clearTicket = function() {
  this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RobotCorpusMarkData.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string AssignName = 3;
 * @return {string}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getAssignname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.RobotCorpusMarkData.prototype.setAssignname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TicketStatus = 4;
 * @return {string}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.RobotCorpusMarkData.prototype.setTicketstatus = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool IsStatusDone = 5;
 * @return {boolean}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getIsstatusdone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.xcommon.RobotCorpusMarkData.prototype.setIsstatusdone = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int64 Id = 6;
 * @return {number}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.RobotCorpusMarkData.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AudioId = 7;
 * @return {string}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getAudioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/** @param {string} value */
proto.xcommon.RobotCorpusMarkData.prototype.setAudioid = function(value) {
  jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional string CaseLevel = 9;
 * @return {string}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.RobotCorpusMarkData.prototype.setCaselevel = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 UrgeUid = 10;
 * @return {number}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getUrgeuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.RobotCorpusMarkData.prototype.setUrgeuid = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string UrgeUserName = 11;
 * @return {string}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getUrgeusername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.RobotCorpusMarkData.prototype.setUrgeusername = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 CaseId = 12;
 * @return {number}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.RobotCorpusMarkData.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 IsOut = 13;
 * @return {number}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getIsout = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.RobotCorpusMarkData.prototype.setIsout = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 OutUrgeTime = 14;
 * @return {number}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getOuturgetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.RobotCorpusMarkData.prototype.setOuturgetime = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * map<int32, string> EntityMap = 15;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getEntitymapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 15, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.RobotCorpusMarkData.prototype.clearEntitymapMap = function() {
  this.getEntitymapMap().clear();
};


/**
 * repeated IntentNode IntentNode = 16;
 * @return {!Array<!proto.xcommon.IntentNode>}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getIntentnodeList = function() {
  return /** @type{!Array<!proto.xcommon.IntentNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.IntentNode, 16));
};


/** @param {!Array<!proto.xcommon.IntentNode>} value */
proto.xcommon.RobotCorpusMarkData.prototype.setIntentnodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.xcommon.IntentNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.IntentNode}
 */
proto.xcommon.RobotCorpusMarkData.prototype.addIntentnode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.xcommon.IntentNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.RobotCorpusMarkData.prototype.clearIntentnodeList = function() {
  this.setIntentnodeList([]);
};


/**
 * repeated RobotDialog DialogMark = 17;
 * @return {!Array<!proto.xcommon.RobotDialog>}
 */
proto.xcommon.RobotCorpusMarkData.prototype.getDialogmarkList = function() {
  return /** @type{!Array<!proto.xcommon.RobotDialog>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_common_pb.RobotDialog, 17));
};


/** @param {!Array<!proto.xcommon.RobotDialog>} value */
proto.xcommon.RobotCorpusMarkData.prototype.setDialogmarkList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.xcommon.RobotDialog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RobotDialog}
 */
proto.xcommon.RobotCorpusMarkData.prototype.addDialogmark = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.xcommon.RobotDialog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.RobotCorpusMarkData.prototype.clearDialogmarkList = function() {
  this.setDialogmarkList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.IntentNode.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.IntentNode.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.IntentNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.IntentNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.IntentNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    nodename: jspb.Message.getFieldWithDefault(msg, 1, ""),
    intentmapList: jspb.Message.toObjectList(msg.getIntentmapList(),
    proto.xcommon.IntentMap.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.IntentNode}
 */
proto.xcommon.IntentNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.IntentNode;
  return proto.xcommon.IntentNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.IntentNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.IntentNode}
 */
proto.xcommon.IntentNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNodename(value);
      break;
    case 2:
      var value = new proto.xcommon.IntentMap;
      reader.readMessage(value,proto.xcommon.IntentMap.deserializeBinaryFromReader);
      msg.addIntentmap(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.IntentNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.IntentNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.IntentNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.IntentNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntentmapList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.IntentMap.serializeBinaryToWriter
    );
  }
};


/**
 * optional string NodeName = 1;
 * @return {string}
 */
proto.xcommon.IntentNode.prototype.getNodename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.IntentNode.prototype.setNodename = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated IntentMap IntentMap = 2;
 * @return {!Array<!proto.xcommon.IntentMap>}
 */
proto.xcommon.IntentNode.prototype.getIntentmapList = function() {
  return /** @type{!Array<!proto.xcommon.IntentMap>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.IntentMap, 2));
};


/** @param {!Array<!proto.xcommon.IntentMap>} value */
proto.xcommon.IntentNode.prototype.setIntentmapList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.IntentMap=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.IntentMap}
 */
proto.xcommon.IntentNode.prototype.addIntentmap = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.IntentMap, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.IntentNode.prototype.clearIntentmapList = function() {
  this.setIntentmapList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.IntentMap.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.IntentMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.IntentMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.IntentMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    intentid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    intentname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.IntentMap}
 */
proto.xcommon.IntentMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.IntentMap;
  return proto.xcommon.IntentMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.IntentMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.IntentMap}
 */
proto.xcommon.IntentMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntentid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntentname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.IntentMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.IntentMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.IntentMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.IntentMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntentid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIntentname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 IntentId = 1;
 * @return {number}
 */
proto.xcommon.IntentMap.prototype.getIntentid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.IntentMap.prototype.setIntentid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string IntentName = 2;
 * @return {string}
 */
proto.xcommon.IntentMap.prototype.getIntentname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.IntentMap.prototype.setIntentname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Multilingual.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Multilingual.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Multilingual} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Multilingual.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    languagekey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    tasktag: jspb.Message.getFieldWithDefault(msg, 5, ""),
    languagevalue: jspb.Message.getFieldWithDefault(msg, 6, ""),
    operator: jspb.Message.getFieldWithDefault(msg, 7, ""),
    utime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    pushassociated: jspb.Message.getFieldWithDefault(msg, 10, 0),
    smsassociated: jspb.Message.getFieldWithDefault(msg, 11, 0),
    itemtag: jspb.Message.getFieldWithDefault(msg, 12, ""),
    casename: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Multilingual}
 */
proto.xcommon.Multilingual.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Multilingual;
  return proto.xcommon.Multilingual.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Multilingual} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Multilingual}
 */
proto.xcommon.Multilingual.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagekey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.StatusTypeEnum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasktag(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagevalue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPushassociated(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSmsassociated(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemtag(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Multilingual.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Multilingual.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Multilingual} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Multilingual.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLanguagekey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTasktag();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLanguagevalue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getPushassociated();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getSmsassociated();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getItemtag();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.Multilingual.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.Multilingual.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string LanguageKey = 2;
 * @return {string}
 */
proto.xcommon.Multilingual.prototype.getLanguagekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.Multilingual.prototype.setLanguagekey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Description = 3;
 * @return {string}
 */
proto.xcommon.Multilingual.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.Multilingual.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional StatusTypeEnum Status = 4;
 * @return {!proto.xcommon.StatusTypeEnum}
 */
proto.xcommon.Multilingual.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.StatusTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.StatusTypeEnum} value */
proto.xcommon.Multilingual.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string TaskTag = 5;
 * @return {string}
 */
proto.xcommon.Multilingual.prototype.getTasktag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.Multilingual.prototype.setTasktag = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string LanguageValue = 6;
 * @return {string}
 */
proto.xcommon.Multilingual.prototype.getLanguagevalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.Multilingual.prototype.setLanguagevalue = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Operator = 7;
 * @return {string}
 */
proto.xcommon.Multilingual.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.Multilingual.prototype.setOperator = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 Utime = 8;
 * @return {number}
 */
proto.xcommon.Multilingual.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.Multilingual.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Ctime = 9;
 * @return {number}
 */
proto.xcommon.Multilingual.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.Multilingual.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 PushAssociated = 10;
 * @return {number}
 */
proto.xcommon.Multilingual.prototype.getPushassociated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.Multilingual.prototype.setPushassociated = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 SmsAssociated = 11;
 * @return {number}
 */
proto.xcommon.Multilingual.prototype.getSmsassociated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.Multilingual.prototype.setSmsassociated = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string ItemTag = 12;
 * @return {string}
 */
proto.xcommon.Multilingual.prototype.getItemtag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.Multilingual.prototype.setItemtag = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string CaseName = 13;
 * @return {string}
 */
proto.xcommon.Multilingual.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.Multilingual.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MultilingualDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MultilingualDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MultilingualDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MultilingualDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    languagekey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    language: jspb.Message.getFieldWithDefault(msg, 3, ""),
    languagevalue: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MultilingualDetail}
 */
proto.xcommon.MultilingualDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MultilingualDetail;
  return proto.xcommon.MultilingualDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MultilingualDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MultilingualDetail}
 */
proto.xcommon.MultilingualDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagekey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagevalue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MultilingualDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MultilingualDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MultilingualDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MultilingualDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLanguagekey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLanguagevalue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.MultilingualDetail.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.MultilingualDetail.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string LanguageKey = 2;
 * @return {string}
 */
proto.xcommon.MultilingualDetail.prototype.getLanguagekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.MultilingualDetail.prototype.setLanguagekey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Language = 3;
 * @return {string}
 */
proto.xcommon.MultilingualDetail.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.MultilingualDetail.prototype.setLanguage = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string LanguageValue = 4;
 * @return {string}
 */
proto.xcommon.MultilingualDetail.prototype.getLanguagevalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.MultilingualDetail.prototype.setLanguagevalue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SaveMultilingualReq.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveMultilingualReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveMultilingualReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveMultilingualReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveMultilingualReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    languagekey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    tasktagList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    itemtagList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveMultilingualReq}
 */
proto.xcommon.SaveMultilingualReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveMultilingualReq;
  return proto.xcommon.SaveMultilingualReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveMultilingualReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveMultilingualReq}
 */
proto.xcommon.SaveMultilingualReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagekey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.StatusTypeEnum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {!Array<!proto.xcommon.PushTaskTypeEnum>} */ (reader.readPackedEnum());
      msg.setTasktagList(value);
      break;
    case 7:
      var value = /** @type {!Array<!proto.xcommon.TicketItemEnum>} */ (reader.readPackedEnum());
      msg.setItemtagList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveMultilingualReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveMultilingualReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveMultilingualReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveMultilingualReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLanguagekey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTasktagList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getItemtagList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveMultilingualReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveMultilingualReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveMultilingualReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveMultilingualReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveMultilingualReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveMultilingualReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string LanguageKey = 3;
 * @return {string}
 */
proto.xcommon.SaveMultilingualReq.prototype.getLanguagekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SaveMultilingualReq.prototype.setLanguagekey = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Description = 4;
 * @return {string}
 */
proto.xcommon.SaveMultilingualReq.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SaveMultilingualReq.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional StatusTypeEnum Status = 5;
 * @return {!proto.xcommon.StatusTypeEnum}
 */
proto.xcommon.SaveMultilingualReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.StatusTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.StatusTypeEnum} value */
proto.xcommon.SaveMultilingualReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated PushTaskTypeEnum TaskTag = 6;
 * @return {!Array<!proto.xcommon.PushTaskTypeEnum>}
 */
proto.xcommon.SaveMultilingualReq.prototype.getTasktagList = function() {
  return /** @type {!Array<!proto.xcommon.PushTaskTypeEnum>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<!proto.xcommon.PushTaskTypeEnum>} value */
proto.xcommon.SaveMultilingualReq.prototype.setTasktagList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.xcommon.PushTaskTypeEnum} value
 * @param {number=} opt_index
 */
proto.xcommon.SaveMultilingualReq.prototype.addTasktag = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SaveMultilingualReq.prototype.clearTasktagList = function() {
  this.setTasktagList([]);
};


/**
 * repeated TicketItemEnum ItemTag = 7;
 * @return {!Array<!proto.xcommon.TicketItemEnum>}
 */
proto.xcommon.SaveMultilingualReq.prototype.getItemtagList = function() {
  return /** @type {!Array<!proto.xcommon.TicketItemEnum>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<!proto.xcommon.TicketItemEnum>} value */
proto.xcommon.SaveMultilingualReq.prototype.setItemtagList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.xcommon.TicketItemEnum} value
 * @param {number=} opt_index
 */
proto.xcommon.SaveMultilingualReq.prototype.addItemtag = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SaveMultilingualReq.prototype.clearItemtagList = function() {
  this.setItemtagList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveMultilingualResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveMultilingualResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveMultilingualResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveMultilingualResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveMultilingualResp}
 */
proto.xcommon.SaveMultilingualResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveMultilingualResp;
  return proto.xcommon.SaveMultilingualResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveMultilingualResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveMultilingualResp}
 */
proto.xcommon.SaveMultilingualResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveMultilingualResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveMultilingualResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveMultilingualResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveMultilingualResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveMultilingualResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveMultilingualResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveMultilingualResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveMultilingualResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListMultilingualReq.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListMultilingualReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListMultilingualReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListMultilingualReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListMultilingualReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    languagekey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    languagevalue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    tasktagList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    itemtagList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListMultilingualReq}
 */
proto.xcommon.ListMultilingualReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListMultilingualReq;
  return proto.xcommon.ListMultilingualReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListMultilingualReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListMultilingualReq}
 */
proto.xcommon.ListMultilingualReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagekey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagevalue(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.StatusTypeEnum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {!Array<!proto.xcommon.PushTaskTypeEnum>} */ (reader.readPackedEnum());
      msg.setTasktagList(value);
      break;
    case 7:
      var value = /** @type {!Array<!proto.xcommon.TicketItemEnum>} */ (reader.readPackedEnum());
      msg.setItemtagList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListMultilingualReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListMultilingualReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListMultilingualReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListMultilingualReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getLanguagekey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLanguagevalue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTasktagList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getItemtagList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListMultilingualReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListMultilingualReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListMultilingualReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListMultilingualReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListMultilingualReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListMultilingualReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListMultilingualReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListMultilingualReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string LanguageKey = 3;
 * @return {string}
 */
proto.xcommon.ListMultilingualReq.prototype.getLanguagekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ListMultilingualReq.prototype.setLanguagekey = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string LanguageValue = 4;
 * @return {string}
 */
proto.xcommon.ListMultilingualReq.prototype.getLanguagevalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListMultilingualReq.prototype.setLanguagevalue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional StatusTypeEnum Status = 5;
 * @return {!proto.xcommon.StatusTypeEnum}
 */
proto.xcommon.ListMultilingualReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.StatusTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.StatusTypeEnum} value */
proto.xcommon.ListMultilingualReq.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated PushTaskTypeEnum TaskTag = 6;
 * @return {!Array<!proto.xcommon.PushTaskTypeEnum>}
 */
proto.xcommon.ListMultilingualReq.prototype.getTasktagList = function() {
  return /** @type {!Array<!proto.xcommon.PushTaskTypeEnum>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<!proto.xcommon.PushTaskTypeEnum>} value */
proto.xcommon.ListMultilingualReq.prototype.setTasktagList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.xcommon.PushTaskTypeEnum} value
 * @param {number=} opt_index
 */
proto.xcommon.ListMultilingualReq.prototype.addTasktag = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListMultilingualReq.prototype.clearTasktagList = function() {
  this.setTasktagList([]);
};


/**
 * repeated TicketItemEnum ItemTag = 7;
 * @return {!Array<!proto.xcommon.TicketItemEnum>}
 */
proto.xcommon.ListMultilingualReq.prototype.getItemtagList = function() {
  return /** @type {!Array<!proto.xcommon.TicketItemEnum>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<!proto.xcommon.TicketItemEnum>} value */
proto.xcommon.ListMultilingualReq.prototype.setItemtagList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.xcommon.TicketItemEnum} value
 * @param {number=} opt_index
 */
proto.xcommon.ListMultilingualReq.prototype.addItemtag = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListMultilingualReq.prototype.clearItemtagList = function() {
  this.setItemtagList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListMultilingualResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListMultilingualResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListMultilingualResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListMultilingualResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListMultilingualResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.Multilingual.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListMultilingualResp}
 */
proto.xcommon.ListMultilingualResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListMultilingualResp;
  return proto.xcommon.ListMultilingualResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListMultilingualResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListMultilingualResp}
 */
proto.xcommon.ListMultilingualResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.Multilingual;
      reader.readMessage(value,proto.xcommon.Multilingual.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListMultilingualResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListMultilingualResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListMultilingualResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListMultilingualResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.Multilingual.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListMultilingualResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListMultilingualResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListMultilingualResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListMultilingualResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListMultilingualResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListMultilingualResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListMultilingualResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListMultilingualResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Multilingual List = 3;
 * @return {!Array<!proto.xcommon.Multilingual>}
 */
proto.xcommon.ListMultilingualResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.Multilingual>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.Multilingual, 3));
};


/** @param {!Array<!proto.xcommon.Multilingual>} value */
proto.xcommon.ListMultilingualResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.Multilingual=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Multilingual}
 */
proto.xcommon.ListMultilingualResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.Multilingual, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListMultilingualResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveMultilingualDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveMultilingualDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveMultilingualDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    languagekey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    language: jspb.Message.getFieldWithDefault(msg, 4, ""),
    languagevalue: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveMultilingualDetailReq}
 */
proto.xcommon.SaveMultilingualDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveMultilingualDetailReq;
  return proto.xcommon.SaveMultilingualDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveMultilingualDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveMultilingualDetailReq}
 */
proto.xcommon.SaveMultilingualDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagekey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagevalue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveMultilingualDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveMultilingualDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveMultilingualDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLanguagekey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLanguagevalue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SaveMultilingualDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SaveMultilingualDetailReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string LanguageKey = 3;
 * @return {string}
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.getLanguagekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SaveMultilingualDetailReq.prototype.setLanguagekey = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Language = 4;
 * @return {string}
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SaveMultilingualDetailReq.prototype.setLanguage = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string LanguageValue = 5;
 * @return {string}
 */
proto.xcommon.SaveMultilingualDetailReq.prototype.getLanguagevalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.SaveMultilingualDetailReq.prototype.setLanguagevalue = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveMultilingualDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveMultilingualDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveMultilingualDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveMultilingualDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveMultilingualDetailResp}
 */
proto.xcommon.SaveMultilingualDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveMultilingualDetailResp;
  return proto.xcommon.SaveMultilingualDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveMultilingualDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveMultilingualDetailResp}
 */
proto.xcommon.SaveMultilingualDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveMultilingualDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveMultilingualDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveMultilingualDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveMultilingualDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveMultilingualDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SaveMultilingualDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SaveMultilingualDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveMultilingualDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DelMultilingualDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DelMultilingualDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DelMultilingualDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelMultilingualDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    languagekey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DelMultilingualDetailReq}
 */
proto.xcommon.DelMultilingualDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DelMultilingualDetailReq;
  return proto.xcommon.DelMultilingualDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DelMultilingualDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DelMultilingualDetailReq}
 */
proto.xcommon.DelMultilingualDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagekey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DelMultilingualDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DelMultilingualDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DelMultilingualDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelMultilingualDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLanguagekey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DelMultilingualDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.DelMultilingualDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DelMultilingualDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DelMultilingualDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.DelMultilingualDetailReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.DelMultilingualDetailReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string LanguageKey = 3;
 * @return {string}
 */
proto.xcommon.DelMultilingualDetailReq.prototype.getLanguagekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.DelMultilingualDetailReq.prototype.setLanguagekey = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DelMultilingualDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DelMultilingualDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DelMultilingualDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelMultilingualDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DelMultilingualDetailResp}
 */
proto.xcommon.DelMultilingualDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DelMultilingualDetailResp;
  return proto.xcommon.DelMultilingualDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DelMultilingualDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DelMultilingualDetailResp}
 */
proto.xcommon.DelMultilingualDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DelMultilingualDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DelMultilingualDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DelMultilingualDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DelMultilingualDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DelMultilingualDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.DelMultilingualDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.DelMultilingualDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DelMultilingualDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListMultilingualDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListMultilingualDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListMultilingualDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListMultilingualDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    languagekey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListMultilingualDetailReq}
 */
proto.xcommon.ListMultilingualDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListMultilingualDetailReq;
  return proto.xcommon.ListMultilingualDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListMultilingualDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListMultilingualDetailReq}
 */
proto.xcommon.ListMultilingualDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagekey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListMultilingualDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListMultilingualDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListMultilingualDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListMultilingualDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getLanguagekey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListMultilingualDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListMultilingualDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListMultilingualDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListMultilingualDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string LanguageKey = 2;
 * @return {string}
 */
proto.xcommon.ListMultilingualDetailReq.prototype.getLanguagekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ListMultilingualDetailReq.prototype.setLanguagekey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListMultilingualDetailResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListMultilingualDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListMultilingualDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListMultilingualDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListMultilingualDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.MultilingualDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListMultilingualDetailResp}
 */
proto.xcommon.ListMultilingualDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListMultilingualDetailResp;
  return proto.xcommon.ListMultilingualDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListMultilingualDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListMultilingualDetailResp}
 */
proto.xcommon.ListMultilingualDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.MultilingualDetail;
      reader.readMessage(value,proto.xcommon.MultilingualDetail.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListMultilingualDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListMultilingualDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListMultilingualDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListMultilingualDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.MultilingualDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListMultilingualDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListMultilingualDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListMultilingualDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListMultilingualDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated MultilingualDetail List = 2;
 * @return {!Array<!proto.xcommon.MultilingualDetail>}
 */
proto.xcommon.ListMultilingualDetailResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.MultilingualDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.MultilingualDetail, 2));
};


/** @param {!Array<!proto.xcommon.MultilingualDetail>} value */
proto.xcommon.ListMultilingualDetailResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.MultilingualDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.MultilingualDetail}
 */
proto.xcommon.ListMultilingualDetailResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.MultilingualDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListMultilingualDetailResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPushTemplateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPushTemplateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPushTemplateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushTemplateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    tasktag: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPushTemplateReq}
 */
proto.xcommon.ListPushTemplateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPushTemplateReq;
  return proto.xcommon.ListPushTemplateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPushTemplateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPushTemplateReq}
 */
proto.xcommon.ListPushTemplateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.PushTaskTypeEnum} */ (reader.readEnum());
      msg.setTasktag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPushTemplateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPushTemplateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPushTemplateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushTemplateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTasktag();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListPushTemplateReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListPushTemplateReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushTemplateReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushTemplateReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PushTaskTypeEnum TaskTag = 5;
 * @return {!proto.xcommon.PushTaskTypeEnum}
 */
proto.xcommon.ListPushTemplateReq.prototype.getTasktag = function() {
  return /** @type {!proto.xcommon.PushTaskTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.PushTaskTypeEnum} value */
proto.xcommon.ListPushTemplateReq.prototype.setTasktag = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListPushTemplateResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPushTemplateResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPushTemplateResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPushTemplateResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushTemplateResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    listList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPushTemplateResp}
 */
proto.xcommon.ListPushTemplateResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPushTemplateResp;
  return proto.xcommon.ListPushTemplateResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPushTemplateResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPushTemplateResp}
 */
proto.xcommon.ListPushTemplateResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPushTemplateResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPushTemplateResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPushTemplateResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushTemplateResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListPushTemplateResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListPushTemplateResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushTemplateResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushTemplateResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string List = 2;
 * @return {!Array<string>}
 */
proto.xcommon.ListPushTemplateResp.prototype.getListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.xcommon.ListPushTemplateResp.prototype.setListList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.xcommon.ListPushTemplateResp.prototype.addList = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListPushTemplateResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PushTask.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PushTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PushTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PushTask.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    taskname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    taskstatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    taskdesc: jspb.Message.getFieldWithDefault(msg, 4, ""),
    pushtarget: jspb.Message.getFieldWithDefault(msg, 5, 0),
    pushparam: jspb.Message.getFieldWithDefault(msg, 6, ""),
    tasktype: jspb.Message.getFieldWithDefault(msg, 7, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 8, 0),
    loantype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    schemamode: jspb.Message.getFieldWithDefault(msg, 10, 0),
    titlekey: jspb.Message.getFieldWithDefault(msg, 11, ""),
    bodykey: jspb.Message.getFieldWithDefault(msg, 12, ""),
    startdate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    enddate: jspb.Message.getFieldWithDefault(msg, 14, 0),
    timing: jspb.Message.getFieldWithDefault(msg, 15, ""),
    operator: jspb.Message.getFieldWithDefault(msg, 16, ""),
    utime: jspb.Message.getFieldWithDefault(msg, 17, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 18, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PushTask}
 */
proto.xcommon.PushTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PushTask;
  return proto.xcommon.PushTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PushTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PushTask}
 */
proto.xcommon.PushTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskname(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.TaskStatusEnum} */ (reader.readEnum());
      msg.setTaskstatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskdesc(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.PushTargetEnum} */ (reader.readEnum());
      msg.setPushtarget(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPushparam(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.PushTaskTypeEnum} */ (reader.readEnum());
      msg.setTasktype(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.PhoneObjectEnum} */ (reader.readEnum());
      msg.setPhoneobject(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.SchemaModeEnum} */ (reader.readEnum());
      msg.setSchemamode(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitlekey(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setBodykey(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartdate(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnddate(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTiming(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PushTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PushTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PushTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PushTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTaskname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTaskstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTaskdesc();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPushtarget();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getPushparam();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTasktype();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getSchemamode();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getTitlekey();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getBodykey();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getStartdate();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getEnddate();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getTiming();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.PushTask.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.PushTask.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string TaskName = 2;
 * @return {string}
 */
proto.xcommon.PushTask.prototype.getTaskname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.PushTask.prototype.setTaskname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TaskStatusEnum TaskStatus = 3;
 * @return {!proto.xcommon.TaskStatusEnum}
 */
proto.xcommon.PushTask.prototype.getTaskstatus = function() {
  return /** @type {!proto.xcommon.TaskStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.TaskStatusEnum} value */
proto.xcommon.PushTask.prototype.setTaskstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string TaskDesc = 4;
 * @return {string}
 */
proto.xcommon.PushTask.prototype.getTaskdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.PushTask.prototype.setTaskdesc = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional PushTargetEnum PushTarget = 5;
 * @return {!proto.xcommon.PushTargetEnum}
 */
proto.xcommon.PushTask.prototype.getPushtarget = function() {
  return /** @type {!proto.xcommon.PushTargetEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.PushTargetEnum} value */
proto.xcommon.PushTask.prototype.setPushtarget = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string PushParam = 6;
 * @return {string}
 */
proto.xcommon.PushTask.prototype.getPushparam = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.PushTask.prototype.setPushparam = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional PushTaskTypeEnum TaskType = 7;
 * @return {!proto.xcommon.PushTaskTypeEnum}
 */
proto.xcommon.PushTask.prototype.getTasktype = function() {
  return /** @type {!proto.xcommon.PushTaskTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.xcommon.PushTaskTypeEnum} value */
proto.xcommon.PushTask.prototype.setTasktype = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional PhoneObjectEnum PhoneObject = 8;
 * @return {!proto.xcommon.PhoneObjectEnum}
 */
proto.xcommon.PushTask.prototype.getPhoneobject = function() {
  return /** @type {!proto.xcommon.PhoneObjectEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.PhoneObjectEnum} value */
proto.xcommon.PushTask.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional LoanTypeEnum LoanType = 9;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.PushTask.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.PushTask.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional SchemaModeEnum SchemaMode = 10;
 * @return {!proto.xcommon.SchemaModeEnum}
 */
proto.xcommon.PushTask.prototype.getSchemamode = function() {
  return /** @type {!proto.xcommon.SchemaModeEnum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.SchemaModeEnum} value */
proto.xcommon.PushTask.prototype.setSchemamode = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string TitleKey = 11;
 * @return {string}
 */
proto.xcommon.PushTask.prototype.getTitlekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.PushTask.prototype.setTitlekey = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string BodyKey = 12;
 * @return {string}
 */
proto.xcommon.PushTask.prototype.getBodykey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.PushTask.prototype.setBodykey = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 StartDate = 13;
 * @return {number}
 */
proto.xcommon.PushTask.prototype.getStartdate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.PushTask.prototype.setStartdate = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 EndDate = 14;
 * @return {number}
 */
proto.xcommon.PushTask.prototype.getEnddate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.PushTask.prototype.setEnddate = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string Timing = 15;
 * @return {string}
 */
proto.xcommon.PushTask.prototype.getTiming = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.PushTask.prototype.setTiming = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string Operator = 16;
 * @return {string}
 */
proto.xcommon.PushTask.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.PushTask.prototype.setOperator = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 Utime = 17;
 * @return {number}
 */
proto.xcommon.PushTask.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.PushTask.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 Ctime = 18;
 * @return {number}
 */
proto.xcommon.PushTask.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.PushTask.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePushTaskReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePushTaskReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePushTaskReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePushTaskReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    taskname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    taskstatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
    taskdesc: jspb.Message.getFieldWithDefault(msg, 5, ""),
    pushtarget: jspb.Message.getFieldWithDefault(msg, 6, 0),
    pushparam: jspb.Message.getFieldWithDefault(msg, 7, ""),
    tasktype: jspb.Message.getFieldWithDefault(msg, 8, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 9, 0),
    loantype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    schemamode: jspb.Message.getFieldWithDefault(msg, 11, 0),
    titlekey: jspb.Message.getFieldWithDefault(msg, 12, ""),
    bodykey: jspb.Message.getFieldWithDefault(msg, 13, ""),
    timerange: jspb.Message.getFieldWithDefault(msg, 14, ""),
    timing: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePushTaskReq}
 */
proto.xcommon.SavePushTaskReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePushTaskReq;
  return proto.xcommon.SavePushTaskReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePushTaskReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePushTaskReq}
 */
proto.xcommon.SavePushTaskReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskname(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.TaskStatusEnum} */ (reader.readEnum());
      msg.setTaskstatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskdesc(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.PushTargetEnum} */ (reader.readEnum());
      msg.setPushtarget(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPushparam(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.PushTaskTypeEnum} */ (reader.readEnum());
      msg.setTasktype(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.PhoneObjectEnum} */ (reader.readEnum());
      msg.setPhoneobject(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.SchemaModeEnum} */ (reader.readEnum());
      msg.setSchemamode(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitlekey(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setBodykey(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTiming(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePushTaskReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePushTaskReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePushTaskReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePushTaskReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTaskname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTaskstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTaskdesc();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPushtarget();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPushparam();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTasktype();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getSchemamode();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getTitlekey();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getBodykey();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTiming();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SavePushTaskReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.SavePushTaskReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SavePushTaskReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePushTaskReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Id = 2;
 * @return {number}
 */
proto.xcommon.SavePushTaskReq.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SavePushTaskReq.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string TaskName = 3;
 * @return {string}
 */
proto.xcommon.SavePushTaskReq.prototype.getTaskname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SavePushTaskReq.prototype.setTaskname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional TaskStatusEnum TaskStatus = 4;
 * @return {!proto.xcommon.TaskStatusEnum}
 */
proto.xcommon.SavePushTaskReq.prototype.getTaskstatus = function() {
  return /** @type {!proto.xcommon.TaskStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.TaskStatusEnum} value */
proto.xcommon.SavePushTaskReq.prototype.setTaskstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string TaskDesc = 5;
 * @return {string}
 */
proto.xcommon.SavePushTaskReq.prototype.getTaskdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.SavePushTaskReq.prototype.setTaskdesc = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional PushTargetEnum PushTarget = 6;
 * @return {!proto.xcommon.PushTargetEnum}
 */
proto.xcommon.SavePushTaskReq.prototype.getPushtarget = function() {
  return /** @type {!proto.xcommon.PushTargetEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.PushTargetEnum} value */
proto.xcommon.SavePushTaskReq.prototype.setPushtarget = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string PushParam = 7;
 * @return {string}
 */
proto.xcommon.SavePushTaskReq.prototype.getPushparam = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.SavePushTaskReq.prototype.setPushparam = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional PushTaskTypeEnum TaskType = 8;
 * @return {!proto.xcommon.PushTaskTypeEnum}
 */
proto.xcommon.SavePushTaskReq.prototype.getTasktype = function() {
  return /** @type {!proto.xcommon.PushTaskTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.xcommon.PushTaskTypeEnum} value */
proto.xcommon.SavePushTaskReq.prototype.setTasktype = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional PhoneObjectEnum PhoneObject = 9;
 * @return {!proto.xcommon.PhoneObjectEnum}
 */
proto.xcommon.SavePushTaskReq.prototype.getPhoneobject = function() {
  return /** @type {!proto.xcommon.PhoneObjectEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.PhoneObjectEnum} value */
proto.xcommon.SavePushTaskReq.prototype.setPhoneobject = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional LoanTypeEnum LoanType = 10;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.SavePushTaskReq.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.SavePushTaskReq.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional SchemaModeEnum SchemaMode = 11;
 * @return {!proto.xcommon.SchemaModeEnum}
 */
proto.xcommon.SavePushTaskReq.prototype.getSchemamode = function() {
  return /** @type {!proto.xcommon.SchemaModeEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {!proto.xcommon.SchemaModeEnum} value */
proto.xcommon.SavePushTaskReq.prototype.setSchemamode = function(value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string TitleKey = 12;
 * @return {string}
 */
proto.xcommon.SavePushTaskReq.prototype.getTitlekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.SavePushTaskReq.prototype.setTitlekey = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string BodyKey = 13;
 * @return {string}
 */
proto.xcommon.SavePushTaskReq.prototype.getBodykey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.SavePushTaskReq.prototype.setBodykey = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string TimeRange = 14;
 * @return {string}
 */
proto.xcommon.SavePushTaskReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.SavePushTaskReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string Timing = 15;
 * @return {string}
 */
proto.xcommon.SavePushTaskReq.prototype.getTiming = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.SavePushTaskReq.prototype.setTiming = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SavePushTaskResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SavePushTaskResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SavePushTaskResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePushTaskResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SavePushTaskResp}
 */
proto.xcommon.SavePushTaskResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SavePushTaskResp;
  return proto.xcommon.SavePushTaskResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SavePushTaskResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SavePushTaskResp}
 */
proto.xcommon.SavePushTaskResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SavePushTaskResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SavePushTaskResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SavePushTaskResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SavePushTaskResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SavePushTaskResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.SavePushTaskResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SavePushTaskResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SavePushTaskResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPushTaskReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPushTaskReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPushTaskReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushTaskReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    languagekey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    taskname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tasktype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    taskstatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    taskdesc: jspb.Message.getFieldWithDefault(msg, 7, ""),
    timerange: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPushTaskReq}
 */
proto.xcommon.ListPushTaskReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPushTaskReq;
  return proto.xcommon.ListPushTaskReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPushTaskReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPushTaskReq}
 */
proto.xcommon.ListPushTaskReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguagekey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskname(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.PushTaskTypeEnum} */ (reader.readEnum());
      msg.setTasktype(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.TaskStatusEnum} */ (reader.readEnum());
      msg.setTaskstatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskdesc(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPushTaskReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPushTaskReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPushTaskReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushTaskReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getLanguagekey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTaskname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTasktype();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTaskstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTaskdesc();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListPushTaskReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListPushTaskReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushTaskReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushTaskReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListPushTaskReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListPushTaskReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushTaskReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushTaskReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string LanguageKey = 3;
 * @return {string}
 */
proto.xcommon.ListPushTaskReq.prototype.getLanguagekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ListPushTaskReq.prototype.setLanguagekey = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TaskName = 4;
 * @return {string}
 */
proto.xcommon.ListPushTaskReq.prototype.getTaskname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListPushTaskReq.prototype.setTaskname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional PushTaskTypeEnum TaskType = 5;
 * @return {!proto.xcommon.PushTaskTypeEnum}
 */
proto.xcommon.ListPushTaskReq.prototype.getTasktype = function() {
  return /** @type {!proto.xcommon.PushTaskTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.PushTaskTypeEnum} value */
proto.xcommon.ListPushTaskReq.prototype.setTasktype = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional TaskStatusEnum TaskStatus = 6;
 * @return {!proto.xcommon.TaskStatusEnum}
 */
proto.xcommon.ListPushTaskReq.prototype.getTaskstatus = function() {
  return /** @type {!proto.xcommon.TaskStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.xcommon.TaskStatusEnum} value */
proto.xcommon.ListPushTaskReq.prototype.setTaskstatus = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string TaskDesc = 7;
 * @return {string}
 */
proto.xcommon.ListPushTaskReq.prototype.getTaskdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.ListPushTaskReq.prototype.setTaskdesc = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string TimeRange = 8;
 * @return {string}
 */
proto.xcommon.ListPushTaskReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.ListPushTaskReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListPushTaskResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPushTaskResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPushTaskResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPushTaskResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushTaskResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.PushTask.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPushTaskResp}
 */
proto.xcommon.ListPushTaskResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPushTaskResp;
  return proto.xcommon.ListPushTaskResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPushTaskResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPushTaskResp}
 */
proto.xcommon.ListPushTaskResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.PushTask;
      reader.readMessage(value,proto.xcommon.PushTask.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPushTaskResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPushTaskResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPushTaskResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushTaskResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.PushTask.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListPushTaskResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListPushTaskResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushTaskResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushTaskResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListPushTaskResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListPushTaskResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushTaskResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushTaskResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated PushTask List = 3;
 * @return {!Array<!proto.xcommon.PushTask>}
 */
proto.xcommon.ListPushTaskResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.PushTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.PushTask, 3));
};


/** @param {!Array<!proto.xcommon.PushTask>} value */
proto.xcommon.ListPushTaskResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.PushTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.PushTask}
 */
proto.xcommon.ListPushTaskResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.PushTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListPushTaskResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPushDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPushDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPushDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    taskid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    timerange: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPushDetailReq}
 */
proto.xcommon.ListPushDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPushDetailReq;
  return proto.xcommon.ListPushDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPushDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPushDetailReq}
 */
proto.xcommon.ListPushDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTaskid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPushDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPushDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPushDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListPushDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ListPushDetailReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushDetailReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListPushDetailReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.ListPushDetailReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushDetailReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushDetailReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 TaskId = 3;
 * @return {number}
 */
proto.xcommon.ListPushDetailReq.prototype.getTaskid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.ListPushDetailReq.prototype.setTaskid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string TimeRange = 4;
 * @return {string}
 */
proto.xcommon.ListPushDetailReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ListPushDetailReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListPushDetailResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPushDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPushDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPushDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.ListPushDetailResp.OnePushDetailRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPushDetailResp}
 */
proto.xcommon.ListPushDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPushDetailResp;
  return proto.xcommon.ListPushDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPushDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPushDetailResp}
 */
proto.xcommon.ListPushDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.ListPushDetailResp.OnePushDetailRow;
      reader.readMessage(value,proto.xcommon.ListPushDetailResp.OnePushDetailRow.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPushDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPushDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPushDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.ListPushDetailResp.OnePushDetailRow.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListPushDetailResp.OnePushDetailRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListPushDetailResp.OnePushDetailRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    pushtime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    pushnum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    successnum: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListPushDetailResp.OnePushDetailRow}
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListPushDetailResp.OnePushDetailRow;
  return proto.xcommon.ListPushDetailResp.OnePushDetailRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListPushDetailResp.OnePushDetailRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListPushDetailResp.OnePushDetailRow}
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPushtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPushnum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuccessnum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListPushDetailResp.OnePushDetailRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListPushDetailResp.OnePushDetailRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPushtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPushnum();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSuccessnum();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int64 PushTime = 4;
 * @return {number}
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.prototype.getPushtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.prototype.setPushtime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 PushNum = 5;
 * @return {number}
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.prototype.getPushnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.prototype.setPushnum = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 SuccessNum = 6;
 * @return {number}
 */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.prototype.getSuccessnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.ListPushDetailResp.OnePushDetailRow.prototype.setSuccessnum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListPushDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ListPushDetailResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushDetailResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListPushDetailResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.ListPushDetailResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ListPushDetailResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListPushDetailResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated OnePushDetailRow List = 3;
 * @return {!Array<!proto.xcommon.ListPushDetailResp.OnePushDetailRow>}
 */
proto.xcommon.ListPushDetailResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ListPushDetailResp.OnePushDetailRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ListPushDetailResp.OnePushDetailRow, 3));
};


/** @param {!Array<!proto.xcommon.ListPushDetailResp.OnePushDetailRow>} value */
proto.xcommon.ListPushDetailResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.ListPushDetailResp.OnePushDetailRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ListPushDetailResp.OnePushDetailRow}
 */
proto.xcommon.ListPushDetailResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.ListPushDetailResp.OnePushDetailRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.ListPushDetailResp.prototype.clearListList = function() {
  this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserItemReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserItemReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserItemReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserItemReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserItemReq}
 */
proto.xcommon.GetUserItemReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserItemReq;
  return proto.xcommon.GetUserItemReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserItemReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserItemReq}
 */
proto.xcommon.GetUserItemReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserItemReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserItemReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserItemReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserItemReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetUserItemReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetUserItemReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserItemReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserItemReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetUserItemReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetUserItemReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserItemReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserItemReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 UserId = 3;
 * @return {number}
 */
proto.xcommon.GetUserItemReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetUserItemReq.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUserItemResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUserItemResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUserItemResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserItemResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    ticketitem: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUserItemResp}
 */
proto.xcommon.GetUserItemResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUserItemResp;
  return proto.xcommon.GetUserItemResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUserItemResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUserItemResp}
 */
proto.xcommon.GetUserItemResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketitem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUserItemResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUserItemResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUserItemResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUserItemResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getTicketitem();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetUserItemResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetUserItemResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserItemResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserItemResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetUserItemResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetUserItemResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetUserItemResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUserItemResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 TicketItem = 3;
 * @return {number}
 */
proto.xcommon.GetUserItemResp.prototype.getTicketitem = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetUserItemResp.prototype.setTicketitem = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ExportTicketEmailCSVReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ExportTicketEmailCSVReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExportTicketEmailCSVReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    getticketlistreq: (f = msg.getGetticketlistreq()) && proto.xcommon.GetTicketListReq.toObject(includeInstance, f),
    email: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ExportTicketEmailCSVReq}
 */
proto.xcommon.ExportTicketEmailCSVReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ExportTicketEmailCSVReq;
  return proto.xcommon.ExportTicketEmailCSVReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ExportTicketEmailCSVReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ExportTicketEmailCSVReq}
 */
proto.xcommon.ExportTicketEmailCSVReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.GetTicketListReq;
      reader.readMessage(value,proto.xcommon.GetTicketListReq.deserializeBinaryFromReader);
      msg.setGetticketlistreq(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ExportTicketEmailCSVReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ExportTicketEmailCSVReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExportTicketEmailCSVReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getGetticketlistreq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.GetTicketListReq.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.ExportTicketEmailCSVReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional GetTicketListReq GetTicketListReq = 2;
 * @return {?proto.xcommon.GetTicketListReq}
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.getGetticketlistreq = function() {
  return /** @type{?proto.xcommon.GetTicketListReq} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.GetTicketListReq, 2));
};


/** @param {?proto.xcommon.GetTicketListReq|undefined} value */
proto.xcommon.ExportTicketEmailCSVReq.prototype.setGetticketlistreq = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.clearGetticketlistreq = function() {
  this.setGetticketlistreq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.hasGetticketlistreq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.xcommon.ExportTicketEmailCSVReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ExportTicketEmailCSVReq.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ExportTicketEmailCSVResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ExportTicketEmailCSVResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ExportTicketEmailCSVResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExportTicketEmailCSVResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ExportTicketEmailCSVResp}
 */
proto.xcommon.ExportTicketEmailCSVResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ExportTicketEmailCSVResp;
  return proto.xcommon.ExportTicketEmailCSVResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ExportTicketEmailCSVResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ExportTicketEmailCSVResp}
 */
proto.xcommon.ExportTicketEmailCSVResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ExportTicketEmailCSVResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ExportTicketEmailCSVResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ExportTicketEmailCSVResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExportTicketEmailCSVResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ExportTicketEmailCSVResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.ExportTicketEmailCSVResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ExportTicketEmailCSVResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ExportTicketEmailCSVResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetHourlyCollectionStatsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetHourlyCollectionStatsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetHourlyCollectionStatsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    loantype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    timerange: jspb.Message.getFieldWithDefault(msg, 5, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    querytype: jspb.Message.getFieldWithDefault(msg, 7, 0),
    hour: jspb.Message.getFieldWithDefault(msg, 8, 0),
    statssort: jspb.Message.getFieldWithDefault(msg, 9, 0),
    statstype: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetHourlyCollectionStatsReq}
 */
proto.xcommon.GetHourlyCollectionStatsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetHourlyCollectionStatsReq;
  return proto.xcommon.GetHourlyCollectionStatsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetHourlyCollectionStatsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetHourlyCollectionStatsReq}
 */
proto.xcommon.GetHourlyCollectionStatsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.LoanTypeEnum} */ (reader.readEnum());
      msg.setLoantype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimerange(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuerytype(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHour(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.StatsSort} */ (reader.readEnum());
      msg.setStatssort(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.StatsType} */ (reader.readEnum());
      msg.setStatstype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetHourlyCollectionStatsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetHourlyCollectionStatsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetHourlyCollectionStatsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLoantype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTimerange();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getQuerytype();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getHour();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getStatssort();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getStatstype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/** @param {?proto.xcommon.CommonIn|undefined} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setCommonin = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.clearCommonin = function() {
  this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/** @param {?proto.xcommon.PageIn|undefined} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setPagein = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.clearPagein = function() {
  this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setItemid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional LoanTypeEnum LoanType = 4;
 * @return {!proto.xcommon.LoanTypeEnum}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getLoantype = function() {
  return /** @type {!proto.xcommon.LoanTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.xcommon.LoanTypeEnum} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setLoantype = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string TimeRange = 5;
 * @return {string}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getTimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setTimerange = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AppName = 6;
 * @return {string}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 QueryType = 7;
 * @return {number}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getQuerytype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setQuerytype = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 Hour = 8;
 * @return {number}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setHour = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional StatsSort StatsSort = 9;
 * @return {!proto.xcommon.StatsSort}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getStatssort = function() {
  return /** @type {!proto.xcommon.StatsSort} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {!proto.xcommon.StatsSort} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setStatssort = function(value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional StatsType StatsType = 10;
 * @return {!proto.xcommon.StatsType}
 */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.getStatstype = function() {
  return /** @type {!proto.xcommon.StatsType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.StatsType} value */
proto.xcommon.GetHourlyCollectionStatsReq.prototype.setStatstype = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetHourlyCollectionStatsResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetHourlyCollectionStatsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetHourlyCollectionStatsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetHourlyCollectionStatsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.HourlyCollectionStat.toObject, includeInstance),
    totalstats: (f = msg.getTotalstats()) && proto.xcommon.HourlyCollectionStat.toObject(includeInstance, f),
    updatetime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetHourlyCollectionStatsResp}
 */
proto.xcommon.GetHourlyCollectionStatsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetHourlyCollectionStatsResp;
  return proto.xcommon.GetHourlyCollectionStatsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetHourlyCollectionStatsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetHourlyCollectionStatsResp}
 */
proto.xcommon.GetHourlyCollectionStatsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.HourlyCollectionStat;
      reader.readMessage(value,proto.xcommon.HourlyCollectionStat.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = new proto.xcommon.HourlyCollectionStat;
      reader.readMessage(value,proto.xcommon.HourlyCollectionStat.deserializeBinaryFromReader);
      msg.setTotalstats(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatetime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetHourlyCollectionStatsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetHourlyCollectionStatsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetHourlyCollectionStatsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.HourlyCollectionStat.serializeBinaryToWriter
    );
  }
  f = message.getTotalstats();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.HourlyCollectionStat.serializeBinaryToWriter
    );
  }
  f = message.getUpdatetime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/** @param {?proto.xcommon.CommonOut|undefined} value */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.setCommonout = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.clearCommonout = function() {
  this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/** @param {?proto.xcommon.PageOut|undefined} value */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.setPageout = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.clearPageout = function() {
  this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated HourlyCollectionStat List = 3;
 * @return {!Array<!proto.xcommon.HourlyCollectionStat>}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.HourlyCollectionStat>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.HourlyCollectionStat, 3));
};


/** @param {!Array<!proto.xcommon.HourlyCollectionStat>} value */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.HourlyCollectionStat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.HourlyCollectionStat}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.HourlyCollectionStat, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.clearListList = function() {
  this.setListList([]);
};


/**
 * optional HourlyCollectionStat TotalStats = 4;
 * @return {?proto.xcommon.HourlyCollectionStat}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.getTotalstats = function() {
  return /** @type{?proto.xcommon.HourlyCollectionStat} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.HourlyCollectionStat, 4));
};


/** @param {?proto.xcommon.HourlyCollectionStat|undefined} value */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.setTotalstats = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.clearTotalstats = function() {
  this.setTotalstats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.hasTotalstats = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 UpdateTime = 5;
 * @return {number}
 */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.getUpdatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.GetHourlyCollectionStatsResp.prototype.setUpdatetime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.HourlyCollectionStat.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.HourlyCollectionStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.HourlyCollectionStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.HourlyCollectionStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    casename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    date: jspb.Message.getFieldWithDefault(msg, 3, ""),
    handlenum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    workercount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    loadnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    avgloadnum: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    avghandlenum: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    diffavghandlenum: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    loadleftunpaidprincipal: jspb.Message.getFieldWithDefault(msg, 10, 0),
    repaytotal: jspb.Message.getFieldWithDefault(msg, 11, 0),
    repayamountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    diffrepayamountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    targetrepayrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    completerate: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.HourlyCollectionStat}
 */
proto.xcommon.HourlyCollectionStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.HourlyCollectionStat;
  return proto.xcommon.HourlyCollectionStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.HourlyCollectionStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.HourlyCollectionStat}
 */
proto.xcommon.HourlyCollectionStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketitemid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCasename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandlenum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkercount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadnum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgloadnum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvghandlenum(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDiffavghandlenum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoadleftunpaidprincipal(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytotal(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepayamountrate(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDiffrepayamountrate(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetrepayrate(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCompleterate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.HourlyCollectionStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.HourlyCollectionStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.HourlyCollectionStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.HourlyCollectionStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketitemid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCasename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHandlenum();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getWorkercount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getLoadnum();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAvgloadnum();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getAvghandlenum();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getDiffavghandlenum();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getLoadleftunpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getRepaytotal();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getRepayamountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getDiffrepayamountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getTargetrepayrate();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getCompleterate();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
};


/**
 * optional int32 TicketItemID = 1;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getTicketitemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setTicketitemid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string CaseName = 2;
 * @return {string}
 */
proto.xcommon.HourlyCollectionStat.prototype.getCasename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.HourlyCollectionStat.prototype.setCasename = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Date = 3;
 * @return {string}
 */
proto.xcommon.HourlyCollectionStat.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.HourlyCollectionStat.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 HandleNum = 4;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getHandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setHandlenum = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 WorkerCount = 5;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getWorkercount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setWorkercount = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 LoadNum = 6;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getLoadnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setLoadnum = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double AvgLoadNum = 7;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getAvgloadnum = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setAvgloadnum = function(value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double AvgHandleNum = 8;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getAvghandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setAvghandlenum = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double DiffAvgHandleNum = 9;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getDiffavghandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setDiffavghandlenum = function(value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional int64 LoadLeftUnpaidPrincipal = 10;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getLoadleftunpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setLoadleftunpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 RepayTotal = 11;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getRepaytotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setRepaytotal = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional double RepayAmountRate = 12;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getRepayamountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setRepayamountrate = function(value) {
  jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double DiffRepayAmountRate = 13;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getDiffrepayamountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setDiffrepayamountrate = function(value) {
  jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double TargetRepayRate = 14;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getTargetrepayrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setTargetrepayrate = function(value) {
  jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double CompleteRate = 15;
 * @return {number}
 */
proto.xcommon.HourlyCollectionStat.prototype.getCompleterate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/** @param {number} value */
proto.xcommon.HourlyCollectionStat.prototype.setCompleterate = function(value) {
  jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * @enum {number}
 */
proto.xcommon.CollectionType = {
  COLLECTIONTYPENONE: 0,
  COLLECTIONTYPEREMIND: 1,
  COLLECTIONTYPEURGE: 2
};

/**
 * @enum {number}
 */
proto.xcommon.RuleAction = {
  RULEACTION_UNSPECIFIED: 0,
  RULEACTION_START: 1,
  RULEACTION_STOP: 2,
  RULEACTION_DELATE: 3
};

/**
 * @enum {number}
 */
proto.xcommon.ReduceType = {
  REDUCETYPE_UNSPECIFIED: 0,
  REDUCETYPE_AMOUNT: 1,
  REDUCETYPE_INTERESTFEE: 2
};

/**
 * @enum {number}
 */
proto.xcommon.ReduceStatus = {
  REDUCESTATUS_UNSPECIFIED: 0,
  REDUCESTATUS_WAIT: 1,
  REDUCESTATUS_PASS: 2,
  REDUCESTATUS_DENY: 3,
  REDUCESTATUS_FAIL: 4,
  REDUCESTATUS_SUCCESS: 5,
  REDUCESTATUS_INVALID: 6
};

/**
 * @enum {number}
 */
proto.xcommon.DialerStatus = {
  DIALERSTATUS_UNSPECIFIED: 0,
  DIALERSTATUS_START: 1,
  DIALERSTATUS_STOP: 2
};

/**
 * @enum {number}
 */
proto.xcommon.CommonStatus = {
  STATUS_UNSPECIFIED: 0,
  STATUS_VALID: 1,
  STATUS_INVALID: 2,
  STATUS_DELETE: 3
};

/**
 * @enum {number}
 */
proto.xcommon.ScorePolicy = {
  SCOREPOLICY_UNSPECIFIED: 0,
  SCOREPOLICY_ADDITION: 1,
  SCOREPOLICY_SUBTRACTION: 2
};

/**
 * @enum {number}
 */
proto.xcommon.MatchTimes = {
  MATCHTIMES_UNSPECIFIED: 0,
  MATCHTIMES_REPEAT: 1,
  MATCHTIMES_ATMOSTONE: 2
};

/**
 * @enum {number}
 */
proto.xcommon.Logical = {
  LOGICAL_UNSPECIFIED: 0,
  LOGICAL_AND: 1,
  LOGICAL_OR: 2
};

/**
 * @enum {number}
 */
proto.xcommon.QualityObject = {
  QUALITYOBJECT_UNSPECIFIED: 0,
  QUALITYOBJECT_COLLECTOR: 1,
  QUALITYOBJECT_CUSTOMER: 2,
  QUALITYOBJECT_ALL: 3
};

/**
 * @enum {number}
 */
proto.xcommon.QualityType = {
  QUALITYTYPE_UNSPECIFIED: 0,
  QUALITYTYPE_REPEATSCRIPT: 1,
  QUALITYTYPE_SCRIPTPOINT: 2
};

/**
 * @enum {number}
 */
proto.xcommon.HitRule = {
  HITRULE_UNSPECIFIED: 0,
  HITRULE_ANYONE: 1,
  HITRULE_ALL: 2,
  HITRULE_ALLMISS: 3,
  HITRULE_ANYONEMISS: 4
};

/**
 * @enum {number}
 */
proto.xcommon.TicketDimension = {
  TICKETDATE: 0,
  TICKETUSER: 1,
  TICKETROLE: 2,
  TICKETITEM: 3
};

/**
 * @enum {number}
 */
proto.xcommon.StatsType = {
  TICKETPERFORMANCEDEFAULT: 0,
  TICKETPERFORMANCEHOURLY: 1,
  TICKETPERFORMANCEDAILY: 2,
  TICKETPERFORMANCEHOURLYSUM: 3,
  TICKETPERFORMANCEDAILYSUM: 4
};

/**
 * @enum {number}
 */
proto.xcommon.StatsSort = {
  STATSSORTUNSPECIFIED: 0,
  ASSIGNNUM: 1,
  COMPLETENUM: 2,
  LOADNUM: 3,
  HANDLENUM: 4,
  NUMBEROFCOLLECTIONS: 5,
  LOADLEFTUNPAIDPRINCIPAL: 6,
  REPAYPRINCIPAL: 7,
  REPAYINTEREST: 8,
  REPAYTOTAL: 9,
  DIFFTARGETREPAY: 10,
  REPAYAMOUNTRATE: 11,
  TARGETREPAYRATE: 12,
  AVGHANDLENUM: 13,
  COMPLETERATE: 14,
  WORKERCOUNT: 15,
  AVGLOADNUM: 16
};

/**
 * @enum {number}
 */
proto.xcommon.CompareType = {
  COMPARE_TYPE_UNSPECIFIED: 0,
  USER_GROUP: 1,
  SENIOR_LEADER_USER_GROUP: 2,
  OM: 3
};

/**
 * @enum {number}
 */
proto.xcommon.ReduceApprovedType = {
  UNKNOWN: 0,
  AUTOMATIC: 1,
  MANUAL: 2
};

/**
 * @enum {number}
 */
proto.xcommon.QpType = {
  QUESTION_TYPE_UNSPECIFIED: 0,
  QUESTION_TYPE_0: 1,
  QUESTION_TYPE_1: 2,
  QUESTION_TYPE_2: 3,
  QUESTION_OPTION: 10
};

/**
 * @enum {number}
 */
proto.xcommon.QStatusEnum = {
  QSTATUS_UNSPECIFIED: 0,
  QSTATUS_VALID: 1,
  QSTATUS_INVALID: 2,
  QSTATUS_ASSOCIATED: 3
};

/**
 * @enum {number}
 */
proto.xcommon.QuestionDisplayEnum = {
  QD_UNSPECIFIED: 0,
  QD_ALL: 1,
  QD_RAND: 2,
  QD_ALLOCATED: 3
};

/**
 * @enum {number}
 */
proto.xcommon.TicketItemEnum = {
  TICKET_ITEM_UNSPECIFIED: 0,
  TICKET_ITEM_PV: 100,
  TICKET_ITEM_IR: 101,
  TICKET_ITEM_QI: 102,
  TICKET_ITEM_PS_CONFIRM_LOAN: 103,
  TICKET_ITEM_PS_RECALL: 104,
  TICKET_ITEM_VOIP_QI: 105,
  TICKET_ITEM_OCR_MARK: 106,
  TICKET_ITEM_CPV: 107,
  TICKET_ITEM_ROBOT_CORPUS: 108,
  TICKET_ITEM_IR_AND_IR: 201
};

/**
 * @enum {number}
 */
proto.xcommon.IDVerifyEnum = {
  ID_VERIFY_ALL: 0,
  ID_VERIFY_YES: 1,
  ID_VERIFY_NO: 2
};

/**
 * @enum {number}
 */
proto.xcommon.VerifyStepItem = {
  VS_UNSPECIFIED: 0,
  VS_PV: 1,
  VS_IR: 2
};

/**
 * @enum {number}
 */
proto.xcommon.VerifyInfoGroupEnum = {
  VIG_UNSPECIFIED: 0,
  VIG_PROFILE: 1,
  VIG_FAMILY: 2,
  VIG_IDINFO: 3,
  VIG_LIVINGINFO: 4,
  VIG_REPAYINFO: 5,
  VIG_WORKINFO: 6,
  VIG_CONTACTINFO: 7,
  VIG_CORPORATE: 8,
  VIG_WALLET: 9,
  VIG_PAYMENT: 10
};

/**
 * @enum {number}
 */
proto.xcommon.VerifyInfoEnum = {
  VI_UNSPECIFIED: 0,
  VI_REALNAME: 1,
  VI_GENDER: 2,
  VI_CARDTYPE: 3,
  VI_IDENTITY: 4,
  VI_MOBILE: 5,
  VI_EMAIL: 6,
  VI_APPVERSION: 7,
  VI_APPVERSIONCODE: 8,
  VI_DATEOFBIRTH: 9,
  VI_EDUCATION: 10,
  VI_FAMILYPHONE: 11,
  VI_MARITALSTATUS: 12,
  VI_CHILDRENNUMBER: 13,
  VI_RESIDENTSTATE: 14,
  VI_RESIDENTADDRESS: 15,
  VI_IDPHOTO: 16,
  VI_IDBACKPHOTO: 17,
  VI_HANDHELDIDPHOTO: 18,
  VI_IMAGEBEST: 19,
  VI_IMAGEENV: 20,
  VI_IMAGEREF1: 21,
  VI_IMAGEREF2: 22,
  VI_IMAGEREF3: 23,
  VI_BANKCARDTYPE: 24,
  VI_BANKNAME: 25,
  VI_BANKNO: 26,
  VI_WORKTYPE: 27,
  VI_MONTHLYINCOME: 28,
  VI_SERVICEYEARS: 29,
  VI_COMPANYTELEPHONE: 30,
  VI_COMPANYNAME: 31,
  VI_COMPANYADDRESS: 32,
  VI_SALARYDAY: 33,
  VI_SALARYTYPE: 34,
  VI_INDEBT: 35,
  VI_CONTACT1NAME: 36,
  VI_RELATIONSHIP1: 37,
  VI_CONTACT1: 38,
  VI_CONTACT2NAME: 39,
  VI_RELATIONSHIP2: 40,
  VI_CONTACT2: 41,
  VI_CONTACT3NAME: 42,
  VI_RELATIONSHIP3: 43,
  VI_CONTACT3: 44,
  VI_PREV_IMAGEBEST: 45,
  VI_CORPORATE_LICENSE: 46,
  VI_CORPORATE_FLOW: 47,
  VI_CORPORATE_ENV1: 48,
  VI_CORPORATE_ENV2: 49,
  VI_CORPORATE_PHONE: 50,
  VI_UTILITY_BILLS: 51,
  VI_SOCIAL_INSURANCE: 52,
  VI_SALARY_PROOF: 53,
  VI_IDENTIFY_EXPIRE: 60,
  VI_ACCOUNT_TYPE: 61,
  VI_WALLET_NAME: 62,
  VI_ACCOUNT_NAME: 63,
  VI_ACCOUNT_NO: 64,
  VI_AVG_INCOME_LAST_THREE_MONTH: 65,
  VI_AVG_EXPENSES_LAST_THREE_MONTH: 66,
  VI_IMAGE_ACCOUNT: 67,
  VI_IMAGE_ACCOUNT_FLOW: 68,
  VI_PAYMENT_TYPE: 69,
  VI_PAYMENT_DATE: 70,
  VI_PAYMENT_AMOUNT: 71,
  VI_PAYMENT_STATE: 72,
  VI_PAYMENT_CITY: 73,
  VI_PAYMENT_ADDRESS: 74,
  VI_HOUSING_STATUS: 75,
  VI_IMAGE_PAYMENT: 76,
  VI_IMAGE_HOUSING_STATUS: 77
};

/**
 * @enum {number}
 */
proto.xcommon.LawyerLetterStatus = {
  LAWYER_STATUS_UNSPECIFIED: 0,
  LAWYERSTATUS_SUCCESS: 1,
  LAWYERSTATUS_FAIL: 2,
  LAWYERSTATUS_UNDSEND: 3,
  LAWYERSTATUS_CANCEL: 4,
  LAWYERSTATUS_INVALID: 5
};

/**
 * @enum {number}
 */
proto.xcommon.LawyerLetterSendType = {
  LAWYER_SENDTYPE_UNSPECIFIED: 0,
  LAWYER_SENDTYPE_WA: 1,
  LAWYER_SENDTYPE_EMAIL: 2
};

/**
 * @enum {number}
 */
proto.xcommon.ImageTypeEnum = {
  IMAGTYPE_UNSPECIFIED: 0,
  IMAGTYPE_ID: 1,
  IMAGTYPE_LIVING: 2,
  IMAGTYPE_CORPORATE: 3
};

/**
 * @enum {number}
 */
proto.xcommon.PVStatus = {
  PVSTATUS_UNSPECIFIED: 0,
  PVSTATUS_PROCESSING: 1,
  PVTATUS_PASS: 2,
  PVTATUS_INVALID: 3,
  PVSTATUS_REJECT: 4,
  PVSTATUS_QI_REJECT: 5,
  PVSTATUS_QI_PASS: 6
};

/**
 * @enum {number}
 */
proto.xcommon.WarningLetterStatus = {
  WARNINGLETTERSTATUS_UNSPECIFIED: 0,
  WARNINGLETTERSTATUS_DOWNLOAD: 1,
  WARNINGLETTERSTATUS_SEND: 2
};

/**
 * @enum {number}
 */
proto.xcommon.UDDimension = {
  UD_DATE: 0,
  UD_ITEM: 1,
  UD_CWAY: 2
};

/**
 * @enum {number}
 */
proto.xcommon.CallTypeEnum = {
  CT_UNSPECIFIED: 0,
  CT_FIRST: 1,
  CT_ALL: 2
};

/**
 * @enum {number}
 */
proto.xcommon.CallType = {
  CALLTYPE_UNSPECIFIED: 0,
  CALLTYPE_NORMAL: 1,
  CALLTYPE_COMPLAIN: 2
};

/**
 * @enum {number}
 */
proto.xcommon.AiStatusEnum = {
  AI_STATUS_UNSPECIFIED: 0,
  AI_STATUS_WITHOUT: 1,
  AI_STATUS_ALREADY: 2
};

/**
 * @enum {number}
 */
proto.xcommon.QualityKindEnum = {
  QUALITYKIND_UNSPECIFIED: 0,
  QUALITYKIND_AI: 1,
  QUALITYKIND_HUMAN: 2
};

/**
 * @enum {number}
 */
proto.xcommon.StatDimension = {
  ENUM_DATE: 0,
  ENUM_USER: 1,
  ENUM_ROLE: 2,
  ENUM_ITEM: 3
};

/**
 * @enum {number}
 */
proto.xcommon.OcrTypeEnum = {
  OCRTYPE_UNSPECIFIED: 0,
  OCRTYPE_CLASSIFY: 1,
  OCRTYPE_REGION: 2
};

/**
 * @enum {number}
 */
proto.xcommon.ThirdStatus = {
  THIRD_STATUS_UNSPECIFIED: 0,
  THIRD_STATUS_NORMAL: 1,
  THIRD_STATUS_RECOGNITION_FAILED: 2,
  THIRD_STATUS_LOGICAL_ERROR: 3,
  THIRD_STATUS_BACKFILL_ERROR: 4
};

/**
 * @enum {number}
 */
proto.xcommon.OcrMarkStatus = {
  OCR_MARK_STATUS_UNSPECIFIED: 0,
  OCR_MARK_STATUS_CONFIRMED: 1,
  OCR_MARK_STATUS_CASE_ABNORMAL: 2,
  OCR_MARK_STATUS_PROCESSING_COMPLETE: 3
};

/**
 * @enum {number}
 */
proto.xcommon.MarkWAType = {
  MARK_WA_TYPE_UNSPECIFIED: 0,
  MARK_WA_TYPE_BANNED: 1,
  MARK_WA_TYPE_DELETED: 2
};

module.exports = proto.xcommon;
